"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key2 of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key2) && key2 !== except)
          __defProp(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/html2canvas/dist/html2canvas.js
  var require_html2canvas = __commonJS({
    "node_modules/html2canvas/dist/html2canvas.js"(exports, module) {
      (function(global, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, global.html2canvas = factory());
      })(exports, function() {
        "use strict";
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
          } || function(d2, b2) {
            for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
          };
          return extendStatics(d, b);
        };
        function __extends(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }
        var __assign = function() {
          __assign = Object.assign || function __assign2(t) {
            for (var s, i2 = 1, n = arguments.length; i2 < n; i2++) {
              s = arguments[i2];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return __assign.apply(this, arguments);
        };
        function __awaiter(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e2) {
                reject(e2);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e2) {
                reject(e2);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }
        function __generator(thisArg, body) {
          var _ = { label: 0, sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
          }, trys: [], ops: [] }, f2, y, t, g;
          return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
          }), g;
          function verb(n) {
            return function(v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f2) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f2 = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e2) {
              op = [6, e2];
              y = 0;
            } finally {
              f2 = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
          }
        }
        function __spreadArray(to, from, pack2) {
          if (pack2 || arguments.length === 2) for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
            if (ar || !(i2 in from)) {
              if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
              ar[i2] = from[i2];
            }
          }
          return to.concat(ar || from);
        }
        var Bounds = (
          /** @class */
          function() {
            function Bounds2(left, top, width, height) {
              this.left = left;
              this.top = top;
              this.width = width;
              this.height = height;
            }
            Bounds2.prototype.add = function(x, y, w, h) {
              return new Bounds2(this.left + x, this.top + y, this.width + w, this.height + h);
            };
            Bounds2.fromClientRect = function(context, clientRect) {
              return new Bounds2(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
            };
            Bounds2.fromDOMRectList = function(context, domRectList) {
              var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
              });
              return domRect ? new Bounds2(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds2.EMPTY;
            };
            Bounds2.EMPTY = new Bounds2(0, 0, 0, 0);
            return Bounds2;
          }()
        );
        var parseBounds = function(context, node) {
          return Bounds.fromClientRect(context, node.getBoundingClientRect());
        };
        var parseDocumentSize = function(document2) {
          var body = document2.body;
          var documentElement = document2.documentElement;
          if (!body || !documentElement) {
            throw new Error("Unable to get document size");
          }
          var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
          var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
          return new Bounds(0, 0, width, height);
        };
        var toCodePoints$1 = function(str) {
          var codePoints = [];
          var i2 = 0;
          var length = str.length;
          while (i2 < length) {
            var value = str.charCodeAt(i2++);
            if (value >= 55296 && value <= 56319 && i2 < length) {
              var extra = str.charCodeAt(i2++);
              if ((extra & 64512) === 56320) {
                codePoints.push(((value & 1023) << 10) + (extra & 1023) + 65536);
              } else {
                codePoints.push(value);
                i2--;
              }
            } else {
              codePoints.push(value);
            }
          }
          return codePoints;
        };
        var fromCodePoint$1 = function() {
          var codePoints = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
          }
          if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
          }
          var length = codePoints.length;
          if (!length) {
            return "";
          }
          var codeUnits = [];
          var index = -1;
          var result = "";
          while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 65535) {
              codeUnits.push(codePoint);
            } else {
              codePoint -= 65536;
              codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
            }
            if (index + 1 === length || codeUnits.length > 16384) {
              result += String.fromCharCode.apply(String, codeUnits);
              codeUnits.length = 0;
            }
          }
          return result;
        };
        var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
          lookup$2[chars$2.charCodeAt(i$2)] = i$2;
        }
        var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
          lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
        }
        var decode$1 = function(base642) {
          var bufferLength = base642.length * 0.75, len = base642.length, i2, p = 0, encoded1, encoded2, encoded3, encoded4;
          if (base642[base642.length - 1] === "=") {
            bufferLength--;
            if (base642[base642.length - 2] === "=") {
              bufferLength--;
            }
          }
          var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
          var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
          for (i2 = 0; i2 < len; i2 += 4) {
            encoded1 = lookup$1$1[base642.charCodeAt(i2)];
            encoded2 = lookup$1$1[base642.charCodeAt(i2 + 1)];
            encoded3 = lookup$1$1[base642.charCodeAt(i2 + 2)];
            encoded4 = lookup$1$1[base642.charCodeAt(i2 + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
          }
          return buffer;
        };
        var polyUint16Array$1 = function(buffer) {
          var length = buffer.length;
          var bytes = [];
          for (var i2 = 0; i2 < length; i2 += 2) {
            bytes.push(buffer[i2 + 1] << 8 | buffer[i2]);
          }
          return bytes;
        };
        var polyUint32Array$1 = function(buffer) {
          var length = buffer.length;
          var bytes = [];
          for (var i2 = 0; i2 < length; i2 += 4) {
            bytes.push(buffer[i2 + 3] << 24 | buffer[i2 + 2] << 16 | buffer[i2 + 1] << 8 | buffer[i2]);
          }
          return bytes;
        };
        var UTRIE2_SHIFT_2$1 = 5;
        var UTRIE2_SHIFT_1$1 = 6 + 5;
        var UTRIE2_INDEX_SHIFT$1 = 2;
        var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
        var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 65536 >> UTRIE2_SHIFT_2$1;
        var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
        var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
        var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 1024 >> UTRIE2_SHIFT_2$1;
        var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
        var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
        var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 2048 >> 6;
        var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
        var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 65536 >> UTRIE2_SHIFT_1$1;
        var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
        var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
        var slice16$1 = function(view, start, end) {
          if (view.slice) {
            return view.slice(start, end);
          }
          return new Uint16Array(Array.prototype.slice.call(view, start, end));
        };
        var slice32$1 = function(view, start, end) {
          if (view.slice) {
            return view.slice(start, end);
          }
          return new Uint32Array(Array.prototype.slice.call(view, start, end));
        };
        var createTrieFromBase64$1 = function(base642, _byteLength) {
          var buffer = decode$1(base642);
          var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
          var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
          var headerLength = 24;
          var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
          var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
          return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
        };
        var Trie$1 = (
          /** @class */
          function() {
            function Trie2(initialValue, errorValue, highStart, highValueIndex, index, data) {
              this.initialValue = initialValue;
              this.errorValue = errorValue;
              this.highStart = highStart;
              this.highValueIndex = highValueIndex;
              this.index = index;
              this.data = data;
            }
            Trie2.prototype.get = function(codePoint) {
              var ix;
              if (codePoint >= 0) {
                if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
                  ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                  ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                  return this.data[ix];
                }
                if (codePoint <= 65535) {
                  ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 55296 >> UTRIE2_SHIFT_2$1)];
                  ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                  return this.data[ix];
                }
                if (codePoint < this.highStart) {
                  ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                  ix = this.index[ix];
                  ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                  ix = this.index[ix];
                  ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                  return this.data[ix];
                }
                if (codePoint <= 1114111) {
                  return this.data[this.highValueIndex];
                }
              }
              return this.errorValue;
            };
            return Trie2;
          }()
        );
        var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
          lookup$3[chars$3.charCodeAt(i$3)] = i$3;
        }
        var base64$1 = "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";
        var LETTER_NUMBER_MODIFIER = 50;
        var BK = 1;
        var CR$1 = 2;
        var LF$1 = 3;
        var CM = 4;
        var NL = 5;
        var WJ = 7;
        var ZW = 8;
        var GL = 9;
        var SP = 10;
        var ZWJ$1 = 11;
        var B2 = 12;
        var BA = 13;
        var BB = 14;
        var HY = 15;
        var CB = 16;
        var CL = 17;
        var CP = 18;
        var EX = 19;
        var IN = 20;
        var NS = 21;
        var OP = 22;
        var QU = 23;
        var IS = 24;
        var NU = 25;
        var PO = 26;
        var PR = 27;
        var SY = 28;
        var AI = 29;
        var AL = 30;
        var CJ = 31;
        var EB = 32;
        var EM = 33;
        var H2 = 34;
        var H3 = 35;
        var HL = 36;
        var ID = 37;
        var JL = 38;
        var JV = 39;
        var JT = 40;
        var RI$1 = 41;
        var SA = 42;
        var XX = 43;
        var ea_OP = [9001, 65288];
        var BREAK_MANDATORY = "!";
        var BREAK_NOT_ALLOWED$1 = "\xD7";
        var BREAK_ALLOWED$1 = "\xF7";
        var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
        var ALPHABETICS = [AL, HL];
        var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
        var SPACE$1 = [SP, ZW];
        var PREFIX_POSTFIX = [PR, PO];
        var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
        var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
        var HYPHEN = [HY, BA];
        var codePointsToCharacterClasses = function(codePoints, lineBreak2) {
          if (lineBreak2 === void 0) {
            lineBreak2 = "strict";
          }
          var types = [];
          var indices = [];
          var categories = [];
          codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
              categories.push(true);
              classType -= LETTER_NUMBER_MODIFIER;
            } else {
              categories.push(false);
            }
            if (["normal", "auto", "loose"].indexOf(lineBreak2) !== -1) {
              if ([8208, 8211, 12316, 12448].indexOf(codePoint) !== -1) {
                indices.push(index);
                return types.push(CB);
              }
            }
            if (classType === CM || classType === ZWJ$1) {
              if (index === 0) {
                indices.push(index);
                return types.push(AL);
              }
              var prev = types[index - 1];
              if (LINE_BREAKS.indexOf(prev) === -1) {
                indices.push(indices[index - 1]);
                return types.push(prev);
              }
              indices.push(index);
              return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
              return types.push(lineBreak2 === "strict" ? NS : ID);
            }
            if (classType === SA) {
              return types.push(AL);
            }
            if (classType === AI) {
              return types.push(AL);
            }
            if (classType === XX) {
              if (codePoint >= 131072 && codePoint <= 196605 || codePoint >= 196608 && codePoint <= 262141) {
                return types.push(ID);
              } else {
                return types.push(AL);
              }
            }
            types.push(classType);
          });
          return [indices, types, categories];
        };
        var isAdjacentWithSpaceIgnored = function(a2, b, currentIndex, classTypes) {
          var current = classTypes[currentIndex];
          if (Array.isArray(a2) ? a2.indexOf(current) !== -1 : a2 === current) {
            var i2 = currentIndex;
            while (i2 <= classTypes.length) {
              i2++;
              var next = classTypes[i2];
              if (next === b) {
                return true;
              }
              if (next !== SP) {
                break;
              }
            }
          }
          if (current === SP) {
            var i2 = currentIndex;
            while (i2 > 0) {
              i2--;
              var prev = classTypes[i2];
              if (Array.isArray(a2) ? a2.indexOf(prev) !== -1 : a2 === prev) {
                var n = currentIndex;
                while (n <= classTypes.length) {
                  n++;
                  var next = classTypes[n];
                  if (next === b) {
                    return true;
                  }
                  if (next !== SP) {
                    break;
                  }
                }
              }
              if (prev !== SP) {
                break;
              }
            }
          }
          return false;
        };
        var previousNonSpaceClassType = function(currentIndex, classTypes) {
          var i2 = currentIndex;
          while (i2 >= 0) {
            var type = classTypes[i2];
            if (type === SP) {
              i2--;
            } else {
              return type;
            }
          }
          return 0;
        };
        var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
          if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
          }
          var currentIndex = index - 1;
          if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
          }
          var beforeIndex = currentIndex - 1;
          var afterIndex = currentIndex + 1;
          var current = classTypes[currentIndex];
          var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
          var next = classTypes[afterIndex];
          if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
          }
          if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
          }
          if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === SP) {
            return BREAK_ALLOWED$1;
          }
          if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
          }
          if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (
            // (PR | PO) × ( OP | HY )? NU
            [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
            [OP, HY].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
            current === NU && [NU, SY, IS].indexOf(next) !== -1
          ) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
              var type = classTypes[prevIndex];
              if (type === NU) {
                return BREAK_NOT_ALLOWED$1;
              } else if ([SY, IS].indexOf(type) !== -1) {
                prevIndex--;
              } else {
                break;
              }
            }
          }
          if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
              var type = classTypes[prevIndex];
              if (type === NU) {
                return BREAK_NOT_ALLOWED$1;
              } else if ([SY, IS].indexOf(type) !== -1) {
                prevIndex--;
              } else {
                break;
              }
            }
          }
          if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === RI$1 && next === RI$1) {
            var i2 = indicies[currentIndex];
            var count = 1;
            while (i2 > 0) {
              i2--;
              if (classTypes[i2] === RI$1) {
                count++;
              } else {
                break;
              }
            }
            if (count % 2 !== 0) {
              return BREAK_NOT_ALLOWED$1;
            }
          }
          if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
          }
          return BREAK_ALLOWED$1;
        };
        var cssFormattedClasses = function(codePoints, options) {
          if (!options) {
            options = { lineBreak: "normal", wordBreak: "normal" };
          }
          var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
          if (options.wordBreak === "break-all" || options.wordBreak === "break-word") {
            classTypes = classTypes.map(function(type) {
              return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
            });
          }
          var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i2) {
            return letterNumber && codePoints[i2] >= 19968 && codePoints[i2] <= 40959;
          }) : void 0;
          return [indicies, classTypes, forbiddenBreakpoints];
        };
        var Break = (
          /** @class */
          function() {
            function Break2(codePoints, lineBreak2, start, end) {
              this.codePoints = codePoints;
              this.required = lineBreak2 === BREAK_MANDATORY;
              this.start = start;
              this.end = end;
            }
            Break2.prototype.slice = function() {
              return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
            };
            return Break2;
          }()
        );
        var LineBreaker = function(str, options) {
          var codePoints = toCodePoints$1(str);
          var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
          var length = codePoints.length;
          var lastEnd = 0;
          var nextIndex = 0;
          return {
            next: function() {
              if (nextIndex >= length) {
                return { done: true, value: null };
              }
              var lineBreak2 = BREAK_NOT_ALLOWED$1;
              while (nextIndex < length && (lineBreak2 = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1) {
              }
              if (lineBreak2 !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                var value = new Break(codePoints, lineBreak2, lastEnd, nextIndex);
                lastEnd = nextIndex;
                return { value, done: false };
              }
              return { done: true, value: null };
            }
          };
        };
        var FLAG_UNRESTRICTED = 1 << 0;
        var FLAG_ID = 1 << 1;
        var FLAG_INTEGER = 1 << 2;
        var FLAG_NUMBER = 1 << 3;
        var LINE_FEED = 10;
        var SOLIDUS = 47;
        var REVERSE_SOLIDUS = 92;
        var CHARACTER_TABULATION = 9;
        var SPACE = 32;
        var QUOTATION_MARK = 34;
        var EQUALS_SIGN = 61;
        var NUMBER_SIGN = 35;
        var DOLLAR_SIGN = 36;
        var PERCENTAGE_SIGN = 37;
        var APOSTROPHE = 39;
        var LEFT_PARENTHESIS = 40;
        var RIGHT_PARENTHESIS = 41;
        var LOW_LINE = 95;
        var HYPHEN_MINUS = 45;
        var EXCLAMATION_MARK = 33;
        var LESS_THAN_SIGN = 60;
        var GREATER_THAN_SIGN = 62;
        var COMMERCIAL_AT = 64;
        var LEFT_SQUARE_BRACKET = 91;
        var RIGHT_SQUARE_BRACKET = 93;
        var CIRCUMFLEX_ACCENT = 61;
        var LEFT_CURLY_BRACKET = 123;
        var QUESTION_MARK = 63;
        var RIGHT_CURLY_BRACKET = 125;
        var VERTICAL_LINE = 124;
        var TILDE = 126;
        var CONTROL = 128;
        var REPLACEMENT_CHARACTER = 65533;
        var ASTERISK = 42;
        var PLUS_SIGN = 43;
        var COMMA = 44;
        var COLON = 58;
        var SEMICOLON = 59;
        var FULL_STOP = 46;
        var NULL = 0;
        var BACKSPACE = 8;
        var LINE_TABULATION = 11;
        var SHIFT_OUT = 14;
        var INFORMATION_SEPARATOR_ONE = 31;
        var DELETE = 127;
        var EOF = -1;
        var ZERO = 48;
        var a = 97;
        var e = 101;
        var f = 102;
        var u = 117;
        var z = 122;
        var A = 65;
        var E = 69;
        var F = 70;
        var U = 85;
        var Z = 90;
        var isDigit = function(codePoint) {
          return codePoint >= ZERO && codePoint <= 57;
        };
        var isSurrogateCodePoint = function(codePoint) {
          return codePoint >= 55296 && codePoint <= 57343;
        };
        var isHex2 = function(codePoint) {
          return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
        };
        var isLowerCaseLetter = function(codePoint) {
          return codePoint >= a && codePoint <= z;
        };
        var isUpperCaseLetter = function(codePoint) {
          return codePoint >= A && codePoint <= Z;
        };
        var isLetter = function(codePoint) {
          return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
        };
        var isNonASCIICodePoint = function(codePoint) {
          return codePoint >= CONTROL;
        };
        var isWhiteSpace = function(codePoint) {
          return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
        };
        var isNameStartCodePoint = function(codePoint) {
          return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
        };
        var isNameCodePoint = function(codePoint) {
          return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
        };
        var isNonPrintableCodePoint = function(codePoint) {
          return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
        };
        var isValidEscape = function(c12, c22) {
          if (c12 !== REVERSE_SOLIDUS) {
            return false;
          }
          return c22 !== LINE_FEED;
        };
        var isIdentifierStart = function(c12, c22, c32) {
          if (c12 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c22) || isValidEscape(c22, c32);
          } else if (isNameStartCodePoint(c12)) {
            return true;
          } else if (c12 === REVERSE_SOLIDUS && isValidEscape(c12, c22)) {
            return true;
          }
          return false;
        };
        var isNumberStart = function(c12, c22, c32) {
          if (c12 === PLUS_SIGN || c12 === HYPHEN_MINUS) {
            if (isDigit(c22)) {
              return true;
            }
            return c22 === FULL_STOP && isDigit(c32);
          }
          if (c12 === FULL_STOP) {
            return isDigit(c22);
          }
          return isDigit(c12);
        };
        var stringToNumber = function(codePoints) {
          var c = 0;
          var sign = 1;
          if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
              sign = -1;
            }
            c++;
          }
          var integers = [];
          while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
          }
          var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
          if (codePoints[c] === FULL_STOP) {
            c++;
          }
          var fraction = [];
          while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
          }
          var fracd = fraction.length;
          var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
          if (codePoints[c] === E || codePoints[c] === e) {
            c++;
          }
          var expsign = 1;
          if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
              expsign = -1;
            }
            c++;
          }
          var exponent = [];
          while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
          }
          var exp2 = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
          return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp2);
        };
        var LEFT_PARENTHESIS_TOKEN = {
          type: 2
          /* LEFT_PARENTHESIS_TOKEN */
        };
        var RIGHT_PARENTHESIS_TOKEN = {
          type: 3
          /* RIGHT_PARENTHESIS_TOKEN */
        };
        var COMMA_TOKEN = {
          type: 4
          /* COMMA_TOKEN */
        };
        var SUFFIX_MATCH_TOKEN = {
          type: 13
          /* SUFFIX_MATCH_TOKEN */
        };
        var PREFIX_MATCH_TOKEN = {
          type: 8
          /* PREFIX_MATCH_TOKEN */
        };
        var COLUMN_TOKEN = {
          type: 21
          /* COLUMN_TOKEN */
        };
        var DASH_MATCH_TOKEN = {
          type: 9
          /* DASH_MATCH_TOKEN */
        };
        var INCLUDE_MATCH_TOKEN = {
          type: 10
          /* INCLUDE_MATCH_TOKEN */
        };
        var LEFT_CURLY_BRACKET_TOKEN = {
          type: 11
          /* LEFT_CURLY_BRACKET_TOKEN */
        };
        var RIGHT_CURLY_BRACKET_TOKEN = {
          type: 12
          /* RIGHT_CURLY_BRACKET_TOKEN */
        };
        var SUBSTRING_MATCH_TOKEN = {
          type: 14
          /* SUBSTRING_MATCH_TOKEN */
        };
        var BAD_URL_TOKEN = {
          type: 23
          /* BAD_URL_TOKEN */
        };
        var BAD_STRING_TOKEN = {
          type: 1
          /* BAD_STRING_TOKEN */
        };
        var CDO_TOKEN = {
          type: 25
          /* CDO_TOKEN */
        };
        var CDC_TOKEN = {
          type: 24
          /* CDC_TOKEN */
        };
        var COLON_TOKEN = {
          type: 26
          /* COLON_TOKEN */
        };
        var SEMICOLON_TOKEN = {
          type: 27
          /* SEMICOLON_TOKEN */
        };
        var LEFT_SQUARE_BRACKET_TOKEN = {
          type: 28
          /* LEFT_SQUARE_BRACKET_TOKEN */
        };
        var RIGHT_SQUARE_BRACKET_TOKEN = {
          type: 29
          /* RIGHT_SQUARE_BRACKET_TOKEN */
        };
        var WHITESPACE_TOKEN = {
          type: 31
          /* WHITESPACE_TOKEN */
        };
        var EOF_TOKEN = {
          type: 32
          /* EOF_TOKEN */
        };
        var Tokenizer = (
          /** @class */
          function() {
            function Tokenizer2() {
              this._value = [];
            }
            Tokenizer2.prototype.write = function(chunk) {
              this._value = this._value.concat(toCodePoints$1(chunk));
            };
            Tokenizer2.prototype.read = function() {
              var tokens = [];
              var token = this.consumeToken();
              while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
              }
              return tokens;
            };
            Tokenizer2.prototype.consumeToken = function() {
              var codePoint = this.consumeCodePoint();
              switch (codePoint) {
                case QUOTATION_MARK:
                  return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                  var c12 = this.peekCodePoint(0);
                  var c22 = this.peekCodePoint(1);
                  var c32 = this.peekCodePoint(2);
                  if (isNameCodePoint(c12) || isValidEscape(c22, c32)) {
                    var flags = isIdentifierStart(c12, c22, c32) ? FLAG_ID : FLAG_UNRESTRICTED;
                    var value = this.consumeName();
                    return { type: 5, value, flags };
                  }
                  break;
                case DOLLAR_SIGN:
                  if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return SUFFIX_MATCH_TOKEN;
                  }
                  break;
                case APOSTROPHE:
                  return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                  return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                  return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                  if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return SUBSTRING_MATCH_TOKEN;
                  }
                  break;
                case PLUS_SIGN:
                  if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                  }
                  break;
                case COMMA:
                  return COMMA_TOKEN;
                case HYPHEN_MINUS:
                  var e1 = codePoint;
                  var e2 = this.peekCodePoint(0);
                  var e3 = this.peekCodePoint(1);
                  if (isNumberStart(e1, e2, e3)) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                  }
                  if (isIdentifierStart(e1, e2, e3)) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                  }
                  if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                    this.consumeCodePoint();
                    this.consumeCodePoint();
                    return CDC_TOKEN;
                  }
                  break;
                case FULL_STOP:
                  if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                  }
                  break;
                case SOLIDUS:
                  if (this.peekCodePoint(0) === ASTERISK) {
                    this.consumeCodePoint();
                    while (true) {
                      var c = this.consumeCodePoint();
                      if (c === ASTERISK) {
                        c = this.consumeCodePoint();
                        if (c === SOLIDUS) {
                          return this.consumeToken();
                        }
                      }
                      if (c === EOF) {
                        return this.consumeToken();
                      }
                    }
                  }
                  break;
                case COLON:
                  return COLON_TOKEN;
                case SEMICOLON:
                  return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                  if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                    this.consumeCodePoint();
                    this.consumeCodePoint();
                    return CDO_TOKEN;
                  }
                  break;
                case COMMERCIAL_AT:
                  var a1 = this.peekCodePoint(0);
                  var a2 = this.peekCodePoint(1);
                  var a3 = this.peekCodePoint(2);
                  if (isIdentifierStart(a1, a2, a3)) {
                    var value = this.consumeName();
                    return { type: 7, value };
                  }
                  break;
                case LEFT_SQUARE_BRACKET:
                  return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                  if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                  }
                  break;
                case RIGHT_SQUARE_BRACKET:
                  return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                  if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return PREFIX_MATCH_TOKEN;
                  }
                  break;
                case LEFT_CURLY_BRACKET:
                  return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                  return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                  var u1 = this.peekCodePoint(0);
                  var u2 = this.peekCodePoint(1);
                  if (u1 === PLUS_SIGN && (isHex2(u2) || u2 === QUESTION_MARK)) {
                    this.consumeCodePoint();
                    this.consumeUnicodeRangeToken();
                  }
                  this.reconsumeCodePoint(codePoint);
                  return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                  if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return DASH_MATCH_TOKEN;
                  }
                  if (this.peekCodePoint(0) === VERTICAL_LINE) {
                    this.consumeCodePoint();
                    return COLUMN_TOKEN;
                  }
                  break;
                case TILDE:
                  if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return INCLUDE_MATCH_TOKEN;
                  }
                  break;
                case EOF:
                  return EOF_TOKEN;
              }
              if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
              }
              if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
              }
              if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
              }
              return { type: 6, value: fromCodePoint$1(codePoint) };
            };
            Tokenizer2.prototype.consumeCodePoint = function() {
              var value = this._value.shift();
              return typeof value === "undefined" ? -1 : value;
            };
            Tokenizer2.prototype.reconsumeCodePoint = function(codePoint) {
              this._value.unshift(codePoint);
            };
            Tokenizer2.prototype.peekCodePoint = function(delta) {
              if (delta >= this._value.length) {
                return -1;
              }
              return this._value[delta];
            };
            Tokenizer2.prototype.consumeUnicodeRangeToken = function() {
              var digits = [];
              var codePoint = this.consumeCodePoint();
              while (isHex2(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
              }
              var questionMarks = false;
              while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
              }
              if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                  return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                  return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return { type: 30, start: start_1, end };
              }
              var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
              if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex2(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex2(codePoint) && endDigits.length < 6) {
                  endDigits.push(codePoint);
                  codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30, start, end };
              } else {
                return { type: 30, start, end: start };
              }
            };
            Tokenizer2.prototype.consumeIdentLikeToken = function() {
              var value = this.consumeName();
              if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
              } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19, value };
              }
              return { type: 20, value };
            };
            Tokenizer2.prototype.consumeUrlToken = function() {
              var value = [];
              this.consumeWhiteSpace();
              if (this.peekCodePoint(0) === EOF) {
                return { type: 22, value: "" };
              }
              var next = this.peekCodePoint(0);
              if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0) {
                  this.consumeWhiteSpace();
                  if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                    this.consumeCodePoint();
                    return { type: 22, value: stringToken.value };
                  }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
              }
              while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                  return { type: 22, value: fromCodePoint$1.apply(void 0, value) };
                } else if (isWhiteSpace(codePoint)) {
                  this.consumeWhiteSpace();
                  if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                    this.consumeCodePoint();
                    return { type: 22, value: fromCodePoint$1.apply(void 0, value) };
                  }
                  this.consumeBadUrlRemnants();
                  return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                  this.consumeBadUrlRemnants();
                  return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                  if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    value.push(this.consumeEscapedCodePoint());
                  } else {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                  }
                } else {
                  value.push(codePoint);
                }
              }
            };
            Tokenizer2.prototype.consumeWhiteSpace = function() {
              while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
              }
            };
            Tokenizer2.prototype.consumeBadUrlRemnants = function() {
              while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                  return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                  this.consumeEscapedCodePoint();
                }
              }
            };
            Tokenizer2.prototype.consumeStringSlice = function(count) {
              var SLICE_STACK_SIZE = 5e4;
              var value = "";
              while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
              }
              this._value.shift();
              return value;
            };
            Tokenizer2.prototype.consumeStringToken = function(endingCodePoint) {
              var value = "";
              var i2 = 0;
              do {
                var codePoint = this._value[i2];
                if (codePoint === EOF || codePoint === void 0 || codePoint === endingCodePoint) {
                  value += this.consumeStringSlice(i2);
                  return { type: 0, value };
                }
                if (codePoint === LINE_FEED) {
                  this._value.splice(0, i2);
                  return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                  var next = this._value[i2 + 1];
                  if (next !== EOF && next !== void 0) {
                    if (next === LINE_FEED) {
                      value += this.consumeStringSlice(i2);
                      i2 = -1;
                      this._value.shift();
                    } else if (isValidEscape(codePoint, next)) {
                      value += this.consumeStringSlice(i2);
                      value += fromCodePoint$1(this.consumeEscapedCodePoint());
                      i2 = -1;
                    }
                  }
                }
                i2++;
              } while (true);
            };
            Tokenizer2.prototype.consumeNumber = function() {
              var repr = [];
              var type = FLAG_INTEGER;
              var c12 = this.peekCodePoint(0);
              if (c12 === PLUS_SIGN || c12 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
              }
              while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
              }
              c12 = this.peekCodePoint(0);
              var c22 = this.peekCodePoint(1);
              if (c12 === FULL_STOP && isDigit(c22)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                  repr.push(this.consumeCodePoint());
                }
              }
              c12 = this.peekCodePoint(0);
              c22 = this.peekCodePoint(1);
              var c32 = this.peekCodePoint(2);
              if ((c12 === E || c12 === e) && ((c22 === PLUS_SIGN || c22 === HYPHEN_MINUS) && isDigit(c32) || isDigit(c22))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                  repr.push(this.consumeCodePoint());
                }
              }
              return [stringToNumber(repr), type];
            };
            Tokenizer2.prototype.consumeNumericToken = function() {
              var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
              var c12 = this.peekCodePoint(0);
              var c22 = this.peekCodePoint(1);
              var c32 = this.peekCodePoint(2);
              if (isIdentifierStart(c12, c22, c32)) {
                var unit = this.consumeName();
                return { type: 15, number, flags, unit };
              }
              if (c12 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16, number, flags };
              }
              return { type: 17, number, flags };
            };
            Tokenizer2.prototype.consumeEscapedCodePoint = function() {
              var codePoint = this.consumeCodePoint();
              if (isHex2(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex2(this.peekCodePoint(0)) && hex.length < 6) {
                  hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                  this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 1114111) {
                  return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
              }
              if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
              }
              return codePoint;
            };
            Tokenizer2.prototype.consumeName = function() {
              var result = "";
              while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                  result += fromCodePoint$1(codePoint);
                } else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                  result += fromCodePoint$1(this.consumeEscapedCodePoint());
                } else {
                  this.reconsumeCodePoint(codePoint);
                  return result;
                }
              }
            };
            return Tokenizer2;
          }()
        );
        var Parser = (
          /** @class */
          function() {
            function Parser2(tokens) {
              this._tokens = tokens;
            }
            Parser2.create = function(value) {
              var tokenizer = new Tokenizer();
              tokenizer.write(value);
              return new Parser2(tokenizer.read());
            };
            Parser2.parseValue = function(value) {
              return Parser2.create(value).parseComponentValue();
            };
            Parser2.parseValues = function(value) {
              return Parser2.create(value).parseComponentValues();
            };
            Parser2.prototype.parseComponentValue = function() {
              var token = this.consumeToken();
              while (token.type === 31) {
                token = this.consumeToken();
              }
              if (token.type === 32) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
              }
              this.reconsumeToken(token);
              var value = this.consumeComponentValue();
              do {
                token = this.consumeToken();
              } while (token.type === 31);
              if (token.type === 32) {
                return value;
              }
              throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
            };
            Parser2.prototype.parseComponentValues = function() {
              var values = [];
              while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32) {
                  return values;
                }
                values.push(value);
                values.push();
              }
            };
            Parser2.prototype.consumeComponentValue = function() {
              var token = this.consumeToken();
              switch (token.type) {
                case 11:
                case 28:
                case 2:
                  return this.consumeSimpleBlock(token.type);
                case 19:
                  return this.consumeFunction(token);
              }
              return token;
            };
            Parser2.prototype.consumeSimpleBlock = function(type) {
              var block = { type, values: [] };
              var token = this.consumeToken();
              while (true) {
                if (token.type === 32 || isEndingTokenFor(token, type)) {
                  return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
              }
            };
            Parser2.prototype.consumeFunction = function(functionToken) {
              var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18
                /* FUNCTION */
              };
              while (true) {
                var token = this.consumeToken();
                if (token.type === 32 || token.type === 3) {
                  return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
              }
            };
            Parser2.prototype.consumeToken = function() {
              var token = this._tokens.shift();
              return typeof token === "undefined" ? EOF_TOKEN : token;
            };
            Parser2.prototype.reconsumeToken = function(token) {
              this._tokens.unshift(token);
            };
            return Parser2;
          }()
        );
        var isDimensionToken = function(token) {
          return token.type === 15;
        };
        var isNumberToken = function(token) {
          return token.type === 17;
        };
        var isIdentToken = function(token) {
          return token.type === 20;
        };
        var isStringToken = function(token) {
          return token.type === 0;
        };
        var isIdentWithValue = function(token, value) {
          return isIdentToken(token) && token.value === value;
        };
        var nonWhiteSpace = function(token) {
          return token.type !== 31;
        };
        var nonFunctionArgSeparator = function(token) {
          return token.type !== 31 && token.type !== 4;
        };
        var parseFunctionArgs = function(tokens) {
          var args = [];
          var arg = [];
          tokens.forEach(function(token) {
            if (token.type === 4) {
              if (arg.length === 0) {
                throw new Error("Error parsing function args, zero tokens for arg");
              }
              args.push(arg);
              arg = [];
              return;
            }
            if (token.type !== 31) {
              arg.push(token);
            }
          });
          if (arg.length) {
            args.push(arg);
          }
          return args;
        };
        var isEndingTokenFor = function(token, type) {
          if (type === 11 && token.type === 12) {
            return true;
          }
          if (type === 28 && token.type === 29) {
            return true;
          }
          return type === 2 && token.type === 3;
        };
        var isLength = function(token) {
          return token.type === 17 || token.type === 15;
        };
        var isLengthPercentage = function(token) {
          return token.type === 16 || isLength(token);
        };
        var parseLengthPercentageTuple = function(tokens) {
          return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
        };
        var ZERO_LENGTH = {
          type: 17,
          number: 0,
          flags: FLAG_INTEGER
        };
        var FIFTY_PERCENT = {
          type: 16,
          number: 50,
          flags: FLAG_INTEGER
        };
        var HUNDRED_PERCENT = {
          type: 16,
          number: 100,
          flags: FLAG_INTEGER
        };
        var getAbsoluteValueForTuple = function(tuple, width, height) {
          var x = tuple[0], y = tuple[1];
          return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== "undefined" ? y : x, height)];
        };
        var getAbsoluteValue = function(token, parent) {
          if (token.type === 16) {
            return token.number / 100 * parent;
          }
          if (isDimensionToken(token)) {
            switch (token.unit) {
              case "rem":
              case "em":
                return 16 * token.number;
              case "px":
              default:
                return token.number;
            }
          }
          return token.number;
        };
        var DEG = "deg";
        var GRAD = "grad";
        var RAD = "rad";
        var TURN = "turn";
        var angle = {
          name: "angle",
          parse: function(_context, value) {
            if (value.type === 15) {
              switch (value.unit) {
                case DEG:
                  return Math.PI * value.number / 180;
                case GRAD:
                  return Math.PI / 200 * value.number;
                case RAD:
                  return value.number;
                case TURN:
                  return Math.PI * 2 * value.number;
              }
            }
            throw new Error("Unsupported angle type");
          }
        };
        var isAngle = function(value) {
          if (value.type === 15) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
              return true;
            }
          }
          return false;
        };
        var parseNamedSide = function(tokens) {
          var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
          }).join(" ");
          switch (sideOrCorner) {
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
              return [ZERO_LENGTH, ZERO_LENGTH];
            case "to top":
            case "bottom":
              return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
              return [ZERO_LENGTH, HUNDRED_PERCENT];
            case "to right":
            case "left":
              return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
              return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case "to bottom":
            case "top":
              return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
              return [HUNDRED_PERCENT, ZERO_LENGTH];
            case "to left":
            case "right":
              return deg(270);
          }
          return 0;
        };
        var deg = function(deg2) {
          return Math.PI * deg2 / 180;
        };
        var color$1 = {
          name: "color",
          parse: function(context, value) {
            if (value.type === 18) {
              var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
              if (typeof colorFunction === "undefined") {
                throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
              }
              return colorFunction(context, value.values);
            }
            if (value.type === 5) {
              if (value.value.length === 3) {
                var r = value.value.substring(0, 1);
                var g = value.value.substring(1, 2);
                var b = value.value.substring(2, 3);
                return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
              }
              if (value.value.length === 4) {
                var r = value.value.substring(0, 1);
                var g = value.value.substring(1, 2);
                var b = value.value.substring(2, 3);
                var a2 = value.value.substring(3, 4);
                return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a2 + a2, 16) / 255);
              }
              if (value.value.length === 6) {
                var r = value.value.substring(0, 2);
                var g = value.value.substring(2, 4);
                var b = value.value.substring(4, 6);
                return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
              }
              if (value.value.length === 8) {
                var r = value.value.substring(0, 2);
                var g = value.value.substring(2, 4);
                var b = value.value.substring(4, 6);
                var a2 = value.value.substring(6, 8);
                return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a2, 16) / 255);
              }
            }
            if (value.type === 20) {
              var namedColor = COLORS[value.value.toUpperCase()];
              if (typeof namedColor !== "undefined") {
                return namedColor;
              }
            }
            return COLORS.TRANSPARENT;
          }
        };
        var isTransparent = function(color3) {
          return (255 & color3) === 0;
        };
        var asString = function(color3) {
          var alpha = 255 & color3;
          var blue = 255 & color3 >> 8;
          var green = 255 & color3 >> 16;
          var red = 255 & color3 >> 24;
          return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
        };
        var pack = function(r, g, b, a2) {
          return (r << 24 | g << 16 | b << 8 | Math.round(a2 * 255) << 0) >>> 0;
        };
        var getTokenColorValue = function(token, i2) {
          if (token.type === 17) {
            return token.number;
          }
          if (token.type === 16) {
            var max2 = i2 === 3 ? 1 : 255;
            return i2 === 3 ? token.number / 100 * max2 : Math.round(token.number / 100 * max2);
          }
          return 0;
        };
        var rgb = function(_context, args) {
          var tokens = args.filter(nonFunctionArgSeparator);
          if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
          }
          if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a2 = _b[3];
            return pack(r, g, b, a2);
          }
          return 0;
        };
        function hue2rgb2(t1, t2, hue) {
          if (hue < 0) {
            hue += 1;
          }
          if (hue >= 1) {
            hue -= 1;
          }
          if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
          } else if (hue < 1 / 2) {
            return t2;
          } else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
          } else {
            return t1;
          }
        }
        var hsl = function(context, args) {
          var tokens = args.filter(nonFunctionArgSeparator);
          var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
          var h = (hue.type === 17 ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
          var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
          var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
          var a2 = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
          if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
          }
          var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
          var t1 = l * 2 - t2;
          var r = hue2rgb2(t1, t2, h + 1 / 3);
          var g = hue2rgb2(t1, t2, h);
          var b = hue2rgb2(t1, t2, h - 1 / 3);
          return pack(r * 255, g * 255, b * 255, a2);
        };
        var SUPPORTED_COLOR_FUNCTIONS = {
          hsl,
          hsla: hsl,
          rgb,
          rgba: rgb
        };
        var parseColor2 = function(context, value) {
          return color$1.parse(context, Parser.create(value).parseComponentValue());
        };
        var COLORS = {
          ALICEBLUE: 4042850303,
          ANTIQUEWHITE: 4209760255,
          AQUA: 16777215,
          AQUAMARINE: 2147472639,
          AZURE: 4043309055,
          BEIGE: 4126530815,
          BISQUE: 4293182719,
          BLACK: 255,
          BLANCHEDALMOND: 4293643775,
          BLUE: 65535,
          BLUEVIOLET: 2318131967,
          BROWN: 2771004159,
          BURLYWOOD: 3736635391,
          CADETBLUE: 1604231423,
          CHARTREUSE: 2147418367,
          CHOCOLATE: 3530104575,
          CORAL: 4286533887,
          CORNFLOWERBLUE: 1687547391,
          CORNSILK: 4294499583,
          CRIMSON: 3692313855,
          CYAN: 16777215,
          DARKBLUE: 35839,
          DARKCYAN: 9145343,
          DARKGOLDENROD: 3095837695,
          DARKGRAY: 2846468607,
          DARKGREEN: 6553855,
          DARKGREY: 2846468607,
          DARKKHAKI: 3182914559,
          DARKMAGENTA: 2332068863,
          DARKOLIVEGREEN: 1433087999,
          DARKORANGE: 4287365375,
          DARKORCHID: 2570243327,
          DARKRED: 2332033279,
          DARKSALMON: 3918953215,
          DARKSEAGREEN: 2411499519,
          DARKSLATEBLUE: 1211993087,
          DARKSLATEGRAY: 793726975,
          DARKSLATEGREY: 793726975,
          DARKTURQUOISE: 13554175,
          DARKVIOLET: 2483082239,
          DEEPPINK: 4279538687,
          DEEPSKYBLUE: 12582911,
          DIMGRAY: 1768516095,
          DIMGREY: 1768516095,
          DODGERBLUE: 512819199,
          FIREBRICK: 2988581631,
          FLORALWHITE: 4294635775,
          FORESTGREEN: 579543807,
          FUCHSIA: 4278255615,
          GAINSBORO: 3705462015,
          GHOSTWHITE: 4177068031,
          GOLD: 4292280575,
          GOLDENROD: 3668254975,
          GRAY: 2155905279,
          GREEN: 8388863,
          GREENYELLOW: 2919182335,
          GREY: 2155905279,
          HONEYDEW: 4043305215,
          HOTPINK: 4285117695,
          INDIANRED: 3445382399,
          INDIGO: 1258324735,
          IVORY: 4294963455,
          KHAKI: 4041641215,
          LAVENDER: 3873897215,
          LAVENDERBLUSH: 4293981695,
          LAWNGREEN: 2096890111,
          LEMONCHIFFON: 4294626815,
          LIGHTBLUE: 2916673279,
          LIGHTCORAL: 4034953471,
          LIGHTCYAN: 3774873599,
          LIGHTGOLDENRODYELLOW: 4210742015,
          LIGHTGRAY: 3553874943,
          LIGHTGREEN: 2431553791,
          LIGHTGREY: 3553874943,
          LIGHTPINK: 4290167295,
          LIGHTSALMON: 4288707327,
          LIGHTSEAGREEN: 548580095,
          LIGHTSKYBLUE: 2278488831,
          LIGHTSLATEGRAY: 2005441023,
          LIGHTSLATEGREY: 2005441023,
          LIGHTSTEELBLUE: 2965692159,
          LIGHTYELLOW: 4294959359,
          LIME: 16711935,
          LIMEGREEN: 852308735,
          LINEN: 4210091775,
          MAGENTA: 4278255615,
          MAROON: 2147483903,
          MEDIUMAQUAMARINE: 1724754687,
          MEDIUMBLUE: 52735,
          MEDIUMORCHID: 3126187007,
          MEDIUMPURPLE: 2473647103,
          MEDIUMSEAGREEN: 1018393087,
          MEDIUMSLATEBLUE: 2070474495,
          MEDIUMSPRINGGREEN: 16423679,
          MEDIUMTURQUOISE: 1221709055,
          MEDIUMVIOLETRED: 3340076543,
          MIDNIGHTBLUE: 421097727,
          MINTCREAM: 4127193855,
          MISTYROSE: 4293190143,
          MOCCASIN: 4293178879,
          NAVAJOWHITE: 4292783615,
          NAVY: 33023,
          OLDLACE: 4260751103,
          OLIVE: 2155872511,
          OLIVEDRAB: 1804477439,
          ORANGE: 4289003775,
          ORANGERED: 4282712319,
          ORCHID: 3664828159,
          PALEGOLDENROD: 4008225535,
          PALEGREEN: 2566625535,
          PALETURQUOISE: 2951671551,
          PALEVIOLETRED: 3681588223,
          PAPAYAWHIP: 4293907967,
          PEACHPUFF: 4292524543,
          PERU: 3448061951,
          PINK: 4290825215,
          PLUM: 3718307327,
          POWDERBLUE: 2967529215,
          PURPLE: 2147516671,
          REBECCAPURPLE: 1714657791,
          RED: 4278190335,
          ROSYBROWN: 3163525119,
          ROYALBLUE: 1097458175,
          SADDLEBROWN: 2336560127,
          SALMON: 4202722047,
          SANDYBROWN: 4104413439,
          SEAGREEN: 780883967,
          SEASHELL: 4294307583,
          SIENNA: 2689740287,
          SILVER: 3233857791,
          SKYBLUE: 2278484991,
          SLATEBLUE: 1784335871,
          SLATEGRAY: 1887473919,
          SLATEGREY: 1887473919,
          SNOW: 4294638335,
          SPRINGGREEN: 16744447,
          STEELBLUE: 1182971135,
          TAN: 3535047935,
          TEAL: 8421631,
          THISTLE: 3636451583,
          TOMATO: 4284696575,
          TRANSPARENT: 0,
          TURQUOISE: 1088475391,
          VIOLET: 4001558271,
          WHEAT: 4125012991,
          WHITE: 4294967295,
          WHITESMOKE: 4126537215,
          YELLOW: 4294902015,
          YELLOWGREEN: 2597139199
        };
        var backgroundClip = {
          name: "background-clip",
          initialValue: "border-box",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.map(function(token) {
              if (isIdentToken(token)) {
                switch (token.value) {
                  case "padding-box":
                    return 1;
                  case "content-box":
                    return 2;
                }
              }
              return 0;
            });
          }
        };
        var backgroundColor = {
          name: "background-color",
          initialValue: "transparent",
          prefix: false,
          type: 3,
          format: "color"
        };
        var parseColorStop = function(context, args) {
          var color3 = color$1.parse(context, args[0]);
          var stop = args[1];
          return stop && isLengthPercentage(stop) ? { color: color3, stop } : { color: color3, stop: null };
        };
        var processColorStops = function(stops, lineLength) {
          var first = stops[0];
          var last = stops[stops.length - 1];
          if (first.stop === null) {
            first.stop = ZERO_LENGTH;
          }
          if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
          }
          var processStops = [];
          var previous = 0;
          for (var i2 = 0; i2 < stops.length; i2++) {
            var stop_1 = stops[i2].stop;
            if (stop_1 !== null) {
              var absoluteValue = getAbsoluteValue(stop_1, lineLength);
              if (absoluteValue > previous) {
                processStops.push(absoluteValue);
              } else {
                processStops.push(previous);
              }
              previous = absoluteValue;
            } else {
              processStops.push(null);
            }
          }
          var gapBegin = null;
          for (var i2 = 0; i2 < processStops.length; i2++) {
            var stop_2 = processStops[i2];
            if (stop_2 === null) {
              if (gapBegin === null) {
                gapBegin = i2;
              }
            } else if (gapBegin !== null) {
              var gapLength = i2 - gapBegin;
              var beforeGap = processStops[gapBegin - 1];
              var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
              for (var g = 1; g <= gapLength; g++) {
                processStops[gapBegin + g - 1] = gapValue * g;
              }
              gapBegin = null;
            }
          }
          return stops.map(function(_a, i3) {
            var color3 = _a.color;
            return { color: color3, stop: Math.max(Math.min(1, processStops[i3] / lineLength), 0) };
          });
        };
        var getAngleFromCorner = function(corner, width, height) {
          var centerX = width / 2;
          var centerY = height / 2;
          var x = getAbsoluteValue(corner[0], width) - centerX;
          var y = centerY - getAbsoluteValue(corner[1], height);
          return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
        };
        var calculateGradientDirection = function(angle2, width, height) {
          var radian = typeof angle2 === "number" ? angle2 : getAngleFromCorner(angle2, width, height);
          var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
          var halfWidth = width / 2;
          var halfHeight = height / 2;
          var halfLineLength = lineLength / 2;
          var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
          var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
          return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
        };
        var distance = function(a2, b) {
          return Math.sqrt(a2 * a2 + b * b);
        };
        var findCorner = function(width, height, x, y, closest) {
          var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
          ];
          return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
              return {
                optimumCorner: corner,
                optimumDistance: d
              };
            }
            return stat;
          }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
          }).optimumCorner;
        };
        var calculateRadius = function(gradient2, x, y, width, height) {
          var rx = 0;
          var ry = 0;
          switch (gradient2.size) {
            case 0:
              if (gradient2.shape === 0) {
                rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
              } else if (gradient2.shape === 1) {
                rx = Math.min(Math.abs(x), Math.abs(x - width));
                ry = Math.min(Math.abs(y), Math.abs(y - height));
              }
              break;
            case 2:
              if (gradient2.shape === 0) {
                rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
              } else if (gradient2.shape === 1) {
                var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                rx = distance(cx - x, (cy - y) / c);
                ry = c * rx;
              }
              break;
            case 1:
              if (gradient2.shape === 0) {
                rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
              } else if (gradient2.shape === 1) {
                rx = Math.max(Math.abs(x), Math.abs(x - width));
                ry = Math.max(Math.abs(y), Math.abs(y - height));
              }
              break;
            case 3:
              if (gradient2.shape === 0) {
                rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
              } else if (gradient2.shape === 1) {
                var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                rx = distance(cx - x, (cy - y) / c);
                ry = c * rx;
              }
              break;
          }
          if (Array.isArray(gradient2.size)) {
            rx = getAbsoluteValue(gradient2.size[0], width);
            ry = gradient2.size.length === 2 ? getAbsoluteValue(gradient2.size[1], height) : rx;
          }
          return [rx, ry];
        };
        var linearGradient = function(context, tokens) {
          var angle$1 = deg(180);
          var stops = [];
          parseFunctionArgs(tokens).forEach(function(arg, i2) {
            if (i2 === 0) {
              var firstToken = arg[0];
              if (firstToken.type === 20 && firstToken.value === "to") {
                angle$1 = parseNamedSide(arg);
                return;
              } else if (isAngle(firstToken)) {
                angle$1 = angle.parse(context, firstToken);
                return;
              }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
          });
          return {
            angle: angle$1,
            stops,
            type: 1
            /* LINEAR_GRADIENT */
          };
        };
        var prefixLinearGradient = function(context, tokens) {
          var angle$1 = deg(180);
          var stops = [];
          parseFunctionArgs(tokens).forEach(function(arg, i2) {
            if (i2 === 0) {
              var firstToken = arg[0];
              if (firstToken.type === 20 && ["top", "left", "right", "bottom"].indexOf(firstToken.value) !== -1) {
                angle$1 = parseNamedSide(arg);
                return;
              } else if (isAngle(firstToken)) {
                angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                return;
              }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
          });
          return {
            angle: angle$1,
            stops,
            type: 1
            /* LINEAR_GRADIENT */
          };
        };
        var webkitGradient = function(context, tokens) {
          var angle2 = deg(180);
          var stops = [];
          var type = 1;
          var shape = 0;
          var size = 3;
          var position2 = [];
          parseFunctionArgs(tokens).forEach(function(arg, i2) {
            var firstToken = arg[0];
            if (i2 === 0) {
              if (isIdentToken(firstToken) && firstToken.value === "linear") {
                type = 1;
                return;
              } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                type = 2;
                return;
              }
            }
            if (firstToken.type === 18) {
              if (firstToken.name === "from") {
                var color3 = color$1.parse(context, firstToken.values[0]);
                stops.push({ stop: ZERO_LENGTH, color: color3 });
              } else if (firstToken.name === "to") {
                var color3 = color$1.parse(context, firstToken.values[0]);
                stops.push({ stop: HUNDRED_PERCENT, color: color3 });
              } else if (firstToken.name === "color-stop") {
                var values = firstToken.values.filter(nonFunctionArgSeparator);
                if (values.length === 2) {
                  var color3 = color$1.parse(context, values[1]);
                  var stop_1 = values[0];
                  if (isNumberToken(stop_1)) {
                    stops.push({
                      stop: { type: 16, number: stop_1.number * 100, flags: stop_1.flags },
                      color: color3
                    });
                  }
                }
              }
            }
          });
          return type === 1 ? {
            angle: (angle2 + deg(180)) % deg(360),
            stops,
            type
          } : { size, shape, stops, position: position2, type };
        };
        var CLOSEST_SIDE = "closest-side";
        var FARTHEST_SIDE = "farthest-side";
        var CLOSEST_CORNER = "closest-corner";
        var FARTHEST_CORNER = "farthest-corner";
        var CIRCLE = "circle";
        var ELLIPSE = "ellipse";
        var COVER = "cover";
        var CONTAIN = "contain";
        var radialGradient = function(context, tokens) {
          var shape = 0;
          var size = 3;
          var stops = [];
          var position2 = [];
          parseFunctionArgs(tokens).forEach(function(arg, i2) {
            var isColorStop = true;
            if (i2 === 0) {
              var isAtPosition_1 = false;
              isColorStop = arg.reduce(function(acc, token) {
                if (isAtPosition_1) {
                  if (isIdentToken(token)) {
                    switch (token.value) {
                      case "center":
                        position2.push(FIFTY_PERCENT);
                        return acc;
                      case "top":
                      case "left":
                        position2.push(ZERO_LENGTH);
                        return acc;
                      case "right":
                      case "bottom":
                        position2.push(HUNDRED_PERCENT);
                        return acc;
                    }
                  } else if (isLengthPercentage(token) || isLength(token)) {
                    position2.push(token);
                  }
                } else if (isIdentToken(token)) {
                  switch (token.value) {
                    case CIRCLE:
                      shape = 0;
                      return false;
                    case ELLIPSE:
                      shape = 1;
                      return false;
                    case "at":
                      isAtPosition_1 = true;
                      return false;
                    case CLOSEST_SIDE:
                      size = 0;
                      return false;
                    case COVER:
                    case FARTHEST_SIDE:
                      size = 1;
                      return false;
                    case CONTAIN:
                    case CLOSEST_CORNER:
                      size = 2;
                      return false;
                    case FARTHEST_CORNER:
                      size = 3;
                      return false;
                  }
                } else if (isLength(token) || isLengthPercentage(token)) {
                  if (!Array.isArray(size)) {
                    size = [];
                  }
                  size.push(token);
                  return false;
                }
                return acc;
              }, isColorStop);
            }
            if (isColorStop) {
              var colorStop = parseColorStop(context, arg);
              stops.push(colorStop);
            }
          });
          return {
            size,
            shape,
            stops,
            position: position2,
            type: 2
            /* RADIAL_GRADIENT */
          };
        };
        var prefixRadialGradient = function(context, tokens) {
          var shape = 0;
          var size = 3;
          var stops = [];
          var position2 = [];
          parseFunctionArgs(tokens).forEach(function(arg, i2) {
            var isColorStop = true;
            if (i2 === 0) {
              isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) {
                  switch (token.value) {
                    case "center":
                      position2.push(FIFTY_PERCENT);
                      return false;
                    case "top":
                    case "left":
                      position2.push(ZERO_LENGTH);
                      return false;
                    case "right":
                    case "bottom":
                      position2.push(HUNDRED_PERCENT);
                      return false;
                  }
                } else if (isLengthPercentage(token) || isLength(token)) {
                  position2.push(token);
                  return false;
                }
                return acc;
              }, isColorStop);
            } else if (i2 === 1) {
              isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) {
                  switch (token.value) {
                    case CIRCLE:
                      shape = 0;
                      return false;
                    case ELLIPSE:
                      shape = 1;
                      return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                      size = 0;
                      return false;
                    case FARTHEST_SIDE:
                      size = 1;
                      return false;
                    case CLOSEST_CORNER:
                      size = 2;
                      return false;
                    case COVER:
                    case FARTHEST_CORNER:
                      size = 3;
                      return false;
                  }
                } else if (isLength(token) || isLengthPercentage(token)) {
                  if (!Array.isArray(size)) {
                    size = [];
                  }
                  size.push(token);
                  return false;
                }
                return acc;
              }, isColorStop);
            }
            if (isColorStop) {
              var colorStop = parseColorStop(context, arg);
              stops.push(colorStop);
            }
          });
          return {
            size,
            shape,
            stops,
            position: position2,
            type: 2
            /* RADIAL_GRADIENT */
          };
        };
        var isLinearGradient = function(background) {
          return background.type === 1;
        };
        var isRadialGradient = function(background) {
          return background.type === 2;
        };
        var image = {
          name: "image",
          parse: function(context, value) {
            if (value.type === 22) {
              var image_1 = {
                url: value.value,
                type: 0
                /* URL */
              };
              context.cache.addImage(value.value);
              return image_1;
            }
            if (value.type === 18) {
              var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
              if (typeof imageFunction === "undefined") {
                throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
              }
              return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
          }
        };
        function isSupportedImage(value) {
          return !(value.type === 20 && value.value === "none") && (value.type !== 18 || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
        }
        var SUPPORTED_IMAGE_FUNCTIONS = {
          "linear-gradient": linearGradient,
          "-moz-linear-gradient": prefixLinearGradient,
          "-ms-linear-gradient": prefixLinearGradient,
          "-o-linear-gradient": prefixLinearGradient,
          "-webkit-linear-gradient": prefixLinearGradient,
          "radial-gradient": radialGradient,
          "-moz-radial-gradient": prefixRadialGradient,
          "-ms-radial-gradient": prefixRadialGradient,
          "-o-radial-gradient": prefixRadialGradient,
          "-webkit-radial-gradient": prefixRadialGradient,
          "-webkit-gradient": webkitGradient
        };
        var backgroundImage = {
          name: "background-image",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(context, tokens) {
            if (tokens.length === 0) {
              return [];
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return [];
            }
            return tokens.filter(function(value) {
              return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
              return image.parse(context, value);
            });
          }
        };
        var backgroundOrigin = {
          name: "background-origin",
          initialValue: "border-box",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.map(function(token) {
              if (isIdentToken(token)) {
                switch (token.value) {
                  case "padding-box":
                    return 1;
                  case "content-box":
                    return 2;
                }
              }
              return 0;
            });
          }
        };
        var backgroundPosition = {
          name: "background-position",
          initialValue: "0% 0%",
          type: 1,
          prefix: false,
          parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
              return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
          }
        };
        var backgroundRepeat = {
          name: "background-repeat",
          initialValue: "repeat",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
              return values.filter(isIdentToken).map(function(token) {
                return token.value;
              }).join(" ");
            }).map(parseBackgroundRepeat);
          }
        };
        var parseBackgroundRepeat = function(value) {
          switch (value) {
            case "no-repeat":
              return 1;
            case "repeat-x":
            case "repeat no-repeat":
              return 2;
            case "repeat-y":
            case "no-repeat repeat":
              return 3;
            case "repeat":
            default:
              return 0;
          }
        };
        var BACKGROUND_SIZE;
        (function(BACKGROUND_SIZE2) {
          BACKGROUND_SIZE2["AUTO"] = "auto";
          BACKGROUND_SIZE2["CONTAIN"] = "contain";
          BACKGROUND_SIZE2["COVER"] = "cover";
        })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
        var backgroundSize = {
          name: "background-size",
          initialValue: "0",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
              return values.filter(isBackgroundSizeInfoToken);
            });
          }
        };
        var isBackgroundSizeInfoToken = function(value) {
          return isIdentToken(value) || isLengthPercentage(value);
        };
        var borderColorForSide = function(side) {
          return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3,
            format: "color"
          };
        };
        var borderTopColor = borderColorForSide("top");
        var borderRightColor = borderColorForSide("right");
        var borderBottomColor = borderColorForSide("bottom");
        var borderLeftColor = borderColorForSide("left");
        var borderRadiusForSide = function(side) {
          return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1,
            parse: function(_context, tokens) {
              return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
          };
        };
        var borderTopLeftRadius = borderRadiusForSide("top-left");
        var borderTopRightRadius = borderRadiusForSide("top-right");
        var borderBottomRightRadius = borderRadiusForSide("bottom-right");
        var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
        var borderStyleForSide = function(side) {
          return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2,
            parse: function(_context, style) {
              switch (style) {
                case "none":
                  return 0;
                case "dashed":
                  return 2;
                case "dotted":
                  return 3;
                case "double":
                  return 4;
              }
              return 1;
            }
          };
        };
        var borderTopStyle = borderStyleForSide("top");
        var borderRightStyle = borderStyleForSide("right");
        var borderBottomStyle = borderStyleForSide("bottom");
        var borderLeftStyle = borderStyleForSide("left");
        var borderWidthForSide = function(side) {
          return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0,
            prefix: false,
            parse: function(_context, token) {
              if (isDimensionToken(token)) {
                return token.number;
              }
              return 0;
            }
          };
        };
        var borderTopWidth = borderWidthForSide("top");
        var borderRightWidth = borderWidthForSide("right");
        var borderBottomWidth = borderWidthForSide("bottom");
        var borderLeftWidth = borderWidthForSide("left");
        var color2 = {
          name: "color",
          initialValue: "transparent",
          prefix: false,
          type: 3,
          format: "color"
        };
        var direction = {
          name: "direction",
          initialValue: "ltr",
          prefix: false,
          type: 2,
          parse: function(_context, direction2) {
            switch (direction2) {
              case "rtl":
                return 1;
              case "ltr":
              default:
                return 0;
            }
          }
        };
        var display = {
          name: "display",
          initialValue: "inline-block",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(
              function(bit, token) {
                return bit | parseDisplayValue(token.value);
              },
              0
              /* NONE */
            );
          }
        };
        var parseDisplayValue = function(display2) {
          switch (display2) {
            case "block":
            case "-webkit-box":
              return 2;
            case "inline":
              return 4;
            case "run-in":
              return 8;
            case "flow":
              return 16;
            case "flow-root":
              return 32;
            case "table":
              return 64;
            case "flex":
            case "-webkit-flex":
              return 128;
            case "grid":
            case "-ms-grid":
              return 256;
            case "ruby":
              return 512;
            case "subgrid":
              return 1024;
            case "list-item":
              return 2048;
            case "table-row-group":
              return 4096;
            case "table-header-group":
              return 8192;
            case "table-footer-group":
              return 16384;
            case "table-row":
              return 32768;
            case "table-cell":
              return 65536;
            case "table-column-group":
              return 131072;
            case "table-column":
              return 262144;
            case "table-caption":
              return 524288;
            case "ruby-base":
              return 1048576;
            case "ruby-text":
              return 2097152;
            case "ruby-base-container":
              return 4194304;
            case "ruby-text-container":
              return 8388608;
            case "contents":
              return 16777216;
            case "inline-block":
              return 33554432;
            case "inline-list-item":
              return 67108864;
            case "inline-table":
              return 134217728;
            case "inline-flex":
              return 268435456;
            case "inline-grid":
              return 536870912;
          }
          return 0;
        };
        var float = {
          name: "float",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, float2) {
            switch (float2) {
              case "left":
                return 1;
              case "right":
                return 2;
              case "inline-start":
                return 3;
              case "inline-end":
                return 4;
            }
            return 0;
          }
        };
        var letterSpacing = {
          name: "letter-spacing",
          initialValue: "0",
          prefix: false,
          type: 0,
          parse: function(_context, token) {
            if (token.type === 20 && token.value === "normal") {
              return 0;
            }
            if (token.type === 17) {
              return token.number;
            }
            if (token.type === 15) {
              return token.number;
            }
            return 0;
          }
        };
        var LINE_BREAK;
        (function(LINE_BREAK2) {
          LINE_BREAK2["NORMAL"] = "normal";
          LINE_BREAK2["STRICT"] = "strict";
        })(LINE_BREAK || (LINE_BREAK = {}));
        var lineBreak = {
          name: "line-break",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, lineBreak2) {
            switch (lineBreak2) {
              case "strict":
                return LINE_BREAK.STRICT;
              case "normal":
              default:
                return LINE_BREAK.NORMAL;
            }
          }
        };
        var lineHeight = {
          name: "line-height",
          initialValue: "normal",
          prefix: false,
          type: 4
          /* TOKEN_VALUE */
        };
        var computeLineHeight = function(token, fontSize2) {
          if (isIdentToken(token) && token.value === "normal") {
            return 1.2 * fontSize2;
          } else if (token.type === 17) {
            return fontSize2 * token.number;
          } else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize2);
          }
          return fontSize2;
        };
        var listStyleImage = {
          name: "list-style-image",
          initialValue: "none",
          type: 0,
          prefix: false,
          parse: function(context, token) {
            if (token.type === 20 && token.value === "none") {
              return null;
            }
            return image.parse(context, token);
          }
        };
        var listStylePosition = {
          name: "list-style-position",
          initialValue: "outside",
          prefix: false,
          type: 2,
          parse: function(_context, position2) {
            switch (position2) {
              case "inside":
                return 0;
              case "outside":
              default:
                return 1;
            }
          }
        };
        var listStyleType = {
          name: "list-style-type",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, type) {
            switch (type) {
              case "disc":
                return 0;
              case "circle":
                return 1;
              case "square":
                return 2;
              case "decimal":
                return 3;
              case "cjk-decimal":
                return 4;
              case "decimal-leading-zero":
                return 5;
              case "lower-roman":
                return 6;
              case "upper-roman":
                return 7;
              case "lower-greek":
                return 8;
              case "lower-alpha":
                return 9;
              case "upper-alpha":
                return 10;
              case "arabic-indic":
                return 11;
              case "armenian":
                return 12;
              case "bengali":
                return 13;
              case "cambodian":
                return 14;
              case "cjk-earthly-branch":
                return 15;
              case "cjk-heavenly-stem":
                return 16;
              case "cjk-ideographic":
                return 17;
              case "devanagari":
                return 18;
              case "ethiopic-numeric":
                return 19;
              case "georgian":
                return 20;
              case "gujarati":
                return 21;
              case "gurmukhi":
                return 22;
              case "hebrew":
                return 22;
              case "hiragana":
                return 23;
              case "hiragana-iroha":
                return 24;
              case "japanese-formal":
                return 25;
              case "japanese-informal":
                return 26;
              case "kannada":
                return 27;
              case "katakana":
                return 28;
              case "katakana-iroha":
                return 29;
              case "khmer":
                return 30;
              case "korean-hangul-formal":
                return 31;
              case "korean-hanja-formal":
                return 32;
              case "korean-hanja-informal":
                return 33;
              case "lao":
                return 34;
              case "lower-armenian":
                return 35;
              case "malayalam":
                return 36;
              case "mongolian":
                return 37;
              case "myanmar":
                return 38;
              case "oriya":
                return 39;
              case "persian":
                return 40;
              case "simp-chinese-formal":
                return 41;
              case "simp-chinese-informal":
                return 42;
              case "tamil":
                return 43;
              case "telugu":
                return 44;
              case "thai":
                return 45;
              case "tibetan":
                return 46;
              case "trad-chinese-formal":
                return 47;
              case "trad-chinese-informal":
                return 48;
              case "upper-armenian":
                return 49;
              case "disclosure-open":
                return 50;
              case "disclosure-closed":
                return 51;
              case "none":
              default:
                return -1;
            }
          }
        };
        var marginForSide = function(side) {
          return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4
            /* TOKEN_VALUE */
          };
        };
        var marginTop = marginForSide("top");
        var marginRight = marginForSide("right");
        var marginBottom = marginForSide("bottom");
        var marginLeft = marginForSide("left");
        var overflow = {
          name: "overflow",
          initialValue: "visible",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow2) {
              switch (overflow2.value) {
                case "hidden":
                  return 1;
                case "scroll":
                  return 2;
                case "clip":
                  return 3;
                case "auto":
                  return 4;
                case "visible":
                default:
                  return 0;
              }
            });
          }
        };
        var overflowWrap = {
          name: "overflow-wrap",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, overflow2) {
            switch (overflow2) {
              case "break-word":
                return "break-word";
              case "normal":
              default:
                return "normal";
            }
          }
        };
        var paddingForSide = function(side) {
          return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3,
            format: "length-percentage"
          };
        };
        var paddingTop = paddingForSide("top");
        var paddingRight = paddingForSide("right");
        var paddingBottom = paddingForSide("bottom");
        var paddingLeft = paddingForSide("left");
        var textAlign = {
          name: "text-align",
          initialValue: "left",
          prefix: false,
          type: 2,
          parse: function(_context, textAlign2) {
            switch (textAlign2) {
              case "right":
                return 2;
              case "center":
              case "justify":
                return 1;
              case "left":
              default:
                return 0;
            }
          }
        };
        var position = {
          name: "position",
          initialValue: "static",
          prefix: false,
          type: 2,
          parse: function(_context, position2) {
            switch (position2) {
              case "relative":
                return 1;
              case "absolute":
                return 2;
              case "fixed":
                return 3;
              case "sticky":
                return 4;
            }
            return 0;
          }
        };
        var textShadow = {
          name: "text-shadow",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) {
              return [];
            }
            return parseFunctionArgs(tokens).map(function(values) {
              var shadow = {
                color: COLORS.TRANSPARENT,
                offsetX: ZERO_LENGTH,
                offsetY: ZERO_LENGTH,
                blur: ZERO_LENGTH
              };
              var c = 0;
              for (var i2 = 0; i2 < values.length; i2++) {
                var token = values[i2];
                if (isLength(token)) {
                  if (c === 0) {
                    shadow.offsetX = token;
                  } else if (c === 1) {
                    shadow.offsetY = token;
                  } else {
                    shadow.blur = token;
                  }
                  c++;
                } else {
                  shadow.color = color$1.parse(context, token);
                }
              }
              return shadow;
            });
          }
        };
        var textTransform = {
          name: "text-transform",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, textTransform2) {
            switch (textTransform2) {
              case "uppercase":
                return 2;
              case "lowercase":
                return 1;
              case "capitalize":
                return 3;
            }
            return 0;
          }
        };
        var transform$1 = {
          name: "transform",
          initialValue: "none",
          prefix: true,
          type: 0,
          parse: function(_context, token) {
            if (token.type === 20 && token.value === "none") {
              return null;
            }
            if (token.type === 18) {
              var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
              if (typeof transformFunction === "undefined") {
                throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
              }
              return transformFunction(token.values);
            }
            return null;
          }
        };
        var matrix = function(args) {
          var values = args.filter(function(arg) {
            return arg.type === 17;
          }).map(function(arg) {
            return arg.number;
          });
          return values.length === 6 ? values : null;
        };
        var matrix3d = function(args) {
          var values = args.filter(function(arg) {
            return arg.type === 17;
          }).map(function(arg) {
            return arg.number;
          });
          var a1 = values[0], b1 = values[1];
          values[2];
          values[3];
          var a2 = values[4], b2 = values[5];
          values[6];
          values[7];
          values[8];
          values[9];
          values[10];
          values[11];
          var a4 = values[12], b4 = values[13];
          values[14];
          values[15];
          return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
        };
        var SUPPORTED_TRANSFORM_FUNCTIONS = {
          matrix,
          matrix3d
        };
        var DEFAULT_VALUE = {
          type: 16,
          number: 50,
          flags: FLAG_INTEGER
        };
        var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
        var transformOrigin = {
          name: "transform-origin",
          initialValue: "50% 50%",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
              return DEFAULT;
            }
            return [origins[0], origins[1]];
          }
        };
        var visibility = {
          name: "visible",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, visibility2) {
            switch (visibility2) {
              case "hidden":
                return 1;
              case "collapse":
                return 2;
              case "visible":
              default:
                return 0;
            }
          }
        };
        var WORD_BREAK;
        (function(WORD_BREAK2) {
          WORD_BREAK2["NORMAL"] = "normal";
          WORD_BREAK2["BREAK_ALL"] = "break-all";
          WORD_BREAK2["KEEP_ALL"] = "keep-all";
        })(WORD_BREAK || (WORD_BREAK = {}));
        var wordBreak = {
          name: "word-break",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, wordBreak2) {
            switch (wordBreak2) {
              case "break-all":
                return WORD_BREAK.BREAK_ALL;
              case "keep-all":
                return WORD_BREAK.KEEP_ALL;
              case "normal":
              default:
                return WORD_BREAK.NORMAL;
            }
          }
        };
        var zIndex2 = {
          name: "z-index",
          initialValue: "auto",
          prefix: false,
          type: 0,
          parse: function(_context, token) {
            if (token.type === 20) {
              return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
              return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
          }
        };
        var time = {
          name: "time",
          parse: function(_context, value) {
            if (value.type === 15) {
              switch (value.unit.toLowerCase()) {
                case "s":
                  return 1e3 * value.number;
                case "ms":
                  return value.number;
              }
            }
            throw new Error("Unsupported time type");
          }
        };
        var opacity = {
          name: "opacity",
          initialValue: "1",
          type: 0,
          prefix: false,
          parse: function(_context, token) {
            if (isNumberToken(token)) {
              return token.number;
            }
            return 1;
          }
        };
        var textDecorationColor = {
          name: "text-decoration-color",
          initialValue: "transparent",
          prefix: false,
          type: 3,
          format: "color"
        };
        var textDecorationLine = {
          name: "text-decoration-line",
          initialValue: "none",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
              switch (token.value) {
                case "underline":
                  return 1;
                case "overline":
                  return 2;
                case "line-through":
                  return 3;
                case "none":
                  return 4;
              }
              return 0;
            }).filter(function(line) {
              return line !== 0;
            });
          }
        };
        var fontFamily = {
          name: "font-family",
          initialValue: "",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
              switch (token.type) {
                case 20:
                case 0:
                  accumulator.push(token.value);
                  break;
                case 17:
                  accumulator.push(token.number.toString());
                  break;
                case 4:
                  results.push(accumulator.join(" "));
                  accumulator.length = 0;
                  break;
              }
            });
            if (accumulator.length) {
              results.push(accumulator.join(" "));
            }
            return results.map(function(result) {
              return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
          }
        };
        var fontSize = {
          name: "font-size",
          initialValue: "0",
          prefix: false,
          type: 3,
          format: "length"
        };
        var fontWeight = {
          name: "font-weight",
          initialValue: "normal",
          type: 0,
          prefix: false,
          parse: function(_context, token) {
            if (isNumberToken(token)) {
              return token.number;
            }
            if (isIdentToken(token)) {
              switch (token.value) {
                case "bold":
                  return 700;
                case "normal":
                default:
                  return 400;
              }
            }
            return 400;
          }
        };
        var fontVariant = {
          name: "font-variant",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
              return token.value;
            });
          }
        };
        var fontStyle = {
          name: "font-style",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, overflow2) {
            switch (overflow2) {
              case "oblique":
                return "oblique";
              case "italic":
                return "italic";
              case "normal":
              default:
                return "normal";
            }
          }
        };
        var contains = function(bit, value) {
          return (bit & value) !== 0;
        };
        var content = {
          name: "content",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return [];
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return [];
            }
            return tokens;
          }
        };
        var counterIncrement = {
          name: "counter-increment",
          initialValue: "none",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return null;
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i2 = 0; i2 < filtered.length; i2++) {
              var counter = filtered[i2];
              var next = filtered[i2 + 1];
              if (counter.type === 20) {
                var increment = next && isNumberToken(next) ? next.number : 1;
                increments.push({ counter: counter.value, increment });
              }
            }
            return increments;
          }
        };
        var counterReset = {
          name: "counter-reset",
          initialValue: "none",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i2 = 0; i2 < filtered.length; i2++) {
              var counter = filtered[i2];
              var next = filtered[i2 + 1];
              if (isIdentToken(counter) && counter.value !== "none") {
                var reset = next && isNumberToken(next) ? next.number : 0;
                resets.push({ counter: counter.value, reset });
              }
            }
            return resets;
          }
        };
        var duration = {
          name: "duration",
          initialValue: "0s",
          prefix: false,
          type: 1,
          parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
              return time.parse(context, token);
            });
          }
        };
        var quotes = {
          name: "quotes",
          initialValue: "none",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return null;
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return null;
            }
            var quotes2 = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
              return null;
            }
            for (var i2 = 0; i2 < filtered.length; i2 += 2) {
              var open_1 = filtered[i2].value;
              var close_1 = filtered[i2 + 1].value;
              quotes2.push({ open: open_1, close: close_1 });
            }
            return quotes2;
          }
        };
        var getQuote = function(quotes2, depth, open) {
          if (!quotes2) {
            return "";
          }
          var quote = quotes2[Math.min(depth, quotes2.length - 1)];
          if (!quote) {
            return "";
          }
          return open ? quote.open : quote.close;
        };
        var boxShadow = {
          name: "box-shadow",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) {
              return [];
            }
            return parseFunctionArgs(tokens).map(function(values) {
              var shadow = {
                color: 255,
                offsetX: ZERO_LENGTH,
                offsetY: ZERO_LENGTH,
                blur: ZERO_LENGTH,
                spread: ZERO_LENGTH,
                inset: false
              };
              var c = 0;
              for (var i2 = 0; i2 < values.length; i2++) {
                var token = values[i2];
                if (isIdentWithValue(token, "inset")) {
                  shadow.inset = true;
                } else if (isLength(token)) {
                  if (c === 0) {
                    shadow.offsetX = token;
                  } else if (c === 1) {
                    shadow.offsetY = token;
                  } else if (c === 2) {
                    shadow.blur = token;
                  } else {
                    shadow.spread = token;
                  }
                  c++;
                } else {
                  shadow.color = color$1.parse(context, token);
                }
              }
              return shadow;
            });
          }
        };
        var paintOrder = {
          name: "paint-order",
          initialValue: "normal",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            var DEFAULT_VALUE2 = [
              0,
              1,
              2
              /* MARKERS */
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
              switch (token.value) {
                case "stroke":
                  layers.push(
                    1
                    /* STROKE */
                  );
                  break;
                case "fill":
                  layers.push(
                    0
                    /* FILL */
                  );
                  break;
                case "markers":
                  layers.push(
                    2
                    /* MARKERS */
                  );
                  break;
              }
            });
            DEFAULT_VALUE2.forEach(function(value) {
              if (layers.indexOf(value) === -1) {
                layers.push(value);
              }
            });
            return layers;
          }
        };
        var webkitTextStrokeColor = {
          name: "-webkit-text-stroke-color",
          initialValue: "currentcolor",
          prefix: false,
          type: 3,
          format: "color"
        };
        var webkitTextStrokeWidth = {
          name: "-webkit-text-stroke-width",
          initialValue: "0",
          type: 0,
          prefix: false,
          parse: function(_context, token) {
            if (isDimensionToken(token)) {
              return token.number;
            }
            return 0;
          }
        };
        var CSSParsedDeclaration = (
          /** @class */
          function() {
            function CSSParsedDeclaration2(context, declaration) {
              var _a, _b;
              this.animationDuration = parse(context, duration, declaration.animationDuration);
              this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
              this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
              this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
              this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
              this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
              this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
              this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
              this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
              this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
              this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
              this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
              this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
              this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
              this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
              this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
              this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
              this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
              this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
              this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
              this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
              this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
              this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
              this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
              this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
              this.color = parse(context, color2, declaration.color);
              this.direction = parse(context, direction, declaration.direction);
              this.display = parse(context, display, declaration.display);
              this.float = parse(context, float, declaration.cssFloat);
              this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
              this.fontSize = parse(context, fontSize, declaration.fontSize);
              this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
              this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
              this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
              this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
              this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
              this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
              this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
              this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
              this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
              this.marginTop = parse(context, marginTop, declaration.marginTop);
              this.marginRight = parse(context, marginRight, declaration.marginRight);
              this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
              this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
              this.opacity = parse(context, opacity, declaration.opacity);
              var overflowTuple = parse(context, overflow, declaration.overflow);
              this.overflowX = overflowTuple[0];
              this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
              this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
              this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
              this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
              this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
              this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
              this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
              this.position = parse(context, position, declaration.position);
              this.textAlign = parse(context, textAlign, declaration.textAlign);
              this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
              this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
              this.textShadow = parse(context, textShadow, declaration.textShadow);
              this.textTransform = parse(context, textTransform, declaration.textTransform);
              this.transform = parse(context, transform$1, declaration.transform);
              this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
              this.visibility = parse(context, visibility, declaration.visibility);
              this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
              this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
              this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
              this.zIndex = parse(context, zIndex2, declaration.zIndex);
            }
            CSSParsedDeclaration2.prototype.isVisible = function() {
              return this.display > 0 && this.opacity > 0 && this.visibility === 0;
            };
            CSSParsedDeclaration2.prototype.isTransparent = function() {
              return isTransparent(this.backgroundColor);
            };
            CSSParsedDeclaration2.prototype.isTransformed = function() {
              return this.transform !== null;
            };
            CSSParsedDeclaration2.prototype.isPositioned = function() {
              return this.position !== 0;
            };
            CSSParsedDeclaration2.prototype.isPositionedWithZIndex = function() {
              return this.isPositioned() && !this.zIndex.auto;
            };
            CSSParsedDeclaration2.prototype.isFloating = function() {
              return this.float !== 0;
            };
            CSSParsedDeclaration2.prototype.isInlineLevel = function() {
              return contains(
                this.display,
                4
                /* INLINE */
              ) || contains(
                this.display,
                33554432
                /* INLINE_BLOCK */
              ) || contains(
                this.display,
                268435456
                /* INLINE_FLEX */
              ) || contains(
                this.display,
                536870912
                /* INLINE_GRID */
              ) || contains(
                this.display,
                67108864
                /* INLINE_LIST_ITEM */
              ) || contains(
                this.display,
                134217728
                /* INLINE_TABLE */
              );
            };
            return CSSParsedDeclaration2;
          }()
        );
        var CSSParsedPseudoDeclaration = (
          /** @class */
          /* @__PURE__ */ function() {
            function CSSParsedPseudoDeclaration2(context, declaration) {
              this.content = parse(context, content, declaration.content);
              this.quotes = parse(context, quotes, declaration.quotes);
            }
            return CSSParsedPseudoDeclaration2;
          }()
        );
        var CSSParsedCounterDeclaration = (
          /** @class */
          /* @__PURE__ */ function() {
            function CSSParsedCounterDeclaration2(context, declaration) {
              this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
              this.counterReset = parse(context, counterReset, declaration.counterReset);
            }
            return CSSParsedCounterDeclaration2;
          }()
        );
        var parse = function(context, descriptor, style) {
          var tokenizer = new Tokenizer();
          var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
          tokenizer.write(value);
          var parser = new Parser(tokenizer.read());
          switch (descriptor.type) {
            case 2:
              var token = parser.parseComponentValue();
              return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0:
              return descriptor.parse(context, parser.parseComponentValue());
            case 1:
              return descriptor.parse(context, parser.parseComponentValues());
            case 4:
              return parser.parseComponentValue();
            case 3:
              switch (descriptor.format) {
                case "angle":
                  return angle.parse(context, parser.parseComponentValue());
                case "color":
                  return color$1.parse(context, parser.parseComponentValue());
                case "image":
                  return image.parse(context, parser.parseComponentValue());
                case "length":
                  var length_1 = parser.parseComponentValue();
                  return isLength(length_1) ? length_1 : ZERO_LENGTH;
                case "length-percentage":
                  var value_1 = parser.parseComponentValue();
                  return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                case "time":
                  return time.parse(context, parser.parseComponentValue());
              }
              break;
          }
        };
        var elementDebuggerAttribute = "data-html2canvas-debug";
        var getElementDebugType = function(element) {
          var attribute = element.getAttribute(elementDebuggerAttribute);
          switch (attribute) {
            case "all":
              return 1;
            case "clone":
              return 2;
            case "parse":
              return 3;
            case "render":
              return 4;
            default:
              return 0;
          }
        };
        var isDebugging = function(element, type) {
          var elementType = getElementDebugType(element);
          return elementType === 1 || type === elementType;
        };
        var ElementContainer = (
          /** @class */
          /* @__PURE__ */ function() {
            function ElementContainer2(context, element) {
              this.context = context;
              this.textNodes = [];
              this.elements = [];
              this.flags = 0;
              if (isDebugging(
                element,
                3
                /* PARSE */
              )) {
                debugger;
              }
              this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
              if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration2) {
                  return duration2 > 0;
                })) {
                  element.style.animationDuration = "0s";
                }
                if (this.styles.transform !== null) {
                  element.style.transform = "none";
                }
              }
              this.bounds = parseBounds(this.context, element);
              if (isDebugging(
                element,
                4
                /* RENDER */
              )) {
                this.flags |= 16;
              }
            }
            return ElementContainer2;
          }()
        );
        var base64 = "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";
        var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
          lookup$1[chars$1.charCodeAt(i$1)] = i$1;
        }
        var decode = function(base642) {
          var bufferLength = base642.length * 0.75, len = base642.length, i2, p = 0, encoded1, encoded2, encoded3, encoded4;
          if (base642[base642.length - 1] === "=") {
            bufferLength--;
            if (base642[base642.length - 2] === "=") {
              bufferLength--;
            }
          }
          var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
          var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
          for (i2 = 0; i2 < len; i2 += 4) {
            encoded1 = lookup$1[base642.charCodeAt(i2)];
            encoded2 = lookup$1[base642.charCodeAt(i2 + 1)];
            encoded3 = lookup$1[base642.charCodeAt(i2 + 2)];
            encoded4 = lookup$1[base642.charCodeAt(i2 + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
          }
          return buffer;
        };
        var polyUint16Array = function(buffer) {
          var length = buffer.length;
          var bytes = [];
          for (var i2 = 0; i2 < length; i2 += 2) {
            bytes.push(buffer[i2 + 1] << 8 | buffer[i2]);
          }
          return bytes;
        };
        var polyUint32Array = function(buffer) {
          var length = buffer.length;
          var bytes = [];
          for (var i2 = 0; i2 < length; i2 += 4) {
            bytes.push(buffer[i2 + 3] << 24 | buffer[i2 + 2] << 16 | buffer[i2 + 1] << 8 | buffer[i2]);
          }
          return bytes;
        };
        var UTRIE2_SHIFT_2 = 5;
        var UTRIE2_SHIFT_1 = 6 + 5;
        var UTRIE2_INDEX_SHIFT = 2;
        var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
        var UTRIE2_LSCP_INDEX_2_OFFSET = 65536 >> UTRIE2_SHIFT_2;
        var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
        var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
        var UTRIE2_LSCP_INDEX_2_LENGTH = 1024 >> UTRIE2_SHIFT_2;
        var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
        var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
        var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 2048 >> 6;
        var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
        var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 65536 >> UTRIE2_SHIFT_1;
        var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
        var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
        var slice16 = function(view, start, end) {
          if (view.slice) {
            return view.slice(start, end);
          }
          return new Uint16Array(Array.prototype.slice.call(view, start, end));
        };
        var slice32 = function(view, start, end) {
          if (view.slice) {
            return view.slice(start, end);
          }
          return new Uint32Array(Array.prototype.slice.call(view, start, end));
        };
        var createTrieFromBase64 = function(base642, _byteLength) {
          var buffer = decode(base642);
          var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
          var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
          var headerLength = 24;
          var index = slice16(view16, headerLength / 2, view32[4] / 2);
          var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
          return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
        };
        var Trie = (
          /** @class */
          function() {
            function Trie2(initialValue, errorValue, highStart, highValueIndex, index, data) {
              this.initialValue = initialValue;
              this.errorValue = errorValue;
              this.highStart = highStart;
              this.highValueIndex = highValueIndex;
              this.index = index;
              this.data = data;
            }
            Trie2.prototype.get = function(codePoint) {
              var ix;
              if (codePoint >= 0) {
                if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
                  ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                  ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                  return this.data[ix];
                }
                if (codePoint <= 65535) {
                  ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 55296 >> UTRIE2_SHIFT_2)];
                  ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                  return this.data[ix];
                }
                if (codePoint < this.highStart) {
                  ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                  ix = this.index[ix];
                  ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                  ix = this.index[ix];
                  ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                  return this.data[ix];
                }
                if (codePoint <= 1114111) {
                  return this.data[this.highValueIndex];
                }
              }
              return this.errorValue;
            };
            return Trie2;
          }()
        );
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i = 0; i < chars.length; i++) {
          lookup[chars.charCodeAt(i)] = i;
        }
        var Prepend = 1;
        var CR = 2;
        var LF = 3;
        var Control = 4;
        var Extend = 5;
        var SpacingMark = 7;
        var L = 8;
        var V = 9;
        var T = 10;
        var LV = 11;
        var LVT = 12;
        var ZWJ = 13;
        var Extended_Pictographic = 14;
        var RI = 15;
        var toCodePoints = function(str) {
          var codePoints = [];
          var i2 = 0;
          var length = str.length;
          while (i2 < length) {
            var value = str.charCodeAt(i2++);
            if (value >= 55296 && value <= 56319 && i2 < length) {
              var extra = str.charCodeAt(i2++);
              if ((extra & 64512) === 56320) {
                codePoints.push(((value & 1023) << 10) + (extra & 1023) + 65536);
              } else {
                codePoints.push(value);
                i2--;
              }
            } else {
              codePoints.push(value);
            }
          }
          return codePoints;
        };
        var fromCodePoint = function() {
          var codePoints = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
          }
          if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
          }
          var length = codePoints.length;
          if (!length) {
            return "";
          }
          var codeUnits = [];
          var index = -1;
          var result = "";
          while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 65535) {
              codeUnits.push(codePoint);
            } else {
              codePoint -= 65536;
              codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
            }
            if (index + 1 === length || codeUnits.length > 16384) {
              result += String.fromCharCode.apply(String, codeUnits);
              codeUnits.length = 0;
            }
          }
          return result;
        };
        var UnicodeTrie = createTrieFromBase64(base64);
        var BREAK_NOT_ALLOWED = "\xD7";
        var BREAK_ALLOWED = "\xF7";
        var codePointToClass = function(codePoint) {
          return UnicodeTrie.get(codePoint);
        };
        var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
          var prevIndex = index - 2;
          var prev = classTypes[prevIndex];
          var current = classTypes[index - 1];
          var next = classTypes[index];
          if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
          }
          if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
          }
          if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
          }
          if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
          }
          if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
          }
          if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
          }
          if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
          }
          if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
          }
          if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
          }
          if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
              prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
              return BREAK_NOT_ALLOWED;
            }
          }
          if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
              countRI++;
              prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
              return BREAK_NOT_ALLOWED;
            }
          }
          return BREAK_ALLOWED;
        };
        var GraphemeBreaker = function(str) {
          var codePoints = toCodePoints(str);
          var length = codePoints.length;
          var index = 0;
          var lastEnd = 0;
          var classTypes = codePoints.map(codePointToClass);
          return {
            next: function() {
              if (index >= length) {
                return { done: true, value: null };
              }
              var graphemeBreak = BREAK_NOT_ALLOWED;
              while (index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) {
              }
              if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                lastEnd = index;
                return { value, done: false };
              }
              return { done: true, value: null };
            }
          };
        };
        var splitGraphemes = function(str) {
          var breaker = GraphemeBreaker(str);
          var graphemes = [];
          var bk;
          while (!(bk = breaker.next()).done) {
            if (bk.value) {
              graphemes.push(bk.value.slice());
            }
          }
          return graphemes;
        };
        var testRangeBounds = function(document2) {
          var TEST_HEIGHT = 123;
          if (document2.createRange) {
            var range = document2.createRange();
            if (range.getBoundingClientRect) {
              var testElement = document2.createElement("boundtest");
              testElement.style.height = TEST_HEIGHT + "px";
              testElement.style.display = "block";
              document2.body.appendChild(testElement);
              range.selectNode(testElement);
              var rangeBounds = range.getBoundingClientRect();
              var rangeHeight = Math.round(rangeBounds.height);
              document2.body.removeChild(testElement);
              if (rangeHeight === TEST_HEIGHT) {
                return true;
              }
            }
          }
          return false;
        };
        var testIOSLineBreak = function(document2) {
          var testElement = document2.createElement("boundtest");
          testElement.style.width = "50px";
          testElement.style.display = "block";
          testElement.style.fontSize = "12px";
          testElement.style.letterSpacing = "0px";
          testElement.style.wordSpacing = "0px";
          document2.body.appendChild(testElement);
          var range = document2.createRange();
          testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
          var node = testElement.firstChild;
          var textList = toCodePoints$1(node.data).map(function(i2) {
            return fromCodePoint$1(i2);
          });
          var offset = 0;
          var prev = {};
          var supports = textList.every(function(text, i2) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i2 === 0) {
              return true;
            }
            return boundAhead;
          });
          document2.body.removeChild(testElement);
          return supports;
        };
        var testCORS = function() {
          return typeof new Image().crossOrigin !== "undefined";
        };
        var testResponseType = function() {
          return typeof new XMLHttpRequest().responseType === "string";
        };
        var testSVG = function(document2) {
          var img = new Image();
          var canvas = document2.createElement("canvas");
          var ctx = canvas.getContext("2d");
          if (!ctx) {
            return false;
          }
          img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
          try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
          } catch (e2) {
            return false;
          }
          return true;
        };
        var isGreenPixel = function(data) {
          return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
        };
        var testForeignObject = function(document2) {
          var canvas = document2.createElement("canvas");
          var size = 100;
          canvas.width = size;
          canvas.height = size;
          var ctx = canvas.getContext("2d");
          if (!ctx) {
            return Promise.reject(false);
          }
          ctx.fillStyle = "rgb(0, 255, 0)";
          ctx.fillRect(0, 0, size, size);
          var img = new Image();
          var greenImageSrc = canvas.toDataURL();
          img.src = greenImageSrc;
          var svg2 = createForeignObjectSVG(size, size, 0, 0, img);
          ctx.fillStyle = "red";
          ctx.fillRect(0, 0, size, size);
          return loadSerializedSVG$1(svg2).then(function(img2) {
            ctx.drawImage(img2, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document2.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
          }).then(function(img2) {
            ctx.drawImage(img2, 0, 0);
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
          }).catch(function() {
            return false;
          });
        };
        var createForeignObjectSVG = function(width, height, x, y, node) {
          var xmlns = "http://www.w3.org/2000/svg";
          var svg2 = document.createElementNS(xmlns, "svg");
          var foreignObject = document.createElementNS(xmlns, "foreignObject");
          svg2.setAttributeNS(null, "width", width.toString());
          svg2.setAttributeNS(null, "height", height.toString());
          foreignObject.setAttributeNS(null, "width", "100%");
          foreignObject.setAttributeNS(null, "height", "100%");
          foreignObject.setAttributeNS(null, "x", x.toString());
          foreignObject.setAttributeNS(null, "y", y.toString());
          foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
          svg2.appendChild(foreignObject);
          foreignObject.appendChild(node);
          return svg2;
        };
        var loadSerializedSVG$1 = function(svg2) {
          return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
              return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg2));
          });
        };
        var FEATURES = {
          get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", { value });
            return value;
          },
          get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", { value });
            return value;
          },
          get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", { value });
            return value;
          },
          get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", { value });
            return value;
          },
          get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", { value });
            return value;
          },
          get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", { value });
            return value;
          },
          get SUPPORT_CORS_XHR() {
            var value = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", { value });
            return value;
          },
          get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            var value = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value });
            return value;
          }
        };
        var TextBounds = (
          /** @class */
          /* @__PURE__ */ function() {
            function TextBounds2(text, bounds) {
              this.text = text;
              this.bounds = bounds;
            }
            return TextBounds2;
          }()
        );
        var parseTextBounds = function(context, value, styles, node) {
          var textList = breakText(value, styles);
          var textBounds = [];
          var offset = 0;
          textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
              if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                var clientRects = createRange(node, offset, text.length).getClientRects();
                if (clientRects.length > 1) {
                  var subSegments = segmentGraphemes(text);
                  var subOffset_1 = 0;
                  subSegments.forEach(function(subSegment) {
                    textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                    subOffset_1 += subSegment.length;
                  });
                } else {
                  textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                }
              } else {
                var replacementNode = node.splitText(text.length);
                textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                node = replacementNode;
              }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
              node = node.splitText(text.length);
            }
            offset += text.length;
          });
          return textBounds;
        };
        var getWrapperBounds = function(context, node) {
          var ownerDocument = node.ownerDocument;
          if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
              parentNode.replaceChild(wrapper, node);
              var bounds = parseBounds(context, wrapper);
              if (wrapper.firstChild) {
                parentNode.replaceChild(wrapper.firstChild, wrapper);
              }
              return bounds;
            }
          }
          return Bounds.EMPTY;
        };
        var createRange = function(node, offset, length) {
          var ownerDocument = node.ownerDocument;
          if (!ownerDocument) {
            throw new Error("Node has no owner document");
          }
          var range = ownerDocument.createRange();
          range.setStart(node, offset);
          range.setEnd(node, offset + length);
          return range;
        };
        var segmentGraphemes = function(value) {
          if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            var segmenter2 = new Intl.Segmenter(void 0, { granularity: "grapheme" });
            return Array.from(segmenter2.segment(value)).map(function(segment) {
              return segment.segment;
            });
          }
          return splitGraphemes(value);
        };
        var segmentWords = function(value, styles) {
          if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            var segmenter2 = new Intl.Segmenter(void 0, {
              granularity: "word"
            });
            return Array.from(segmenter2.segment(value)).map(function(segment) {
              return segment.segment;
            });
          }
          return breakWords(value, styles);
        };
        var breakText = function(value, styles) {
          return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
        };
        var wordSeparators = [32, 160, 4961, 65792, 65793, 4153, 4241];
        var breakWords = function(str, styles) {
          var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" ? "break-word" : styles.wordBreak
          });
          var words = [];
          var bk;
          var _loop_1 = function() {
            if (bk.value) {
              var value = bk.value.slice();
              var codePoints = toCodePoints$1(value);
              var word_1 = "";
              codePoints.forEach(function(codePoint) {
                if (wordSeparators.indexOf(codePoint) === -1) {
                  word_1 += fromCodePoint$1(codePoint);
                } else {
                  if (word_1.length) {
                    words.push(word_1);
                  }
                  words.push(fromCodePoint$1(codePoint));
                  word_1 = "";
                }
              });
              if (word_1.length) {
                words.push(word_1);
              }
            }
          };
          while (!(bk = breaker.next()).done) {
            _loop_1();
          }
          return words;
        };
        var TextContainer = (
          /** @class */
          /* @__PURE__ */ function() {
            function TextContainer2(context, node, styles) {
              this.text = transform(node.data, styles.textTransform);
              this.textBounds = parseTextBounds(context, this.text, styles, node);
            }
            return TextContainer2;
          }()
        );
        var transform = function(text, transform2) {
          switch (transform2) {
            case 1:
              return text.toLowerCase();
            case 3:
              return text.replace(CAPITALIZE, capitalize);
            case 2:
              return text.toUpperCase();
            default:
              return text;
          }
        };
        var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
        var capitalize = function(m, p1, p2) {
          if (m.length > 0) {
            return p1 + p2.toUpperCase();
          }
          return m;
        };
        var ImageElementContainer = (
          /** @class */
          function(_super) {
            __extends(ImageElementContainer2, _super);
            function ImageElementContainer2(context, img) {
              var _this = _super.call(this, context, img) || this;
              _this.src = img.currentSrc || img.src;
              _this.intrinsicWidth = img.naturalWidth;
              _this.intrinsicHeight = img.naturalHeight;
              _this.context.cache.addImage(_this.src);
              return _this;
            }
            return ImageElementContainer2;
          }(ElementContainer)
        );
        var CanvasElementContainer = (
          /** @class */
          function(_super) {
            __extends(CanvasElementContainer2, _super);
            function CanvasElementContainer2(context, canvas) {
              var _this = _super.call(this, context, canvas) || this;
              _this.canvas = canvas;
              _this.intrinsicWidth = canvas.width;
              _this.intrinsicHeight = canvas.height;
              return _this;
            }
            return CanvasElementContainer2;
          }(ElementContainer)
        );
        var SVGElementContainer = (
          /** @class */
          function(_super) {
            __extends(SVGElementContainer2, _super);
            function SVGElementContainer2(context, img) {
              var _this = _super.call(this, context, img) || this;
              var s = new XMLSerializer();
              var bounds = parseBounds(context, img);
              img.setAttribute("width", bounds.width + "px");
              img.setAttribute("height", bounds.height + "px");
              _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
              _this.intrinsicWidth = img.width.baseVal.value;
              _this.intrinsicHeight = img.height.baseVal.value;
              _this.context.cache.addImage(_this.svg);
              return _this;
            }
            return SVGElementContainer2;
          }(ElementContainer)
        );
        var LIElementContainer = (
          /** @class */
          function(_super) {
            __extends(LIElementContainer2, _super);
            function LIElementContainer2(context, element) {
              var _this = _super.call(this, context, element) || this;
              _this.value = element.value;
              return _this;
            }
            return LIElementContainer2;
          }(ElementContainer)
        );
        var OLElementContainer = (
          /** @class */
          function(_super) {
            __extends(OLElementContainer2, _super);
            function OLElementContainer2(context, element) {
              var _this = _super.call(this, context, element) || this;
              _this.start = element.start;
              _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
              return _this;
            }
            return OLElementContainer2;
          }(ElementContainer)
        );
        var CHECKBOX_BORDER_RADIUS = [
          {
            type: 15,
            flags: 0,
            unit: "px",
            number: 3
          }
        ];
        var RADIO_BORDER_RADIUS = [
          {
            type: 16,
            flags: 0,
            number: 50
          }
        ];
        var reformatInputBounds = function(bounds) {
          if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
          } else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
          }
          return bounds;
        };
        var getInputValue = function(node) {
          var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
          return value.length === 0 ? node.placeholder || "" : value;
        };
        var CHECKBOX = "checkbox";
        var RADIO = "radio";
        var PASSWORD = "password";
        var INPUT_COLOR = 707406591;
        var InputElementContainer = (
          /** @class */
          function(_super) {
            __extends(InputElementContainer2, _super);
            function InputElementContainer2(context, input) {
              var _this = _super.call(this, context, input) || this;
              _this.type = input.type.toLowerCase();
              _this.checked = input.checked;
              _this.value = getInputValue(input);
              if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 3739148031;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 2779096575;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1;
                _this.styles.backgroundClip = [
                  0
                  /* BORDER_BOX */
                ];
                _this.styles.backgroundOrigin = [
                  0
                  /* BORDER_BOX */
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
              }
              switch (_this.type) {
                case CHECKBOX:
                  _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                  break;
                case RADIO:
                  _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                  break;
              }
              return _this;
            }
            return InputElementContainer2;
          }(ElementContainer)
        );
        var SelectElementContainer = (
          /** @class */
          function(_super) {
            __extends(SelectElementContainer2, _super);
            function SelectElementContainer2(context, element) {
              var _this = _super.call(this, context, element) || this;
              var option = element.options[element.selectedIndex || 0];
              _this.value = option ? option.text || "" : "";
              return _this;
            }
            return SelectElementContainer2;
          }(ElementContainer)
        );
        var TextareaElementContainer = (
          /** @class */
          function(_super) {
            __extends(TextareaElementContainer2, _super);
            function TextareaElementContainer2(context, element) {
              var _this = _super.call(this, context, element) || this;
              _this.value = element.value;
              return _this;
            }
            return TextareaElementContainer2;
          }(ElementContainer)
        );
        var IFrameElementContainer = (
          /** @class */
          function(_super) {
            __extends(IFrameElementContainer2, _super);
            function IFrameElementContainer2(context, iframe) {
              var _this = _super.call(this, context, iframe) || this;
              _this.src = iframe.src;
              _this.width = parseInt(iframe.width, 10) || 0;
              _this.height = parseInt(iframe.height, 10) || 0;
              _this.backgroundColor = _this.styles.backgroundColor;
              try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                  _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                  var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor2(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                  var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor2(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                  _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
              } catch (e2) {
              }
              return _this;
            }
            return IFrameElementContainer2;
          }(ElementContainer)
        );
        var LIST_OWNERS = ["OL", "UL", "MENU"];
        var parseNodeTree = function(context, node, parent, root) {
          for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
              parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            } else if (isElementNode(childNode)) {
              if (isSlotElement(childNode) && childNode.assignedNodes) {
                childNode.assignedNodes().forEach(function(childNode2) {
                  return parseNodeTree(context, childNode2, parent, root);
                });
              } else {
                var container = createContainer(context, childNode);
                if (container.styles.isVisible()) {
                  if (createsRealStackingContext(childNode, container, root)) {
                    container.flags |= 4;
                  } else if (createsStackingContext(container.styles)) {
                    container.flags |= 2;
                  }
                  if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                    container.flags |= 8;
                  }
                  parent.elements.push(container);
                  childNode.slot;
                  if (childNode.shadowRoot) {
                    parseNodeTree(context, childNode.shadowRoot, container, root);
                  } else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                    parseNodeTree(context, childNode, container, root);
                  }
                }
              }
            }
          }
        };
        var createContainer = function(context, element) {
          if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
          }
          if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
          }
          if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
          }
          if (isLIElement(element)) {
            return new LIElementContainer(context, element);
          }
          if (isOLElement(element)) {
            return new OLElementContainer(context, element);
          }
          if (isInputElement(element)) {
            return new InputElementContainer(context, element);
          }
          if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
          }
          if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
          }
          if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
          }
          return new ElementContainer(context, element);
        };
        var parseTree = function(context, element) {
          var container = createContainer(context, element);
          container.flags |= 4;
          parseNodeTree(context, element, container, container);
          return container;
        };
        var createsRealStackingContext = function(node, container, root) {
          return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
        };
        var createsStackingContext = function(styles) {
          return styles.isPositioned() || styles.isFloating();
        };
        var isTextNode = function(node) {
          return node.nodeType === Node.TEXT_NODE;
        };
        var isElementNode = function(node) {
          return node.nodeType === Node.ELEMENT_NODE;
        };
        var isHTMLElementNode = function(node) {
          return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
        };
        var isSVGElementNode = function(element) {
          return typeof element.className === "object";
        };
        var isLIElement = function(node) {
          return node.tagName === "LI";
        };
        var isOLElement = function(node) {
          return node.tagName === "OL";
        };
        var isInputElement = function(node) {
          return node.tagName === "INPUT";
        };
        var isHTMLElement3 = function(node) {
          return node.tagName === "HTML";
        };
        var isSVGElement = function(node) {
          return node.tagName === "svg";
        };
        var isBodyElement = function(node) {
          return node.tagName === "BODY";
        };
        var isCanvasElement = function(node) {
          return node.tagName === "CANVAS";
        };
        var isVideoElement = function(node) {
          return node.tagName === "VIDEO";
        };
        var isImageElement = function(node) {
          return node.tagName === "IMG";
        };
        var isIFrameElement = function(node) {
          return node.tagName === "IFRAME";
        };
        var isStyleElement = function(node) {
          return node.tagName === "STYLE";
        };
        var isScriptElement = function(node) {
          return node.tagName === "SCRIPT";
        };
        var isTextareaElement = function(node) {
          return node.tagName === "TEXTAREA";
        };
        var isSelectElement = function(node) {
          return node.tagName === "SELECT";
        };
        var isSlotElement = function(node) {
          return node.tagName === "SLOT";
        };
        var isCustomElement = function(node) {
          return node.tagName.indexOf("-") > 0;
        };
        var CounterState = (
          /** @class */
          function() {
            function CounterState2() {
              this.counters = {};
            }
            CounterState2.prototype.getCounterValue = function(name) {
              var counter = this.counters[name];
              if (counter && counter.length) {
                return counter[counter.length - 1];
              }
              return 1;
            };
            CounterState2.prototype.getCounterValues = function(name) {
              var counter = this.counters[name];
              return counter ? counter : [];
            };
            CounterState2.prototype.pop = function(counters) {
              var _this = this;
              counters.forEach(function(counter) {
                return _this.counters[counter].pop();
              });
            };
            CounterState2.prototype.parse = function(style) {
              var _this = this;
              var counterIncrement2 = style.counterIncrement;
              var counterReset2 = style.counterReset;
              var canReset = true;
              if (counterIncrement2 !== null) {
                counterIncrement2.forEach(function(entry) {
                  var counter = _this.counters[entry.counter];
                  if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) {
                      counter.push(1);
                    }
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                  }
                });
              }
              var counterNames = [];
              if (canReset) {
                counterReset2.forEach(function(entry) {
                  var counter = _this.counters[entry.counter];
                  counterNames.push(entry.counter);
                  if (!counter) {
                    counter = _this.counters[entry.counter] = [];
                  }
                  counter.push(entry.reset);
                });
              }
              return counterNames;
            };
            return CounterState2;
          }()
        );
        var ROMAN_UPPER = {
          integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
          values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
        };
        var ARMENIAN = {
          integers: [
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
          ],
          values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
          ]
        };
        var HEBREW = {
          integers: [
            1e4,
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
          ],
          values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
          ]
        };
        var GEORGIAN = {
          integers: [
            1e4,
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
          ],
          values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
          ]
        };
        var createAdditiveCounter = function(value, min, max2, symbols, fallback, suffix) {
          if (value < min || value > max2) {
            return createCounterText(value, fallback, suffix.length > 0);
          }
          return symbols.integers.reduce(function(string, integer, index) {
            while (value >= integer) {
              value -= integer;
              string += symbols.values[index];
            }
            return string;
          }, "") + suffix;
        };
        var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
          var string = "";
          do {
            if (!isNumeric) {
              value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
          } while (value * codePointRangeLength >= codePointRangeLength);
          return string;
        };
        var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
          var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
          return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
          }) + suffix);
        };
        var createCounterStyleFromSymbols = function(value, symbols, suffix) {
          if (suffix === void 0) {
            suffix = ". ";
          }
          var codePointRangeLength = symbols.length;
          return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
          }) + suffix;
        };
        var CJK_ZEROS = 1 << 0;
        var CJK_TEN_COEFFICIENTS = 1 << 1;
        var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
        var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
        var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
          if (value < -9999 || value > 9999) {
            return createCounterText(value, 4, suffix.length > 0);
          }
          var tmp = Math.abs(value);
          var string = suffix;
          if (tmp === 0) {
            return numbers[0] + string;
          }
          for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") {
              string = numbers[coefficient] + string;
            } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) {
              string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            } else if (coefficient === 1 && digit > 0) {
              string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
          }
          return (value < 0 ? negativeSign : "") + string;
        };
        var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
        var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
        var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
        var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
        var createCounterText = function(value, type, appendSuffix) {
          var defaultSuffix = appendSuffix ? ". " : "";
          var cjkSuffix = appendSuffix ? "\u3001" : "";
          var koreanSuffix = appendSuffix ? ", " : "";
          var spaceSuffix = appendSuffix ? " " : "";
          switch (type) {
            case 0:
              return "\u2022" + spaceSuffix;
            case 1:
              return "\u25E6" + spaceSuffix;
            case 2:
              return "\u25FE" + spaceSuffix;
            case 5:
              var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
              return string.length < 4 ? "0" + string : string;
            case 4:
              return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6:
              return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3, defaultSuffix).toLowerCase();
            case 7:
              return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3, defaultSuffix);
            case 8:
              return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9:
              return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10:
              return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11:
              return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12:
            case 49:
              return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3, defaultSuffix);
            case 35:
              return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3, defaultSuffix).toLowerCase();
            case 13:
              return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14:
            case 30:
              return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15:
              return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16:
              return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17:
            case 48:
              return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47:
              return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42:
              return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41:
              return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26:
              return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25:
              return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31:
              return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33:
              return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32:
              return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18:
              return createCounterStyleFromRange(value, 2406, 2415, true, defaultSuffix);
            case 20:
              return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3, defaultSuffix);
            case 21:
              return createCounterStyleFromRange(value, 2790, 2799, true, defaultSuffix);
            case 22:
              return createCounterStyleFromRange(value, 2662, 2671, true, defaultSuffix);
            case 22:
              return createAdditiveCounter(value, 1, 10999, HEBREW, 3, defaultSuffix);
            case 23:
              return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24:
              return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27:
              return createCounterStyleFromRange(value, 3302, 3311, true, defaultSuffix);
            case 28:
              return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29:
              return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34:
              return createCounterStyleFromRange(value, 3792, 3801, true, defaultSuffix);
            case 37:
              return createCounterStyleFromRange(value, 6160, 6169, true, defaultSuffix);
            case 38:
              return createCounterStyleFromRange(value, 4160, 4169, true, defaultSuffix);
            case 39:
              return createCounterStyleFromRange(value, 2918, 2927, true, defaultSuffix);
            case 40:
              return createCounterStyleFromRange(value, 1776, 1785, true, defaultSuffix);
            case 43:
              return createCounterStyleFromRange(value, 3046, 3055, true, defaultSuffix);
            case 44:
              return createCounterStyleFromRange(value, 3174, 3183, true, defaultSuffix);
            case 45:
              return createCounterStyleFromRange(value, 3664, 3673, true, defaultSuffix);
            case 46:
              return createCounterStyleFromRange(value, 3872, 3881, true, defaultSuffix);
            case 3:
            default:
              return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
          }
        };
        var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
        var DocumentCloner = (
          /** @class */
          function() {
            function DocumentCloner2(context, element, options) {
              this.context = context;
              this.options = options;
              this.scrolledElements = [];
              this.referenceElement = element;
              this.counters = new CounterState();
              this.quoteDepth = 0;
              if (!element.ownerDocument) {
                throw new Error("Cloned element does not have an owner document");
              }
              this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
            }
            DocumentCloner2.prototype.toIFrame = function(ownerDocument, windowSize) {
              var _this = this;
              var iframe = createIFrameContainer(ownerDocument, windowSize);
              if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
              }
              var scrollX = ownerDocument.defaultView.pageXOffset;
              var scrollY = ownerDocument.defaultView.pageYOffset;
              var cloneWindow = iframe.contentWindow;
              var documentClone = cloneWindow.document;
              var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                  var onclone, referenceElement;
                  return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        this.scrolledElements.forEach(restoreNodeScroll);
                        if (cloneWindow) {
                          cloneWindow.scrollTo(windowSize.left, windowSize.top);
                          if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                            this.context.logger.warn("Unable to restore scroll position for cloned document");
                            this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                          }
                        }
                        onclone = this.options.onclone;
                        referenceElement = this.clonedReferenceElement;
                        if (typeof referenceElement === "undefined") {
                          return [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                        }
                        if (!(documentClone.fonts && documentClone.fonts.ready)) return [3, 2];
                        return [4, documentClone.fonts.ready];
                      case 1:
                        _a.sent();
                        _a.label = 2;
                      case 2:
                        if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3, 4];
                        return [4, imagesReady(documentClone)];
                      case 3:
                        _a.sent();
                        _a.label = 4;
                      case 4:
                        if (typeof onclone === "function") {
                          return [2, Promise.resolve().then(function() {
                            return onclone(documentClone, referenceElement);
                          }).then(function() {
                            return iframe;
                          })];
                        }
                        return [2, iframe];
                    }
                  });
                });
              });
              documentClone.open();
              documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
              restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
              documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
              documentClone.close();
              return iframeLoad;
            };
            DocumentCloner2.prototype.createElementClone = function(node) {
              if (isDebugging(
                node,
                2
                /* CLONE */
              )) {
                debugger;
              }
              if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
              }
              if (isVideoElement(node)) {
                return this.createVideoClone(node);
              }
              if (isStyleElement(node)) {
                return this.createStyleClone(node);
              }
              var clone = node.cloneNode(false);
              if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                  clone.src = node.currentSrc;
                  clone.srcset = "";
                }
                if (clone.loading === "lazy") {
                  clone.loading = "eager";
                }
              }
              if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
              }
              return clone;
            };
            DocumentCloner2.prototype.createCustomElementClone = function(node) {
              var clone = document.createElement("html2canvascustomelement");
              copyCSSStyles(node.style, clone);
              return clone;
            };
            DocumentCloner2.prototype.createStyleClone = function(node) {
              try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                  var css = [].slice.call(sheet.cssRules, 0).reduce(function(css2, rule) {
                    if (rule && typeof rule.cssText === "string") {
                      return css2 + rule.cssText;
                    }
                    return css2;
                  }, "");
                  var style = node.cloneNode(false);
                  style.textContent = css;
                  return style;
                }
              } catch (e2) {
                this.context.logger.error("Unable to access cssRules property", e2);
                if (e2.name !== "SecurityError") {
                  throw e2;
                }
              }
              return node.cloneNode(false);
            };
            DocumentCloner2.prototype.createCanvasClone = function(canvas) {
              var _a;
              if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                  img.src = canvas.toDataURL();
                  return img;
                } catch (e2) {
                  this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
              }
              var clonedCanvas = canvas.cloneNode(false);
              try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                  if (!this.options.allowTaint && ctx) {
                    clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                  } else {
                    var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                    if (gl) {
                      var attribs = gl.getContextAttributes();
                      if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                        this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                      }
                    }
                    clonedCtx.drawImage(canvas, 0, 0);
                  }
                }
                return clonedCanvas;
              } catch (e2) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
              }
              return clonedCanvas;
            };
            DocumentCloner2.prototype.createVideoClone = function(video) {
              var canvas = video.ownerDocument.createElement("canvas");
              canvas.width = video.offsetWidth;
              canvas.height = video.offsetHeight;
              var ctx = canvas.getContext("2d");
              try {
                if (ctx) {
                  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                  if (!this.options.allowTaint) {
                    ctx.getImageData(0, 0, canvas.width, canvas.height);
                  }
                }
                return canvas;
              } catch (e2) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
              }
              var blankCanvas = video.ownerDocument.createElement("canvas");
              blankCanvas.width = video.offsetWidth;
              blankCanvas.height = video.offsetHeight;
              return blankCanvas;
            };
            DocumentCloner2.prototype.appendChildNode = function(clone, child, copyStyles) {
              if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                  clone.appendChild(this.cloneNode(child, copyStyles));
                }
              }
            };
            DocumentCloner2.prototype.cloneChildNodes = function(node, clone, copyStyles) {
              var _this = this;
              for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                  var assignedNodes = child.assignedNodes();
                  if (assignedNodes.length) {
                    assignedNodes.forEach(function(assignedNode) {
                      return _this.appendChildNode(clone, assignedNode, copyStyles);
                    });
                  }
                } else {
                  this.appendChildNode(clone, child, copyStyles);
                }
              }
            };
            DocumentCloner2.prototype.cloneNode = function(node, copyStyles) {
              if (isTextNode(node)) {
                return document.createTextNode(node.data);
              }
              if (!node.ownerDocument) {
                return node.cloneNode(false);
              }
              var window2 = node.ownerDocument.defaultView;
              if (window2 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window2.getComputedStyle(node);
                var styleBefore = window2.getComputedStyle(node, ":before");
                var styleAfter = window2.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                  this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                  createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                  copyStyles = true;
                }
                if (!isVideoElement(node)) {
                  this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                  clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                  clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) {
                  copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                  this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) {
                  clone.value = node.value;
                }
                return clone;
              }
              return node.cloneNode(false);
            };
            DocumentCloner2.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
              var _this = this;
              if (!style) {
                return;
              }
              var value = style.content;
              var document2 = clone.ownerDocument;
              if (!document2 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") {
                return;
              }
              this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
              var declaration = new CSSParsedPseudoDeclaration(this.context, style);
              var anonymousReplacedElement = document2.createElement("html2canvaspseudoelement");
              copyCSSStyles(style, anonymousReplacedElement);
              declaration.content.forEach(function(token) {
                if (token.type === 0) {
                  anonymousReplacedElement.appendChild(document2.createTextNode(token.value));
                } else if (token.type === 22) {
                  var img = document2.createElement("img");
                  img.src = token.value;
                  img.style.opacity = "1";
                  anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18) {
                  if (token.name === "attr") {
                    var attr = token.values.filter(isIdentToken);
                    if (attr.length) {
                      anonymousReplacedElement.appendChild(document2.createTextNode(node.getAttribute(attr[0].value) || ""));
                    }
                  } else if (token.name === "counter") {
                    var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                    if (counter && isIdentToken(counter)) {
                      var counterState = _this.counters.getCounterValue(counter.value);
                      var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3;
                      anonymousReplacedElement.appendChild(document2.createTextNode(createCounterText(counterState, counterType, false)));
                    }
                  } else if (token.name === "counters") {
                    var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                    if (counter && isIdentToken(counter)) {
                      var counterStates = _this.counters.getCounterValues(counter.value);
                      var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3;
                      var separator = delim && delim.type === 0 ? delim.value : "";
                      var text = counterStates.map(function(value2) {
                        return createCounterText(value2, counterType_1, false);
                      }).join(separator);
                      anonymousReplacedElement.appendChild(document2.createTextNode(text));
                    }
                  } else ;
                } else if (token.type === 20) {
                  switch (token.value) {
                    case "open-quote":
                      anonymousReplacedElement.appendChild(document2.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                      break;
                    case "close-quote":
                      anonymousReplacedElement.appendChild(document2.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                      break;
                    default:
                      anonymousReplacedElement.appendChild(document2.createTextNode(token.value));
                  }
                }
              });
              anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
              var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
              if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
              } else {
                clone.className += newClassName;
              }
              return anonymousReplacedElement;
            };
            DocumentCloner2.destroy = function(container) {
              if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
              }
              return false;
            };
            return DocumentCloner2;
          }()
        );
        var PseudoElementType;
        (function(PseudoElementType2) {
          PseudoElementType2[PseudoElementType2["BEFORE"] = 0] = "BEFORE";
          PseudoElementType2[PseudoElementType2["AFTER"] = 1] = "AFTER";
        })(PseudoElementType || (PseudoElementType = {}));
        var createIFrameContainer = function(ownerDocument, bounds) {
          var cloneIframeContainer = ownerDocument.createElement("iframe");
          cloneIframeContainer.className = "html2canvas-container";
          cloneIframeContainer.style.visibility = "hidden";
          cloneIframeContainer.style.position = "fixed";
          cloneIframeContainer.style.left = "-10000px";
          cloneIframeContainer.style.top = "0px";
          cloneIframeContainer.style.border = "0";
          cloneIframeContainer.width = bounds.width.toString();
          cloneIframeContainer.height = bounds.height.toString();
          cloneIframeContainer.scrolling = "no";
          cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
          ownerDocument.body.appendChild(cloneIframeContainer);
          return cloneIframeContainer;
        };
        var imageReady = function(img) {
          return new Promise(function(resolve) {
            if (img.complete) {
              resolve();
              return;
            }
            if (!img.src) {
              resolve();
              return;
            }
            img.onload = resolve;
            img.onerror = resolve;
          });
        };
        var imagesReady = function(document2) {
          return Promise.all([].slice.call(document2.images, 0).map(imageReady));
        };
        var iframeLoader = function(iframe) {
          return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
              return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
              cloneWindow.onload = iframe.onload = null;
              var interval = setInterval(function() {
                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                  clearInterval(interval);
                  resolve(iframe);
                }
              }, 50);
            };
          });
        };
        var ignoredStyleProperties = [
          "all",
          "d",
          "content"
          // Safari shows pseudoelements if content is set
        ];
        var copyCSSStyles = function(style, target) {
          for (var i2 = style.length - 1; i2 >= 0; i2--) {
            var property = style.item(i2);
            if (ignoredStyleProperties.indexOf(property) === -1) {
              target.style.setProperty(property, style.getPropertyValue(property));
            }
          }
          return target;
        };
        var serializeDoctype = function(doctype) {
          var str = "";
          if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) {
              str += doctype.name;
            }
            if (doctype.internalSubset) {
              str += doctype.internalSubset;
            }
            if (doctype.publicId) {
              str += '"' + doctype.publicId + '"';
            }
            if (doctype.systemId) {
              str += '"' + doctype.systemId + '"';
            }
            str += ">";
          }
          return str;
        };
        var restoreOwnerScroll = function(ownerDocument, x, y) {
          if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
          }
        };
        var restoreNodeScroll = function(_a) {
          var element = _a[0], x = _a[1], y = _a[2];
          element.scrollLeft = x;
          element.scrollTop = y;
        };
        var PSEUDO_BEFORE = ":before";
        var PSEUDO_AFTER = ":after";
        var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
        var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
        var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
        var createPseudoHideStyles = function(body) {
          createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
        };
        var createStyles = function(body, styles) {
          var document2 = body.ownerDocument;
          if (document2) {
            var style = document2.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
          }
        };
        var CacheStorage = (
          /** @class */
          function() {
            function CacheStorage2() {
            }
            CacheStorage2.getOrigin = function(url) {
              var link = CacheStorage2._link;
              if (!link) {
                return "about:blank";
              }
              link.href = url;
              link.href = link.href;
              return link.protocol + link.hostname + link.port;
            };
            CacheStorage2.isSameOrigin = function(src) {
              return CacheStorage2.getOrigin(src) === CacheStorage2._origin;
            };
            CacheStorage2.setContext = function(window2) {
              CacheStorage2._link = window2.document.createElement("a");
              CacheStorage2._origin = CacheStorage2.getOrigin(window2.location.href);
            };
            CacheStorage2._origin = "about:blank";
            return CacheStorage2;
          }()
        );
        var Cache = (
          /** @class */
          function() {
            function Cache2(context, _options) {
              this.context = context;
              this._options = _options;
              this._cache = {};
            }
            Cache2.prototype.addImage = function(src) {
              var result = Promise.resolve();
              if (this.has(src)) {
                return result;
              }
              if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                });
                return result;
              }
              return result;
            };
            Cache2.prototype.match = function(src) {
              return this._cache[src];
            };
            Cache2.prototype.loadImage = function(key2) {
              return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      isSameOrigin = CacheStorage.isSameOrigin(key2);
                      useCORS = !isInlineImage(key2) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                      useProxy = !isInlineImage(key2) && !isSameOrigin && !isBlobImage(key2) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                      if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key2) && !isBlobImage(key2) && !useProxy && !useCORS) {
                        return [
                          2
                          /*return*/
                        ];
                      }
                      src = key2;
                      if (!useProxy) return [3, 2];
                      return [4, this.proxy(src)];
                    case 1:
                      src = _a.sent();
                      _a.label = 2;
                    case 2:
                      this.context.logger.debug("Added image " + key2.substring(0, 256));
                      return [4, new Promise(function(resolve, reject) {
                        var img = new Image();
                        img.onload = function() {
                          return resolve(img);
                        };
                        img.onerror = reject;
                        if (isInlineBase64Image(src) || useCORS) {
                          img.crossOrigin = "anonymous";
                        }
                        img.src = src;
                        if (img.complete === true) {
                          setTimeout(function() {
                            return resolve(img);
                          }, 500);
                        }
                        if (_this._options.imageTimeout > 0) {
                          setTimeout(function() {
                            return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                          }, _this._options.imageTimeout);
                        }
                      })];
                    case 3:
                      return [2, _a.sent()];
                  }
                });
              });
            };
            Cache2.prototype.has = function(key2) {
              return typeof this._cache[key2] !== "undefined";
            };
            Cache2.prototype.keys = function() {
              return Promise.resolve(Object.keys(this._cache));
            };
            Cache2.prototype.proxy = function(src) {
              var _this = this;
              var proxy = this._options.proxy;
              if (!proxy) {
                throw new Error("No proxy defined");
              }
              var key2 = src.substring(0, 256);
              return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                  if (xhr.status === 200) {
                    if (responseType === "text") {
                      resolve(xhr.response);
                    } else {
                      var reader_1 = new FileReader();
                      reader_1.addEventListener("load", function() {
                        return resolve(reader_1.result);
                      }, false);
                      reader_1.addEventListener("error", function(e2) {
                        return reject(e2);
                      }, false);
                      reader_1.readAsDataURL(xhr.response);
                    }
                  } else {
                    reject("Failed to proxy resource " + key2 + " with status code " + xhr.status);
                  }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) {
                  xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                  var timeout_1 = _this._options.imageTimeout;
                  xhr.timeout = timeout_1;
                  xhr.ontimeout = function() {
                    return reject("Timed out (" + timeout_1 + "ms) proxying " + key2);
                  };
                }
                xhr.send();
              });
            };
            return Cache2;
          }()
        );
        var INLINE_SVG = /^data:image\/svg\+xml/i;
        var INLINE_BASE64 = /^data:image\/.*;base64,/i;
        var INLINE_IMG = /^data:image\/.*/i;
        var isRenderable = function(src) {
          return FEATURES.SUPPORT_SVG_DRAWING || !isSVG2(src);
        };
        var isInlineImage = function(src) {
          return INLINE_IMG.test(src);
        };
        var isInlineBase64Image = function(src) {
          return INLINE_BASE64.test(src);
        };
        var isBlobImage = function(src) {
          return src.substr(0, 4) === "blob";
        };
        var isSVG2 = function(src) {
          return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
        };
        var Vector = (
          /** @class */
          function() {
            function Vector2(x, y) {
              this.type = 0;
              this.x = x;
              this.y = y;
            }
            Vector2.prototype.add = function(deltaX, deltaY) {
              return new Vector2(this.x + deltaX, this.y + deltaY);
            };
            return Vector2;
          }()
        );
        var lerp6 = function(a2, b, t) {
          return new Vector(a2.x + (b.x - a2.x) * t, a2.y + (b.y - a2.y) * t);
        };
        var BezierCurve = (
          /** @class */
          function() {
            function BezierCurve2(start, startControl, endControl, end) {
              this.type = 1;
              this.start = start;
              this.startControl = startControl;
              this.endControl = endControl;
              this.end = end;
            }
            BezierCurve2.prototype.subdivide = function(t, firstHalf) {
              var ab = lerp6(this.start, this.startControl, t);
              var bc = lerp6(this.startControl, this.endControl, t);
              var cd = lerp6(this.endControl, this.end, t);
              var abbc = lerp6(ab, bc, t);
              var bccd = lerp6(bc, cd, t);
              var dest = lerp6(abbc, bccd, t);
              return firstHalf ? new BezierCurve2(this.start, ab, abbc, dest) : new BezierCurve2(dest, bccd, cd, this.end);
            };
            BezierCurve2.prototype.add = function(deltaX, deltaY) {
              return new BezierCurve2(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
            };
            BezierCurve2.prototype.reverse = function() {
              return new BezierCurve2(this.end, this.endControl, this.startControl, this.start);
            };
            return BezierCurve2;
          }()
        );
        var isBezierCurve = function(path) {
          return path.type === 1;
        };
        var BoundCurves = (
          /** @class */
          /* @__PURE__ */ function() {
            function BoundCurves2(element) {
              var styles = element.styles;
              var bounds = element.bounds;
              var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
              var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
              var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
              var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
              var factors = [];
              factors.push((tlh + trh) / bounds.width);
              factors.push((blh + brh) / bounds.width);
              factors.push((tlv + blv) / bounds.height);
              factors.push((trv + brv) / bounds.height);
              var maxFactor = Math.max.apply(Math, factors);
              if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
              }
              var topWidth = bounds.width - trh;
              var rightHeight = bounds.height - brv;
              var bottomWidth = bounds.width - brh;
              var leftHeight = bounds.height - blv;
              var borderTopWidth2 = styles.borderTopWidth;
              var borderRightWidth2 = styles.borderRightWidth;
              var borderBottomWidth2 = styles.borderBottomWidth;
              var borderLeftWidth2 = styles.borderLeftWidth;
              var paddingTop2 = getAbsoluteValue(styles.paddingTop, element.bounds.width);
              var paddingRight2 = getAbsoluteValue(styles.paddingRight, element.bounds.width);
              var paddingBottom2 = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
              var paddingLeft2 = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
              this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3, tlh - borderLeftWidth2 / 3, tlv - borderTopWidth2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3);
              this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 3, trh - borderRightWidth2 / 3, trv - borderTopWidth2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + borderTopWidth2 / 3);
              this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 3, brv - borderBottomWidth2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
              this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 / 3, blv - borderBottomWidth2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
              this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3, tlh - borderLeftWidth2 * 2 / 3, tlv - borderTopWidth2 * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
              this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 * 2 / 3, trh - borderRightWidth2 * 2 / 3, trv - borderTopWidth2 * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
              this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 * 2 / 3, brv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
              this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 * 2 / 3, blv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
              this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2, tlh - borderLeftWidth2 / 2, tlv - borderTopWidth2 / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2);
              this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 2, trh - borderRightWidth2 / 2, trv - borderTopWidth2 / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + borderTopWidth2 / 2);
              this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 2, brv - borderBottomWidth2 / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
              this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + leftHeight, blh - borderLeftWidth2 / 2, blv - borderBottomWidth2 / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
              this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
              this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
              this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
              this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
              this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2, Math.max(0, tlh - borderLeftWidth2), Math.max(0, tlv - borderTopWidth2), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2);
              this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth2), bounds.top + borderTopWidth2, topWidth > bounds.width + borderRightWidth2 ? 0 : Math.max(0, trh - borderRightWidth2), Math.max(0, trv - borderTopWidth2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + borderTopWidth2);
              this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth2), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth2), Math.max(0, brh - borderRightWidth2), Math.max(0, brv - borderBottomWidth2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + bounds.height - borderBottomWidth2);
              this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth2), Math.max(0, blh - borderLeftWidth2), Math.max(0, blv - borderBottomWidth2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + bounds.height - borderBottomWidth2);
              this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2, Math.max(0, tlh - (borderLeftWidth2 + paddingLeft2)), Math.max(0, tlv - (borderTopWidth2 + paddingTop2)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2);
              this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth2 + paddingLeft2), bounds.top + borderTopWidth2 + paddingTop2, topWidth > bounds.width + borderLeftWidth2 + paddingLeft2 ? 0 : trh - borderLeftWidth2 + paddingLeft2, trv - (borderTopWidth2 + paddingTop2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + borderTopWidth2 + paddingTop2);
              this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth2 + paddingLeft2)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth2 + paddingTop2), Math.max(0, brh - (borderRightWidth2 + paddingRight2)), brv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
              this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth2 + paddingLeft2)), blv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
            }
            return BoundCurves2;
          }()
        );
        var CORNER;
        (function(CORNER2) {
          CORNER2[CORNER2["TOP_LEFT"] = 0] = "TOP_LEFT";
          CORNER2[CORNER2["TOP_RIGHT"] = 1] = "TOP_RIGHT";
          CORNER2[CORNER2["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
          CORNER2[CORNER2["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
        })(CORNER || (CORNER = {}));
        var getCurvePoints = function(x, y, r1, r2, position2) {
          var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
          var ox = r1 * kappa;
          var oy = r2 * kappa;
          var xm = x + r1;
          var ym = y + r2;
          switch (position2) {
            case CORNER.TOP_LEFT:
              return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
              return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
              return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
              return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
          }
        };
        var calculateBorderBoxPath = function(curves) {
          return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
        };
        var calculateContentBoxPath = function(curves) {
          return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
          ];
        };
        var calculatePaddingBoxPath = function(curves) {
          return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
          ];
        };
        var TransformEffect = (
          /** @class */
          /* @__PURE__ */ function() {
            function TransformEffect2(offsetX, offsetY, matrix2) {
              this.offsetX = offsetX;
              this.offsetY = offsetY;
              this.matrix = matrix2;
              this.type = 0;
              this.target = 2 | 4;
            }
            return TransformEffect2;
          }()
        );
        var ClipEffect = (
          /** @class */
          /* @__PURE__ */ function() {
            function ClipEffect2(path, target) {
              this.path = path;
              this.target = target;
              this.type = 1;
            }
            return ClipEffect2;
          }()
        );
        var OpacityEffect = (
          /** @class */
          /* @__PURE__ */ function() {
            function OpacityEffect2(opacity2) {
              this.opacity = opacity2;
              this.type = 2;
              this.target = 2 | 4;
            }
            return OpacityEffect2;
          }()
        );
        var isTransformEffect = function(effect) {
          return effect.type === 0;
        };
        var isClipEffect = function(effect) {
          return effect.type === 1;
        };
        var isOpacityEffect = function(effect) {
          return effect.type === 2;
        };
        var equalPath = function(a2, b) {
          if (a2.length === b.length) {
            return a2.some(function(v, i2) {
              return v === b[i2];
            });
          }
          return false;
        };
        var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
          return path.map(function(point, index) {
            switch (index) {
              case 0:
                return point.add(deltaX, deltaY);
              case 1:
                return point.add(deltaX + deltaW, deltaY);
              case 2:
                return point.add(deltaX + deltaW, deltaY + deltaH);
              case 3:
                return point.add(deltaX, deltaY + deltaH);
            }
            return point;
          });
        };
        var StackingContext = (
          /** @class */
          /* @__PURE__ */ function() {
            function StackingContext2(container) {
              this.element = container;
              this.inlineLevel = [];
              this.nonInlineLevel = [];
              this.negativeZIndex = [];
              this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
              this.positiveZIndex = [];
              this.nonPositionedFloats = [];
              this.nonPositionedInlineLevel = [];
            }
            return StackingContext2;
          }()
        );
        var ElementPaint = (
          /** @class */
          function() {
            function ElementPaint2(container, parent) {
              this.container = container;
              this.parent = parent;
              this.effects = [];
              this.curves = new BoundCurves(this.container);
              if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
              }
              if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix2 = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix2));
              }
              if (this.container.styles.overflowX !== 0) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox2 = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox2)) {
                  this.effects.push(new ClipEffect(
                    borderBox,
                    2 | 4
                    /* CONTENT */
                  ));
                } else {
                  this.effects.push(new ClipEffect(
                    borderBox,
                    2
                    /* BACKGROUND_BORDERS */
                  ));
                  this.effects.push(new ClipEffect(
                    paddingBox2,
                    4
                    /* CONTENT */
                  ));
                }
              }
            }
            ElementPaint2.prototype.getEffects = function(target) {
              var inFlow = [
                2,
                3
                /* FIXED */
              ].indexOf(this.container.styles.position) === -1;
              var parent = this.parent;
              var effects = this.effects.slice(0);
              while (parent) {
                var croplessEffects = parent.effects.filter(function(effect) {
                  return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 || !parent.parent) {
                  effects.unshift.apply(effects, croplessEffects);
                  inFlow = [
                    2,
                    3
                    /* FIXED */
                  ].indexOf(parent.container.styles.position) === -1;
                  if (parent.container.styles.overflowX !== 0) {
                    var borderBox = calculateBorderBoxPath(parent.curves);
                    var paddingBox2 = calculatePaddingBoxPath(parent.curves);
                    if (!equalPath(borderBox, paddingBox2)) {
                      effects.unshift(new ClipEffect(
                        paddingBox2,
                        2 | 4
                        /* CONTENT */
                      ));
                    }
                  }
                } else {
                  effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
              }
              return effects.filter(function(effect) {
                return contains(effect.target, target);
              });
            };
            return ElementPaint2;
          }()
        );
        var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
          parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(
              child.flags,
              4
              /* CREATES_REAL_STACKING_CONTEXT */
            );
            var createsStackingContext2 = contains(
              child.flags,
              2
              /* CREATES_STACKING_CONTEXT */
            );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(
              child.styles.display,
              2048
              /* LIST_ITEM */
            )) {
              listItems.push(paintContainer);
            }
            var listOwnerItems = contains(
              child.flags,
              8
              /* IS_LIST_OWNER */
            ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext2) {
              var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
              var stack = new StackingContext(paintContainer);
              if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                var order_1 = child.styles.zIndex.order;
                if (order_1 < 0) {
                  var index_1 = 0;
                  parentStack.negativeZIndex.some(function(current, i2) {
                    if (order_1 > current.element.container.styles.zIndex.order) {
                      index_1 = i2;
                      return false;
                    } else if (index_1 > 0) {
                      return true;
                    }
                    return false;
                  });
                  parentStack.negativeZIndex.splice(index_1, 0, stack);
                } else if (order_1 > 0) {
                  var index_2 = 0;
                  parentStack.positiveZIndex.some(function(current, i2) {
                    if (order_1 >= current.element.container.styles.zIndex.order) {
                      index_2 = i2 + 1;
                      return false;
                    } else if (index_2 > 0) {
                      return true;
                    }
                    return false;
                  });
                  parentStack.positiveZIndex.splice(index_2, 0, stack);
                } else {
                  parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                }
              } else {
                if (child.styles.isFloating()) {
                  parentStack.nonPositionedFloats.push(stack);
                } else {
                  parentStack.nonPositionedInlineLevel.push(stack);
                }
              }
              parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
              if (child.styles.isInlineLevel()) {
                stackingContext.inlineLevel.push(paintContainer);
              } else {
                stackingContext.nonInlineLevel.push(paintContainer);
              }
              parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(
              child.flags,
              8
              /* IS_LIST_OWNER */
            )) {
              processListItems(child, listOwnerItems);
            }
          });
        };
        var processListItems = function(owner, elements) {
          var numbering = owner instanceof OLElementContainer ? owner.start : 1;
          var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
          for (var i2 = 0; i2 < elements.length; i2++) {
            var item = elements[i2];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) {
              numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
          }
        };
        var parseStackingContexts = function(container) {
          var paintContainer = new ElementPaint(container, null);
          var root = new StackingContext(paintContainer);
          var listItems = [];
          parseStackTree(paintContainer, root, root, listItems);
          processListItems(paintContainer.container, listItems);
          return root;
        };
        var parsePathForBorder = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
              return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
              return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
              return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
          }
        };
        var parsePathForBorderDoubleOuter = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
              return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
              return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
              return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
          }
        };
        var parsePathForBorderDoubleInner = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
              return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
              return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
              return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
          }
        };
        var parsePathForBorderStroke = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
              return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
              return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
              return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
          }
        };
        var createStrokePathFromCurves = function(outer1, outer2) {
          var path = [];
          if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
          } else {
            path.push(outer1);
          }
          if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
          } else {
            path.push(outer2);
          }
          return path;
        };
        var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
          var path = [];
          if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
          } else {
            path.push(outer1);
          }
          if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
          } else {
            path.push(outer2);
          }
          if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
          } else {
            path.push(inner2);
          }
          if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
          } else {
            path.push(inner1);
          }
          return path;
        };
        var paddingBox = function(element) {
          var bounds = element.bounds;
          var styles = element.styles;
          return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
        };
        var contentBox = function(element) {
          var styles = element.styles;
          var bounds = element.bounds;
          var paddingLeft2 = getAbsoluteValue(styles.paddingLeft, bounds.width);
          var paddingRight2 = getAbsoluteValue(styles.paddingRight, bounds.width);
          var paddingTop2 = getAbsoluteValue(styles.paddingTop, bounds.width);
          var paddingBottom2 = getAbsoluteValue(styles.paddingBottom, bounds.width);
          return bounds.add(paddingLeft2 + styles.borderLeftWidth, paddingTop2 + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft2 + paddingRight2), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop2 + paddingBottom2));
        };
        var calculateBackgroundPositioningArea = function(backgroundOrigin2, element) {
          if (backgroundOrigin2 === 0) {
            return element.bounds;
          }
          if (backgroundOrigin2 === 2) {
            return contentBox(element);
          }
          return paddingBox(element);
        };
        var calculateBackgroundPaintingArea = function(backgroundClip2, element) {
          if (backgroundClip2 === 0) {
            return element.bounds;
          }
          if (backgroundClip2 === 2) {
            return contentBox(element);
          }
          return paddingBox(element);
        };
        var calculateBackgroundRendering = function(container, index, intrinsicSize) {
          var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
          var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
          var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
          var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
          var position2 = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
          var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position2, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
          var offsetX = Math.round(backgroundPositioningArea.left + position2[0]);
          var offsetY = Math.round(backgroundPositioningArea.top + position2[1]);
          return [path, offsetX, offsetY, sizeWidth, sizeHeight];
        };
        var isAuto = function(token) {
          return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
        };
        var hasIntrinsicValue = function(value) {
          return typeof value === "number";
        };
        var calculateBackgroundSize = function(size, _a, bounds) {
          var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
          var first = size[0], second = size[1];
          if (!first) {
            return [0, 0];
          }
          if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
          }
          var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
          if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
              var targetRatio = bounds.width / bounds.height;
              return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [bounds.width, bounds.width / intrinsicProportion] : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
          }
          var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
          var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
          var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
          if (isAuto(first) && (!second || isAuto(second))) {
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
              return [intrinsicWidth, intrinsicHeight];
            }
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
              return [bounds.width, bounds.height];
            }
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
              var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
              var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
              return [width_1, height_1];
            }
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
          }
          if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
              width_3 = getAbsoluteValue(first, bounds.width);
            } else if (isLengthPercentage(second)) {
              height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
              width_3 = height_3 * intrinsicProportion;
            } else if (!second || isAuto(second)) {
              height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
          }
          var width = null;
          var height = null;
          if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
          } else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
          }
          if (width !== null && (!second || isAuto(second))) {
            height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
          }
          if (height !== null && isAuto(first)) {
            width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
          }
          if (width !== null && height !== null) {
            return [width, height];
          }
          throw new Error("Unable to calculate background-size for element");
        };
        var getBackgroundValueForIndex = function(values, index) {
          var value = values[index];
          if (typeof value === "undefined") {
            return values[0];
          }
          return value;
        };
        var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
          var x = _a[0], y = _a[1];
          var width = _b[0], height = _b[1];
          switch (repeat) {
            case 2:
              return [
                new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
              ];
            case 3:
              return [
                new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
              ];
            case 1:
              return [
                new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
              ];
            default:
              return [
                new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
              ];
          }
        };
        var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        var SAMPLE_TEXT = "Hidden Text";
        var FontMetrics = (
          /** @class */
          function() {
            function FontMetrics2(document2) {
              this._data = {};
              this._document = document2;
            }
            FontMetrics2.prototype.parseMetrics = function(fontFamily2, fontSize2) {
              var container = this._document.createElement("div");
              var img = this._document.createElement("img");
              var span = this._document.createElement("span");
              var body = this._document.body;
              container.style.visibility = "hidden";
              container.style.fontFamily = fontFamily2;
              container.style.fontSize = fontSize2;
              container.style.margin = "0";
              container.style.padding = "0";
              container.style.whiteSpace = "nowrap";
              body.appendChild(container);
              img.src = SMALL_IMAGE;
              img.width = 1;
              img.height = 1;
              img.style.margin = "0";
              img.style.padding = "0";
              img.style.verticalAlign = "baseline";
              span.style.fontFamily = fontFamily2;
              span.style.fontSize = fontSize2;
              span.style.margin = "0";
              span.style.padding = "0";
              span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
              container.appendChild(span);
              container.appendChild(img);
              var baseline = img.offsetTop - span.offsetTop + 2;
              container.removeChild(span);
              container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
              container.style.lineHeight = "normal";
              img.style.verticalAlign = "super";
              var middle = img.offsetTop - container.offsetTop + 2;
              body.removeChild(container);
              return { baseline, middle };
            };
            FontMetrics2.prototype.getMetrics = function(fontFamily2, fontSize2) {
              var key2 = fontFamily2 + " " + fontSize2;
              if (typeof this._data[key2] === "undefined") {
                this._data[key2] = this.parseMetrics(fontFamily2, fontSize2);
              }
              return this._data[key2];
            };
            return FontMetrics2;
          }()
        );
        var Renderer = (
          /** @class */
          /* @__PURE__ */ function() {
            function Renderer2(context, options) {
              this.context = context;
              this.options = options;
            }
            return Renderer2;
          }()
        );
        var MASK_OFFSET = 1e4;
        var CanvasRenderer = (
          /** @class */
          function(_super) {
            __extends(CanvasRenderer2, _super);
            function CanvasRenderer2(context, options) {
              var _this = _super.call(this, context, options) || this;
              _this._activeEffects = [];
              _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
              _this.ctx = _this.canvas.getContext("2d");
              if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
              }
              _this.fontMetrics = new FontMetrics(document);
              _this.ctx.scale(_this.options.scale, _this.options.scale);
              _this.ctx.translate(-options.x, -options.y);
              _this.ctx.textBaseline = "bottom";
              _this._activeEffects = [];
              _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
              return _this;
            }
            CanvasRenderer2.prototype.applyEffects = function(effects) {
              var _this = this;
              while (this._activeEffects.length) {
                this.popEffect();
              }
              effects.forEach(function(effect) {
                return _this.applyEffect(effect);
              });
            };
            CanvasRenderer2.prototype.applyEffect = function(effect) {
              this.ctx.save();
              if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
              }
              if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
              }
              if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
              }
              this._activeEffects.push(effect);
            };
            CanvasRenderer2.prototype.popEffect = function() {
              this._activeEffects.pop();
              this.ctx.restore();
            };
            CanvasRenderer2.prototype.renderStack = function(stack) {
              return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      styles = stack.element.container.styles;
                      if (!styles.isVisible()) return [3, 2];
                      return [4, this.renderStackContent(stack)];
                    case 1:
                      _a.sent();
                      _a.label = 2;
                    case 2:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.renderNode = function(paint) {
              return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      if (contains(
                        paint.container.flags,
                        16
                        /* DEBUG_RENDER */
                      )) {
                        debugger;
                      }
                      if (!paint.container.styles.isVisible()) return [3, 3];
                      return [4, this.renderNodeBackgroundAndBorders(paint)];
                    case 1:
                      _a.sent();
                      return [4, this.renderNodeContent(paint)];
                    case 2:
                      _a.sent();
                      _a.label = 3;
                    case 3:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.renderTextWithLetterSpacing = function(text, letterSpacing2, baseline) {
              var _this = this;
              if (letterSpacing2 === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
              } else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                  _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                  return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
              }
            };
            CanvasRenderer2.prototype.createFontStyle = function(styles) {
              var fontVariant2 = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
              }).join("");
              var fontFamily2 = fixIOSSystemFonts(styles.fontFamily).join(", ");
              var fontSize2 = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
              return [
                [styles.fontStyle, fontVariant2, styles.fontWeight, fontSize2, fontFamily2].join(" "),
                fontFamily2,
                fontSize2
              ];
            };
            CanvasRenderer2.prototype.renderTextNode = function(text, styles) {
              return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily2, fontSize2, _b, baseline, middle, paintOrder2;
                var _this = this;
                return __generator(this, function(_c) {
                  _a = this.createFontStyle(styles), font = _a[0], fontFamily2 = _a[1], fontSize2 = _a[2];
                  this.ctx.font = font;
                  this.ctx.direction = styles.direction === 1 ? "rtl" : "ltr";
                  this.ctx.textAlign = "left";
                  this.ctx.textBaseline = "alphabetic";
                  _b = this.fontMetrics.getMetrics(fontFamily2, fontSize2), baseline = _b.baseline, middle = _b.middle;
                  paintOrder2 = styles.paintOrder;
                  text.textBounds.forEach(function(text2) {
                    paintOrder2.forEach(function(paintOrderLayer) {
                      switch (paintOrderLayer) {
                        case 0:
                          _this.ctx.fillStyle = asString(styles.color);
                          _this.renderTextWithLetterSpacing(text2, styles.letterSpacing, baseline);
                          var textShadows = styles.textShadow;
                          if (textShadows.length && text2.text.trim().length) {
                            textShadows.slice(0).reverse().forEach(function(textShadow2) {
                              _this.ctx.shadowColor = asString(textShadow2.color);
                              _this.ctx.shadowOffsetX = textShadow2.offsetX.number * _this.options.scale;
                              _this.ctx.shadowOffsetY = textShadow2.offsetY.number * _this.options.scale;
                              _this.ctx.shadowBlur = textShadow2.blur.number;
                              _this.renderTextWithLetterSpacing(text2, styles.letterSpacing, baseline);
                            });
                            _this.ctx.shadowColor = "";
                            _this.ctx.shadowOffsetX = 0;
                            _this.ctx.shadowOffsetY = 0;
                            _this.ctx.shadowBlur = 0;
                          }
                          if (styles.textDecorationLine.length) {
                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                            styles.textDecorationLine.forEach(function(textDecorationLine2) {
                              switch (textDecorationLine2) {
                                case 1:
                                  _this.ctx.fillRect(text2.bounds.left, Math.round(text2.bounds.top + baseline), text2.bounds.width, 1);
                                  break;
                                case 2:
                                  _this.ctx.fillRect(text2.bounds.left, Math.round(text2.bounds.top), text2.bounds.width, 1);
                                  break;
                                case 3:
                                  _this.ctx.fillRect(text2.bounds.left, Math.ceil(text2.bounds.top + middle), text2.bounds.width, 1);
                                  break;
                              }
                            });
                          }
                          break;
                        case 1:
                          if (styles.webkitTextStrokeWidth && text2.text.trim().length) {
                            _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                            _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                            _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                            _this.ctx.strokeText(text2.text, text2.bounds.left, text2.bounds.top + baseline);
                          }
                          _this.ctx.strokeStyle = "";
                          _this.ctx.lineWidth = 0;
                          _this.ctx.lineJoin = "miter";
                          break;
                      }
                    });
                  });
                  return [
                    2
                    /*return*/
                  ];
                });
              });
            };
            CanvasRenderer2.prototype.renderReplacedElement = function(container, curves, image2) {
              if (image2 && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image2, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
              }
            };
            CanvasRenderer2.prototype.renderNodeContent = function(paint) {
              return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image2, image2, iframeRenderer, canvas, size, _b, fontFamily2, fontSize2, baseline, bounds, x, textBounds, img, image2, url, fontFamily2, bounds;
                return __generator(this, function(_c) {
                  switch (_c.label) {
                    case 0:
                      this.applyEffects(paint.getEffects(
                        4
                        /* CONTENT */
                      ));
                      container = paint.container;
                      curves = paint.curves;
                      styles = container.styles;
                      _i = 0, _a = container.textNodes;
                      _c.label = 1;
                    case 1:
                      if (!(_i < _a.length)) return [3, 4];
                      child = _a[_i];
                      return [4, this.renderTextNode(child, styles)];
                    case 2:
                      _c.sent();
                      _c.label = 3;
                    case 3:
                      _i++;
                      return [3, 1];
                    case 4:
                      if (!(container instanceof ImageElementContainer)) return [3, 8];
                      _c.label = 5;
                    case 5:
                      _c.trys.push([5, 7, , 8]);
                      return [4, this.context.cache.match(container.src)];
                    case 6:
                      image2 = _c.sent();
                      this.renderReplacedElement(container, curves, image2);
                      return [3, 8];
                    case 7:
                      _c.sent();
                      this.context.logger.error("Error loading image " + container.src);
                      return [3, 8];
                    case 8:
                      if (container instanceof CanvasElementContainer) {
                        this.renderReplacedElement(container, curves, container.canvas);
                      }
                      if (!(container instanceof SVGElementContainer)) return [3, 12];
                      _c.label = 9;
                    case 9:
                      _c.trys.push([9, 11, , 12]);
                      return [4, this.context.cache.match(container.svg)];
                    case 10:
                      image2 = _c.sent();
                      this.renderReplacedElement(container, curves, image2);
                      return [3, 12];
                    case 11:
                      _c.sent();
                      this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                      return [3, 12];
                    case 12:
                      if (!(container instanceof IFrameElementContainer && container.tree)) return [3, 14];
                      iframeRenderer = new CanvasRenderer2(this.context, {
                        scale: this.options.scale,
                        backgroundColor: container.backgroundColor,
                        x: 0,
                        y: 0,
                        width: container.width,
                        height: container.height
                      });
                      return [4, iframeRenderer.render(container.tree)];
                    case 13:
                      canvas = _c.sent();
                      if (container.width && container.height) {
                        this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                      }
                      _c.label = 14;
                    case 14:
                      if (container instanceof InputElementContainer) {
                        size = Math.min(container.bounds.width, container.bounds.height);
                        if (container.type === CHECKBOX) {
                          if (container.checked) {
                            this.ctx.save();
                            this.path([
                              new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                              new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                              new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                              new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                              new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                              new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                              new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                            ]);
                            this.ctx.fillStyle = asString(INPUT_COLOR);
                            this.ctx.fill();
                            this.ctx.restore();
                          }
                        } else if (container.type === RADIO) {
                          if (container.checked) {
                            this.ctx.save();
                            this.ctx.beginPath();
                            this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                            this.ctx.fillStyle = asString(INPUT_COLOR);
                            this.ctx.fill();
                            this.ctx.restore();
                          }
                        }
                      }
                      if (isTextInputElement(container) && container.value.length) {
                        _b = this.createFontStyle(styles), fontFamily2 = _b[0], fontSize2 = _b[1];
                        baseline = this.fontMetrics.getMetrics(fontFamily2, fontSize2).baseline;
                        this.ctx.font = fontFamily2;
                        this.ctx.fillStyle = asString(styles.color);
                        this.ctx.textBaseline = "alphabetic";
                        this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                        bounds = contentBox(container);
                        x = 0;
                        switch (container.styles.textAlign) {
                          case 1:
                            x += bounds.width / 2;
                            break;
                          case 2:
                            x += bounds.width;
                            break;
                        }
                        textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                        this.ctx.save();
                        this.path([
                          new Vector(bounds.left, bounds.top),
                          new Vector(bounds.left + bounds.width, bounds.top),
                          new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                          new Vector(bounds.left, bounds.top + bounds.height)
                        ]);
                        this.ctx.clip();
                        this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                        this.ctx.restore();
                        this.ctx.textBaseline = "alphabetic";
                        this.ctx.textAlign = "left";
                      }
                      if (!contains(
                        container.styles.display,
                        2048
                        /* LIST_ITEM */
                      )) return [3, 20];
                      if (!(container.styles.listStyleImage !== null)) return [3, 19];
                      img = container.styles.listStyleImage;
                      if (!(img.type === 0)) return [3, 18];
                      image2 = void 0;
                      url = img.url;
                      _c.label = 15;
                    case 15:
                      _c.trys.push([15, 17, , 18]);
                      return [4, this.context.cache.match(url)];
                    case 16:
                      image2 = _c.sent();
                      this.ctx.drawImage(image2, container.bounds.left - (image2.width + 10), container.bounds.top);
                      return [3, 18];
                    case 17:
                      _c.sent();
                      this.context.logger.error("Error loading list-style-image " + url);
                      return [3, 18];
                    case 18:
                      return [3, 20];
                    case 19:
                      if (paint.listValue && container.styles.listStyleType !== -1) {
                        fontFamily2 = this.createFontStyle(styles)[0];
                        this.ctx.font = fontFamily2;
                        this.ctx.fillStyle = asString(styles.color);
                        this.ctx.textBaseline = "middle";
                        this.ctx.textAlign = "right";
                        bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                        this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                        this.ctx.textBaseline = "bottom";
                        this.ctx.textAlign = "left";
                      }
                      _c.label = 20;
                    case 20:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.renderStackContent = function(stack) {
              return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                  switch (_p.label) {
                    case 0:
                      if (contains(
                        stack.element.container.flags,
                        16
                        /* DEBUG_RENDER */
                      )) {
                        debugger;
                      }
                      return [4, this.renderNodeBackgroundAndBorders(stack.element)];
                    case 1:
                      _p.sent();
                      _i = 0, _a = stack.negativeZIndex;
                      _p.label = 2;
                    case 2:
                      if (!(_i < _a.length)) return [3, 5];
                      child = _a[_i];
                      return [4, this.renderStack(child)];
                    case 3:
                      _p.sent();
                      _p.label = 4;
                    case 4:
                      _i++;
                      return [3, 2];
                    case 5:
                      return [4, this.renderNodeContent(stack.element)];
                    case 6:
                      _p.sent();
                      _b = 0, _c = stack.nonInlineLevel;
                      _p.label = 7;
                    case 7:
                      if (!(_b < _c.length)) return [3, 10];
                      child = _c[_b];
                      return [4, this.renderNode(child)];
                    case 8:
                      _p.sent();
                      _p.label = 9;
                    case 9:
                      _b++;
                      return [3, 7];
                    case 10:
                      _d = 0, _e = stack.nonPositionedFloats;
                      _p.label = 11;
                    case 11:
                      if (!(_d < _e.length)) return [3, 14];
                      child = _e[_d];
                      return [4, this.renderStack(child)];
                    case 12:
                      _p.sent();
                      _p.label = 13;
                    case 13:
                      _d++;
                      return [3, 11];
                    case 14:
                      _f = 0, _g = stack.nonPositionedInlineLevel;
                      _p.label = 15;
                    case 15:
                      if (!(_f < _g.length)) return [3, 18];
                      child = _g[_f];
                      return [4, this.renderStack(child)];
                    case 16:
                      _p.sent();
                      _p.label = 17;
                    case 17:
                      _f++;
                      return [3, 15];
                    case 18:
                      _h = 0, _j = stack.inlineLevel;
                      _p.label = 19;
                    case 19:
                      if (!(_h < _j.length)) return [3, 22];
                      child = _j[_h];
                      return [4, this.renderNode(child)];
                    case 20:
                      _p.sent();
                      _p.label = 21;
                    case 21:
                      _h++;
                      return [3, 19];
                    case 22:
                      _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                      _p.label = 23;
                    case 23:
                      if (!(_k < _l.length)) return [3, 26];
                      child = _l[_k];
                      return [4, this.renderStack(child)];
                    case 24:
                      _p.sent();
                      _p.label = 25;
                    case 25:
                      _k++;
                      return [3, 23];
                    case 26:
                      _m = 0, _o = stack.positiveZIndex;
                      _p.label = 27;
                    case 27:
                      if (!(_m < _o.length)) return [3, 30];
                      child = _o[_m];
                      return [4, this.renderStack(child)];
                    case 28:
                      _p.sent();
                      _p.label = 29;
                    case 29:
                      _m++;
                      return [3, 27];
                    case 30:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.mask = function(paths) {
              this.ctx.beginPath();
              this.ctx.moveTo(0, 0);
              this.ctx.lineTo(this.canvas.width, 0);
              this.ctx.lineTo(this.canvas.width, this.canvas.height);
              this.ctx.lineTo(0, this.canvas.height);
              this.ctx.lineTo(0, 0);
              this.formatPath(paths.slice(0).reverse());
              this.ctx.closePath();
            };
            CanvasRenderer2.prototype.path = function(paths) {
              this.ctx.beginPath();
              this.formatPath(paths);
              this.ctx.closePath();
            };
            CanvasRenderer2.prototype.formatPath = function(paths) {
              var _this = this;
              paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                  _this.ctx.moveTo(start.x, start.y);
                } else {
                  _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                  _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
              });
            };
            CanvasRenderer2.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
              this.path(path);
              this.ctx.fillStyle = pattern;
              this.ctx.translate(offsetX, offsetY);
              this.ctx.fill();
              this.ctx.translate(-offsetX, -offsetY);
            };
            CanvasRenderer2.prototype.resizeImage = function(image2, width, height) {
              var _a;
              if (image2.width === width && image2.height === height) {
                return image2;
              }
              var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
              var canvas = ownerDocument.createElement("canvas");
              canvas.width = Math.max(1, width);
              canvas.height = Math.max(1, height);
              var ctx = canvas.getContext("2d");
              ctx.drawImage(image2, 0, 0, image2.width, image2.height, 0, 0, width, height);
              return canvas;
            };
            CanvasRenderer2.prototype.renderBackgroundImage = function(container) {
              return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage2;
                return __generator(this, function(_b) {
                  switch (_b.label) {
                    case 0:
                      index = container.styles.backgroundImage.length - 1;
                      _loop_1 = function(backgroundImage3) {
                        var image2, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position2, x, y, _g, rx, ry, radialGradient_1, midX, midY, f2, invF;
                        return __generator(this, function(_h) {
                          switch (_h.label) {
                            case 0:
                              if (!(backgroundImage3.type === 0)) return [3, 5];
                              image2 = void 0;
                              url = backgroundImage3.url;
                              _h.label = 1;
                            case 1:
                              _h.trys.push([1, 3, , 4]);
                              return [4, this_1.context.cache.match(url)];
                            case 2:
                              image2 = _h.sent();
                              return [3, 4];
                            case 3:
                              _h.sent();
                              this_1.context.logger.error("Error loading background-image " + url);
                              return [3, 4];
                            case 4:
                              if (image2) {
                                _c = calculateBackgroundRendering(container, index, [
                                  image2.width,
                                  image2.height,
                                  image2.width / image2.height
                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image2, width, height), "repeat");
                                this_1.renderRepeat(path, pattern, x, y);
                              }
                              return [3, 6];
                            case 5:
                              if (isLinearGradient(backgroundImage3)) {
                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                _e = calculateGradientDirection(backgroundImage3.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                canvas = document.createElement("canvas");
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext("2d");
                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                processColorStops(backgroundImage3.stops, lineLength).forEach(function(colorStop) {
                                  return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                });
                                ctx.fillStyle = gradient_1;
                                ctx.fillRect(0, 0, width, height);
                                if (width > 0 && height > 0) {
                                  pattern = this_1.ctx.createPattern(canvas, "repeat");
                                  this_1.renderRepeat(path, pattern, x, y);
                                }
                              } else if (isRadialGradient(backgroundImage3)) {
                                _f = calculateBackgroundRendering(container, index, [
                                  null,
                                  null,
                                  null
                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                position2 = backgroundImage3.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage3.position;
                                x = getAbsoluteValue(position2[0], width);
                                y = getAbsoluteValue(position2[position2.length - 1], height);
                                _g = calculateRadius(backgroundImage3, x, y, width, height), rx = _g[0], ry = _g[1];
                                if (rx > 0 && ry > 0) {
                                  radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                  processColorStops(backgroundImage3.stops, rx * 2).forEach(function(colorStop) {
                                    return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                  });
                                  this_1.path(path);
                                  this_1.ctx.fillStyle = radialGradient_1;
                                  if (rx !== ry) {
                                    midX = container.bounds.left + 0.5 * container.bounds.width;
                                    midY = container.bounds.top + 0.5 * container.bounds.height;
                                    f2 = ry / rx;
                                    invF = 1 / f2;
                                    this_1.ctx.save();
                                    this_1.ctx.translate(midX, midY);
                                    this_1.ctx.transform(1, 0, 0, f2, 0, 0);
                                    this_1.ctx.translate(-midX, -midY);
                                    this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                    this_1.ctx.restore();
                                  } else {
                                    this_1.ctx.fill();
                                  }
                                }
                              }
                              _h.label = 6;
                            case 6:
                              index--;
                              return [
                                2
                                /*return*/
                              ];
                          }
                        });
                      };
                      this_1 = this;
                      _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                      _b.label = 1;
                    case 1:
                      if (!(_i < _a.length)) return [3, 4];
                      backgroundImage2 = _a[_i];
                      return [5, _loop_1(backgroundImage2)];
                    case 2:
                      _b.sent();
                      _b.label = 3;
                    case 3:
                      _i++;
                      return [3, 1];
                    case 4:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.renderSolidBorder = function(color3, side, curvePoints) {
              return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                  this.path(parsePathForBorder(curvePoints, side));
                  this.ctx.fillStyle = asString(color3);
                  this.ctx.fill();
                  return [
                    2
                    /*return*/
                  ];
                });
              });
            };
            CanvasRenderer2.prototype.renderDoubleBorder = function(color3, width, side, curvePoints) {
              return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      if (!(width < 3)) return [3, 2];
                      return [4, this.renderSolidBorder(color3, side, curvePoints)];
                    case 1:
                      _a.sent();
                      return [
                        2
                        /*return*/
                      ];
                    case 2:
                      outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                      this.path(outerPaths);
                      this.ctx.fillStyle = asString(color3);
                      this.ctx.fill();
                      innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                      this.path(innerPaths);
                      this.ctx.fill();
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.renderNodeBackgroundAndBorders = function(paint) {
              return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      this.applyEffects(paint.getEffects(
                        2
                        /* BACKGROUND_BORDERS */
                      ));
                      styles = paint.container.styles;
                      hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                      borders = [
                        { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                        { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                        { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                        { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                      ];
                      backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                      if (!(hasBackground || styles.boxShadow.length)) return [3, 2];
                      this.ctx.save();
                      this.path(backgroundPaintingArea);
                      this.ctx.clip();
                      if (!isTransparent(styles.backgroundColor)) {
                        this.ctx.fillStyle = asString(styles.backgroundColor);
                        this.ctx.fill();
                      }
                      return [4, this.renderBackgroundImage(paint.container)];
                    case 1:
                      _a.sent();
                      this.ctx.restore();
                      styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                        _this.ctx.save();
                        var borderBoxArea = calculateBorderBoxPath(paint.curves);
                        var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                        var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                        if (shadow.inset) {
                          _this.path(borderBoxArea);
                          _this.ctx.clip();
                          _this.mask(shadowPaintingArea);
                        } else {
                          _this.mask(borderBoxArea);
                          _this.ctx.clip();
                          _this.path(shadowPaintingArea);
                        }
                        _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                        _this.ctx.shadowOffsetY = shadow.offsetY.number;
                        _this.ctx.shadowColor = asString(shadow.color);
                        _this.ctx.shadowBlur = shadow.blur.number;
                        _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                        _this.ctx.fill();
                        _this.ctx.restore();
                      });
                      _a.label = 2;
                    case 2:
                      side = 0;
                      _i = 0, borders_1 = borders;
                      _a.label = 3;
                    case 3:
                      if (!(_i < borders_1.length)) return [3, 13];
                      border = borders_1[_i];
                      if (!(border.style !== 0 && !isTransparent(border.color) && border.width > 0)) return [3, 11];
                      if (!(border.style === 2)) return [3, 5];
                      return [4, this.renderDashedDottedBorder(
                        border.color,
                        border.width,
                        side,
                        paint.curves,
                        2
                        /* DASHED */
                      )];
                    case 4:
                      _a.sent();
                      return [3, 11];
                    case 5:
                      if (!(border.style === 3)) return [3, 7];
                      return [4, this.renderDashedDottedBorder(
                        border.color,
                        border.width,
                        side,
                        paint.curves,
                        3
                        /* DOTTED */
                      )];
                    case 6:
                      _a.sent();
                      return [3, 11];
                    case 7:
                      if (!(border.style === 4)) return [3, 9];
                      return [4, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                    case 8:
                      _a.sent();
                      return [3, 11];
                    case 9:
                      return [4, this.renderSolidBorder(border.color, side, paint.curves)];
                    case 10:
                      _a.sent();
                      _a.label = 11;
                    case 11:
                      side++;
                      _a.label = 12;
                    case 12:
                      _i++;
                      return [3, 3];
                    case 13:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            };
            CanvasRenderer2.prototype.renderDashedDottedBorder = function(color3, width, side, curvePoints, style) {
              return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                  this.ctx.save();
                  strokePaths = parsePathForBorderStroke(curvePoints, side);
                  boxPaths = parsePathForBorder(curvePoints, side);
                  if (style === 2) {
                    this.path(boxPaths);
                    this.ctx.clip();
                  }
                  if (isBezierCurve(boxPaths[0])) {
                    startX = boxPaths[0].start.x;
                    startY = boxPaths[0].start.y;
                  } else {
                    startX = boxPaths[0].x;
                    startY = boxPaths[0].y;
                  }
                  if (isBezierCurve(boxPaths[1])) {
                    endX = boxPaths[1].end.x;
                    endY = boxPaths[1].end.y;
                  } else {
                    endX = boxPaths[1].x;
                    endY = boxPaths[1].y;
                  }
                  if (side === 0 || side === 2) {
                    length = Math.abs(startX - endX);
                  } else {
                    length = Math.abs(startY - endY);
                  }
                  this.ctx.beginPath();
                  if (style === 3) {
                    this.formatPath(strokePaths);
                  } else {
                    this.formatPath(boxPaths.slice(0, 2));
                  }
                  dashLength = width < 3 ? width * 3 : width * 2;
                  spaceLength = width < 3 ? width * 2 : width;
                  if (style === 3) {
                    dashLength = width;
                    spaceLength = width;
                  }
                  useLineDash = true;
                  if (length <= dashLength * 2) {
                    useLineDash = false;
                  } else if (length <= dashLength * 2 + spaceLength) {
                    multiplier = length / (2 * dashLength + spaceLength);
                    dashLength *= multiplier;
                    spaceLength *= multiplier;
                  } else {
                    numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                    minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                    maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                    spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                  }
                  if (useLineDash) {
                    if (style === 3) {
                      this.ctx.setLineDash([0, dashLength + spaceLength]);
                    } else {
                      this.ctx.setLineDash([dashLength, spaceLength]);
                    }
                  }
                  if (style === 3) {
                    this.ctx.lineCap = "round";
                    this.ctx.lineWidth = width;
                  } else {
                    this.ctx.lineWidth = width * 2 + 1.1;
                  }
                  this.ctx.strokeStyle = asString(color3);
                  this.ctx.stroke();
                  this.ctx.setLineDash([]);
                  if (style === 2) {
                    if (isBezierCurve(boxPaths[0])) {
                      path1 = boxPaths[3];
                      path2 = boxPaths[0];
                      this.ctx.beginPath();
                      this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                      this.ctx.stroke();
                    }
                    if (isBezierCurve(boxPaths[1])) {
                      path1 = boxPaths[1];
                      path2 = boxPaths[2];
                      this.ctx.beginPath();
                      this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                      this.ctx.stroke();
                    }
                  }
                  this.ctx.restore();
                  return [
                    2
                    /*return*/
                  ];
                });
              });
            };
            CanvasRenderer2.prototype.render = function(element) {
              return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      if (this.options.backgroundColor) {
                        this.ctx.fillStyle = asString(this.options.backgroundColor);
                        this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                      }
                      stack = parseStackingContexts(element);
                      return [4, this.renderStack(stack)];
                    case 1:
                      _a.sent();
                      this.applyEffects([]);
                      return [2, this.canvas];
                  }
                });
              });
            };
            return CanvasRenderer2;
          }(Renderer)
        );
        var isTextInputElement = function(container) {
          if (container instanceof TextareaElementContainer) {
            return true;
          } else if (container instanceof SelectElementContainer) {
            return true;
          } else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
          }
          return false;
        };
        var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
          switch (clip) {
            case 0:
              return calculateBorderBoxPath(curves);
            case 2:
              return calculateContentBoxPath(curves);
            case 1:
            default:
              return calculatePaddingBoxPath(curves);
          }
        };
        var canvasTextAlign = function(textAlign2) {
          switch (textAlign2) {
            case 1:
              return "center";
            case 2:
              return "right";
            case 0:
            default:
              return "left";
          }
        };
        var iOSBrokenFonts = ["-apple-system", "system-ui"];
        var fixIOSSystemFonts = function(fontFamilies) {
          return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily2) {
            return iOSBrokenFonts.indexOf(fontFamily2) === -1;
          }) : fontFamilies;
        };
        var ForeignObjectRenderer = (
          /** @class */
          function(_super) {
            __extends(ForeignObjectRenderer2, _super);
            function ForeignObjectRenderer2(context, options) {
              var _this = _super.call(this, context, options) || this;
              _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
              _this.ctx = _this.canvas.getContext("2d");
              _this.options = options;
              _this.canvas.width = Math.floor(options.width * options.scale);
              _this.canvas.height = Math.floor(options.height * options.scale);
              _this.canvas.style.width = options.width + "px";
              _this.canvas.style.height = options.height + "px";
              _this.ctx.scale(_this.options.scale, _this.options.scale);
              _this.ctx.translate(-options.x, -options.y);
              _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
              return _this;
            }
            ForeignObjectRenderer2.prototype.render = function(element) {
              return __awaiter(this, void 0, void 0, function() {
                var svg2, img;
                return __generator(this, function(_a) {
                  switch (_a.label) {
                    case 0:
                      svg2 = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                      return [4, loadSerializedSVG(svg2)];
                    case 1:
                      img = _a.sent();
                      if (this.options.backgroundColor) {
                        this.ctx.fillStyle = asString(this.options.backgroundColor);
                        this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                      }
                      this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                      return [2, this.canvas];
                  }
                });
              });
            };
            return ForeignObjectRenderer2;
          }(Renderer)
        );
        var loadSerializedSVG = function(svg2) {
          return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
              resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg2));
          });
        };
        var Logger = (
          /** @class */
          function() {
            function Logger2(_a) {
              var id2 = _a.id, enabled = _a.enabled;
              this.id = id2;
              this.enabled = enabled;
              this.start = Date.now();
            }
            Logger2.prototype.debug = function() {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              if (this.enabled) {
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") {
                  console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                } else {
                  this.info.apply(this, args);
                }
              }
            };
            Logger2.prototype.getTime = function() {
              return Date.now() - this.start;
            };
            Logger2.prototype.info = function() {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              if (this.enabled) {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") {
                  console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
              }
            };
            Logger2.prototype.warn = function() {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              if (this.enabled) {
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") {
                  console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                } else {
                  this.info.apply(this, args);
                }
              }
            };
            Logger2.prototype.error = function() {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              if (this.enabled) {
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") {
                  console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                } else {
                  this.info.apply(this, args);
                }
              }
            };
            Logger2.instances = {};
            return Logger2;
          }()
        );
        var Context = (
          /** @class */
          function() {
            function Context2(options, windowBounds) {
              var _a;
              this.windowBounds = windowBounds;
              this.instanceName = "#" + Context2.instanceCount++;
              this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
              this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
            }
            Context2.instanceCount = 1;
            return Context2;
          }()
        );
        var html2canvas = function(element, options) {
          if (options === void 0) {
            options = {};
          }
          return renderElement(element, options);
        };
        if (typeof window !== "undefined") {
          CacheStorage.setContext(window);
        }
        var renderElement = function(element, opts) {
          return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor2, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
              switch (_u.label) {
                case 0:
                  if (!element || typeof element !== "object") {
                    return [2, Promise.reject("Invalid element provided as first argument")];
                  }
                  ownerDocument = element.ownerDocument;
                  if (!ownerDocument) {
                    throw new Error("Element is not attached to a Document");
                  }
                  defaultView = ownerDocument.defaultView;
                  if (!defaultView) {
                    throw new Error("Document is not attached to a Window");
                  }
                  resourceOptions = {
                    allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                    imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15e3,
                    proxy: opts.proxy,
                    useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                  };
                  contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                  windowOptions = {
                    windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                    windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                    scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                    scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                  };
                  windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                  context = new Context(contextOptions, windowBounds);
                  foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                  cloneOptions = {
                    allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                    onclone: opts.onclone,
                    ignoreElements: opts.ignoreElements,
                    inlineImages: foreignObjectRendering,
                    copyStyles: foreignObjectRendering
                  };
                  context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                  documentCloner = new DocumentCloner(context, element, cloneOptions);
                  clonedElement = documentCloner.clonedReferenceElement;
                  if (!clonedElement) {
                    return [2, Promise.reject("Unable to find element in cloned iframe")];
                  }
                  return [4, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                  container = _u.sent();
                  _a = isBodyElement(clonedElement) || isHTMLElement3(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                  backgroundColor2 = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                  renderOptions = {
                    canvas: opts.canvas,
                    backgroundColor: backgroundColor2,
                    scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                    x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                    y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                    width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                    height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                  };
                  if (!foreignObjectRendering) return [3, 3];
                  context.logger.debug("Document cloned, using foreign object rendering");
                  renderer = new ForeignObjectRenderer(context, renderOptions);
                  return [4, renderer.render(clonedElement)];
                case 2:
                  canvas = _u.sent();
                  return [3, 5];
                case 3:
                  context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                  context.logger.debug("Starting DOM parsing");
                  root = parseTree(context, clonedElement);
                  if (backgroundColor2 === root.styles.backgroundColor) {
                    root.styles.backgroundColor = COLORS.TRANSPARENT;
                  }
                  context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                  renderer = new CanvasRenderer(context, renderOptions);
                  return [4, renderer.render(root)];
                case 4:
                  canvas = _u.sent();
                  _u.label = 5;
                case 5:
                  if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                    if (!DocumentCloner.destroy(container)) {
                      context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                    }
                  }
                  context.logger.debug("Finished rendering");
                  return [2, canvas];
              }
            });
          });
        };
        var parseBackgroundColor = function(context, element, backgroundColorOverride) {
          var ownerDocument = element.ownerDocument;
          var documentBackgroundColor = ownerDocument.documentElement ? parseColor2(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
          var bodyBackgroundColor = ownerDocument.body ? parseColor2(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
          var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor2(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 4294967295;
          return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
        };
        return html2canvas;
      });
    }
  });

  // src/core/ticker.ts
  var Ticker = class {
    constructor() {
      this.cbs = /* @__PURE__ */ new Set();
      this.raf = 0;
      this.last = 0;
      this.running = false;
      this.frame = (now2) => {
        const dt = Math.min((now2 - this.last) / 1e3, 0.05);
        this.last = now2;
        for (const cb of [...this.cbs]) cb(dt, now2);
        if (this.cbs.size > 0) {
          this.raf = requestAnimationFrame(this.frame);
        } else {
          this.running = false;
          cancelAnimationFrame(this.raf);
        }
      };
    }
    add(fn) {
      this.cbs.add(fn);
      this.wake();
      return () => this.cbs.delete(fn);
    }
    wake() {
      if (this.running) return;
      this.running = true;
      this.last = performance.now();
      this.raf = requestAnimationFrame(this.frame);
    }
    get size() {
      return this.cbs.size;
    }
    /** Drop all callbacks and stop the loop. */
    clear() {
      this.cbs.clear();
      this.running = false;
      if (this.raf) cancelAnimationFrame(this.raf);
    }
  };
  var ticker = new Ticker();

  // src/core/easing.ts
  var c1 = 1.70158;
  var c2 = c1 * 1.525;
  var c3 = c1 + 1;
  var c4 = 2 * Math.PI / 3;
  var c5 = 2 * Math.PI / 4.5;
  var Easing = {
    linear: (t) => t,
    easeInQuad: (t) => t * t,
    easeOutQuad: (t) => 1 - (1 - t) * (1 - t),
    easeInOutQuad: (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2,
    easeInSine: (t) => 1 - Math.cos(t * Math.PI / 2),
    easeOutSine: (t) => Math.sin(t * Math.PI / 2),
    easeInOutSine: (t) => -(Math.cos(Math.PI * t) - 1) / 2,
    easeInCubic: (t) => t * t * t,
    easeOutCubic: (t) => 1 - Math.pow(1 - t, 3),
    easeInOutCubic: (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2,
    easeInQuart: (t) => t * t * t * t,
    easeOutQuart: (t) => 1 - Math.pow(1 - t, 4),
    easeInOutQuart: (t) => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2,
    easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * t - 10),
    easeOutExpo: (t) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t),
    easeInOutExpo: (t) => t === 0 ? 0 : t === 1 ? 1 : t < 0.5 ? Math.pow(2, 20 * t - 10) / 2 : (2 - Math.pow(2, -20 * t + 10)) / 2,
    easeInBack: (t) => c3 * t * t * t - c1 * t * t,
    easeOutBack: (t) => 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2),
    easeInOutBack: (t) => t < 0.5 ? Math.pow(2 * t, 2) * ((c2 + 1) * 2 * t - c2) / 2 : (Math.pow(2 * t - 2, 2) * ((c2 + 1) * (t * 2 - 2) + c2) + 2) / 2,
    easeInElastic: (t) => t === 0 ? 0 : t === 1 ? 1 : -Math.pow(2, 10 * t - 10) * Math.sin((t * 10 - 10.75) * c4),
    easeOutElastic: (t) => t === 0 ? 0 : t === 1 ? 1 : Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * c4) + 1,
    easeInOutElastic: (t) => t === 0 ? 0 : t === 1 ? 1 : t < 0.5 ? -(Math.pow(2, 20 * t - 10) * Math.sin((20 * t - 11.125) * c5)) / 2 : Math.pow(2, -20 * t + 10) * Math.sin((20 * t - 11.125) * c5) / 2,
    easeInBounce: (t) => 1 - Easing.easeOutBounce(1 - t),
    easeOutBounce: (t) => {
      const n1 = 7.5625;
      const d1 = 2.75;
      if (t < 1 / d1) return n1 * t * t;
      if (t < 2 / d1) return n1 * (t -= 1.5 / d1) * t + 0.75;
      if (t < 2.5 / d1) return n1 * (t -= 2.25 / d1) * t + 0.9375;
      return n1 * (t -= 2.625 / d1) * t + 0.984375;
    },
    easeInOutBounce: (t) => t < 0.5 ? (1 - Easing.easeOutBounce(1 - 2 * t)) / 2 : (1 + Easing.easeOutBounce(2 * t - 1)) / 2,
    // continuous wobble for ambient loops (no 0..1 bound — feeds sin)
    wobble: (t, amp = 1, freq = 1) => Math.sin(t * Math.PI * 2 * freq) * amp
  };
  var aliases = {
    linear: "linear",
    inQuad: "easeInQuad",
    outQuad: "easeOutQuad",
    inOutQuad: "easeInOutQuad",
    inSine: "easeInSine",
    outSine: "easeOutSine",
    inOutSine: "easeInOutSine",
    inCubic: "easeInCubic",
    outCubic: "easeOutCubic",
    inOutCubic: "easeInOutCubic",
    inQuart: "easeInQuart",
    outQuart: "easeOutQuart",
    inOutQuart: "easeInOutQuart",
    inExpo: "easeInExpo",
    outExpo: "easeOutExpo",
    inOutExpo: "easeInOutExpo",
    inBack: "easeInBack",
    outBack: "easeOutBack",
    inOutBack: "easeInOutBack",
    inElastic: "easeInElastic",
    outElastic: "easeOutElastic",
    inOutElastic: "easeInOutElastic",
    inBounce: "easeInBounce",
    outBounce: "easeOutBounce",
    inOutBounce: "easeInOutBounce"
  };
  function resolveEase(ease) {
    if (typeof ease === "function") return ease;
    if (!ease) return Easing.easeOutCubic;
    const key2 = aliases[ease] ?? ease;
    return Easing[key2] ?? Easing.easeOutCubic;
  }

  // src/core/spring.ts
  var Spring = class {
    constructor(opts = {}) {
      this.k = opts.stiffness ?? 170;
      this.c = opts.damping ?? 22;
      this.m = opts.mass ?? 1;
      this.v = opts.velocity ?? 0;
      this.restX = opts.restDisplacement ?? 1e-3;
      this.restV = opts.restVelocity ?? 1e-3;
    }
    /** Advance from current pos x by dt seconds. Returns new pos. */
    step(x, dt) {
      const h = Math.min(dt, 1 / 60);
      const fSpring = -this.k * (x - 1);
      const fDamp = -this.c * this.v;
      const a = (fSpring + fDamp) / this.m;
      this.v += a * h;
      const nx = x + this.v * h;
      return nx;
    }
    /** True when settled near target (1) and at rest. */
    settled(x) {
      return Math.abs(1 - x) < this.restX && Math.abs(this.v) < this.restV;
    }
  };

  // src/properties/aliases.ts
  var ALIASES = {
    op: "opacity",
    rot: "rotate",
    sc: "scale",
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    rx: "rotateX",
    ry: "rotateY",
    rz: "rotateZ",
    skew: "skewX",
    // css-function style aliases
    blur: "blur",
    glow: "glow",
    bloom: "bloom",
    shadow: "boxShadow",
    bscale: "brightnessScale",
    tilt: "tilt",
    // color props
    col: "color",
    bg: "backgroundColor",
    bc: "borderColor",
    fill: "fill",
    stroke: "stroke"
  };
  function aliasOf(key2) {
    return ALIASES[key2] ?? key2;
  }

  // src/properties/units.ts
  var UNITS = {
    opacity: "",
    translateX: "px",
    translateY: "px",
    translateZ: "px",
    rotate: "deg",
    rotateX: "deg",
    rotateY: "deg",
    rotateZ: "deg",
    scale: "",
    skewX: "deg",
    skewY: "deg",
    width: "px",
    height: "px",
    x: "px",
    y: "px",
    cx: "",
    cy: "",
    r: "",
    strokeDashoffset: "",
    // css-function props
    blur: "px",
    glow: "",
    bloom: "",
    boxShadow: "px",
    brightnessScale: "",
    tilt: "deg",
    slamShadow: "px",
    burst: ""
  };
  function unitFor(prop) {
    return UNITS[prop] ?? "";
  }

  // src/properties/transformMap.ts
  var TRANSFORM_MAP = {
    translateX: { fn: "translateX", output: "transform" },
    translateY: { fn: "translateY", output: "transform" },
    translateZ: { fn: "translateZ", output: "transform" },
    rotate: { fn: "rotate", output: "transform" },
    rotateX: { fn: "rotateX", output: "transform" },
    rotateY: { fn: "rotateY", output: "transform" },
    rotateZ: { fn: "rotateZ", output: "transform" },
    scale: { fn: "scale", output: "transform" },
    skewX: { fn: "skewX", output: "transform" },
    skewY: { fn: "skewY", output: "transform" },
    // css functions
    blur: { fn: "blur", output: "css-fn", cssProp: "filter" },
    boxShadow: { fn: "drop-shadow", output: "css-fn", cssProp: "filter" },
    glow: { fn: "", output: "custom-prop", cssProp: "--glow" },
    bloom: { fn: "", output: "custom-prop", cssProp: "--bloom" },
    brightnessScale: { fn: "", output: "custom-prop", cssProp: "--brightness" },
    tilt: { fn: "", output: "custom-prop", cssProp: "--tilt" },
    slamShadow: { fn: "", output: "custom-prop", cssProp: "--slam-shadow" },
    burst: { fn: "", output: "custom-prop", cssProp: "--burst" },
    // direct style props
    opacity: { fn: "", output: "style", cssProp: "opacity" },
    width: { fn: "", output: "style", cssProp: "width" },
    height: { fn: "", output: "style", cssProp: "height" },
    // svg attrs
    strokeDashoffset: { fn: "", output: "svg-attr", cssProp: "strokeDashoffset" },
    // color props — interpolated in HSL space, written as rgb()
    color: { fn: "color", output: "color", cssProp: "color" },
    backgroundColor: { fn: "backgroundColor", output: "color", cssProp: "backgroundColor" },
    borderColor: { fn: "borderColor", output: "color", cssProp: "borderColor" },
    fill: { fn: "fill", output: "color", cssProp: "fill" },
    stroke: { fn: "stroke", output: "color", cssProp: "stroke" }
  };
  function transformEntry(prop) {
    return TRANSFORM_MAP[prop];
  }

  // src/properties/normalizeProperty.ts
  var SVG_ATTR_RE = /^attr:(.+)$/;
  function normalizeProperty(rawKey) {
    const attrMatch = SVG_ATTR_RE.exec(rawKey);
    if (attrMatch) {
      const p = attrMatch[1];
      return { prop: p, unit: "", output: "svg-attr", cssProp: p, svgAttr: true };
    }
    const canon = aliasOf(rawKey);
    const entry = transformEntry(canon);
    if (entry) {
      return {
        prop: canon,
        unit: unitFor(canon),
        output: entry.output,
        cssProp: entry.cssProp,
        fn: entry.fn
      };
    }
    return { prop: canon, unit: unitFor(canon), output: "style", cssProp: canon };
  }

  // src/properties/normalizeValue.ts
  function normalizeValue(raw) {
    if (raw == null) return { keys: [0, 1], unit: "" };
    if (typeof raw === "number") return { keys: [raw], unit: "" };
    if (Array.isArray(raw)) {
      if (raw.length === 0) return { keys: [0, 1], unit: "" };
      if (raw.length === 1) return { keys: [raw[0], raw[0]], unit: "" };
      return { keys: raw.slice(), unit: "" };
    }
    if ("keys" in raw && Array.isArray(raw.keys)) {
      return { keys: raw.keys.slice(), unit: raw.unit ?? "" };
    }
    const from = raw.from ?? 0;
    const to = raw.to ?? from;
    return { keys: [from, to], unit: raw.unit ?? "" };
  }

  // src/properties/cssFunctions.ts
  function applyCssFn(fn, value, unit) {
    switch (fn) {
      case "blur":
        return `blur(${value}${unit})`;
      case "drop-shadow":
        return `drop-shadow(0 0 ${value}${unit} rgba(0,0,0,0.5))`;
      default:
        return `${value}${unit}`;
    }
  }

  // src/adapters/adapters.ts
  var registry = [];
  var adapters = registry;
  function registerAdapter(a) {
    registry.unshift(a);
  }
  function resolveAdapter(t) {
    for (const a of registry) if (a.test(t)) return a;
    return null;
  }
  function readProp(t, prop) {
    const a = resolveAdapter(t);
    if (!a) return { v: Number(t[prop]) || 0 };
    const unit = a.unit?.(t, prop);
    return { v: a.get(t, prop), unit };
  }
  function writeProp(t, prop, value) {
    const a = resolveAdapter(t);
    if (a) a.set(t, prop, value);
    else if (t && typeof t === "object") t[prop] = value;
  }
  registerAdapter({
    test: () => true,
    // fallback — must be LAST registered; registered first in array so it wins only if no other
    props: (t) => t && typeof t === "object" ? Object.keys(t) : [],
    get: (t, p) => Number(t[p]) || 0,
    set: (t, p, v) => {
      t[p] = v;
    }
  });
  registerAdapter({
    test: (t) => typeof HTMLElement !== "undefined" && t instanceof HTMLElement,
    props: (t) => {
      const out = [];
      if (t.style) out.push("opacity", "x", "y", "scale", "rotate", "width", "height");
      return out;
    },
    get: (t, p) => {
      if (p === "opacity") {
        const inline = parseFloat(t.style.opacity);
        if (Number.isFinite(inline)) return inline;
        const computed = typeof getComputedStyle === "function" ? parseFloat(getComputedStyle(t).opacity) : Number.NaN;
        return Number.isFinite(computed) ? computed : 1;
      }
      const transform = t.style.transform || "";
      const transformValue = (fn, fallback) => {
        const match = new RegExp(`${fn}\\(\\s*(-?[\\d.]+)`).exec(transform);
        return match ? Number(match[1]) || fallback : fallback;
      };
      if (p === "x") return transformValue("translateX", 0);
      if (p === "y") return transformValue("translateY", 0);
      if (p === "scale") return transformValue("scale", 1);
      if (p === "rotate") return transformValue("rotate", 0);
      if (p === "width") return t.offsetWidth;
      if (p === "height") return t.offsetHeight;
      return 0;
    },
    set: (t, p, v) => {
      if (p === "opacity") t.style.opacity = String(v);
      else if (p === "width") t.style.width = `${v}px`;
      else if (p === "height") t.style.height = `${v}px`;
      else if (p === "x" || p === "y" || p === "scale" || p === "rotate") {
        const cur = t.style.transform || "";
        const fn = p === "x" ? "translateX" : p === "y" ? "translateY" : p === "scale" ? "scale" : "rotate";
        const u = p === "scale" ? "" : p === "rotate" ? "deg" : "px";
        const re = new RegExp(`${fn}\\([^)]*\\)`);
        const next = `${fn}(${v}${u})`;
        t.style.transform = re.test(cur) ? cur.replace(re, next) : (cur + " " + next).trim();
      }
    },
    unit: (_t, p) => p === "rotate" ? "deg" : p === "scale" ? "" : "px"
  });

  // src/properties/color.ts
  var NAMED = {
    transparent: "rgba(0,0,0,0)",
    black: "#000",
    white: "#fff",
    red: "#d32f2f",
    green: "#0a0",
    blue: "#00f",
    gold: "#f3c34a",
    bone: "#f3e9d2",
    brown: "#5d4037",
    orange: "#ff8a5b",
    yellow: "#ff0",
    cyan: "#0ff",
    magenta: "#f0f",
    gray: "#808080",
    grey: "#808080",
    silver: "#c0c0c0"
  };
  function parseColor(input) {
    if (Array.isArray(input)) {
      const [r, g, b] = input;
      return rgbToHsl(r / 255, g / 255, b / 255);
    }
    let s = input.trim().toLowerCase();
    if (NAMED[s]) s = NAMED[s];
    if (s.startsWith("#")) return hexToHsl(s);
    if (s.startsWith("rgb")) return rgbStrToHsl(s);
    if (s.startsWith("hsl")) return hslStrToHsl(s);
    return { h: 0, s: 0, l: 0 };
  }
  function hexToHsl(hex) {
    let h = hex.slice(1);
    if (h.length === 3) h = h.split("").map((c) => c + c).join("");
    const n = parseInt(h.slice(0, 6), 16);
    if (Number.isNaN(n)) return { h: 0, s: 0, l: 0 };
    const r = (n >> 16 & 255) / 255;
    const g = (n >> 8 & 255) / 255;
    const b = (n & 255) / 255;
    return rgbToHsl(r, g, b);
  }
  function rgbStrToHsl(str) {
    const nums = (str.match(/-?[\d.]+/g) || []).map(Number);
    if (nums.length < 3) return { h: 0, s: 0, l: 0 };
    const [r, g, b] = nums;
    const isPct = /%/.test(str);
    return rgbToHsl(
      isPct ? r / 100 : r / 255,
      isPct ? g / 100 : g / 255,
      isPct ? b / 100 : b / 255
    );
  }
  function hslStrToHsl(str) {
    const nums = (str.match(/-?[\d.]+/g) || []).map(Number);
    if (nums.length < 3) return { h: 0, s: 0, l: 0 };
    return { h: nums[0], s: nums[1], l: nums[2] };
  }
  function rgbToHsl(r, g, b) {
    const max2 = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0;
    const l = (max2 + min) / 2;
    const d = max2 - min;
    const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
    if (d !== 0) {
      switch (max2) {
        case r:
          h = (g - b) / d % 6;
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        default:
          h = (r - g) / d + 4;
          break;
      }
      h *= 60;
      if (h < 0) h += 360;
    }
    return { h, s: s * 100, l: l * 100 };
  }
  function mixHsl(a, b, t) {
    let dh = b.h - a.h;
    if (dh > 180) dh -= 360;
    else if (dh < -180) dh += 360;
    return {
      h: (a.h + dh * t + 360) % 360,
      s: a.s + (b.s - a.s) * t,
      l: a.l + (b.l - a.l) * t
    };
  }
  function mixColor(from, to, t) {
    const a = parseColor(from), b = parseColor(to);
    const m = mixHsl(a, b, Math.max(0, Math.min(1, t)));
    const { r, g, b: bb } = hslToRgb(m);
    return `rgb(${Math.round(r)},${Math.round(g)},${Math.round(bb)})`;
  }
  function hslToRgb(c) {
    const h = c.h / 360, s = c.s / 100, l = c.l / 100;
    if (s === 0) {
      const v = Math.round(l * 255);
      return { r: v, g: v, b: v };
    }
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const hue = (t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    return { r: hue(h + 1 / 3) * 255, g: hue(h) * 255, b: hue(h - 1 / 3) * 255 };
  }
  var color = { parseColor, mixHsl, mixColor, hslToRgb };

  // src/properties/index.ts
  var PulseProperties = {
    /** Resolve a raw key → canonical prop + output target + unit. */
    normalizeProp(rawKey) {
      return normalizeProperty(rawKey);
    },
    /** Resolve a keyframe value → uniform {keys, unit}. */
    normalizeValue(raw) {
      return normalizeValue(raw);
    },
    aliasOf,
    unitFor,
    /** Compose a css-fn value string (filter: blur(..), etc). */
    cssFn(fn, value, unit) {
      return applyCssFn(fn, value, unit);
    },
    /**
     * The single write path. Given a target element, the normalized spec, and the
     * per-key computed values, resolve each key → alias → output kind → adapter
     * write. This is where Bag/Tween hand off; the Adapter seam does the actual
     * DOM/SVG/object write.
     */
    apply(el, spec, values, progress = 1) {
      const adapter = resolveAdapter(el);
      for (const raw of Object.keys(spec)) {
        const norm = spec[raw];
        if (norm.template) continue;
        if (norm.colors && norm.colors.length >= 2) {
          const cssProp = norm.css ?? this.normalizeProp(raw).cssProp ?? raw;
          const stops = norm.colors;
          const t = Math.max(0, Math.min(1, progress));
          const col = stops.length === 2 ? mixColor(stops[0], stops[1], t) : (() => {
            const seg = t * (stops.length - 1);
            const i = Math.min(stops.length - 2, Math.floor(seg));
            return mixColor(stops[i], stops[i + 1], seg - i);
          })();
          if (el.style && typeof el.style === "object") {
            if (cssProp.startsWith("--") || cssProp.includes("-")) el.style.setProperty(cssProp, col);
            else el.style[cssProp] = col;
          } else el[cssProp] = col;
          continue;
        }
        const v = values[raw];
        const np = normalizeProperty(raw);
        const output = spec[raw].css ? "custom-prop" : np.output;
        const outProp = spec[raw].css ?? np.cssProp ?? raw;
        const fnName = spec[raw].fn ?? np.fn;
        const unit = spec[raw].unit ?? (fnName ? unitFor(fnName) : void 0) ?? unitFor(outProp) ?? np.unit ?? "";
        const adapterProps = adapter?.props(el) ?? [];
        if (adapter && !el?.style && (adapterProps.includes(raw) || adapterProps.includes(np.prop) || adapterProps.includes(outProp))) {
          writeProp(el, raw, v);
          continue;
        }
        switch (output) {
          case "transform": {
            const fn = spec[raw].fn ?? np.fn;
            const cur = el.style.transform || "";
            const next = `${fn}(${v}${unit})`;
            const re = new RegExp(`${fn.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\([^)]*\\)`);
            el.style.transform = re.test(cur) ? cur.replace(re, next) : (cur + " " + next).trim();
            break;
          }
          case "css-fn": {
            const cssProp = spec[raw].css ?? np.cssProp;
            el.style[cssProp] = applyCssFn(np.fn, v, unit);
            break;
          }
          case "custom-prop": {
            el.style.setProperty(spec[raw].css ?? np.cssProp, `${v}${unit}`);
            break;
          }
          case "svg-attr": {
            const cssProp = spec[raw].css ?? np.cssProp;
            if (el.style && cssProp === "strokeDashoffset") el.style.strokeDashoffset = String(v);
            else if (el.setAttribute) el.setAttribute(cssProp, String(v));
            break;
          }
          case "color": {
            const cssProp = spec[raw].css ?? np.cssProp;
            const col = mixColor("#000", "#fff", Math.max(0, Math.min(1, v)));
            if (el.style && typeof el.style === "object") {
              if (cssProp.startsWith("--") || cssProp.includes("-")) el.style.setProperty(cssProp, col);
              else el.style[cssProp] = col;
            } else el[cssProp] = col;
            break;
          }
          default: {
            const cssProp = spec[raw].css ?? np.cssProp ?? raw;
            if (el.style && typeof el.style === "object") el.style[cssProp] = `${v}${unit}`;
            else if (adapter) writeProp(el, cssProp, v);
            else el[cssProp] = v;
          }
        }
      }
    }
  };

  // src/core/tween.ts
  var Tween = class {
    constructor(target, spec) {
      this.target = target;
      this.elapsed = 0;
      this.unsub = null;
      this.done = false;
      this.speed = 1;
      /** Drive progress 0..1 externally (manual mode). */
      this.progress = 0;
      this.tick = (dt) => {
        dt *= this.speed;
        if (this.delayLeft > 0) {
          this.delayLeft -= dt;
          if (this.delayLeft > 0) return;
          dt = -this.delayLeft;
        }
        const dur = this.spec.duration ?? 0.4;
        if (this.spring) {
          const start = this.from;
          const nx = this.spring.step(this.cur ?? start, dt);
          this.cur = nx;
          const p = (nx - this.from) / (this.to - this.from || 1);
          this.render(Math.max(0, Math.min(1, p)));
          if (this.spring.settled(nx)) this.finish();
          return;
        }
        this.elapsed += dt;
        const raw = dur <= 0 ? 1 : Math.min(this.elapsed / dur, 1);
        this.render(this.ease(raw));
        if (raw >= 1) this.finish();
      };
      this.spec = spec;
      this.ease = resolveEase(spec.ease);
      if (spec.spring && spec.mode !== "manual") {
        this.spring = new Spring(spec.spring);
      }
      this.delayLeft = spec.delay ?? 0;
      this.from = typeof spec.from === "number" ? spec.from : 0;
      this.to = typeof spec.to === "number" ? spec.to : 1;
      this.mapFrom = typeof spec.from === "object" && spec.from ? spec.from : {};
      this.mapTo = typeof spec.to === "object" && spec.to ? spec.to : {};
      if (spec.mode !== "manual") this.start();
    }
    /** Duration in seconds (for timeline planning). */
    get dur() {
      return this.spec.duration ?? 0.4;
    }
    start() {
      if (this.unsub) return this;
      this.unsub = ticker.add(this.tick);
      return this;
    }
    stop() {
      this.unsub?.();
      this.unsub = null;
      return this;
    }
    play() {
      return this.start();
    }
    pause() {
      return this.stop();
    }
    seek(time) {
      const duration = Math.max(0, this.spec.duration ?? 0.4);
      this.elapsed = Math.max(0, Math.min(duration, Number(time) || 0));
      const raw = duration <= 0 ? 1 : this.elapsed / duration;
      this.progress = raw;
      this.render(this.ease(raw));
      return this;
    }
    restart() {
      this.stop();
      this.elapsed = 0;
      this.delayLeft = this.spec.delay ?? 0;
      this.progress = 0;
      this.done = false;
      if (this.spec.spring && this.spec.mode !== "manual") this.spring = new Spring(this.spec.spring);
      this.render(this.ease(0));
      return this.start();
    }
    setSpeed(rate) {
      this.speed = Math.max(1e-6, Number(rate) || 1);
      return this;
    }
    reverse() {
      [this.from, this.to] = [this.to, this.from];
      [this.mapFrom, this.mapTo] = [this.mapTo, this.mapFrom];
      return this.restart();
    }
    dispose() {
      this.stop();
    }
    /** Manually set normalized progress (0..1) and re-render. */
    set(p) {
      this.progress = Math.max(0, Math.min(1, p));
      this.render(this.progress);
      if (this.progress >= 1 && !this.done) this.finish();
      return this;
    }
    render(e) {
      this.progress = e;
      const scalar = this.from + (this.to - this.from) * e;
      const map2 = {};
      for (const k in this.mapTo) {
        const a = this.mapFrom[k] ?? 0;
        const b = this.mapTo[k];
        map2[k] = a + (b - a) * e;
      }
      if (this.target) applyTarget(this.target, scalar, map2);
      this.spec.onUpdate?.(scalar, map2);
    }
    finish() {
      if (this.done) return;
      this.done = true;
      this.stop();
      this.spec.onComplete?.();
    }
  };
  function applyTarget(target, scalar, map2) {
    if (!target) return;
    if (target instanceof HTMLElement) {
      if (Object.keys(map2).length === 0) {
        target.style.setProperty("--p", scalar.toFixed(4));
        return;
      }
      const normalized = {};
      for (const key2 of Object.keys(map2)) normalized[key2] = { from: map2[key2], to: map2[key2] };
      PulseProperties.apply(target, normalized, map2, 1);
    } else {
      if (Object.keys(map2).length === 0) {
        target.value = scalar;
      }
      for (const k in map2) target[k] = map2[k];
    }
  }
  function stagger(els, spec, step = 0.08, base = 0) {
    return els.map((el, i) => new Tween(el, { ...spec, delay: (spec.delay ?? 0) + base + i * step }));
  }

  // node_modules/animejs/dist/modules/core/consts.js
  var isBrowser = typeof window !== "undefined";
  var win = isBrowser ? (
    /** @type {AnimeJSWindow} */
    /** @type {unknown} */
    window
  ) : null;
  var doc = isBrowser ? document : null;
  var tweenTypes = {
    OBJECT: 0,
    ATTRIBUTE: 1,
    CSS: 2,
    TRANSFORM: 3,
    CSS_VAR: 4
  };
  var valueTypes = {
    NUMBER: 0,
    UNIT: 1,
    COLOR: 2,
    COMPLEX: 3
  };
  var tickModes = {
    NONE: 0,
    AUTO: 1,
    FORCE: 2
  };
  var compositionTypes = {
    replace: 0,
    none: 1,
    blend: 2
  };
  var isRegisteredTargetSymbol = Symbol();
  var isDomSymbol = Symbol();
  var isSvgSymbol = Symbol();
  var transformsSymbol = Symbol();
  var proxyTargetSymbol = Symbol();
  var minValue = 1e-11;
  var maxValue = 1e12;
  var K = 1e3;
  var maxFps = 240;
  var emptyString = "";
  var cssVarPrefix = "var(";
  var emptyArray = [];
  var shortTransforms = /* @__PURE__ */ (() => {
    const map2 = /* @__PURE__ */ new Map();
    map2.set("x", "translateX");
    map2.set("y", "translateY");
    map2.set("z", "translateZ");
    return map2;
  })();
  var validTransforms = [
    "perspective",
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY"
  ];
  var transformsFragmentStrings = /* @__PURE__ */ validTransforms.reduce((a, v) => ({ ...a, [v]: v + "(" }), {});
  var noop = () => {
  };
  var noopModifier = (v) => v;
  var validRgbHslRgx = /\)\s*[-.\d]/;
  var hexTestRgx = /(^#([\da-f]{3}){1,2}$)|(^#([\da-f]{4}){1,2}$)/i;
  var rgbExecRgx = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i;
  var rgbaExecRgx = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/i;
  var hslExecRgx = /hsl\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*\)/i;
  var hslaExecRgx = /hsla\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/i;
  var digitWithExponentRgx = /[-+]?\d*\.?\d+(?:e[-+]?\d)?/gi;
  var unitsExecRgx = /^([-+]?\d*\.?\d+(?:e[-+]?\d+)?)([a-z]+|%)$/i;
  var lowerCaseRgx = /([a-z])([A-Z])/g;
  var relativeValuesExecRgx = /(\*=|\+=|-=)/;
  var cssVariableMatchRgx = /var\(\s*(--[\w-]+)(?:\s*,\s*([^)]+))?\s*\)/;

  // node_modules/animejs/dist/modules/core/globals.js
  var defaults = {
    id: null,
    keyframes: null,
    playbackEase: null,
    playbackRate: 1,
    frameRate: maxFps,
    loop: 0,
    reversed: false,
    alternate: false,
    autoplay: true,
    persist: false,
    duration: K,
    delay: 0,
    loopDelay: 0,
    ease: "out(2)",
    composition: compositionTypes.replace,
    modifier: noopModifier,
    onBegin: noop,
    onBeforeUpdate: noop,
    onUpdate: noop,
    onLoop: noop,
    onPause: noop,
    onComplete: noop,
    onRender: noop
  };
  var scope = {
    /** @type {Scope} */
    current: null,
    /** @type {Document|DOMTarget} */
    root: doc
  };
  var globals = {
    /** @type {DefaultsParams} */
    defaults,
    /** @type {Number} */
    precision: 4,
    /** @type {Number} equals 1 in ms mode, 0.001 in s mode */
    timeScale: 1,
    /** @type {Number} */
    tickThreshold: 200,
    /** @type {EditorGlobals|null} */
    editor: null
  };
  var globalVersions = { version: "4.5.0", engine: null };
  if (isBrowser) {
    if (!win.AnimeJS) win.AnimeJS = [];
    win.AnimeJS.push(globalVersions);
  }

  // node_modules/animejs/dist/modules/core/helpers.js
  var toLowerCase = (str) => str.replace(lowerCaseRgx, "$1-$2").toLowerCase();
  var stringStartsWith = (str, sub) => str.indexOf(sub) === 0;
  var now = Date.now;
  var isArr = Array.isArray;
  var isObj = (a) => a && a.constructor === Object;
  var isNum = (a) => typeof a === "number" && !isNaN(a);
  var isStr = (a) => typeof a === "string";
  var isFnc = (a) => typeof a === "function";
  var isUnd = (a) => typeof a === "undefined";
  var isNil = (a) => isUnd(a) || a === null;
  var isSvg = (a) => isBrowser && a instanceof SVGElement;
  var isHex = (a) => hexTestRgx.test(a);
  var isRgb = (a) => stringStartsWith(a, "rgb");
  var isHsl = (a) => stringStartsWith(a, "hsl");
  var isCol = (a) => isHex(a) || (isRgb(a) || isHsl(a)) && (a[a.length - 1] === ")" || !validRgbHslRgx.test(a));
  var isKey = (a) => !globals.defaults.hasOwnProperty(a);
  var svgCssReservedProperties = ["opacity", "rotate", "overflow", "color"];
  var isValidSVGAttribute = (el, propertyName) => {
    if (svgCssReservedProperties.includes(propertyName)) return false;
    if (el.getAttribute(propertyName) || propertyName in el) {
      if (propertyName === "scale") {
        const elParentNode = (
          /** @type {SVGGeometryElement} */
          /** @type {DOMTarget} */
          el.parentNode
        );
        return elParentNode && elParentNode.tagName === "filter";
      }
      return true;
    }
  };
  var pow = Math.pow;
  var sqrt = Math.sqrt;
  var sin = Math.sin;
  var cos = Math.cos;
  var abs = Math.abs;
  var exp = Math.exp;
  var floor = Math.floor;
  var asin = Math.asin;
  var max = Math.max;
  var atan2 = Math.atan2;
  var PI = Math.PI;
  var _round = Math.round;
  var clamp = (v, min, max2) => v < min ? min : v > max2 ? max2 : v;
  var round = (v, decimalLength) => {
    if (decimalLength < 0) return v;
    if (!decimalLength) return _round(v);
    const p = 10 ** decimalLength;
    return _round(v * p) / p;
  };
  var snap = (v, increment) => isArr(increment) ? increment.reduce((closest, cv) => abs(cv - v) < abs(closest - v) ? cv : closest) : increment ? _round(v / increment) * increment : v;
  var lerp = (start, end, factor) => factor === 1 ? end : factor === 0 ? start : start + (end - start) * factor;
  var clampInfinity = (v) => v === Infinity ? maxValue : v === -Infinity ? -maxValue : v;
  var normalizeTime = (v) => v <= minValue ? minValue : clampInfinity(round(v, 11));
  var cloneArray = (a) => isArr(a) ? [...a] : a;
  var mergeObjects = (o1, o2) => {
    const merged = (
      /** @type {T & U} */
      { ...o1 }
    );
    for (let p in o2) {
      const o1p = (
        /** @type {T & U} */
        o1[p]
      );
      merged[p] = isUnd(o1p) ? (
        /** @type {T & U} */
        o2[p]
      ) : o1p;
    }
    return merged;
  };
  var forEachChildren = (parent, callback, reverse, prevProp = "_prev", nextProp = "_next") => {
    let next = parent._head;
    let adjustedNextProp = nextProp;
    if (reverse) {
      next = parent._tail;
      adjustedNextProp = prevProp;
    }
    while (next) {
      const currentNext = next[adjustedNextProp];
      callback(next);
      next = currentNext;
    }
  };
  var removeChild = (parent, child, prevProp = "_prev", nextProp = "_next") => {
    const prev = child[prevProp];
    const next = child[nextProp];
    prev ? prev[nextProp] = next : parent._head = next;
    next ? next[prevProp] = prev : parent._tail = prev;
    child[prevProp] = null;
    child[nextProp] = null;
  };
  var addChild = (parent, child, sortMethod, prevProp = "_prev", nextProp = "_next") => {
    let prev = parent._tail;
    while (prev && sortMethod && sortMethod(prev, child)) prev = prev[prevProp];
    const next = prev ? prev[nextProp] : parent._head;
    prev ? prev[nextProp] = child : parent._head = child;
    next ? next[prevProp] = child : parent._tail = child;
    child[prevProp] = prev;
    child[nextProp] = next;
  };

  // node_modules/animejs/dist/modules/core/transforms.js
  var parseInlineTransforms = (target, propName, animationInlineStyles) => {
    const inlineTransforms = target.style.transform;
    if (inlineTransforms) {
      const cachedTransforms = target[transformsSymbol];
      let pos = 0;
      const len = inlineTransforms.length;
      let fullTranslateValue;
      while (pos < len) {
        while (pos < len && inlineTransforms.charCodeAt(pos) === 32) pos++;
        if (pos >= len) break;
        const nameStart = pos;
        while (pos < len && inlineTransforms.charCodeAt(pos) !== 40) pos++;
        if (pos >= len) break;
        const name = inlineTransforms.substring(nameStart, pos);
        let depth = 1;
        const valueStart = pos + 1;
        let c12 = -1, c22 = -1;
        pos++;
        while (pos < len && depth > 0) {
          const c = inlineTransforms.charCodeAt(pos);
          if (c === 40) depth++;
          else if (c === 41) depth--;
          else if (c === 44 && depth === 1) {
            if (c12 === -1) c12 = pos;
            else if (c22 === -1) c22 = pos;
          }
          pos++;
        }
        const valueEnd = pos - 1;
        if (name === "translate" || name === "translate3d") {
          if (c12 === -1) {
            cachedTransforms.translateX = inlineTransforms.substring(valueStart, valueEnd).trim();
          } else {
            cachedTransforms.translateX = inlineTransforms.substring(valueStart, c12).trim();
            if (c22 === -1) {
              cachedTransforms.translateY = inlineTransforms.substring(c12 + 1, valueEnd).trim();
            } else {
              cachedTransforms.translateY = inlineTransforms.substring(c12 + 1, c22).trim();
              cachedTransforms.translateZ = inlineTransforms.substring(c22 + 1, valueEnd).trim();
            }
          }
          fullTranslateValue = inlineTransforms.substring(valueStart, valueEnd);
        } else if (name === "scale" || name === "scale3d") {
          if (c12 === -1) {
            cachedTransforms.scale = inlineTransforms.substring(valueStart, valueEnd).trim();
          } else {
            cachedTransforms.scaleX = inlineTransforms.substring(valueStart, c12).trim();
            if (c22 === -1) {
              cachedTransforms.scaleY = inlineTransforms.substring(c12 + 1, valueEnd).trim();
            } else {
              cachedTransforms.scaleY = inlineTransforms.substring(c12 + 1, c22).trim();
              cachedTransforms.scaleZ = inlineTransforms.substring(c22 + 1, valueEnd).trim();
            }
          }
        } else {
          cachedTransforms[name] = inlineTransforms.substring(valueStart, valueEnd);
        }
      }
      if (propName === "translate3d" && fullTranslateValue) {
        if (animationInlineStyles) animationInlineStyles[propName] = fullTranslateValue;
        return fullTranslateValue;
      }
      const cached = cachedTransforms[propName];
      if (!isUnd(cached)) {
        if (animationInlineStyles) animationInlineStyles[propName] = cached;
        return cached;
      }
    }
    return propName === "translate3d" ? "0px, 0px, 0px" : propName === "rotate3d" ? "0, 0, 0, 0deg" : stringStartsWith(propName, "scale") ? "1" : stringStartsWith(propName, "rotate") || stringStartsWith(propName, "skew") ? "0deg" : "0px";
  };
  var buildTransformString = (props) => {
    let str = emptyString;
    for (let i = 0, l = validTransforms.length; i < l; i++) {
      const key2 = validTransforms[i];
      const val = props[key2];
      if (val !== void 0) {
        if (key2 === "translateX") {
          const next = props.translateY;
          if (next !== void 0) {
            const next2 = props.translateZ;
            if (next2 !== void 0) {
              str += `translate3d(${val},${next},${next2}) `;
              i += 2;
            } else {
              str += `translate(${val},${next}) `;
              i += 1;
            }
            continue;
          }
        }
        if (key2 === "scaleX" && props.scale === void 0) {
          const next = props.scaleY;
          if (next !== void 0) {
            const next2 = props.scaleZ;
            if (next2 !== void 0) {
              str += `scale3d(${val},${next},${next2}) `;
              i += 2;
            } else {
              str += `scale(${val},${next}) `;
              i += 1;
            }
            continue;
          }
        }
        str += `${transformsFragmentStrings[key2]}${val}) `;
      }
      if (key2 === "rotateZ") {
        if (props.rotate3d !== void 0) str += `rotate3d(${props.rotate3d}) `;
      }
    }
    if (props.matrix !== void 0) str += `matrix(${props.matrix}) `;
    if (props.matrix3d !== void 0) str += `matrix3d(${props.matrix3d}) `;
    return str;
  };

  // node_modules/animejs/dist/modules/adapters/registry.js
  var adapters2 = (
    /** @type {Adapter[]} */
    []
  );
  function resolveAdapterEntry(target, name) {
    if (!target) return null;
    const al = adapters2.length;
    outer: for (let i = 0; i < al; i++) {
      const a = adapters2[i];
      if (a.detect && !a.detect(target)) continue;
      const tas = a.targetAdapters;
      for (let j = 0, m = tas.length; j < m; j++) {
        const ta = tas[j];
        if (ta.detect(target)) {
          const entry = ta.props[name];
          if (entry && (!entry.gate || entry.gate(target))) return entry;
          break outer;
        }
      }
    }
    for (let i = 0; i < al; i++) {
      const a = adapters2[i];
      if (a.detect && !a.detect(target)) continue;
      const rs = a.propertyResolvers;
      for (let j = 0, m = rs.length; j < m; j++) {
        const entry = rs[j](target, name);
        if (entry) return entry;
      }
    }
    return null;
  }

  // node_modules/animejs/dist/modules/core/colors.js
  var rgbToRgba = (rgbValue) => {
    const rgba = rgbExecRgx.exec(rgbValue) || rgbaExecRgx.exec(rgbValue);
    const a = !isUnd(rgba[4]) ? +rgba[4] : 1;
    return [
      +rgba[1],
      +rgba[2],
      +rgba[3],
      a
    ];
  };
  var hexToRgba = (hexValue) => {
    const hexLength = hexValue.length;
    const isShort = hexLength === 4 || hexLength === 5;
    return [
      +("0x" + hexValue[1] + hexValue[isShort ? 1 : 2]),
      +("0x" + hexValue[isShort ? 2 : 3] + hexValue[isShort ? 2 : 4]),
      +("0x" + hexValue[isShort ? 3 : 5] + hexValue[isShort ? 3 : 6]),
      hexLength === 5 || hexLength === 9 ? +(+("0x" + hexValue[isShort ? 4 : 7] + hexValue[isShort ? 4 : 8]) / 255).toFixed(3) : 1
    ];
  };
  var hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    return t < 1 / 6 ? p + (q - p) * 6 * t : t < 1 / 2 ? q : t < 2 / 3 ? p + (q - p) * (2 / 3 - t) * 6 : p;
  };
  var hslToRgba = (hslValue) => {
    const hsla = hslExecRgx.exec(hslValue) || hslaExecRgx.exec(hslValue);
    const h = +hsla[1] / 360;
    const s = +hsla[2] / 100;
    const l = +hsla[3] / 100;
    const a = !isUnd(hsla[4]) ? +hsla[4] : 1;
    let r, g, b;
    if (s === 0) {
      r = g = b = l;
    } else {
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = round(hue2rgb(p, q, h + 1 / 3) * 255, 0);
      g = round(hue2rgb(p, q, h) * 255, 0);
      b = round(hue2rgb(p, q, h - 1 / 3) * 255, 0);
    }
    return [r, g, b, a];
  };
  var convertColorStringValuesToRgbaArray = (colorString) => {
    return isRgb(colorString) ? rgbToRgba(colorString) : isHex(colorString) ? hexToRgba(colorString) : isHsl(colorString) ? hslToRgba(colorString) : [0, 0, 0, 1];
  };

  // node_modules/animejs/dist/modules/core/values.js
  var setValue = (targetValue, defaultValue) => {
    return isUnd(targetValue) ? defaultValue : targetValue;
  };
  var resolveCssVar = (value, target) => {
    const match = value.match(cssVariableMatchRgx);
    const el = target[isDomSymbol] ? target : document.documentElement;
    let computed = getComputedStyle(
      /** @type {HTMLElement} */
      el
    )?.getPropertyValue(match[1]);
    if ((!computed || computed.trim() === emptyString) && match[2]) computed = match[2].trim();
    return computed || 0;
  };
  var getFunctionValue = (value, target, index, targets, store, prevTween) => {
    if (isFnc(value)) {
      if (!store) {
        const computed = (
          /** @type {Function} */
          value(target, index, targets, prevTween)
        );
        return !isNaN(+computed) ? +computed : computed || 0;
      }
      const func = () => {
        const computed = (
          /** @type {Function} */
          value(target, index, targets, prevTween)
        );
        return !isNaN(+computed) ? +computed : computed || 0;
      };
      store.func = func;
      return func();
    }
    if (isStr(value) && stringStartsWith(value, cssVarPrefix)) {
      if (!store) return resolveCssVar(
        /** @type {String} */
        value,
        target
      );
      const func = () => resolveCssVar(
        /** @type {String} */
        value,
        target
      );
      store.func = func;
      return func();
    }
    return value;
  };
  var getTweenType = (target, prop) => {
    return !target[isDomSymbol] ? tweenTypes.OBJECT : (
      // Handle SVG attributes
      target[isSvgSymbol] && isValidSVGAttribute(target, prop) ? tweenTypes.ATTRIBUTE : (
        // Handle CSS Transform properties differently than CSS to allow individual animations
        validTransforms.includes(prop) || shortTransforms.get(prop) ? tweenTypes.TRANSFORM : (
          // CSS variables
          stringStartsWith(prop, "--") ? tweenTypes.CSS_VAR : (
            // All other CSS properties
            prop in /** @type {DOMTarget} */
            target.style ? tweenTypes.CSS : (
              // Handle other DOM Attributes
              prop in target ? tweenTypes.OBJECT : tweenTypes.ATTRIBUTE
            )
          )
        )
      )
    );
  };
  var getCSSValue = (target, propName, animationInlineStyles) => {
    const inlineStyles = target.style[propName];
    if (inlineStyles && animationInlineStyles) {
      animationInlineStyles[propName] = inlineStyles;
    }
    const value = inlineStyles || getComputedStyle(target[proxyTargetSymbol] || target).getPropertyValue(propName);
    return value === "auto" ? "0" : value;
  };
  var getOriginalAnimatableValue = (target, propName, tweenType, animationInlineStyles) => {
    const type = !isUnd(tweenType) ? tweenType : getTweenType(target, propName);
    const adapterProp = resolveAdapterEntry(target, propName);
    if (adapterProp) {
      const value = adapterProp.get(target);
      if (value && animationInlineStyles) animationInlineStyles[propName] = value;
      return value == null ? 0 : value;
    }
    if (type === tweenTypes.OBJECT) {
      const value = target[propName];
      if (value && animationInlineStyles) animationInlineStyles[propName] = value;
      return value || 0;
    }
    if (type === tweenTypes.ATTRIBUTE) {
      const value = (
        /** @type {DOMTarget} */
        target.getAttribute(propName)
      );
      if (value && animationInlineStyles) animationInlineStyles[propName] = value;
      return value;
    }
    return type === tweenTypes.TRANSFORM ? parseInlineTransforms(
      /** @type {DOMTarget} */
      target,
      propName,
      animationInlineStyles
    ) : type === tweenTypes.CSS_VAR ? getCSSValue(
      /** @type {DOMTarget} */
      target,
      propName,
      animationInlineStyles
    ).trimStart() : getCSSValue(
      /** @type {DOMTarget} */
      target,
      propName,
      animationInlineStyles
    );
  };
  var getRelativeValue = (x, y, operator) => {
    return operator === "-" ? x - y : operator === "+" ? x + y : x * y;
  };
  var createDecomposedValueTargetObject = () => {
    return {
      /** @type {valueTypes} */
      t: valueTypes.NUMBER,
      n: 0,
      u: null,
      o: null,
      d: null,
      s: null
    };
  };
  var decomposeRawValue = (rawValue, targetObject) => {
    targetObject.t = valueTypes.NUMBER;
    targetObject.n = 0;
    targetObject.u = null;
    targetObject.o = null;
    targetObject.d = null;
    targetObject.s = null;
    if (!rawValue) return targetObject;
    const num4 = +rawValue;
    if (!isNaN(num4)) {
      targetObject.n = num4;
      return targetObject;
    }
    let str = (
      /** @type {String} */
      rawValue
    );
    if (str[1] === "=") {
      targetObject.o = str[0];
      str = str.slice(2);
    }
    const unitMatch = str.includes(" ") ? false : unitsExecRgx.exec(str);
    if (unitMatch) {
      targetObject.t = valueTypes.UNIT;
      targetObject.n = +unitMatch[1];
      targetObject.u = unitMatch[2];
      return targetObject;
    } else if (targetObject.o) {
      targetObject.n = +str;
      return targetObject;
    } else if (isCol(str)) {
      targetObject.t = valueTypes.COLOR;
      targetObject.d = convertColorStringValuesToRgbaArray(str);
      return targetObject;
    } else {
      const matchedNumbers = str.match(digitWithExponentRgx);
      targetObject.t = valueTypes.COMPLEX;
      targetObject.d = matchedNumbers ? matchedNumbers.map(Number) : [];
      targetObject.s = str.split(digitWithExponentRgx) || [];
      return targetObject;
    }
  };
  var decomposeTweenValue = (tween, targetObject) => {
    targetObject.t = tween._valueType;
    targetObject.n = tween._toNumber;
    targetObject.u = tween._unit;
    targetObject.o = null;
    targetObject.d = cloneArray(tween._toNumbers);
    targetObject.s = cloneArray(tween._strings);
    return targetObject;
  };
  var decomposedOriginalValue = createDecomposedValueTargetObject();
  var composeComplexValue = (tween, progress, precision) => {
    const mod = tween._modifier;
    const fn = tween._fromNumbers;
    const tn = tween._toNumbers;
    const ts = tween._strings;
    let v = ts[0];
    for (let j = 0, l = tn.length; j < l; j++) {
      const n = (
        /** @type {Number} */
        mod(round(lerp(fn[j], tn[j], progress), precision))
      );
      const s = ts[j + 1];
      v += `${s ? n + s : n}`;
      tween._numbers[j] = n;
    }
    return v;
  };

  // node_modules/animejs/dist/modules/core/render.js
  var render = (tickable, time, muteCallbacks, internalRender, tickMode) => {
    const parent = tickable.parent;
    const duration = tickable.duration;
    const completed = tickable.completed;
    const iterationDuration = tickable.iterationDuration;
    const iterationCount = tickable.iterationCount;
    const _currentIteration = tickable._currentIteration;
    const _loopDelay = tickable._loopDelay;
    const _reversed = tickable._reversed;
    const _alternate = tickable._alternate;
    const _hasChildren = tickable._hasChildren;
    const tickableDelay = tickable._delay;
    const tickablePrevAbsoluteTime = tickable._currentTime;
    const tickableEndTime = tickableDelay + iterationDuration;
    const tickableAbsoluteTime = time - tickableDelay;
    const tickablePrevTime = clamp(tickablePrevAbsoluteTime, -tickableDelay, duration);
    const tickableCurrentTime = clamp(tickableAbsoluteTime, -tickableDelay, duration);
    const deltaTime = tickableAbsoluteTime - tickablePrevAbsoluteTime;
    const isCurrentTimeAboveZero = tickableCurrentTime > 0;
    const isCurrentTimeEqualOrAboveDuration = tickableCurrentTime >= duration;
    const isSetter = duration <= minValue;
    const forcedTick = tickMode === tickModes.FORCE;
    let isOdd = 0;
    let iterationElapsedTime = tickableAbsoluteTime;
    let hasRendered = 0;
    if (iterationCount > 1) {
      const period = iterationDuration + (isCurrentTimeEqualOrAboveDuration ? 0 : _loopDelay);
      const currentIteration = ~~(tickableCurrentTime / period);
      tickable._currentIteration = clamp(currentIteration, 0, iterationCount);
      if (isCurrentTimeEqualOrAboveDuration) tickable._currentIteration--;
      isOdd = tickable._currentIteration % 2;
      iterationElapsedTime = tickableCurrentTime - currentIteration * period || 0;
    }
    const isReversed = _reversed ^ (_alternate && isOdd);
    const _ease = (
      /** @type {Renderable} */
      tickable._ease
    );
    let iterationTime = isCurrentTimeEqualOrAboveDuration ? isReversed ? 0 : duration : isReversed ? iterationDuration - iterationElapsedTime : iterationElapsedTime;
    if (_ease) iterationTime = iterationDuration * _ease(iterationTime / iterationDuration) || 0;
    const isRunningBackwards = (parent ? parent.backwards : tickableAbsoluteTime < tickablePrevAbsoluteTime) ? !isReversed : !!isReversed;
    tickable._currentTime = tickableAbsoluteTime;
    tickable._iterationTime = iterationTime;
    tickable.backwards = isRunningBackwards;
    if (isCurrentTimeAboveZero && !tickable.began) {
      tickable.began = true;
      if (!muteCallbacks && !(parent && (isRunningBackwards || !parent.began))) {
        tickable.onBegin(
          /** @type {CallbackArgument} */
          tickable
        );
      }
    } else if (tickableAbsoluteTime <= 0) {
      tickable.began = false;
    }
    if (!muteCallbacks && !_hasChildren && isCurrentTimeAboveZero && tickable._currentIteration !== _currentIteration) {
      tickable.onLoop(
        /** @type {CallbackArgument} */
        tickable
      );
    }
    if (forcedTick || tickMode === tickModes.AUTO && // Timeline children render from their offset instead of their delay so the gap left by a truncated sibling is covered on seek.
    (time >= (parent && tickableDelay > 0 ? 0 : tickableDelay) && time <= tickableEndTime || // Normal render
    time <= tickableDelay && tickablePrevTime > tickableDelay || // Playhead is before the animation start time so make sure the animation is at its initial state
    time >= tickableEndTime && tickablePrevTime !== duration) || iterationTime >= tickableEndTime && tickablePrevTime !== duration || // iterationTime is per-iteration, compared to the delay to catch a backward seek into a looped iteration's delay region. Exclude the final settled end, where iterationTime clamps to duration and would falsely match the delay region when the delay exceeds the duration.
    iterationTime <= tickableDelay && tickablePrevTime > 0 && !isCurrentTimeEqualOrAboveDuration || time <= tickablePrevTime && tickablePrevTime === duration && completed || // Force a render if a seek occurs on an completed animation
    isCurrentTimeEqualOrAboveDuration && !completed && isSetter) {
      if (isCurrentTimeAboveZero) {
        tickable.computeDeltaTime(tickablePrevTime);
        if (!muteCallbacks) tickable.onBeforeUpdate(
          /** @type {CallbackArgument} */
          tickable
        );
      }
      if (!_hasChildren) {
        const forcedRender = forcedTick || (isRunningBackwards ? deltaTime * -1 : deltaTime) >= globals.tickThreshold;
        const absoluteTime = round(tickable._offset + (parent ? parent._offset : 0) + tickableDelay + iterationTime, 12);
        let tween = (
          /** @type {Tween} */
          /** @type {JSAnimation} */
          tickable._head
        );
        let tweenTarget;
        let tweenStyle;
        let tweenTargetTransforms;
        let tweenTargetTransformsProperties;
        let tweenTransformsNeedUpdate = 0;
        while (tween) {
          const tweenComposition = tween._composition;
          const tweenCurrentTime = tween._currentTime;
          const tweenChangeDuration = tween._changeDuration;
          const tweenAbsEndTime = tween._absoluteStartTime + tween._changeDuration;
          const tweenNextRep = tween._nextRep;
          const tweenPrevRep = tween._prevRep;
          const tweenHasComposition = tweenComposition !== compositionTypes.none;
          const tweenPrevRepEndTime = tweenPrevRep ? tweenPrevRep._absoluteStartTime + tweenPrevRep._changeDuration : 0;
          const tweenPrevRepIsCrossParent = tweenPrevRep && tweenPrevRep.parent !== tween.parent;
          const tweenNextRepTakeover = !tweenNextRep || tweenNextRep._isOverridden ? tweenAbsEndTime : tweenNextRep.parent === tween.parent ? tweenAbsEndTime + tweenNextRep._delay : tweenNextRep._absoluteStartTime < tweenNextRep._absoluteUpdateStartTime ? tweenNextRep._absoluteStartTime : tweenNextRep._absoluteUpdateStartTime;
          if ((forcedRender || // Tail keyframes always re-evaluate the gate so an earlier keyframe cannot leave the target stale by writing past its own range after a backward seek.
          (tweenCurrentTime !== tweenChangeDuration || absoluteTime <= tweenNextRepTakeover || tweenPrevRep && !tweenPrevRepIsCrossParent && (!tweenNextRep || tweenNextRep.parent !== tween.parent)) && // A cross parent tween re-renders its from value from the previous sibling truncated end so the handoff gap holds.
          // A keyframe re-renders its from revert while the next keyframe time is stale so a backward jump over its range cannot leave the next value in place.
          (tweenCurrentTime !== 0 || absoluteTime >= tween._absoluteStartTime || tweenPrevRepIsCrossParent && !tween._hasFromValue && !tweenPrevRep._isOverridden && absoluteTime >= tweenPrevRepEndTime || tweenNextRep && !tweenNextRep._isOverridden && tweenNextRep.parent === tween.parent && tweenNextRep._currentTime !== 0 && iterationTime < tweenNextRep._startTime)) && // Non-first keyframes wait until the iteration reaches their own start before rendering, so the previous keyframe can handle the from-revert when scrubbed backward past this tween's range.
          (!tweenPrevRep || tweenPrevRepIsCrossParent || iterationTime >= tween._startTime) && (!tweenHasComposition || !tween._isOverridden && (!tween._isOverlapped || absoluteTime <= tweenAbsEndTime) && // The next sibling owns the value past its takeover point, so yielding there keeps writes single owner in both directions.
          (!tweenNextRep || tweenNextRep._isOverridden || absoluteTime <= tweenNextRepTakeover) && // The previous sibling owns the value up to its truncated end.
          // Cross parent tweens take over the hold from that point, explicit from values wait for their own start.
          (!tweenPrevRep || (tweenPrevRep._isOverridden || (!tweenPrevRepIsCrossParent ? absoluteTime >= tweenPrevRepEndTime + tween._delay : absoluteTime >= tween._absoluteStartTime || !tween._hasFromValue && absoluteTime >= tweenPrevRepEndTime))))) {
            const tweenNewTime = tween._currentTime = clamp(iterationTime - tween._startTime, 0, tweenChangeDuration);
            const tweenProgress = tween._ease(tweenNewTime / tween._updateDuration);
            const tweenModifier = tween._modifier;
            const tweenValueType = tween._valueType;
            const tweenType = tween._tweenType;
            const tweenIsObject = tweenType === tweenTypes.OBJECT;
            const tweenIsNumber = tweenValueType === valueTypes.NUMBER;
            const tweenPrecision = tweenIsNumber && tweenIsObject || tweenProgress === 0 || tweenProgress === 1 ? -1 : globals.precision;
            let value;
            let number;
            if (tweenIsNumber) {
              value = number = /** @type {Number} */
              tweenModifier(round(lerp(tween._fromNumber, tween._toNumber, tweenProgress), tweenPrecision));
            } else if (tweenValueType === valueTypes.UNIT) {
              number = /** @type {Number} */
              tweenModifier(round(lerp(tween._fromNumber, tween._toNumber, tweenProgress), tweenPrecision));
              value = `${number}${tween._unit}`;
            } else if (tweenValueType === valueTypes.COLOR) {
              const ns = tween._numbers;
              const fn = tween._fromNumbers;
              const tn = tween._toNumbers;
              const omt = 1 - tweenProgress;
              const fr = fn[0], fg = fn[1], fb = fn[2];
              const tr = tn[0], tg = tn[1], tb = tn[2];
              ns[0] = /** @type {Number} */
              tweenModifier(Math.sqrt(fr * fr * omt + tr * tr * tweenProgress));
              ns[1] = /** @type {Number} */
              tweenModifier(Math.sqrt(fg * fg * omt + tg * tg * tweenProgress));
              ns[2] = /** @type {Number} */
              tweenModifier(Math.sqrt(fb * fb * omt + tb * tb * tweenProgress));
              ns[3] = /** @type {Number} */
              tweenModifier(lerp(fn[3], tn[3], tweenProgress));
              if (!tween._setter || internalRender) {
                value = `rgba(${round(ns[0], 0)},${round(ns[1], 0)},${round(ns[2], 0)},${ns[3]})`;
              }
            } else if (tweenValueType === valueTypes.COMPLEX) {
              value = composeComplexValue(tween, tweenProgress, tweenPrecision);
            }
            if (tweenHasComposition) {
              tween._number = number;
            }
            if (!internalRender && tweenComposition !== compositionTypes.blend) {
              const tweenProperty = tween.property;
              tweenTarget = tween.target;
              if (tween._setter) {
                tween._setter(tweenTarget, number, tween);
              } else if (tweenIsObject) {
                tweenTarget[tweenProperty] = value;
              } else if (tweenType === tweenTypes.ATTRIBUTE) {
                tweenTarget.setAttribute(
                  tweenProperty,
                  /** @type {String} */
                  value
                );
              } else {
                tweenStyle = /** @type {DOMTarget} */
                tweenTarget.style;
                if (tweenType === tweenTypes.TRANSFORM) {
                  if (tweenTarget !== tweenTargetTransforms) {
                    tweenTargetTransforms = tweenTarget;
                    tweenTargetTransformsProperties = tweenTarget[transformsSymbol];
                  }
                  tweenTargetTransformsProperties[tweenProperty] = value;
                  tweenTransformsNeedUpdate = 1;
                } else if (tweenType === tweenTypes.CSS) {
                  tweenStyle[tweenProperty] = value;
                } else if (tweenType === tweenTypes.CSS_VAR) {
                  tweenStyle.setProperty(
                    tweenProperty,
                    /** @type {String} */
                    value
                  );
                }
              }
              if (isCurrentTimeAboveZero) hasRendered = 1;
            } else {
              tween._value = value;
            }
          } else if (tweenCurrentTime && tweenPrevRep && !tweenPrevRepIsCrossParent && iterationTime < tween._startTime) {
            tween._currentTime = 0;
          }
          if (tweenTransformsNeedUpdate && tween._renderTransforms) {
            tweenStyle.transform = buildTransformString(tweenTargetTransformsProperties);
            tweenTransformsNeedUpdate = 0;
          }
          tween = tween._next;
        }
        if (!muteCallbacks && hasRendered) {
          tickable.onRender(
            /** @type {JSAnimation} */
            tickable
          );
        }
      }
      if (!muteCallbacks && isCurrentTimeAboveZero) {
        tickable.onUpdate(
          /** @type {CallbackArgument} */
          tickable
        );
      }
    }
    if (parent && isSetter) {
      if (!muteCallbacks && // (tickableAbsoluteTime > 0 instead) of (tickableAbsoluteTime >= duration) to prevent floating point precision issues
      // see: https://github.com/juliangarnier/anime/issues/1088
      (parent.began && !isRunningBackwards && tickableAbsoluteTime > 0 && !completed || isRunningBackwards && tickableAbsoluteTime <= minValue && completed)) {
        tickable.onComplete(
          /** @type {CallbackArgument} */
          tickable
        );
        tickable.completed = !isRunningBackwards;
      }
    } else if (isCurrentTimeAboveZero && isCurrentTimeEqualOrAboveDuration) {
      if (iterationCount === Infinity) {
        tickable._startTime += tickable.duration;
      } else if (tickable._currentIteration >= iterationCount - 1) {
        tickable.paused = true;
        if (!completed && !_hasChildren) {
          tickable.completed = true;
          if (!muteCallbacks && !(parent && (isRunningBackwards || !parent.began))) {
            tickable.onComplete(
              /** @type {CallbackArgument} */
              tickable
            );
            tickable._resolve(
              /** @type {CallbackArgument} */
              tickable
            );
          }
        }
      }
    } else {
      tickable.completed = false;
    }
    return hasRendered;
  };
  var tick = (tickable, time, muteCallbacks, internalRender, tickMode) => {
    const _currentIteration = tickable._currentIteration;
    render(tickable, time, muteCallbacks, internalRender, tickMode);
    if (tickable._hasChildren) {
      const tl = (
        /** @type {Timeline} */
        tickable
      );
      const tlIsRunningBackwards = tl.backwards;
      const tlChildrenTime = internalRender ? time : tl._iterationTime;
      const tlCildrenTickTime = now();
      let tlChildrenHasRendered = 0;
      let tlChildrenHaveCompleted = true;
      if (!internalRender && tl._currentIteration !== _currentIteration) {
        const tlIterationDuration = tl.iterationDuration;
        forEachChildren(tl, (child) => {
          if (!tlIsRunningBackwards) {
            if (!child.completed && !child.backwards && child._currentTime < child.iterationDuration) {
              render(child, tlIterationDuration, muteCallbacks, 1, tickModes.FORCE);
            }
            child.began = false;
            child.completed = false;
          } else {
            const childDuration = child.duration;
            const childStartTime = child._offset + child._delay;
            const childEndTime = childStartTime + childDuration;
            if (!muteCallbacks && childDuration <= minValue && (!childStartTime || childEndTime === tlIterationDuration)) {
              child.onComplete(child);
            }
          }
        });
        if (!muteCallbacks) tl.onLoop(
          /** @type {CallbackArgument} */
          tl
        );
      }
      forEachChildren(tl, (child) => {
        const childTime = round((tlChildrenTime - child._offset) * child._speed, 12);
        if (tlIsRunningBackwards && childTime > child._delay + child.duration) return;
        const childTickMode = child._fps < tl._fps ? child.requestTick(tlCildrenTickTime) : tickMode;
        tlChildrenHasRendered += render(child, childTime, muteCallbacks, internalRender, childTickMode);
        if (!child.completed && tlChildrenHaveCompleted) tlChildrenHaveCompleted = false;
      }, tlIsRunningBackwards);
      if (!muteCallbacks && tlChildrenHasRendered) tl.onRender(
        /** @type {CallbackArgument} */
        tl
      );
      if ((tlChildrenHaveCompleted || tlIsRunningBackwards) && tl._currentTime >= tl.duration) {
        tl.paused = true;
        if (!tl.completed) {
          tl.completed = true;
          if (!muteCallbacks) {
            tl.onComplete(
              /** @type {CallbackArgument} */
              tl
            );
            tl._resolve(
              /** @type {CallbackArgument} */
              tl
            );
          }
        }
      }
    }
  };

  // node_modules/animejs/dist/modules/core/styles.js
  var propertyNamesCache = {};
  var sanitizePropertyName = (propertyName, target, tweenType) => {
    if (tweenType === tweenTypes.TRANSFORM) {
      const t = shortTransforms.get(propertyName);
      return t ? t : propertyName;
    } else if (tweenType === tweenTypes.CSS || // Handle special cases where properties like "strokeDashoffset" needs to be set as "stroke-dashoffset"
    // but properties like "baseFrequency" should stay in lowerCamelCase
    tweenType === tweenTypes.ATTRIBUTE && (isSvg(target) && propertyName in /** @type {DOMTarget} */
    target.style)) {
      const cachedPropertyName = propertyNamesCache[propertyName];
      if (cachedPropertyName) {
        return cachedPropertyName;
      } else {
        const lowerCaseName = propertyName ? toLowerCase(propertyName) : propertyName;
        propertyNamesCache[propertyName] = lowerCaseName;
        return lowerCaseName;
      }
    } else {
      return propertyName;
    }
  };
  var revertValues = (renderable, inlineStylesOnly = false) => {
    if (renderable._hasChildren) {
      forEachChildren(renderable, (child) => revertValues(child, inlineStylesOnly), true);
    } else {
      const animation = (
        /** @type {JSAnimation} */
        renderable
      );
      animation.pause();
      forEachChildren(animation, (tween) => {
        const tweenProperty = tween.property;
        const tweenTarget = tween.target;
        const tweenType = tween._tweenType;
        const originalInlinedValue = tween._inlineValue;
        const tweenHadNoInlineValue = isNil(originalInlinedValue) || originalInlinedValue === emptyString;
        if (tween._setter) {
          if (!inlineStylesOnly && !tweenHadNoInlineValue) {
            decomposeRawValue(originalInlinedValue, decomposedOriginalValue);
            if (decomposedOriginalValue.d) {
              const src = decomposedOriginalValue.d;
              const dst = tween._numbers;
              for (let i = 0, l = src.length; i < l; i++) dst[i] = src[i];
            } else {
              tween._number = decomposedOriginalValue.n;
            }
            tween._setter(tween.target, tween._number, tween);
          }
        } else if (tweenType === tweenTypes.OBJECT) {
          if (!inlineStylesOnly && !tweenHadNoInlineValue) {
            tweenTarget[tweenProperty] = originalInlinedValue;
          }
        } else if (tweenTarget[isDomSymbol]) {
          if (tweenType === tweenTypes.ATTRIBUTE) {
            if (!inlineStylesOnly) {
              if (tweenHadNoInlineValue) {
                tweenTarget.removeAttribute(tweenProperty);
              } else {
                tweenTarget.setAttribute(
                  tweenProperty,
                  /** @type {String} */
                  originalInlinedValue
                );
              }
            }
          } else {
            const targetStyle = (
              /** @type {DOMTarget} */
              tweenTarget.style
            );
            if (tweenType === tweenTypes.TRANSFORM) {
              const cachedTransforms = tweenTarget[transformsSymbol];
              if (tweenHadNoInlineValue) {
                delete cachedTransforms[tweenProperty];
              } else {
                cachedTransforms[tweenProperty] = originalInlinedValue;
              }
              if (tween._renderTransforms) {
                if (!Object.keys(cachedTransforms).length) {
                  targetStyle.removeProperty("transform");
                } else {
                  targetStyle.transform = buildTransformString(cachedTransforms);
                }
              }
            } else {
              if (tweenHadNoInlineValue) {
                targetStyle.removeProperty(toLowerCase(tweenProperty));
              } else {
                targetStyle[tweenProperty] = originalInlinedValue;
              }
            }
          }
        }
        if (tweenTarget[isDomSymbol] && animation._tail === tween) {
          animation.targets.forEach((t) => {
            if (t.getAttribute && t.getAttribute("style") === emptyString) {
              t.removeAttribute("style");
            }
          });
        }
      });
    }
    return renderable;
  };

  // node_modules/animejs/dist/modules/core/clock.js
  var Clock = class {
    /** @param {Number} [initTime] */
    constructor(initTime = 0) {
      this.deltaTime = 0;
      this._currentTime = initTime;
      this._lastTickTime = initTime;
      this._startTime = initTime;
      this._lastTime = initTime;
      this._frameDuration = K / maxFps;
      this._fps = maxFps;
      this._speed = 1;
      this._hasChildren = false;
      this._head = null;
      this._tail = null;
    }
    get fps() {
      return this._fps;
    }
    set fps(frameRate) {
      const fr = +frameRate;
      const fps = fr < minValue ? minValue : fr;
      const frameDuration = K / fps;
      if (fps > defaults.frameRate) defaults.frameRate = fps;
      this._fps = fps;
      this._frameDuration = frameDuration;
    }
    get speed() {
      return this._speed;
    }
    set speed(playbackRate) {
      const pbr = +playbackRate;
      this._speed = pbr < minValue ? minValue : pbr;
    }
    /**
     * @param  {Number} time
     * @return {tickModes}
     */
    requestTick(time) {
      const frameDuration = this._frameDuration;
      const elapsed = time - this._lastTickTime;
      const scaled = frameDuration * 0.25;
      const tolerance = scaled < 4 ? scaled : 4;
      if (elapsed + tolerance < frameDuration) return tickModes.NONE;
      this._lastTickTime = elapsed >= frameDuration ? time - elapsed % frameDuration : time;
      return tickModes.AUTO;
    }
    /**
     * @param  {Number} time
     * @return {Number}
     */
    computeDeltaTime(time) {
      const delta = time - this._lastTime;
      this.deltaTime = delta;
      this._lastTime = time;
      return delta;
    }
  };

  // node_modules/animejs/dist/modules/animation/additive.js
  var additive = {
    animation: null,
    update: noop
  };
  var addAdditiveAnimation = (lookups2) => {
    let animation = additive.animation;
    if (!animation) {
      animation = {
        duration: minValue,
        computeDeltaTime: noop,
        _offset: 0,
        _delay: 0,
        _head: null,
        _tail: null
      };
      additive.animation = animation;
      additive.update = () => {
        lookups2.forEach((propertyAnimation) => {
          for (let propertyName in propertyAnimation) {
            const tweens = propertyAnimation[propertyName];
            const lookupTween = tweens._head;
            if (lookupTween) {
              const valueType = lookupTween._valueType;
              const additiveValues = valueType === valueTypes.COMPLEX || valueType === valueTypes.COLOR ? cloneArray(lookupTween._fromNumbers) : null;
              let additiveValue = lookupTween._fromNumber;
              let tween = tweens._tail;
              while (tween && tween !== lookupTween) {
                if (additiveValues) {
                  for (let i = 0, l = tween._numbers.length; i < l; i++) additiveValues[i] += tween._numbers[i];
                } else {
                  additiveValue += tween._number;
                }
                tween = tween._prevAdd;
              }
              lookupTween._toNumber = additiveValue;
              lookupTween._toNumbers = additiveValues;
            }
          }
        });
        render(animation, 1, 1, 0, tickModes.FORCE);
      };
    }
    return animation;
  };

  // node_modules/animejs/dist/modules/engine/engine.js
  var engineTickMethod = /* @__PURE__ */ (() => isBrowser ? requestAnimationFrame : setImmediate)();
  var engineCancelMethod = /* @__PURE__ */ (() => isBrowser ? cancelAnimationFrame : clearImmediate)();
  var Engine = class extends Clock {
    /** @param {Number} [initTime] */
    constructor(initTime) {
      super(initTime);
      this.useDefaultMainLoop = true;
      this.pauseOnDocumentHidden = true;
      this.defaults = defaults;
      this.paused = true;
      this.reqId = 0;
    }
    update() {
      const time = this._currentTime = now();
      if (this.requestTick(time)) {
        this.computeDeltaTime(time);
        const engineSpeed = this._speed;
        const engineFps = this._fps;
        let activeTickable = (
          /** @type {Tickable} */
          this._head
        );
        while (activeTickable) {
          const nextTickable = activeTickable._next;
          if (!activeTickable.paused) {
            tick(
              activeTickable,
              (time - activeTickable._startTime) * activeTickable._speed * engineSpeed,
              0,
              // !muteCallbacks
              0,
              // !internalRender
              activeTickable._fps < engineFps ? activeTickable.requestTick(time) : tickModes.AUTO
            );
          } else {
            removeChild(this, activeTickable);
            this._hasChildren = !!this._tail;
            activeTickable._running = false;
            if (activeTickable.completed && !activeTickable._cancelled) {
              activeTickable.cancel();
            }
          }
          activeTickable = nextTickable;
        }
        additive.update();
      }
    }
    wake() {
      if (this.useDefaultMainLoop && !this.reqId) {
        this.requestTick(now());
        this.reqId = engineTickMethod(tickEngine);
      }
      return this;
    }
    pause() {
      if (!this.reqId) return;
      this.paused = true;
      return killEngine();
    }
    resume() {
      if (!this.paused) return;
      this.paused = false;
      forEachChildren(this, (child) => child.resetTime());
      return this.wake();
    }
    // Getter and setter for speed
    get speed() {
      return this._speed * (globals.timeScale === 1 ? 1 : K);
    }
    set speed(playbackRate) {
      const speed = playbackRate * globals.timeScale;
      if (this._speed === speed) return;
      this._speed = speed;
      forEachChildren(this, (child) => child.speed = child._speed);
    }
    // Getter and setter for timeUnit
    get timeUnit() {
      return globals.timeScale === 1 ? "ms" : "s";
    }
    set timeUnit(unit) {
      const secondsScale = 1e-3;
      const isSecond = unit === "s";
      const newScale = isSecond ? secondsScale : 1;
      if (globals.timeScale !== newScale) {
        globals.timeScale = newScale;
        globals.tickThreshold = 200 * newScale;
        const scaleFactor = isSecond ? secondsScale : K;
        this.defaults.duration *= scaleFactor;
        this._speed *= scaleFactor;
      }
    }
    // Getter and setter for precision
    get precision() {
      return globals.precision;
    }
    set precision(precision) {
      globals.precision = precision;
    }
  };
  var engine = /* @__PURE__ */ (() => {
    const engine2 = new Engine(now());
    if (isBrowser) {
      globalVersions.engine = engine2;
      doc.addEventListener("visibilitychange", () => {
        if (!engine2.pauseOnDocumentHidden) return;
        doc.hidden ? engine2.pause() : engine2.resume();
      });
    }
    return engine2;
  })();
  var tickEngine = () => {
    if (engine._head) {
      engine.reqId = engineTickMethod(tickEngine);
      engine.update();
    } else {
      engine.reqId = 0;
    }
  };
  var killEngine = () => {
    engineCancelMethod(
      /** @type {NodeJS.Immediate & Number} */
      engine.reqId
    );
    engine.reqId = 0;
    return engine;
  };

  // node_modules/animejs/dist/modules/animation/composition.js
  var lookups = {
    /** @type {TweenReplaceLookups} */
    _rep: /* @__PURE__ */ new WeakMap(),
    /** @type {TweenAdditiveLookups} */
    _add: /* @__PURE__ */ new Map()
  };
  var getTweenSiblings = (target, property, lookup = "_rep") => {
    const lookupMap = lookups[lookup];
    let targetLookup = lookupMap.get(target);
    if (!targetLookup) {
      targetLookup = {};
      lookupMap.set(target, targetLookup);
    }
    return targetLookup[property] ? targetLookup[property] : targetLookup[property] = {
      _head: null,
      _tail: null
    };
  };
  var addTweenSortMethod = (p, c) => {
    return p._isOverridden || p._absoluteStartTime > c._absoluteStartTime;
  };
  var overrideTween = (tween) => {
    tween._isOverlapped = 1;
    tween._isOverridden = 1;
    tween._changeDuration = minValue;
    tween._currentTime = minValue;
  };
  var composeTween = (tween, siblings) => {
    const tweenCompositionType = tween._composition;
    if (tweenCompositionType === compositionTypes.replace) {
      const tweenAbsStartTime = tween._absoluteStartTime;
      addChild(siblings, tween, addTweenSortMethod, "_prevRep", "_nextRep");
      const prevSibling = tween._prevRep;
      if (prevSibling) {
        const prevParent = prevSibling.parent;
        const prevAbsEndTime = prevSibling._absoluteEndTime;
        if (
          // Check if the previous tween is from a different animation
          tween.parent.id !== prevParent.id && // Check if the animation has loops
          prevParent.iterationCount > 1 && // Check if _absoluteChangeEndTime of last loop overlaps the current tween
          prevAbsEndTime + (prevParent.duration - prevParent.iterationDuration) > tweenAbsStartTime
        ) {
          overrideTween(prevSibling);
          let prevPrevSibling = prevSibling._prevRep;
          while (prevPrevSibling && prevPrevSibling.parent.id === prevParent.id) {
            overrideTween(prevPrevSibling);
            prevPrevSibling = prevPrevSibling._prevRep;
          }
        }
        const absoluteUpdateStartTime = tween._absoluteUpdateStartTime;
        if (prevAbsEndTime > absoluteUpdateStartTime) {
          const prevChangeStartTime = prevSibling._startTime;
          const prevTLOffset = prevAbsEndTime - (prevChangeStartTime + prevSibling._updateDuration);
          const updatedPrevChangeDuration = round(absoluteUpdateStartTime - prevTLOffset - prevChangeStartTime, 12);
          prevSibling._changeDuration = updatedPrevChangeDuration;
          prevSibling._currentTime = updatedPrevChangeDuration;
          prevSibling._isOverlapped = 1;
          if (updatedPrevChangeDuration < minValue) {
            overrideTween(prevSibling);
          }
        }
        const tweenParentTL = tween.parent.parent;
        if (!tweenParentTL || tweenParentTL !== prevParent.parent) {
          let pausePrevParentAnimation = true;
          forEachChildren(prevParent, (t) => {
            if (!t._isOverlapped) pausePrevParentAnimation = false;
          });
          if (pausePrevParentAnimation) {
            const prevParentTL = prevParent.parent;
            if (prevParentTL) {
              let pausePrevParentTL = true;
              forEachChildren(prevParentTL, (a) => {
                if (a !== prevParent) {
                  forEachChildren(a, (t) => {
                    if (!t._isOverlapped) pausePrevParentTL = false;
                  });
                }
              });
              if (pausePrevParentTL) {
                prevParentTL.cancel();
              }
            } else {
              prevParent.cancel();
            }
          }
        }
      }
    } else if (tweenCompositionType === compositionTypes.blend) {
      const additiveTweenSiblings = getTweenSiblings(tween.target, tween.property, "_add");
      const additiveAnimation = addAdditiveAnimation(lookups._add);
      let lookupTween = additiveTweenSiblings._head;
      if (!lookupTween) {
        lookupTween = { ...tween };
        lookupTween._composition = compositionTypes.replace;
        lookupTween._updateDuration = minValue;
        lookupTween._startTime = 0;
        lookupTween._numbers = cloneArray(tween._fromNumbers);
        lookupTween._number = 0;
        lookupTween._next = null;
        lookupTween._prev = null;
        addChild(additiveTweenSiblings, lookupTween);
        addChild(additiveAnimation, lookupTween);
      }
      const toNumber = tween._toNumber;
      tween._fromNumber = lookupTween._fromNumber - toNumber;
      tween._toNumber = 0;
      tween._numbers = cloneArray(tween._fromNumbers);
      tween._number = 0;
      lookupTween._fromNumber = toNumber;
      if (tween._toNumbers.length) {
        const toNumbers = cloneArray(tween._toNumbers);
        toNumbers.forEach((value, i) => {
          tween._fromNumbers[i] = lookupTween._fromNumbers[i] - value;
          tween._toNumbers[i] = 0;
        });
        lookupTween._fromNumbers = toNumbers;
      }
      addChild(additiveTweenSiblings, tween, null, "_prevAdd", "_nextAdd");
    }
    return tween;
  };
  var removeTweenSliblings = (tween) => {
    const tweenComposition = tween._composition;
    if (tweenComposition !== compositionTypes.none) {
      const tweenTarget = tween.target;
      const tweenProperty = tween.property;
      const replaceTweensLookup = lookups._rep;
      const replaceTargetProps = replaceTweensLookup.get(tweenTarget);
      const tweenReplaceSiblings = replaceTargetProps[tweenProperty];
      removeChild(tweenReplaceSiblings, tween, "_prevRep", "_nextRep");
      if (tweenComposition === compositionTypes.blend) {
        const addTweensLookup = lookups._add;
        const addTargetProps = addTweensLookup.get(tweenTarget);
        if (!addTargetProps) return;
        const additiveTweenSiblings = addTargetProps[tweenProperty];
        const additiveAnimation = additive.animation;
        removeChild(additiveTweenSiblings, tween, "_prevAdd", "_nextAdd");
        const lookupTween = additiveTweenSiblings._head;
        if (lookupTween && lookupTween === additiveTweenSiblings._tail) {
          removeChild(additiveTweenSiblings, lookupTween, "_prevAdd", "_nextAdd");
          removeChild(additiveAnimation, lookupTween);
          let shouldClean = true;
          for (let prop in addTargetProps) {
            if (addTargetProps[prop]._head) {
              shouldClean = false;
              break;
            }
          }
          if (shouldClean) {
            addTweensLookup.delete(tweenTarget);
          }
        }
      }
    }
    return tween;
  };
  var removeTargetsFromJSAnimation = (targetsArray, animation, propertyName) => {
    let tweensMatchesTargets = false;
    forEachChildren(animation, (tween) => {
      const tweenTarget = tween.target;
      if (targetsArray.includes(tweenTarget)) {
        const tweenName = tween.property;
        const tweenType = tween._tweenType;
        const normalizePropName = sanitizePropertyName(propertyName, tweenTarget, tweenType);
        if (!normalizePropName || normalizePropName && normalizePropName === tweenName) {
          if (tween.parent._tail === tween && tween._tweenType === tweenTypes.TRANSFORM && tween._prev && tween._prev._tweenType === tweenTypes.TRANSFORM) {
            tween._prev._renderTransforms = 1;
          }
          removeChild(animation, tween);
          removeTweenSliblings(tween);
          tweensMatchesTargets = true;
        }
      }
    }, true);
    return tweensMatchesTargets;
  };
  var removeTargetsFromRenderable = (targetsArray, renderable, propertyName) => {
    const parent = (
      /** @type {Renderable|typeof engine} **/
      renderable ? renderable : engine
    );
    let removeMatches;
    if (parent._hasChildren) {
      let iterationDuration = 0;
      forEachChildren(parent, (child) => {
        if (!child._hasChildren) {
          removeMatches = removeTargetsFromJSAnimation(
            targetsArray,
            /** @type {JSAnimation} */
            child,
            propertyName
          );
          if (removeMatches && !child._head) {
            child.cancel();
            removeChild(parent, child);
          } else {
            const childTLOffset = child._offset + child._delay;
            const childDur = childTLOffset + child.duration;
            if (childDur > iterationDuration) {
              iterationDuration = childDur;
            }
          }
        }
        if (child._head) {
          removeTargetsFromRenderable(targetsArray, child, propertyName);
        } else {
          child._hasChildren = false;
        }
      }, true);
      if (!isUnd(
        /** @type {Renderable} */
        parent.iterationDuration
      )) {
        parent.iterationDuration = iterationDuration;
      }
    } else {
      removeMatches = removeTargetsFromJSAnimation(
        targetsArray,
        /** @type {JSAnimation} */
        parent,
        propertyName
      );
    }
    if (removeMatches && !parent._head) {
      parent._hasChildren = false;
      if (
        /** @type {Renderable} */
        parent.cancel
      ) parent.cancel();
    }
  };

  // node_modules/animejs/dist/modules/timer/timer.js
  var resetTimerProperties = (timer) => {
    timer.paused = true;
    timer.began = false;
    timer.completed = false;
    return timer;
  };
  var reviveTimer = (timer) => {
    if (!timer._cancelled) return timer;
    if (timer._hasChildren) {
      forEachChildren(timer, reviveTimer);
    } else {
      forEachChildren(timer, (tween) => {
        if (tween._composition !== compositionTypes.none) {
          composeTween(tween, getTweenSiblings(tween.target, tween.property));
        }
      });
    }
    timer._cancelled = 0;
    return timer;
  };
  var timerId = 0;
  var sortByPriority = (prev, child) => prev._priority > child._priority;
  var Timer = class extends Clock {
    /**
     * @param {TimerParams} [parameters]
     * @param {Timeline} [parent]
     * @param {Number} [parentPosition]
     */
    constructor(parameters = {}, parent = null, parentPosition = 0) {
      super(0);
      ++timerId;
      const {
        id: id2,
        delay,
        duration,
        reversed,
        alternate,
        loop,
        loopDelay,
        autoplay,
        frameRate,
        playbackRate,
        priority,
        onComplete,
        onLoop,
        onPause,
        onBegin,
        onBeforeUpdate,
        onUpdate
      } = parameters;
      if (scope.current) scope.current.register(this);
      const timerInitTime = parent ? 0 : engine._lastTickTime;
      const timerDefaults = parent ? parent.defaults : globals.defaults;
      const timerDelay = (
        /** @type {Number} */
        isFnc(delay) || isUnd(delay) ? timerDefaults.delay : +delay
      );
      const timerDuration = isFnc(duration) || isUnd(duration) ? Infinity : +duration;
      const timerLoop = setValue(loop, timerDefaults.loop);
      const timerLoopDelay = setValue(loopDelay, timerDefaults.loopDelay);
      let timerIterationCount = timerLoop === true || timerLoop === Infinity || /** @type {Number} */
      timerLoop < 0 ? Infinity : (
        /** @type {Number} */
        timerLoop + 1
      );
      let offsetPosition = 0;
      if (parent) {
        offsetPosition = parentPosition;
      } else {
        if (!engine.reqId) engine.requestTick(now());
        offsetPosition = (engine._lastTickTime - engine._startTime) * globals.timeScale;
      }
      this.id = !isUnd(id2) ? id2 : timerId;
      this.parent = parent;
      this.duration = clampInfinity((timerDuration + timerLoopDelay) * timerIterationCount - timerLoopDelay) || minValue;
      this.backwards = false;
      this.paused = true;
      this.began = false;
      this.completed = false;
      this.onBegin = onBegin || timerDefaults.onBegin;
      this.onBeforeUpdate = onBeforeUpdate || timerDefaults.onBeforeUpdate;
      this.onUpdate = onUpdate || timerDefaults.onUpdate;
      this.onLoop = onLoop || timerDefaults.onLoop;
      this.onPause = onPause || timerDefaults.onPause;
      this.onComplete = onComplete || timerDefaults.onComplete;
      this.iterationDuration = timerDuration;
      this.iterationCount = timerIterationCount;
      this._autoplay = parent ? false : setValue(autoplay, timerDefaults.autoplay);
      this._offset = offsetPosition;
      this._delay = timerDelay;
      this._loopDelay = timerLoopDelay;
      this._iterationTime = 0;
      this._currentIteration = 0;
      this._resolve = noop;
      this._running = false;
      this._reversed = +setValue(reversed, timerDefaults.reversed);
      this._reverse = this._reversed;
      this._cancelled = 0;
      this._alternate = setValue(alternate, timerDefaults.alternate);
      this._prev = null;
      this._next = null;
      this._lastTickTime = timerInitTime;
      this._startTime = timerInitTime;
      this._lastTime = timerInitTime;
      this._fps = setValue(frameRate, timerDefaults.frameRate);
      this._speed = setValue(playbackRate, timerDefaults.playbackRate);
      this._priority = +setValue(priority, 1);
    }
    get cancelled() {
      return !!this._cancelled;
    }
    set cancelled(cancelled) {
      cancelled ? this.cancel() : this.reset(true).play();
    }
    get currentTime() {
      return clamp(round(this._currentTime, globals.precision), -this._delay, this.duration);
    }
    set currentTime(time) {
      const paused = this.paused;
      this.pause().seek(+time);
      if (!paused) this.resume();
    }
    get iterationCurrentTime() {
      return clamp(round(this._iterationTime, globals.precision), 0, this.iterationDuration);
    }
    set iterationCurrentTime(time) {
      this.currentTime = this.iterationDuration * this._currentIteration + time;
    }
    get progress() {
      return clamp(round(this._currentTime / this.duration, 10), 0, 1);
    }
    set progress(progress) {
      this.currentTime = this.duration * progress;
    }
    get iterationProgress() {
      return clamp(round(this._iterationTime / this.iterationDuration, 10), 0, 1);
    }
    set iterationProgress(progress) {
      const iterationDuration = this.iterationDuration;
      this.currentTime = iterationDuration * this._currentIteration + iterationDuration * progress;
    }
    get currentIteration() {
      return this._currentIteration;
    }
    set currentIteration(iterationCount) {
      this.currentTime = this.iterationDuration * clamp(+iterationCount, 0, this.iterationCount - 1);
    }
    get reversed() {
      return !!this._reversed;
    }
    set reversed(reverse) {
      reverse ? this.reverse() : this.play();
    }
    get speed() {
      return super.speed;
    }
    set speed(playbackRate) {
      super.speed = playbackRate;
      this.resetTime();
    }
    /**
     * @param  {Boolean} [softReset]
     * @return {this}
     */
    reset(softReset = false) {
      reviveTimer(this);
      if (this._reversed && !this._reverse) this.reversed = false;
      this._iterationTime = this.iterationDuration;
      tick(this, 0, 1, ~~softReset, tickModes.FORCE);
      resetTimerProperties(this);
      if (this._hasChildren) {
        forEachChildren(this, resetTimerProperties);
      }
      return this;
    }
    /**
     * @param  {Boolean} internalRender
     * @return {this}
     */
    init(internalRender = false) {
      this.fps = this._fps;
      this.speed = this._speed;
      if (!internalRender && this._hasChildren) {
        tick(this, this.duration, 1, ~~internalRender, tickModes.FORCE);
      }
      this.reset(internalRender);
      const autoplay = this._autoplay;
      if (autoplay === true) {
        this.resume();
      } else if (autoplay && !isUnd(
        /** @type {ScrollObserver} */
        autoplay.linked
      )) {
        autoplay.link(this);
      }
      return this;
    }
    /** @return {this} */
    resetTime() {
      const timeScale = 1 / (this._speed * engine._speed);
      this._startTime = now() - (this._currentTime + this._delay) * timeScale;
      return this;
    }
    /** @return {this} */
    pause() {
      if (this.paused) return this;
      this.paused = true;
      this.onPause(this);
      return this;
    }
    /** @return {this} */
    resume() {
      if (!this.paused) return this;
      this.paused = false;
      if (this.duration <= minValue && !this._hasChildren) {
        tick(this, minValue, 0, 0, tickModes.FORCE);
      } else {
        if (!this._running) {
          addChild(engine, this, sortByPriority);
          engine._hasChildren = true;
          this._running = true;
        }
        this.resetTime();
        this._startTime -= 12;
        engine.wake();
      }
      return this;
    }
    /** @return {this} */
    restart() {
      return this.reset().resume();
    }
    /**
     * @param  {Number} time
     * @param  {Boolean|Number} [muteCallbacks]
     * @param  {Boolean|Number} [internalRender]
     * @return {this}
     */
    seek(time, muteCallbacks = 0, internalRender = 0) {
      reviveTimer(this);
      this.completed = false;
      const isPaused = this.paused;
      this.paused = true;
      tick(this, time + this._delay, ~~muteCallbacks, ~~internalRender, tickModes.AUTO);
      return isPaused ? this : this.resume();
    }
    /** @return {this} */
    alternate() {
      const reversed = this._reversed;
      const count = this.iterationCount;
      const duration = this.iterationDuration;
      const iterations = count === Infinity ? floor(maxValue / duration) : count;
      this._reversed = +(this._alternate && !(iterations % 2) ? reversed : !reversed);
      if (count === Infinity) {
        this.iterationProgress = this._reversed ? 1 - this.iterationProgress : this.iterationProgress;
      } else {
        this.seek(duration * iterations - this._currentTime);
      }
      this.resetTime();
      return this;
    }
    /** @return {this} */
    play() {
      if (this._reversed) this.alternate();
      return this.resume();
    }
    /** @return {this} */
    reverse() {
      if (!this._reversed) this.alternate();
      return this.resume();
    }
    // TODO: Move all the animation / tweens / children related code to Animation / Timeline
    /** @return {this} */
    cancel() {
      if (this._hasChildren) {
        forEachChildren(this, (child) => child.cancel(), true);
      } else {
        forEachChildren(this, removeTweenSliblings);
      }
      this._cancelled = 1;
      return this.pause();
    }
    /**
     * @param  {Number} newDuration
     * @return {this}
     */
    stretch(newDuration) {
      const currentDuration = this.duration;
      const normlizedDuration = normalizeTime(newDuration);
      if (currentDuration === normlizedDuration) return this;
      const timeScale = newDuration / currentDuration;
      const isSetter = newDuration <= minValue;
      this.duration = isSetter ? minValue : normlizedDuration;
      this.iterationDuration = isSetter ? minValue : normalizeTime(this.iterationDuration * timeScale);
      this._offset *= timeScale;
      this._delay *= timeScale;
      this._loopDelay *= timeScale;
      return this;
    }
    /**
      * Cancels the timer by seeking it back to 0 and reverting the attached scroller if necessary
      * @return {this}
      */
    revert() {
      tick(this, 0, 1, 0, tickModes.AUTO);
      const ap = (
        /** @type {ScrollObserver} */
        this._autoplay
      );
      if (ap && ap.linked && ap.linked === this) ap.revert();
      return this.cancel();
    }
    /**
      * Imediatly completes the timer, cancels it and triggers the onComplete callback
      * @param  {Boolean|Number} [muteCallbacks]
      * @return {this}
      */
    complete(muteCallbacks = 0) {
      return this.seek(this.duration, muteCallbacks).cancel();
    }
    /**
     * @typedef {this & {then: null}} ResolvedTimer
     */
    /**
     * @param  {Callback<ResolvedTimer>} [callback]
     * @return Promise<this>
     */
    then(callback = noop) {
      const then = this.then;
      const onResolve = () => {
        this.then = null;
        callback(
          /** @type {ResolvedTimer} */
          this
        );
        this.then = then;
        this._resolve = noop;
      };
      return new Promise((r) => {
        this._resolve = () => r(onResolve());
        if (this.completed) this._resolve();
        return this;
      });
    }
  };

  // node_modules/animejs/dist/modules/core/targets.js
  function getNodeList(v) {
    const n = isStr(v) ? scope.root.querySelectorAll(v) : v;
    if (n instanceof NodeList || n instanceof HTMLCollection) return n;
  }
  function parseTargets(targets) {
    if (isNil(targets)) return (
      /** @type {TargetsArray} */
      []
    );
    if (!isBrowser) return (
      /** @type {JSTargetsArray} */
      isArr(targets) && targets.flat(Infinity) || [targets]
    );
    if (isArr(targets)) {
      const flattened = targets.flat(Infinity);
      const parsed = [];
      for (let i = 0, l = flattened.length; i < l; i++) {
        const item = flattened[i];
        if (!isNil(item)) {
          const nodeList2 = getNodeList(item);
          if (nodeList2) {
            for (let j = 0, jl = nodeList2.length; j < jl; j++) {
              const subItem = nodeList2[j];
              if (!isNil(subItem)) {
                let isDuplicate = false;
                for (let k = 0, kl = parsed.length; k < kl; k++) {
                  if (parsed[k] === subItem) {
                    isDuplicate = true;
                    break;
                  }
                }
                if (!isDuplicate) {
                  parsed.push(subItem);
                }
              }
            }
          } else {
            let isDuplicate = false;
            for (let j = 0, jl = parsed.length; j < jl; j++) {
              if (parsed[j] === item) {
                isDuplicate = true;
                break;
              }
            }
            if (!isDuplicate) {
              parsed.push(item);
            }
          }
        }
      }
      return parsed;
    }
    const nodeList = getNodeList(targets);
    if (nodeList) return (
      /** @type {DOMTargetsArray} */
      Array.from(nodeList)
    );
    return (
      /** @type {TargetsArray} */
      [targets]
    );
  }
  function registerTargets(targets) {
    const parsedTargetsArray = parseTargets(targets);
    const parsedTargetsLength = parsedTargetsArray.length;
    for (let i = 0; i < parsedTargetsLength; i++) {
      const target = parsedTargetsArray[i];
      if (!target[isRegisteredTargetSymbol]) {
        target[isRegisteredTargetSymbol] = true;
        const isSvgType = isSvg(target);
        const isDom = (
          /** @type {DOMTarget} */
          target.nodeType || isSvgType
        );
        if (isDom) {
          target[isDomSymbol] = true;
          target[isSvgSymbol] = isSvgType;
          target[transformsSymbol] = {};
        }
      }
    }
    return parsedTargetsArray;
  }

  // node_modules/animejs/dist/modules/core/units.js
  var angleUnitsMap = { "deg": 1, "rad": 180 / PI, "turn": 360 };
  var convertedValuesCache = {};
  var convertValueUnit = (el, decomposedValue, unit, force = false) => {
    const currentUnit = decomposedValue.u;
    const currentNumber = decomposedValue.n;
    if (decomposedValue.t === valueTypes.UNIT && currentUnit === unit) {
      return decomposedValue;
    }
    const cachedKey = currentNumber + currentUnit + unit;
    const cached = convertedValuesCache[cachedKey];
    if (!isUnd(cached) && !force) {
      decomposedValue.n = cached;
    } else {
      let convertedValue;
      if (currentUnit in angleUnitsMap) {
        convertedValue = currentNumber * angleUnitsMap[currentUnit] / angleUnitsMap[unit];
      } else {
        const baseline = 100;
        const tempEl = (
          /** @type {DOMTarget} */
          el.cloneNode()
        );
        const parentNode = el.parentNode;
        const parentEl = parentNode && parentNode !== doc ? parentNode : doc.body;
        parentEl.appendChild(tempEl);
        const elStyle = tempEl.style;
        elStyle.width = baseline + currentUnit;
        const currentUnitWidth = (
          /** @type {HTMLElement} */
          tempEl.offsetWidth || baseline
        );
        elStyle.width = baseline + unit;
        const newUnitWidth = (
          /** @type {HTMLElement} */
          tempEl.offsetWidth || baseline
        );
        const factor = currentUnitWidth / newUnitWidth;
        parentEl.removeChild(tempEl);
        convertedValue = factor * currentNumber;
      }
      decomposedValue.n = convertedValue;
      convertedValuesCache[cachedKey] = convertedValue;
    }
    decomposedValue.t === valueTypes.UNIT;
    decomposedValue.u = unit;
    return decomposedValue;
  };

  // node_modules/animejs/dist/modules/easings/none.js
  var none = (t) => t;

  // node_modules/animejs/dist/modules/easings/eases/parser.js
  var easeInPower = (p = 1.68) => (t) => pow(t, +p);
  var easeTypes = {
    in: (easeIn) => (t) => easeIn(t),
    out: (easeIn) => (t) => 1 - easeIn(1 - t),
    inOut: (easeIn) => (t) => t < 0.5 ? easeIn(t * 2) / 2 : 1 - easeIn(t * -2 + 2) / 2,
    outIn: (easeIn) => (t) => t < 0.5 ? (1 - easeIn(1 - t * 2)) / 2 : (easeIn(t * 2 - 1) + 1) / 2
  };
  var halfPI = PI / 2;
  var doublePI = PI * 2;
  var easeInFunctions = {
    [emptyString]: easeInPower,
    Quad: easeInPower(2),
    Cubic: easeInPower(3),
    Quart: easeInPower(4),
    Quint: easeInPower(5),
    /** @type {EasingFunction} */
    Sine: (t) => 1 - cos(t * halfPI),
    /** @type {EasingFunction} */
    Circ: (t) => 1 - sqrt(1 - t * t),
    /** @type {EasingFunction} */
    Expo: (t) => t ? pow(2, 10 * t - 10) : 0,
    /** @type {EasingFunction} */
    Bounce: (t) => {
      let pow2, b = 4;
      while (t < ((pow2 = pow(2, --b)) - 1) / 11) ;
      return 1 / pow(4, 3 - b) - 7.5625 * pow((pow2 * 3 - 2) / 22 - t, 2);
    },
    /** @type {BackEasing} */
    Back: (overshoot = 1.7) => (t) => (+overshoot + 1) * t * t * t - +overshoot * t * t,
    /** @type {ElasticEasing} */
    Elastic: (amplitude = 1, period = 0.3) => {
      const a = clamp(+amplitude, 1, 10);
      const p = clamp(+period, minValue, 2);
      const s = p / doublePI * asin(1 / a);
      const e = doublePI / p;
      return (t) => t === 0 || t === 1 ? t : -a * pow(2, -10 * (1 - t)) * sin((1 - t - s) * e);
    }
  };
  var eases = /* @__PURE__ */ (() => {
    const list = { linear: none, none };
    for (let type in easeTypes) {
      for (let name in easeInFunctions) {
        const easeIn = easeInFunctions[name];
        const easeType = easeTypes[type];
        list[type + name] = /** @type {EasingFunctionWithParams|EasingFunction} */
        name === emptyString || name === "Back" || name === "Elastic" ? (a, b) => easeType(
          /** @type {EasingFunctionWithParams} */
          easeIn(a, b)
        ) : easeType(
          /** @type {EasingFunction} */
          easeIn
        );
      }
    }
    return (
      /** @type {EasesFunctions} */
      list
    );
  })();
  var easesLookups = { linear: none, none };
  var parseEaseString = (string) => {
    if (easesLookups[string]) return easesLookups[string];
    if (string.indexOf("(") <= -1) {
      const hasParams = easeTypes[string] || string.includes("Back") || string.includes("Elastic");
      const parsedFn = (
        /** @type {EasingFunction} */
        hasParams ? (
          /** @type {EasingFunctionWithParams} */
          eases[string]()
        ) : eases[string]
      );
      return parsedFn ? easesLookups[string] = parsedFn : none;
    } else {
      const split2 = string.slice(0, -1).split("(");
      const parsedFn = (
        /** @type {EasingFunctionWithParams} */
        eases[split2[0]]
      );
      return parsedFn ? easesLookups[string] = parsedFn(...split2[1].split(",")) : none;
    }
  };
  var deprecated = ["steps(", "irregular(", "linear(", "cubicBezier("];
  var parseEase = (ease) => {
    if (isStr(ease)) {
      for (let i = 0, l = deprecated.length; i < l; i++) {
        if (stringStartsWith(ease, deprecated[i])) {
          console.warn(`String syntax for \`ease: "${ease}"\` has been removed from the core and replaced by importing and passing the easing function directly: \`ease: ${ease}\``);
          return none;
        }
      }
    }
    const easeFunc = isFnc(ease) ? ease : isStr(ease) ? parseEaseString(
      /** @type {String} */
      ease
    ) : none;
    return easeFunc;
  };

  // node_modules/animejs/dist/modules/animation/animation.js
  var fromTargetObject = createDecomposedValueTargetObject();
  var toTargetObject = createDecomposedValueTargetObject();
  var inlineStylesStore = {};
  var toFunctionStore = { func: null };
  var fromFunctionStore = { func: null };
  var keyframesTargetArray = [null];
  var fastSetValuesArray = [null, null];
  var keyObjectTarget = { to: null };
  var tweenId = 0;
  var JSAnimationId = 0;
  var keyframes;
  var key;
  var generateKeyframes = (keyframes2, parameters) => {
    const properties = {};
    if (isArr(keyframes2)) {
      const propertyNames = [].concat(.../** @type {DurationKeyframes} */
      keyframes2.map((key2) => Object.keys(key2))).filter(isKey);
      for (let i = 0, l = propertyNames.length; i < l; i++) {
        const propName = propertyNames[i];
        const propArray = (
          /** @type {DurationKeyframes} */
          keyframes2.map((key2) => {
            const newKey = {};
            for (let p in key2) {
              const keyValue = (
                /** @type {TweenPropValue} */
                key2[p]
              );
              if (isKey(p)) {
                if (p === propName) {
                  newKey.to = keyValue;
                }
              } else {
                newKey[p] = keyValue;
              }
            }
            return newKey;
          })
        );
        properties[propName] = /** @type {ArraySyntaxValue} */
        propArray;
      }
    } else {
      const totalDuration = (
        /** @type {Number} */
        setValue(parameters.duration, globals.defaults.duration)
      );
      const keys = Object.keys(keyframes2).map((key2) => {
        return { o: parseFloat(key2) / 100, p: keyframes2[key2] };
      }).sort((a, b) => a.o - b.o);
      keys.forEach((key2) => {
        const offset = key2.o;
        const prop = key2.p;
        for (let name in prop) {
          if (isKey(name)) {
            let propArray = (
              /** @type {Array} */
              properties[name]
            );
            if (!propArray) propArray = properties[name] = [];
            const duration = offset * totalDuration;
            let length = propArray.length;
            let prevKey = propArray[length - 1];
            const keyObj = { to: prop[name] };
            let durProgress = 0;
            for (let i = 0; i < length; i++) {
              durProgress += propArray[i].duration;
            }
            if (length === 1) {
              keyObj.from = prevKey.to;
            }
            if (prop.ease) {
              keyObj.ease = prop.ease;
            }
            keyObj.duration = duration - (length ? durProgress : 0);
            propArray.push(keyObj);
          }
        }
        return key2;
      });
      for (let name in properties) {
        const propArray = (
          /** @type {Array} */
          properties[name]
        );
        let prevEase;
        for (let i = 0, l = propArray.length; i < l; i++) {
          const prop = propArray[i];
          const currentEase = prop.ease;
          prop.ease = prevEase ? prevEase : void 0;
          prevEase = currentEase;
        }
        if (!propArray[0].duration) {
          propArray.shift();
        }
      }
    }
    return properties;
  };
  var JSAnimation = class extends Timer {
    /**
     * @param {TargetsParam} targets
     * @param {AnimationParams} parameters
     * @param {Timeline} [parent]
     * @param {Number} [parentPosition]
     * @param {Boolean} [fastSet=false]
     * @param {Number} [index=0]
     * @param {TargetsArray} [allTargets]
     */
    constructor(targets, parameters, parent, parentPosition, fastSet = false, index = 0, allTargets) {
      super(
        /** @type {TimerParams & AnimationParams} */
        parameters,
        parent,
        parentPosition
      );
      this._head;
      this._tail;
      ++JSAnimationId;
      const parsedTargets = registerTargets(targets);
      const targetsLength = parsedTargets.length;
      const kfParams = (
        /** @type {AnimationParams} */
        parameters.keyframes
      );
      const params = (
        /** @type {AnimationParams} */
        kfParams ? mergeObjects(generateKeyframes(
          /** @type {DurationKeyframes} */
          kfParams,
          parameters
        ), parameters) : parameters
      );
      const {
        id: id2,
        delay,
        duration,
        ease,
        playbackEase,
        modifier,
        composition,
        onRender
      } = params;
      const animDefaults = parent ? parent.defaults : globals.defaults;
      const animEase = setValue(ease, animDefaults.ease);
      const animPlaybackEase = setValue(playbackEase, animDefaults.playbackEase);
      const parsedAnimPlaybackEase = animPlaybackEase ? parseEase(animPlaybackEase) : null;
      const hasSpring = !isUnd(
        /** @type {Spring} */
        animEase.ease
      );
      const tEasing = hasSpring ? (
        /** @type {Spring} */
        animEase.ease
      ) : setValue(ease, parsedAnimPlaybackEase ? "linear" : animDefaults.ease);
      const tDuration = hasSpring ? (
        /** @type {Spring} */
        animEase.settlingDuration
      ) : setValue(duration, animDefaults.duration);
      const tDelay = setValue(delay, animDefaults.delay);
      const tModifier = modifier || animDefaults.modifier;
      const tComposition = isUnd(composition) && targetsLength >= K ? compositionTypes.none : !isUnd(composition) ? composition : animDefaults.composition;
      const absoluteOffsetTime = this._offset + (parent ? parent._offset : 0);
      if (hasSpring) animEase.parent = this;
      let iterationDuration = NaN;
      let iterationDelay = NaN;
      let animationAnimationLength = 0;
      let shouldTriggerRender = 0;
      for (let targetIndex = 0; targetIndex < targetsLength; targetIndex++) {
        const target = parsedTargets[targetIndex];
        const ti = index || targetIndex;
        const tl = allTargets || parsedTargets;
        let lastTransformGroupIndex = NaN;
        let lastTransformGroupLength = NaN;
        for (let p in params) {
          if (isKey(p)) {
            const tweenType = getTweenType(target, p);
            const adapterProp = resolveAdapterEntry(target, p);
            const propName = sanitizePropertyName(p, target, tweenType);
            let propValue = params[p];
            const isPropValueArray = isArr(propValue);
            if (fastSet && !isPropValueArray) {
              fastSetValuesArray[0] = propValue;
              fastSetValuesArray[1] = propValue;
              propValue = fastSetValuesArray;
            }
            if (isPropValueArray) {
              const arrayLength = (
                /** @type {Array} */
                propValue.length
              );
              const isNotObjectValue = !isObj(propValue[0]);
              if (arrayLength === 2 && isNotObjectValue) {
                keyObjectTarget.to = /** @type {TweenParamValue} */
                /** @type {unknown} */
                propValue;
                keyframesTargetArray[0] = keyObjectTarget;
                keyframes = keyframesTargetArray;
              } else if (arrayLength > 2 && isNotObjectValue) {
                keyframes = [];
                propValue.forEach((v, i) => {
                  if (!i) {
                    fastSetValuesArray[0] = v;
                  } else if (i === 1) {
                    fastSetValuesArray[1] = v;
                    keyframes.push(fastSetValuesArray);
                  } else {
                    keyframes.push(v);
                  }
                });
              } else {
                keyframes = /** @type {Array.<TweenKeyValue>} */
                propValue;
              }
            } else {
              keyframesTargetArray[0] = propValue;
              keyframes = keyframesTargetArray;
            }
            let siblings = null;
            let prevTween = null;
            let firstTweenChangeStartTime = NaN;
            let lastTweenChangeEndTime = 0;
            let tweenIndex = 0;
            for (let l = keyframes.length; tweenIndex < l; tweenIndex++) {
              const keyframe = keyframes[tweenIndex];
              if (isObj(keyframe)) {
                key = keyframe;
              } else {
                keyObjectTarget.to = /** @type {TweenParamValue} */
                keyframe;
                key = keyObjectTarget;
              }
              toFunctionStore.func = null;
              fromFunctionStore.func = null;
              const computedComposition = getFunctionValue(setValue(key.composition, tComposition), target, ti, tl, null, null);
              const tweenComposition = isNum(computedComposition) ? computedComposition : compositionTypes[computedComposition];
              if (!siblings && tweenComposition !== compositionTypes.none) siblings = getTweenSiblings(target, propName);
              const tailTween = siblings ? siblings._tail : null;
              const prevSiblingTween = parent && tailTween && tailTween.parent.parent === parent ? tailTween : prevTween;
              const computedToValue = getFunctionValue(key.to, target, ti, tl, toFunctionStore, prevSiblingTween);
              let tweenToValue;
              if (isObj(computedToValue) && !isUnd(computedToValue.to)) {
                key = computedToValue;
                tweenToValue = computedToValue.to;
              } else {
                tweenToValue = computedToValue;
              }
              const tweenFromValue = getFunctionValue(key.from, target, ti, tl, fromFunctionStore, prevSiblingTween);
              const easeToParse = key.ease || tEasing;
              const easeFunctionResult = getFunctionValue(easeToParse, target, ti, tl, null, prevSiblingTween);
              const keyEasing = isFnc(easeFunctionResult) || isStr(easeFunctionResult) ? easeFunctionResult : easeToParse;
              const hasSpring2 = !isUnd(keyEasing) && !isUnd(
                /** @type {Spring} */
                keyEasing.ease
              );
              const tweenEasing = hasSpring2 ? (
                /** @type {Spring} */
                keyEasing.ease
              ) : keyEasing;
              const tweenDuration = hasSpring2 ? (
                /** @type {Spring} */
                keyEasing.settlingDuration
              ) : getFunctionValue(setValue(key.duration, l > 1 ? getFunctionValue(tDuration, target, ti, tl, null, prevSiblingTween) / l : tDuration), target, ti, tl, null, prevSiblingTween);
              const tweenDelay = getFunctionValue(setValue(key.delay, !tweenIndex ? tDelay : 0), target, ti, tl, null, prevSiblingTween);
              const tweenModifier = key.modifier || tModifier;
              const hasFromvalue = !isUnd(tweenFromValue);
              const hasToValue = !isUnd(tweenToValue);
              const isFromToArray = isArr(tweenToValue);
              const isFromToValue = isFromToArray || hasFromvalue && hasToValue;
              const tweenUpdateStartLocal = prevTween ? lastTweenChangeEndTime : 0;
              const tweenStartTime = prevTween ? lastTweenChangeEndTime + tweenDelay : tweenDelay;
              const absoluteStartTime = round(absoluteOffsetTime + tweenStartTime, 12);
              const absoluteUpdateStartTime = round(absoluteOffsetTime + tweenUpdateStartLocal, 12);
              if (!shouldTriggerRender && (hasFromvalue || isFromToArray)) shouldTriggerRender = 1;
              let prevSibling = prevTween;
              if (tweenComposition !== compositionTypes.none) {
                let nextSibling = siblings._head;
                while (nextSibling && nextSibling._absoluteStartTime <= absoluteStartTime) {
                  if (!nextSibling._isOverridden) prevSibling = nextSibling;
                  nextSibling = nextSibling._nextRep;
                  if (nextSibling && nextSibling._absoluteStartTime >= absoluteStartTime) {
                    while (nextSibling) {
                      overrideTween(nextSibling);
                      nextSibling = nextSibling._nextRep;
                    }
                  }
                }
              }
              if (isFromToValue) {
                decomposeRawValue(isFromToArray ? getFunctionValue(tweenToValue[0], target, ti, tl, fromFunctionStore, prevSiblingTween) : tweenFromValue, fromTargetObject);
                decomposeRawValue(isFromToArray ? getFunctionValue(tweenToValue[1], target, ti, tl, toFunctionStore, prevSiblingTween) : tweenToValue, toTargetObject);
                const originalValue = getOriginalAnimatableValue(target, propName, tweenType, inlineStylesStore);
                if (fromTargetObject.t === valueTypes.NUMBER) {
                  if (prevSibling) {
                    if (prevSibling._valueType === valueTypes.UNIT) {
                      fromTargetObject.t = valueTypes.UNIT;
                      fromTargetObject.u = prevSibling._unit;
                    }
                  } else {
                    decomposeRawValue(
                      originalValue,
                      decomposedOriginalValue
                    );
                    if (decomposedOriginalValue.t === valueTypes.UNIT) {
                      fromTargetObject.t = valueTypes.UNIT;
                      fromTargetObject.u = decomposedOriginalValue.u;
                    }
                  }
                }
              } else {
                if (hasToValue) {
                  decomposeRawValue(tweenToValue, toTargetObject);
                } else {
                  if (prevTween) {
                    decomposeTweenValue(prevTween, toTargetObject);
                  } else {
                    decomposeRawValue(parent && prevSibling && prevSibling.parent.parent === parent ? prevSibling._value : getOriginalAnimatableValue(target, propName, tweenType, inlineStylesStore), toTargetObject);
                  }
                }
                if (hasFromvalue) {
                  decomposeRawValue(tweenFromValue, fromTargetObject);
                } else {
                  if (prevTween) {
                    decomposeTweenValue(prevTween, fromTargetObject);
                  } else {
                    decomposeRawValue(parent && prevSibling && prevSibling.parent.parent === parent ? prevSibling._value : getOriginalAnimatableValue(target, propName, tweenType, inlineStylesStore), fromTargetObject);
                  }
                }
              }
              if (fromTargetObject.o) {
                fromTargetObject.n = getRelativeValue(
                  !prevSibling ? decomposeRawValue(
                    getOriginalAnimatableValue(target, propName, tweenType, inlineStylesStore),
                    decomposedOriginalValue
                  ).n : prevSibling._toNumber,
                  fromTargetObject.n,
                  fromTargetObject.o
                );
              }
              if (toTargetObject.o) {
                toTargetObject.n = getRelativeValue(fromTargetObject.n, toTargetObject.n, toTargetObject.o);
              }
              if (fromTargetObject.t !== toTargetObject.t) {
                if (fromTargetObject.t === valueTypes.COMPLEX || toTargetObject.t === valueTypes.COMPLEX) {
                  const complexValue = fromTargetObject.t === valueTypes.COMPLEX ? fromTargetObject : toTargetObject;
                  const notComplexValue = fromTargetObject.t === valueTypes.COMPLEX ? toTargetObject : fromTargetObject;
                  notComplexValue.t = valueTypes.COMPLEX;
                  notComplexValue.s = cloneArray(complexValue.s);
                  notComplexValue.d = complexValue.d.map(() => notComplexValue.n);
                } else if (fromTargetObject.t === valueTypes.UNIT || toTargetObject.t === valueTypes.UNIT) {
                  const unitValue = fromTargetObject.t === valueTypes.UNIT ? fromTargetObject : toTargetObject;
                  const notUnitValue = fromTargetObject.t === valueTypes.UNIT ? toTargetObject : fromTargetObject;
                  notUnitValue.t = valueTypes.UNIT;
                  notUnitValue.u = unitValue.u;
                } else if (fromTargetObject.t === valueTypes.COLOR || toTargetObject.t === valueTypes.COLOR) {
                  const colorValue = fromTargetObject.t === valueTypes.COLOR ? fromTargetObject : toTargetObject;
                  const notColorValue = fromTargetObject.t === valueTypes.COLOR ? toTargetObject : fromTargetObject;
                  notColorValue.t = valueTypes.COLOR;
                  notColorValue.d = colorValue.d.map(() => 0);
                }
              }
              if (fromTargetObject.u !== toTargetObject.u) {
                let valueToConvert = toTargetObject.u ? fromTargetObject : toTargetObject;
                valueToConvert = convertValueUnit(
                  /** @type {DOMTarget} */
                  target,
                  valueToConvert,
                  toTargetObject.u ? toTargetObject.u : fromTargetObject.u,
                  false
                );
              }
              if (toTargetObject.d && fromTargetObject.d && toTargetObject.d.length !== fromTargetObject.d.length) {
                const longestValue = fromTargetObject.d.length > toTargetObject.d.length ? fromTargetObject : toTargetObject;
                const shortestValue = longestValue === fromTargetObject ? toTargetObject : fromTargetObject;
                shortestValue.d = longestValue.d.map((_, i) => isUnd(shortestValue.d[i]) ? 0 : shortestValue.d[i]);
                shortestValue.s = cloneArray(longestValue.s);
              }
              const tweenUpdateDuration = round(+tweenDuration || minValue, 12);
              let inlineValue = inlineStylesStore[propName];
              if (!isNil(inlineValue)) inlineStylesStore[propName] = null;
              const tweenSetter = adapterProp ? adapterProp.set : null;
              lastTweenChangeEndTime = round(tweenStartTime + tweenUpdateDuration, 12);
              const fromD = fromTargetObject.d;
              const toD = toTargetObject.d;
              const toS = toTargetObject.s;
              const tween = {
                parent: this,
                id: tweenId++,
                property: propName,
                target,
                _value: null,
                _toFunc: toFunctionStore.func,
                _fromFunc: fromFunctionStore.func,
                _ease: parseEase(tweenEasing),
                _fromNumbers: fromD ? cloneArray(fromD) : emptyArray,
                _toNumbers: toD ? cloneArray(toD) : emptyArray,
                _strings: toS ? cloneArray(toS) : emptyArray,
                _fromNumber: fromTargetObject.n,
                _toNumber: toTargetObject.n,
                _numbers: fromD ? cloneArray(fromD) : emptyArray,
                // For additive tween and animatables
                _number: fromTargetObject.n,
                // For additive tween and animatables
                _unit: toTargetObject.u,
                _modifier: tweenModifier,
                _currentTime: 0,
                _startTime: tweenStartTime,
                _delay: +tweenDelay,
                _updateDuration: tweenUpdateDuration,
                _changeDuration: tweenUpdateDuration,
                _absoluteStartTime: absoluteStartTime,
                _absoluteUpdateStartTime: absoluteUpdateStartTime,
                _absoluteEndTime: round(absoluteOffsetTime + lastTweenChangeEndTime, 12),
                _hasFromValue: hasFromvalue || isFromToArray ? 1 : 0,
                // NOTE: Investigate bit packing to stores ENUM / BOOL
                _tweenType: tweenType,
                _setter: tweenSetter,
                _valueType: toTargetObject.t,
                _composition: tweenComposition,
                _isOverlapped: 0,
                _isOverridden: 0,
                _renderTransforms: 0,
                _inlineValue: inlineValue,
                _prevRep: null,
                // For replaced tween
                _nextRep: null,
                // For replaced tween
                _prevAdd: null,
                // For additive tween
                _nextAdd: null,
                // For additive tween
                _prev: null,
                _next: null
              };
              if (tweenComposition !== compositionTypes.none) {
                composeTween(tween, siblings);
              }
              const vt = tween._valueType;
              if (vt === valueTypes.COMPLEX) {
                tween._value = composeComplexValue(tween, 1, -1);
              } else if (vt === valueTypes.UNIT) {
                tween._value = `${tweenModifier(tween._toNumber)}${tween._unit}`;
              } else if (vt === valueTypes.COLOR) {
                const d = toTargetObject.d;
                tween._value = `rgba(${round(d[0], 0)},${round(d[1], 0)},${round(d[2], 0)},${d[3]})`;
              } else {
                tween._value = tweenModifier(tween._toNumber);
              }
              if (isNaN(firstTweenChangeStartTime)) {
                firstTweenChangeStartTime = tween._startTime;
              }
              prevTween = tween;
              animationAnimationLength++;
              addChild(this, tween);
            }
            if (isNaN(iterationDelay) || firstTweenChangeStartTime < iterationDelay) {
              iterationDelay = firstTweenChangeStartTime;
            }
            if (isNaN(iterationDuration) || lastTweenChangeEndTime > iterationDuration) {
              iterationDuration = lastTweenChangeEndTime;
            }
            if (tweenType === tweenTypes.TRANSFORM) {
              lastTransformGroupIndex = animationAnimationLength - tweenIndex;
              lastTransformGroupLength = animationAnimationLength;
            }
          }
        }
        if (!isNaN(lastTransformGroupIndex)) {
          let i = 0;
          forEachChildren(this, (tween) => {
            if (i >= lastTransformGroupIndex && i < lastTransformGroupLength) {
              tween._renderTransforms = 1;
              if (tween._composition === compositionTypes.blend) {
                forEachChildren(additive.animation, (additiveTween) => {
                  if (additiveTween.id === tween.id) {
                    additiveTween._renderTransforms = 1;
                  }
                });
              }
            }
            i++;
          });
        }
      }
      if (!targetsLength) {
        console.warn(`No target found. Make sure the element you're trying to animate is accessible before creating your animation.`);
      }
      if (iterationDelay) {
        forEachChildren(this, (tween) => {
          if (!(tween._startTime - tween._delay)) {
            tween._delay -= iterationDelay;
          }
          tween._startTime -= iterationDelay;
        });
        iterationDuration -= iterationDelay;
      } else {
        iterationDelay = 0;
      }
      if (!iterationDuration) {
        iterationDuration = minValue;
        this.iterationCount = 0;
      }
      this.targets = parsedTargets;
      this.id = !isUnd(id2) ? id2 : JSAnimationId;
      this.duration = iterationDuration === minValue ? minValue : clampInfinity((iterationDuration + this._loopDelay) * this.iterationCount - this._loopDelay) || minValue;
      this.onRender = onRender || animDefaults.onRender;
      this._ease = parsedAnimPlaybackEase;
      this._delay = iterationDelay;
      this.iterationDuration = iterationDuration;
      if (!this._autoplay && shouldTriggerRender) this.onRender(this);
    }
    /**
     * @param  {Number} newDuration
     * @return {this}
     */
    stretch(newDuration) {
      const currentDuration = this.duration;
      if (currentDuration === normalizeTime(newDuration)) return this;
      const timeScale = newDuration / currentDuration;
      forEachChildren(this, (tween) => {
        tween._updateDuration = normalizeTime(tween._updateDuration * timeScale);
        tween._changeDuration = normalizeTime(tween._changeDuration * timeScale);
        tween._currentTime *= timeScale;
        tween._delay *= timeScale;
        tween._startTime *= timeScale;
        tween._absoluteStartTime *= timeScale;
        tween._absoluteUpdateStartTime *= timeScale;
        tween._absoluteEndTime *= timeScale;
      });
      return super.stretch(newDuration);
    }
    /**
     * @return {this}
     */
    refresh() {
      forEachChildren(this, (tween) => {
        const toFunc = tween._toFunc;
        const fromFunc = tween._fromFunc;
        if (toFunc || fromFunc) {
          if (fromFunc) {
            decomposeRawValue(fromFunc(), fromTargetObject);
            if (fromTargetObject.u !== tween._unit && tween.target[isDomSymbol]) {
              convertValueUnit(
                /** @type {DOMTarget} */
                tween.target,
                fromTargetObject,
                tween._unit,
                true
              );
            }
            tween._fromNumbers = cloneArray(fromTargetObject.d);
            tween._fromNumber = fromTargetObject.n;
          } else if (toFunc) {
            decomposeRawValue(getOriginalAnimatableValue(tween.target, tween.property, tween._tweenType), decomposedOriginalValue);
            tween._fromNumbers = cloneArray(decomposedOriginalValue.d);
            tween._fromNumber = decomposedOriginalValue.n;
          }
          if (toFunc) {
            decomposeRawValue(toFunc(), toTargetObject);
            tween._toNumbers = cloneArray(toTargetObject.d);
            tween._strings = cloneArray(toTargetObject.s);
            tween._toNumber = toTargetObject.o ? getRelativeValue(tween._fromNumber, toTargetObject.n, toTargetObject.o) : toTargetObject.n;
          }
        }
      });
      if (this.duration === minValue) this.restart();
      return this;
    }
    /**
     * Cancel the animation and revert all the values affected by this animation to their original state
     * @return {this}
     */
    revert() {
      super.revert();
      return revertValues(this);
    }
    /**
     * @typedef {this & {then: null}} ResolvedJSAnimation
     */
    /**
     * @param  {Callback<ResolvedJSAnimation>} [callback]
     * @return Promise<this>
     */
    then(callback) {
      return super.then(callback);
    }
  };

  // node_modules/animejs/dist/modules/timeline/position.js
  var getPrevChildOffset = (timeline, timePosition) => {
    if (stringStartsWith(timePosition, "<")) {
      const goToPrevAnimationOffset = timePosition[1] === "<";
      const prevAnimation = (
        /** @type {Tickable} */
        timeline._tail
      );
      const prevOffset = prevAnimation ? prevAnimation._offset + prevAnimation._delay : 0;
      return goToPrevAnimationOffset ? prevOffset : prevOffset + prevAnimation.duration;
    }
  };
  var parseTimelinePosition = (timeline, timePosition) => {
    let tlDuration = timeline.iterationDuration;
    if (tlDuration === minValue) tlDuration = 0;
    if (isUnd(timePosition)) return tlDuration;
    if (isNum(+timePosition)) return +timePosition;
    const timePosStr = (
      /** @type {String} */
      timePosition
    );
    const tlLabels = timeline ? timeline.labels : null;
    const hasLabels = !isNil(tlLabels);
    const prevOffset = getPrevChildOffset(timeline, timePosStr);
    const hasSibling = !isUnd(prevOffset);
    const matchedRelativeOperator = relativeValuesExecRgx.exec(timePosStr);
    if (matchedRelativeOperator) {
      const fullOperator = matchedRelativeOperator[0];
      const split2 = timePosStr.split(fullOperator);
      const labelOffset = hasLabels && split2[0] ? tlLabels[split2[0]] : tlDuration;
      const parsedOffset = hasSibling ? prevOffset : hasLabels ? labelOffset : tlDuration;
      const parsedNumericalOffset = +split2[1];
      return getRelativeValue(parsedOffset, parsedNumericalOffset, fullOperator[0]);
    } else {
      return hasSibling ? prevOffset : hasLabels ? !isUnd(tlLabels[timePosStr]) ? tlLabels[timePosStr] : tlDuration : tlDuration;
    }
  };

  // node_modules/animejs/dist/modules/timeline/timeline.js
  function getTimelineTotalDuration(tl) {
    return clampInfinity((tl.iterationDuration + tl._loopDelay) * tl.iterationCount - tl._loopDelay) || minValue;
  }
  function addTlChild(childParams, tl, timePosition, targets, index, allTargets) {
    const isSetter = isNum(childParams.duration) && /** @type {Number} */
    childParams.duration <= minValue;
    const adjustedPosition = isSetter ? timePosition - minValue : timePosition;
    if (tl.composition) tick(tl, adjustedPosition, 1, 1, tickModes.AUTO);
    const tlChild = targets ? new JSAnimation(
      targets,
      /** @type {AnimationParams} */
      childParams,
      tl,
      adjustedPosition,
      false,
      index,
      allTargets
    ) : new Timer(
      /** @type {TimerParams} */
      childParams,
      tl,
      adjustedPosition
    );
    if (tl.composition) tlChild.init(true);
    addChild(tl, tlChild);
    forEachChildren(tl, (child) => {
      const childTLOffset = child._offset + child._delay;
      const childDur = childTLOffset + child.duration;
      if (childDur > tl.iterationDuration) tl.iterationDuration = childDur;
    });
    tl.duration = getTimelineTotalDuration(tl);
    return tl;
  }
  var TLId = 0;
  var Timeline = class extends Timer {
    /**
     * @param {TimelineParams} [parameters]
     */
    constructor(parameters = {}) {
      super(
        /** @type {TimerParams&TimelineParams} */
        parameters,
        null,
        0
      );
      ++TLId;
      this.id = !isUnd(parameters.id) ? parameters.id : TLId;
      this.duration = 0;
      this.labels = {};
      const defaultsParams = parameters.defaults;
      const globalDefaults = globals.defaults;
      this.defaults = defaultsParams ? mergeObjects(defaultsParams, globalDefaults) : globalDefaults;
      this.composition = setValue(parameters.composition, true);
      this.onRender = parameters.onRender || globalDefaults.onRender;
      const tlPlaybackEase = setValue(parameters.playbackEase, globalDefaults.playbackEase);
      this._ease = tlPlaybackEase ? parseEase(tlPlaybackEase) : null;
      this.iterationDuration = 0;
    }
    /**
     * @overload
     * @param {TargetsParam} a1
     * @param {AnimationParams} a2
     * @param {TimelinePosition|StaggerFunction<Number|String>|TweakRegister} [a3]
     * @return {this}
     *
     * @overload
     * @param {TimerParams} a1
     * @param {TimelinePosition} [a2]
     * @return {this}
     *
     * @param {TargetsParam|TimerParams} a1
     * @param {TimelinePosition|AnimationParams} a2
     * @param {TimelinePosition|StaggerFunction<Number|String>|TweakRegister} [a3]
     */
    add(a1, a2, a3) {
      const isAnim = isObj(a2);
      const isTimer = isObj(a1);
      if (isAnim || isTimer) {
        this._hasChildren = true;
        if (isAnim) {
          const childParams = (
            /** @type {AnimationParams} */
            a2
          );
          const editorHook = globals.editor && globals.editor.addTimelineChild;
          const isStaggerType = a3 && /** @type {TweakRegister} */
          a3.type === "Stagger" && globals.editor;
          const staggeredPosition = isFnc(a3) ? a3 : null;
          if (staggeredPosition || isStaggerType) {
            const parsedTargetsArray = parseTargets(
              /** @type {TargetsParam} */
              a1
            );
            const tlDuration = this.duration;
            const tlIterationDuration = this.iterationDuration;
            const id2 = childParams.id;
            let i = 0;
            const parsedLength = parsedTargetsArray.length;
            const resolvedParams = editorHook ? editorHook(
              /** @type {TargetsParam} */
              a1,
              childParams,
              this.id,
              a3,
              parsedLength
            ) : null;
            const staggerFn = staggeredPosition || globals.editor.resolveStagger(
              /** @type {TweakRegister} */
              a3.defaultValue
            );
            parsedTargetsArray.forEach((target) => {
              const staggeredChildParams = { ...resolvedParams || childParams };
              this.duration = tlDuration;
              this.iterationDuration = tlIterationDuration;
              if (!isUnd(id2)) staggeredChildParams.id = id2 + "-" + i;
              const staggeredTimePosition = parseTimelinePosition(this, staggerFn(target, i, parsedTargetsArray, null, this));
              addTlChild(
                staggeredChildParams,
                this,
                staggeredTimePosition,
                target,
                i,
                parsedTargetsArray
              );
              i++;
            });
          } else {
            const resolvedChildParams = editorHook ? editorHook(
              /** @type {TargetsParam} */
              a1,
              childParams,
              this.id,
              a3
            ) : childParams;
            const resolvedPosition = a3 && /** @type {*} */
            a3.type ? (
              /** @type {*} */
              a3.defaultValue
            ) : a3;
            addTlChild(
              resolvedChildParams,
              this,
              parseTimelinePosition(this, resolvedPosition),
              /** @type {TargetsParam} */
              a1
            );
          }
        } else {
          addTlChild(
            /** @type TimerParams */
            a1,
            this,
            parseTimelinePosition(this, a2)
          );
        }
        if (this.composition) this.init(true);
        return this;
      }
    }
    /**
     * @overload
     * @param {Tickable} [synced]
     * @param {TimelinePosition} [position]
     * @return {this}
     *
     * @overload
     * @param {globalThis.Animation} [synced]
     * @param {TimelinePosition} [position]
     * @return {this}
     *
     * @overload
     * @param {WAAPIAnimation} [synced]
     * @param {TimelinePosition} [position]
     * @return {this}
     *
     * @param {Tickable|WAAPIAnimation|globalThis.Animation} [synced]
     * @param {TimelinePosition} [position]
     */
    sync(synced, position) {
      if (isUnd(synced) || synced && isUnd(synced.pause)) return this;
      synced.pause();
      const duration = +/** @type {globalThis.Animation} */
      (synced.effect ? (
        /** @type {globalThis.Animation} */
        synced.effect.getTiming().duration
      ) : (
        /** @type {Tickable} */
        synced.duration
      ));
      if (!isUnd(synced) && !isUnd(
        /** @type {WAAPIAnimation} */
        synced.persist
      )) {
        synced.persist = true;
      }
      const editor = globals.editor;
      const childHook = editor && editor.addTimelineChild;
      if (editor && editor.addTimelineSync) {
        position = editor.addTimelineSync(synced, position, this.id);
        editor.addTimelineChild = null;
      }
      const result = this.add(synced, { currentTime: [0, duration], duration, delay: 0, ease: "linear", playbackEase: "linear" }, position);
      if (editor) editor.addTimelineChild = childHook;
      return result;
    }
    /**
     * @param  {TargetsParam} targets
     * @param  {AnimationParams} parameters
     * @param  {TimelinePosition|StaggerFunction<Number|String>|TweakRegister} [position]
     * @return {this}
     */
    set(targets, parameters, position) {
      if (isUnd(parameters)) return this;
      parameters.duration = minValue;
      parameters.composition = compositionTypes.replace;
      return this.add(targets, parameters, position);
    }
    /**
     * @param {Callback<Timer>} callback
     * @param {TimelinePosition} [position]
     * @return {this}
     */
    call(callback, position) {
      if (isUnd(callback) || callback && !isFnc(callback)) return this;
      if (globals.editor && globals.editor.addTimelineCall) position = globals.editor.addTimelineCall(callback, position, this.id);
      return this.add({ duration: 0, delay: 0, onComplete: () => callback(this) }, position);
    }
    /**
     * @param {String} labelName
     * @param {TimelinePosition} [position]
     * @return {this}
     *
     */
    label(labelName, position) {
      if (isUnd(labelName) || labelName && !isStr(labelName)) return this;
      if (globals.editor && globals.editor.addTimelineLabel) position = globals.editor.addTimelineLabel(labelName, position, this.id);
      this.labels[labelName] = parseTimelinePosition(this, position);
      return this;
    }
    /**
     * @param  {TargetsParam} targets
     * @param  {String} [propertyName]
     * @return {this}
     */
    remove(targets, propertyName) {
      removeTargetsFromRenderable(parseTargets(targets), this, propertyName);
      return this;
    }
    /**
     * @param  {Number} newDuration
     * @return {this}
     */
    stretch(newDuration) {
      const currentDuration = this.duration;
      if (currentDuration === normalizeTime(newDuration)) return this;
      const timeScale = newDuration / currentDuration;
      const labels = this.labels;
      forEachChildren(this, (child) => child.stretch(child.duration * timeScale));
      for (let labelName in labels) labels[labelName] *= timeScale;
      return super.stretch(newDuration);
    }
    /**
     * @return {this}
     */
    refresh() {
      forEachChildren(this, (child) => {
        if (
          /** @type {JSAnimation} */
          child.refresh
        ) child.refresh();
      });
      return this;
    }
    /**
     * @return {this}
     */
    revert() {
      super.revert();
      forEachChildren(this, (child) => child.revert, true);
      return revertValues(this);
    }
    /**
     * @typedef {this & {then: null}} ResolvedTimeline
     */
    /**
     * @param  {Callback<ResolvedTimeline>} [callback]
     * @return Promise<this>
     */
    then(callback) {
      return super.then(callback);
    }
  };
  var createTimeline = (parameters) => {
    if (globals.editor) {
      return (
        /** @type {Timeline} */
        /** @type {unknown} */
        globals.editor.addTimeline(parameters)
      );
    }
    return new Timeline(parameters).init();
  };

  // node_modules/animejs/dist/modules/animatable/animatable.js
  var Animatable = class {
    /**
     * @param {TargetsParam} targets
     * @param {AnimatableParams} parameters
     */
    constructor(targets, parameters) {
      if (scope.current) scope.current.register(this);
      const beginHandler = () => {
        if (this.callbacks.completed) this.callbacks.reset();
        this.callbacks.play();
      };
      const pauseHandler = () => {
        if (this.callbacks.completed) return;
        let paused = true;
        for (let name in this.animations) {
          const anim = this.animations[name];
          if (!anim.paused && paused) {
            paused = false;
            break;
          }
        }
        if (paused) {
          this.callbacks.complete();
        }
      };
      const globalParams = {
        onBegin: beginHandler,
        onComplete: pauseHandler,
        onPause: pauseHandler
      };
      const callbacksAnimationParams = { v: 1, autoplay: false };
      const properties = {};
      this.targets = [];
      this.animations = {};
      this.callbacks = null;
      if (isUnd(targets) || isUnd(parameters)) return;
      for (let propName in parameters) {
        const paramValue = parameters[propName];
        if (isKey(propName)) {
          properties[propName] = paramValue;
        } else if (stringStartsWith(propName, "on")) {
          callbacksAnimationParams[propName] = paramValue;
        } else {
          globalParams[propName] = paramValue;
        }
      }
      this.callbacks = new JSAnimation({ v: 0 }, callbacksAnimationParams);
      for (let propName in properties) {
        const propValue = properties[propName];
        const isObjValue = isObj(propValue);
        let propParams = {};
        let to = "+=0";
        if (isObjValue) {
          const unit = propValue.unit;
          if (isStr(unit)) to += unit;
        } else {
          propParams.duration = propValue;
        }
        propParams[propName] = isObjValue ? mergeObjects({ to }, propValue) : to;
        const animParams = mergeObjects(globalParams, propParams);
        animParams.composition = compositionTypes.replace;
        animParams.autoplay = false;
        const animation = this.animations[propName] = new JSAnimation(targets, animParams, null, 0, false).init();
        if (!this.targets.length) this.targets.push(...animation.targets);
        this[propName] = (to2, duration, ease) => {
          const tween = (
            /** @type {Tween} */
            animation._head
          );
          if (isUnd(to2) && tween) {
            const numbers = tween._numbers;
            if (numbers && numbers.length) {
              return numbers;
            } else {
              return tween._modifier(tween._number);
            }
          } else {
            forEachChildren(animation, (tween2) => {
              if (isArr(to2)) {
                for (let i = 0, l = (
                  /** @type {Array} */
                  to2.length
                ); i < l; i++) {
                  if (!isUnd(tween2._numbers[i])) {
                    tween2._fromNumbers[i] = /** @type {Number} */
                    tween2._modifier(tween2._numbers[i]);
                    tween2._toNumbers[i] = to2[i];
                  }
                }
              } else {
                tween2._fromNumber = /** @type {Number} */
                tween2._modifier(tween2._number);
                tween2._toNumber = /** @type {Number} */
                to2;
              }
              if (!isUnd(ease)) tween2._ease = parseEase(ease);
              tween2._currentTime = 0;
            });
            if (!isUnd(duration)) animation.stretch(duration);
            animation.reset(true).resume();
            return this;
          }
        };
      }
    }
    revert() {
      for (let propName in this.animations) {
        this[propName] = noop;
        this.animations[propName].revert();
      }
      this.animations = {};
      this.targets.length = 0;
      if (this.callbacks) this.callbacks.revert();
      return this;
    }
  };

  // node_modules/animejs/dist/modules/utils/number.js
  var mapRange = (value, inLow, inHigh, outLow, outHigh) => outLow + (value - inLow) / (inHigh - inLow) * (outHigh - outLow);

  // node_modules/animejs/dist/modules/easings/spring/index.js
  var maxSpringParamValue = K * 10;
  var Spring2 = class {
    /**
     * @param {SpringParams} [parameters]
     */
    constructor(parameters = {}) {
      const hasBounceOrDuration = !isUnd(parameters.bounce) || !isUnd(parameters.duration);
      this.timeStep = 0.02;
      this.restThreshold = 5e-4;
      this.restDuration = 200;
      this.maxDuration = 6e4;
      this.maxRestSteps = this.restDuration / this.timeStep / K;
      this.maxIterations = this.maxDuration / this.timeStep / K;
      this.bn = clamp(setValue(parameters.bounce, 0.5), -1, 1);
      this.pd = clamp(setValue(parameters.duration, 628), 10 * globals.timeScale, maxSpringParamValue * globals.timeScale);
      this.m = clamp(setValue(parameters.mass, 1), 1, maxSpringParamValue);
      this.s = clamp(setValue(parameters.stiffness, 100), minValue, maxSpringParamValue);
      this.d = clamp(setValue(parameters.damping, 10), minValue, maxSpringParamValue);
      this.v = clamp(setValue(parameters.velocity, 0), -maxSpringParamValue, maxSpringParamValue);
      this.w0 = 0;
      this.zeta = 0;
      this.wd = 0;
      this.b = 0;
      this.completed = false;
      this.solverDuration = 0;
      this.settlingDuration = 0;
      this.parent = null;
      this.onComplete = parameters.onComplete || noop;
      if (hasBounceOrDuration) this.calculateSDFromBD();
      this.compute();
      this.ease = (t) => {
        const currentTime = t * this.settlingDuration;
        const completed = this.completed;
        const perceivedTime = this.pd;
        if (currentTime >= perceivedTime && !completed) {
          this.completed = true;
          this.onComplete(this.parent);
        }
        if (currentTime < perceivedTime && completed) {
          this.completed = false;
        }
        return t === 0 || t === 1 ? t : this.solve(t * this.solverDuration);
      };
    }
    /** @type {EasingFunction} */
    solve(time) {
      const { zeta, w0, wd, b } = this;
      let t = time;
      if (zeta < 1) {
        t = exp(-t * zeta * w0) * (1 * cos(wd * t) + b * sin(wd * t));
      } else if (zeta === 1) {
        t = (1 + b * t) * exp(-t * w0);
      } else {
        t = ((1 + b) * exp((-zeta * w0 + wd) * t) + (1 - b) * exp((-zeta * w0 - wd) * t)) / 2;
      }
      return 1 - t;
    }
    calculateSDFromBD() {
      const pds = globals.timeScale === 1 ? this.pd / K : this.pd;
      this.m = 1;
      this.v = 0;
      this.s = pow(2 * PI / pds, 2);
      if (this.bn >= 0) {
        this.d = (1 - this.bn) * 4 * PI / pds;
      } else {
        this.d = 4 * PI / (pds * (1 + this.bn));
      }
      this.s = round(clamp(this.s, minValue, maxSpringParamValue), 3);
      this.d = round(clamp(this.d, minValue, 300), 3);
    }
    calculateBDFromSD() {
      const pds = 2 * PI / sqrt(this.s);
      this.pd = pds * (globals.timeScale === 1 ? K : 1);
      const zeta = this.d / (2 * sqrt(this.s));
      if (zeta <= 1) {
        this.bn = 1 - this.d * pds / (4 * PI);
      } else {
        this.bn = 4 * PI / (this.d * pds) - 1;
      }
      this.bn = round(clamp(this.bn, -1, 1), 3);
      this.pd = round(clamp(this.pd, 10 * globals.timeScale, maxSpringParamValue * globals.timeScale), 3);
    }
    compute() {
      const { maxRestSteps, maxIterations, restThreshold, timeStep, m, d, s, v } = this;
      const w0 = this.w0 = clamp(sqrt(s / m), minValue, K);
      const bouncedZeta = this.zeta = d / (2 * sqrt(s * m));
      if (bouncedZeta < 1) {
        this.wd = w0 * sqrt(1 - bouncedZeta * bouncedZeta);
        this.b = (bouncedZeta * w0 + -v) / this.wd;
      } else if (bouncedZeta === 1) {
        this.wd = 0;
        this.b = -v + w0;
      } else {
        this.wd = w0 * sqrt(bouncedZeta * bouncedZeta - 1);
        this.b = (bouncedZeta * w0 + -v) / this.wd;
      }
      let solverTime = 0;
      let restSteps = 0;
      let iterations = 0;
      while (restSteps <= maxRestSteps && iterations <= maxIterations) {
        if (abs(1 - this.solve(solverTime)) < restThreshold) {
          restSteps++;
        } else {
          restSteps = 0;
        }
        this.solverDuration = solverTime;
        solverTime += timeStep;
        iterations++;
      }
      this.settlingDuration = round(this.solverDuration * K, 0) * globals.timeScale;
    }
    get bounce() {
      return this.bn;
    }
    set bounce(v) {
      this.bn = clamp(setValue(v, 1), -1, 1);
      this.calculateSDFromBD();
      this.compute();
    }
    get duration() {
      return this.pd;
    }
    set duration(v) {
      this.pd = clamp(setValue(v, 1), 10 * globals.timeScale, maxSpringParamValue * globals.timeScale);
      this.calculateSDFromBD();
      this.compute();
    }
    get stiffness() {
      return this.s;
    }
    set stiffness(v) {
      this.s = clamp(setValue(v, 100), minValue, maxSpringParamValue);
      this.calculateBDFromSD();
      this.compute();
    }
    get damping() {
      return this.d;
    }
    set damping(v) {
      this.d = clamp(setValue(v, 10), minValue, maxSpringParamValue);
      this.calculateBDFromSD();
      this.compute();
    }
    get mass() {
      return this.m;
    }
    set mass(v) {
      this.m = clamp(setValue(v, 1), 1, maxSpringParamValue);
      this.compute();
    }
    get velocity() {
      return this.v;
    }
    set velocity(v) {
      this.v = clamp(setValue(v, 0), -maxSpringParamValue, maxSpringParamValue);
      this.compute();
    }
  };
  var spring = (parameters) => new Spring2(parameters);

  // node_modules/animejs/dist/modules/waapi/composition.js
  var WAAPIAnimationsLookups = {
    _head: null,
    _tail: null
  };
  var removeWAAPIAnimation = ($el, property, parent) => {
    let nextLookup = WAAPIAnimationsLookups._head;
    let anim;
    while (nextLookup) {
      const next = nextLookup._next;
      const matchTarget = nextLookup.$el === $el;
      const matchProperty = !property || nextLookup.property === property;
      const matchParent = !parent || nextLookup.parent === parent;
      if (matchTarget && matchProperty && matchParent) {
        anim = nextLookup.animation;
        try {
          anim.commitStyles();
        } catch {
        }
        anim.cancel();
        removeChild(WAAPIAnimationsLookups, nextLookup);
        const lookupParent = nextLookup.parent;
        if (lookupParent) {
          lookupParent._completed++;
          if (lookupParent.animations.length === lookupParent._completed) {
            lookupParent.completed = true;
            lookupParent.paused = true;
            if (!lookupParent.muteCallbacks) {
              lookupParent.onComplete(lookupParent);
              lookupParent._resolve(lookupParent);
            }
          }
        }
      }
      nextLookup = next;
    }
    return anim;
  };
  var addWAAPIAnimation = (parent, $el, property, keyframes2, params) => {
    const animation = $el.animate(keyframes2, params);
    const animTotalDuration = params.delay + +params.duration * params.iterations;
    animation.playbackRate = parent._speed;
    if (parent.paused) animation.pause();
    if (parent.duration < animTotalDuration) {
      parent.duration = animTotalDuration;
      parent.controlAnimation = animation;
    }
    parent.animations.push(animation);
    removeWAAPIAnimation($el, property);
    addChild(WAAPIAnimationsLookups, { parent, animation, $el, property, _next: null, _prev: null });
    const handleRemove = () => removeWAAPIAnimation($el, property, parent);
    animation.oncancel = handleRemove;
    animation.onremove = handleRemove;
    if (!parent.persist) {
      animation.onfinish = handleRemove;
    }
    return animation;
  };

  // node_modules/animejs/dist/modules/utils/target.js
  function get(targetSelector, propName, unit) {
    const targets = registerTargets(targetSelector);
    if (!targets.length) return;
    const [target] = targets;
    const tweenType = getTweenType(target, propName);
    const normalizePropName = sanitizePropertyName(propName, target, tweenType);
    let originalValue = getOriginalAnimatableValue(target, normalizePropName);
    if (isUnd(unit)) {
      return originalValue;
    } else {
      decomposeRawValue(originalValue, decomposedOriginalValue);
      if (decomposedOriginalValue.t === valueTypes.NUMBER || decomposedOriginalValue.t === valueTypes.UNIT) {
        if (unit === false) {
          return decomposedOriginalValue.n;
        } else {
          const convertedValue = convertValueUnit(
            /** @type {DOMTarget} */
            target,
            decomposedOriginalValue,
            /** @type {String} */
            unit,
            false
          );
          return `${round(convertedValue.n, globals.precision)}${convertedValue.u}`;
        }
      }
    }
  }
  var set = (targets, parameters) => {
    if (isUnd(parameters)) return;
    if (globals.editor && globals.editor.addSet) {
      return globals.editor.addSet(targets, parameters);
    }
    parameters.duration = minValue;
    parameters.composition = setValue(parameters.composition, compositionTypes.none);
    return new JSAnimation(targets, parameters, null, 0, true).resume();
  };

  // node_modules/animejs/dist/modules/draggable/draggable.js
  var preventDefault = (e) => {
    if (e.cancelable) e.preventDefault();
  };
  var DOMProxy = class {
    /** @param {Object} el */
    constructor(el) {
      this.el = el;
      this.zIndex = 0;
      this.parentElement = null;
      this.classList = {
        add: noop,
        remove: noop
      };
    }
    get x() {
      return this.el.x || 0;
    }
    set x(v) {
      this.el.x = v;
    }
    get y() {
      return this.el.y || 0;
    }
    set y(v) {
      this.el.y = v;
    }
    get width() {
      return this.el.width || 0;
    }
    set width(v) {
      this.el.width = v;
    }
    get height() {
      return this.el.height || 0;
    }
    set height(v) {
      this.el.height = v;
    }
    getBoundingClientRect() {
      return {
        top: this.y,
        right: this.x,
        bottom: this.y + this.height,
        left: this.x + this.width
      };
    }
  };
  var Transforms = class {
    /**
     * @param {DOMTarget|DOMProxy} $el
     */
    constructor($el) {
      this.$el = $el;
      this.inlineTransforms = [];
      this.point = new DOMPoint();
      this.inversedMatrix = this.getMatrix().inverse();
    }
    /**
     * @param {Number} x
     * @param {Number} y
     * @return {DOMPoint}
     */
    normalizePoint(x, y) {
      this.point.x = x;
      this.point.y = y;
      return this.point.matrixTransform(this.inversedMatrix);
    }
    /**
     * @callback TraverseParentsCallback
     * @param {DOMTarget} $el
     * @param {Number} i
     */
    /**
     * @param {TraverseParentsCallback} cb
     */
    traverseUp(cb) {
      let $el = (
        /** @type {DOMTarget|Document} */
        this.$el.parentElement
      ), i = 0;
      while ($el && $el !== doc) {
        cb(
          /** @type {DOMTarget} */
          $el,
          i
        );
        $el = /** @type {DOMTarget} */
        $el.parentElement;
        i++;
      }
    }
    getMatrix() {
      const matrix = new DOMMatrix();
      this.traverseUp(($el) => {
        const transformValue = getComputedStyle($el).transform;
        if (transformValue) {
          const elMatrix = new DOMMatrix(transformValue);
          matrix.preMultiplySelf(elMatrix);
        }
      });
      return matrix;
    }
    remove() {
      this.traverseUp(($el, i) => {
        this.inlineTransforms[i] = $el.style.transform;
        $el.style.transform = "none";
      });
    }
    revert() {
      this.traverseUp(($el, i) => {
        const ct = this.inlineTransforms[i];
        if (ct === "") {
          $el.style.removeProperty("transform");
        } else {
          $el.style.transform = ct;
        }
      });
    }
  };
  var parseDraggableFunctionParameter = (value, draggable) => value && isFnc(value) ? (
    /** @type {Function} */
    value(draggable)
  ) : (
    /** @type {T} */
    value
  );
  var zIndex = 0;
  var Draggable = class {
    /**
     * @param {TargetsParam} target
     * @param {DraggableParams} [parameters]
     */
    constructor(target, parameters = {}) {
      if (!target) return;
      if (scope.current) scope.current.register(this);
      const paramX = parameters.x;
      const paramY = parameters.y;
      const trigger = parameters.trigger;
      const modifier = parameters.modifier;
      const ease = parameters.releaseEase;
      const customEase = ease && parseEase(ease);
      const hasSpring = !isUnd(ease) && !isUnd(
        /** @type {Spring} */
        ease.ease
      );
      const xProp = (
        /** @type {String} */
        isObj(paramX) && !isUnd(
          /** @type {Object} */
          paramX.mapTo
        ) ? (
          /** @type {Object} */
          paramX.mapTo
        ) : "translateX"
      );
      const yProp = (
        /** @type {String} */
        isObj(paramY) && !isUnd(
          /** @type {Object} */
          paramY.mapTo
        ) ? (
          /** @type {Object} */
          paramY.mapTo
        ) : "translateY"
      );
      const container = parseDraggableFunctionParameter(parameters.container, this);
      this.containerArray = isArr(container) ? container : null;
      this.$container = /** @type {HTMLElement} */
      container && !this.containerArray ? parseTargets(
        /** @type {DOMTarget} */
        container
      )[0] : doc.body;
      this.useWin = this.$container === doc.body;
      this.$scrollContainer = this.useWin ? win : this.$container;
      this.$target = /** @type {HTMLElement} */
      isObj(target) ? new DOMProxy(target) : parseTargets(target)[0];
      this.$trigger = /** @type {HTMLElement} */
      parseTargets(trigger ? trigger : target)[0];
      this.fixed = get(this.$target, "position") === "fixed";
      this.isFinePointer = true;
      this.containerPadding = [0, 0, 0, 0];
      this.containerFriction = 0;
      this.releaseContainerFriction = 0;
      this.snapX = 0;
      this.snapY = 0;
      this.scrollSpeed = 0;
      this.scrollThreshold = 0;
      this.dragSpeed = 0;
      this.dragThreshold = 3;
      this.maxVelocity = 0;
      this.minVelocity = 0;
      this.velocityMultiplier = 0;
      this.cursor = false;
      this.releaseXSpring = hasSpring ? (
        /** @type {Spring} */
        ease
      ) : spring({
        mass: setValue(parameters.releaseMass, 1),
        stiffness: setValue(parameters.releaseStiffness, 80),
        damping: setValue(parameters.releaseDamping, 20)
      });
      this.releaseYSpring = hasSpring ? (
        /** @type {Spring} */
        ease
      ) : spring({
        mass: setValue(parameters.releaseMass, 1),
        stiffness: setValue(parameters.releaseStiffness, 80),
        damping: setValue(parameters.releaseDamping, 20)
      });
      this.releaseEase = customEase || eases.outQuint;
      this.hasReleaseSpring = hasSpring;
      this.onGrab = parameters.onGrab || noop;
      this.onDrag = parameters.onDrag || noop;
      this.onRelease = parameters.onRelease || noop;
      this.onUpdate = parameters.onUpdate || noop;
      this.onSettle = parameters.onSettle || noop;
      this.onSnap = parameters.onSnap || noop;
      this.onResize = parameters.onResize || noop;
      this.onAfterResize = parameters.onAfterResize || noop;
      this.disabled = [0, 0];
      const animatableParams = {};
      if (modifier) animatableParams.modifier = modifier;
      if (isUnd(paramX) || paramX === true) {
        animatableParams[xProp] = 0;
      } else if (isObj(paramX)) {
        const paramXObject = (
          /** @type {DraggableAxisParam} */
          paramX
        );
        const animatableXParams = {};
        if (paramXObject.modifier) animatableXParams.modifier = paramXObject.modifier;
        if (paramXObject.composition) animatableXParams.composition = paramXObject.composition;
        animatableParams[xProp] = animatableXParams;
      } else if (paramX === false) {
        animatableParams[xProp] = 0;
        this.disabled[0] = 1;
      }
      if (isUnd(paramY) || paramY === true) {
        animatableParams[yProp] = 0;
      } else if (isObj(paramY)) {
        const paramYObject = (
          /** @type {DraggableAxisParam} */
          paramY
        );
        const animatableYParams = {};
        if (paramYObject.modifier) animatableYParams.modifier = paramYObject.modifier;
        if (paramYObject.composition) animatableYParams.composition = paramYObject.composition;
        animatableParams[yProp] = animatableYParams;
      } else if (paramY === false) {
        animatableParams[yProp] = 0;
        this.disabled[1] = 1;
      }
      this.animate = /** @type {AnimatableObject} */
      new Animatable(this.$target, animatableParams);
      this.xProp = xProp;
      this.yProp = yProp;
      this.destX = 0;
      this.destY = 0;
      this.deltaX = 0;
      this.deltaY = 0;
      this.scroll = { x: 0, y: 0 };
      this.coords = [this.x, this.y, 0, 0];
      this.snapped = [0, 0];
      this.pointer = [0, 0, 0, 0, 0, 0, 0, 0];
      this.scrollView = [0, 0];
      this.dragArea = [0, 0, 0, 0];
      this.containerBounds = [-maxValue, maxValue, maxValue, -maxValue];
      this.scrollBounds = [0, 0, 0, 0];
      this.targetBounds = [0, 0, 0, 0];
      this.window = [0, 0];
      this.velocityStack = [0, 0, 0];
      this.velocityStackIndex = 0;
      this.velocityTime = now();
      this.velocity = 0;
      this.angle = 0;
      this.cursorStyles = null;
      this.triggerStyles = null;
      this.bodyStyles = null;
      this.targetStyles = null;
      this.touchActionStyles = null;
      this.transforms = new Transforms(this.$target);
      this.overshootCoords = { x: 0, y: 0 };
      this.overshootTicker = new Timer({
        autoplay: false,
        onUpdate: () => {
          this.updated = true;
          this.manual = true;
          if (!this.disabled[0]) this.animate[this.xProp](this.overshootCoords.x, 1);
          if (!this.disabled[1]) this.animate[this.yProp](this.overshootCoords.y, 1);
        },
        onComplete: () => {
          this.manual = false;
          if (!this.disabled[0]) this.animate[this.xProp](this.overshootCoords.x, 0);
          if (!this.disabled[1]) this.animate[this.yProp](this.overshootCoords.y, 0);
        }
      }, null, 0).init();
      this.updateTicker = new Timer({ autoplay: false, onUpdate: () => this.update() }, null, 0).init();
      this.contained = !isUnd(container);
      this.manual = false;
      this.grabbed = false;
      this.dragged = false;
      this.updated = false;
      this.released = false;
      this.canScroll = false;
      this.enabled = false;
      this.initialized = false;
      this.activeProp = this.disabled[1] ? xProp : yProp;
      this.animate.callbacks.onRender = () => {
        const hasUpdated = this.updated;
        const hasMoved = this.grabbed && hasUpdated;
        const hasReleased = !hasMoved && this.released;
        const x = this.x;
        const y = this.y;
        const dx = x - this.coords[2];
        const dy = y - this.coords[3];
        this.deltaX = dx;
        this.deltaY = dy;
        this.coords[2] = x;
        this.coords[3] = y;
        if (hasUpdated && (dx || dy)) {
          this.onUpdate(this);
        }
        if (!hasReleased) {
          this.updated = false;
        } else {
          this.computeVelocity(dx, dy);
          this.angle = atan2(dy, dx);
        }
      };
      this.animate.callbacks.onComplete = () => {
        if (!this.grabbed && this.released) {
          this.released = false;
        }
        if (!this.manual) {
          this.deltaX = 0;
          this.deltaY = 0;
          this.velocity = 0;
          this.velocityStack[0] = 0;
          this.velocityStack[1] = 0;
          this.velocityStack[2] = 0;
          this.velocityStackIndex = 0;
          this.onSettle(this);
        }
      };
      this.resizeTicker = new Timer({
        autoplay: false,
        duration: 150 * globals.timeScale,
        onComplete: () => {
          this.onResize(this);
          this.refresh();
          this.onAfterResize(this);
        }
      }).init();
      this.parameters = parameters;
      this.resizeObserver = new ResizeObserver(() => {
        if (this.initialized) {
          this.resizeTicker.restart();
        } else {
          this.initialized = true;
        }
      });
      this.enable();
      this.refresh();
      this.resizeObserver.observe(this.$container);
      if (!isObj(target)) this.resizeObserver.observe(this.$target);
    }
    /**
     * @param  {Number} dx
     * @param  {Number} dy
     * @return {Number}
     */
    computeVelocity(dx, dy) {
      const prevTime = this.velocityTime;
      const curTime = now();
      const elapsed = curTime - prevTime;
      if (elapsed < 17) return this.velocity;
      this.velocityTime = curTime;
      const velocityStack = this.velocityStack;
      const vMul = this.velocityMultiplier;
      const minV = this.minVelocity;
      const maxV = this.maxVelocity;
      const vi = this.velocityStackIndex;
      velocityStack[vi] = round(clamp(sqrt(dx * dx + dy * dy) / elapsed * vMul, minV, maxV), 5);
      const velocity = max(velocityStack[0], velocityStack[1], velocityStack[2]);
      this.velocity = velocity;
      this.velocityStackIndex = (vi + 1) % 3;
      return velocity;
    }
    /**
     * @param {Number}  x
     * @param {Boolean} [muteUpdateCallback]
     * @return {this}
     */
    setX(x, muteUpdateCallback = false) {
      if (this.disabled[0]) return;
      const v = round(x, 5);
      this.overshootTicker.pause();
      this.manual = true;
      this.updated = !muteUpdateCallback;
      this.destX = v;
      this.snapped[0] = snap(v, this.snapX);
      this.animate[this.xProp](v, 0);
      this.manual = false;
      return this;
    }
    /**
     * @param {Number}  y
     * @param {Boolean} [muteUpdateCallback]
     * @return {this}
     */
    setY(y, muteUpdateCallback = false) {
      if (this.disabled[1]) return;
      const v = round(y, 5);
      this.overshootTicker.pause();
      this.manual = true;
      this.updated = !muteUpdateCallback;
      this.destY = v;
      this.snapped[1] = snap(v, this.snapY);
      this.animate[this.yProp](v, 0);
      this.manual = false;
      return this;
    }
    get x() {
      return round(
        /** @type {Number} */
        this.animate[this.xProp](),
        globals.precision
      );
    }
    set x(x) {
      this.setX(x, false);
    }
    get y() {
      return round(
        /** @type {Number} */
        this.animate[this.yProp](),
        globals.precision
      );
    }
    set y(y) {
      this.setY(y, false);
    }
    get progressX() {
      return mapRange(this.x, this.containerBounds[3], this.containerBounds[1], 0, 1);
    }
    set progressX(x) {
      this.setX(mapRange(x, 0, 1, this.containerBounds[3], this.containerBounds[1]), false);
    }
    get progressY() {
      return mapRange(this.y, this.containerBounds[0], this.containerBounds[2], 0, 1);
    }
    set progressY(y) {
      this.setY(mapRange(y, 0, 1, this.containerBounds[0], this.containerBounds[2]), false);
    }
    updateScrollCoords() {
      const sx = round(this.useWin ? win.scrollX : this.$container.scrollLeft, 0);
      const sy = round(this.useWin ? win.scrollY : this.$container.scrollTop, 0);
      const [cpt, cpr, cpb, cpl] = this.containerPadding;
      const threshold = this.scrollThreshold;
      this.scroll.x = sx;
      this.scroll.y = sy;
      this.scrollBounds[0] = sy - this.targetBounds[0] + cpt - threshold;
      this.scrollBounds[1] = sx - this.targetBounds[1] - cpr + threshold;
      this.scrollBounds[2] = sy - this.targetBounds[2] - cpb + threshold;
      this.scrollBounds[3] = sx - this.targetBounds[3] + cpl - threshold;
    }
    updateBoundingValues() {
      const $container = this.$container;
      if (!$container) return;
      const cx = this.x;
      const cy = this.y;
      const cx2 = this.coords[2];
      const cy2 = this.coords[3];
      this.coords[2] = 0;
      this.coords[3] = 0;
      this.setX(0, true);
      this.setY(0, true);
      this.transforms.remove();
      const iw = this.window[0] = win.innerWidth;
      const ih = this.window[1] = win.innerHeight;
      const uw = this.useWin;
      const sw = $container.scrollWidth;
      const sh = $container.scrollHeight;
      const fx2 = this.fixed;
      const transformContainerRect = $container.getBoundingClientRect();
      const [cpt, cpr, cpb, cpl] = this.containerPadding;
      this.dragArea[0] = uw ? 0 : transformContainerRect.left;
      this.dragArea[1] = uw ? 0 : transformContainerRect.top;
      this.scrollView[0] = uw ? clamp(sw, iw, sw) : sw;
      this.scrollView[1] = uw ? clamp(sh, ih, sh) : sh;
      this.updateScrollCoords();
      const { width, height, left, top, right, bottom } = $container.getBoundingClientRect();
      this.dragArea[2] = round(uw ? clamp(width, iw, iw) : width, 0);
      this.dragArea[3] = round(uw ? clamp(height, ih, ih) : height, 0);
      const containerOverflow = get($container, "overflow");
      const visibleOverflow = containerOverflow === "visible";
      const hiddenOverflow = containerOverflow === "hidden";
      this.canScroll = fx2 ? false : this.contained && ($container === doc.body && visibleOverflow || !hiddenOverflow && !visibleOverflow) && (sw > this.dragArea[2] + cpl - cpr || sh > this.dragArea[3] + cpt - cpb) && (!this.containerArray || this.containerArray && !isArr(this.containerArray));
      if (this.contained) {
        const sx = this.scroll.x;
        const sy = this.scroll.y;
        const canScroll = this.canScroll;
        const targetRect = this.$target.getBoundingClientRect();
        const hiddenLeft = canScroll ? uw ? 0 : $container.scrollLeft : 0;
        const hiddenTop = canScroll ? uw ? 0 : $container.scrollTop : 0;
        const hiddenRight = canScroll ? this.scrollView[0] - hiddenLeft - width : 0;
        const hiddenBottom = canScroll ? this.scrollView[1] - hiddenTop - height : 0;
        this.targetBounds[0] = round(targetRect.top + sy - (uw ? 0 : top), 0);
        this.targetBounds[1] = round(targetRect.right + sx - (uw ? iw : right), 0);
        this.targetBounds[2] = round(targetRect.bottom + sy - (uw ? ih : bottom), 0);
        this.targetBounds[3] = round(targetRect.left + sx - (uw ? 0 : left), 0);
        if (this.containerArray) {
          this.containerBounds[0] = this.containerArray[0] + cpt;
          this.containerBounds[1] = this.containerArray[1] - cpr;
          this.containerBounds[2] = this.containerArray[2] - cpb;
          this.containerBounds[3] = this.containerArray[3] + cpl;
        } else {
          this.containerBounds[0] = -round(targetRect.top - (fx2 ? clamp(top, 0, ih) : top) + hiddenTop - cpt, 0);
          this.containerBounds[1] = -round(targetRect.right - (fx2 ? clamp(right, 0, iw) : right) - hiddenRight + cpr, 0);
          this.containerBounds[2] = -round(targetRect.bottom - (fx2 ? clamp(bottom, 0, ih) : bottom) - hiddenBottom + cpb, 0);
          this.containerBounds[3] = -round(targetRect.left - (fx2 ? clamp(left, 0, iw) : left) + hiddenLeft - cpl, 0);
        }
      }
      this.transforms.revert();
      this.coords[2] = cx2;
      this.coords[3] = cy2;
      this.setX(cx, true);
      this.setY(cy, true);
    }
    /**
     * @param  {Array} bounds
     * @param  {Number} x
     * @param  {Number} y
     * @return {Number}
     */
    isOutOfBounds(bounds, x, y) {
      if (!this.contained) return 0;
      const [bt, br, bb, bl] = bounds;
      const [dx, dy] = this.disabled;
      const obx = !dx && x < bl || !dx && x > br;
      const oby = !dy && y < bt || !dy && y > bb;
      return obx && !oby ? 1 : !obx && oby ? 2 : obx && oby ? 3 : 0;
    }
    refresh() {
      const params = this.parameters;
      const paramX = params.x;
      const paramY = params.y;
      const container = parseDraggableFunctionParameter(params.container, this);
      const cp = parseDraggableFunctionParameter(params.containerPadding, this) || 0;
      const containerPadding = (
        /** @type {[Number, Number, Number, Number]} */
        isArr(cp) ? cp : [cp, cp, cp, cp]
      );
      const cx = this.x;
      const cy = this.y;
      const parsedCursorStyles = parseDraggableFunctionParameter(params.cursor, this);
      const cursorStyles = { onHover: "grab", onGrab: "grabbing" };
      if (parsedCursorStyles) {
        const { onHover, onGrab } = (
          /** @type {DraggableCursorParams} */
          parsedCursorStyles
        );
        if (onHover) cursorStyles.onHover = onHover;
        if (onGrab) cursorStyles.onGrab = onGrab;
      }
      const parsedDragThreshold = parseDraggableFunctionParameter(params.dragThreshold, this);
      const dragThreshold = { mouse: 3, touch: 7 };
      if (isNum(parsedDragThreshold)) {
        dragThreshold.mouse = parsedDragThreshold;
        dragThreshold.touch = parsedDragThreshold;
      } else if (parsedDragThreshold) {
        const { mouse, touch } = parsedDragThreshold;
        if (!isUnd(mouse)) dragThreshold.mouse = mouse;
        if (!isUnd(touch)) dragThreshold.touch = touch;
      }
      this.containerArray = isArr(container) ? container : null;
      this.$container = /** @type {HTMLElement} */
      container && !this.containerArray ? parseTargets(
        /** @type {DOMTarget} */
        container
      )[0] : doc.body;
      this.useWin = this.$container === doc.body;
      this.$scrollContainer = this.useWin ? win : this.$container;
      this.isFinePointer = matchMedia("(pointer:fine)").matches;
      this.containerPadding = setValue(containerPadding, [0, 0, 0, 0]);
      this.containerFriction = clamp(setValue(parseDraggableFunctionParameter(params.containerFriction, this), 0.8), 0, 1);
      this.releaseContainerFriction = clamp(setValue(parseDraggableFunctionParameter(params.releaseContainerFriction, this), this.containerFriction), 0, 1);
      this.snapX = parseDraggableFunctionParameter(isObj(paramX) && !isUnd(paramX.snap) ? paramX.snap : params.snap, this);
      this.snapY = parseDraggableFunctionParameter(isObj(paramY) && !isUnd(paramY.snap) ? paramY.snap : params.snap, this);
      this.scrollSpeed = setValue(parseDraggableFunctionParameter(params.scrollSpeed, this), 1.5);
      this.scrollThreshold = setValue(parseDraggableFunctionParameter(params.scrollThreshold, this), 20);
      this.dragSpeed = setValue(parseDraggableFunctionParameter(params.dragSpeed, this), 1);
      this.dragThreshold = this.isFinePointer ? dragThreshold.mouse : dragThreshold.touch;
      this.minVelocity = setValue(parseDraggableFunctionParameter(params.minVelocity, this), 0);
      this.maxVelocity = setValue(parseDraggableFunctionParameter(params.maxVelocity, this), 50);
      this.velocityMultiplier = setValue(parseDraggableFunctionParameter(params.velocityMultiplier, this), 1);
      this.cursor = parsedCursorStyles === false ? false : cursorStyles;
      this.updateBoundingValues();
      const [bt, br, bb, bl] = this.containerBounds;
      this.setX(clamp(cx, bl, br), true);
      this.setY(clamp(cy, bt, bb), true);
    }
    update() {
      this.updateScrollCoords();
      if (this.canScroll) {
        const [cpt, cpr, cpb, cpl] = this.containerPadding;
        const [sw, sh] = this.scrollView;
        const daw = this.dragArea[2];
        const dah = this.dragArea[3];
        const csx = this.scroll.x;
        const csy = this.scroll.y;
        const nsw = this.$container.scrollWidth;
        const nsh = this.$container.scrollHeight;
        const csw = this.useWin ? clamp(nsw, this.window[0], nsw) : nsw;
        const csh = this.useWin ? clamp(nsh, this.window[1], nsh) : nsh;
        const swd = sw - csw;
        const shd = sh - csh;
        if (this.dragged && swd > 0) {
          this.coords[0] -= swd;
          this.scrollView[0] = csw;
        }
        if (this.dragged && shd > 0) {
          this.coords[1] -= shd;
          this.scrollView[1] = csh;
        }
        const s = this.scrollSpeed * 10;
        const threshold = this.scrollThreshold;
        const [x, y] = this.coords;
        const [st, sr, sb, sl] = this.scrollBounds;
        const t = round(clamp((y - st + cpt) / threshold, -1, 0) * s, 0);
        const r = round(clamp((x - sr - cpr) / threshold, 0, 1) * s, 0);
        const b = round(clamp((y - sb - cpb) / threshold, 0, 1) * s, 0);
        const l = round(clamp((x - sl + cpl) / threshold, -1, 0) * s, 0);
        if (t || b || l || r) {
          const [nx, ny] = this.disabled;
          let scrollX = csx;
          let scrollY = csy;
          if (!nx) {
            scrollX = round(clamp(csx + (l || r), 0, sw - daw), 0);
            this.coords[0] -= csx - scrollX;
          }
          if (!ny) {
            scrollY = round(clamp(csy + (t || b), 0, sh - dah), 0);
            this.coords[1] -= csy - scrollY;
          }
          if (this.useWin) {
            this.$scrollContainer.scrollBy(-(csx - scrollX), -(csy - scrollY));
          } else {
            this.$scrollContainer.scrollTo(scrollX, scrollY);
          }
        }
      }
      const [ct, cr, cb, cl] = this.containerBounds;
      const [px1, py1, px2, py2, px3, py3] = this.pointer;
      this.coords[0] += (px1 - px3) * this.dragSpeed;
      this.coords[1] += (py1 - py3) * this.dragSpeed;
      this.pointer[4] = px1;
      this.pointer[5] = py1;
      const [cx, cy] = this.coords;
      const [sx, sy] = this.snapped;
      const cf = (1 - this.containerFriction) * this.dragSpeed;
      this.setX(cx > cr ? cr + (cx - cr) * cf : cx < cl ? cl + (cx - cl) * cf : cx, false);
      this.setY(cy > cb ? cb + (cy - cb) * cf : cy < ct ? ct + (cy - ct) * cf : cy, false);
      this.computeVelocity(px1 - px3, py1 - py3);
      this.angle = atan2(py1 - py2, px1 - px2);
      const [nsx, nsy] = this.snapped;
      if (nsx !== sx && this.snapX || nsy !== sy && this.snapY) {
        this.onSnap(this);
      }
    }
    stop() {
      this.updateTicker.pause();
      this.overshootTicker.pause();
      for (let prop in this.animate.animations) this.animate.animations[prop].pause();
      removeTargetsFromRenderable([this], null, "x");
      removeTargetsFromRenderable([this], null, "y");
      removeTargetsFromRenderable([this], null, "progressX");
      removeTargetsFromRenderable([this], null, "progressY");
      removeTargetsFromRenderable([this.scroll]);
      removeTargetsFromRenderable([this.overshootCoords]);
      return this;
    }
    /**
     * @param {Number} [duration]
     * @param {Number} [gap]
     * @param {EasingParam} [ease]
     * @return {this}
     */
    scrollInView(duration, gap = 0, ease = eases.inOutQuad) {
      this.updateScrollCoords();
      const x = this.destX;
      const y = this.destY;
      const scroll = this.scroll;
      const scrollBounds = this.scrollBounds;
      const canScroll = this.canScroll;
      if (!this.containerArray && this.isOutOfBounds(scrollBounds, x, y)) {
        const [st, sr, sb, sl] = scrollBounds;
        const t = round(clamp(y - st, -maxValue, 0), 0);
        const r = round(clamp(x - sr, 0, maxValue), 0);
        const b = round(clamp(y - sb, 0, maxValue), 0);
        const l = round(clamp(x - sl, -maxValue, 0), 0);
        new JSAnimation(scroll, {
          x: round(scroll.x + (l ? l - gap : r ? r + gap : 0), 0),
          y: round(scroll.y + (t ? t - gap : b ? b + gap : 0), 0),
          duration: isUnd(duration) ? 350 * globals.timeScale : duration,
          ease,
          onUpdate: () => {
            this.canScroll = false;
            this.$scrollContainer.scrollTo(scroll.x, scroll.y);
          }
        }).init().then(() => {
          this.canScroll = canScroll;
        });
      }
      return this;
    }
    handleHover() {
      if (this.isFinePointer && this.cursor && !this.cursorStyles) {
        this.cursorStyles = set(this.$trigger, {
          cursor: (
            /** @type {DraggableCursorParams} */
            this.cursor.onHover
          )
        });
      }
    }
    /**
     * @param  {Number} [duration]
     * @param  {Number} [gap]
     * @param  {EasingParam} [ease]
     * @return {this}
     */
    animateInView(duration, gap = 0, ease = eases.inOutQuad) {
      this.stop();
      this.updateBoundingValues();
      const x = this.x;
      const y = this.y;
      const [cpt, cpr, cpb, cpl] = this.containerPadding;
      const bt = this.scroll.y - this.targetBounds[0] + cpt + gap;
      const br = this.scroll.x - this.targetBounds[1] - cpr - gap;
      const bb = this.scroll.y - this.targetBounds[2] - cpb - gap;
      const bl = this.scroll.x - this.targetBounds[3] + cpl + gap;
      const ob = this.isOutOfBounds([bt, br, bb, bl], x, y);
      if (ob) {
        const [disabledX, disabledY] = this.disabled;
        const destX = clamp(snap(x, this.snapX), bl, br);
        const destY = clamp(snap(y, this.snapY), bt, bb);
        const dur = isUnd(duration) ? 350 * globals.timeScale : duration;
        if (!disabledX && (ob === 1 || ob === 3)) this.animate[this.xProp](destX, dur, ease);
        if (!disabledY && (ob === 2 || ob === 3)) this.animate[this.yProp](destY, dur, ease);
      }
      return this;
    }
    /**
     * @param {MouseEvent|TouchEvent} e
     */
    handleDown(e) {
      const $eTarget = (
        /** @type {HTMLElement} */
        e.target
      );
      if (this.grabbed || /** @type {HTMLInputElement} */
      $eTarget.type === "range") return;
      e.stopPropagation();
      this.grabbed = true;
      this.released = false;
      this.stop();
      this.updateBoundingValues();
      const touches = (
        /** @type {TouchEvent} */
        e.changedTouches
      );
      const eventX = touches ? touches[0].clientX : (
        /** @type {MouseEvent} */
        e.clientX
      );
      const eventY = touches ? touches[0].clientY : (
        /** @type {MouseEvent} */
        e.clientY
      );
      const { x, y } = this.transforms.normalizePoint(eventX, eventY);
      const [ct, cr, cb, cl] = this.containerBounds;
      const cf = (1 - this.containerFriction) * this.dragSpeed;
      const cx = this.x;
      const cy = this.y;
      this.coords[0] = this.coords[2] = !cf ? cx : cx > cr ? cr + (cx - cr) / cf : cx < cl ? cl + (cx - cl) / cf : cx;
      this.coords[1] = this.coords[3] = !cf ? cy : cy > cb ? cb + (cy - cb) / cf : cy < ct ? ct + (cy - ct) / cf : cy;
      this.pointer[0] = x;
      this.pointer[1] = y;
      this.pointer[2] = x;
      this.pointer[3] = y;
      this.pointer[4] = x;
      this.pointer[5] = y;
      this.pointer[6] = x;
      this.pointer[7] = y;
      this.deltaX = 0;
      this.deltaY = 0;
      this.velocity = 0;
      this.velocityStack[0] = 0;
      this.velocityStack[1] = 0;
      this.velocityStack[2] = 0;
      this.velocityStackIndex = 0;
      this.angle = 0;
      if (this.targetStyles) {
        this.targetStyles.revert();
        this.targetStyles = null;
      }
      const z = (
        /** @type {Number} */
        get(this.$target, "zIndex", false)
      );
      zIndex = (z > zIndex ? z : zIndex) + 1;
      this.targetStyles = set(this.$target, { zIndex });
      if (this.triggerStyles) {
        this.triggerStyles.revert();
        this.triggerStyles = null;
      }
      if (this.cursorStyles) {
        this.cursorStyles.revert();
        this.cursorStyles = null;
      }
      if (this.isFinePointer && this.cursor) {
        this.bodyStyles = set(doc.body, {
          cursor: (
            /** @type {DraggableCursorParams} */
            this.cursor.onGrab
          )
        });
      }
      this.scrollInView(100, 0, eases.out(3));
      this.onGrab(this);
      doc.addEventListener("touchmove", this);
      doc.addEventListener("touchend", this);
      doc.addEventListener("touchcancel", this);
      doc.addEventListener("mousemove", this);
      doc.addEventListener("mouseup", this);
      doc.addEventListener("selectstart", this);
    }
    /**
     * @param {MouseEvent|TouchEvent} e
     */
    handleMove(e) {
      if (!this.grabbed) return;
      const touches = (
        /** @type {TouchEvent} */
        e.changedTouches
      );
      const eventX = touches ? touches[0].clientX : (
        /** @type {MouseEvent} */
        e.clientX
      );
      const eventY = touches ? touches[0].clientY : (
        /** @type {MouseEvent} */
        e.clientY
      );
      const { x, y } = this.transforms.normalizePoint(eventX, eventY);
      const movedX = x - this.pointer[6];
      const movedY = y - this.pointer[7];
      let $parent = (
        /** @type {HTMLElement} */
        e.target
      );
      let isAtTop = false;
      let isAtBottom = false;
      let canTouchScroll = false;
      while (touches && $parent && $parent !== this.$trigger) {
        const overflowY = get($parent, "overflow-y");
        if (overflowY !== "hidden" && overflowY !== "visible") {
          const { scrollTop, scrollHeight, clientHeight } = $parent;
          if (scrollHeight > clientHeight) {
            canTouchScroll = true;
            isAtTop = scrollTop <= 3;
            isAtBottom = scrollTop >= scrollHeight - clientHeight - 3;
            break;
          }
        }
        $parent = $parent.parentElement;
      }
      if (canTouchScroll && (!isAtTop && !isAtBottom || isAtTop && movedY < 0 || isAtBottom && movedY > 0)) {
        this.pointer[0] = x;
        this.pointer[1] = y;
        this.pointer[2] = x;
        this.pointer[3] = y;
        this.pointer[4] = x;
        this.pointer[5] = y;
        this.pointer[6] = x;
        this.pointer[7] = y;
      } else {
        preventDefault(e);
        if (!this.triggerStyles) this.triggerStyles = set(this.$trigger, { pointerEvents: "none" });
        this.$trigger.addEventListener("touchstart", preventDefault, { passive: false });
        this.$trigger.addEventListener("touchmove", preventDefault, { passive: false });
        this.$trigger.addEventListener("touchend", preventDefault);
        if (this.dragged || !this.disabled[0] && abs(movedX) > this.dragThreshold || !this.disabled[1] && abs(movedY) > this.dragThreshold) {
          this.updateTicker.resume();
          this.pointer[2] = this.pointer[0];
          this.pointer[3] = this.pointer[1];
          this.pointer[0] = x;
          this.pointer[1] = y;
          this.dragged = true;
          this.released = false;
          this.onDrag(this);
        }
      }
    }
    handleUp() {
      if (!this.grabbed) return;
      this.updateTicker.pause();
      if (this.triggerStyles) {
        this.triggerStyles.revert();
        this.triggerStyles = null;
      }
      if (this.bodyStyles) {
        this.bodyStyles.revert();
        this.bodyStyles = null;
      }
      const [disabledX, disabledY] = this.disabled;
      const [px1, py1, px2, py2, px3, py3] = this.pointer;
      const [ct, cr, cb, cl] = this.containerBounds;
      const [sx, sy] = this.snapped;
      const springX = this.releaseXSpring;
      const springY = this.releaseYSpring;
      const releaseEase = this.releaseEase;
      const hasReleaseSpring = this.hasReleaseSpring;
      const overshootCoords = this.overshootCoords;
      const cx = this.x;
      const cy = this.y;
      const pv = this.computeVelocity(px1 - px3, py1 - py3);
      const pa = this.angle = atan2(py1 - py2, px1 - px2);
      const ds = pv * 150;
      const cf = (1 - this.releaseContainerFriction) * this.dragSpeed;
      const nx = cx + cos(pa) * ds;
      const ny = cy + sin(pa) * ds;
      const bx = nx > cr ? cr + (nx - cr) * cf : nx < cl ? cl + (nx - cl) * cf : nx;
      const by = ny > cb ? cb + (ny - cb) * cf : ny < ct ? ct + (ny - ct) * cf : ny;
      const dx = this.destX = clamp(round(snap(bx, this.snapX), 5), cl, cr);
      const dy = this.destY = clamp(round(snap(by, this.snapY), 5), ct, cb);
      const ob = this.isOutOfBounds(this.containerBounds, nx, ny);
      let durationX = 0;
      let durationY = 0;
      let easeX = releaseEase;
      let easeY = releaseEase;
      let longestReleaseDuration = 0;
      overshootCoords.x = cx;
      overshootCoords.y = cy;
      if (!disabledX) {
        const directionX = dx === cr ? cx > cr ? -1 : 1 : cx < cl ? -1 : 1;
        const distanceX = round(cx - dx, 0);
        springX.velocity = disabledY && hasReleaseSpring ? distanceX ? ds * directionX / abs(distanceX) : 0 : pv;
        const { ease, settlingDuration, restDuration } = springX;
        durationX = cx === dx ? 0 : hasReleaseSpring ? settlingDuration : settlingDuration - restDuration * globals.timeScale;
        if (hasReleaseSpring) easeX = ease;
        if (durationX > longestReleaseDuration) longestReleaseDuration = durationX;
      }
      if (!disabledY) {
        const directionY = dy === cb ? cy > cb ? -1 : 1 : cy < ct ? -1 : 1;
        const distanceY = round(cy - dy, 0);
        springY.velocity = disabledX && hasReleaseSpring ? distanceY ? ds * directionY / abs(distanceY) : 0 : pv;
        const { ease, settlingDuration, restDuration } = springY;
        durationY = cy === dy ? 0 : hasReleaseSpring ? settlingDuration : settlingDuration - restDuration * globals.timeScale;
        if (hasReleaseSpring) easeY = ease;
        if (durationY > longestReleaseDuration) longestReleaseDuration = durationY;
      }
      if (!hasReleaseSpring && ob && cf && (durationX || durationY)) {
        const composition = compositionTypes.blend;
        new JSAnimation(overshootCoords, {
          x: { to: bx, duration: durationX * 0.65 },
          y: { to: by, duration: durationY * 0.65 },
          ease: releaseEase,
          composition
        }).init();
        new JSAnimation(overshootCoords, {
          x: { to: dx, duration: durationX },
          y: { to: dy, duration: durationY },
          ease: releaseEase,
          composition
        }).init();
        this.overshootTicker.stretch(max(durationX, durationY)).restart();
      } else {
        if (!disabledX) this.animate[this.xProp](dx, durationX, easeX);
        if (!disabledY) this.animate[this.yProp](dy, durationY, easeY);
      }
      this.scrollInView(longestReleaseDuration, this.scrollThreshold, releaseEase);
      let hasSnapped = false;
      if (dx !== sx) {
        this.snapped[0] = dx;
        if (this.snapX) hasSnapped = true;
      }
      if (dy !== sy && this.snapY) {
        this.snapped[1] = dy;
        if (this.snapY) hasSnapped = true;
      }
      if (hasSnapped) this.onSnap(this);
      this.grabbed = false;
      this.dragged = false;
      this.updated = true;
      this.released = true;
      this.onRelease(this);
      this.$trigger.removeEventListener("touchstart", preventDefault);
      this.$trigger.removeEventListener("touchmove", preventDefault);
      this.$trigger.removeEventListener("touchend", preventDefault);
      doc.removeEventListener("touchmove", this);
      doc.removeEventListener("touchend", this);
      doc.removeEventListener("touchcancel", this);
      doc.removeEventListener("mousemove", this);
      doc.removeEventListener("mouseup", this);
      doc.removeEventListener("selectstart", this);
    }
    reset() {
      this.stop();
      this.resizeTicker.pause();
      this.grabbed = false;
      this.dragged = false;
      this.updated = false;
      this.released = false;
      this.canScroll = false;
      this.setX(0, true);
      this.setY(0, true);
      this.coords[0] = 0;
      this.coords[1] = 0;
      this.pointer[0] = 0;
      this.pointer[1] = 0;
      this.pointer[2] = 0;
      this.pointer[3] = 0;
      this.pointer[4] = 0;
      this.pointer[5] = 0;
      this.pointer[6] = 0;
      this.pointer[7] = 0;
      this.velocity = 0;
      this.velocityStack[0] = 0;
      this.velocityStack[1] = 0;
      this.velocityStack[2] = 0;
      this.velocityStackIndex = 0;
      this.angle = 0;
      return this;
    }
    enable() {
      if (!this.enabled) {
        this.enabled = true;
        this.$target.classList.remove("is-disabled");
        this.touchActionStyles = set(this.$trigger, {
          touchAction: this.disabled[0] ? "pan-x" : this.disabled[1] ? "pan-y" : "none"
        });
        this.$trigger.addEventListener("touchstart", this, { passive: true });
        this.$trigger.addEventListener("mousedown", this, { passive: true });
        this.$trigger.addEventListener("mouseenter", this);
      }
      return this;
    }
    disable() {
      this.enabled = false;
      this.grabbed = false;
      this.dragged = false;
      this.updated = false;
      this.released = false;
      this.canScroll = false;
      this.touchActionStyles.revert();
      if (this.cursorStyles) {
        this.cursorStyles.revert();
        this.cursorStyles = null;
      }
      if (this.triggerStyles) {
        this.triggerStyles.revert();
        this.triggerStyles = null;
      }
      if (this.bodyStyles) {
        this.bodyStyles.revert();
        this.bodyStyles = null;
      }
      if (this.targetStyles) {
        this.targetStyles.revert();
        this.targetStyles = null;
      }
      this.$target.classList.add("is-disabled");
      this.$trigger.removeEventListener("touchstart", this);
      this.$trigger.removeEventListener("mousedown", this);
      this.$trigger.removeEventListener("mouseenter", this);
      doc.removeEventListener("touchmove", this);
      doc.removeEventListener("touchend", this);
      doc.removeEventListener("touchcancel", this);
      doc.removeEventListener("mousemove", this);
      doc.removeEventListener("mouseup", this);
      doc.removeEventListener("selectstart", this);
      return this;
    }
    revert() {
      this.reset();
      this.disable();
      this.$target.classList.remove("is-disabled");
      this.updateTicker.revert();
      this.overshootTicker.revert();
      this.resizeTicker.revert();
      this.animate.revert();
      this.resizeObserver.disconnect();
      return this;
    }
    /**
     * @param {Event} e
     */
    handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.handleDown(
            /** @type {MouseEvent} */
            e
          );
          break;
        case "touchstart":
          this.handleDown(
            /** @type {TouchEvent} */
            e
          );
          break;
        case "mousemove":
          this.handleMove(
            /** @type {MouseEvent} */
            e
          );
          break;
        case "touchmove":
          this.handleMove(
            /** @type {TouchEvent} */
            e
          );
          break;
        case "mouseup":
          this.handleUp();
          break;
        case "touchend":
          this.handleUp();
          break;
        case "touchcancel":
          this.handleUp();
          break;
        case "mouseenter":
          this.handleHover();
          break;
        case "selectstart":
          preventDefault(e);
          break;
      }
    }
  };

  // node_modules/animejs/dist/modules/utils/time.js
  var sync = (callback = noop) => {
    return new Timer({ duration: 1 * globals.timeScale, onComplete: callback }, null, 0).resume();
  };
  var keepTime = (constructor) => {
    let tracked;
    return (
      /** @type {(...args: any[]) => T extends void ? () => void : T} */
      /** @type {*} */
      (...args) => {
        let currentIteration, currentIterationProgress, reversed, alternate, startTime;
        if (tracked) {
          currentIteration = tracked.currentIteration;
          currentIterationProgress = tracked.iterationProgress;
          reversed = tracked.reversed;
          alternate = tracked._alternate;
          startTime = tracked._startTime;
          tracked.revert();
        }
        const cleanup = constructor(...args);
        if (cleanup && !isFnc(cleanup) && cleanup.revert) tracked = cleanup;
        if (!isUnd(currentIterationProgress)) {
          tracked.currentIteration = currentIteration;
          tracked.iterationProgress = (alternate ? !(currentIteration % 2) ? reversed : !reversed : reversed) ? 1 - currentIterationProgress : currentIterationProgress;
          tracked._startTime = startTime;
        }
        return cleanup || noop;
      }
    );
  };

  // node_modules/animejs/dist/modules/events/scroll.js
  var getMaxViewHeight = () => {
    const $el = doc.createElement("div");
    doc.body.appendChild($el);
    $el.style.height = "100lvh";
    const height = $el.offsetHeight;
    doc.body.removeChild($el);
    return height;
  };
  var parseScrollObserverFunctionParameter = (value, scroller) => value && isFnc(value) ? (
    /** @type {Function} */
    value(scroller)
  ) : (
    /** @type {T} */
    value
  );
  var scrollContainers = /* @__PURE__ */ new Map();
  var ScrollContainer = class {
    /**
     * @param {HTMLElement} $el
     */
    constructor($el) {
      this.element = $el;
      this.useWin = this.element === doc.body;
      this.winWidth = 0;
      this.winHeight = 0;
      this.width = 0;
      this.height = 0;
      this.left = 0;
      this.top = 0;
      this.scale = 1;
      this.zIndex = 0;
      this.scrollX = 0;
      this.scrollY = 0;
      this.prevScrollX = 0;
      this.prevScrollY = 0;
      this.scrollWidth = 0;
      this.scrollHeight = 0;
      this.velocity = 0;
      this.backwardX = false;
      this.backwardY = false;
      this.scrollTicker = new Timer({
        autoplay: false,
        onBegin: () => this.dataTimer.resume(),
        onUpdate: () => {
          const backwards = this.backwardX || this.backwardY;
          forEachChildren(this, (child) => child.handleScroll(), backwards);
        },
        onComplete: () => this.dataTimer.pause()
      }).init();
      this.dataTimer = new Timer({
        autoplay: false,
        frameRate: 30,
        onUpdate: (self2) => {
          const dt = self2.deltaTime;
          const px = this.prevScrollX;
          const py = this.prevScrollY;
          const nx = this.scrollX;
          const ny = this.scrollY;
          const dx = px - nx;
          const dy = py - ny;
          this.prevScrollX = nx;
          this.prevScrollY = ny;
          if (dx) this.backwardX = px > nx;
          if (dy) this.backwardY = py > ny;
          this.velocity = round(dt > 0 ? Math.sqrt(dx * dx + dy * dy) / dt : 0, 5);
        }
      }).init();
      this.resizeTicker = new Timer({
        autoplay: false,
        duration: 250 * globals.timeScale,
        onComplete: () => {
          this.updateWindowBounds();
          this.refreshScrollObservers();
          this.handleScroll();
        }
      }).init();
      this.wakeTicker = new Timer({
        autoplay: false,
        duration: 500 * globals.timeScale,
        onBegin: () => {
          this.scrollTicker.resume();
        },
        onComplete: () => {
          this.scrollTicker.pause();
        }
      }).init();
      this._head = null;
      this._tail = null;
      this.updateScrollCoords();
      this.updateWindowBounds();
      this.updateBounds();
      this.refreshScrollObservers();
      this.handleScroll();
      this.resizeObserver = new ResizeObserver(() => this.resizeTicker.restart());
      this.resizeObserver.observe(this.element);
      (this.useWin ? win : this.element).addEventListener("scroll", this, false);
    }
    updateScrollCoords() {
      const useWin = this.useWin;
      const $el = this.element;
      this.scrollX = round(useWin ? win.scrollX : $el.scrollLeft, 0);
      this.scrollY = round(useWin ? win.scrollY : $el.scrollTop, 0);
    }
    updateWindowBounds() {
      this.winWidth = win.innerWidth;
      this.winHeight = getMaxViewHeight();
    }
    updateBounds() {
      const style = getComputedStyle(this.element);
      const $el = this.element;
      this.scrollWidth = $el.scrollWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      this.scrollHeight = $el.scrollHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
      this.updateWindowBounds();
      let width, height;
      if (this.useWin) {
        width = this.winWidth;
        height = this.winHeight;
      } else {
        const elRect = $el.getBoundingClientRect();
        width = $el.clientWidth;
        height = $el.clientHeight;
        this.top = elRect.top;
        this.left = elRect.left;
        this.scale = elRect.width ? width / elRect.width : elRect.height ? height / elRect.height : 1;
      }
      this.width = width;
      this.height = height;
    }
    refreshScrollObservers() {
      forEachChildren(this, (child) => {
        if (!child.ready) return;
        if (child._debug) {
          child.removeDebug();
        }
      });
      this.updateBounds();
      forEachChildren(this, (child) => {
        if (!child.ready) return;
        child.refresh();
        child.onResize(child);
        if (child._debug) {
          child.debug();
        }
      });
    }
    refresh() {
      this.updateWindowBounds();
      this.updateBounds();
      this.refreshScrollObservers();
      this.handleScroll();
    }
    handleScroll() {
      this.updateScrollCoords();
      this.wakeTicker.restart();
    }
    /**
     * @param {Event} e
     */
    handleEvent(e) {
      switch (e.type) {
        case "scroll":
          this.handleScroll();
          break;
      }
    }
    revert() {
      this.scrollTicker.cancel();
      this.dataTimer.cancel();
      this.resizeTicker.cancel();
      this.wakeTicker.cancel();
      this.resizeObserver.disconnect();
      (this.useWin ? win : this.element).removeEventListener("scroll", this);
      scrollContainers.delete(this.element);
    }
  };
  var registerAndGetScrollContainer = (target) => {
    const $el = (
      /** @type {HTMLElement} */
      target ? parseTargets(target)[0] || doc.body : doc.body
    );
    let scrollContainer = scrollContainers.get($el);
    if (!scrollContainer) {
      scrollContainer = new ScrollContainer($el);
      scrollContainers.set($el, scrollContainer);
    }
    return scrollContainer;
  };
  var convertValueToPx = ($el, v, size, under, over) => {
    const clampMin = v === "min";
    const clampMax = v === "max";
    const value = v === "top" || v === "left" || v === "start" || clampMin ? 0 : v === "bottom" || v === "right" || v === "end" || clampMax ? "100%" : v === "center" ? "50%" : v;
    const { n, u } = decomposeRawValue(value, decomposedOriginalValue);
    let px = n;
    if (u === "%") {
      px = n / 100 * size;
    } else if (u) {
      px = convertValueUnit($el, decomposedOriginalValue, "px", true).n;
    }
    if (clampMax && under < 0) px += under;
    if (clampMin && over > 0) px += over;
    return px;
  };
  var parseBoundValue = ($el, v, size, under, over) => {
    let value;
    if (isStr(v)) {
      const matchedOperator = relativeValuesExecRgx.exec(
        /** @type {String} */
        v
      );
      if (matchedOperator) {
        const splitter = matchedOperator[0];
        const operator = splitter[0];
        const splitted = (
          /** @type {String} */
          v.split(splitter)
        );
        const clampMin = splitted[0] === "min";
        const clampMax = splitted[0] === "max";
        const valueAPx = convertValueToPx($el, splitted[0], size, under, over);
        const valueBPx = convertValueToPx($el, splitted[1], size, under, over);
        if (clampMin) {
          const min = getRelativeValue(convertValueToPx($el, "min", size), valueBPx, operator);
          value = min < valueAPx ? valueAPx : min;
        } else if (clampMax) {
          const max2 = getRelativeValue(convertValueToPx($el, "max", size), valueBPx, operator);
          value = max2 > valueAPx ? valueAPx : max2;
        } else {
          value = getRelativeValue(valueAPx, valueBPx, operator);
        }
      } else {
        value = convertValueToPx($el, v, size, under, over);
      }
    } else {
      value = /** @type {Number} */
      v;
    }
    return round(value, 0);
  };
  var getAnimationDomTarget = (linked) => {
    let $linkedTarget;
    const linkedTargets = linked.targets;
    for (let i = 0, l = linkedTargets.length; i < l; i++) {
      const target = linkedTargets[i];
      if (target[isDomSymbol]) {
        $linkedTarget = /** @type {HTMLElement} */
        target;
        break;
      }
    }
    return $linkedTarget;
  };
  var scrollerIndex = 0;
  var debugColors = ["#FF4B4B", "#FF971B", "#FFC730", "#F9F640", "#7AFF5A", "#18FF74", "#17E09B", "#3CFFEC", "#05DBE9", "#33B3F1", "#638CF9", "#C563FE", "#FF4FCF", "#F93F8A"];
  var ScrollObserver = class {
    /**
     * @param {ScrollObserverParams} parameters
     */
    constructor(parameters = {}) {
      if (scope.current) scope.current.register(this);
      const syncMode = setValue(parameters.sync, "play pause");
      const ease = syncMode ? parseEase(
        /** @type {EasingParam} */
        syncMode
      ) : null;
      const isLinear = syncMode && (syncMode === "linear" || syncMode === none);
      const isEase = syncMode && !(ease === none && !isLinear);
      const isSmooth = syncMode && (isNum(syncMode) || syncMode === true || isLinear);
      const isMethods = syncMode && (isStr(syncMode) && !isEase && !isSmooth);
      const syncMethods = isMethods ? (
        /** @type {String} */
        syncMode.split(" ").map(
          (m) => () => {
            const linked = this.linked;
            return linked && linked[m] ? linked[m]() : null;
          }
        )
      ) : null;
      const biDirSync = isMethods && syncMethods.length > 2;
      this.index = scrollerIndex++;
      this.id = !isUnd(parameters.id) ? parameters.id : this.index;
      this.container = registerAndGetScrollContainer(parameters.container);
      this.target = null;
      this.linked = null;
      this.repeat = null;
      this.horizontal = null;
      this.enter = null;
      this.leave = null;
      this.sync = isEase || isSmooth || !!syncMethods;
      this.syncEase = isEase ? ease : null;
      this.syncSmooth = isSmooth ? syncMode === true || isLinear ? 1 : (
        /** @type {Number} */
        syncMode
      ) : null;
      this.onSyncEnter = syncMethods && !biDirSync && syncMethods[0] ? syncMethods[0] : noop;
      this.onSyncLeave = syncMethods && !biDirSync && syncMethods[1] ? syncMethods[1] : noop;
      this.onSyncEnterForward = syncMethods && biDirSync && syncMethods[0] ? syncMethods[0] : noop;
      this.onSyncLeaveForward = syncMethods && biDirSync && syncMethods[1] ? syncMethods[1] : noop;
      this.onSyncEnterBackward = syncMethods && biDirSync && syncMethods[2] ? syncMethods[2] : noop;
      this.onSyncLeaveBackward = syncMethods && biDirSync && syncMethods[3] ? syncMethods[3] : noop;
      this.onEnter = parameters.onEnter || noop;
      this.onLeave = parameters.onLeave || noop;
      this.onEnterForward = parameters.onEnterForward || noop;
      this.onLeaveForward = parameters.onLeaveForward || noop;
      this.onEnterBackward = parameters.onEnterBackward || noop;
      this.onLeaveBackward = parameters.onLeaveBackward || noop;
      this.onUpdate = parameters.onUpdate || noop;
      this.onResize = parameters.onResize || noop;
      this.onSyncComplete = parameters.onSyncComplete || noop;
      this.reverted = false;
      this.ready = false;
      this.completed = false;
      this.began = false;
      this.isInView = false;
      this.forceEnter = false;
      this.hasEntered = false;
      this.offset = 0;
      this.offsetStart = 0;
      this.offsetEnd = 0;
      this.distance = 0;
      this.prevProgress = 0;
      this.thresholds = ["start", "end", "end", "start"];
      this.coords = [0, 0, 0, 0];
      this.debugStyles = null;
      this.$debug = null;
      this._params = parameters;
      this._debug = setValue(parameters.debug, false);
      this._next = null;
      this._prev = null;
      addChild(this.container, this);
      sync(() => {
        if (this.reverted) return;
        if (!this.target) {
          const target = (
            /** @type {HTMLElement} */
            parseTargets(parameters.target)[0]
          );
          this.target = target || doc.body;
          this.refresh();
        }
        if (this._debug) this.debug();
      });
    }
    /**
     * @param {Tickable|WAAPIAnimation} linked
     */
    link(linked) {
      if (linked) {
        linked.pause();
        this.linked = linked;
        if (!isUnd(linked) && !isUnd(
          /** @type {WAAPIAnimation} */
          linked.persist
        )) {
          linked.persist = true;
        }
        if (!this._params.target) {
          let $linkedTarget;
          if (!isUnd(
            /** @type {JSAnimation} */
            linked.targets
          )) {
            $linkedTarget = getAnimationDomTarget(
              /** @type {JSAnimation} */
              linked
            );
          } else {
            forEachChildren(
              /** @type {Timeline} */
              linked,
              (child) => {
                if (child.targets && !$linkedTarget) {
                  $linkedTarget = getAnimationDomTarget(
                    /** @type {JSAnimation} */
                    child
                  );
                }
              }
            );
          }
          this.target = $linkedTarget || doc.body;
          this.refresh();
        }
      }
      return this;
    }
    get velocity() {
      return this.container.velocity;
    }
    get backward() {
      return this.horizontal ? this.container.backwardX : this.container.backwardY;
    }
    get scroll() {
      return this.horizontal ? this.container.scrollX : this.container.scrollY;
    }
    get progress() {
      const p = (this.scroll - this.offsetStart) / this.distance;
      return p === Infinity || isNaN(p) ? 0 : round(clamp(p, 0, 1), 6);
    }
    refresh() {
      this.ready = true;
      this.reverted = false;
      const params = this._params;
      this.repeat = setValue(parseScrollObserverFunctionParameter(params.repeat, this), true);
      this.horizontal = setValue(parseScrollObserverFunctionParameter(params.axis, this), "y") === "x";
      this.enter = setValue(parseScrollObserverFunctionParameter(params.enter, this), "end start");
      this.leave = setValue(parseScrollObserverFunctionParameter(params.leave, this), "start end");
      this.updateBounds();
      this.handleScroll();
      return this;
    }
    removeDebug() {
      if (this.$debug) {
        this.$debug.parentNode.removeChild(this.$debug);
        this.$debug = null;
      }
      if (this.debugStyles) {
        this.debugStyles.revert();
        this.$debug = null;
      }
      return this;
    }
    debug() {
      this.removeDebug();
      const container = this.container;
      const isHori = this.horizontal;
      const $existingDebug = container.element.querySelector(":scope > .animejs-onscroll-debug");
      const $debug = doc.createElement("div");
      const $thresholds = doc.createElement("div");
      const $triggers = doc.createElement("div");
      const color2 = debugColors[this.index % debugColors.length];
      const useWin = container.useWin;
      const containerWidth = useWin ? container.winWidth : container.width;
      const containerHeight = useWin ? container.winHeight : container.height;
      const scrollWidth = container.scrollWidth;
      const scrollHeight = container.scrollHeight;
      const size = this.container.width > 360 ? 320 : 260;
      const offLeft = isHori ? 0 : 10;
      const offTop = isHori ? 10 : 0;
      const half = isHori ? 24 : size / 2;
      const labelHeight = isHori ? half : 15;
      const labelWidth = isHori ? 60 : half;
      const labelSize = isHori ? labelWidth : labelHeight;
      const repeat = isHori ? "repeat-x" : "repeat-y";
      const gradientOffset = (v) => isHori ? "0px " + v + "px" : v + "px 2px";
      const lineCSS = (c) => `linear-gradient(${isHori ? 90 : 0}deg, ${c} 2px, transparent 1px)`;
      const baseCSS = (p, l, t, w, h) => `position:${p};left:${l}px;top:${t}px;width:${w}px;height:${h}px;`;
      $debug.style.cssText = `${baseCSS("absolute", offLeft, offTop, isHori ? scrollWidth : size, isHori ? size : scrollHeight)}
      pointer-events: none;
      z-index: ${this.container.zIndex++};
      display: flex;
      flex-direction: ${isHori ? "column" : "row"};
      filter: drop-shadow(0px 1px 0px rgba(0,0,0,.75));
    `;
      $thresholds.style.cssText = `${baseCSS("sticky", 0, 0, isHori ? containerWidth : half, isHori ? half : containerHeight)}`;
      if (!$existingDebug) {
        $thresholds.style.cssText += `background:
        ${lineCSS("#FFFF")}${gradientOffset(half - 10)} / ${isHori ? "100px 100px" : "100px 100px"} ${repeat},
        ${lineCSS("#FFF8")}${gradientOffset(half - 10)} / ${isHori ? "10px 10px" : "10px 10px"} ${repeat};
      `;
      }
      $triggers.style.cssText = `${baseCSS("relative", 0, 0, isHori ? scrollWidth : half, isHori ? half : scrollHeight)}`;
      if (!$existingDebug) {
        $triggers.style.cssText += `background:
        ${lineCSS("#FFFF")}${gradientOffset(0)} / ${isHori ? "100px 10px" : "10px 100px"} ${repeat},
        ${lineCSS("#FFF8")}${gradientOffset(0)} / ${isHori ? "10px 0px" : "0px 10px"} ${repeat};
      `;
      }
      const labels = [" enter: ", " leave: "];
      this.coords.forEach((v, i) => {
        const isView = i > 1;
        const value = (isView ? 0 : this.offset) + v;
        const isTail = i % 2;
        const isFirst = value < labelSize;
        const isOver = value > (isView ? isHori ? containerWidth : containerHeight : isHori ? scrollWidth : scrollHeight) - labelSize;
        const isFlip = (isView ? isTail && !isFirst : !isTail && !isFirst) || isOver;
        const $label = doc.createElement("div");
        const $text = doc.createElement("div");
        const dirProp = isHori ? isFlip ? "right" : "left" : isFlip ? "bottom" : "top";
        const flipOffset = isFlip ? (isHori ? labelWidth : labelHeight) + (!isView ? isHori ? -1 : -2 : isHori ? -1 : isOver ? 0 : -2) : !isView ? isHori ? 1 : 0 : isHori ? 1 : 0;
        $text.innerHTML = `${this.id}${labels[isTail]}${this.thresholds[i]}`;
        $label.style.cssText = `${baseCSS("absolute", 0, 0, labelWidth, labelHeight)}
        display: flex;
        flex-direction: ${isHori ? "column" : "row"};
        justify-content: flex-${isView ? "start" : "end"};
        align-items: flex-${isFlip ? "end" : "start"};
        border-${dirProp}: 2px ${isTail ? "solid" : "solid"} ${color2};
      `;
        $text.style.cssText = `
        overflow: hidden;
        max-width: ${size / 2 - 10}px;
        height: ${labelHeight};
        margin-${isHori ? isFlip ? "right" : "left" : isFlip ? "bottom" : "top"}: -2px;
        padding: 1px;
        font-family: ui-monospace, monospace;
        font-size: 10px;
        letter-spacing: -.025em;
        line-height: 9px;
        font-weight: 600;
        text-align: ${isHori && isFlip || !isHori && !isView ? "right" : "left"};
        white-space: pre;
        text-overflow: ellipsis;
        color: ${isTail ? color2 : "rgba(0,0,0,.75)"};
        background-color: ${isTail ? "rgba(0,0,0,.65)" : color2};
        border: 2px solid ${isTail ? color2 : "transparent"};
        border-${isHori ? isFlip ? "top-left" : "top-right" : isFlip ? "top-left" : "bottom-left"}-radius: 5px;
        border-${isHori ? isFlip ? "bottom-left" : "bottom-right" : isFlip ? "top-right" : "bottom-right"}-radius: 5px;
      `;
        $label.appendChild($text);
        let position = value - flipOffset + (isHori ? 1 : 0);
        $label.style[isHori ? "left" : "top"] = `${position}px`;
        (isView ? $thresholds : $triggers).appendChild($label);
      });
      $debug.appendChild($thresholds);
      $debug.appendChild($triggers);
      container.element.appendChild($debug);
      if (!$existingDebug) $debug.classList.add("animejs-onscroll-debug");
      this.$debug = $debug;
      const containerPosition = get(container.element, "position");
      if (containerPosition === "static") {
        this.debugStyles = set(container.element, { position: "relative " });
      }
    }
    updateBounds() {
      if (this._debug) {
        this.removeDebug();
      }
      let stickys;
      const $target = this.target;
      const container = this.container;
      const isHori = this.horizontal;
      const linked = this.linked;
      let linkedTime;
      let $el = $target;
      if (linked) {
        linkedTime = linked.currentTime;
        linked.seek(0, true);
      }
      while ($el && $el !== container.element && $el !== doc.body) {
        const isSticky = get($el, "position") === "sticky" ? set($el, { position: "static" }) : false;
        $el = $el.parentElement;
        if (isSticky) {
          if (!stickys) stickys = [];
          stickys.push(isSticky);
        }
      }
      const rect = $target.getBoundingClientRect();
      const scale = container.scale;
      const offset = (isHori ? rect.left + container.scrollX - container.left : rect.top + container.scrollY - container.top) * scale;
      const targetSize = (isHori ? rect.width : rect.height) * scale;
      const containerSize = isHori ? container.width : container.height;
      const scrollSize = isHori ? container.scrollWidth : container.scrollHeight;
      const maxScroll = scrollSize - containerSize;
      const enter = this.enter;
      const leave = this.leave;
      let enterTarget = "start";
      let leaveTarget = "end";
      let enterContainer = "end";
      let leaveContainer = "start";
      if (isStr(enter)) {
        const splitted = (
          /** @type {String} */
          enter.split(" ")
        );
        enterContainer = splitted[0];
        enterTarget = splitted.length > 1 ? splitted[1] : enterTarget;
      } else if (isObj(enter)) {
        const e = (
          /** @type {ScrollThresholdParam} */
          enter
        );
        if (!isUnd(e.container)) enterContainer = e.container;
        if (!isUnd(e.target)) enterTarget = e.target;
      } else if (isNum(enter)) {
        enterContainer = /** @type {Number} */
        enter;
      }
      if (isStr(leave)) {
        const splitted = (
          /** @type {String} */
          leave.split(" ")
        );
        leaveContainer = splitted[0];
        leaveTarget = splitted.length > 1 ? splitted[1] : leaveTarget;
      } else if (isObj(leave)) {
        const t = (
          /** @type {ScrollThresholdParam} */
          leave
        );
        if (!isUnd(t.container)) leaveContainer = t.container;
        if (!isUnd(t.target)) leaveTarget = t.target;
      } else if (isNum(leave)) {
        leaveContainer = /** @type {Number} */
        leave;
      }
      const parsedEnterTarget = parseBoundValue($target, enterTarget, targetSize);
      const parsedLeaveTarget = parseBoundValue($target, leaveTarget, targetSize);
      const under = parsedEnterTarget + offset - containerSize;
      const over = parsedLeaveTarget + offset - maxScroll;
      const parsedEnterContainer = parseBoundValue($target, enterContainer, containerSize, under, over);
      const parsedLeaveContainer = parseBoundValue($target, leaveContainer, containerSize, under, over);
      const offsetStart = parsedEnterTarget + offset - parsedEnterContainer;
      const offsetEnd = parsedLeaveTarget + offset - parsedLeaveContainer;
      const scrollDelta = offsetEnd - offsetStart;
      this.offset = offset;
      this.offsetStart = offsetStart;
      this.offsetEnd = offsetEnd;
      this.distance = scrollDelta <= 0 ? 0 : scrollDelta;
      this.thresholds = [enterTarget, leaveTarget, enterContainer, leaveContainer];
      this.coords = [parsedEnterTarget, parsedLeaveTarget, parsedEnterContainer, parsedLeaveContainer];
      if (stickys) {
        stickys.forEach((sticky) => sticky.revert());
      }
      if (linked) {
        linked.seek(linkedTime, true);
      }
      if (this._debug) {
        this.debug();
      }
    }
    handleScroll() {
      if (!this.ready) return;
      const linked = this.linked;
      const sync2 = this.sync;
      const syncEase = this.syncEase;
      const syncSmooth = this.syncSmooth;
      const shouldSeek = linked && (syncEase || syncSmooth);
      const isHori = this.horizontal;
      const container = this.container;
      const scroll = this.scroll;
      const isBefore = scroll <= this.offsetStart;
      const isAfter = scroll >= this.offsetEnd;
      const isInView = !isBefore && !isAfter;
      const isOnTheEdge = scroll === this.offsetStart || scroll === this.offsetEnd;
      const forceEnter = !this.hasEntered && isOnTheEdge;
      const $debug = this._debug && this.$debug;
      let hasUpdated = false;
      let syncCompleted = false;
      let p = this.progress;
      if (isBefore && this.began) {
        this.began = false;
      }
      if (p > 0 && !this.began) {
        this.began = true;
      }
      if (shouldSeek) {
        const lp = linked.progress;
        if (syncSmooth && isNum(syncSmooth)) {
          if (
            /** @type {Number} */
            syncSmooth < 1
          ) {
            const step = 1e-4;
            const snap3 = lp < p && p === 1 ? step : lp > p && !p ? -step : 0;
            p = round(lerp(lp, p, lerp(
              0.01,
              0.2,
              /** @type {Number} */
              syncSmooth
            )) + snap3, 6);
          }
        } else if (syncEase) {
          p = syncEase(p);
        }
        hasUpdated = p !== this.prevProgress;
        syncCompleted = lp === 1;
        if (hasUpdated && !syncCompleted && (syncSmooth && lp)) {
          container.wakeTicker.restart();
        }
      }
      if ($debug) {
        const sticky = isHori ? container.scrollY : container.scrollX;
        $debug.style[isHori ? "top" : "left"] = sticky + 10 + "px";
      }
      if (isInView && !this.isInView || forceEnter && !this.forceEnter && !this.hasEntered) {
        if (isInView) this.isInView = true;
        if (!this.forceEnter || !this.hasEntered) {
          if ($debug && isInView) $debug.style.zIndex = `${this.container.zIndex++}`;
          this.onSyncEnter(this);
          this.onEnter(this);
          if (this.backward) {
            this.onSyncEnterBackward(this);
            this.onEnterBackward(this);
          } else {
            this.onSyncEnterForward(this);
            this.onEnterForward(this);
          }
          this.hasEntered = true;
          if (forceEnter) this.forceEnter = true;
        } else if (isInView) {
          this.forceEnter = false;
        }
      }
      if (isInView || !isInView && this.isInView) {
        hasUpdated = true;
      }
      if (hasUpdated) {
        if (shouldSeek) linked.seek(linked.duration * p);
        this.onUpdate(this);
      }
      if (!isInView && this.isInView) {
        this.isInView = false;
        this.onSyncLeave(this);
        this.onLeave(this);
        if (this.backward) {
          this.onSyncLeaveBackward(this);
          this.onLeaveBackward(this);
        } else {
          this.onSyncLeaveForward(this);
          this.onLeaveForward(this);
        }
        if (sync2 && !syncSmooth) {
          syncCompleted = true;
        }
      }
      if (p >= 1 && this.began && !this.completed && (sync2 && syncCompleted || !sync2)) {
        if (sync2) {
          this.onSyncComplete(this);
        }
        this.completed = true;
        if (!this.repeat && !linked || !this.repeat && linked && linked.completed) {
          this.revert();
        }
      }
      if (p < 1 && this.completed) {
        this.completed = false;
      }
      this.prevProgress = p;
    }
    revert() {
      if (this.reverted) return;
      const container = this.container;
      removeChild(container, this);
      if (!container._head) {
        container.revert();
      }
      if (this._debug) {
        this.removeDebug();
      }
      this.reverted = true;
      this.ready = false;
      return this;
    }
  };
  var onScroll = (parameters = {}) => new ScrollObserver(parameters);

  // node_modules/animejs/dist/modules/waapi/waapi.js
  var easingToLinear = (fn, samples = 100) => {
    const points = [];
    for (let i = 0; i <= samples; i++) points.push(round(fn(i / samples), 4));
    return `linear(${points.join(", ")})`;
  };
  var WAAPIEasesLookups = {};
  var parseWAAPIEasing = (ease) => {
    let parsedEase = WAAPIEasesLookups[ease];
    if (parsedEase) return parsedEase;
    parsedEase = "linear";
    if (isStr(ease)) {
      if (stringStartsWith(ease, "linear") || stringStartsWith(ease, "cubic-") || stringStartsWith(ease, "steps") || stringStartsWith(ease, "ease")) {
        parsedEase = ease;
      } else if (stringStartsWith(ease, "cubicB")) {
        parsedEase = toLowerCase(ease);
      } else {
        const parsed = parseEaseString(ease);
        if (isFnc(parsed)) parsedEase = parsed === none ? "linear" : easingToLinear(parsed);
      }
      WAAPIEasesLookups[ease] = parsedEase;
    } else if (isFnc(ease)) {
      const easing = easingToLinear(ease);
      if (easing) parsedEase = easing;
    } else if (
      /** @type {Spring} */
      ease.ease
    ) {
      parsedEase = easingToLinear(
        /** @type {Spring} */
        ease.ease
      );
    }
    return parsedEase;
  };
  var transformsShorthands = ["x", "y", "z"];
  var commonDefaultPXProperties = [
    "perspective",
    "width",
    "height",
    "margin",
    "padding",
    "top",
    "right",
    "bottom",
    "left",
    "borderWidth",
    "fontSize",
    "borderRadius",
    ...transformsShorthands
  ];
  var validIndividualTransforms = /* @__PURE__ */ (() => [...transformsShorthands, ...validTransforms.filter((t) => ["X", "Y", "Z"].some((axis) => t.endsWith(axis)))])();
  var transformsPropertiesRegistered = null;
  var normalizeTweenValue = (propName, value, $el, i, parsedTargets) => {
    let v = isStr(value) ? value : getFunctionValue(
      /** @type {any} */
      value,
      $el,
      i,
      parsedTargets,
      null,
      null
    );
    if (!isNum(v)) return v;
    if (commonDefaultPXProperties.includes(propName) || stringStartsWith(propName, "translate")) return `${v}px`;
    if (stringStartsWith(propName, "rotate") || stringStartsWith(propName, "skew")) return `${v}deg`;
    return `${v}`;
  };
  var parseIndividualTweenValue = ($el, propName, from, to, i, parsedTargets) => {
    let tweenValue = "0";
    const computedTo = !isUnd(to) ? normalizeTweenValue(propName, to, $el, i, parsedTargets) : getComputedStyle($el)[propName];
    if (!isUnd(from)) {
      const computedFrom = normalizeTweenValue(propName, from, $el, i, parsedTargets);
      tweenValue = [computedFrom, computedTo];
    } else {
      tweenValue = isArr(to) ? to.map((v) => normalizeTweenValue(propName, v, $el, i, parsedTargets)) : computedTo;
    }
    return tweenValue;
  };
  var WAAPIAnimation = class {
    /**
     * @param {DOMTargetsParam} targets
     * @param {WAAPIAnimationParams} params
     */
    constructor(targets, params) {
      if (scope.current) scope.current.register(this);
      if (isNil(transformsPropertiesRegistered)) {
        if (isBrowser && (isUnd(CSS) || !Object.hasOwnProperty.call(CSS, "registerProperty"))) {
          transformsPropertiesRegistered = false;
        } else {
          validTransforms.forEach((t) => {
            const isSkew = stringStartsWith(t, "skew");
            const isScale = stringStartsWith(t, "scale");
            const isRotate = stringStartsWith(t, "rotate");
            const isTranslate = stringStartsWith(t, "translate");
            const isAngle = isRotate || isSkew;
            const syntax = isAngle ? "<angle>" : isScale ? "<number>" : isTranslate ? "<length-percentage>" : "*";
            try {
              CSS.registerProperty({
                name: "--" + t,
                syntax,
                inherits: false,
                initialValue: isTranslate ? "0px" : isAngle ? "0deg" : isScale ? "1" : "0"
              });
            } catch {
            }
          });
          transformsPropertiesRegistered = true;
        }
      }
      const parsedTargets = registerTargets(targets);
      if (!parsedTargets.length) {
        console.warn(`No target found. Make sure the element you're trying to animate is accessible before creating your animation.`);
      }
      const autoplay = setValue(params.autoplay, globals.defaults.autoplay);
      const scroll = autoplay && /** @type {ScrollObserver} */
      autoplay.link ? autoplay : false;
      const alternate = params.alternate && /** @type {Boolean} */
      params.alternate === true;
      const reversed = params.reversed && /** @type {Boolean} */
      params.reversed === true;
      const loop = setValue(params.loop, globals.defaults.loop);
      const iterations = (
        /** @type {Number} */
        loop === true || loop === Infinity ? Infinity : isNum(loop) ? loop + 1 : 1
      );
      const direction = alternate ? reversed ? "alternate-reverse" : "alternate" : reversed ? "reverse" : "normal";
      const fill = "both";
      const timeScale = globals.timeScale === 1 ? 1 : K;
      this.targets = parsedTargets;
      this.animations = [];
      this.controlAnimation = null;
      this.onComplete = params.onComplete || /** @type {Callback<WAAPIAnimation>} */
      /** @type {unknown} */
      globals.defaults.onComplete;
      this.duration = 0;
      this.muteCallbacks = false;
      this.completed = false;
      this.paused = !autoplay || scroll !== false;
      this.reversed = reversed;
      this.persist = setValue(params.persist, globals.defaults.persist);
      this.autoplay = autoplay;
      this._speed = setValue(params.playbackRate, globals.defaults.playbackRate);
      this._resolve = noop;
      this._completed = 0;
      this._inlineStyles = [];
      parsedTargets.forEach(($el, i) => {
        const cachedTransforms = $el[transformsSymbol];
        const hasIndividualTransforms = validIndividualTransforms.some((t) => params.hasOwnProperty(t));
        const elStyle = $el.style;
        const inlineStyles = this._inlineStyles[i] = {};
        const easeToParse = setValue(params.ease, globals.defaults.ease);
        const easeFunctionResult = getFunctionValue(easeToParse, $el, i, parsedTargets, null, null);
        const keyEasing = isFnc(easeFunctionResult) || isStr(easeFunctionResult) ? easeFunctionResult : easeToParse;
        const spring2 = (
          /** @type {Spring} */
          easeToParse.ease && easeToParse
        );
        const easing = parseWAAPIEasing(keyEasing);
        const duration = (spring2 ? (
          /** @type {Spring} */
          spring2.settlingDuration
        ) : getFunctionValue(setValue(params.duration, globals.defaults.duration), $el, i, parsedTargets, null, null)) * timeScale;
        const delay = getFunctionValue(setValue(params.delay, globals.defaults.delay), $el, i, parsedTargets, null, null) * timeScale;
        const composite2 = (
          /** @type {CompositeOperation} */
          setValue(params.composition, "replace")
        );
        for (let name in params) {
          if (!isKey(name)) continue;
          const keyframes2 = {};
          const tweenParams = { iterations, direction, fill, easing, duration, delay, composite: composite2 };
          const propertyValue = params[name];
          const individualTransformProperty = hasIndividualTransforms ? validTransforms.includes(name) ? name : shortTransforms.get(name) : false;
          const styleName = individualTransformProperty ? "transform" : name;
          if (!inlineStyles[styleName]) {
            inlineStyles[styleName] = elStyle[styleName];
          }
          let parsedPropertyValue;
          if (isObj(propertyValue)) {
            const tweenOptions = (
              /** @type {WAAPITweenOptions} */
              propertyValue
            );
            const tweenOptionsEase = setValue(tweenOptions.ease, easing);
            const tweenOptionsSpring = (
              /** @type {Spring} */
              tweenOptionsEase.ease && tweenOptionsEase
            );
            const to = (
              /** @type {WAAPITweenOptions} */
              tweenOptions.to
            );
            const from = (
              /** @type {WAAPITweenOptions} */
              tweenOptions.from
            );
            tweenParams.duration = (tweenOptionsSpring ? (
              /** @type {Spring} */
              tweenOptionsSpring.settlingDuration
            ) : getFunctionValue(setValue(tweenOptions.duration, duration), $el, i, parsedTargets, null, null)) * timeScale;
            tweenParams.delay = getFunctionValue(setValue(tweenOptions.delay, delay), $el, i, parsedTargets, null, null) * timeScale;
            tweenParams.composite = /** @type {CompositeOperation} */
            setValue(tweenOptions.composition, composite2);
            tweenParams.easing = parseWAAPIEasing(tweenOptionsEase);
            parsedPropertyValue = parseIndividualTweenValue($el, name, from, to, i, parsedTargets);
            if (individualTransformProperty) {
              keyframes2[`--${individualTransformProperty}`] = parsedPropertyValue;
              cachedTransforms[individualTransformProperty] = parsedPropertyValue;
            } else {
              keyframes2[name] = parseIndividualTweenValue($el, name, from, to, i, parsedTargets);
            }
            addWAAPIAnimation(this, $el, name, keyframes2, tweenParams);
            if (!isUnd(from)) {
              if (!individualTransformProperty) {
                elStyle[name] = keyframes2[name][0];
              } else {
                const key2 = `--${individualTransformProperty}`;
                elStyle.setProperty(key2, keyframes2[key2][0]);
              }
            }
          } else {
            parsedPropertyValue = isArr(propertyValue) ? propertyValue.map((v) => normalizeTweenValue(name, v, $el, i, parsedTargets)) : normalizeTweenValue(
              name,
              /** @type {any} */
              propertyValue,
              $el,
              i,
              parsedTargets
            );
            if (individualTransformProperty) {
              keyframes2[`--${individualTransformProperty}`] = parsedPropertyValue;
              cachedTransforms[individualTransformProperty] = parsedPropertyValue;
            } else {
              keyframes2[name] = parsedPropertyValue;
            }
            addWAAPIAnimation(this, $el, name, keyframes2, tweenParams);
          }
        }
        if (hasIndividualTransforms) {
          let transforms = emptyString;
          for (let t in cachedTransforms) {
            transforms += `${transformsFragmentStrings[t]}var(--${t})) `;
          }
          elStyle.transform = transforms;
        }
      });
      if (scroll) {
        this.autoplay.link(this);
      }
    }
    /**
     * @callback forEachCallback
     * @param {globalThis.Animation} animation
     */
    /**
     * @param  {forEachCallback|String} callback
     * @return {this}
     */
    forEach(callback) {
      try {
        const cb = isStr(callback) ? (a) => a[callback]() : callback;
        this.animations.forEach(cb);
      } catch {
      }
      return this;
    }
    get speed() {
      return this._speed;
    }
    set speed(speed) {
      this._speed = +speed;
      this.forEach((anim) => anim.playbackRate = speed);
    }
    get currentTime() {
      const controlAnimation = this.controlAnimation;
      const timeScale = globals.timeScale;
      return this.completed ? this.duration : controlAnimation ? +controlAnimation.currentTime * (timeScale === 1 ? 1 : timeScale) : 0;
    }
    set currentTime(time) {
      const t = time * (globals.timeScale === 1 ? 1 : K);
      this.forEach((anim) => {
        if (!this.persist && t >= this.duration) anim.play();
        anim.currentTime = t;
      });
    }
    get progress() {
      return this.currentTime / this.duration;
    }
    set progress(progress) {
      this.forEach((anim) => anim.currentTime = progress * this.duration || 0);
    }
    resume() {
      if (!this.paused) return this;
      this.paused = false;
      return this.forEach("play");
    }
    pause() {
      if (this.paused) return this;
      this.paused = true;
      return this.forEach("pause");
    }
    alternate() {
      this.reversed = !this.reversed;
      this.forEach("reverse");
      if (this.paused) this.forEach("pause");
      return this;
    }
    play() {
      if (this.reversed) this.alternate();
      return this.resume();
    }
    reverse() {
      if (!this.reversed) this.alternate();
      return this.resume();
    }
    /**
     * @param {Number} time
     * @param {Boolean} muteCallbacks
     */
    seek(time, muteCallbacks = false) {
      if (muteCallbacks) this.muteCallbacks = true;
      if (time < this.duration) this.completed = false;
      this.currentTime = time;
      this.muteCallbacks = false;
      if (this.paused) this.pause();
      return this;
    }
    restart() {
      this.completed = false;
      return this.seek(0, true).resume();
    }
    commitStyles() {
      return this.forEach("commitStyles");
    }
    complete() {
      return this.seek(this.duration);
    }
    cancel() {
      this.muteCallbacks = true;
      this.commitStyles().forEach("cancel");
      this.animations.length = 0;
      requestAnimationFrame(() => {
        this.targets.forEach(($el) => {
          if ($el.style.transform === "none") $el.style.removeProperty("transform");
        });
      });
      return this;
    }
    revert() {
      this.cancel().targets.forEach(($el, i) => {
        const targetStyle = $el.style;
        const targetInlineStyles = this._inlineStyles[i];
        for (let name in targetInlineStyles) {
          const originalInlinedValue = targetInlineStyles[name];
          if (isUnd(originalInlinedValue) || originalInlinedValue === emptyString) {
            targetStyle.removeProperty(toLowerCase(name));
          } else {
            $el.style[name] = originalInlinedValue;
          }
        }
        if ($el.getAttribute("style") === emptyString) $el.removeAttribute("style");
      });
      return this;
    }
    /**
     * @typedef {this & {then: null}} ResolvedWAAPIAnimation
     */
    /**
     * @param  {Callback<ResolvedWAAPIAnimation>} [callback]
     * @return Promise<this>
     */
    then(callback = noop) {
      const then = this.then;
      const onResolve = () => {
        this.then = null;
        callback(
          /** @type {ResolvedWAAPIAnimation} */
          this
        );
        this.then = then;
        this._resolve = noop;
      };
      return new Promise((r) => {
        this._resolve = () => r(onResolve());
        if (this.completed) this._resolve();
        return this;
      });
    }
  };
  var waapi = {
    /**
     * @param {DOMTargetsParam} targets
     * @param {WAAPIAnimationParams} params
     * @return {WAAPIAnimation}
     */
    animate: (targets, params) => new WAAPIAnimation(targets, params),
    convertEase: easingToLinear
  };

  // node_modules/animejs/dist/modules/layout/layout.js
  var layoutId = 0;
  var nodeId = 0;
  var isElementInRoot = (root, $el) => {
    if (!root || !$el) return false;
    return root === $el || root.contains($el);
  };
  var muteElementTransition = ($el) => {
    if (!$el) return null;
    const style = $el.style;
    const transition = style.transition || "";
    style.setProperty("transition", "none", "important");
    return transition;
  };
  var restoreElementTransition = ($el, transition) => {
    if (!$el) return;
    const style = $el.style;
    if (transition) {
      style.transition = transition;
    } else {
      style.removeProperty("transition");
    }
  };
  var muteNodeTransition = (node) => {
    const store = node.layout.transitionMuteStore;
    const $el = node.$el;
    const $measure = node.$measure;
    if ($el && !store.has($el)) store.set($el, muteElementTransition($el));
    if ($measure && !store.has($measure)) store.set($measure, muteElementTransition($measure));
  };
  var restoreLayoutTransition = (store) => {
    store.forEach((value, $el) => restoreElementTransition($el, value));
    store.clear();
  };
  var hiddenComputedStyle = (
    /** @type {CSSStyleDeclaration} */
    {
      display: "none",
      visibility: "hidden",
      opacity: "0",
      transform: "none",
      position: "static"
    }
  );
  var detachNode = (node) => {
    if (!node) return;
    const parent = node.parentNode;
    if (!parent) return;
    if (parent._head === node) parent._head = node._next;
    if (parent._tail === node) parent._tail = node._prev;
    if (node._prev) node._prev._next = node._next;
    if (node._next) node._next._prev = node._prev;
    node._prev = null;
    node._next = null;
    node.parentNode = null;
  };
  var createNode = ($el, parentNode, state, recycledNode) => {
    let dataId = $el.dataset.layoutId;
    if (!dataId) dataId = $el.dataset.layoutId = `node-${nodeId++}`;
    const node = recycledNode ? recycledNode : (
      /** @type {LayoutNode} */
      {}
    );
    node.$el = $el;
    node.$measure = $el;
    node.id = dataId;
    node.index = 0;
    node.targets = null;
    node.delay = 0;
    node.duration = 0;
    node.ease = null;
    node.state = state;
    node.layout = state.layout;
    node.parentNode = parentNode || null;
    node.isTarget = false;
    node.isEntering = false;
    node.isLeaving = false;
    node.isInlined = false;
    node.hasTransform = false;
    node.inlineStyles = [];
    node.inlineTransforms = null;
    node.inlineTransition = null;
    node.branchAdded = false;
    node.branchRemoved = false;
    node.branchNotRendered = false;
    node.sizeChanged = false;
    node.hasVisibilitySwap = false;
    node.hasDisplayNone = false;
    node.hasVisibilityHidden = false;
    node.measuredInlineTransform = null;
    node.measuredInlineTransition = null;
    node.measuredDisplay = null;
    node.measuredVisibility = null;
    node.measuredPosition = null;
    node.measuredHasDisplayNone = false;
    node.measuredHasVisibilityHidden = false;
    node.measuredIsVisible = false;
    node.measuredIsRemoved = false;
    node.measuredIsInsideRoot = false;
    node.properties = /** @type {LayoutNodeProperties} */
    {
      transform: "none",
      x: 0,
      y: 0,
      left: 0,
      top: 0,
      clientLeft: 0,
      clientTop: 0,
      width: 0,
      height: 0
    };
    node.layout.properties.forEach((prop) => node.properties[prop] = 0);
    node._head = null;
    node._tail = null;
    node._prev = null;
    node._next = null;
    return node;
  };
  var recordNodeState = (node, $measure, computedStyle, skipMeasurements) => {
    const $el = node.$el;
    const root = node.layout.root;
    const isRoot = root === $el;
    const properties = node.properties;
    const rootNode = node.state.rootNode;
    const parentNode = node.parentNode;
    const computedTransforms = computedStyle.transform;
    const inlineTransforms = $el.style.transform;
    const parentNotRendered = parentNode ? parentNode.measuredIsRemoved : false;
    const position = computedStyle.position;
    if (isRoot) node.layout.absoluteCoords = position === "fixed" || position === "absolute";
    node.$measure = $measure;
    node.inlineTransforms = inlineTransforms;
    node.hasTransform = computedTransforms && computedTransforms !== "none";
    node.measuredIsInsideRoot = isElementInRoot(root, $measure);
    node.measuredInlineTransform = null;
    node.measuredDisplay = computedStyle.display;
    node.measuredVisibility = computedStyle.visibility;
    node.measuredPosition = position;
    node.measuredHasDisplayNone = computedStyle.display === "none";
    node.measuredHasVisibilityHidden = computedStyle.visibility === "hidden";
    node.measuredIsVisible = !(node.measuredHasDisplayNone || node.measuredHasVisibilityHidden);
    node.measuredIsRemoved = node.measuredHasDisplayNone || node.measuredHasVisibilityHidden || parentNotRendered;
    let hasAdjacentText = false;
    let s = $el.previousSibling;
    while (s && (s.nodeType === Node.COMMENT_NODE || s.nodeType === Node.TEXT_NODE && !s.textContent.trim())) s = s.previousSibling;
    if (s && s.nodeType === Node.TEXT_NODE) {
      hasAdjacentText = true;
    } else {
      s = $el.nextSibling;
      while (s && (s.nodeType === Node.COMMENT_NODE || s.nodeType === Node.TEXT_NODE && !s.textContent.trim())) s = s.nextSibling;
      hasAdjacentText = s !== null && s.nodeType === Node.TEXT_NODE;
    }
    node.isInlined = hasAdjacentText;
    if (node.hasTransform && !skipMeasurements) {
      const transitionMuteStore = node.layout.transitionMuteStore;
      if (!transitionMuteStore.get($el)) node.inlineTransition = muteElementTransition($el);
      if ($measure === $el) {
        $el.style.transform = "none";
      } else {
        if (!transitionMuteStore.get($measure)) node.measuredInlineTransition = muteElementTransition($measure);
        node.measuredInlineTransform = $measure.style.transform;
        $measure.style.transform = "none";
      }
    }
    let left = 0;
    let top = 0;
    let width = 0;
    let height = 0;
    if (!skipMeasurements) {
      const rect = $measure.getBoundingClientRect();
      left = rect.left;
      top = rect.top;
      width = rect.width;
      height = rect.height;
    }
    for (let name in properties) {
      const computedProp = name === "transform" ? computedTransforms : computedStyle[name] || computedStyle.getPropertyValue && computedStyle.getPropertyValue(name);
      if (!isUnd(computedProp)) properties[name] = computedProp;
    }
    properties.left = left;
    properties.top = top;
    properties.clientLeft = skipMeasurements ? 0 : $measure.clientLeft;
    properties.clientTop = skipMeasurements ? 0 : $measure.clientTop;
    let absoluteLeft, absoluteTop;
    if (isRoot) {
      if (!node.layout.absoluteCoords) {
        absoluteLeft = 0;
        absoluteTop = 0;
      } else {
        absoluteLeft = left;
        absoluteTop = top;
      }
    } else {
      const p = parentNode || rootNode;
      const parentLeft = p.properties.left;
      const parentTop = p.properties.top;
      const borderLeft = p.properties.clientLeft;
      const borderTop = p.properties.clientTop;
      if (!node.layout.absoluteCoords) {
        if (p === rootNode) {
          const rootLeft = rootNode.properties.left;
          const rootTop = rootNode.properties.top;
          const rootBorderLeft = rootNode.properties.clientLeft;
          const rootBorderTop = rootNode.properties.clientTop;
          absoluteLeft = left - rootLeft - rootBorderLeft;
          absoluteTop = top - rootTop - rootBorderTop;
        } else {
          absoluteLeft = left - parentLeft - borderLeft;
          absoluteTop = top - parentTop - borderTop;
        }
      } else {
        absoluteLeft = left - parentLeft - borderLeft;
        absoluteTop = top - parentTop - borderTop;
      }
    }
    properties.x = absoluteLeft;
    properties.y = absoluteTop;
    properties.width = width;
    properties.height = height;
    return node;
  };
  var updateNodeProperties = (node, props) => {
    if (!props) return;
    for (let name in props) {
      node.properties[name] = props[name];
    }
  };
  var updateNodeTimingParams = (node, params) => {
    const easeFunctionResult = getFunctionValue(params.ease, node.$el, node.index, node.targets, null, null);
    const keyEasing = isFnc(easeFunctionResult) ? easeFunctionResult : params.ease;
    const hasSpring = !isUnd(keyEasing) && !isUnd(
      /** @type {Spring} */
      keyEasing.ease
    );
    node.ease = hasSpring ? (
      /** @type {Spring} */
      keyEasing.ease
    ) : keyEasing;
    node.duration = hasSpring ? (
      /** @type {Spring} */
      keyEasing.settlingDuration
    ) : getFunctionValue(params.duration, node.$el, node.index, node.targets, null, null);
    node.delay = getFunctionValue(params.delay, node.$el, node.index, node.targets, null, null);
  };
  var recordNodeInlineStyles = (node) => {
    const style = node.$el.style;
    const stylesStore = node.inlineStyles;
    stylesStore.length = 0;
    node.layout.recordedProperties.forEach((prop) => {
      stylesStore.push(prop, style[prop] || "");
    });
  };
  var restoreNodeInlineStyles = (node) => {
    const style = node.$el.style;
    const stylesStore = node.inlineStyles;
    for (let i = 0, l = stylesStore.length; i < l; i += 2) {
      const property = stylesStore[i];
      const styleValue2 = stylesStore[i + 1];
      if (styleValue2 && styleValue2 !== "") {
        style[property] = styleValue2;
      } else {
        style[property] = "";
        style.removeProperty(property);
      }
    }
  };
  var restoreNodeTransform = (node) => {
    const inlineTransforms = node.inlineTransforms;
    const nodeStyle = node.$el.style;
    if (!node.hasTransform || !inlineTransforms || node.hasTransform && nodeStyle.transform === "none" || inlineTransforms && inlineTransforms === "none") {
      nodeStyle.removeProperty("transform");
    } else if (inlineTransforms) {
      nodeStyle.transform = inlineTransforms;
    }
    const $measure = node.$measure;
    if (node.hasTransform && $measure !== node.$el) {
      const measuredStyle = $measure.style;
      const measuredInline = node.measuredInlineTransform;
      if (measuredInline && measuredInline !== "") {
        measuredStyle.transform = measuredInline;
      } else {
        measuredStyle.removeProperty("transform");
      }
    }
    node.measuredInlineTransform = null;
    if (node.inlineTransition !== null) {
      restoreElementTransition(node.$el, node.inlineTransition);
      node.inlineTransition = null;
    }
    if ($measure !== node.$el && node.measuredInlineTransition !== null) {
      restoreElementTransition($measure, node.measuredInlineTransition);
      node.measuredInlineTransition = null;
    }
  };
  var restoreNodeVisualState = (node) => {
    if (node.measuredIsRemoved || node.hasVisibilitySwap) {
      node.$el.style.removeProperty("display");
      node.$el.style.removeProperty("visibility");
      if (node.hasVisibilitySwap) {
        node.$measure.style.removeProperty("display");
        node.$measure.style.removeProperty("visibility");
      }
    }
    node.layout.pendingRemoval.delete(node.$el);
  };
  var cloneNodeProperties = (node, targetNode, newState) => {
    targetNode.properties = /** @type {LayoutNodeProperties} */
    { ...node.properties };
    targetNode.state = newState;
    targetNode.isTarget = node.isTarget;
    targetNode.hasTransform = node.hasTransform;
    targetNode.inlineTransforms = node.inlineTransforms;
    targetNode.measuredIsVisible = node.measuredIsVisible;
    targetNode.measuredDisplay = node.measuredDisplay;
    targetNode.measuredIsRemoved = node.measuredIsRemoved;
    targetNode.measuredHasDisplayNone = node.measuredHasDisplayNone;
    targetNode.measuredHasVisibilityHidden = node.measuredHasVisibilityHidden;
    targetNode.hasDisplayNone = node.hasDisplayNone;
    targetNode.isInlined = node.isInlined;
    targetNode.hasVisibilityHidden = node.hasVisibilityHidden;
    return targetNode;
  };
  var LayoutSnapshot = class {
    /**
     * @param {AutoLayout} layout
     */
    constructor(layout2) {
      this.layout = layout2;
      this.rootNode = null;
      this.rootNodes = /* @__PURE__ */ new Set();
      this.nodes = /* @__PURE__ */ new Map();
      this.scrollX = 0;
      this.scrollY = 0;
    }
    /**
     * @return {this}
     */
    revert() {
      this.forEachNode((node) => {
        this.layout.pendingRemoval.delete(node.$el);
        node.$el.removeAttribute("data-layout-id");
        node.$measure.removeAttribute("data-layout-id");
      });
      this.rootNode = null;
      this.rootNodes.clear();
      this.nodes.clear();
      return this;
    }
    /**
     * @param {DOMTarget} $el
     * @return {LayoutNode}
     */
    getNode($el) {
      if (!$el || !$el.dataset) return;
      return this.nodes.get($el.dataset.layoutId);
    }
    /**
     * @param {DOMTarget} $el
     * @param {String} prop
     * @return {Number|String}
     */
    getComputedValue($el, prop) {
      const node = this.getNode($el);
      if (!node) return;
      return (
        /** @type {Number|String} */
        node.properties[prop]
      );
    }
    /**
     * @param {LayoutNode|null} rootNode
     * @param {LayoutNodeIterator} cb
     */
    forEach(rootNode, cb) {
      let node = rootNode;
      let i = 0;
      while (node) {
        cb(node, i++);
        if (node._head) {
          node = node._head;
        } else if (node._next) {
          node = node._next;
        } else {
          while (node && !node._next) {
            node = node.parentNode;
          }
          if (node) node = node._next;
        }
      }
    }
    /**
     * @param {LayoutNodeIterator} cb
     */
    forEachRootNode(cb) {
      this.forEach(this.rootNode, cb);
    }
    /**
     * @param {LayoutNodeIterator} cb
     */
    forEachNode(cb) {
      for (const rootNode of this.rootNodes) {
        this.forEach(rootNode, cb);
      }
    }
    /**
     * @param {DOMTarget} $el
     * @param {LayoutNode|null} parentNode
     * @return {LayoutNode|null}
     */
    registerElement($el, parentNode) {
      if (!$el || $el.nodeType !== 1) return null;
      if (!this.layout.transitionMuteStore.has($el)) this.layout.transitionMuteStore.set($el, muteElementTransition($el));
      const stack = [$el, parentNode];
      const root = this.layout.root;
      let firstNode = null;
      while (stack.length) {
        const $parent = (
          /** @type {LayoutNode|null} */
          stack.pop()
        );
        const $current = (
          /** @type {DOMTarget|null} */
          stack.pop()
        );
        if (!$current || $current.nodeType !== 1 || isSvg($current)) continue;
        const skipMeasurements = $parent ? $parent.measuredIsRemoved : false;
        const computedStyle = skipMeasurements ? hiddenComputedStyle : getComputedStyle($current);
        const hasDisplayNone = skipMeasurements ? true : computedStyle.display === "none";
        const hasVisibilityHidden = skipMeasurements ? true : computedStyle.visibility === "hidden";
        const isVisible = !hasDisplayNone && !hasVisibilityHidden;
        const existingId = $current.dataset.layoutId;
        const isInsideRoot = isElementInRoot(root, $current);
        let node = existingId ? this.nodes.get(existingId) : null;
        if (node && node.$el !== $current) {
          const nodeInsideRoot = isElementInRoot(root, node.$el);
          const measuredVisible = node.measuredIsVisible;
          const shouldReassignNode = !nodeInsideRoot && (isInsideRoot || !isInsideRoot && !measuredVisible && isVisible);
          const shouldReuseMeasurements = nodeInsideRoot && !measuredVisible && isVisible;
          if (shouldReassignNode) {
            detachNode(node);
            node = createNode($current, $parent, this, node);
          } else if (shouldReuseMeasurements) {
            recordNodeState(node, $current, computedStyle, skipMeasurements);
            let $child2 = $current.lastElementChild;
            while ($child2) {
              stack.push(
                /** @type {DOMTarget} */
                $child2,
                node
              );
              $child2 = $child2.previousElementSibling;
            }
            if (!firstNode) firstNode = node;
            continue;
          } else {
            let $child2 = $current.lastElementChild;
            while ($child2) {
              stack.push(
                /** @type {DOMTarget} */
                $child2,
                $parent
              );
              $child2 = $child2.previousElementSibling;
            }
            if (!firstNode) firstNode = node;
            continue;
          }
        } else {
          node = createNode($current, $parent, this, node);
        }
        node.branchAdded = false;
        node.branchRemoved = false;
        node.branchNotRendered = false;
        node.isTarget = false;
        node.sizeChanged = false;
        node.hasVisibilityHidden = hasVisibilityHidden;
        node.hasDisplayNone = hasDisplayNone;
        node.hasVisibilitySwap = hasVisibilityHidden && !node.measuredHasVisibilityHidden || hasDisplayNone && !node.measuredHasDisplayNone;
        this.nodes.set(node.id, node);
        node.parentNode = $parent || null;
        node._prev = null;
        node._next = null;
        if ($parent) {
          this.rootNodes.delete(node);
          if (!$parent._head) {
            $parent._head = node;
            $parent._tail = node;
          } else {
            $parent._tail._next = node;
            node._prev = $parent._tail;
            $parent._tail = node;
          }
        } else {
          this.rootNodes.add(node);
        }
        recordNodeState(node, node.$el, computedStyle, skipMeasurements);
        let $child = $current.lastElementChild;
        while ($child) {
          stack.push(
            /** @type {DOMTarget} */
            $child,
            node
          );
          $child = $child.previousElementSibling;
        }
        if (!firstNode) firstNode = node;
      }
      return firstNode;
    }
    /**
     * @param {DOMTarget} $el
     * @param {Set<DOMTarget>} candidates
     * @return {LayoutNode|null}
     */
    ensureDetachedNode($el, candidates) {
      if (!$el || $el === this.layout.root) return null;
      const existingId = $el.dataset.layoutId;
      const existingNode = existingId ? this.nodes.get(existingId) : null;
      if (existingNode && existingNode.$el === $el) return existingNode;
      let parentNode = null;
      let $ancestor = $el.parentElement;
      while ($ancestor && $ancestor !== this.layout.root) {
        if (candidates.has($ancestor)) {
          parentNode = this.ensureDetachedNode($ancestor, candidates);
          break;
        }
        $ancestor = $ancestor.parentElement;
      }
      return this.registerElement($el, parentNode);
    }
    /**
     * @return {this}
     */
    record() {
      const layout2 = this.layout;
      const children = layout2.children;
      const root = layout2.root;
      const toParse = isArr(children) ? children : [children];
      const scoped = [];
      const scopeRoot = children === "*" ? root : scope.root;
      const rootAncestorTransformStore = [];
      let $ancestor = root.parentElement;
      while ($ancestor && $ancestor.nodeType === 1) {
        const computedStyle = getComputedStyle($ancestor);
        if (computedStyle.transform && computedStyle.transform !== "none") {
          const inlineTransform = $ancestor.style.transform || "";
          const inlineTransition = muteElementTransition($ancestor);
          rootAncestorTransformStore.push($ancestor, inlineTransform, inlineTransition);
          $ancestor.style.transform = "none";
        }
        $ancestor = $ancestor.parentElement;
      }
      for (let i = 0, l = toParse.length; i < l; i++) {
        const child = toParse[i];
        scoped[i] = isStr(child) ? scopeRoot.querySelectorAll(child) : child;
      }
      const parsedChildren = registerTargets(scoped);
      this.nodes.clear();
      this.rootNodes.clear();
      const rootNode = this.registerElement(root, null);
      rootNode.isTarget = true;
      this.rootNode = rootNode;
      const inRootNodeIds = /* @__PURE__ */ new Set();
      let index = 0;
      const allNodeTargets = [];
      this.nodes.forEach((node) => {
        allNodeTargets.push(node.$el);
      });
      this.nodes.forEach((node, id2) => {
        node.index = index++;
        node.targets = allNodeTargets;
        if (node && node.measuredIsInsideRoot) {
          inRootNodeIds.add(id2);
        }
      });
      const detachedElementsLookup = /* @__PURE__ */ new Set();
      const orderedDetachedElements = [];
      for (let i = 0, l = parsedChildren.length; i < l; i++) {
        const $el = parsedChildren[i];
        if (!$el || $el.nodeType !== 1 || $el === root) continue;
        const insideRoot = isElementInRoot(root, $el);
        if (!insideRoot) {
          const layoutNodeId = $el.dataset.layoutId;
          if (!layoutNodeId || !inRootNodeIds.has(layoutNodeId)) continue;
        }
        if (!detachedElementsLookup.has($el)) {
          detachedElementsLookup.add($el);
          orderedDetachedElements.push($el);
        }
      }
      for (let i = 0, l = orderedDetachedElements.length; i < l; i++) {
        this.ensureDetachedNode(orderedDetachedElements[i], detachedElementsLookup);
      }
      for (let i = 0, l = parsedChildren.length; i < l; i++) {
        const $el = parsedChildren[i];
        const node = this.getNode($el);
        if (node) {
          let cur = node;
          while (cur) {
            if (cur.isTarget) break;
            cur.isTarget = true;
            cur = cur.parentNode;
          }
        }
      }
      this.scrollX = window.scrollX;
      this.scrollY = window.scrollY;
      this.forEachNode(restoreNodeTransform);
      for (let i = 0, l = rootAncestorTransformStore.length; i < l; i += 3) {
        const $el = (
          /** @type {DOMTarget} */
          rootAncestorTransformStore[i]
        );
        const inlineTransform = (
          /** @type {String} */
          rootAncestorTransformStore[i + 1]
        );
        const inlineTransition = (
          /** @type {String|null} */
          rootAncestorTransformStore[i + 2]
        );
        if (inlineTransform && inlineTransform !== "") {
          $el.style.transform = inlineTransform;
        } else {
          $el.style.removeProperty("transform");
        }
        restoreElementTransition($el, inlineTransition);
      }
      return this;
    }
  };
  function splitPropertiesFromParams(params) {
    const properties = {};
    const parameters = {};
    for (let name in params) {
      const value = params[name];
      const isEase = name === "ease";
      const isTiming = name === "duration" || name === "delay";
      if (isTiming || isEase) {
        if (isEase) {
          parameters[name] = /** @type {EasingParam} */
          value;
        } else {
          parameters[name] = /** @type {Number|FunctionValue} */
          value;
        }
      } else {
        properties[name] = /** @type {Number|String} */
        value;
      }
    }
    return [properties, parameters];
  }
  var AutoLayout = class {
    /**
     * @param {DOMTargetSelector} root
     * @param {AutoLayoutParams} [params]
     */
    constructor(root, params = {}) {
      if (scope.current) scope.current.register(this);
      const swapAtSplitParams = splitPropertiesFromParams(params.swapAt);
      const enterFromSplitParams = splitPropertiesFromParams(params.enterFrom);
      const leaveToSplitParams = splitPropertiesFromParams(params.leaveTo);
      const transitionProperties = params.properties;
      params.duration = setValue(params.duration, 350);
      params.delay = setValue(params.delay, 0);
      params.ease = setValue(params.ease, "inOut(3.5)");
      this.params = params;
      this.root = /** @type {DOMTarget} */
      registerTargets(root)[0];
      this.id = params.id || layoutId++;
      this.children = params.children || "*";
      this.absoluteCoords = false;
      this.swapAtParams = mergeObjects(params.swapAt || { opacity: 0 }, { ease: "inOut(1.75)" });
      this.enterFromParams = params.enterFrom || { opacity: 0 };
      this.leaveToParams = params.leaveTo || { opacity: 0 };
      this.properties = /* @__PURE__ */ new Set([
        "opacity",
        "fontSize",
        "color",
        "backgroundColor",
        "borderRadius",
        "border",
        "filter",
        "clipPath"
      ]);
      if (swapAtSplitParams[0]) for (let name in swapAtSplitParams[0]) this.properties.add(name);
      if (enterFromSplitParams[0]) for (let name in enterFromSplitParams[0]) this.properties.add(name);
      if (leaveToSplitParams[0]) for (let name in leaveToSplitParams[0]) this.properties.add(name);
      if (transitionProperties) for (let i = 0, l = transitionProperties.length; i < l; i++) this.properties.add(transitionProperties[i]);
      this.recordedProperties = /* @__PURE__ */ new Set([
        "display",
        "visibility",
        "translate",
        "position",
        "left",
        "top",
        "marginLeft",
        "marginTop",
        "width",
        "height",
        "maxWidth",
        "maxHeight",
        "minWidth",
        "minHeight"
      ]);
      this.properties.forEach((prop) => this.recordedProperties.add(prop));
      this.pendingRemoval = /* @__PURE__ */ new WeakSet();
      this.transitionMuteStore = /* @__PURE__ */ new Map();
      this.oldState = new LayoutSnapshot(this);
      this.newState = new LayoutSnapshot(this);
      this.timeline = null;
      this.transformAnimation = null;
      this.animating = [];
      this.swapping = [];
      this.leaving = [];
      this.entering = [];
      this.oldState.record();
      restoreLayoutTransition(this.transitionMuteStore);
    }
    /**
     * @return {this}
     */
    revert() {
      this.root.classList.remove("is-animated");
      if (this.timeline) {
        this.timeline.complete();
        this.timeline = null;
      }
      if (this.transformAnimation) {
        this.transformAnimation.complete();
        this.transformAnimation = null;
      }
      this.animating.length = this.swapping.length = this.leaving.length = this.entering.length = 0;
      this.oldState.revert();
      this.newState.revert();
      requestAnimationFrame(() => restoreLayoutTransition(this.transitionMuteStore));
      return this;
    }
    /**
     * @return {this}
     */
    record() {
      if (this.transformAnimation) {
        this.transformAnimation.cancel();
        this.transformAnimation = null;
      }
      this.oldState.record();
      if (this.timeline) {
        this.timeline.cancel();
        this.timeline = null;
      }
      this.newState.forEachRootNode(restoreNodeInlineStyles);
      return this;
    }
    /**
     * @param {LayoutAnimationParams} [params]
     * @return {Timeline}
     */
    animate(params = {}) {
      const animationTimings = {
        ease: setValue(params.ease, this.params.ease),
        delay: setValue(params.delay, this.params.delay),
        duration: setValue(params.duration, this.params.duration)
      };
      const tlParams = {
        id: this.id
      };
      const onComplete = setValue(params.onComplete, this.params.onComplete);
      const onPause = setValue(params.onPause, this.params.onPause);
      for (let name in defaults) {
        if (name !== "ease" && name !== "duration" && name !== "delay") {
          if (!isUnd(params[name])) {
            tlParams[name] = params[name];
          } else if (!isUnd(this.params[name])) {
            tlParams[name] = this.params[name];
          }
        }
      }
      tlParams.onComplete = () => {
        const ap = (
          /** @type {ScrollObserver} */
          params.autoplay
        );
        const ed = globals.editor;
        const isScrollControled = ap && ap.linked || ed && ed.showPanel;
        if (isScrollControled) {
          if (onComplete) onComplete(this.timeline);
          return;
        }
        if (this.transformAnimation) this.transformAnimation.cancel();
        newState.forEachRootNode((node) => {
          restoreNodeVisualState(node);
          restoreNodeInlineStyles(node);
        });
        for (let i = 0, l = transformed.length; i < l; i++) {
          const $el = transformed[i];
          $el.style.transform = newState.getComputedValue($el, "transform");
        }
        if (this.root.classList.contains("is-animated")) {
          this.root.classList.remove("is-animated");
          if (onComplete) onComplete(this.timeline);
        }
        requestAnimationFrame(() => {
          if (this.root.classList.contains("is-animated")) return;
          restoreLayoutTransition(this.transitionMuteStore);
        });
      };
      tlParams.onPause = () => {
        const ap = (
          /** @type {ScrollObserver} */
          params.autoplay
        );
        const isScrollControled = ap && ap.linked;
        if (isScrollControled) {
          if (onComplete) onComplete(this.timeline);
          if (onPause) onPause(this.timeline);
          return;
        }
        if (!this.root.classList.contains("is-animated")) return;
        if (this.transformAnimation) this.transformAnimation.cancel();
        newState.forEachRootNode(restoreNodeVisualState);
        this.root.classList.remove("is-animated");
        if (onComplete) onComplete(this.timeline);
        if (onPause) onPause(this.timeline);
      };
      tlParams.composition = false;
      const swapAtParams = mergeObjects(mergeObjects(params.swapAt || {}, this.swapAtParams), animationTimings);
      const enterFromParams = mergeObjects(mergeObjects(params.enterFrom || {}, this.enterFromParams), animationTimings);
      const leaveToParams = mergeObjects(mergeObjects(params.leaveTo || {}, this.leaveToParams), animationTimings);
      const [swapAtProps, swapAtTimings] = splitPropertiesFromParams(swapAtParams);
      const [enterFromProps, enterFromTimings] = splitPropertiesFromParams(enterFromParams);
      const [leaveToProps, leaveToTimings] = splitPropertiesFromParams(leaveToParams);
      const oldState = this.oldState;
      const newState = this.newState;
      const animating = this.animating;
      const swapping = this.swapping;
      const entering = this.entering;
      const leaving = this.leaving;
      const pendingRemoval = this.pendingRemoval;
      animating.length = swapping.length = entering.length = leaving.length = 0;
      oldState.forEachRootNode(muteNodeTransition);
      newState.record();
      newState.forEachRootNode(recordNodeInlineStyles);
      const targets = [];
      const animated = [];
      const transformed = [];
      const animatedSwap = [];
      const rootNode = newState.rootNode;
      const $root = rootNode.$el;
      newState.forEachRootNode((node) => {
        const $el = node.$el;
        const id2 = node.id;
        const parent = node.parentNode;
        const parentAdded = parent ? parent.branchAdded : false;
        const parentRemoved = parent ? parent.branchRemoved : false;
        const parentNotRendered = parent ? parent.branchNotRendered : false;
        let oldStateNode = oldState.nodes.get(id2);
        const hasNoOldState = !oldStateNode;
        if (hasNoOldState) {
          oldStateNode = cloneNodeProperties(
            node,
            /** @type {LayoutNode} */
            {},
            oldState
          );
          oldState.nodes.set(id2, oldStateNode);
          oldStateNode.measuredIsRemoved = true;
        } else if (oldStateNode.measuredIsRemoved && !node.measuredIsRemoved) {
          cloneNodeProperties(node, oldStateNode, oldState);
          oldStateNode.measuredIsRemoved = true;
        }
        const oldParentNode = oldStateNode.parentNode;
        const oldParentId = oldParentNode ? oldParentNode.id : null;
        const newParentId = parent ? parent.id : null;
        const parentChanged = oldParentId !== newParentId;
        const elementChanged = oldStateNode.$el !== node.$el;
        const wasRemovedBefore = oldStateNode.measuredIsRemoved;
        const isRemovedNow = node.measuredIsRemoved;
        if (!oldStateNode.measuredIsRemoved && !isRemovedNow && !hasNoOldState && (parentChanged || elementChanged)) {
          const oldAbsoluteLeft = oldStateNode.properties.left;
          const oldAbsoluteTop = oldStateNode.properties.top;
          const newParent = parent || newState.rootNode;
          const oldParent = newParent.id ? oldState.nodes.get(newParent.id) : null;
          const parentLeft = oldParent ? oldParent.properties.left : newParent.properties.left;
          const parentTop = oldParent ? oldParent.properties.top : newParent.properties.top;
          const borderLeft = oldParent ? oldParent.properties.clientLeft : newParent.properties.clientLeft;
          const borderTop = oldParent ? oldParent.properties.clientTop : newParent.properties.clientTop;
          oldStateNode.properties.x = oldAbsoluteLeft - parentLeft - borderLeft;
          oldStateNode.properties.y = oldAbsoluteTop - parentTop - borderTop;
        }
        if (node.hasVisibilitySwap) {
          if (node.hasVisibilityHidden) {
            node.$el.style.visibility = "visible";
            node.$measure.style.visibility = "hidden";
          }
          if (node.hasDisplayNone) {
            node.$el.style.display = oldStateNode.measuredDisplay || node.measuredDisplay || "";
            node.$measure.style.visibility = "hidden";
          }
        }
        const wasPendingRemoval = pendingRemoval.has($el);
        const wasVisibleBefore = oldStateNode.measuredIsVisible;
        const isVisibleNow = node.measuredIsVisible;
        const becomeVisible = !wasVisibleBefore && isVisibleNow && !parentNotRendered;
        const topLevelAdded = !isRemovedNow && (wasRemovedBefore || wasPendingRemoval) && !parentAdded;
        const newlyRemoved = isRemovedNow && !wasRemovedBefore && !parentRemoved;
        const topLevelRemoved = newlyRemoved || isRemovedNow && wasPendingRemoval && !parentRemoved;
        node.branchAdded = parentAdded || topLevelAdded;
        node.branchRemoved = parentRemoved || topLevelRemoved;
        node.branchNotRendered = parentNotRendered || isRemovedNow;
        if (isRemovedNow && wasVisibleBefore) {
          node.$el.style.display = oldStateNode.measuredDisplay;
          node.$el.style.visibility = "visible";
          cloneNodeProperties(oldStateNode, node, newState);
        }
        if (newlyRemoved) {
          if (node.isTarget) {
            leaving.push($el);
            node.isLeaving = true;
          }
          pendingRemoval.add($el);
        } else if (!isRemovedNow && wasPendingRemoval) {
          pendingRemoval.delete($el);
        }
        if (topLevelAdded && !parentNotRendered || becomeVisible) {
          updateNodeProperties(oldStateNode, enterFromProps);
          if (node.isTarget) {
            entering.push($el);
            node.isEntering = true;
          }
        } else if (topLevelRemoved && !parentNotRendered) {
          updateNodeProperties(node, leaveToProps);
        }
        if (node !== rootNode && node.isTarget && !node.isEntering && !node.isLeaving) {
          animating.push($el);
        }
        targets.push($el);
      });
      let enteringIndex = 0;
      let leavingIndex = 0;
      let animatingIndex = 0;
      newState.forEachRootNode((node) => {
        const $el = node.$el;
        const parent = node.parentNode;
        const oldStateNode = oldState.nodes.get(node.id);
        const nodeProperties = node.properties;
        const oldStateNodeProperties = oldStateNode.properties;
        let animatedParent = parent !== rootNode && parent;
        while (animatedParent && !animatedParent.isTarget && animatedParent !== rootNode) {
          animatedParent = animatedParent.parentNode;
        }
        if (node === rootNode) {
          node.index = 0;
          node.targets = animating;
          updateNodeTimingParams(node, animationTimings);
        } else if (node.isEntering) {
          node.index = animatedParent ? animatedParent.index : enteringIndex;
          node.targets = animatedParent ? animating : entering;
          updateNodeTimingParams(node, enterFromTimings);
          enteringIndex++;
        } else if (node.isLeaving) {
          node.index = animatedParent ? animatedParent.index : leavingIndex;
          node.targets = animatedParent ? animating : leaving;
          leavingIndex++;
          updateNodeTimingParams(node, leaveToTimings);
        } else if (node.isTarget) {
          node.index = animatingIndex++;
          node.targets = animating;
          updateNodeTimingParams(node, animationTimings);
        } else {
          node.index = animatedParent ? animatedParent.index : 0;
          node.targets = animating;
          updateNodeTimingParams(node, swapAtTimings);
        }
        oldStateNode.index = node.index;
        oldStateNode.targets = node.targets;
        for (let prop in nodeProperties) {
          nodeProperties[prop] = getFunctionValue(nodeProperties[prop], $el, node.index, node.targets, null, null);
          oldStateNodeProperties[prop] = getFunctionValue(oldStateNodeProperties[prop], $el, oldStateNode.index, oldStateNode.targets, null, null);
        }
        const sizeTolerance = 1;
        const widthChanged = Math.abs(nodeProperties.width - oldStateNodeProperties.width) > sizeTolerance;
        const heightChanged = Math.abs(nodeProperties.height - oldStateNodeProperties.height) > sizeTolerance;
        node.sizeChanged = widthChanged || heightChanged;
        if (node.isTarget && (!node.measuredIsRemoved && oldStateNode.measuredIsVisible || node.measuredIsRemoved && node.measuredIsVisible)) {
          if (nodeProperties.transform !== "none" || oldStateNodeProperties.transform !== "none") {
            node.hasTransform = true;
            transformed.push($el);
          }
          for (let prop in nodeProperties) {
            if (prop !== "transform" && nodeProperties[prop] !== oldStateNodeProperties[prop]) {
              animated.push($el);
              break;
            }
          }
        }
        if (!node.isTarget) {
          swapping.push($el);
          if (node.sizeChanged && parent && parent.isTarget && parent.sizeChanged) {
            if (swapAtProps.transform) {
              node.hasTransform = true;
              transformed.push($el);
            }
            animatedSwap.push($el);
          }
        }
      });
      const timingParams = {
        delay: ($el) => newState.getNode($el).delay,
        duration: ($el) => newState.getNode($el).duration,
        ease: ($el) => newState.getNode($el).ease
      };
      tlParams.defaults = timingParams;
      this.timeline = createTimeline(tlParams);
      if (!animated.length && !transformed.length && !swapping.length) {
        restoreLayoutTransition(this.transitionMuteStore);
        return this.timeline.complete();
      }
      if (targets.length) {
        this.root.classList.add("is-animated");
        for (let i = 0, l = targets.length; i < l; i++) {
          const $el = targets[i];
          const id2 = $el.dataset.layoutId;
          const oldNode = oldState.nodes.get(id2);
          const newNode = newState.nodes.get(id2);
          const oldNodeState = oldNode.properties;
          if (!newNode.isInlined) {
            if (oldNode.measuredDisplay === "grid" || newNode.measuredDisplay === "grid") $el.style.setProperty("display", "block", "important");
            if ($el !== $root || this.absoluteCoords) {
              $el.style.position = this.absoluteCoords ? "fixed" : "absolute";
              $el.style.left = "0px";
              $el.style.top = "0px";
              $el.style.marginLeft = "0px";
              $el.style.marginTop = "0px";
              $el.style.translate = `${oldNodeState.x}px ${oldNodeState.y}px`;
            }
            if ($el === $root && newNode.measuredPosition === "static") {
              $el.style.position = "relative";
              $el.style.left = "0px";
              $el.style.top = "0px";
            }
          }
          $el.style.width = `${oldNodeState.width}px`;
          $el.style.height = `${oldNodeState.height}px`;
          $el.style.minWidth = `auto`;
          $el.style.minHeight = `auto`;
          $el.style.maxWidth = `none`;
          $el.style.maxHeight = `none`;
        }
        if (oldState.scrollX !== window.scrollX || oldState.scrollY !== window.scrollY) {
          requestAnimationFrame(() => window.scrollTo(oldState.scrollX, oldState.scrollY));
        }
        for (let i = 0, l = animated.length; i < l; i++) {
          const $el = animated[i];
          const id2 = $el.dataset.layoutId;
          const oldNode = oldState.nodes.get(id2);
          const newNode = newState.nodes.get(id2);
          const oldNodeState = oldNode.properties;
          const newNodeState = newNode.properties;
          let nodeHasChanged = false;
          const animatedProps = {
            composition: "none"
          };
          if (oldNodeState.width !== newNodeState.width) {
            animatedProps.width = [oldNodeState.width, newNodeState.width];
            nodeHasChanged = true;
          }
          if (oldNodeState.height !== newNodeState.height) {
            animatedProps.height = [oldNodeState.height, newNodeState.height];
            nodeHasChanged = true;
          }
          if (!newNode.hasTransform && !newNode.isInlined) {
            animatedProps.translate = [`${oldNodeState.x}px ${oldNodeState.y}px`, `${newNodeState.x}px ${newNodeState.y}px`];
            nodeHasChanged = true;
          }
          this.properties.forEach((prop) => {
            const oldVal = oldNodeState[prop];
            const newVal = newNodeState[prop];
            if (prop !== "transform" && oldVal !== newVal) {
              animatedProps[prop] = [oldVal, newVal];
              nodeHasChanged = true;
            }
          });
          if (nodeHasChanged) {
            this.timeline.add($el, animatedProps, 0);
          }
        }
      }
      if (swapping.length) {
        for (let i = 0, l = swapping.length; i < l; i++) {
          const $el = swapping[i];
          const oldNode = oldState.getNode($el);
          const oldNodeProps = oldNode.properties;
          $el.style.width = `${oldNodeProps.width}px`;
          $el.style.height = `${oldNodeProps.height}px`;
          $el.style.minWidth = `auto`;
          $el.style.minHeight = `auto`;
          $el.style.maxWidth = `none`;
          $el.style.maxHeight = `none`;
          if (!oldNode.isInlined) {
            $el.style.translate = `${oldNodeProps.x}px ${oldNodeProps.y}px`;
          }
          this.properties.forEach((prop) => {
            if (prop !== "transform") {
              $el.style[prop] = `${oldState.getComputedValue($el, prop)}`;
            }
          });
        }
        for (let i = 0, l = swapping.length; i < l; i++) {
          const $el = swapping[i];
          const newNode = newState.getNode($el);
          const newNodeProps = newNode.properties;
          this.timeline.call(() => {
            $el.style.width = `${newNodeProps.width}px`;
            $el.style.height = `${newNodeProps.height}px`;
            $el.style.minWidth = `auto`;
            $el.style.minHeight = `auto`;
            $el.style.maxWidth = `none`;
            $el.style.maxHeight = `none`;
            if (!newNode.isInlined) {
              $el.style.translate = `${newNodeProps.x}px ${newNodeProps.y}px`;
            }
            this.properties.forEach((prop) => {
              if (prop !== "transform") {
                $el.style[prop] = `${newState.getComputedValue($el, prop)}`;
              }
            });
          }, newNode.delay + newNode.duration / 2);
        }
        if (animatedSwap.length) {
          const ease = parseEase(newState.nodes.get(animatedSwap[0].dataset.layoutId).ease);
          const inverseEased = (t) => 1 - ease(1 - t);
          const animatedSwapParams = (
            /** @type {AnimationParams} */
            {}
          );
          if (swapAtProps) {
            for (let prop in swapAtProps) {
              if (prop !== "transform") {
                animatedSwapParams[prop] = [
                  { from: ($el) => oldState.getComputedValue($el, prop), to: swapAtProps[prop] },
                  { from: swapAtProps[prop], to: ($el) => newState.getComputedValue($el, prop), ease: inverseEased }
                ];
              }
            }
          }
          this.timeline.add(animatedSwap, animatedSwapParams, 0);
        }
      }
      const transformedLength = transformed.length;
      if (transformedLength) {
        for (let i = 0; i < transformedLength; i++) {
          const $el = transformed[i];
          const node = newState.getNode($el);
          if (!node.isInlined) {
            $el.style.translate = `${oldState.getComputedValue($el, "x")}px ${oldState.getComputedValue($el, "y")}px`;
          }
          $el.style.transform = oldState.getComputedValue($el, "transform");
          if (animatedSwap.includes($el)) {
            node.ease = getFunctionValue(swapAtParams.ease, $el, node.index, node.targets, null, null);
            node.duration = getFunctionValue(swapAtParams.duration, $el, node.index, node.targets, null, null);
          }
        }
        this.transformAnimation = waapi.animate(transformed, {
          translate: ($el) => {
            const node = newState.getNode($el);
            if (node.isInlined) return "0px 0px";
            return `${newState.getComputedValue($el, "x")}px ${newState.getComputedValue($el, "y")}px`;
          },
          transform: ($el) => {
            const newValue = newState.getComputedValue($el, "transform");
            if (!animatedSwap.includes($el)) return newValue;
            const oldValue = oldState.getComputedValue($el, "transform");
            const node = newState.getNode($el);
            return [oldValue, getFunctionValue(swapAtProps.transform, $el, node.index, node.targets, null, null), newValue];
          },
          autoplay: false,
          // persist: true,
          ...timingParams
        });
        this.timeline.sync(this.transformAnimation, 0);
      }
      return this.timeline.init();
    }
    /**
     * @param {(layout: this) => void} callback
     * @param {LayoutAnimationParams} [params]
     * @return {Timeline}
     */
    update(callback, params = {}) {
      this.record();
      callback(this);
      return this.animate(params);
    }
  };
  var createLayout = (root, params) => new AutoLayout(root, params);

  // node_modules/animejs/dist/modules/text/split.js
  var segmenter = typeof Intl !== "undefined" && Intl.Segmenter;
  var valueRgx = /\{value\}/g;
  var indexRgx = /\{i\}/g;
  var whiteSpaceGroupRgx = /(\s+)/;
  var whiteSpaceRgx = /^\s+$/;
  var lineType = "line";
  var wordType = "word";
  var charType = "char";
  var dataLine = `data-line`;
  var wordSegmenter = null;
  var graphemeSegmenter = null;
  var $splitTemplate = null;
  var isSegmentWordLike = (seg) => {
    return seg.isWordLike || seg.segment === " " || // Consider spaces as words first, then handle them diffrently later
    isNum(+seg.segment);
  };
  var setAriaHidden = ($el) => $el.setAttribute("aria-hidden", "true");
  var getAllTopLevelElements = ($el, type) => [.../** @type {*} */
  $el.querySelectorAll(`[data-${type}]:not([data-${type}] [data-${type}])`)];
  var debugColors2 = { line: "#00D672", word: "#FF4B4B", char: "#5A87FF" };
  var filterEmptyElements = ($el) => {
    if (!$el.childElementCount && !$el.textContent.trim()) {
      const $parent = $el.parentElement;
      $el.remove();
      if ($parent) filterEmptyElements($parent);
    }
  };
  var filterLineElements = ($el, lineIndex, bin) => {
    const dataLineAttr = $el.getAttribute(dataLine);
    if (dataLineAttr !== null && +dataLineAttr !== lineIndex || $el.tagName === "BR") {
      bin.add($el);
      const prev = $el.previousSibling;
      const next = $el.nextSibling;
      if (prev && prev.nodeType === 3 && whiteSpaceRgx.test(prev.textContent)) {
        bin.add(prev);
      }
      if (next && next.nodeType === 3 && whiteSpaceRgx.test(next.textContent)) {
        bin.add(next);
      }
    }
    let i = $el.childElementCount;
    while (i--) filterLineElements(
      /** @type {HTMLElement} */
      $el.children[i],
      lineIndex,
      bin
    );
    return bin;
  };
  var generateTemplate = (type, params = {}) => {
    let template = ``;
    if (!params) params = {};
    const classString = isStr(params.class) ? ` class="${params.class}"` : "";
    const cloneType = setValue(params.clone, false);
    const wrapType = setValue(params.wrap, false);
    const overflow = wrapType ? wrapType === true ? "clip" : wrapType : cloneType ? "clip" : false;
    if (wrapType) template += `<span${overflow ? ` style="overflow:${overflow};"` : ""}>`;
    template += `<span${classString}${cloneType ? ` style="position:relative;"` : ""} data-${type}="{i}">`;
    if (cloneType) {
      const left = cloneType === "left" ? "-100%" : cloneType === "right" ? "100%" : "0";
      const top = cloneType === "top" ? "-100%" : cloneType === "bottom" ? "100%" : "0";
      template += `<span>{value}</span>`;
      template += `<span inert style="position:absolute;top:${top};left:${left};white-space:nowrap;">{value}</span>`;
    } else {
      template += `{value}`;
    }
    template += `</span>`;
    if (wrapType) template += `</span>`;
    return template;
  };
  var processHTMLTemplate = (htmlTemplate, store, node, $parentFragment, type, debug2, lineIndex, wordIndex, charIndex) => {
    const isLine = type === lineType;
    const isChar = type === charType;
    const className = `_${type}_`;
    const template = isFnc(htmlTemplate) ? htmlTemplate(node) : htmlTemplate;
    const displayStyle = isLine ? "block" : "inline-block";
    $splitTemplate.innerHTML = template.replace(valueRgx, `<i class="${className}"></i>`).replace(indexRgx, `${isChar ? charIndex : isLine ? lineIndex : wordIndex}`);
    const $content = $splitTemplate.content;
    const $highestParent = (
      /** @type {HTMLElement} */
      $content.firstElementChild
    );
    const $split = (
      /** @type {HTMLElement} */
      $content.querySelector(`[data-${type}]`) || $highestParent
    );
    const $replacables = (
      /** @type {NodeListOf<HTMLElement>} */
      $content.querySelectorAll(`i.${className}`)
    );
    const replacablesLength = $replacables.length;
    if (replacablesLength) {
      $highestParent.style.display = displayStyle;
      $split.style.display = displayStyle;
      $split.setAttribute(dataLine, `${lineIndex}`);
      if (!isLine) {
        $split.setAttribute("data-word", `${wordIndex}`);
        if (isChar) $split.setAttribute("data-char", `${charIndex}`);
      }
      let i = replacablesLength;
      while (i--) {
        const $replace = $replacables[i];
        const $closestParent = $replace.parentElement;
        $closestParent.style.display = displayStyle;
        if (isLine) {
          $closestParent.innerHTML = /** @type {HTMLElement} */
          node.innerHTML;
        } else {
          $closestParent.replaceChild(node.cloneNode(true), $replace);
        }
      }
      store.push($split);
      $parentFragment.appendChild($content);
    } else {
      console.warn(`The expression "{value}" is missing from the provided template.`);
    }
    if (debug2) $highestParent.style.outline = `1px dotted ${debugColors2[type]}`;
    return $highestParent;
  };
  var TextSplitter = class {
    /**
     * @param  {Element|NodeList|String|Array<Element>} target
     * @param  {TextSplitterParams} [parameters]
     */
    constructor(target, parameters = {}) {
      if (!wordSegmenter) wordSegmenter = segmenter ? new segmenter([], { granularity: wordType }) : {
        segment: (text) => {
          const segments = [];
          const words2 = text.split(whiteSpaceGroupRgx);
          for (let i = 0, l = words2.length; i < l; i++) {
            const segment = words2[i];
            segments.push({
              segment,
              isWordLike: !whiteSpaceRgx.test(segment)
              // Consider non-whitespace as word-like
            });
          }
          return segments;
        }
      };
      if (!graphemeSegmenter) graphemeSegmenter = segmenter ? new segmenter([], { granularity: "grapheme" }) : {
        segment: (text) => [...text].map((char) => ({ segment: char }))
      };
      if (!$splitTemplate && isBrowser) $splitTemplate = doc.createElement("template");
      if (scope.current) scope.current.register(this);
      const { words, chars, lines, accessible, includeSpaces, debug: debug2 } = parameters;
      const $target = (
        /** @type {HTMLElement} */
        (target = isArr(target) ? target[0] : target) && /** @type {Node} */
        target.nodeType ? target : (getNodeList(target) || [])[0]
      );
      const lineParams = lines === true ? {} : lines;
      const wordParams = words === true || isUnd(words) ? {} : words;
      const charParams = chars === true ? {} : chars;
      this.debug = setValue(debug2, false);
      this.includeSpaces = setValue(includeSpaces, false);
      this.accessible = setValue(accessible, true);
      this.linesOnly = lineParams && (!wordParams && !charParams);
      this.lineTemplate = isObj(lineParams) ? generateTemplate(
        lineType,
        /** @type {SplitTemplateParams} */
        lineParams
      ) : lineParams;
      this.wordTemplate = isObj(wordParams) || this.linesOnly ? generateTemplate(
        wordType,
        /** @type {SplitTemplateParams} */
        wordParams
      ) : wordParams;
      this.charTemplate = isObj(charParams) ? generateTemplate(
        charType,
        /** @type {SplitTemplateParams} */
        charParams
      ) : charParams;
      this.$target = $target;
      this.html = $target && $target.innerHTML;
      this.lines = [];
      this.words = [];
      this.chars = [];
      this.effects = [];
      this.effectsCleanups = [];
      this.cache = null;
      this.ready = false;
      this.width = 0;
      this.resizeTimeout = null;
      const handleSplit = () => this.html && (lineParams || wordParams || charParams) && this.split();
      this.resizeObserver = new ResizeObserver(() => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          const currentWidth = (
            /** @type {HTMLElement} */
            $target.offsetWidth
          );
          if (currentWidth === this.width) return;
          this.width = currentWidth;
          handleSplit();
        }, 150);
      });
      if (this.lineTemplate && !this.ready) {
        doc.fonts.ready.then(handleSplit);
      } else {
        handleSplit();
      }
      $target ? this.resizeObserver.observe($target) : console.warn("No Text Splitter target found.");
    }
    /**
     * @param  {(...args: any[]) => Tickable | (() => void) | void} effect
     * @return this
     */
    addEffect(effect) {
      if (!isFnc(effect)) {
        console.warn("Effect must return a function.");
        return this;
      }
      const refreshableEffect = keepTime(effect);
      this.effects.push(refreshableEffect);
      if (this.ready) this.effectsCleanups[this.effects.length - 1] = refreshableEffect(this);
      return this;
    }
    revert() {
      clearTimeout(this.resizeTimeout);
      this.lines.length = this.words.length = this.chars.length = 0;
      this.resizeObserver.disconnect();
      this.effectsCleanups.forEach((cleanup) => isFnc(cleanup) ? cleanup(this) : cleanup.revert && cleanup.revert());
      this.$target.innerHTML = this.html;
      return this;
    }
    /**
     * Recursively processes a node and its children
     * @param {Node} node
     */
    splitNode(node) {
      const wordTemplate = this.wordTemplate;
      const charTemplate = this.charTemplate;
      const includeSpaces = this.includeSpaces;
      const debug2 = this.debug;
      const nodeType = node.nodeType;
      if (nodeType === 3) {
        const nodeText = node.nodeValue;
        if (nodeText.trim()) {
          const tempWords = [];
          const words = this.words;
          const chars = this.chars;
          const wordSegments = wordSegmenter.segment(nodeText);
          const $wordsFragment = doc.createDocumentFragment();
          let prevSeg = null;
          for (const wordSegment of wordSegments) {
            const segment = wordSegment.segment;
            const isWordLike = isSegmentWordLike(wordSegment);
            if (!prevSeg || isWordLike && (prevSeg && isSegmentWordLike(prevSeg))) {
              tempWords.push(segment);
            } else {
              const lastWordIndex = tempWords.length - 1;
              const lastWord = tempWords[lastWordIndex];
              if (!whiteSpaceGroupRgx.test(lastWord) && !whiteSpaceGroupRgx.test(segment)) {
                tempWords[lastWordIndex] += segment;
              } else {
                tempWords.push(segment);
              }
            }
            prevSeg = wordSegment;
          }
          for (let i = 0, l = tempWords.length; i < l; i++) {
            const word = tempWords[i];
            if (!word.trim()) {
              if (i && includeSpaces) continue;
              $wordsFragment.appendChild(doc.createTextNode(word));
            } else {
              const nextWord = tempWords[i + 1];
              const hasWordFollowingSpace = includeSpaces && nextWord && !nextWord.trim();
              const wordToProcess = word;
              const charSegments = charTemplate ? graphemeSegmenter.segment(wordToProcess) : null;
              const $charsFragment = charTemplate ? doc.createDocumentFragment() : doc.createTextNode(hasWordFollowingSpace ? word + "\xA0" : word);
              if (charTemplate) {
                const charSegmentsArray = [...charSegments];
                for (let j = 0, jl = charSegmentsArray.length; j < jl; j++) {
                  const charSegment = charSegmentsArray[j];
                  const isLastChar = j === jl - 1;
                  const charText = isLastChar && hasWordFollowingSpace ? charSegment.segment + "\xA0" : charSegment.segment;
                  const $charNode = doc.createTextNode(charText);
                  processHTMLTemplate(
                    charTemplate,
                    chars,
                    $charNode,
                    /** @type {DocumentFragment} */
                    $charsFragment,
                    charType,
                    debug2,
                    -1,
                    words.length,
                    chars.length
                  );
                }
              }
              if (wordTemplate) {
                processHTMLTemplate(wordTemplate, words, $charsFragment, $wordsFragment, wordType, debug2, -1, words.length, chars.length);
              } else if (charTemplate) {
                $wordsFragment.appendChild($charsFragment);
              } else {
                $wordsFragment.appendChild(doc.createTextNode(word));
              }
              if (hasWordFollowingSpace) i++;
            }
          }
          node.parentNode.replaceChild($wordsFragment, node);
        }
      } else if (nodeType === 1) {
        const childNodes = (
          /** @type {Array<Node>} */
          [.../** @type {*} */
          node.childNodes]
        );
        for (let i = 0, l = childNodes.length; i < l; i++) this.splitNode(childNodes[i]);
      }
    }
    /**
     * @param {Boolean} clearCache
     * @return {this}
     */
    split(clearCache = false) {
      const $el = this.$target;
      const isCached = !!this.cache && !clearCache;
      const lineTemplate = this.lineTemplate;
      const wordTemplate = this.wordTemplate;
      const charTemplate = this.charTemplate;
      const fontsReady = doc.fonts.status !== "loading";
      const canSplitLines = lineTemplate && fontsReady;
      this.ready = !lineTemplate || fontsReady;
      if (canSplitLines || clearCache) {
        this.effectsCleanups.forEach((cleanup) => isFnc(cleanup) && cleanup(this));
      }
      if (!isCached) {
        if (clearCache) {
          $el.innerHTML = this.html;
          this.words.length = this.chars.length = 0;
        }
        this.splitNode($el);
        this.cache = $el.innerHTML;
      }
      if (canSplitLines) {
        if (isCached) $el.innerHTML = this.cache;
        this.lines.length = 0;
        if (wordTemplate) this.words = getAllTopLevelElements($el, wordType);
      }
      if (charTemplate && (canSplitLines || wordTemplate)) {
        this.chars = getAllTopLevelElements($el, charType);
      }
      const elementsArray = this.words.length ? this.words : this.chars;
      let y, linesCount = 0;
      for (let i = 0, l = elementsArray.length; i < l; i++) {
        const $el2 = elementsArray[i];
        const { top, height } = $el2.getBoundingClientRect();
        if (!isUnd(y) && top - y > height * 0.5) linesCount++;
        $el2.setAttribute(dataLine, `${linesCount}`);
        const nested = $el2.querySelectorAll(`[${dataLine}]`);
        let c = nested.length;
        while (c--) nested[c].setAttribute(dataLine, `${linesCount}`);
        y = top;
      }
      if (canSplitLines) {
        const linesFragment = doc.createDocumentFragment();
        const parents = /* @__PURE__ */ new Set();
        const clones = [];
        for (let lineIndex = 0; lineIndex < linesCount + 1; lineIndex++) {
          const $clone = (
            /** @type {HTMLElement} */
            $el.cloneNode(true)
          );
          filterLineElements($clone, lineIndex, /* @__PURE__ */ new Set()).forEach(($el2) => {
            const $parent = $el2.parentNode;
            if ($parent) {
              if ($el2.nodeType === 1) parents.add(
                /** @type {HTMLElement} */
                $parent
              );
              $parent.removeChild($el2);
            }
          });
          clones.push($clone);
        }
        parents.forEach(filterEmptyElements);
        for (let cloneIndex = 0, clonesLength = clones.length; cloneIndex < clonesLength; cloneIndex++) {
          processHTMLTemplate(lineTemplate, this.lines, clones[cloneIndex], linesFragment, lineType, this.debug, cloneIndex);
        }
        $el.innerHTML = "";
        $el.appendChild(linesFragment);
        if (wordTemplate) this.words = getAllTopLevelElements($el, wordType);
        if (charTemplate) this.chars = getAllTopLevelElements($el, charType);
      }
      if (this.linesOnly) {
        const words = this.words;
        let w = words.length;
        while (w--) {
          const $word = words[w];
          $word.replaceWith($word.textContent);
        }
        words.length = 0;
      }
      if (this.accessible && (canSplitLines || !isCached)) {
        const $accessible = doc.createElement("span");
        $accessible.style.cssText = `position:absolute;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);width:1px;height:1px;white-space:nowrap;`;
        $accessible.innerHTML = this.html;
        $el.insertBefore($accessible, $el.firstChild);
        this.lines.forEach(setAriaHidden);
        this.words.forEach(setAriaHidden);
        this.chars.forEach(setAriaHidden);
      }
      this.width = /** @type {HTMLElement} */
      $el.offsetWidth;
      if (canSplitLines || clearCache) {
        this.effects.forEach((effect, i) => this.effectsCleanups[i] = effect(this));
      }
      return this;
    }
    refresh() {
      this.split(true);
    }
  };
  var splitText = (target, parameters) => new TextSplitter(target, parameters);

  // src/box-engine/draggable-adapter.ts
  function makeDraggable(target, opts = {}) {
    const el = target.el ?? target;
    const box = target.el ? target : null;
    const xOn = opts.axis !== "y";
    const yOn = opts.axis !== "x";
    const container = opts.container instanceof HTMLElement ? opts.container : opts.container === null ? void 0 : opts.container;
    const draggable = new Draggable(el, {
      x: xOn,
      y: yOn,
      container,
      snap: opts.snap ?? 0,
      onGrab: (d) => opts.onGrab?.(d),
      onDrag: (d) => {
        if (box) {
          box.rect.x = d.x;
          box.rect.y = d.y;
        }
        opts.onDrag?.(d, box);
      },
      onRelease: (d) => {
        if (box && box.parent) {
          box.fitCheck(true);
        }
        opts.onRelease?.(d, box);
      },
      onSettle: (d) => {
        if (box) box.publishLayout();
        opts.onSettle?.(d, box);
      }
    });
    return {
      draggable,
      box,
      get x() {
        return draggable.x;
      },
      get y() {
        return draggable.y;
      },
      set(x, y) {
        if (xOn) draggable.setX(x);
        if (yOn) draggable.setY(y);
      },
      enable: () => draggable.enable(),
      disable: () => draggable.disable(),
      revert: () => draggable.revert()
    };
  }

  // src/box-engine/box-adapter.ts
  var TRANSFORM_PROPS = /* @__PURE__ */ new Set(["x", "y", "scale", "rotate", "opacity"]);
  function isBox(t) {
    const hasElement = typeof HTMLElement !== "undefined" && t?.el instanceof HTMLElement;
    return t instanceof Box || t && typeof t === "object" && hasElement && "kind" in t && "rect" in t;
  }
  function readTransform(el) {
    const m = /([-\d.]+)/.exec(el.style.transform || "");
    return m ? parseFloat(m[1]) : 0;
  }
  function writeTransform(el, p, v) {
    const cur = el.style.transform || "";
    const fn = p === "x" ? "translateX" : p === "y" ? "translateY" : p === "scale" ? "scale" : "rotate";
    const u = p === "scale" ? "" : p === "rotate" ? "deg" : "px";
    const re = new RegExp(`${fn}\\([^)]*\\)`);
    const next = `${fn}(${v}${u})`;
    el.style.transform = re.test(cur) ? cur.replace(re, next) : (cur + " " + next).trim();
  }
  registerAdapter({
    test: (t) => isBox(t),
    props: (t) => {
      const out = ["x", "y", "scale", "rotate", "opacity"];
      if (t.rect) out.push("w", "h");
      return out;
    },
    get: (t, p) => {
      if (TRANSFORM_PROPS.has(p)) {
        if (p === "opacity") return parseFloat(t.el.style.opacity) || 1;
        return readTransform(t.el);
      }
      if (p === "w") return t.rect?.w ?? t.el.offsetWidth ?? 0;
      if (p === "h") return t.rect?.h ?? t.el.offsetHeight ?? 0;
      return 0;
    },
    set: (t, p, v) => {
      if (TRANSFORM_PROPS.has(p)) {
        if (p === "opacity") {
          t.el.style.opacity = String(v);
          return;
        }
        writeTransform(t.el, p, v);
        return;
      }
      if (p === "w" || p === "h") {
        if (!t.rect) t.rect = { x: 0, y: 0, w: 0, h: 0 };
        t.rect[p] = v;
        if (p === "w") t.el.style.width = `${v}px`;
        if (p === "h") t.el.style.height = `${v}px`;
        t.el.style.setProperty("--box-w", `${t.rect.w.toFixed(1)}px`);
        t.el.style.setProperty("--box-h", `${t.rect.h.toFixed(1)}px`);
      }
    },
    unit: (_t, p) => p === "rotate" ? "deg" : p === "scale" ? "" : p === "w" || p === "h" ? "px" : "px"
  });
  var boxAdapter = { isBox };

  // src/box-engine/box-engine.ts
  var KIND_COLORS = {
    scene: "#7c4dff",
    container: "#ff5252",
    subcontainer: "#ffffff",
    module: "#ffd740",
    component: "#69f0ae",
    micro: "#40c4ff"
  };
  var UID = 0;
  var Box = class {
    constructor(spec = {}, mount) {
      this.parent = null;
      this.children = [];
      this.rect = { x: 0, y: 0, w: 0, h: 0 };
      this.fitOk = true;
      this.kind = spec.kind ?? "module";
      this.id = spec.id ?? `box-${++UID}`;
      this.spec = spec;
      const el = document.createElement("div");
      el.dataset.boxId = this.id;
      el.dataset.kind = this.kind;
      if (spec.label) el.dataset.label = spec.label;
      if (spec.className) el.className = spec.className;
      el.style.position = "relative";
      el.style.boxSizing = "border-box";
      if (spec.w) el.style.width = `${spec.w}px`;
      if (spec.h) el.style.height = `${spec.h}px`;
      if (spec.style) Object.assign(el.style, spec.style);
      this.el = el;
      if (mount) mount.appendChild(el);
    }
    add(...kids) {
      for (const k of kids) {
        k.parent = this;
        this.children.push(k);
        this.el.appendChild(k.el);
      }
      return this;
    }
    remove(kid) {
      const i = this.children.indexOf(kid);
      if (i >= 0) {
        this.children.splice(i, 1);
        kid.parent = null;
        kid.el.remove();
      }
      return this;
    }
    /** Measure this box + all children (depth-first). Returns nothing; fills rects. */
    measure() {
      const r = this.el.getBoundingClientRect();
      const parent = this.el.parentElement;
      const pr = parent ? parent.getBoundingClientRect() : { x: 0, y: 0 };
      this.rect = {
        x: r.x - pr.x,
        y: r.y - pr.y,
        w: r.width,
        h: r.height
      };
      for (const c of this.children) c.measure();
    }
    /**
     * fitCheck: a module must fit INSIDE its parent subcontainer.
     * If the module's measured rect exceeds the parent's content box, flag it.
     * Returns true if OK. (Call after measure().)
     */
    fitCheck(allowShrink = true) {
      if (this.kind !== "module" && this.kind !== "component" && this.kind !== "micro") return true;
      const p = this.parent;
      if (!p) return true;
      const pad = p.spec.pad ?? 0;
      const availW = p.rect.w - pad * 2;
      const availH = p.rect.h - pad * 2;
      this.fitOk = this.rect.w <= availW + 0.5 && this.rect.h <= availH + 0.5;
      if (!this.fitOk && allowShrink) {
        const sx = availW / this.rect.w;
        const sy = availH / this.rect.h;
        const s = Math.min(sx, sy, 1);
        this.el.style.transform = `scale(${s.toFixed(3)})`;
        this.el.style.transformOrigin = "top left";
        this.fitOk = true;
      }
      return this.fitOk;
    }
    /** Expose layout as CSS custom props on the element (Pulse composes on top). */
    publishLayout() {
      this.el.style.setProperty("--box-x", `${this.rect.x.toFixed(1)}px`);
      this.el.style.setProperty("--box-y", `${this.rect.y.toFixed(1)}px`);
      this.el.style.setProperty("--box-w", `${this.rect.w.toFixed(1)}px`);
      this.el.style.setProperty("--box-h", `${this.rect.h.toFixed(1)}px`);
      this.el.style.setProperty("--box-kind", this.kind);
      this.el.style.setProperty("--box-color", KIND_COLORS[this.kind]);
      this.el.style.outline = `1px solid ${KIND_COLORS[this.kind]}`;
      this.el.style.outlineOffset = "-1px";
      for (const c of this.children) c.publishLayout();
    }
    /** Drive this box's element via Pulse's bag (compose with keyframes). */
    animate(pulse, keys, opts = {}) {
      return pulse.bag(this.el, keys, opts);
    }
    /** Make this box draggable via anime.js v4 Draggable (see draggable-adapter). */
    makeDraggable(opts = {}) {
      return makeDraggable(this, opts);
    }
    /** boundedGrid: arrange parallel subcontainers at EQUAL size. Enforces
     *  paint↔resize parity — same carve logic used in both measure and resize. */
    static carveBounded(parent) {
      const kids = parent.children.filter((c) => c.kind === "subcontainer");
      if (kids.length === 0) return;
      const pad = parent.spec.pad ?? 0;
      const gap = parent.spec.gap ?? 0;
      const flow = parent.spec.flow ?? "row";
      const innerW = parent.rect.w - pad * 2;
      const innerH = parent.rect.h - pad * 2;
      if (flow === "row") {
        const cw = (innerW - gap * (kids.length - 1)) / kids.length;
        kids.forEach((k, i) => {
          k.el.style.position = "absolute";
          k.el.style.left = `${pad + i * (cw + gap)}px`;
          k.el.style.top = `${pad}px`;
          k.el.style.width = `${cw}px`;
          k.el.style.height = `${innerH}px`;
        });
      } else {
        const ch = (innerH - gap * (kids.length - 1)) / kids.length;
        kids.forEach((k, i) => {
          k.el.style.position = "absolute";
          k.el.style.left = `${pad}px`;
          k.el.style.top = `${pad + i * (ch + gap)}px`;
          k.el.style.width = `${innerW}px`;
          k.el.style.height = `${ch}px`;
        });
      }
    }
    destroy() {
      for (const c of [...this.children]) c.destroy();
      this.el.remove();
    }
    /** Canonical PulsePlayable teardown alias. */
    dispose() {
      this.destroy();
    }
  };
  var BoxTree = class {
    constructor(rootSpec = { kind: "scene" }, mount) {
      this.nodes = /* @__PURE__ */ new Map();
      this.root = new Box(rootSpec, mount);
      this.nodes.set(this.root.id, this.root);
    }
    /** Build the hierarchy from a declarative spec tree. */
    build(node) {
      const box = new Box(node, this.root.el);
      this.nodes.set(box.id, box);
      this.root.add(box);
      return box;
    }
    register(b) {
      this.nodes.set(b.id, b);
    }
    get(id2) {
      return this.nodes.get(id2);
    }
    /** Full layout pass: measure → bounded carve → fitCheck → publish. */
    layout() {
      this.root.measure();
      const walk = (b) => {
        for (const c of b.children) walk(c);
        if (b.spec.bounded) Box.carveBounded(b);
      };
      walk(this.root);
      this.root.measure();
      const fitFails = [];
      const fc = (b) => {
        if (b.spec.fitCheck !== false) {
          if (!b.fitCheck(true)) fitFails.push(b);
        }
        for (const c of b.children) fc(c);
      };
      fc(this.root);
      this.root.publishLayout();
      return { fitFails };
    }
    /** Animate a box through Pulse. */
    animate(id2, pulse, keys, opts) {
      const b = this.nodes.get(id2);
      if (!b) throw new Error(`BoxTree: no box '${id2}'`);
      return b.animate(pulse, keys, opts);
    }
    destroy() {
      this.root.destroy();
      this.nodes.clear();
    }
    /** Canonical PulsePlayable teardown alias. */
    dispose() {
      this.destroy();
    }
  };
  var pulseBox = {
    Box,
    BoxTree,
    KIND_COLORS
  };

  // src/box-engine/drag-adapter.ts
  var DragInstance = class {
    constructor(el, params = {}) {
      // live state
      this.x = 0;
      this.y = 0;
      this.angle = 0;
      this.scale = 1;
      this.velocity = 0;
      this.grabbed = false;
      this.dragged = false;
      // internal
      this.startX = 0;
      this.startY = 0;
      this.originX = 0;
      this.originY = 0;
      this.lastT = 0;
      this.vStack = [0, 0, 0];
      this.vIdx = 0;
      this.el = el;
      this.params = params;
      this.type = params.type ?? "xy";
      this.bindDown = this.onDown.bind(this);
      this.bindMove = this.onMove.bind(this);
      this.bindUp = this.onUp.bind(this);
      el.style.touchAction = "none";
      el.addEventListener("pointerdown", this.bindDown);
    }
    bounds() {
      const c = this.params.container;
      if (!c) return null;
      const cr = c.getBoundingClientRect();
      const er = this.el.getBoundingClientRect();
      return {
        minX: -(er.width / 2),
        maxX: cr.width - er.width / 2,
        minY: -(er.height / 2),
        maxY: cr.height - er.height / 2
      };
    }
    clampAxis(v, axis) {
      const b = this.bounds();
      if (!b) return v;
      return axis === "x" ? Math.max(b.minX, Math.min(b.maxX, v)) : Math.max(b.minY, Math.min(b.maxY, v));
    }
    apply() {
      const t = this.type;
      const transforms = [];
      if (t === "x" || t === "xy" || t === "translate") transforms.push(`translateX(${this.x.toFixed(2)}px)`);
      if (t === "y" || t === "xy" || t === "translate") transforms.push(`translateY(${this.y.toFixed(2)}px)`);
      if (t === "rotate") transforms.push(`rotate(${this.angle.toFixed(2)}deg)`);
      if (t === "scale") transforms.push(`scale(${this.scale.toFixed(3)})`);
      this.el.style.transform = transforms.join(" ");
      this.params.onUpdate?.(this);
    }
    onDown(e) {
      this.grabbed = true;
      this.dragged = false;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.originX = this.x;
      this.originY = this.y;
      this.lastT = performance.now();
      this.vStack = [0, 0, 0];
      this.el.ownerDocument.addEventListener("pointermove", this.bindMove);
      this.el.ownerDocument.addEventListener("pointerup", this.bindUp);
      this.params.onGrab?.(this);
    }
    onMove(e) {
      if (!this.grabbed) return;
      const thresh = this.params.threshold ?? 3;
      let dx = e.clientX - this.startX;
      let dy = e.clientY - this.startY;
      if (!this.dragged && Math.hypot(dx, dy) < thresh) return;
      this.dragged = true;
      const t = this.type;
      if (t === "x" || t === "xy" || t === "translate") this.x = this.clampAxis(this.originX + dx, "x");
      if (t === "y" || t === "xy" || t === "translate") this.y = this.clampAxis(this.originY + dy, "y");
      if (t === "rotate") this.angle = Math.atan2(dy, dx) * (180 / Math.PI);
      if (t === "scale") {
        const dist = Math.hypot(dx, dy);
        this.scale = Math.max(0.2, Math.min(3, 1 + dist / 120));
      }
      this.computeVelocity(dx, dy);
      this.apply();
      this.params.onDrag?.(this);
    }
    onUp(e) {
      if (!this.grabbed) return;
      this.grabbed = false;
      this.el.ownerDocument.removeEventListener("pointermove", this.bindMove);
      this.el.ownerDocument.removeEventListener("pointerup", this.bindUp);
      if (this.dragged) {
        this.angle = this.type === "rotate" ? this.angle : Math.atan2(e.clientY - this.startY, e.clientX - this.startX) * (180 / Math.PI);
        this.params.onRelease?.(this);
      }
    }
    computeVelocity(dx, dy) {
      const now2 = performance.now();
      const elapsed = now2 - this.lastT;
      if (elapsed < 17) return;
      this.lastT = now2;
      const v = Math.round(Math.hypot(dx, dy) / elapsed * 1e3) / 1e3;
      this.vStack[this.vIdx] = v;
      this.vIdx = (this.vIdx + 1) % 3;
      this.velocity = Math.max(this.vStack[0], this.vStack[1], this.vStack[2]);
    }
    /** Programmatic set (anime.js setX/setY). */
    setX(x) {
      this.x = this.clampAxis(x, "x");
      this.apply();
    }
    setY(y) {
      this.y = this.clampAxis(y, "y");
      this.apply();
    }
    destroy() {
      this.el.removeEventListener("pointerdown", this.bindDown);
      this.el.ownerDocument.removeEventListener("pointermove", this.bindMove);
      this.el.ownerDocument.removeEventListener("pointerup", this.bindUp);
    }
  };
  function makeDraggable2(el, params = {}) {
    return new DragInstance(el, params);
  }

  // src/utils/utils.ts
  var clamp2 = (v, min = 0, max2 = 1) => v < min ? min : v > max2 ? max2 : v;
  var round2 = (v, dp = 2) => {
    const f = 10 ** dp;
    return Math.round(v * f) / f;
  };
  var snap2 = (v, step) => step === 0 ? v : Math.round(v / step) * step;
  var map = (v, inMin, inMax, outMin, outMax) => {
    if (inMax === inMin) return outMin;
    const t = (v - inMin) / (inMax - inMin);
    return outMin + (outMax - outMin) * t;
  };
  var lerp2 = (a, b, t) => a + (b - a) * t;
  var interpolate = lerp2;
  function mulberry32(seed) {
    let s = seed >>> 0;
    return function() {
      s |= 0;
      s = s + 1831565813 | 0;
      let t = Math.imul(s ^ s >>> 15, 1 | s);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function rng(seed = 1, min = 0, max2 = 1) {
    let s, lo = min, hi = max2;
    if (typeof seed === "object") {
      s = seed.seed ?? Math.random() * 1e9 | 0;
      lo = seed.min ?? 0;
      hi = seed.max ?? 1;
    } else s = seed;
    const r = mulberry32(s || 1);
    return () => lo + r() * (hi - lo);
  }
  var random = (min = 0, max2 = 1) => min + Math.random() * (max2 - min);
  var randomInt = (min, max2) => Math.floor(random(min, max2 + 1));
  var pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  var deg2rad = (d) => d * Math.PI / 180;
  var rad2deg = (r) => r * 180 / Math.PI;
  var smoothstep = (t) => {
    const x = clamp2(t);
    return x * x * (3 - 2 * x);
  };
  function stagger2(count, opts = {}) {
    const { step = 0.08, base = 0, reversed = false, from = 0, seed = false } = opts;
    const idx = [];
    for (let i = 0; i < count; i++) idx.push(i);
    let order = idx;
    if (from === "first") order = idx;
    else if (from === "last") order = [...idx].reverse();
    else if (from === "center") {
      const c = (count - 1) / 2;
      order = [...idx].sort((a, b) => Math.abs(a - c) - Math.abs(b - c));
    } else if (from === "random") {
      const r = typeof seed === "number" ? mulberry32(seed) : Math.random;
      order = [...idx].sort(() => r() - 0.5);
    } else if (typeof from === "number") {
      order = [...idx].sort((a, b) => Math.abs(a - from) - Math.abs(b - from));
    }
    const delays = new Array(count).fill(0);
    order.forEach((origIdx, pos) => {
      const p = reversed ? order.length - 1 - pos : pos;
      delays[origIdx] = base + p * step;
    });
    return delays;
  }
  var utils = {
    clamp: clamp2,
    round: round2,
    snap: snap2,
    map,
    lerp: lerp2,
    interpolate,
    rng,
    mulberry32,
    random,
    randomInt,
    pick,
    deg2rad,
    rad2deg,
    smoothstep,
    stagger: stagger2
  };

  // src/core/timer.ts
  var EPS = 1e-6;
  var Timer2 = class {
    constructor(opts = {}) {
      // --- public params ---
      this.duration = 0;
      // total duration (= iterationDuration * iterationCount, minus loop delays)
      this.iterationDuration = 0;
      // duration of ONE loop
      this.iterationCount = 1;
      // number of loops
      this.paused = true;
      this.began = false;
      this.completed = false;
      this.reversed = false;
      // --- internal clock state ---
      this._elapsed = 0;
      // iteration time within current loop (0..iterationDuration)
      this._iteration = 0;
      // current loop index (0-based)
      this._dir = 1;
      // 1 = forward, -1 = reverse (alternate)
      this._delayLeft = 0;
      this._speed = 1;
      this._alternate = false;
      this._loop = false;
      this._loopDelay = 0;
      this._autoplay = true;
      this._cancelled = false;
      this._resolve = () => {
      };
      this._unsub = null;
      // ===== internal tick =====
      this._tick = (rawDt) => {
        if (this.paused || this._cancelled) return;
        let dt = rawDt * this._speed;
        if (this._delayLeft > 0) {
          this._delayLeft -= dt;
          if (this._delayLeft > 0) return;
          dt = -this._delayLeft;
          this._delayLeft = 0;
        }
        if (!this.began) {
          this.began = true;
          this.onBegin?.(this);
        }
        this.onBeforeUpdate?.(this);
        let next = this._elapsed + dt * this._dir;
        if (this._dir === 1 && next >= this.iterationDuration) {
          const over = next - this.iterationDuration;
          if (this._isLastIteration()) {
            this._elapsed = this.iterationDuration;
            this._renderFrame();
            this._finish();
            this.pause();
            return;
          }
          this._iteration++;
          this.onLoop?.(this);
          if (this._alternate) {
            this._dir = -1;
            this._elapsed = this.iterationDuration - over;
            if (this._loopDelay > 0) this._elapsed = Math.max(0, this.iterationDuration - this._loopDelay);
          } else {
            this._elapsed = over % this.iterationDuration;
          }
          this._renderFrame();
          return;
        }
        if (this._dir === -1 && next <= 0) {
          const under = -next;
          if (this._iteration <= 0) {
            this._elapsed = 0;
            this._renderFrame();
            if (this._loop) {
              this._dir = 1;
              this._iteration = 0;
              this.onLoop?.(this);
              this._renderFrame();
              return;
            }
            this._finish();
            this.pause();
            return;
          }
          this._iteration--;
          this.onLoop?.(this);
          this._dir = 1;
          this._elapsed = under % this.iterationDuration;
          this._renderFrame();
          return;
        }
        this._elapsed = Math.max(0, Math.min(this.iterationDuration, next));
        this._renderFrame();
      };
      const {
        duration = 0,
        delay = 0,
        loopDelay = 0,
        loop = false,
        alternate = false,
        reversed = false,
        autoplay = true,
        playbackRate = 1,
        onBegin,
        onBeforeUpdate,
        onUpdate,
        onLoop,
        onPause,
        onComplete
      } = opts;
      const iter = duration;
      const count = loop === true || loop === Infinity || typeof loop === "number" && loop < 0 ? Infinity : loop === false ? 1 : loop + 1;
      this.iterationDuration = iter;
      this.iterationCount = count;
      this.duration = count === Infinity ? Infinity : Math.max(EPS, (iter + loopDelay) * count - loopDelay);
      this._delayLeft = delay;
      this._loop = !!loop;
      this._loopDelay = loopDelay;
      this._alternate = !!alternate;
      this._dir = reversed ? -1 : 1;
      this.reversed = reversed;
      this._autoplay = autoplay;
      this._speed = playbackRate;
      this.onBegin = onBegin;
      this.onBeforeUpdate = onBeforeUpdate;
      this.onUpdate = onUpdate;
      this.onLoop = onLoop;
      this.onPause = onPause;
      this.onComplete = onComplete;
      if (autoplay) this.resume();
    }
    // ===== lifecycle =====
    resume() {
      if (!this.paused) return this;
      this.paused = false;
      if (!this._unsub) this._unsub = ticker.add(this._tick);
      if (this._delayLeft > 0) this._delayLeft -= EPS;
      return this;
    }
    pause() {
      if (this.paused) return this;
      this.paused = true;
      this._unsub?.();
      this._unsub = null;
      this.onPause?.(this);
      return this;
    }
    play() {
      return this.resume();
    }
    restart() {
      this._resetState();
      return this.resume();
    }
    // ===== seeking =====
    /** Jump to absolute time (seconds). Renders that frame. */
    seek(time) {
      const wasPaused = this.paused;
      this.paused = true;
      this._applyTime(time);
      if (!wasPaused) this.resume();
      return this;
    }
    /** Set playback speed (1 = normal). */
    setSpeed(rate) {
      this._speed = rate < EPS ? EPS : rate;
      return this;
    }
    /** Render the final frame immediately (no ticker). For reduced-motion snap. */
    snap() {
      this._elapsed = this.iterationDuration;
      this._renderFrame();
      return this;
    }
    /** Reverse direction (toggles alternate under the hood, like anime). */
    reverse() {
      if (this._dir === 1) this._dir = -1;
      else this._dir = 1;
      this.reversed = this._dir === -1;
      return this.resume();
    }
    /** Toggle alternate on/off. */
    alternate(on = true) {
      this._alternate = on;
      return this;
    }
    /** Immediately complete (jump to end) + cancel + onComplete. */
    complete() {
      this._applyTime(this.duration === Infinity ? this.iterationDuration : this.duration);
      this._finish();
      this.pause();
      return this;
    }
    /** Cancel (stop, mark cancelled). */
    cancel() {
      this._cancelled = true;
      return this.pause();
    }
    /** Revert (seek to 0 and cancel) — subclass may restore original values. */
    revert() {
      this._applyTime(0);
      return this.cancel();
    }
    /** Rescale the whole timer to a new total duration. */
    stretch(newDuration) {
      if (newDuration <= EPS) {
        this.iterationDuration = EPS;
        this.duration = EPS;
        return this;
      }
      const scale = newDuration / (this.duration === Infinity ? this.iterationDuration : this.duration);
      this.iterationDuration *= scale;
      this.duration = this.iterationCount === Infinity ? Infinity : this.iterationDuration * this.iterationCount;
      this._loopDelay *= scale;
      return this;
    }
    // ===== properties =====
    get currentTime() {
      return this._cancelled ? 0 : this._elapsed + this._iteration * (this.iterationDuration + this._loopDelay);
    }
    set currentTime(t) {
      this.seek(t);
    }
    get iterationCurrentTime() {
      return this._elapsed;
    }
    get progress() {
      if (this.duration === Infinity) return this.iterationDuration ? this._elapsed / this.iterationDuration : 0;
      return Math.max(0, Math.min(1, this.currentTime / this.duration));
    }
    get iterationProgress() {
      return this.iterationDuration ? Math.max(0, Math.min(1, this._elapsed / this.iterationDuration)) : 0;
    }
    get currentIteration() {
      return this._iteration;
    }
    get cancelled() {
      return this._cancelled;
    }
    // ===== promise =====
    then(cb) {
      return new Promise((res) => {
        this._resolve = () => {
          this._resolve = () => {
          };
          cb?.(this);
          res(this);
        };
        if (this.completed) this._resolve();
      });
    }
    // ===== subclass hook =====
    /** Render a frame at raw iteration progress (0..1). Override in subclasses. */
    render(_progress) {
    }
    _isLastIteration() {
      return this.iterationCount === Infinity ? false : this._iteration >= this.iterationCount - 1;
    }
    _renderFrame() {
      const p = this.iterationDuration ? this._elapsed / this.iterationDuration : 1;
      this.render(p);
      this.onUpdate?.(this);
    }
    _applyTime(time) {
      const span = this.iterationDuration + this._loopDelay;
      if (span <= 0) {
        this._iteration = 0;
        this._elapsed = 0;
        this._dir = 1;
        this._renderFrame();
        return;
      }
      let t = Math.max(0, time);
      this._iteration = Math.floor(t / span);
      let rem = t - this._iteration * span;
      if (rem > this.iterationDuration) {
        this._elapsed = this.iterationDuration;
      } else {
        this._elapsed = rem;
      }
      this._dir = this._alternate && this._iteration % 2 === 1 ? -1 : 1;
      if (this._iteration >= this.iterationCount && this.iterationCount !== Infinity) {
        this._iteration = this.iterationCount - 1;
        this._elapsed = this.iterationDuration;
      }
      this._renderFrame();
    }
    _finish() {
      if (this.completed) return;
      this.completed = true;
      this.onComplete?.(this);
      this._resolve();
    }
    _resetState() {
      this._elapsed = 0;
      this._iteration = 0;
      this._dir = this.reversed ? -1 : 1;
      this.began = false;
      this.completed = false;
      this._cancelled = false;
      this._delayLeft = 0;
    }
    /** Drop the ticker subscription (cleanup). */
    dispose() {
      this.pause();
    }
  };

  // src/core/bag.ts
  var Bag = class extends Timer2 {
    constructor(el, spec, opts = {}) {
      super({
        duration: opts.duration ?? 0.9,
        delay: opts.delay ?? 0,
        loop: opts.loop ?? false,
        alternate: opts.alternate ?? false,
        loopDelay: opts.loopDelay,
        reversed: opts.reversed,
        autoplay: opts.autoplay ?? true,
        playbackRate: opts.playbackRate,
        onBegin: opts.onBegin,
        onBeforeUpdate: opts.onBeforeUpdate,
        onUpdate: opts.onUpdate,
        onLoop: opts.onLoop,
        onPause: opts.onPause,
        onComplete: opts.onComplete
      });
      this.specNorm = {};
      this.keysList = [];
      this.el = el;
      this._easeFn = resolveEase(opts.ease);
      for (const raw of Object.keys(spec)) {
        const v = spec[raw];
        const norm = {};
        if (Array.isArray(v)) {
          if (v.length && v.every((x) => typeof x === "string")) norm.colors = v.slice();
          else norm.keys = v.slice();
        } else {
          if (v.keys) norm.keys = v.keys.slice();
          if ("from" in v) norm.from = v.from;
          if ("to" in v) norm.to = v.to;
          if (v.unit) norm.unit = v.unit;
          if (v.css) norm.css = v.css;
          if (v.fn) norm.fn = v.fn;
          if (v.template) norm.template = v.template;
          if (Array.isArray(v.colors)) norm.colors = v.colors.slice();
        }
        this.specNorm[raw] = norm;
        this.keysList.push(raw);
      }
    }
    /** Read current value of a key (canonical or raw name). */
    get(key2) {
      const norm = this.specNorm[key2];
      if (!norm) return 0;
      const vals = this.keyValues(norm);
      const t = this.iterationDuration <= 0 ? 1 : Math.min(1, this._elapsed / this.iterationDuration);
      return this.interp(vals, t);
    }
    render(progress) {
      if (!this.el) return;
      const p = this._easeFn(progress);
      const values = {};
      for (const k of this.keysList) {
        const norm = this.specNorm[k];
        if (norm.colors) continue;
        const v = this.interp(this.keyValues(norm), p);
        if (norm.template) {
          norm.template({ ...values, [k]: v });
          continue;
        }
        values[k] = v;
      }
      PulseProperties.apply(this.el, this.specNorm, values, p);
    }
    /** Non-destructive: compute the value map at a progress WITHOUT writing to the target. */
    values(progress = 1) {
      const p = this._easeFn(progress);
      const out = {};
      for (const k of this.keysList) out[k] = this.interp(this.keyValues(this.specNorm[k]), p);
      return out;
    }
    keyValues(norm) {
      if (norm.keys) return norm.keys;
      if (norm.from !== void 0 && norm.to !== void 0) return [norm.from, norm.to];
      if (norm.from !== void 0) return [norm.from];
      if (norm.to !== void 0) return [norm.to];
      return [0];
    }
    interp(keys, p) {
      if (keys.length === 1) return keys[0];
      const seg = p * (keys.length - 1);
      const i = Math.min(keys.length - 2, Math.floor(seg));
      const f = seg - i;
      return keys[i] + (keys[i + 1] - keys[i]) * f;
    }
  };

  // src/text/text.ts
  function splitText2(el, mode = "chars") {
    const original = el.innerHTML;
    const text = el.textContent ?? "";
    el.textContent = "";
    const units = [];
    const make = (s) => {
      const span = document.createElement("span");
      span.textContent = s;
      span.style.display = "inline-block";
      span.style.willChange = "transform, opacity";
      span.dataset.textUnit = "1";
      return span;
    };
    if (mode === "chars") {
      for (const ch of text) {
        if (ch === " ") {
          el.appendChild(document.createTextNode(" "));
          continue;
        }
        const u = make(ch);
        units.push(u);
        el.appendChild(u);
      }
    } else if (mode === "words") {
      text.split(/(\s+)/).forEach((tok) => {
        if (tok.trim() === "") {
          el.appendChild(document.createTextNode(tok));
          return;
        }
        const u = make(tok);
        units.push(u);
        el.appendChild(u);
      });
    } else {
      text.split(/\n|<br\s*\/?>/i).forEach((line) => {
        const u = make(line);
        u.style.display = "block";
        units.push(u);
        el.appendChild(u);
      });
    }
    return {
      root: el,
      units,
      revert() {
        el.innerHTML = original;
      }
    };
  }
  registerAdapter({
    test: (t) => typeof HTMLElement !== "undefined" && t instanceof HTMLElement && t.dataset?.textUnit === "1",
    props: () => ["opacity", "x", "y", "rotate", "scale"],
    get: (t, p) => {
      if (p === "opacity") return parseFloat(t.style.opacity) || 1;
      const m = /([-\d.]+)/.exec(t.style.transform || "");
      return m ? parseFloat(m[1]) : 0;
    },
    set: (t, p, v) => {
      if (p === "opacity") {
        t.style.opacity = String(v);
        return;
      }
      const cur = t.style.transform || "";
      const fn = p === "x" ? "translateX" : p === "y" ? "translateY" : p === "rotate" ? "rotate" : "scale";
      const u = p === "scale" ? "" : p === "rotate" ? "deg" : "px";
      const re = new RegExp(`${fn}\\([^)]*\\)`);
      const next = `${fn}(${v}${u})`;
      t.style.transform = re.test(cur) ? cur.replace(re, next) : (cur + " " + next).trim();
    },
    unit: (_t, p) => p === "rotate" ? "deg" : p === "scale" ? "" : "px"
  });
  function textAnim(el, spec, opts = {}) {
    const { mode = "chars", step = 0.03, base = 0, duration = 0.6, ease = "outExpo", loop = false, alternate = false } = opts;
    const split2 = splitText2(el, mode);
    const delays = utils.stagger(split2.units.length, { step, base });
    const bags = split2.units.map(
      (u, i) => new Bag(u, spec, { duration, ease, delay: delays[i], loop, alternate })
    );
    return { bags, revert: split2.revert };
  }

  // src/text/split-adapter.ts
  var SPLIT_DATASET = "pulseSplitUnit";
  var NUMERIC_UNIT_PROPS = /* @__PURE__ */ new Set(["progress", "phase", "unitCount", "x", "y", "rotate", "scale", "opacity"]);
  function clamp01(value) {
    return Math.max(0, Math.min(1, Number(value) || 0));
  }
  function isHTMLElement(value) {
    return Boolean(value) && typeof HTMLElement !== "undefined" && value instanceof HTMLElement;
  }
  function toElements(value, scope2) {
    if (!value) return [];
    if (typeof value === "string") {
      const root = scope2 ?? (typeof document !== "undefined" ? document : null);
      return root ? Array.from(root.querySelectorAll(value)).filter(isHTMLElement) : [];
    }
    if (isHTMLElement(value)) return [value];
    if (Array.isArray(value)) return value.filter(isHTMLElement);
    return Array.from(value).filter(isHTMLElement);
  }
  function resolveRoot(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:split] document is not available");
      const el = document.querySelector(root);
      if (!isHTMLElement(el)) throw new Error(`[pulse:split] root not found: ${root}`);
      return el;
    }
    if (isHTMLElement(root)) return root;
    const first = toElements(root)[0];
    if (!first) throw new Error("[pulse:split] root not found");
    return first.parentElement ?? first;
  }
  function modeFromOptions(options) {
    if (options.items) return "items";
    return options.mode ?? "chars";
  }
  function animeParams(options) {
    const { mode = "chars", items: _items, stagger: _stagger, base: _base, reducedMotion: _reducedMotion, ...rest } = options;
    const params = { ...rest };
    if (mode === "all") {
      if (params.lines === void 0) params.lines = true;
      if (params.words === void 0) params.words = true;
      if (params.chars === void 0) params.chars = true;
    } else if (mode === "lines") {
      if (params.lines === void 0) params.lines = true;
    } else if (mode === "words") {
      if (params.words === void 0) params.words = true;
    } else if (mode === "chars") {
      if (params.chars === void 0) params.chars = true;
    }
    return params;
  }
  function markUnit(unit, index, total) {
    unit.dataset[SPLIT_DATASET] = "1";
    unit.dataset.pulseSplitIndex = String(index);
    unit.dataset.pulseSplitTotal = String(total);
    unit.style.setProperty("--pulse-split-index", String(index));
    unit.style.setProperty("--pulse-split-total", String(total));
    if (!unit.style.display) unit.style.display = "inline-block";
    unit.style.willChange = `${unit.style.willChange ? `${unit.style.willChange}, ` : ""}transform, opacity`;
  }
  function firstNumber(input) {
    const match = /(-?\d+(?:\.\d+)?)/.exec(input);
    return match ? Number(match[1]) || 0 : 0;
  }
  function fanValue(prop, value, index, total, phase, progress) {
    if (prop === "unitCount") return total;
    if (prop === "progress" || prop === "phase") return value;
    const denominator = Math.max(1, total - 1);
    const t = total <= 1 ? 0.5 : index / denominator;
    const wave = Math.sin((t + phase) * Math.PI * 2) * (0.3 + progress * 0.7);
    if (prop === "opacity") return Math.max(0, Math.min(1, value + wave * 0.22));
    if (prop === "scale") return Math.max(0.02, value + wave * 0.08);
    return value + wave * Math.max(2, Math.abs(value) * 0.18);
  }
  var PulseSplit = class {
    constructor(root, options = {}) {
      this.__pulseSplit = true;
      this.splitter = null;
      this.lines = [];
      this.words = [];
      this.chars = [];
      this.items = [];
      this.units = [];
      this.legacy = null;
      this.manualOriginal = null;
      this._progress = 0;
      this._phase = 0;
      this._disposed = false;
      this.options = { ...options };
      this.mode = modeFromOptions(options);
      this.root = resolveRoot(root);
      if (this.mode === "items") this.createItemSplit();
      else this.createTextSplit();
      this.setProgress(0);
    }
    get progress() {
      return this._progress;
    }
    get phase() {
      return this._phase;
    }
    get unitCount() {
      return this.units.length;
    }
    all(mode) {
      if (!mode || mode === this.mode || mode === "all") return this.units.slice();
      if (mode === "chars") return this.chars.slice();
      if (mode === "words") return this.words.slice();
      if (mode === "lines") return this.lines.slice();
      return this.items.slice();
    }
    apply(spec, opts = {}) {
      const reduced = Boolean(this.options.reducedMotion);
      const step = opts.step ?? opts.stagger ?? this.options.stagger ?? 0.035;
      const base = opts.base ?? this.options.base ?? 0;
      return this.units.map((unit, index) => {
        const bag = new Bag(unit, spec, {
          duration: reduced ? 0 : opts.duration ?? 0.8,
          ease: opts.ease ?? "outExpo",
          delay: reduced ? 0 : base + index * step,
          loop: opts.loop ?? false,
          alternate: opts.alternate ?? false,
          autoplay: opts.autoplay ?? true
        });
        if (reduced) bag.snap();
        return bag;
      });
    }
    addEffect(effect) {
      if (this.splitter && typeof this.splitter.addEffect === "function") this.splitter.addEffect(effect);
      else {
        const cleanup = effect(this.units, this);
        if (typeof cleanup === "function") this._pulseCleanup = cleanup;
      }
      return this;
    }
    setProgress(value) {
      this._progress = clamp01(value);
      this.writeVariables();
    }
    setPhase(value) {
      this._phase = Number(value) || 0;
      this.writeVariables();
    }
    write(prop, value) {
      if (prop === "progress") {
        this.setProgress(value);
        return;
      }
      if (prop === "phase") {
        this.setPhase(value);
        return;
      }
      if (!NUMERIC_UNIT_PROPS.has(prop)) return;
      const total = this.units.length;
      this.units.forEach((unit, index) => {
        const next = fanValue(prop, value, index, total, this._phase, this._progress);
        PulseProperties.apply(unit, { [prop]: { from: 0, to: next } }, { [prop]: next }, this._progress);
      });
    }
    refresh() {
      if (this._disposed) return this;
      if (this.splitter && typeof this.splitter.refresh === "function") {
        this.splitter.refresh();
        this.collectTextUnits();
      } else if (this.mode === "items") {
        this.createItemSplit();
      }
      this.writeVariables();
      return this;
    }
    revert() {
      try {
        if (this._pulseCleanup) this._pulseCleanup();
        if (this.manualOriginal !== null) {
          this.root.innerHTML = this.manualOriginal;
          this.manualOriginal = null;
        }
        if (this.splitter) this.splitter.revert();
        if (this.legacy) this.legacy.revert();
        if (!this.splitter && !this.legacy) {
          this.units.forEach((unit) => {
            delete unit.dataset[SPLIT_DATASET];
            delete unit.dataset.pulseSplitIndex;
            delete unit.dataset.pulseSplitTotal;
            unit.style.removeProperty("--pulse-split-index");
            unit.style.removeProperty("--pulse-split-total");
            unit.style.removeProperty("--pulse-split-progress");
            unit.style.removeProperty("--pulse-split-local");
            unit.style.removeProperty("--pulse-split-phase");
          });
        }
      } catch (error) {
        if (this.options.debug && typeof console !== "undefined") console.warn("[pulse:split]", error);
      }
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this.revert();
      this._disposed = true;
    }
    createTextSplit() {
      try {
        this.splitter = splitText(this.root, animeParams(this.options));
        this.collectTextUnits();
        this.collectAfterFontsReady();
      } catch (error) {
        if (this.options.debug && typeof console !== "undefined") console.warn("[pulse:split] falling back to legacy splitter", error);
        const mode = this.mode === "all" ? "chars" : this.mode;
        this.legacy = splitText2(this.root, mode);
        this.chars = mode === "chars" ? this.legacy.units : [];
        this.words = mode === "words" ? this.legacy.units : [];
        this.lines = mode === "lines" ? this.legacy.units : [];
        this.units = this.legacy.units;
        this.markUnits();
      }
    }
    createItemSplit() {
      const scoped = this.options.items ? toElements(this.options.items, this.root) : Array.from(this.root.children).filter(isHTMLElement);
      this.items = scoped;
      this.lines = [];
      this.words = [];
      this.chars = [];
      this.units = this.items;
      this.markUnits();
    }
    collectTextUnits() {
      const splitter = this.splitter;
      this.lines = splitter ? Array.from(splitter.lines ?? []).filter(isHTMLElement) : [];
      this.words = splitter ? Array.from(splitter.words ?? []).filter(isHTMLElement) : [];
      this.chars = splitter ? Array.from(splitter.chars ?? []).filter(isHTMLElement) : [];
      this.items = [];
      if (this.mode === "lines") this.units = this.lines.length ? this.lines : this.words;
      else if (this.mode === "words") this.units = this.words;
      else if (this.mode === "all") this.units = [...this.lines, ...this.words, ...this.chars];
      else this.units = this.chars.length ? this.chars : this.words;
      this.markUnits();
    }
    collectAfterFontsReady() {
      if (!this.splitter || this.mode !== "lines") return;
      const fonts = typeof document !== "undefined" ? document.fonts : null;
      const ready = fonts?.ready;
      if (!ready || typeof ready.then !== "function") return;
      ready.then(() => {
        setTimeout(() => {
          if (this._disposed || !this.splitter) return;
          this.collectTextUnits();
          if (!this.units.length) this.createManualLineSplit();
          this.writeVariables();
        }, 0);
      }).catch(() => void 0);
    }
    createManualLineSplit() {
      const original = this.splitter?.html ?? this.root.innerHTML;
      this.manualOriginal = original;
      try {
        this.splitter?.revert();
      } catch (error) {
        if (this.options.debug && typeof console !== "undefined") console.warn("[pulse:split] manual line fallback", error);
      }
      this.splitter = null;
      this.root.innerHTML = "";
      const holder = document.createElement("div");
      holder.innerHTML = original.replace(/<br\s*\/?>/gi, "\n");
      const source = holder.textContent ?? "";
      const lines = source.split(/\n+/).map((line) => line.trim()).filter(Boolean);
      this.lines = lines.map((line) => {
        const span = document.createElement("span");
        span.textContent = line;
        span.style.display = "block";
        span.style.willChange = "transform, opacity";
        span.dataset.pulseSplitLine = "manual";
        this.root.appendChild(span);
        return span;
      });
      this.words = [];
      this.chars = [];
      this.items = [];
      this.units = this.lines;
      this.markUnits();
    }
    markUnits() {
      const total = this.units.length;
      this.units.forEach((unit, index) => markUnit(unit, index, total));
    }
    writeVariables() {
      const total = this.units.length;
      this.root.style.setProperty("--pulse-split-progress", String(this._progress));
      this.root.style.setProperty("--pulse-split-phase", String(this._phase));
      this.root.style.setProperty("--pulse-split-count", String(total));
      this.units.forEach((unit, index) => {
        const denominator = Math.max(1, total - 1);
        const local = total <= 1 ? this._progress : clamp01(this._progress - index / denominator * 0.45);
        unit.style.setProperty("--pulse-split-progress", String(this._progress));
        unit.style.setProperty("--pulse-split-phase", String(this._phase));
        unit.style.setProperty("--pulse-split-local", String(local));
      });
    }
  };
  var PulseSplitAdapter = {
    test: (target) => Boolean(target?.__pulseSplit),
    props: () => ["progress", "phase", "unitCount", "x", "y", "rotate", "scale", "opacity"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "phase") return target.phase;
      if (prop === "unitCount") return target.unitCount;
      const first = target.units[0];
      if (!first) return 0;
      if (prop === "opacity") return parseFloat(first.style.opacity) || 1;
      return firstNumber(first.style.transform || "");
    },
    set: (target, prop, value) => {
      target.write(prop, value);
    },
    unit: (_target, prop) => prop === "rotate" ? "deg" : prop === "scale" || prop === "opacity" || prop === "progress" || prop === "phase" || prop === "unitCount" ? "" : "px"
  };
  registerAdapter(PulseSplitAdapter);
  function pulseSplit(root, params) {
    return new PulseSplit(root, params);
  }

  // src/timeline-engine/timeline-engine.ts
  var TIME_KEYS = /* @__PURE__ */ new Set(["duration", "delay", "loopDelay", "endDelay"]);
  function isPlainObject(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value);
  }
  function toAnimeTime(value, unit) {
    if (typeof value === "function") {
      return (...args) => toAnimeTime(value(...args), unit);
    }
    if (typeof value !== "number" || !Number.isFinite(value)) return value;
    if (unit === "ms") return value;
    if (unit === "seconds") return value * 1e3;
    return value > 0 && value <= 20 ? value * 1e3 : value;
  }
  function fromAnimeTime(value) {
    return typeof value === "number" && Number.isFinite(value) ? value / 1e3 : 0;
  }
  function clamp012(value) {
    return Math.max(0, Math.min(1, Number(value) || 0));
  }
  var PulseTimelineEngine = class {
    constructor(params = {}) {
      this.__pulseTimelineEngine = true;
      this._debug = false;
      this._disposed = false;
      this._reducedMotion = false;
      this.events = [];
      const { timeUnit = "auto", debug: debug2 = false, reducedMotion = false, ...timelineParams } = params;
      this.timeUnit = timeUnit;
      this._debug = debug2;
      this._reducedMotion = reducedMotion;
      this.raw = createTimeline(this.normalizeParams({ autoplay: false, ...timelineParams }));
    }
    get disposed() {
      return this._disposed;
    }
    get currentTime() {
      return fromAnimeTime(this.raw.currentTime);
    }
    get time() {
      return this.currentTime;
    }
    get duration() {
      return fromAnimeTime(this.effectiveDurationMs());
    }
    get progress() {
      const rawDuration = Number(this.raw.duration) || 0;
      if (!Number.isFinite(rawDuration) || rawDuration > 1e9) {
        return Number(this.raw.iterationProgress) || 0;
      }
      return Number(this.raw.progress) || 0;
    }
    get speed() {
      return Number(this.raw.speed) || 0;
    }
    get paused() {
      return Boolean(this.raw.paused);
    }
    get labels() {
      const rawLabels = this.raw.labels ?? {};
      return Object.fromEntries(Object.entries(rawLabels).map(([key2, value]) => [key2, fromAnimeTime(value)]));
    }
    add(targetOrTimer, paramsOrPosition, position) {
      if (paramsOrPosition === void 0 || typeof paramsOrPosition === "number" || typeof paramsOrPosition === "string" || typeof paramsOrPosition === "function") {
        this.raw.add(this.normalizeParams(targetOrTimer), this.normalizePosition(paramsOrPosition));
      } else {
        this.raw.add(targetOrTimer, this.normalizeParams(paramsOrPosition), this.normalizePosition(position));
      }
      return this;
    }
    timer(params, position) {
      return this.add(params, position);
    }
    set(targets, params, position) {
      this.raw.set(targets, this.normalizeParams(params), this.normalizePosition(position));
      return this;
    }
    sync(timelineOrAnimation, position) {
      const synced = timelineOrAnimation?.__pulseTimelineEngine ? timelineOrAnimation.raw : timelineOrAnimation;
      this.raw.sync(synced, this.normalizePosition(position));
      return this;
    }
    call(callback, position) {
      this.raw.call((animeTimer) => {
        this.events.push(`call@${this.currentTime.toFixed(3)}`);
        callback(animeTimer, this);
      }, this.normalizePosition(position));
      return this;
    }
    label(name, position) {
      this.raw.label(name, this.normalizePosition(position));
      return this;
    }
    remove(targets, propertyName) {
      this.raw.remove(targets, propertyName);
      return this;
    }
    init() {
      this.raw.init();
      return this;
    }
    play() {
      if (this._reducedMotion) return this.complete(false);
      this.raw.play();
      return this;
    }
    pause() {
      this.raw.pause();
      return this;
    }
    resume() {
      if (this._reducedMotion) return this.complete(false);
      this.raw.resume();
      return this;
    }
    restart() {
      this.events.length = 0;
      if (this._reducedMotion) {
        this.raw.reset();
        return this.complete(false);
      }
      this.raw.restart();
      return this;
    }
    reverse() {
      this.raw.reverse();
      return this;
    }
    alternate() {
      this.raw.alternate();
      return this;
    }
    reset() {
      this.events.length = 0;
      this.raw.reset();
      return this;
    }
    cancel() {
      this.raw.cancel();
      return this;
    }
    complete(muteCallbacks) {
      this.raw.complete(muteCallbacks);
      return this;
    }
    seek(time, muteCallbacks = false) {
      this.raw.seek(toAnimeTime(time, this.timeUnit), muteCallbacks);
      return this;
    }
    seekProgress(progress, muteCallbacks = true) {
      this.raw.seek(this.effectiveDurationMs() * clamp012(progress), muteCallbacks);
      return this;
    }
    stretch(newDuration) {
      this.raw.stretch(toAnimeTime(newDuration, this.timeUnit));
      return this;
    }
    refresh() {
      this.raw.refresh();
      return this;
    }
    revert() {
      try {
        this.raw.revert();
      } catch (error) {
        this.warn(error);
      }
      return this;
    }
    setSpeed(rate) {
      this.raw.speed = rate;
      return this;
    }
    eventLog() {
      return this.events.slice();
    }
    dispose() {
      if (this._disposed) return;
      this.cancel();
      this.revert();
      this._disposed = true;
    }
    normalizePosition(position) {
      if (position === void 0) return void 0;
      if (typeof position === "function") return (...args) => toAnimeTime(position(...args), this.timeUnit);
      if (typeof position === "number") return toAnimeTime(position, this.timeUnit);
      return position;
    }
    effectiveDurationMs() {
      const rawDuration = Number(this.raw.duration) || 0;
      const iterationDuration = Number(this.raw.iterationDuration) || rawDuration;
      if (!Number.isFinite(rawDuration) || rawDuration > 1e9) return iterationDuration;
      return rawDuration;
    }
    normalizeParams(params) {
      if (!isPlainObject(params)) return params;
      const next = {};
      for (const [key2, value] of Object.entries(params)) {
        if (TIME_KEYS.has(key2)) {
          next[key2] = toAnimeTime(value, this.timeUnit);
        } else if (Array.isArray(value)) {
          next[key2] = value.map((item) => isPlainObject(item) ? this.normalizeParams(item) : item);
        } else if (isPlainObject(value)) {
          next[key2] = this.normalizeParams(value);
        } else {
          next[key2] = value;
        }
      }
      return next;
    }
    warn(error) {
      if (this._debug && typeof console !== "undefined") console.warn("[pulse:timeline]", error);
    }
  };
  var PulseTimelineEngineAdapter = {
    test: (target) => Boolean(target?.__pulseTimelineEngine),
    props: () => ["time", "progress", "speed", "duration", "paused"],
    get: (target, prop) => {
      if (prop === "time") return target.time;
      if (prop === "progress") return target.progress;
      if (prop === "speed") return target.speed;
      if (prop === "duration") return target.duration;
      if (prop === "paused") return target.paused ? 1 : 0;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "time") target.seek(value, true);
      else if (prop === "progress") target.seekProgress(value, true);
      else if (prop === "speed") target.setSpeed(value);
      else if (prop === "paused") value >= 0.5 ? target.pause() : target.play();
    },
    unit: () => ""
  };
  registerAdapter(PulseTimelineEngineAdapter);
  function timelineEngine(params) {
    return new PulseTimelineEngine(params);
  }

  // src/text/type-morph.ts
  function resolveTarget(target) {
    if (typeof target !== "string") return target;
    if (typeof document === "undefined") throw new Error("[pulse:type-morph] document is not available");
    const element = document.querySelector(target);
    if (!(element instanceof HTMLElement)) throw new Error(`[pulse:type-morph] target not found: ${target}`);
    return element;
  }
  function wrapIndex(index, length) {
    if (!length) return 0;
    const rounded = Math.round(Number(index) || 0);
    return (rounded % length + length) % length;
  }
  function numeric(value, fallback) {
    return Number.isFinite(value) ? Number(value) : fallback;
  }
  var PulseTypeMorph = class {
    constructor(target, options) {
      this.__pulseTypeMorph = true;
      this.timeline = null;
      this._stateIndex = 0;
      this._disposed = false;
      this.target = resolveTarget(target);
      this.states = options.states.filter((state) => state?.name);
      if (this.states.length < 2) throw new Error("[pulse:type-morph] at least two named states are required");
      this.options = {
        ...options,
        duration: Math.max(0, options.duration ?? 0.72),
        stagger: Math.max(0, options.stagger ?? 0.026),
        ease: options.ease ?? "outExpo",
        reducedMotion: options.reducedMotion ?? false,
        restore: options.restore ?? true
      };
      this.originalState = this.target.getAttribute("data-pulse-type-state");
      this.originalVars = {
        index: this.target.style.getPropertyValue("--pulse-type-state-index"),
        count: this.target.style.getPropertyValue("--pulse-type-state-count")
      };
      this.split = new PulseSplit(this.target, {
        mode: options.split ?? "chars",
        chars: { wrap: "clip" },
        accessible: true,
        reducedMotion: this.options.reducedMotion,
        debug: options.debug
      });
      this.units = this.split.units;
      if (!this.units.length) throw new Error("[pulse:type-morph] target produced no text units");
      this.units.forEach((unit) => {
        unit.dataset.pulseTypeUnit = "1";
        unit.style.transformOrigin = "50% 65%";
        unit.style.willChange = `${unit.style.willChange ? `${unit.style.willChange}, ` : ""}transform, color, -webkit-text-stroke`;
      });
      const initial = this.resolveIndex(options.initialState ?? 0);
      this._stateIndex = initial;
      this.applyImmediate(this.states[initial]);
      this.writeState(initial);
    }
    get disposed() {
      return this._disposed;
    }
    get stateIndex() {
      return this._stateIndex;
    }
    get stateCount() {
      return this.states.length;
    }
    get state() {
      return this.states[this._stateIndex];
    }
    get progress() {
      return this.timeline?.progress ?? 1;
    }
    get paused() {
      return this.timeline?.paused ?? true;
    }
    setState(state, transition = {}) {
      if (this._disposed) return this;
      const index = this.resolveIndex(state);
      if (index === this._stateIndex && !transition.force) return this;
      this.timeline?.cancel();
      this.timeline = null;
      this._stateIndex = index;
      const next = this.states[index];
      this.writeState(index);
      if (this.options.reducedMotion || transition.animate === false || (transition.duration ?? this.options.duration) === 0) {
        this.applyImmediate(next);
        this.options.onStateChange?.(next, index, this);
        return this;
      }
      const duration = Math.max(0, transition.duration ?? this.options.duration);
      const stagger3 = Math.max(0, transition.stagger ?? this.options.stagger);
      const center = (this.units.length - 1) / 2;
      const stateValues = this.unitValues(next);
      if (numeric(next.strokeWidth, 0) > 0) {
        this.units.forEach((unit) => {
          unit.style.setProperty("-webkit-text-stroke-color", next.stroke ?? "transparent");
        });
      }
      this.timeline = new PulseTimelineEngine({
        timeUnit: "seconds",
        autoplay: false,
        defaults: { duration, ease: transition.ease ?? this.options.ease },
        debug: this.options.debug
      }).label("type-morph", 0).add(this.units, {
        color: next.fill ?? "currentColor",
        "-webkit-text-stroke-width": `${numeric(next.strokeWidth, 0)}px`,
        scaleX: stateValues.scaleX,
        scaleY: stateValues.scaleY,
        y: (_unit, unitIndex) => this.unitY(next, unitIndex),
        rotate: (_unit, unitIndex) => this.unitSigned(next.rotate, unitIndex),
        skewX: stateValues.skewX,
        opacity: stateValues.opacity,
        delay: (_unit, unitIndex) => Math.abs(unitIndex - center) * stagger3
      }, "type-morph").label("type-settle", duration + center * stagger3).init().restart();
      this.options.onStateChange?.(next, index, this);
      return this;
    }
    setIndex(index, transition) {
      return this.setState(wrapIndex(index, this.states.length), transition);
    }
    cycle(step = 1, transition) {
      return this.setIndex(this._stateIndex + step, transition);
    }
    seekProgress(progress) {
      this.timeline?.seekProgress(Math.max(0, Math.min(1, Number(progress) || 0)), true);
      return this;
    }
    seek(time) {
      this.timeline?.seek(Math.max(0, Number(time) || 0), true);
      return this;
    }
    restart() {
      this.timeline?.restart();
      return this;
    }
    setSpeed(rate) {
      this.timeline?.setSpeed(Math.max(0.01, Math.abs(Number(rate) || 1)));
      return this;
    }
    pause() {
      this.timeline?.pause();
      return this;
    }
    play() {
      this.timeline?.play();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this.timeline?.cancel();
      this.timeline = null;
      this.split.dispose();
      if (this.options.restore) {
        if (this.originalState === null) this.target.removeAttribute("data-pulse-type-state");
        else this.target.setAttribute("data-pulse-type-state", this.originalState);
        this.restoreVar("--pulse-type-state-index", this.originalVars.index);
        this.restoreVar("--pulse-type-state-count", this.originalVars.count);
      }
      this._disposed = true;
      this.options.onDispose?.(this);
    }
    resolveIndex(state) {
      if (typeof state === "number") return wrapIndex(state, this.states.length);
      const index = this.states.findIndex((entry) => entry.name === state);
      if (index < 0) throw new Error(`[pulse:type-morph] unknown state: ${state}`);
      return index;
    }
    unitValues(state) {
      return {
        scaleX: numeric(state.scaleX, 1),
        scaleY: numeric(state.scaleY, 1),
        skewX: numeric(state.skewX, 0),
        opacity: numeric(state.opacity, 1)
      };
    }
    unitY(state, index) {
      return numeric(state.y, 0) + this.unitSigned(state.scatterY, index);
    }
    unitSigned(value, index) {
      const amount = numeric(value, 0);
      return amount * (index % 2 ? 1 : -1);
    }
    applyImmediate(state) {
      const values = this.unitValues(state);
      this.units.forEach((unit, index) => {
        unit.style.color = state.fill ?? "currentColor";
        unit.style.setProperty("-webkit-text-stroke-color", state.stroke ?? "transparent");
        unit.style.setProperty("-webkit-text-stroke-width", `${numeric(state.strokeWidth, 0)}px`);
        unit.style.opacity = String(values.opacity);
        unit.style.transform = `translateY(${this.unitY(state, index)}px) rotate(${this.unitSigned(state.rotate, index)}deg) skewX(${values.skewX}deg) scale(${values.scaleX}, ${values.scaleY})`;
      });
    }
    writeState(index) {
      this.target.dataset.pulseTypeState = this.states[index].name;
      this.target.style.setProperty("--pulse-type-state-index", String(index));
      this.target.style.setProperty("--pulse-type-state-count", String(this.states.length));
    }
    restoreVar(property, value) {
      if (value) this.target.style.setProperty(property, value);
      else this.target.style.removeProperty(property);
    }
  };
  var PulseTypeMorphAdapter = {
    name: "type-morph",
    test: (target) => Boolean(target?.__pulseTypeMorph),
    props: () => ["progress", "stateIndex", "stateCount", "paused"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "stateIndex") return target.stateIndex;
      if (prop === "stateCount") return target.stateCount;
      if (prop === "paused") return target.paused ? 1 : 0;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "progress") target.seekProgress(value);
      else if (prop === "stateIndex") target.setIndex(value);
      else if (prop === "paused") value >= 0.5 ? target.pause() : target.play();
    },
    unit: () => ""
  };
  registerAdapter(PulseTypeMorphAdapter);
  function typeMorph(target, options) {
    return new PulseTypeMorph(target, options);
  }

  // src/svg/morph.ts
  function resolvePath(target) {
    if (typeof target !== "string") return target;
    if (typeof document === "undefined") throw new Error("[pulse:morph] document is not available");
    const element = document.querySelector(target);
    if (!(element instanceof SVGElement) || element.tagName.toLowerCase() !== "path") throw new Error(`[pulse:morph] path not found: ${target}`);
    return element;
  }
  function pathData(state) {
    return typeof state === "string" ? state : state.getAttribute("d") ?? "";
  }
  function fallbackSample(d, count) {
    const numbers = d.match(/-?\d*\.?\d+(?:e[-+]?\d+)?/gi)?.map(Number) ?? [];
    const points = [];
    for (let index = 0; index + 1 < numbers.length; index += 2) points.push({ x: numbers[index], y: numbers[index + 1] });
    if (!points.length) return Array.from({ length: count }, () => ({ x: 0, y: 0 }));
    return Array.from({ length: count }, (_, index) => {
      const position = count <= 1 ? 0 : index / (count - 1) * (points.length - 1);
      const left = Math.floor(position);
      const right = Math.min(points.length - 1, left + 1);
      const t = position - left;
      return {
        x: points[left].x + (points[right].x - points[left].x) * t,
        y: points[left].y + (points[right].y - points[left].y) * t
      };
    });
  }
  function geometrySample(target, d, count) {
    if (typeof document === "undefined" || typeof target.getTotalLength !== "function") return fallbackSample(d, count);
    const sampler = document.createElementNS("http://www.w3.org/2000/svg", "path");
    sampler.setAttribute("d", d);
    sampler.setAttribute("visibility", "hidden");
    sampler.setAttribute("pointer-events", "none");
    const host = target.ownerSVGElement;
    try {
      host?.appendChild(sampler);
      const length = sampler.getTotalLength();
      if (!Number.isFinite(length) || length <= 0 || typeof sampler.getPointAtLength !== "function") return fallbackSample(d, count);
      return Array.from({ length: count }, (_, index) => {
        const point = sampler.getPointAtLength(index / Math.max(1, count - 1) * length);
        return { x: point.x, y: point.y };
      });
    } catch {
      return fallbackSample(d, count);
    } finally {
      sampler.remove();
    }
  }
  function serialize(points, closed) {
    if (!points.length) return "";
    const body = points.map((point, index) => `${index ? "L" : "M"}${point.x.toFixed(2)},${point.y.toFixed(2)}`).join(" ");
    return closed ? `${body} Z` : body;
  }
  function observeElement(value, target) {
    if (typeof value !== "string") return value ?? target.ownerSVGElement ?? target;
    return document.querySelector(value) ?? target.ownerSVGElement ?? target;
  }
  var PulseMorph = class {
    constructor(target, states2, options = {}) {
      this.__pulseMorph = true;
      this.observer = null;
      this.visible = false;
      this.requestedPlaying = false;
      this.began = false;
      this._disposed = false;
      this._stateIndex = -1;
      this.onIntersection = (entries) => {
        const next = entries.some((entry) => entry.isIntersecting);
        if (next !== this.visible) {
          this.visible = next;
          this.options.onVisibilityChange?.(next, this);
        }
        this.syncPlayback();
      };
      this.target = resolvePath(target);
      this.originalD = this.target.getAttribute("d") ?? "";
      this.states = states2.map(pathData).filter(Boolean);
      if (this.states.length < 2) throw new Error("[pulse:morph] at least two valid path states are required");
      this.duration = Math.max(1e-6, options.duration ?? 4);
      this.samples = Math.max(12, Math.round(options.samples ?? 96));
      this.closed = options.closed ?? this.states.every((state) => /z\s*$/i.test(state.trim()));
      this.options = {
        ...options,
        visibility: options.visibility ?? "viewport",
        restore: options.restore ?? true,
        reducedMotion: options.reducedMotion ?? false
      };
      this.pointStates = this.states.map((state) => geometrySample(this.target, state, this.samples));
      this.bag = new Bag(this.target, {
        __morphProgress: {
          from: 0,
          to: 1,
          template: (values) => {
            this.render(values.__morphProgress);
            return "";
          }
        }
      }, {
        duration: this.duration,
        delay: options.delay ?? 0,
        ease: options.ease ?? "inOutSine",
        loop: options.loop ?? true,
        alternate: options.alternate ?? true,
        autoplay: false,
        playbackRate: options.speed ?? 1
      });
      this.seekProgress(0);
      if (!this.options.reducedMotion && this.options.visibility === "viewport" && typeof IntersectionObserver !== "undefined") {
        this.observer = new IntersectionObserver(this.onIntersection, {
          rootMargin: options.rootMargin ?? "120px 0px",
          threshold: options.threshold ?? 0.01
        });
        this.observer.observe(observeElement(options.observe, this.target));
      } else if (!this.options.reducedMotion) {
        this.visible = true;
      }
      if (options.autoplay !== false && !this.options.reducedMotion) this.play();
    }
    get disposed() {
      return this._disposed;
    }
    get paused() {
      return this.bag.paused;
    }
    get progress() {
      return this.bag.iterationProgress;
    }
    get stateIndex() {
      return this._stateIndex;
    }
    get stateCount() {
      return this.states.length;
    }
    play() {
      if (this._disposed || this.options.reducedMotion) return this;
      this.requestedPlaying = true;
      if (!this.began) {
        this.began = true;
        this.options.onBegin?.(this);
      }
      this.syncPlayback();
      return this;
    }
    pause() {
      this.requestedPlaying = false;
      this.bag.pause();
      return this;
    }
    seek(time) {
      this.bag.seek(Math.max(0, Number(time) || 0));
      return this;
    }
    seekProgress(progress) {
      const normalized = Math.max(0, Math.min(1, Number(progress) || 0));
      return this.seek(normalized >= 1 ? Math.max(0, this.duration - 1e-6) : normalized * this.duration);
    }
    setState(index) {
      const next = Math.max(0, Math.min(this.stateCount - 1, Math.round(Number(index) || 0)));
      return this.seekProgress(next / Math.max(1, this.stateCount - 1));
    }
    restart() {
      this.seekProgress(0);
      return this.play();
    }
    setSpeed(rate) {
      this.bag.setSpeed(rate);
      return this;
    }
    reverse() {
      this.bag.reverse();
      if (!this.shouldPlay()) this.bag.pause();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.requestedPlaying = false;
      this.observer?.disconnect();
      this.observer = null;
      this.bag.dispose();
      if (this.options.restore) this.target.setAttribute("d", this.originalD);
      this.options.onDispose?.(this);
    }
    render(progress) {
      const scaled = Math.max(0, Math.min(1, progress)) * (this.pointStates.length - 1);
      const leftIndex = Math.min(this.pointStates.length - 2, Math.floor(scaled));
      const rightIndex = leftIndex + 1;
      const t = scaled - leftIndex;
      const left = this.pointStates[leftIndex];
      const right = this.pointStates[rightIndex];
      const points = left.map((point, index) => ({
        x: point.x + (right[index].x - point.x) * t,
        y: point.y + (right[index].y - point.y) * t
      }));
      this.target.setAttribute("d", serialize(points, this.closed));
      const stateIndex = Math.round(scaled);
      if (stateIndex !== this._stateIndex) {
        this._stateIndex = stateIndex;
        this.target.dataset.pulseMorphState = String(stateIndex);
        this.options.onStateChange?.(stateIndex, this);
      }
    }
    shouldPlay() {
      return this.requestedPlaying && (this.options.visibility === "always" || this.visible);
    }
    syncPlayback() {
      if (this.shouldPlay()) this.bag.play();
      else this.bag.pause();
    }
  };
  var PulseMorphAdapter = {
    name: "morph",
    test: (target) => Boolean(target?.__pulseMorph),
    props: () => ["progress", "stateIndex", "stateCount", "paused"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "stateIndex") return target.stateIndex;
      if (prop === "stateCount") return target.stateCount;
      if (prop === "paused") return target.paused ? 1 : 0;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "progress") target.seekProgress(value);
      else if (prop === "stateIndex") target.setState(value);
      else if (prop === "paused") value >= 0.5 ? target.pause() : target.play();
    },
    unit: () => ""
  };
  registerAdapter(PulseMorphAdapter);
  function morph(target, states2, options) {
    return new PulseMorph(target, states2, options);
  }

  // src/svg/svg.ts
  function isSVG(t) {
    return typeof SVGElement !== "undefined" && t instanceof SVGElement;
  }
  function attrNum(el, name) {
    const v = el.getAttribute(name);
    return v == null ? 0 : parseFloat(v);
  }
  registerAdapter({
    test: (t) => isSVG(t),
    props: (t) => {
      const out = ["opacity", "x", "y", "cx", "cy", "r", "width", "height", "strokeDashoffset"];
      for (const a of Array.from(t.attributes)) {
        const n = parseFloat(a.value);
        if (!Number.isNaN(n) && !out.includes(a.name)) out.push(a.name);
      }
      return out;
    },
    get: (t, p) => attrNum(t, p),
    set: (t, p, v) => {
      if (p === "opacity") t.style.opacity = String(v);
      else t.setAttribute(p, String(v));
    },
    unit: () => void 0
  });
  function prepareDraw(el) {
    const len = el.getTotalLength?.() ?? 0;
    el.style.strokeDasharray = String(len);
    el.style.strokeDashoffset = String(len);
    return len;
  }
  function drawOn(el, opts = {}) {
    const len = prepareDraw(el);
    return new Bag(el, {
      strokeDashoffset: { from: len, to: 0 }
    }, { duration: opts.duration ?? 1.2, ease: opts.ease ?? "inOutSine", delay: opts.delay ?? 0, loop: opts.loop ?? false });
  }
  function morphPath(el, fromD, toD, opts = {}) {
    return new PulseMorph(el, [fromD, toD], {
      ...opts,
      samples: opts.samples ?? opts.steps ?? 64,
      loop: opts.loop ?? false,
      alternate: opts.alternate ?? false,
      visibility: opts.visibility ?? "always"
    });
  }
  var svg = { isSVG, prepareDraw, drawOn, morphPath };

  // src/core/timeline.ts
  var Timeline2 = class {
    constructor() {
      this.tracks = [];
      this.labels = /* @__PURE__ */ new Map();
      this.elapsed = 0;
      this.playing = false;
      this.unsub = null;
      this.callbacks = /* @__PURE__ */ new Map();
      this._duration = 0;
      this.speed = 1;
      this.fired = /* @__PURE__ */ new Set();
      this.tick = (dt) => {
        this.elapsed += dt * this.speed;
        for (const tr of this.tracks) {
          const local = (this.elapsed - tr.at) / tr.tween.dur;
          tr.tween.set(local);
        }
        for (const [id2, fn] of this.callbacks) {
          const at = this.labels.get(id2);
          if (!this.fired.has(id2) && this.elapsed >= at) {
            this.fired.add(id2);
            fn();
          }
        }
        if (this.elapsed >= this._duration) {
          this.pause();
          this.onDone?.();
        }
      };
    }
    get duration() {
      return this._duration;
    }
    /** Add a tween starting at `at` seconds. */
    add(at, target, spec, label) {
      const tween = new Tween(target, { ...spec, mode: "manual" });
      tween.stop();
      this.tracks.push({ at, tween, label });
      if (at + tween.dur + (spec.delay ?? 0) > this._duration) {
        this._duration = at + tween.dur + (spec.delay ?? 0);
      }
      if (label) this.labels.set(label, at);
      return this;
    }
    /** Register a named callback fired once when the playhead crosses `at`. */
    call(at, fn, label) {
      const id2 = label ?? `cb${at}`;
      this.callbacks.set(id2, fn);
      this.labels.set(id2, at);
      if (at > this._duration) this._duration = at;
      return this;
    }
    getTime(label) {
      return this.labels.get(label) ?? 0;
    }
    play() {
      if (this.playing) return this;
      this.playing = true;
      this.unsub = ticker.add(this.tick);
      return this;
    }
    pause() {
      this.playing = false;
      this.unsub?.();
      this.unsub = null;
      return this;
    }
    seek(t) {
      this.elapsed = Math.max(0, Math.min(t, this._duration));
      for (const tr of this.tracks) {
        const local = (this.elapsed - tr.at) / tr.tween.dur;
        tr.tween.set(local);
      }
      return this;
    }
    onComplete(fn) {
      this.onDone = fn;
      return this;
    }
    restart() {
      this.pause();
      this.elapsed = 0;
      this.fired.clear();
      this.seek(0);
      return this.play();
    }
    setSpeed(rate) {
      this.speed = Math.max(1e-6, Number(rate) || 1);
      return this;
    }
    reverse() {
      this.seek(Math.max(0, this._duration - this.elapsed));
      return this;
    }
    dispose() {
      this.pause();
      this.tracks.forEach((track) => track.tween.dispose());
      this.tracks = [];
      this.callbacks.clear();
      this.fired.clear();
    }
  };

  // src/modules/audio.ts
  var Audio = class {
    constructor(opts = {}) {
      this.ctx = null;
      this.analyser = null;
      this.source = null;
      this.freq = null;
      this.unsub = null;
      this.energy = 0;
      this.beatGate = 0;
      this.bands = { bass: 0, lowMid: 0, mid: 0, highMid: 0, treble: 0, level: 0, beat: false, beatStrength: 0 };
      this.pump = () => {
        if (!this.analyser || !this.freq) return;
        this.analyser.getByteFrequencyData(this.freq);
        const bins = this.freq.length;
        const nyquist = (this.ctx?.sampleRate ?? 44100) / 2;
        const hzPerBin = nyquist / bins;
        const band = (lo, hi) => {
          const a = Math.max(1, Math.floor(lo / hzPerBin));
          const b = Math.min(bins - 1, Math.ceil(hi / hzPerBin));
          let s = 0;
          for (let i = a; i <= b; i++) s += this.freq[i];
          return s / ((b - a + 1) * 255);
        };
        const bass = band(20, 250);
        const lowMid = band(250, 500);
        const mid = band(500, 2e3);
        const highMid = band(2e3, 4e3);
        const treble = band(4e3, nyquist);
        const level = (bass + lowMid + mid + highMid + treble) / 5;
        this.energy = this.energy * 0.92 + bass * 0.08;
        const isBeat = bass > this.opts.beatLowpass && bass > this.energy * 1.35 && this.beatGate <= 0;
        const beatStrength = isBeat ? Math.min(1, bass) : 0;
        if (isBeat) this.beatGate = this.opts.beatThreshold;
        this.beatGate = Math.max(0, this.beatGate - this.opts.beatDecay);
        this.bands = { bass, lowMid, mid, highMid, treble, level, beat: isBeat, beatStrength };
      };
      this.opts = {
        fftSize: opts.fftSize ?? 1024,
        smoothing: opts.smoothing ?? 0.8,
        beatThreshold: opts.beatThreshold ?? 0.4,
        beatDecay: opts.beatDecay ?? 0.06,
        beatLowpass: opts.beatLowpass ?? 0.35
      };
    }
    /** Attach an <audio>/<video> element as the source. Lazily creates context. */
    connect(media) {
      try {
        if (!this.ctx) {
          const AC = window.AudioContext || window.webkitAudioContext;
          this.ctx = new AC();
          const analyser = this.ctx.createAnalyser();
          analyser.fftSize = this.opts.fftSize;
          analyser.smoothingTimeConstant = this.opts.smoothing;
          this.analyser = analyser;
          this.freq = new Uint8Array(new ArrayBuffer(analyser.frequencyBinCount));
        }
        if (!this.source) {
          this.source = this.ctx.createMediaElementSource(media);
          this.source.connect(this.analyser);
          this.analyser.connect(this.ctx.destination);
        }
        if (this.ctx.state === "suspended") this.ctx.resume();
        if (!this.unsub) this.unsub = ticker.add(this.pump);
        return true;
      } catch (e) {
        console.warn("[pulse:audio] connect failed", e);
        return false;
      }
    }
    /** Manual frequency data injection (for mic/stream sources). */
    setSource(analyser) {
      this.analyser = analyser;
      this.freq = new Uint8Array(new ArrayBuffer(analyser.frequencyBinCount));
      if (!this.unsub) this.unsub = ticker.add(this.pump);
    }
    stop() {
      this.unsub?.();
      this.unsub = null;
    }
    /** Canonical lifecycle alias. */
    dispose() {
      this.stop();
    }
  };

  // src/modules/pointer.ts
  var Cursor = class {
    constructor(opts = {}) {
      this.mx = -100;
      this.my = -100;
      this.rx = -100;
      this.ry = -100;
      this.scale = 1;
      this.unsub = null;
      this.onMove = (e) => {
        this.mx = e.clientX;
        this.my = e.clientY;
      };
      this.onOver = (e) => {
        const t = e.target;
        if (t.closest(this.hoverSel)) this.scale = 1.8;
      };
      this.onOut = (e) => {
        const t = e.target;
        if (t.closest(this.hoverSel)) this.scale = 1;
      };
      this.tick = () => {
        if (this.dot) {
          this.dot.style.transform = `translate(${this.mx}px,${this.my}px) translate(-50%,-50%)`;
        }
        if (this.ring) {
          this.rx += (this.mx - this.rx) * this.ringEase;
          this.ry += (this.my - this.ry) * this.ringEase;
          this.ring.style.transform = `translate(${this.rx}px,${this.ry}px) translate(-50%,-50%) scale(${this.scale})`;
        }
      };
      this.dot = opts.dot ? document.querySelector(opts.dot) : null;
      this.ring = opts.ring ? document.querySelector(opts.ring) : null;
      this.ringEase = opts.ringEase ?? 0.18;
      this.hoverSel = opts.hoverSelectors ?? "a,button,.tile-inner,[data-cursor]";
      if (opts.hideOnReduce && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      window.addEventListener("pointermove", this.onMove, { passive: true });
      document.addEventListener("pointerover", this.onOver, { passive: true });
      document.addEventListener("pointerout", this.onOut, { passive: true });
      this.unsub = ticker.add(this.tick);
    }
    destroy() {
      this.unsub?.();
      window.removeEventListener("pointermove", this.onMove);
      document.removeEventListener("pointerover", this.onOver);
      document.removeEventListener("pointerout", this.onOut);
    }
    /** Canonical PulsePlayable teardown alias. */
    dispose() {
      this.destroy();
    }
  };
  var Magnet = class {
    constructor(opts = {}) {
      this.items = [];
      this.onMove = (e) => {
        const x = e.clientX;
        const y = e.clientY;
        for (const it of this.items) {
          const r = it.el.getBoundingClientRect();
          const cx = r.left + r.width / 2;
          const cy = r.top + r.height / 2;
          const dx = (x - cx) * it.strength;
          const dy = (y - cy) * it.strength;
          const cl = (v) => Math.max(-it.max, Math.min(it.max, v));
          it.el.style.transform = `translate(${cl(dx)}px,${cl(dy)}px)`;
        }
      };
      const sel = opts.selector ?? "[data-magnet]";
      const strength = opts.strength ?? 0.3;
      const max2 = opts.max ?? 40;
      document.querySelectorAll(sel).forEach((el) => {
        this.items.push({ el, strength, max: max2 });
      });
      if (this.items.length) {
        window.addEventListener("pointermove", this.onMove, { passive: true });
      }
    }
    destroy() {
      window.removeEventListener("pointermove", this.onMove);
      this.items.forEach((it) => it.el.style.transform = "");
    }
    /** Canonical PulsePlayable teardown alias. */
    dispose() {
      this.destroy();
    }
  };

  // src/modules/fx.ts
  var FxRegistry = class {
    constructor() {
      this.map = /* @__PURE__ */ new Map();
    }
    register(name, fn) {
      this.map.set(name, fn);
      return this;
    }
    has(name) {
      return this.map.has(name);
    }
    /** Build + play an effect on a target element. */
    play(name, el, opts = {}) {
      const f = this.map.get(name);
      if (!f) {
        console.warn(`[pulse:fx] unknown effect "${name}"`);
        return null;
      }
      return f(opts).run(el);
    }
    names() {
      return [...this.map.keys()];
    }
  };
  var fx = new FxRegistry();
  function bagOf(el, spec, o) {
    return new Bag(el, spec, {
      duration: o.duration ?? 0.6,
      ease: o.ease ?? "outCubic",
      delay: o.delay ?? 0,
      loop: o.loop ?? false,
      alternate: o.alternate ?? false,
      loopDelay: o.loopDelay ?? 0,
      autoplay: o.autoplay ?? true
    });
  }
  fx.register(
    "popIn",
    (o) => bagResult((el) => {
      return bagOf(el, { fxScale: { from: o.from ?? 0.6, to: 1, unit: "", css: "--fx-scale" }, fxOpacity: { from: 0.2, to: 1, unit: "", css: "--fx-opacity" }, tilt: { from: o.tilt ?? -8, to: 0, unit: "deg", css: "--fx-tilt" } }, o);
    })
  );
  fx.register(
    "impactSlam",
    (o) => bagResult(
      (el) => bagOf(
        el,
        {
          sc: { from: o.from ?? 1.4, to: 1, unit: "" },
          fxScale: { from: o.from ?? 1.4, to: 1, unit: "", css: "--fx-scale" },
          fxOpacity: { from: 0.25, to: 1, unit: "", css: "--fx-opacity" },
          sh: { from: o.shadow ?? 40, to: 0, unit: "px", css: "--fx-slam-shadow" }
        },
        { ...o, ease: "outBack", duration: o.duration ?? 0.5 }
      )
    )
  );
  fx.register(
    "floatDrift",
    (o) => bagResult(
      (el) => bagOf(
        el,
        {
          y: { from: 0, to: o.amp ?? 10, unit: "px", css: "--drift-y" }
        },
        { ...o, ease: "inOutSine", duration: o.duration ?? 2.4 }
      )
    )
  );
  fx.register(
    "blurBloom",
    (o) => bagResult(
      (el) => bagOf(
        el,
        {
          fxBlur: { from: o.from ?? 14, to: 0, unit: "px", css: "--fx-blur" },
          fxScale: { from: o.fromScale ?? 1.08, to: 1, unit: "", css: "--fx-scale" },
          bloom: { from: 0, to: 1, unit: "", css: "--fx-bloom" }
        },
        { ...o, ease: "outCubic", duration: o.duration ?? 0.7 }
      )
    )
  );
  fx.register(
    "spinIn",
    (o) => bagResult(
      (el) => bagOf(el, { rot: { from: o.from ?? 180, to: 0, unit: "deg", css: "--spin-rot" }, op: { from: 0, to: 1 } }, { ...o, ease: "outBack", duration: o.duration ?? 0.8 })
    )
  );
  fx.register(
    "scatterBurst",
    (o) => bagResult(
      (el) => bagOf(
        el,
        {
          x: { from: 0, to: o.dx ?? 40, unit: "px", css: "--burst-x" },
          y: { from: 0, to: o.dy ?? -30, unit: "px", css: "--burst-y" },
          op: { from: 1, to: 0 },
          sc: { from: 1, to: 0.4, unit: "" }
        },
        { ...o, ease: "outCubic", duration: o.duration ?? 0.5 }
      )
    )
  );
  fx.register(
    "pulseGlow",
    (o) => bagResult(
      (el) => bagOf(el, { glow: { from: 0, to: o.to ?? 1, unit: "", css: "--fx-glow" }, fxScale: { from: 1, to: o.scale ?? 1.08, unit: "", css: "--fx-scale" } }, { ...o, ease: "inOutSine", duration: o.duration ?? 1.2 })
    )
  );
  fx.register(
    "shake",
    (o) => bagResult(
      (el) => bagOf(el, { fxShakeX: { from: 0, to: o.amount ?? 10, unit: "px", css: "--fx-shake-x" }, fxShakeY: { from: 0, to: (o.amount ?? 10) * 0.4, unit: "px", css: "--fx-shake-y" } }, { ...o, ease: "linear", duration: o.duration ?? 0.4, loop: o.loop ?? true, alternate: true })
    )
  );
  fx.register(
    "bounce",
    (o) => bagResult(
      (el) => bagOf(el, { y: { from: 0, to: o.amount ?? -18, unit: "px", css: "--fx-bounce-y" }, fxSquash: { from: 1, to: 0.88, unit: "", css: "--fx-squash" } }, { ...o, ease: "outQuad", duration: o.duration ?? 0.6, loop: o.loop ?? true, alternate: true })
    )
  );
  fx.register(
    "glitch",
    (o) => bagResult(
      (el) => bagOf(el, { fxGlitchX: { from: 0, to: o.amount ?? 8, unit: "px", css: "--fx-glitch-x" }, fxGlitchRGB: { from: 0, to: o.rgb ?? 6, unit: "px", css: "--fx-glitch-rgb" }, fxGlitchScan: { from: 0, to: 100, unit: "%", css: "--fx-glitch-scan" } }, { ...o, ease: "linear", duration: o.duration ?? 0.3, loop: o.loop ?? true })
    )
  );
  fx.register(
    "ripple",
    (o) => bagResult(
      (el) => bagOf(el, { fxRipple: { from: 0, to: o.strength ?? 18, unit: "px", css: "--fx-ripple" }, fxRippleR: { from: 0, to: o.radius ?? 120, unit: "px", css: "--fx-ripple-radius" } }, { ...o, ease: "outQuad", duration: o.duration ?? 1, loop: o.loop ?? true })
    )
  );
  fx.register(
    "wave",
    (o) => bagResult(
      (el) => bagOf(el, { fxWaveX: { from: 0, to: o.amp ?? 24, unit: "px", css: "--fx-wave-x" }, fxWaveY: { from: 0, to: (o.amp ?? 24) * 0.3, unit: "px", css: "--fx-wave-y" } }, { ...o, ease: "inOutSine", duration: o.duration ?? 1.6, loop: o.loop ?? true, alternate: true })
    )
  );
  fx.register(
    "wobble",
    (o) => bagResult(
      (el) => bagOf(el, { fxRot: { from: -(o.deg ?? 6), to: o.deg ?? 6, unit: "deg", css: "--fx-wobble-rot" } }, { ...o, ease: "inOutSine", duration: o.duration ?? 1, loop: o.loop ?? true, alternate: true })
    )
  );
  fx.register(
    "static",
    (o) => bagResult(
      (el) => bagOf(el, {
        fxStatic: { keys: [0.25, 1, 0.55, 0.9, 0.35, 1], unit: "", css: "--fx-static" },
        fxNoiseX: { keys: [0, 17, 4, 31, 9, 44], unit: "px", css: "--fx-noise-x" },
        fxNoiseY: { keys: [0, 11, 29, 3, 37, 16], unit: "px", css: "--fx-noise-y" },
        fxNoiseX2: { keys: [0, -9, -27, -4, -33, -13], unit: "px", css: "--fx-noise-x2" },
        fxNoiseY2: { keys: [0, -21, -6, -35, -12, -42], unit: "px", css: "--fx-noise-y2" },
        fxFlicker: { keys: [0.65, 1, 0.78, 0.92, 0.55, 1], unit: "", css: "--fx-flicker" }
      }, { ...o, ease: "linear", duration: o.duration ?? 0.38, loop: o.loop ?? true })
    )
  );
  fx.register(
    "scanlines",
    (o) => bagResult(
      (el) => bagOf(el, { fxScan: { from: 0, to: 100, unit: "%", css: "--fx-scan" }, fxScanOp: { from: 0.1, to: o.opacity ?? 0.4, unit: "", css: "--fx-scan-op" } }, { ...o, ease: "linear", duration: o.duration ?? 4, loop: o.loop ?? true })
    )
  );
  fx.register(
    "crt",
    (o) => bagResult(
      (el) => bagOf(el, { fxCRTScan: { from: 0, to: 100, unit: "%", css: "--fx-crt-scan" }, fxCRTFlicker: { from: 0.7, to: 1, unit: "", css: "--fx-crt-flicker" }, fxCRTCurve: { from: 0, to: 1, unit: "", css: "--fx-crt-curve" } }, { ...o, ease: "linear", duration: o.duration ?? 3, loop: o.loop ?? true })
    )
  );
  fx.register(
    "heat",
    (o) => bagResult(
      (el) => bagOf(el, { fxHeat: { from: 0, to: o.amount ?? 14, unit: "px", css: "--fx-heat" }, fxHeatSpeed: { from: 0.3, to: o.speed ?? 1.2, unit: "", css: "--fx-heat-speed" } }, { ...o, ease: "linear", duration: o.duration ?? 1.4, loop: o.loop ?? true })
    )
  );
  fx.register(
    "waterWarp",
    (o) => bagResult(
      (el) => bagOf(el, { fxWarpX: { from: 0, to: o.amp ?? 16, unit: "px", css: "--fx-warp-x" }, fxWarpY: { from: 0, to: (o.amp ?? 16) * 0.5, unit: "px", css: "--fx-warp-y" }, fxWarpBlur: { from: 0, to: o.blur ?? 3, unit: "px", css: "--fx-warp-blur" } }, { ...o, ease: "inOutSine", duration: o.duration ?? 1.8, loop: o.loop ?? true, alternate: true })
    )
  );
  fx.register(
    "noise",
    (o) => bagResult(
      (el) => bagOf(el, {
        fxNoise: { keys: [0.2, o.amount ?? 1, 0.4, 0.85, 0.3], unit: "", css: "--fx-noise" },
        fxNoiseX: { keys: [0, 23, 6, 40, 12], unit: "px", css: "--fx-noise-x" },
        fxNoiseY: { keys: [0, 5, 32, 11, 48], unit: "px", css: "--fx-noise-y" },
        fxNoiseX2: { keys: [0, -15, -3, -34, -7], unit: "px", css: "--fx-noise-x2" },
        fxNoiseY2: { keys: [0, -4, -28, -9, -39], unit: "px", css: "--fx-noise-y2" },
        fxFlicker: { keys: [0.7, 1, 0.82, 0.96, 0.62], unit: "", css: "--fx-flicker" }
      }, { ...o, ease: "linear", duration: o.duration ?? 0.28, loop: o.loop ?? true })
    )
  );
  fx.register(
    "hologram",
    (o) => bagResult(
      (el) => bagOf(el, { fxHoloA: { colors: ["#00eaff", "#ff00ea"], css: "--fx-holo-a" }, fxHoloB: { colors: ["#ff00ea", "#00ff88"], css: "--fx-holo-b" }, fxHoloScan: { from: 0, to: 100, unit: "%", css: "--fx-holo-scan" }, fxHoloFlicker: { from: 0.6, to: 1, unit: "", css: "--fx-holo-flicker" } }, { ...o, ease: "linear", duration: o.duration ?? 2.4, loop: o.loop ?? true })
    )
  );
  fx.register(
    "shineSweep",
    (o) => bagResult(
      (el) => bagOf(el, { fxShineX: { from: -60, to: 160, unit: "%", css: "--fx-shine-x" }, fxShineOp: { from: 0, to: o.opacity ?? 0.9, unit: "", css: "--fx-shine-op" } }, { ...o, ease: "outExpo", duration: o.duration ?? 1.4, loop: o.loop ?? true, loopDelay: o.loopDelay ?? 0.8 })
    )
  );
  fx.register(
    "diamondSparkle",
    (o) => bagResult(
      (el) => bagOf(el, { fxSparkX: { from: -40, to: 140, unit: "%", css: "--fx-spark-x" }, fxSpark: { from: 0, to: 1, unit: "", css: "--fx-spark" }, fxGlow: { from: 0.2, to: 1, unit: "", css: "--fx-glow" } }, { ...o, ease: "outExpo", duration: o.duration ?? 1.6, loop: o.loop ?? true, loopDelay: o.loopDelay ?? 1.2 })
    )
  );
  fx.register(
    "prismFlash",
    (o) => bagResult(
      (el) => bagOf(el, { fxPrismA: { colors: ["#ffffff", "#00eaff"], css: "--fx-prism-a" }, fxPrismB: { colors: ["#ffffff", "#ff4dff"], css: "--fx-prism-b" } }, { ...o, ease: "inOutSine", duration: o.duration ?? 0.8, loop: o.loop ?? true })
    )
  );
  function bagResult(run) {
    return { kind: "bag", run: (el) => run(el) };
  }

  // src/modules/recorder.ts
  var Recorder = class {
    constructor(stage, opts = {}) {
      this.stage = stage;
      this.recorder = null;
      this.chunks = [];
      this.raf = 0;
      this.stream = null;
      this.audioCtx = null;
      this.audioDest = null;
      this.captureFn = null;
      this.running = false;
      this.opts = { fps: opts.fps ?? 30, audio: opts.audio ?? null, mimeType: opts.mimeType ?? "video/webm", scale: opts.scale ?? 2, capture: opts.capture ?? null };
      this.canvas = document.createElement("canvas");
      this.ctx = this.canvas.getContext("2d");
    }
    async prepare() {
      if (this.opts.capture) {
        this.captureFn = async () => {
          await this.opts.capture(this.stage, this.canvas);
        };
        return true;
      }
      try {
        const h2c = window.html2canvas ?? (await Promise.resolve().then(() => __toESM(require_html2canvas(), 1)).catch(() => null))?.default ?? await Promise.resolve().then(() => __toESM(require_html2canvas(), 1)).catch(() => null);
        if (!h2c) throw new Error("no html2canvas");
        this.captureFn = async () => {
          const shot = await h2c(this.stage, { backgroundColor: null, scale: this.opts.scale, logging: false });
          this.canvas.width = shot.width;
          this.canvas.height = shot.height;
          this.ctx.clearRect(0, 0, shot.width, shot.height);
          this.ctx.drawImage(shot, 0, 0);
        };
        return true;
      } catch (e) {
        console.warn("[pulse:recorder] html2canvas not available \u2014 pass RecorderOptions.capture to use a custom rasterizer", e);
        return false;
      }
    }
    async start() {
      if (this.running) return true;
      if (!this.captureFn) {
        const ok = await this.prepare();
        if (!ok) return false;
      }
      await this.captureFn();
      this.stream = this.canvas.captureStream(this.opts.fps);
      if (this.opts.audio && this.opts.audio.src) {
        try {
          const AC = window.AudioContext || window.webkitAudioContext;
          this.audioCtx = new AC();
          const src = this.audioCtx.createMediaElementSource(this.opts.audio);
          this.audioDest = this.audioCtx.createMediaStreamDestination();
          src.connect(this.audioDest);
          this.audioDest.stream.getAudioTracks().forEach((t) => this.stream.addTrack(t));
        } catch (e) {
          console.warn("[pulse:recorder] audio mux failed", e);
        }
      }
      const mime = MediaRecorder.isTypeSupported(this.opts.mimeType) ? this.opts.mimeType : "";
      this.recorder = new MediaRecorder(this.stream, mime ? { mimeType: mime } : void 0);
      this.chunks = [];
      this.recorder.ondataavailable = (e) => e.data.size && this.chunks.push(e.data);
      this.recorder.start();
      this.running = true;
      const frameMs = 1e3 / this.opts.fps;
      const loop = async () => {
        if (!this.running) return;
        await this.captureFn();
        this.raf = window.setTimeout(() => requestAnimationFrame(loop), frameMs);
      };
      loop();
      return true;
    }
    stop() {
      return new Promise((resolve) => {
        this.running = false;
        clearTimeout(this.raf);
        if (!this.recorder) return resolve(null);
        this.recorder.onstop = () => {
          const blob = new Blob(this.chunks, { type: this.recorder.mimeType || "video/webm" });
          this.audioCtx?.close();
          resolve(blob);
        };
        this.recorder.stop();
      });
    }
    /** Stop capture and release the recording loop. */
    dispose() {
      void this.stop();
    }
    /** Trigger a browser download of the recorded blob. */
    static download(blob, name = "pulse-recording.webm") {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1e3);
    }
  };

  // src/scene.ts
  function wrapTimers(timers, label) {
    return {
      play: () => timers.forEach((t) => t.play()),
      pause: () => timers.forEach((t) => t.pause()),
      seek: (t) => timers.forEach((i) => i.seek(t)),
      dispose: () => timers.forEach((i) => i.dispose()),
      label,
      kind: `group(${timers.map((t) => t.constructor.name).join(",")})`
    };
  }
  function resolveItem(item, label) {
    if (!item) return null;
    if (Array.isArray(item)) return wrapTimers(item.filter((i) => i instanceof Timer2), label ?? "array");
    if (item instanceof Timer2) {
      return { play: () => item.play(), pause: () => item.pause(), seek: (t) => item.seek(t), dispose: () => item.dispose(), label, kind: item.constructor.name };
    }
    if (item.bags && Array.isArray(item.bags)) return wrapTimers(item.bags, label ?? "textAnim");
    if (item.play && item.pause && item.seek && item.dispose) {
      return { play: () => item.play(), pause: () => item.pause(), seek: (t) => item.seek(t), dispose: () => item.dispose(), label, kind: item.constructor?.name ?? "duck" };
    }
    return null;
  }
  var PulseScene = class {
    constructor(id2 = `scene-${Math.random().toString(36).slice(2, 8)}`) {
      this.items = [];
      this._disposed = false;
      this.id = id2;
      this.reduced = typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    get size() {
      return this.items.length;
    }
    add(item, label) {
      if (this._disposed) return this;
      const r = resolveItem(item, label);
      if (r) this.items.push(r);
      return this;
    }
    play() {
      if (this.reduced) return this.snap();
      for (const it of this.items) it.play();
      return this;
    }
    pause() {
      for (const it of this.items) it.pause();
      return this;
    }
    resume() {
      return this.play();
    }
    seek(t) {
      for (const it of this.items) it.seek(t);
      return this;
    }
    setSpeed(r) {
      for (const it of this.items) it.setSpeed?.(r);
      return this;
    }
    /** Reduced-motion: snap every timer to its final frame. */
    snap() {
      for (const it of this.items) it.snap?.();
      return this;
    }
    /** Tear down: dispose every item. */
    dispose() {
      for (const it of this.items) it.dispose();
      this.items = [];
      this._disposed = true;
      return this;
    }
    get disposed() {
      return this._disposed;
    }
    /** Diagnostics: list items + state. */
    inspect() {
      return this.items.map((it) => ({ label: it.label, paused: it.paused ?? false, progress: it.progress ?? 0, kind: it.kind }));
    }
  };

  // src/group.ts
  var TimerGroup = class {
    constructor() {
      this.timers = [];
    }
    add(...timers) {
      for (const t of timers) if (t) this.timers.push(t);
      return this;
    }
    play() {
      for (const t of this.timers) t.resume();
      return this;
    }
    pause() {
      for (const t of this.timers) t.pause();
      return this;
    }
    seek(t) {
      for (const t2 of this.timers) t2.seek(t);
      return this;
    }
    seekProgress(progress) {
      const p = Math.max(0, Math.min(1, Number(progress) || 0));
      for (const timer of this.timers) timer.seek((timer.duration === Infinity ? timer.iterationDuration : timer.duration) * p);
      return this;
    }
    restart() {
      for (const timer of this.timers) timer.restart();
      return this;
    }
    setSpeed(rate) {
      for (const timer of this.timers) timer.setSpeed(rate);
      return this;
    }
    reverse() {
      for (const timer of this.timers) timer.reverse();
      return this;
    }
    resume() {
      return this.play();
    }
    dispose() {
      for (const t of this.timers) {
        t.cancel();
        t.dispose();
      }
      this.timers = [];
      return this;
    }
    get size() {
      return this.timers.length;
    }
  };

  // src/debug.ts
  var PulseDebug = class {
    /** Number of timers currently subscribed to the shared ticker. */
    activeTimers() {
      return ticker.size;
    }
    /** Names of every registered adapter. */
    adapterNames() {
      return adapters.map((a) => a.name ?? "anon");
    }
    /** What can a target animate, and through which adapter? */
    inspect(el) {
      const a = resolveAdapter(el);
      return { adapter: a ? a.name ?? "anon" : null, props: a ? a.props(el) : [] };
    }
    /** Compact runtime snapshot of a timer. */
    traceTimer(t) {
      return {
        duration: t.duration,
        progress: +(t.progress ?? 0).toFixed(3),
        iteration: t.currentIteration,
        paused: !!t.paused,
        loop: !!t._loop,
        alternate: !!t._alternate
      };
    }
    /** Compact snapshot of a scene. */
    traceScene(s) {
      return { id: s.id, size: s.size ?? 0 };
    }
  };
  var debug = new PulseDebug();

  // src/converter/pulsePlan.ts
  var PulsePlan = class {
    constructor(opts) {
      this.built = null;
      this.id = opts.id;
      this.name = opts.name;
      this.kind = opts.kind;
      this.sourceType = opts.sourceType;
      this.targets = opts.targets;
      this.duration = opts.duration;
      this.metadata = opts.metadata;
      this.mountFn = opts.mount;
    }
    /** Build (and cache) the concrete playable. */
    mount(P) {
      if (!this.built) this.built = this.mountFn(P);
      return this.built;
    }
    preview(P) {
      return this.mount(P);
    }
    serialize() {
      return {
        id: this.id,
        name: this.name,
        kind: this.kind,
        sourceType: this.sourceType,
        targets: this.targets,
        duration: this.duration,
        metadata: this.metadata
      };
    }
  };

  // src/integrations/rmt-layer-splitter/index.ts
  var RMT_LAYER_SPLITTER_SOURCE_TYPE = "rmt-layer-splitter";
  var record = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
  var finite = (value, fallback) => typeof value === "number" && Number.isFinite(value) ? value : fallback;
  var positive = (value, fallback) => {
    const result = finite(value, fallback);
    return result > 0 ? result : fallback;
  };
  var clamp3 = (value, min, max2) => Math.min(max2, Math.max(min, value));
  var slug = (value, fallback) => value.trim().toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "") || fallback;
  function diagnostic(code, severity, message, path) {
    return path ? { code, severity, message, path } : { code, severity, message };
  }
  function validateRmtLayerManifest(input) {
    const diagnostics = [];
    if (!record(input)) return { ok: false, diagnostics: [diagnostic("RMTLS_MANIFEST", "error", "Manifest must be an object.")] };
    if (!record(input.canvas)) diagnostics.push(diagnostic("RMTLS_CANVAS", "error", "canvas must be an object.", "canvas"));
    else {
      if (!(typeof input.canvas.width === "number" && Number.isFinite(input.canvas.width) && input.canvas.width > 0)) diagnostics.push(diagnostic("RMTLS_CANVAS_WIDTH", "error", "canvas.width must be positive.", "canvas.width"));
      if (!(typeof input.canvas.height === "number" && Number.isFinite(input.canvas.height) && input.canvas.height > 0)) diagnostics.push(diagnostic("RMTLS_CANVAS_HEIGHT", "error", "canvas.height must be positive.", "canvas.height"));
    }
    if (!Array.isArray(input.layers)) diagnostics.push(diagnostic("RMTLS_LAYERS", "error", "layers must be an array.", "layers"));
    else {
      const ids = /* @__PURE__ */ new Set();
      input.layers.forEach((layer2, index) => {
        const path = `layers[${index}]`;
        if (!record(layer2)) {
          diagnostics.push(diagnostic("RMTLS_LAYER", "error", "Layer must be an object.", path));
          return;
        }
        if (typeof layer2.id !== "string" || !layer2.id.trim()) diagnostics.push(diagnostic("RMTLS_LAYER_ID", "error", "Layer.id must be a non-empty string.", `${path}.id`));
        else if (ids.has(layer2.id)) diagnostics.push(diagnostic("RMTLS_LAYER_ID_DUPLICATE", "error", `Duplicate layer id "${layer2.id}".`, `${path}.id`));
        else ids.add(layer2.id);
        if (typeof layer2.src !== "string" || !layer2.src.trim()) diagnostics.push(diagnostic("RMTLS_LAYER_SRC", "error", "Layer.src must be a non-empty string.", `${path}.src`));
        if (layer2.bbox !== void 0 && (!Array.isArray(layer2.bbox) || layer2.bbox.length !== 4 || !layer2.bbox.every((item) => typeof item === "number" && Number.isFinite(item)))) diagnostics.push(diagnostic("RMTLS_LAYER_BBOX", "error", "Layer.bbox must contain four finite numbers.", `${path}.bbox`));
        if (layer2.depth !== void 0 && !(typeof layer2.depth === "number" && Number.isFinite(layer2.depth))) diagnostics.push(diagnostic("RMTLS_LAYER_DEPTH", "warning", "Layer.depth is not finite; a type default will be used.", `${path}.depth`));
      });
    }
    if (input.schemaVersion === void 0) diagnostics.push(diagnostic("RMTLS_SCHEMA_VERSION", "warning", "schemaVersion is missing; treating input as v1.", "schemaVersion"));
    return { ok: !diagnostics.some((item) => item.severity === "error"), diagnostics };
  }
  function isRmtLayerManifest(input) {
    return validateRmtLayerManifest(input).ok;
  }
  var RmtManifestError = class extends Error {
    constructor(diagnostics) {
      super("Invalid RMT Layer Splitter manifest.");
      this.diagnostics = diagnostics;
      this.name = "RmtManifestError";
    }
  };
  function layerType(value) {
    const type = String(value ?? "unknown").toLowerCase();
    if (type === "background") return "background";
    if (["subject", "person", "product"].includes(type)) return "subject";
    if (["text", "headline", "copy"].includes(type)) return "text";
    if (["text-raster", "raster-text"].includes(type)) return "text-raster";
    if (["logo", "brand"].includes(type)) return "logo";
    if (["graphic", "decoration"].includes(type)) return "graphic";
    if (type === "foreground") return "foreground";
    if (["effect", "smoke", "particles", "glow"].includes(type)) return "effect";
    return "unknown";
  }
  function depthDefault(type) {
    return type === "background" ? 0.05 : type === "foreground" || type === "effect" ? 0.9 : type === "text" || type === "text-raster" || type === "logo" ? 0.8 : 0.5;
  }
  function parallaxDefault(type) {
    return type === "background" ? 0.15 : type === "foreground" || type === "effect" ? 1.1 : type === "text" || type === "text-raster" || type === "logo" ? 0.9 : 0.65;
  }
  function zDefault(type, index) {
    return type === "background" ? 0 : type === "foreground" || type === "effect" ? 80 + index : type === "text" || type === "text-raster" || type === "logo" ? 60 + index : 20 + index;
  }
  function resolveAsset(baseUrl, source) {
    if (!baseUrl) return source;
    try {
      return new URL(source, baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`).toString();
    } catch {
      return `${baseUrl.replace(/[\\/]+$/, "")}/${source.replace(/^[\\/]+/, "")}`;
    }
  }
  function normalizeLayer(layer2, index, width, height, options) {
    const type = layerType(layer2.type);
    const bbox = Array.isArray(layer2.bbox) && layer2.bbox.length === 4 ? layer2.bbox : null;
    const explicit = [layer2.x, layer2.y, layer2.width, layer2.height].every((item) => typeof item === "number" && Number.isFinite(item));
    const useBbox = options.placementMode === "bbox" || options.placementMode === "auto" && layer2.fullCanvas !== true && bbox !== null;
    const placement = explicit ? { x: finite(layer2.x, 0), y: finite(layer2.y, 0), width: positive(layer2.width, width), height: positive(layer2.height, height) } : useBbox && bbox ? { x: bbox[0], y: bbox[1], width: positive(bbox[2], width), height: positive(bbox[3], height) } : { x: 0, y: 0, width, height };
    return {
      id: slug(layer2.id, `layer-${index + 1}`),
      name: layer2.name ?? layer2.id,
      type,
      src: resolveAsset(options.baseUrl, layer2.src),
      mask: typeof layer2.mask === "string" && layer2.mask.trim() ? resolveAsset(options.baseUrl, layer2.mask) : null,
      ...placement,
      bbox,
      zIndex: Math.round(finite(layer2.zIndex, zDefault(type, index))),
      depth: clamp3(finite(layer2.depth, depthDefault(type)), 0, 1),
      parallax: clamp3(finite(layer2.parallax, parallaxDefault(type)), -4, 4),
      blur: Math.max(0, finite(layer2.blur, 0)),
      opacity: clamp3(finite(layer2.opacity, 1), 0, 1),
      visible: layer2.visible !== false,
      locked: layer2.locked === true,
      fullCanvas: layer2.fullCanvas === true || placement.x === 0 && placement.y === 0 && placement.width === width && placement.height === height,
      ...layer2.extraction ? { extraction: layer2.extraction } : {},
      metadata: { originalId: layer2.id, ...layer2.metadata ?? {} },
      sourceIndex: index
    };
  }
  function normalizeRmtLayerManifest(input, options = {}) {
    const validation = validateRmtLayerManifest(input);
    if (!validation.ok) throw new RmtManifestError(validation.diagnostics);
    const manifest = input;
    const width = positive(manifest.canvas.width, 1), height = positive(manifest.canvas.height, 1);
    const layers = manifest.layers.map((layer2, index) => normalizeLayer(layer2, index, width, height, { placementMode: "full-canvas", ...options })).filter((layer2) => options.includeHidden || layer2.visible).sort((a, b) => a.zIndex - b.zIndex || a.sourceIndex - b.sourceIndex);
    const id2 = options.projectId ?? manifest.projectId ?? manifest.id ?? "rmt-layer-scene";
    return {
      schemaVersion: 1,
      id: slug(id2, "rmt-layer-scene"),
      name: options.projectName ?? manifest.name ?? "RMT Layer Scene",
      width,
      height,
      colorSpace: manifest.canvas.colorSpace ?? "sRGB",
      backgroundColor: options.backgroundColor ?? manifest.background?.color ?? "#000000",
      depthMap: manifest.background?.depthMap ? resolveAsset(options.baseUrl, manifest.background.depthMap) : null,
      layers,
      ...manifest.source ? { source: manifest.source } : {},
      metadata: { sourceType: RMT_LAYER_SPLITTER_SOURCE_TYPE, ...manifest.metadata ?? {} }
    };
  }
  function stable(value) {
    if (Array.isArray(value)) return value.map(stable);
    if (record(value)) return Object.fromEntries(Object.keys(value).sort().map((key2) => [key2, stable(value[key2])]));
    return typeof value === "number" && !Number.isFinite(value) ? null : value;
  }
  function fnv1a(text) {
    let hash = 2166136261;
    for (let index = 0; index < text.length; index += 1) {
      hash ^= text.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16).padStart(8, "0");
  }
  function fingerprintRmtLayerSplitterManifest(input, options = {}) {
    const manifest = normalizeRmtLayerManifest(input, options);
    return `rmtls-${fnv1a(JSON.stringify(stable({ id: manifest.id, size: [manifest.width, manifest.height], background: manifest.backgroundColor, depthMap: manifest.depthMap, layers: manifest.layers.map((layer2) => ({ id: layer2.id, src: layer2.src, mask: layer2.mask, placement: [layer2.x, layer2.y, layer2.width, layer2.height], zIndex: layer2.zIndex, depth: layer2.depth, parallax: layer2.parallax, opacity: layer2.opacity, visible: layer2.visible, locked: layer2.locked })) })))}`;
  }
  function rmtLayerSplitterToPulseEditorProject(input, options = {}) {
    const manifest = normalizeRmtLayerManifest(input, options), duration = positive(options.duration, 10), fps = Math.round(positive(options.fps, 60));
    return {
      schemaVersion: 1,
      id: manifest.id,
      name: manifest.name,
      width: manifest.width,
      height: manifest.height,
      fps,
      duration,
      background: manifest.backgroundColor,
      tracks: manifest.layers.map((layer2, order) => ({ id: `rmt-track-${layer2.id}`, name: layer2.name, kind: "image", order, visible: layer2.visible, locked: layer2.locked, muted: false })),
      assets: manifest.layers.map((layer2) => ({ id: `rmt-asset-${layer2.id}`, kind: "image", name: layer2.name, source: layer2.src })),
      clips: manifest.layers.map((layer2) => ({
        id: `rmt-clip-${layer2.id}`,
        trackId: `rmt-track-${layer2.id}`,
        targetId: `rmt-target-${layer2.id}`,
        kind: "image",
        name: layer2.name,
        start: 0,
        end: duration,
        enabled: layer2.visible,
        assetId: `rmt-asset-${layer2.id}`,
        transform: { x: layer2.x, y: layer2.y, scale: 1, rotate: 0, opacity: layer2.opacity },
        keyframes: [],
        effects: [],
        metadata: { source: RMT_LAYER_SPLITTER_SOURCE_TYPE, units: "px", width: layer2.width, height: layer2.height, canvasWidth: manifest.width, canvasHeight: manifest.height, zIndex: layer2.zIndex, depth: layer2.depth, parallax: layer2.parallax, blur: layer2.blur, mask: layer2.mask, bbox: layer2.bbox, fullCanvas: layer2.fullCanvas, extraction: layer2.extraction ?? null }
      }))
    };
  }
  function cssUrl(value) {
    return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }
  function mountRmtLayerDomScene(input, root, options = {}) {
    if (!(root instanceof HTMLElement)) throw new TypeError("RMT Layer Splitter requires an HTMLElement root.");
    const manifest = normalizeRmtLayerManifest(input, options), stage = document.createElement("div"), layers = /* @__PURE__ */ new Map();
    stage.className = options.className ?? "rmt-pulse-layer-scene";
    stage.dataset.rmtProjectId = manifest.id;
    stage.dataset.pulseScene = RMT_LAYER_SPLITTER_SOURCE_TYPE;
    Object.assign(stage.style, { position: "relative", width: "100%", aspectRatio: `${manifest.width} / ${manifest.height}`, overflow: "hidden", background: manifest.backgroundColor, isolation: "isolate", containerType: "size" });
    if (!options.preserveRootStyles) {
      if (!root.style.position) root.style.position = "relative";
      if (!root.style.overflow) root.style.overflow = "hidden";
    }
    for (const layer2 of manifest.layers) {
      const image = document.createElement("img");
      image.alt = "";
      image.draggable = false;
      image.decoding = options.imageDecoding ?? "async";
      image.loading = options.imageLoading ?? "eager";
      image.src = layer2.src;
      image.dataset.rmtLayerId = layer2.id;
      image.dataset.rmtLayerType = layer2.type;
      image.dataset.pulseTargetId = `rmt-target-${layer2.id}`;
      image.dataset.pulseDepth = String(layer2.depth);
      image.dataset.pulseParallax = String(layer2.parallax);
      Object.assign(image.style, { position: "absolute", left: `${layer2.x / manifest.width * 100}%`, top: `${layer2.y / manifest.height * 100}%`, width: `${layer2.width / manifest.width * 100}%`, height: `${layer2.height / manifest.height * 100}%`, objectFit: "fill", zIndex: String(layer2.zIndex), opacity: String(layer2.opacity), pointerEvents: "none", userSelect: "none", transformOrigin: "50% 50%", willChange: "transform, opacity, filter", visibility: layer2.visible ? "visible" : "hidden" });
      if (layer2.blur > 0) image.style.filter = `blur(${layer2.blur}px)`;
      if (options.applyMasks && layer2.mask) {
        const value = `url("${cssUrl(layer2.mask)}")`;
        Object.assign(image.style, { maskImage: value, maskRepeat: "no-repeat", maskSize: "100% 100%", maskPosition: "center", webkitMaskImage: value, webkitMaskRepeat: "no-repeat", webkitMaskSize: "100% 100%", webkitMaskPosition: "center" });
      }
      stage.append(image);
      layers.set(layer2.id, image);
    }
    root.append(stage);
    let disposed = false;
    return { stage, layers, manifest, dispose() {
      if (disposed) return;
      disposed = true;
      layers.clear();
      stage.remove();
    } };
  }
  function composite(scope2, scene) {
    let disposed = false;
    return {
      play() {
        if (!disposed) scope2.play();
        return this;
      },
      pause() {
        if (!disposed) scope2.pause();
        return this;
      },
      seek(time) {
        if (!disposed) scope2.seek(time);
        return this;
      },
      restart() {
        if (!disposed) scope2.restart();
        return this;
      },
      setSpeed(rate) {
        if (!disposed) scope2.setSpeed(rate);
        return this;
      },
      reverse() {
        if (!disposed) scope2.reverse?.();
        return this;
      },
      dispose() {
        if (disposed) return;
        disposed = true;
        try {
          scope2.dispose();
        } finally {
          scene.dispose();
        }
      }
    };
  }
  function createRmtLayerSplitterPulsePlan(input, options) {
    if (!options?.root) throw new TypeError("RMT Layer Splitter requires options.root.");
    const manifest = normalizeRmtLayerManifest(input, options), duration = positive(options.duration, 10), planId = `rmt-plan-${manifest.id}`;
    return new PulsePlan({
      id: planId,
      name: manifest.name,
      kind: "scope",
      sourceType: RMT_LAYER_SPLITTER_SOURCE_TYPE,
      targets: manifest.layers.map((layer2) => `rmt-target-${layer2.id}`),
      duration,
      metadata: { manifestId: manifest.id, fingerprint: fingerprintRmtLayerSplitterManifest(input, options), canvas: { width: manifest.width, height: manifest.height }, motionPreset: options.motionPreset ?? "none", depthMap: manifest.depthMap },
      mount: (pulse) => {
        const scene = mountRmtLayerDomScene(input, options.root, options), reduced = Boolean(pulse.reducedMotion), drifting = !reduced && options.motionPreset === "depth-drift";
        const scope2 = pulse.scope(planId, { loop: drifting, paused: !(options.autoPlay ?? false), metadata: { sourceType: RMT_LAYER_SPLITTER_SOURCE_TYPE, manifestId: scene.manifest.id } });
        if (drifting) {
          const strength = Math.max(0, finite(options.motionStrength, 1)), loopDuration = positive(options.loopDuration, 8);
          for (const layer2 of scene.manifest.layers) {
            const element = scene.layers.get(layer2.id);
            if (!element || layer2.parallax === 0) continue;
            const distance = 10 * layer2.parallax * strength, scaleLift = 0.012 + layer2.depth * 0.018 * strength;
            scope2.add(pulse.convert("bag", { target: element, props: { x: [0, distance, -distance * 0.55, 0], y: [0, -distance * 0.55, distance * 0.3, 0], scale: [1, 1 + scaleLift, 1] }, duration: loopDuration, ease: "inOutSine", loop: true }).mount(pulse));
          }
        }
        const playable = composite(scope2, scene);
        if (options.autoPlay) playable.play();
        return playable;
      }
    });
  }
  function rmtLayerSplitterConverter(_pulse, input) {
    if (!record(input) || !("manifest" in input) || !("root" in input)) throw new TypeError('pulse.convert("rmt-layer-splitter", input) requires { manifest, root }.');
    const { manifest, ...options } = input;
    return createRmtLayerSplitterPulsePlan(manifest, options);
  }

  // src/converter/converters.ts
  var _id = 0;
  var nextId = (p) => `${p}-${++_id}`;
  function textPlayable(res) {
    const bags = res && res.bags ? res.bags : [];
    return {
      play() {
        bags.forEach((b) => b.play());
        return this;
      },
      pause() {
        bags.forEach((b) => b.pause());
        return this;
      },
      seek(t) {
        bags.forEach((b) => b.seek(t));
        return this;
      },
      restart() {
        bags.forEach((b) => b.restart());
        return this;
      },
      setSpeed(r) {
        bags.forEach((b) => b.setSpeed && b.setSpeed(r));
        return this;
      },
      dispose() {
        bags.forEach((b) => b.dispose && b.dispose());
        res && res.revert && res.revert();
      },
      get disposed() {
        return false;
      }
    };
  }
  function bagConverter(_P, input) {
    const { target, props, duration = 0.9, ease = "outExpo", loop = false, alternate = false, delay = 0, step, mode, ...rest } = input;
    const kind = step || mode ? "text" : "bag";
    return new PulsePlan({
      id: nextId("bag"),
      name: input.name,
      kind,
      sourceType: "bag",
      targets: [target],
      duration,
      metadata: rest,
      mount: (Pinst) => {
        if (mode || step !== void 0) {
          return textPlayable(Pinst.textAnim(target, props, { duration, ease, loop, alternate, delay, step, mode }));
        }
        return Pinst.bag(target, props, { duration, ease, loop, alternate, delay });
      }
    });
  }
  function textPresetConverter(_P, input) {
    const { target, preset, mode = "chars", duration = 0.9, stagger: stagger3 = 0.04, props = { y: [40, 0], opacity: [0, 1] }, ...rest } = input;
    return new PulsePlan({
      id: nextId("text"),
      name: preset || input.name,
      kind: "text",
      sourceType: "text-preset",
      targets: [target],
      duration,
      metadata: { preset, ...rest },
      mount: (Pinst) => textPlayable(Pinst.textAnim(target, props, { duration, ease: "outExpo", step: stagger3, mode, loop: rest.loop, alternate: rest.alternate }))
    });
  }
  function fxConverter(_P, input) {
    const { target, preset, ...rest } = input;
    return new PulsePlan({
      id: nextId("fx"),
      name: preset || input.name,
      kind: "fx",
      sourceType: "fx-preset",
      targets: [target],
      duration: rest.duration ?? 0.6,
      metadata: rest,
      mount: (Pinst) => {
        let live = null;
        return {
          play() {
            live?.cancel?.();
            live?.dispose?.();
            live = Pinst.fx.play(preset, target, { ...rest });
          },
          pause() {
            live?.pause?.();
          },
          seek(t) {
            live?.seek?.(t);
          },
          restart() {
            live?.cancel?.();
            live?.dispose?.();
            live = Pinst.fx.play(preset, target, { ...rest });
          },
          setSpeed(r) {
            live?.setSpeed?.(r);
          },
          dispose() {
            live?.cancel?.();
            live?.dispose?.();
            live = null;
          }
        };
      }
    });
  }
  function waapiConverter(_P, input) {
    const { target, targets, props, duration = 1e3, ease = "linear", loop = false, alternate = false, delay = 0, ...rest } = input;
    const resolvedTargets = targets ?? target;
    return new PulsePlan({
      id: nextId("waapi"),
      name: input.name,
      kind: "waapi",
      sourceType: "waapi",
      targets: Array.isArray(resolvedTargets) ? resolvedTargets : [resolvedTargets],
      duration,
      metadata: { ease, loop, alternate, delay, ...rest },
      mount: (Pinst) => Pinst.waapi(resolvedTargets, { ...props ?? rest, duration, ease, loop, alternate, delay })
    });
  }
  var CONVERTERS = {
    bag: bagConverter,
    tween: bagConverter,
    "text-preset": textPresetConverter,
    text: textPresetConverter,
    fx: fxConverter,
    waapi: waapiConverter,
    "rmt-layer-splitter": rmtLayerSplitterConverter
  };
  var PulseConverter = {
    register(type, fn) {
      CONVERTERS[type] = fn;
    },
    convert(P, type, input) {
      const fn = CONVERTERS[type];
      if (!fn) throw new Error(`PulseConverter: no converter for "${type}"`);
      return fn(P, input);
    },
    types() {
      return Object.keys(CONVERTERS);
    }
  };

  // src/scope/scope.ts
  var PulseScope = class _PulseScope {
    constructor(id2 = `scope-${Math.random().toString(36).slice(2, 8)}`, opts = {}) {
      this.children = [];
      this.scopes = [];
      this.parentTime = 0;
      this.bound = false;
      this._disposed = false;
      this.onTick = (dt) => {
        if (this.paused || this.muted || this._disposed) return;
        this.parentTime += dt;
        const lt = this.localTime();
        for (const c of this.children) {
          c.localTime = lt;
          c.item.seek(Math.max(0, lt));
        }
        for (const s of this.scopes) s.parentTime = lt;
      };
      this.id = id2;
      this.offset = opts.offset ?? 0;
      this.speed = opts.speed ?? 1;
      this.loop = opts.loop ?? false;
      this.reversed = opts.reversed ?? false;
      this.muted = opts.muted ?? false;
      this.paused = opts.paused ?? false;
      this.metadata = opts.metadata;
    }
    /** Local time derived from parent clock. */
    localTime() {
      let t = (this.parentTime - this.offset) * this.speed;
      if (this.reversed) t = -t;
      return t;
    }
    add(playable) {
      if (this._disposed) return playable;
      this.children.push({ item: playable, localTime: 0 });
      if (!this.bound) this.bind();
      if (!this.paused && !this.muted) playable.play();
      return playable;
    }
    /** Build a plan via converter and add its mounted playable. */
    from(type, input, P) {
      const plan = P.convert(type, input);
      return this.add(plan.mount(P));
    }
    scope(id2, opts = {}) {
      const s = new _PulseScope(id2, opts);
      this.scopes.push(s);
      if (!this.bound) this.bind();
      return s;
    }
    children_() {
      return this.children.map((c) => c.item);
    }
    subScopes() {
      return this.scopes;
    }
    bind() {
      if (this.bound) return;
      this.bound = true;
      this._unsub = ticker.add(this.onTick);
    }
    unbind() {
      if (!this.bound) return;
      this.bound = false;
      this._unsub?.();
    }
    play() {
      this.paused = false;
      this.bind();
      for (const c of this.children) c.item.play();
      for (const s of this.scopes) s.play();
      return this;
    }
    pause() {
      this.paused = true;
      for (const c of this.children) c.item.pause();
      for (const s of this.scopes) s.pause();
      return this;
    }
    seek(time) {
      this.parentTime = time;
      const lt = this.localTime();
      for (const c of this.children) c.item.seek(Math.max(0, lt));
      for (const s of this.scopes) s.seek(lt);
      return this;
    }
    restart() {
      this.parentTime = 0;
      this.play();
      return this;
    }
    setSpeed(rate) {
      this.speed = rate;
      for (const s of this.scopes) s.setSpeed(rate);
      return this;
    }
    reverse() {
      this.reversed = !this.reversed;
      return this;
    }
    dispose() {
      this._disposed = true;
      for (const c of this.children) c.item.dispose();
      for (const s of this.scopes) s.dispose();
      this.children = [];
      this.scopes = [];
      this.unbind();
    }
    get disposed() {
      return this._disposed;
    }
    get size() {
      return this.children.length + this.scopes.length;
    }
  };

  // src/signal/signal.ts
  var _sid = 0;
  var nextId2 = () => `sig-${++_sid}`;
  var PulseSignal = class {
    constructor(id2 = nextId2()) {
      this.sourceFn = () => 0;
      this.mapRange = null;
      this.smoothAmt = 0;
      this.clampRange = null;
      this.smoothed = 0;
      this.initialized = false;
      this.bindings = [];
      this.active = false;
      this._disposed = false;
      this.onTick = () => {
        if (!this.active || this._disposed) return;
        const v = this.compute();
        for (const b of this.bindings) {
          const tgt = b.target;
          if (!tgt) continue;
          PulseProperties.apply(tgt, { [b.prop]: { from: 0, to: v } }, { [b.prop]: v });
        }
        this._onChange?.(v);
      };
      this.bound = false;
      this.id = id2;
    }
    from(fn) {
      this.clearSource();
      this.sourceFn = fn;
      return this;
    }
    fromPointer(axis = "x") {
      this.clearSource();
      let x = typeof window !== "undefined" ? window.innerWidth / 2 : 0;
      let y = typeof window !== "undefined" ? window.innerHeight / 2 : 0;
      if (typeof window !== "undefined") {
        const onPointerMove = (event) => {
          x = event.clientX;
          y = event.clientY;
        };
        window.addEventListener("pointermove", onPointerMove, { passive: true });
        this.sourceCleanup = () => window.removeEventListener("pointermove", onPointerMove);
      }
      this.sourceFn = () => axis === "x" ? x : y;
      return this;
    }
    fromScroll() {
      this.clearSource();
      this.sourceFn = () => typeof window !== "undefined" && window.scrollY !== void 0 ? window.scrollY : 0;
      return this;
    }
    fromAudio(getBands) {
      this.clearSource();
      this.sourceFn = () => getBands().bass;
      return this;
    }
    map(inMin, inMax, outMin, outMax) {
      this.mapRange = [inMin, inMax, outMin, outMax];
      return this;
    }
    clamp(min, max2) {
      this.clampRange = [min, max2];
      return this;
    }
    smooth(amount) {
      this.smoothAmt = amount;
      return this;
    }
    threshold(value) {
      this.mapRange = [value, value + 1e-4, 1, 1];
      return this;
    }
    to(target, prop) {
      const b = {
        id: nextId2(),
        signalId: this.id,
        target,
        prop,
        pause: () => {
          this.active = false;
        },
        resume: () => {
          this.active = true;
          this.bind();
        },
        dispose: () => {
          this.dispose();
        }
      };
      this.bindings.push(b);
      this.active = true;
      this.bind();
      return b;
    }
    onChange(fn) {
      this._onChange = fn;
      return this;
    }
    compute() {
      let v = this.sourceFn();
      if (this.mapRange) {
        const [a, b, c, d] = this.mapRange;
        const t = b === a ? 0 : (v - a) / (b - a);
        v = c + (d - c) * Math.max(0, Math.min(1, t));
      }
      if (this.clampRange) v = Math.max(this.clampRange[0], Math.min(this.clampRange[1], v));
      if (this.smoothAmt > 0) {
        if (!this.initialized) {
          this.smoothed = v;
          this.initialized = true;
        }
        this.smoothed += (v - this.smoothed) * this.smoothAmt;
        v = this.smoothed;
      }
      return v;
    }
    bind() {
      if (this.bound) return;
      this.bound = true;
      this._unsub = ticker.add(this.onTick);
    }
    unbind() {
      if (!this.bound) return;
      this.bound = false;
      this._unsub?.();
    }
    dispose() {
      this._disposed = true;
      this.active = false;
      this.bindings = [];
      this.unbind();
      this.clearSource();
    }
    get disposed() {
      return this._disposed;
    }
    clearSource() {
      this.sourceCleanup?.();
      this.sourceCleanup = void 0;
    }
  };
  var SignalRegistry = {
    signals: [],
    create(name) {
      const s = new PulseSignal(name);
      this.signals.push(s);
      return s;
    }
  };

  // src/patch/patch.ts
  var _pid = 0;
  var nextId3 = () => `patch-${++_pid}`;
  var PulsePatchChain = class {
    constructor(target, spec, opts = {}, engine2) {
      this.nodes = [];
      this.base = null;
      // the underlying Bag/Tween playable
      this._elapsed = 0;
      this.bound = false;
      this.playing = false;
      this._disposed = false;
      this.onTick = (dt) => {
        if (!this.playing || this._disposed) return;
        this._elapsed += dt;
        this.run(this.engine);
      };
      this.target = target;
      this.baseSpec = spec;
      this.baseOpts = opts;
      this.engine = engine2 || (typeof globalThis !== "undefined" ? globalThis.Pulse : null);
    }
    /** Build the base Bag animation. */
    buildBase(P) {
      this.base = P.bag(this.target, this.baseSpec, { ...this.baseOpts, autoplay: false });
    }
    animate(spec, opts = {}) {
      this.baseSpec = spec;
      this.baseOpts = opts;
      return this;
    }
    use(node) {
      this.nodes.push(node);
      return this;
    }
    spring(opts = {}) {
      const k = opts.stiffness ?? 180;
      const d = opts.damping ?? 18;
      return this.use({
        id: nextId3(),
        name: "spring",
        props: ["*"],
        process: (ctx) => {
          for (const key2 of Object.keys(ctx.values)) {
            const v = ctx.values[key2];
            const prev = ctx._prev ? ctx._prev[key2] : void 0;
            ctx.values[key2] = v + (v - (prev ?? v)) * (d / k);
            ctx._prev = ctx._prev || {};
            ctx._prev[key2] = v;
          }
          return ctx;
        }
      });
    }
    shake(opts = {}) {
      const amt = opts.amount ?? 6;
      const decay = opts.decay ?? 0.4;
      return this.use({
        id: nextId3(),
        name: "shake",
        props: ["x", "y"],
        process: (ctx) => {
          const t = ctx.time * 30;
          const m = amt * Math.exp(-ctx.progress * decay * 10);
          ctx.values.x = (ctx.values.x ?? 0) + Math.sin(t) * m;
          ctx.values.y = (ctx.values.y ?? 0) + Math.cos(t * 1.3) * m;
          return ctx;
        }
      });
    }
    glow(opts = {}) {
      const strength = opts.strength ?? 20;
      return this.use({
        id: nextId3(),
        name: "glow",
        props: ["--glow"],
        process: (ctx) => {
          ctx.target?.style?.setProperty("--glow", `${strength * (1 - ctx.progress)}px`);
          return ctx;
        }
      });
    }
    // ---- effect-chain nodes: write --fx-* vars the patch CSS consumes ----
    ripple(opts = {}) {
      const s = opts.strength ?? 18, sp = opts.speed ?? 1;
      return this.use({
        id: nextId3(),
        name: "ripple",
        props: ["--fx-ripple"],
        process: (ctx) => {
          const w = Math.sin(ctx.time * 6 * sp) * 0.5 + 0.5;
          ctx.target?.style?.setProperty("--fx-ripple", `${s * w}px`);
          return ctx;
        }
      });
    }
    static(opts = {}) {
      const a = opts.amount ?? 1, sp = opts.speed ?? 2;
      return this.use({
        id: nextId3(),
        name: "static",
        props: ["--fx-static"],
        process: (ctx) => {
          const p = Math.sin(ctx.time * 12 * sp) * 0.5 + 0.5;
          ctx.target?.style?.setProperty("--fx-static", `${a * p}`);
          ctx.target?.style?.setProperty("--fx-noise-x", `${(p * 42).toFixed(2)}px`);
          ctx.target?.style?.setProperty("--fx-noise-y", `${((1 - p) * 31).toFixed(2)}px`);
          return ctx;
        }
      });
    }
    scanlines(opts = {}) {
      const o = opts.opacity ?? 0.35;
      return this.use({
        id: nextId3(),
        name: "scanlines",
        props: ["--fx-scan-op"],
        process: (ctx) => {
          ctx.target?.style?.setProperty("--fx-scan-op", `${o}`);
          ctx.target?.style?.setProperty("--fx-scan", `${(ctx.progress * 100).toFixed(1)}%`);
          return ctx;
        }
      });
    }
    glitch(opts = {}) {
      const a = opts.amount ?? 6;
      return this.use({
        id: nextId3(),
        name: "glitch",
        props: ["--fx-glitch-x"],
        process: (ctx) => {
          const g = Math.sin(ctx.time * 40) * a * (ctx.progress < 1 ? 1 : 0);
          ctx.target?.style?.setProperty("--fx-glitch-x", `${g}px`);
          ctx.target?.style?.setProperty("--fx-glitch-rgb", `${Math.abs(g)}px`);
          return ctx;
        }
      });
    }
    heat(opts = {}) {
      const a = opts.amount ?? 14;
      return this.use({
        id: nextId3(),
        name: "heat",
        props: ["--fx-heat"],
        process: (ctx) => {
          ctx.target?.style?.setProperty("--fx-heat", `${a * (Math.sin(ctx.time * 5) * 0.5 + 0.5)}px`);
          return ctx;
        }
      });
    }
    wobble(opts = {}) {
      const d = opts.deg ?? 6;
      return this.use({
        id: nextId3(),
        name: "wobble",
        props: ["--fx-wobble-rot"],
        process: (ctx) => {
          ctx.target?.style?.setProperty("--fx-wobble-rot", `${(Math.sin(ctx.time * 4) * d).toFixed(2)}deg`);
          return ctx;
        }
      });
    }
    /** Run the chain: base evaluates → patches modify → adapter writes via PulseProperties. */
    run(P) {
      if (!this.base) this.buildBase(P);
      const p = Math.min(1, this._elapsed / (this.baseOpts.duration ?? 0.9));
      const ctx = {
        time: this._elapsed,
        progress: p,
        target: this.target,
        values: this.base.values(p),
        styles: {}
      };
      for (const n of this.nodes) ctx.values = n.process(ctx).values;
      P.properties.apply(this.target, this.baseSpec, ctx.values);
    }
    bind() {
      if (!this.bound) {
        this.bound = true;
        this._unsub = ticker.add(this.onTick);
      }
    }
    unbind() {
      if (this.bound) {
        this.bound = false;
        this._unsub?.();
      }
    }
    play() {
      this.playing = true;
      this.bind();
      return this;
    }
    pause() {
      this.playing = false;
      this.unbind();
      return this;
    }
    seek(time) {
      this._elapsed = time;
      this.run(this.engine);
      return this;
    }
    restart() {
      this._elapsed = 0;
      this.play();
      return this;
    }
    setSpeed(_rate) {
      return this;
    }
    dispose() {
      this._disposed = true;
      this.playing = false;
      this.unbind();
      for (const n of this.nodes) n.dispose?.();
      this.base?.dispose?.();
    }
    get disposed() {
      return this._disposed;
    }
    output() {
      return this.target;
    }
  };

  // src/layout/layout.ts
  var DEFAULT_STATES = ["1", "2", "3", "4"];
  var DEFAULT_ANIMATION = { duration: 650, ease: "outExpo" };
  var WEB_LAYOUT_TYPES = [
    "single-column",
    "two-column",
    "grid",
    "f-pattern",
    "z-pattern",
    "split-screen",
    "magazine",
    "asymmetrical",
    "holy-grail",
    "masonry",
    "hero-landing",
    "full-screen"
  ];
  var LAYOUT_STYLE_PROPERTIES = [
    "gap",
    "box-sizing",
    "display",
    "grid-template-columns",
    "align-content",
    "grid-template-areas",
    "columns",
    "column-gap",
    "place-items",
    "min-height",
    "text-align",
    "overflow",
    "grid-column",
    "grid-area",
    "translate",
    "break-inside",
    "margin-bottom"
  ];
  function snapshotLayoutStyles(element) {
    const styles = {};
    LAYOUT_STYLE_PROPERTIES.forEach((property) => {
      styles[property] = {
        value: element.style.getPropertyValue(property),
        priority: element.style.getPropertyPriority(property)
      };
    });
    return styles;
  }
  function cssSize(value, fallback) {
    if (typeof value === "number") return `${value}px`;
    return value || fallback;
  }
  function setStyles(element, styles) {
    for (const [property, value] of Object.entries(styles)) element.style.setProperty(property, value);
  }
  function applyWebLayout(element, section, defaults2) {
    const gap = cssSize(section.gap, defaults2.gap);
    const min = cssSize(section.minColumnWidth, defaults2.minColumnWidth);
    const children = Array.from(element.children).filter(isHTMLElement2);
    element.dataset.pulseLayoutType = section.type;
    setStyles(element, { gap, "box-sizing": "border-box" });
    const grid2 = (columns) => setStyles(element, {
      display: "grid",
      "grid-template-columns": columns,
      "align-content": "start"
    });
    switch (section.type) {
      case "single-column":
        grid2("minmax(0, 1fr)");
        break;
      case "two-column":
        grid2("repeat(2, minmax(0, 1fr))");
        break;
      case "grid":
        grid2(`repeat(auto-fit, minmax(min(100%, ${min}), 1fr))`);
        break;
      case "f-pattern":
        grid2("minmax(0, 2fr) minmax(0, 1fr)");
        if (children[0]) children[0].style.gridColumn = "1 / -1";
        break;
      case "z-pattern":
        grid2("repeat(2, minmax(0, 1fr))");
        children.forEach((child, index) => {
          if (index % 4 === 1) child.style.gridColumn = "2";
          if (index % 4 === 2) child.style.gridColumn = "2";
        });
        break;
      case "split-screen":
        grid2("repeat(2, minmax(0, 1fr))");
        break;
      case "magazine":
        grid2("repeat(12, minmax(0, 1fr))");
        children.forEach((child, index) => child.style.gridColumn = `span ${index === 0 ? 8 : index < 3 ? 4 : 6}`);
        break;
      case "asymmetrical":
        grid2("repeat(12, minmax(0, 1fr))");
        children.forEach((child, index) => {
          child.style.gridColumn = `span ${[7, 5, 4, 8][index % 4]}`;
          if (index % 3 === 1) child.style.translate = "0 8%";
        });
        break;
      case "holy-grail":
        grid2("minmax(10rem, 1fr) minmax(0, 3fr) minmax(10rem, 1fr)");
        setStyles(element, { "grid-template-areas": '"header header header" "left main right" "footer footer footer"' });
        ["header", "left", "main", "right", "footer"].forEach((area, index) => {
          if (children[index]) children[index].style.gridArea = area;
        });
        break;
      case "masonry":
        setStyles(element, { display: "block", columns: min, "column-gap": gap });
        children.forEach((child) => setStyles(child, { "break-inside": "avoid", "margin-bottom": gap }));
        break;
      case "hero-landing":
        grid2("minmax(0, 1fr)");
        setStyles(element, { "place-items": "center", "min-height": "min(80vh, 56rem)", "text-align": "center" });
        break;
      case "full-screen":
        grid2("minmax(0, 1fr)");
        setStyles(element, { "place-items": "center", "min-height": "100vh", overflow: "hidden" });
        break;
    }
  }
  function resolveRoot2(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") return null;
      return document.querySelector(root);
    }
    return root ?? null;
  }
  function toAnimeTime2(value) {
    if (typeof value !== "number") return value;
    if (value > 0 && value <= 20) return value * 1e3;
    return value;
  }
  function normalizeTimings(params) {
    const next = { ...params };
    if ("duration" in next) next.duration = toAnimeTime2(next.duration);
    if ("delay" in next) next.delay = toAnimeTime2(next.delay);
    return next;
  }
  function wrapIndex2(index, length) {
    if (length <= 0) return 0;
    const rounded = Math.round(Number(index) || 0);
    return (rounded % length + length) % length;
  }
  function isHTMLElement2(node) {
    return typeof HTMLElement !== "undefined" && node instanceof HTMLElement || "style" in node;
  }
  var PulseLayout = class {
    constructor(root, params = {}) {
      this.__pulseLayout = true;
      this.auto = null;
      this.lastAnimation = null;
      this._stateIndex = 0;
      this._progress = 0;
      this._disposed = false;
      this._debug = false;
      this.layoutSnapshots = [];
      this._layoutTypes = [];
      this.baseSections = [];
      this.baseDefaults = {};
      this.breakpoints = [];
      this.resizeCleanup = null;
      this.activeResponsiveKey = "";
      const el = resolveRoot2(root);
      if (!el) throw new Error("[pulse:layout] root not found");
      const {
        states: states2 = DEFAULT_STATES,
        stateAttribute = "layout",
        debug: debug2 = false,
        type,
        types,
        sections,
        layoutGap,
        minColumnWidth,
        breakpoints = [],
        ...layoutParams
      } = params;
      this.root = el;
      this.states = states2.length ? states2.map(String) : DEFAULT_STATES.slice();
      this.stateAttribute = stateAttribute.replace(/^data-/, "");
      this.dataAttribute = `data-${this.stateAttribute}`;
      this.params = normalizeTimings(layoutParams);
      this._debug = debug2;
      const existing = this.readState();
      const existingIndex = existing ? this.states.indexOf(existing) : -1;
      this._stateIndex = existingIndex >= 0 ? existingIndex : 0;
      this.writeState(this.states[this._stateIndex]);
      this.baseDefaults = { gap: layoutGap, minColumnWidth };
      this.baseSections = this.composeSections(type, types, sections, this.baseDefaults);
      this.breakpoints = breakpoints.slice();
      if (this.breakpoints.length && typeof window !== "undefined") {
        const update = () => this.applyResponsiveLayout();
        window.addEventListener("resize", update, { passive: true });
        this.resizeCleanup = () => window.removeEventListener("resize", update);
        update();
      } else if (this.baseSections.length) {
        this.setSections(this.baseSections, this.baseDefaults);
      }
      try {
        this.auto = createLayout(this.root, this.params);
      } catch (error) {
        this.auto = null;
        this.warn(error);
      }
    }
    get disposed() {
      return this._disposed;
    }
    get stateIndex() {
      return this._stateIndex;
    }
    get state() {
      return this.states[this._stateIndex] ?? this.readState() ?? "";
    }
    get progress() {
      return this._progress;
    }
    get itemCount() {
      return this.items().length;
    }
    get layoutTypes() {
      return this._layoutTypes.slice();
    }
    get layoutCount() {
      return this._layoutTypes.length;
    }
    /** Replace the active webpage-layout composition. Existing inline styles are restored first. */
    setSections(sections, defaults2 = {}) {
      this.restoreWebLayouts();
      const resolvedDefaults = {
        gap: cssSize(defaults2.gap, "16px"),
        minColumnWidth: cssSize(defaults2.minColumnWidth, "240px")
      };
      for (const section of sections) {
        if (!WEB_LAYOUT_TYPES.includes(section.type)) throw new Error(`[pulse:layout] unknown webpage layout type: ${section.type}`);
        const element = section.target === this.root ? this.root : resolveRoot2(section.target);
        if (!element) {
          this.warn(new Error(`[pulse:layout] section root not found: ${String(section.target)}`));
          continue;
        }
        const snapshotElements = [element, ...Array.from(element.children).filter(isHTMLElement2)];
        snapshotElements.forEach((snapshotElement) => {
          if (!this.layoutSnapshots.some((entry) => entry.element === snapshotElement)) {
            this.layoutSnapshots.push({
              element: snapshotElement,
              styles: snapshotLayoutStyles(snapshotElement),
              type: snapshotElement.getAttribute("data-pulse-layout-type")
            });
          }
        });
        applyWebLayout(element, section, resolvedDefaults);
        this._layoutTypes.push(section.type);
      }
      return this;
    }
    /**
     * Animate the root between webpage layout presets while preserving the same DOM nodes.
     * Anime AutoLayout records the current geometry, the preset mutation runs once, then
     * transform-based FLIP motion carries every child to its new responsive position.
     */
    transitionTo(type, params = {}, options = {}) {
      if (!WEB_LAYOUT_TYPES.includes(type)) throw new Error(`[pulse:layout] unknown webpage layout type: ${type}`);
      const nextIndex = this.states.indexOf(type);
      return this.update(() => {
        if (nextIndex >= 0) this._stateIndex = nextIndex;
        this.writeState(type);
        this.setSections([{ target: this.root, type, ...options }], options);
      }, params);
    }
    /** Animate a nested multi-section composition change as one layout transaction. */
    transitionSections(sections, params = {}, defaults2 = {}) {
      return this.update(() => this.setSections(sections, defaults2), params);
    }
    items() {
      const children = this.params.children;
      if (typeof children === "string") {
        return Array.from(this.root.querySelectorAll(children)).filter(isHTMLElement2);
      }
      return Array.from(this.root.children).filter(isHTMLElement2);
    }
    record() {
      if (this._disposed || !this.auto) return null;
      try {
        return this.auto.record();
      } catch (error) {
        this.warn(error);
        return null;
      }
    }
    animate(params = {}) {
      if (this._disposed || !this.auto) return null;
      this.cancelLast();
      try {
        this.lastAnimation = this.auto.animate(this.animationParams(params));
        return this.lastAnimation;
      } catch (error) {
        this.warn(error);
        return null;
      }
    }
    update(mutator, params = {}) {
      if (this._disposed) return null;
      let didMutate = false;
      const run = () => {
        didMutate = true;
        mutator({ root: this.root, items: this.items(), layout: this });
      };
      this.cancelLast();
      if (!this.auto) {
        run();
        this.setProgress(1);
        return null;
      }
      try {
        this.lastAnimation = this.auto.update(() => run(), this.animationParams(params));
        this.setProgress(1);
        return this.lastAnimation;
      } catch (error) {
        this.warn(error);
        if (!didMutate) run();
        this.setProgress(1);
        return null;
      }
    }
    setState(state, params = {}) {
      const next = String(state);
      if (WEB_LAYOUT_TYPES.includes(next)) return this.transitionTo(next, params);
      const nextIndex = this.states.indexOf(next);
      if (next === this.readState()) return this.lastAnimation;
      this._stateIndex = nextIndex >= 0 ? nextIndex : this._stateIndex;
      return this.update(() => this.writeState(next), params);
    }
    setIndex(index, params = {}) {
      const nextIndex = wrapIndex2(index, this.states.length);
      const nextState = this.states[nextIndex];
      if (WEB_LAYOUT_TYPES.includes(nextState)) return this.transitionTo(nextState, params);
      if (nextIndex === this._stateIndex && this.readState() === this.states[nextIndex]) return this.lastAnimation;
      this._stateIndex = nextIndex;
      return this.update(() => this.writeState(this.states[nextIndex]), params);
    }
    cycle(step = 1, params = {}) {
      return this.setIndex(this._stateIndex + step, params);
    }
    shuffle(params = {}) {
      return this.update(({ root, items }) => {
        if (items.length < 2) return;
        const first = items.shift();
        if (first) root.appendChild(first);
      }, params);
    }
    setProgress(value) {
      const next = Math.max(0, Math.min(1, Number(value) || 0));
      this._progress = next;
      this.root.style.setProperty("--pulse-layout-progress", String(next));
    }
    revert() {
      this.cancelLast();
      try {
        this.auto?.revert();
      } catch (error) {
        this.warn(error);
      }
      this.restoreWebLayouts();
    }
    dispose() {
      if (this._disposed) return;
      this.revert();
      this.resizeCleanup?.();
      this.resizeCleanup = null;
      this._disposed = true;
    }
    animationParams(params) {
      return normalizeTimings({ ...DEFAULT_ANIMATION, ...params });
    }
    readState() {
      return this.root.getAttribute(this.dataAttribute);
    }
    writeState(state) {
      this.root.setAttribute(this.dataAttribute, state);
    }
    cancelLast() {
      const animation = this.lastAnimation;
      if (animation && typeof animation.cancel === "function") animation.cancel();
      this.lastAnimation = null;
    }
    warn(error) {
      if (this._debug && typeof console !== "undefined") console.warn("[pulse:layout]", error);
    }
    composeSections(type, types, sections, defaults2 = {}) {
      const composed = sections?.slice() ?? [];
      if (type) composed.unshift({ target: this.root, type, gap: defaults2.gap, minColumnWidth: defaults2.minColumnWidth });
      if (types?.length) {
        const children = Array.from(this.root.children).filter(isHTMLElement2);
        types.forEach((layoutType, index) => {
          if (children[index]) composed.push({ target: children[index], type: layoutType, gap: defaults2.gap, minColumnWidth: defaults2.minColumnWidth });
        });
      }
      return composed;
    }
    applyResponsiveLayout() {
      if (typeof window === "undefined") return;
      const width = window.innerWidth;
      const index = this.breakpoints.findIndex((entry) => (entry.minWidth === void 0 || width >= entry.minWidth) && (entry.maxWidth === void 0 || width <= entry.maxWidth));
      const key2 = index < 0 ? "base" : String(index);
      if (key2 === this.activeResponsiveKey) return;
      const isInitialLayout = this.activeResponsiveKey === "";
      this.activeResponsiveKey = key2;
      this.root.dataset.pulseLayoutBreakpoint = key2;
      if (index < 0) {
        if (isInitialLayout) this.setSections(this.baseSections, this.baseDefaults);
        else this.transitionSections(this.baseSections, {}, this.baseDefaults);
        return;
      }
      const match = this.breakpoints[index];
      const defaults2 = {
        gap: match.layoutGap ?? this.baseDefaults.gap,
        minColumnWidth: match.minColumnWidth ?? this.baseDefaults.minColumnWidth
      };
      const composed = this.composeSections(match.type, match.types, match.sections, defaults2);
      const nextSections = composed.length ? composed : this.baseSections;
      if (isInitialLayout) this.setSections(nextSections, defaults2);
      else this.transitionSections(nextSections, {}, defaults2);
    }
    restoreWebLayouts() {
      for (const snapshot of this.layoutSnapshots) {
        Object.entries(snapshot.styles).forEach(([property, state]) => {
          if (state.value) snapshot.element.style.setProperty(property, state.value, state.priority);
          else snapshot.element.style.removeProperty(property);
        });
        if (snapshot.type === null) snapshot.element.removeAttribute("data-pulse-layout-type");
        else snapshot.element.setAttribute("data-pulse-layout-type", snapshot.type);
      }
      this.layoutSnapshots = [];
      this._layoutTypes = [];
    }
  };
  var PulseLayoutAdapter = {
    test: (target) => Boolean(target?.__pulseLayout),
    props: () => ["stateIndex", "progress", "itemCount", "layoutCount"],
    get: (target, prop) => {
      if (prop === "stateIndex") return target.stateIndex;
      if (prop === "progress") return target.progress;
      if (prop === "itemCount") return target.itemCount;
      if (prop === "layoutCount") return target.layoutCount;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "stateIndex") target.setIndex(value);
      else if (prop === "progress") target.setProgress(value);
    },
    unit: () => ""
  };
  registerAdapter(PulseLayoutAdapter);
  function layout(root, params) {
    return new PulseLayout(root, params);
  }

  // src/grid/grid.ts
  function clamp4(value, min, max2) {
    return Math.max(min, Math.min(max2, Number(value) || 0));
  }
  function resolveRoot3(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:grid] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:grid] root not found: ${root}`);
      return el;
    }
    return root;
  }
  var PulseGrid = class {
    constructor(root, options = {}) {
      this.__pulseGrid = true;
      this.cells = [];
      this._rows = 3;
      this._cols = 3;
      this._progress = 0;
      this._phase = 0;
      this._gap = 8;
      this._spread = 0;
      this._wave = 0;
      this._scale = 1;
      this._rotate = 0;
      this._opacity = 1;
      this._stateIndex = 0;
      this._disposed = false;
      this.root = resolveRoot3(root);
      this.options = { ...options };
      this._rows = Math.max(1, Math.round(options.rows ?? 3));
      this._cols = Math.max(1, Math.round(options.cols ?? 3));
      this.root.classList.add("pulse-grid");
      this.root.style.display = "grid";
      this.root.style.setProperty("--pulse-grid-gap", `${this._gap}px`);
      this.root.style.gap = `var(--pulse-grid-gap)`;
      this.rebuild(options.create ?? this.root.children.length === 0);
      this.write();
    }
    get rows() {
      return this._rows;
    }
    get cols() {
      return this._cols;
    }
    get progress() {
      return this._progress;
    }
    get phase() {
      return this._phase;
    }
    get gap() {
      return this._gap;
    }
    get cellCount() {
      return this.cells.length;
    }
    get stateIndex() {
      return this._stateIndex;
    }
    setRows(rows) {
      this._rows = Math.max(1, Math.round(rows));
      this.rebuild(true);
    }
    setCols(cols) {
      this._cols = Math.max(1, Math.round(cols));
      this.rebuild(true);
    }
    setState(index) {
      this._stateIndex = Math.round(Number(index) || 0);
      this.root.dataset.gridState = String(this._stateIndex);
      const modes = ["matrix", "rings", "diagonal", "burst"];
      this.root.dataset.gridMode = modes[(this._stateIndex % modes.length + modes.length) % modes.length];
      this.write();
    }
    shuffle() {
      const nodes = this.cells.slice();
      for (let i = nodes.length - 1; i > 0; i--) {
        const j = Math.floor(((i + 1) * 9301 + this._stateIndex * 49297) % (i + 1));
        [nodes[i], nodes[j]] = [nodes[j], nodes[i]];
      }
      nodes.forEach((node) => this.root.appendChild(node));
      this.cells = nodes;
      this.markCells();
      this.write();
    }
    writeProp(prop, value) {
      if (prop === "rows") this.setRows(value);
      else if (prop === "cols") this.setCols(value);
      else if (prop === "progress") this._progress = clamp4(value, 0, 1);
      else if (prop === "phase") this._phase = Number(value) || 0;
      else if (prop === "gap") this._gap = Math.max(0, Number(value) || 0);
      else if (prop === "spread") this._spread = Number(value) || 0;
      else if (prop === "wave") this._wave = Number(value) || 0;
      else if (prop === "scale") this._scale = Math.max(0.02, Number(value) || 0);
      else if (prop === "rotate") this._rotate = Number(value) || 0;
      else if (prop === "opacity") this._opacity = clamp4(value, 0, 1);
      else if (prop === "stateIndex") this.setState(value);
      this.write();
    }
    refresh() {
      this.cells = Array.from(this.root.children).filter((el) => el instanceof HTMLElement);
      this.markCells();
      this.write();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.cells.forEach((cell) => {
        cell.style.transform = "";
        cell.style.opacity = "";
        delete cell.dataset.gridIndex;
        delete cell.dataset.gridRow;
        delete cell.dataset.gridCol;
      });
    }
    rebuild(create) {
      const total = this._rows * this._cols;
      this.root.style.gridTemplateColumns = `repeat(${this._cols}, minmax(0, 1fr))`;
      this.root.style.gridTemplateRows = `repeat(${this._rows}, minmax(0, 1fr))`;
      if (create) {
        this.root.innerHTML = "";
        for (let i = 0; i < total; i++) {
          const cell = document.createElement("i");
          cell.className = this.options.cellClass ?? "pulse-grid-cell";
          cell.textContent = this.options.label ? this.options.label(i) : String(i + 1);
          this.root.appendChild(cell);
        }
      }
      this.refresh();
    }
    markCells() {
      this.cells.forEach((cell, index) => {
        const row = Math.floor(index / this._cols);
        const col = index % this._cols;
        cell.dataset.gridIndex = String(index);
        cell.dataset.gridRow = String(row);
        cell.dataset.gridCol = String(col);
        cell.style.setProperty("--grid-i", String(index));
        cell.style.setProperty("--grid-r", String(row));
        cell.style.setProperty("--grid-c", String(col));
      });
    }
    write() {
      this.root.style.setProperty("--pulse-grid-progress", String(this._progress));
      this.root.style.setProperty("--pulse-grid-phase", String(this._phase));
      this.root.style.setProperty("--pulse-grid-gap", `${this._gap}px`);
      const cx = (this._cols - 1) / 2;
      const cy = (this._rows - 1) / 2;
      const maxDist = Math.max(1, Math.hypot(cx, cy));
      this.cells.forEach((cell, index) => {
        const row = Math.floor(index / this._cols);
        const col = index % this._cols;
        const dx = col - cx;
        const dy = row - cy;
        const dist = Math.hypot(dx, dy) / maxDist;
        const wave = Math.sin((dist + this._phase) * Math.PI * 2) * this._wave;
        const local = clamp4(this._progress - dist * 0.3, 0, 1);
        const x = dx * this._spread * local;
        const y = dy * this._spread * local + wave;
        const scale = this._scale + wave * 5e-3;
        const rotate = this._rotate * (dx || dy || 1) * 0.2;
        cell.style.setProperty("--grid-local", String(local));
        cell.style.transform = `translate(${x.toFixed(2)}px, ${y.toFixed(2)}px) rotate(${rotate.toFixed(2)}deg) scale(${scale.toFixed(3)})`;
        cell.style.opacity = String(clamp4(this._opacity * (0.45 + local * 0.55), 0, 1));
      });
    }
  };
  var PulseGridAdapter = {
    test: (target) => Boolean(target?.__pulseGrid),
    props: () => ["progress", "phase", "rows", "cols", "cellCount", "gap", "spread", "wave", "scale", "rotate", "opacity", "stateIndex"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "phase") return target.phase;
      if (prop === "rows") return target.rows;
      if (prop === "cols") return target.cols;
      if (prop === "cellCount") return target.cellCount;
      if (prop === "gap") return target.gap;
      if (prop === "stateIndex") return target.stateIndex;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "rotate" ? "deg" : prop === "scale" || prop === "opacity" || prop === "progress" || prop === "phase" || prop === "rows" || prop === "cols" || prop === "cellCount" || prop === "stateIndex" ? "" : "px"
  };
  registerAdapter(PulseGridAdapter);
  function grid(root, params) {
    return new PulseGrid(root, params);
  }

  // src/magnet/magnet.ts
  function clamp5(value, min, max2) {
    return Math.max(min, Math.min(max2, Number(value) || 0));
  }
  function resolveRoot4(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:magnet] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:magnet] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function collectTargets(root, targets) {
    if (!targets) return Array.from(root.children).filter((el) => el instanceof HTMLElement);
    if (typeof targets === "string") return Array.from(root.querySelectorAll(targets)).filter((el) => el instanceof HTMLElement);
    return Array.from(targets).filter((el) => el instanceof HTMLElement);
  }
  var PulseMagnet = class {
    constructor(root, options = {}) {
      this.__pulseMagnet = true;
      this.targets = [];
      this._pointerX = 50;
      this._pointerY = 50;
      this._strength = 28;
      this._radius = 120;
      this._polarity = 1;
      this._progress = 1;
      this._falloff = 1;
      this._disposed = false;
      this.boundMove = (event) => {
        const rect = this.root.getBoundingClientRect();
        const x = rect.width ? (event.clientX - rect.left) / rect.width * 100 : 50;
        const y = rect.height ? (event.clientY - rect.top) / rect.height * 100 : 50;
        this.setPointer(x, y);
      };
      this.root = resolveRoot4(root);
      this.root.classList.add("pulse-magnet");
      this._strength = options.strength ?? this._strength;
      this._radius = options.radius ?? this._radius;
      this._polarity = options.polarity ?? this._polarity;
      this.targets = collectTargets(this.root, options.targets);
      this.markTargets();
      if (options.bindPointer) this.bind();
      this.write();
    }
    get pointerX() {
      return this._pointerX;
    }
    get pointerY() {
      return this._pointerY;
    }
    get strength() {
      return this._strength;
    }
    get radius() {
      return this._radius;
    }
    get polarity() {
      return this._polarity;
    }
    get progress() {
      return this._progress;
    }
    get targetCount() {
      return this.targets.length;
    }
    bind() {
      this.root.addEventListener("pointermove", this.boundMove);
      return this;
    }
    unbind() {
      this.root.removeEventListener("pointermove", this.boundMove);
      return this;
    }
    setPointer(x, y) {
      this._pointerX = clamp5(x, 0, 100);
      this._pointerY = clamp5(y, 0, 100);
      this.write();
    }
    refresh() {
      this.targets = collectTargets(this.root);
      this.markTargets();
      this.write();
      return this;
    }
    writeProp(prop, value) {
      if (prop === "pointerX") this._pointerX = clamp5(value, 0, 100);
      else if (prop === "pointerY") this._pointerY = clamp5(value, 0, 100);
      else if (prop === "strength") this._strength = Number(value) || 0;
      else if (prop === "radius") this._radius = Math.max(1, Number(value) || 1);
      else if (prop === "polarity") this._polarity = Number(value) || 0;
      else if (prop === "progress") this._progress = clamp5(value, 0, 1);
      else if (prop === "falloff") this._falloff = Math.max(0.05, Number(value) || 0.05);
      this.write();
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.unbind();
      this.targets.forEach((target) => {
        target.style.transform = "";
        target.style.opacity = "";
        delete target.dataset.magnetIndex;
      });
    }
    markTargets() {
      this.targets.forEach((target, index) => {
        target.dataset.magnetIndex = String(index);
        target.style.willChange = `${target.style.willChange ? `${target.style.willChange}, ` : ""}transform, opacity`;
      });
    }
    write() {
      this.root.style.setProperty("--pulse-magnet-x", `${this._pointerX}%`);
      this.root.style.setProperty("--pulse-magnet-y", `${this._pointerY}%`);
      this.root.style.setProperty("--pulse-magnet-progress", String(this._progress));
      const rect = this.root.getBoundingClientRect();
      const px = rect.width * (this._pointerX / 100);
      const py = rect.height * (this._pointerY / 100);
      this.targets.forEach((target) => {
        const tRect = target.getBoundingClientRect();
        const cx = tRect.left - rect.left + tRect.width / 2;
        const cy = tRect.top - rect.top + tRect.height / 2;
        const dx = px - cx;
        const dy = py - cy;
        const dist = Math.max(1e-3, Math.hypot(dx, dy));
        const pull = Math.pow(clamp5(1 - dist / this._radius, 0, 1), this._falloff) * this._strength * this._polarity * this._progress;
        const nx = dx / dist;
        const ny = dy / dist;
        const rotate = (nx - ny) * pull * 0.35;
        const scale = 1 + Math.abs(pull) * 6e-3;
        target.style.transform = `translate(${(nx * pull).toFixed(2)}px, ${(ny * pull).toFixed(2)}px) rotate(${rotate.toFixed(2)}deg) scale(${scale.toFixed(3)})`;
        target.style.opacity = String(0.62 + clamp5(Math.abs(pull) / Math.max(1, Math.abs(this._strength)), 0, 1) * 0.38);
      });
    }
  };
  var PulseMagnetAdapter = {
    test: (target) => Boolean(target?.__pulseMagnet),
    props: () => ["pointerX", "pointerY", "strength", "radius", "polarity", "progress", "falloff", "targetCount"],
    get: (target, prop) => {
      if (prop === "pointerX") return target.pointerX;
      if (prop === "pointerY") return target.pointerY;
      if (prop === "strength") return target.strength;
      if (prop === "radius") return target.radius;
      if (prop === "polarity") return target.polarity;
      if (prop === "progress") return target.progress;
      if (prop === "targetCount") return target.targetCount;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "radius" || prop === "strength" ? "px" : ""
  };
  registerAdapter(PulseMagnetAdapter);
  function magnet(root, params) {
    return new PulseMagnet(root, params);
  }

  // src/camera/camera.ts
  function resolveRoot5(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:camera] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:camera] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function resolveTarget2(root, target) {
    if (typeof target === "string") {
      const el = root.querySelector(target) ?? (typeof document !== "undefined" ? document.querySelector(target) : null);
      if (el instanceof HTMLElement) return el;
    } else if (target instanceof HTMLElement) {
      return target;
    }
    const first = root.firstElementChild;
    return first instanceof HTMLElement ? first : root;
  }
  var PulseCamera = class {
    constructor(root, options = {}) {
      this.__pulseCamera = true;
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._zoom = 1;
      this._rotate = 0;
      this._tilt = 0;
      this._yaw = 0;
      this._focus = 0;
      this._shake = 0;
      this._progress = 0;
      this._perspective = 700;
      this._disposed = false;
      this.root = resolveRoot5(root);
      this.target = resolveTarget2(this.root, options.target);
      this._perspective = options.perspective ?? this._perspective;
      this.root.classList.add("pulse-camera");
      this.root.style.perspective = `${this._perspective}px`;
      this.root.style.overflow = this.root.style.overflow || "hidden";
      this.target.style.transformStyle = "preserve-3d";
      this.target.style.willChange = `${this.target.style.willChange ? `${this.target.style.willChange}, ` : ""}transform, filter`;
      this.write();
    }
    get x() {
      return this._x;
    }
    get y() {
      return this._y;
    }
    get z() {
      return this._z;
    }
    get zoom() {
      return this._zoom;
    }
    get rotate() {
      return this._rotate;
    }
    get tilt() {
      return this._tilt;
    }
    get yaw() {
      return this._yaw;
    }
    get focus() {
      return this._focus;
    }
    get shake() {
      return this._shake;
    }
    get progress() {
      return this._progress;
    }
    get perspective() {
      return this._perspective;
    }
    lookAt(el) {
      const rootRect = this.root.getBoundingClientRect();
      const targetRect = el.getBoundingClientRect();
      this._x = targetRect.left - rootRect.left + targetRect.width / 2 - rootRect.width / 2;
      this._y = targetRect.top - rootRect.top + targetRect.height / 2 - rootRect.height / 2;
      this.write();
      return this;
    }
    writeProp(prop, value) {
      if (prop === "x") this._x = Number(value) || 0;
      else if (prop === "y") this._y = Number(value) || 0;
      else if (prop === "z") this._z = Number(value) || 0;
      else if (prop === "zoom") this._zoom = Math.max(0.05, Number(value) || 0.05);
      else if (prop === "rotate") this._rotate = Number(value) || 0;
      else if (prop === "tilt") this._tilt = Number(value) || 0;
      else if (prop === "yaw") this._yaw = Number(value) || 0;
      else if (prop === "focus") this._focus = Math.max(0, Number(value) || 0);
      else if (prop === "shake") this._shake = Number(value) || 0;
      else if (prop === "progress") this._progress = Math.max(0, Math.min(1, Number(value) || 0));
      else if (prop === "perspective") this._perspective = Math.max(1, Number(value) || 1);
      this.write();
    }
    refresh() {
      this.write();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.target.style.transform = "";
      this.target.style.filter = "";
    }
    write() {
      const shakeX = Math.sin(this._progress * Math.PI * 12.9898) * this._shake;
      const shakeY = Math.cos(this._progress * Math.PI * 9.233) * this._shake;
      this.root.style.perspective = `${this._perspective}px`;
      this.root.style.setProperty("--pulse-camera-progress", String(this._progress));
      this.root.style.setProperty("--pulse-camera-focus", String(this._focus));
      this.target.style.transform = [
        `translate3d(${(-this._x + shakeX).toFixed(2)}px, ${(-this._y + shakeY).toFixed(2)}px, ${this._z.toFixed(2)}px)`,
        `scale(${this._zoom.toFixed(4)})`,
        `rotate(${this._rotate.toFixed(2)}deg)`,
        `rotateX(${this._tilt.toFixed(2)}deg)`,
        `rotateY(${this._yaw.toFixed(2)}deg)`
      ].join(" ");
      this.target.style.filter = this._focus ? `blur(${this._focus.toFixed(2)}px)` : "";
    }
  };
  var PulseCameraAdapter = {
    test: (target) => Boolean(target?.__pulseCamera),
    props: () => ["x", "y", "z", "zoom", "rotate", "tilt", "yaw", "focus", "shake", "progress", "perspective"],
    get: (target, prop) => {
      if (prop === "x") return target.x;
      if (prop === "y") return target.y;
      if (prop === "z") return target.z;
      if (prop === "zoom") return target.zoom;
      if (prop === "rotate") return target.rotate;
      if (prop === "tilt") return target.tilt;
      if (prop === "yaw") return target.yaw;
      if (prop === "focus") return target.focus;
      if (prop === "shake") return target.shake;
      if (prop === "progress") return target.progress;
      if (prop === "perspective") return target.perspective;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "rotate" || prop === "tilt" || prop === "yaw" ? "deg" : prop === "zoom" || prop === "progress" ? "" : "px"
  };
  registerAdapter(PulseCameraAdapter);
  function camera(root, params) {
    return new PulseCamera(root, params);
  }

  // src/events/events.ts
  function resolveEl(value) {
    if (!value) return void 0;
    if (typeof value === "string") {
      if (typeof document === "undefined") return void 0;
      const el = document.querySelector(value);
      return el instanceof HTMLElement ? el : void 0;
    }
    return value;
  }
  function clamp013(value) {
    return Math.max(0, Math.min(1, Number(value) || 0));
  }
  var PulseEvents = class {
    constructor(options = {}) {
      this.__pulseEvents = true;
      this.observer = null;
      this.listeners = /* @__PURE__ */ new Map();
      this._progress = 0;
      this._velocity = 0;
      this._scroll = 0;
      this._backward = false;
      this._active = 0;
      this._eventCount = 0;
      this._disposed = false;
      this.options = { ...options };
      if (!options.manual) this.createObserver();
    }
    get progress() {
      return this.observer ? this.observer.progress : this._progress;
    }
    get velocity() {
      return this.observer ? this.observer.velocity : this._velocity;
    }
    get scroll() {
      return this.observer ? this.observer.scroll : this._scroll;
    }
    get backward() {
      return this.observer ? this.observer.backward : this._backward;
    }
    get active() {
      return this._active;
    }
    get eventCount() {
      return this._eventCount;
    }
    on(name, listener) {
      if (!this.listeners.has(name)) this.listeners.set(name, /* @__PURE__ */ new Set());
      this.listeners.get(name).add(listener);
      return this;
    }
    off(name, listener) {
      this.listeners.get(name)?.delete(listener);
      return this;
    }
    emit(name) {
      this._eventCount++;
      this.options.onEvent?.(name, this);
      this.listeners.get(name)?.forEach((listener) => listener(this, name));
      this.listeners.get("manual")?.forEach((listener) => listener(this, name));
      return this;
    }
    link(linked) {
      if (this.observer && typeof this.observer.link === "function") this.observer.link(linked);
      return this;
    }
    setProgress(value) {
      const previous = this._progress;
      const next = clamp013(value);
      this._backward = next < previous;
      this._velocity = next - previous;
      this._scroll = next * 100;
      this._progress = next;
      this._active = next > 0 && next < 1 ? 1 : 0;
      if (previous <= 0 && next > 0) this.emit(this._backward ? "enterBackward" : "enterForward").emit("enter");
      if (previous < 1 && next >= 1) this.emit(this._backward ? "leaveBackward" : "leaveForward").emit("leave");
      this.emit("update");
    }
    writeProp(prop, value) {
      if (prop === "progress") this.setProgress(value);
      else if (prop === "velocity") this._velocity = Number(value) || 0;
      else if (prop === "scroll") this._scroll = Number(value) || 0;
      else if (prop === "active") this._active = value >= 0.5 ? 1 : 0;
    }
    refresh() {
      try {
        this.observer?.refresh();
        this.emit("resize");
      } catch (error) {
        this.warn(error);
      }
      return this;
    }
    revert() {
      try {
        this.observer?.revert();
      } catch (error) {
        this.warn(error);
      }
      this.observer = null;
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.revert();
      this.listeners.clear();
    }
    createObserver() {
      if (typeof document === "undefined" || typeof window === "undefined") return;
      try {
        const params = this.toAnimeParams();
        this.observer = onScroll(params);
      } catch (error) {
        this.observer = null;
        this.warn(error);
      }
    }
    toAnimeParams() {
      const {
        manual: _manual,
        onEvent: _onEvent,
        target,
        container,
        debug: debug2,
        ...rest
      } = this.options;
      return {
        ...rest,
        target: resolveEl(target) ?? target,
        container: resolveEl(container) ?? container,
        debug: debug2,
        onEnter: () => {
          this._active = 1;
          this.emit("enter");
        },
        onLeave: () => {
          this._active = 0;
          this.emit("leave");
        },
        onEnterForward: () => this.emit("enterForward"),
        onLeaveForward: () => this.emit("leaveForward"),
        onEnterBackward: () => this.emit("enterBackward"),
        onLeaveBackward: () => this.emit("leaveBackward"),
        onUpdate: () => {
          this._progress = this.observer?.progress ?? this._progress;
          this._velocity = this.observer?.velocity ?? this._velocity;
          this._scroll = this.observer?.scroll ?? this._scroll;
          this._backward = this.observer?.backward ?? this._backward;
          this.emit("update");
        },
        onResize: () => this.emit("resize"),
        onSyncComplete: () => this.emit("syncComplete")
      };
    }
    warn(error) {
      if (this.options.debug && typeof console !== "undefined") console.warn("[pulse:events]", error);
    }
  };
  var PulseEventsAdapter = {
    test: (target) => Boolean(target?.__pulseEvents),
    props: () => ["progress", "velocity", "scroll", "backward", "active", "eventCount"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "velocity") return target.velocity;
      if (prop === "scroll") return target.scroll;
      if (prop === "backward") return target.backward ? 1 : 0;
      if (prop === "active") return target.active;
      if (prop === "eventCount") return target.eventCount;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: () => ""
  };
  registerAdapter(PulseEventsAdapter);
  function events(params) {
    return new PulseEvents(params);
  }

  // src/mask/mask.ts
  var num = (v, d = 0) => v == null ? d : Number(v);
  var PulseMask = class {
    constructor(_engine) {
      this.defs = /* @__PURE__ */ new Map();
      this.injected = false;
      this.registerDefaults();
    }
    // ---- builders (chainable) ------------------------------------------------
    gradient(name, o = {}) {
      this.defs.set(name, { kind: "gradient", opts: o });
      return this;
    }
    radial(name, o = {}) {
      this.defs.set(name, { kind: "radial", opts: o });
      return this;
    }
    scanlines(name, o = {}) {
      this.defs.set(name, { kind: "scanlines", opts: { gap: 6, thickness: 1, ...o } });
      return this;
    }
    slices(name, o = {}) {
      this.defs.set(name, { kind: "slices", opts: { count: 8, max: 12, seed: 5, ...o } });
      return this;
    }
    shine(name = "shine", o = {}) {
      this.defs.set(name, { kind: "shine", opts: { angle: 120, width: 22, softness: 0.4, ...o } });
      return this;
    }
    noise(name, o = {}) {
      this.defs.set(name, { kind: "noise", opts: { freq: 0.82, oct: 2, seed: 7, contrast: 0.62, bright: 0.18, ...o } });
      return this;
    }
    turbulence(name, o = {}) {
      this.defs.set(name, { kind: "turbulence", opts: { freq: "0.02 0.05", oct: 2, seed: 3, strength: 18, ...o } });
      return this;
    }
    ripple(name = "water", o = {}) {
      this.defs.set(name, { kind: "ripple", opts: { freq: "0.02 0.05", oct: 2, seed: 3, strength: 18, ...o } });
      return this;
    }
    displacement(name, o = {}) {
      this.defs.set(name, { kind: "displacement", opts: { freq: 0.05, oct: 2, seed: 5, strength: 12, ...o } });
      return this;
    }
    fracture(name, o = {}) {
      this.defs.set(name, { kind: "fracture", opts: { seed: 12, points: 18, crackWidth: 3, jitter: 0.45, ...o } });
      return this;
    }
    pattern(name, o = {}) {
      this.defs.set(name, { kind: "pattern", opts: o });
      return this;
    }
    has(name) {
      return this.defs.has(name);
    }
    names() {
      return [...this.defs.keys()];
    }
    // ---- realize ------------------------------------------------------------
    /** CSS `filter: url(#pm-{name})` for filter-kind masks. */
    filter(name) {
      const d = this.defs.get(name);
      if (!d || !["noise", "turbulence", "ripple", "displacement"].includes(d.kind)) return "";
      return `url(#pm-${name})`;
    }
    /** CSS `background-image: url(#pm-pat-{name})` for pattern masks. */
    patternURL(name) {
      const d = this.defs.get(name);
      if (!d || d.kind !== "pattern") return "";
      return `url(#pm-pat-${name})`;
    }
    /** CSS `mask-image: url(#pm-mask-{name})` for mask-kind (fracture/slices/scanlines). */
    maskURL(name) {
      const d = this.defs.get(name);
      if (!d || !["fracture", "slices", "scanlines", "radial", "gradient"].includes(d.kind)) return "";
      return `url(#pm-mask-${name})`;
    }
    /** CSS background-string for gradient/shine/radial/scanlines masks. */
    background(name) {
      const d = this.defs.get(name);
      if (!d) return "";
      const o = d.opts;
      if (d.kind === "gradient" || d.kind === "shine") {
        const a = num(o.angle, 120), w = num(o.width, 22), s = num(o.softness, 0.4);
        const peak = Math.min(1, s);
        return `linear-gradient(${a}deg, transparent 0%, rgba(255,255,255,0) calc(var(--shine-x,0%) - ${w}%), rgba(255,255,255,${peak}) var(--shine-x,0%), rgba(255,255,255,0) calc(var(--shine-x,0%) + ${w}%), transparent 100%)`;
      }
      if (d.kind === "radial") {
        const x = o.x ?? 50, y = o.y ?? 50, c = o.color || "rgba(255,255,255,.9)";
        return `radial-gradient(circle at ${x}% ${y}%, ${c}, transparent ${num(o.falloff, 60)}%)`;
      }
      if (d.kind === "scanlines") {
        const g = num(o.gap, 6), t = num(o.thickness, 1), col = o.color || "rgba(255,255,255,.4)";
        return `repeating-linear-gradient(to bottom, ${col} 0px, ${col} ${t}px, transparent ${t}px, transparent ${g}px)`;
      }
      return "";
    }
    /** Generated data URL (canvas if available, else inline SVG) for sparkle/noise. */
    dataURL(name) {
      const d = this.defs.get(name);
      if (!d) return "";
      if (d.kind === "noise") return this.noiseData(d.opts);
      return "";
    }
    /** Apply a mask to an element: picks mask-image / filter / pattern / background by kind. */
    apply(el, name) {
      const d = this.defs.get(name);
      if (!d) return "";
      if (["fracture", "slices", "scanlines", "radial", "gradient"].includes(d.kind)) {
        el.style.maskImage = this.maskURL(name);
        return this.maskURL(name);
      }
      if (d.kind === "pattern") {
        el.style.backgroundImage = this.patternURL(name);
        return this.patternURL(name);
      }
      if (d.kind === "gradient" || d.kind === "shine" || d.kind === "radial") {
        el.style.background = this.background(name);
        return this.background(name);
      }
      el.style.filter = this.filter(name);
      return this.filter(name);
    }
    /** Inject all SVG filter/pattern/mask defs into a root document once. */
    // SAFE: svg is built solely from internal `defs` (mask builder opts), never
    // from user/DOM/external input — no XSS surface. If external opt strings are
    // ever added, sanitize first.
    ensureInto(root = typeof document !== "undefined" ? document : null) {
      if (!root || this.injected) return this.injected;
      const svg2 = this.buildSVG();
      if (!svg2) return false;
      try {
        if (root.body) root.body.insertAdjacentHTML("beforeend", svg2);
        else root.insertAdjacentHTML("beforeend", svg2);
        this.injected = true;
        return true;
      } catch {
        return false;
      }
    }
    // ---- internals ----------------------------------------------------------
    registerDefaults() {
      this.noise("static", { freq: 0.82, oct: 2, seed: 7, contrast: 0.62, bright: 0.18 });
      this.noise("diamond-grain", { freq: 0.9, oct: 2, seed: 3, contrast: 0.9, bright: 0.1 });
      this.noise("brushed", { freq: "0.012 0.85", oct: 2, seed: 11, contrast: 0.5, bright: 0.32 });
      this.noise("glass-grain", { freq: 0.6, oct: 2, seed: 5, contrast: 0.28, bright: 0.42 });
      this.turbulence("water", { freq: "0.02 0.05", oct: 2, seed: 3, strength: 18 });
      this.displacement("heat", { freq: "0.01 0.05", oct: 2, seed: 9, strength: 11 });
      this.displacement("glitch", { freq: "0.25 0.015", oct: 1, seed: 4, strength: 7 });
      this.displacement("glass", { freq: "0.008 0.03", oct: 2, seed: 6, strength: 5 });
      this.radial("glow", { x: 50, y: 50, color: "rgba(255,255,255,.92)", falloff: 58 });
      this.scanlines("scan", { gap: 6, thickness: 1 });
      this.slices("glitch-slices", { count: 8, max: 12, seed: 4 });
      this.fracture("cracks", { seed: 12, points: 18, crackWidth: 3, jitter: 0.45 });
      this.shine("shine", { angle: 120, width: 22, softness: 0.4 });
      this.pattern("facets", {
        w: 120,
        h: 104,
        rotate: 8,
        polys: [
          "0,0 60,0 30,52|#1a1a22",
          "60,0 120,0 90,46 30,52|#2c2c38",
          "0,0 30,52 0,104|#15151c",
          "30,52 90,46 60,104 0,104|#23232e",
          "90,46 120,0 120,104 60,104|#33333f",
          "90,46 60,104 120,104|#1f1f28",
          "30,52 90,46 60,52|#3d3d4a"
        ]
      });
    }
    buildSVG() {
      const filters = [];
      const patterns = [];
      const masks = [];
      for (const [name, def] of this.defs) {
        if (def.kind === "noise") {
          const o = def.opts;
          filters.push(`<filter id="pm-${name}" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="${o.freq}" numOctaves="${o.oct}" stitchTiles="stitch" seed="${o.seed}" result="n"/><feColorMatrix in="n" type="matrix" values="0 0 0 0 ${o.bright}  0 0 0 0 ${o.bright}  0 0 0 0 ${num(o.bright) + 0.04}  0 0 0 ${o.contrast} ${-num(o.contrast) * 0.18}"/></filter>`);
        } else if (def.kind === "turbulence" || def.kind === "ripple") {
          const o = def.opts;
          filters.push(`<filter id="pm-${name}" x="-20%" y="-20%" width="140%" height="140%"><feTurbulence type="turbulence" baseFrequency="${o.freq}" numOctaves="${o.oct}" seed="${o.seed}" result="noise"/><feDisplacementMap in="SourceGraphic" in2="noise" scale="${o.strength}" xChannelSelector="R" yChannelSelector="G"/></filter>`);
        } else if (def.kind === "displacement") {
          const o = def.opts;
          filters.push(`<filter id="pm-${name}" x="-20%" y="-20%" width="140%" height="140%"><feTurbulence type="fractalNoise" baseFrequency="${o.freq}" numOctaves="${o.oct}" seed="${o.seed}" result="noise"/><feDisplacementMap in="SourceGraphic" in2="noise" scale="${o.strength}" xChannelSelector="R" yChannelSelector="G"/></filter>`);
        } else if (def.kind === "pattern") {
          const o = def.opts;
          const polys = (o.polys || []).map((p) => {
            const [pts, fill] = p.split("|");
            return `<polygon points="${pts}" fill="${fill}"/>`;
          }).join("");
          patterns.push(`<pattern id="pm-pat-${name}" width="${o.w}" height="${o.h}" patternUnits="userSpaceOnUse" patternTransform="rotate(${o.rotate || 0})"><rect width="${o.w}" height="${o.h}" fill="#0c0c12"/>${polys}</pattern>`);
        } else if (def.kind === "radial" || def.kind === "gradient" || def.kind === "scanlines" || def.kind === "slices" || def.kind === "fracture") {
          if (def.kind === "radial" || def.kind === "gradient") {
            const o = def.opts;
            const stops = def.kind === "radial" ? `<stop offset="0%" stop-color="${o.color || "rgba(255,255,255,.92)"}"/><stop offset="${num(o.falloff, 60)}%" stop-color="rgba(0,0,0,1)"/>` : `<stop offset="0%" stop-color="rgba(0,0,0,1)"/><stop offset="30%" stop-color="rgba(0,0,0,1)"/><stop offset="50%" stop-color="rgba(255,255,255,1)"/><stop offset="100%" stop-color="rgba(0,0,0,1)"/>`;
            const gradTag = def.kind === "radial" ? `<radialGradient id="pm-bg-${name}" cx="${o.x ?? 50}%" cy="${o.y ?? 50}%" r="50%">${stops}</radialGradient>` : `<linearGradient id="pm-bg-${name}">${stops}</linearGradient>`;
            masks.push(`<mask id="pm-mask-${name}"><rect width="100%" height="100%" fill="url(#pm-bg-${name})"/></mask>${gradTag}`);
          } else if (def.kind === "scanlines") {
            const o = def.opts;
            masks.push(`<mask id="pm-mask-${name}"><rect width="100%" height="100%" fill="url(#pm-bg-${name})"/></mask><pattern id="pm-bg-${name}" width="100%" height="${num(o.gap, 6)}" patternUnits="userSpaceOnUse"><rect width="100%" height="${num(o.thickness, 1)}" fill="white"/></pattern>`);
          } else {
            const o = def.opts;
            const lines = def.kind === "fracture" ? this.fracturePaths(o).map((p) => `<path d="${p}" stroke="white" stroke-width="${o.crackWidth}" fill="none"/>`).join("") : Array.from({ length: num(o.count, 8) }, (_, i) => {
              const y = (i + 0.5) / num(o.count, 8) * 100;
              const off = (Math.sin(i * 12.9 + num(o.seed, 5)) * 43758.5453 % 1 + 1) % 1 * num(o.max, 12);
              return `<rect x="0" y="${y}%" width="100%" height="2" fill="white" transform="translate(${off})"/>`;
            }).join("");
            masks.push(`<mask id="pm-mask-${name}"><rect width="100%" height="100%" fill="black"/>${lines}</mask>`);
          }
        }
      }
      if (!filters.length && !patterns.length && !masks.length) return "";
      return `<svg id="pulse-mask-defs" class="pulse-mask-defs" width="0" height="0" style="position:absolute" aria-hidden="true"><defs>${filters.join("")}${patterns.join("")}${masks.join("")}</defs></svg>`;
    }
    fracturePaths(o) {
      const pts = num(o.points, 18), jit = num(o.jitter, 0.45), seed = num(o.seed, 12);
      const rnd = (n) => {
        const x = Math.sin(n * 12.9898 + seed * 78.233) * 43758.5453;
        return x - Math.floor(x);
      };
      const verts = Array.from({ length: pts }, (_, i) => [rnd(i) * 100, rnd(i + pts) * 100]);
      const paths = [];
      for (let i = 1; i < pts; i++) {
        const a = verts[i - 1], b = verts[i];
        const mx = (a[0] + b[0]) / 2 + (rnd(i * 3) - 0.5) * jit * 100;
        const my = (a[1] + b[1]) / 2 + (rnd(i * 3 + 1) - 0.5) * jit * 100;
        paths.push(`M${a[0].toFixed(1)} ${a[1].toFixed(1)} L${mx.toFixed(1)} ${my.toFixed(1)} L${b[0].toFixed(1)} ${b[1].toFixed(1)}`);
      }
      return paths;
    }
    // canvas if available, else inline SVG dataURI — never a file
    noiseData(o) {
      const size = num(o.size, 128);
      try {
        const c = typeof document !== "undefined" ? document.createElement("canvas") : null;
        const ctx = c?.getContext?.("2d");
        if (c && ctx) {
          c.width = c.height = size;
          const img = ctx.createImageData(size, size);
          for (let i = 0; i < img.data.length; i += 4) {
            const v = Math.random() * 255 | 0;
            img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
            img.data[i + 3] = 255;
          }
          ctx.putImageData(img, 0, 0);
          return c.toDataURL("image/png");
        }
      } catch {
      }
      const freq = num(o.freq, 0.82);
      return `data:image/svg+xml;utf8,` + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}"><filter id="n"><feTurbulence type="fractalNoise" baseFrequency="${freq}" numOctaves="2"/></filter><rect width="100%" height="100%" filter="url(#n)"/></svg>`);
    }
  };
  var mask = (engine2) => new PulseMask(engine2);

  // src/mask/mask-layer.ts
  function resolveRoot6(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:mask-layer] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:mask-layer] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function clamp014(value) {
    return Math.max(0, Math.min(1, Number(value) || 0));
  }
  var PulseMaskLayer = class {
    constructor(root, name = "shine", options = {}) {
      this.__pulseMaskLayer = true;
      this._progress = 0;
      this._x = 50;
      this._y = 50;
      this._scale = 1;
      this._opacity = 1;
      this._feather = 0;
      this._blur = 0;
      this._rotate = 0;
      this._shine = 0.45;
      this._grain = 0;
      this._intensity = 1;
      this._modeIndex = 0;
      this._disposed = false;
      this.root = resolveRoot6(root);
      this.mask = options.mask ?? new PulseMask(null);
      this.name = name;
      this.root.classList.add("pulse-mask-layer");
      if (options.className) this.root.classList.add(options.className);
      this.root.style.position = this.root.style.position || "relative";
      this.root.style.overflow = this.root.style.overflow || "hidden";
      this.root.style.isolation = this.root.style.isolation || "isolate";
      this.applyMask();
      this.write();
    }
    get progress() {
      return this._progress;
    }
    get x() {
      return this._x;
    }
    get y() {
      return this._y;
    }
    get scale() {
      return this._scale;
    }
    get opacity() {
      return this._opacity;
    }
    get feather() {
      return this._feather;
    }
    get blur() {
      return this._blur;
    }
    get rotate() {
      return this._rotate;
    }
    get shine() {
      return this._shine;
    }
    get grain() {
      return this._grain;
    }
    get intensity() {
      return this._intensity;
    }
    get modeIndex() {
      return this._modeIndex;
    }
    setMask(name) {
      this.name = name;
      this.applyMask();
      this.write();
      return this;
    }
    writeProp(prop, value) {
      if (prop === "progress") this._progress = clamp014(value);
      else if (prop === "x") this._x = Number(value) || 0;
      else if (prop === "y") this._y = Number(value) || 0;
      else if (prop === "scale") this._scale = Math.max(0.01, Number(value) || 0.01);
      else if (prop === "opacity") this._opacity = clamp014(value);
      else if (prop === "feather") this._feather = Math.max(0, Number(value) || 0);
      else if (prop === "blur") this._blur = Math.max(0, Number(value) || 0);
      else if (prop === "rotate") this._rotate = Number(value) || 0;
      else if (prop === "shine") this._shine = clamp014(value);
      else if (prop === "grain") this._grain = Math.max(0, Number(value) || 0);
      else if (prop === "intensity") this._intensity = Math.max(0, Number(value) || 0);
      else if (prop === "modeIndex") this.setMode(value);
      this.write();
    }
    refresh() {
      this.applyMask();
      this.write();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.root.style.maskImage = "";
      this.root.style.webkitMaskImage = "";
      this.root.style.filter = "";
      this.root.style.backgroundImage = "";
      this.root.classList.remove("pulse-mask-layer");
    }
    setMode(value) {
      const names = this.mask.names();
      if (!names.length) return;
      this._modeIndex = Math.round(Number(value) || 0);
      const index = (this._modeIndex % names.length + names.length) % names.length;
      this.setMask(names[index]);
    }
    applyMask() {
      if (typeof document !== "undefined") this.mask.ensureInto(document);
      const output = this.mask.apply(this.root, this.name);
      this.root.dataset.maskName = this.name;
      if (!output) {
        this.root.style.backgroundImage = this.mask.background(this.name);
      }
    }
    write() {
      const shineX = this._x + (this._progress - 0.5) * 120;
      const shineY = this._y + Math.sin(this._progress * Math.PI * 2) * 16;
      this.root.style.setProperty("--pulse-mask-progress", String(this._progress));
      this.root.style.setProperty("--mask-x", `${this._x}%`);
      this.root.style.setProperty("--mask-y", `${this._y}%`);
      this.root.style.setProperty("--mask-scale", String(this._scale));
      this.root.style.setProperty("--mask-opacity", String(this._opacity));
      this.root.style.setProperty("--mask-feather", `${this._feather}px`);
      this.root.style.setProperty("--shine-x", `${shineX}%`);
      this.root.style.setProperty("--shine-y", `${shineY}%`);
      this.root.style.setProperty("--shine-opacity", String(this._shine));
      this.root.style.setProperty("--grain", String(this._grain));
      this.root.style.setProperty("--surface-intensity", String(this._intensity));
      this.root.style.setProperty("--noise-x", String(this._progress * 70));
      this.root.style.setProperty("--noise-y", String((1 - this._progress) * 54));
      this.root.style.opacity = String(this._opacity);
      this.root.style.transform = `rotate(${this._rotate.toFixed(2)}deg) scale(${this._scale.toFixed(3)})`;
      const baseFilter = this.mask.filter(this.name);
      const blur = this._blur ? ` blur(${this._blur.toFixed(2)}px)` : "";
      this.root.style.filter = `${baseFilter}${blur}`.trim();
    }
  };
  var PulseMaskLayerAdapter = {
    test: (target) => Boolean(target?.__pulseMaskLayer),
    props: () => ["progress", "x", "y", "scale", "opacity", "feather", "blur", "rotate", "shine", "grain", "intensity", "modeIndex"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "x") return target.x;
      if (prop === "y") return target.y;
      if (prop === "scale") return target.scale;
      if (prop === "opacity") return target.opacity;
      if (prop === "feather") return target.feather;
      if (prop === "blur") return target.blur;
      if (prop === "rotate") return target.rotate;
      if (prop === "shine") return target.shine;
      if (prop === "grain") return target.grain;
      if (prop === "intensity") return target.intensity;
      if (prop === "modeIndex") return target.modeIndex;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "rotate" ? "deg" : prop === "scale" || prop === "opacity" || prop === "progress" || prop === "shine" || prop === "grain" || prop === "intensity" || prop === "modeIndex" ? "" : "px"
  };
  registerAdapter(PulseMaskLayerAdapter);
  function maskLayer(root, name, params) {
    return new PulseMaskLayer(root, name, params);
  }

  // src/mask/mask-maps.ts
  var COMBINE_MODES = ["override", "replace", "add", "subtract", "multiply", "intersect", "max", "exclude", "paintOnly"];
  var SOURCES = ["image", "canvas", "text", "gradient", "green", "luma", "alpha"];
  var CHANNELS = ["alpha", "luma", "red", "green", "blue"];
  var OUTPUT_MODES = ["softReveal", "hardCut", "opacity", "dissolve", "displacement"];
  var PROPS = ["time", "size", "threshold", "softness", "opacity", "strength", "scale", "angle", "offsetX", "offsetY", "motion", "speed", "crackWidth", "rippleCount", "keyTolerance", "keyFeather", "blur", "expand", "invert", "clampMask", "animate", "showBaseMaskInPaint", "brushSize", "brushStrength", "brushFeather", "paintBaseOpacity", "sourceScale", "sourceRotate", "sourceOffsetX", "sourceOffsetY", "displacementStrength", "modeIndex", "combineModeIndex", "sourceIndex", "channelIndex", "outputModeIndex"];
  var MODES = ["source", "luma", "alpha", "chroma", "radial", "linear", "noise", "staticMotion", "scanLines", "cracks", "ripples", "waves", "vignette", "stripes"];
  function resolveRoot7(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:mask-maps] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:mask-maps] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function clamp6(v, min = 0, max2 = 1) {
    return Math.max(min, Math.min(max2, Number(v) || 0));
  }
  function lerp3(a, b, t) {
    return a + (b - a) * t;
  }
  function smooth(t) {
    return t * t * (3 - 2 * t);
  }
  function smoothStep(a, b, x) {
    const t = clamp6((x - a) / Math.max(1e-5, b - a));
    return t * t * (3 - 2 * t);
  }
  function randHash(x, y) {
    const s = Math.sin(x * 127.1 + y * 311.7) * 43758.5453123;
    return s - Math.floor(s);
  }
  function valueNoise(x, y) {
    const xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
    const a = randHash(xi, yi), b = randHash(xi + 1, yi), c = randHash(xi, yi + 1), d = randHash(xi + 1, yi + 1);
    const ux = smooth(xf), uy = smooth(yf);
    return lerp3(lerp3(a, b, ux), lerp3(c, d, ux), uy);
  }
  function fractalNoise(x, y, octaves) {
    let total = 0, amp = 1, freq = 1, max2 = 0;
    for (let i = 0; i < octaves; i++) {
      total += valueNoise(x * freq, y * freq) * amp;
      max2 += amp;
      amp *= 0.5;
      freq *= 2;
    }
    return total / max2;
  }
  function hexToRgb(hex) {
    const clean = hex.startsWith("#") ? hex.slice(1) : hex;
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean.padEnd(6, "0").slice(0, 6);
    const n = parseInt(full, 16);
    return { r: n >> 16 & 255, g: n >> 8 & 255, b: n & 255 };
  }
  function distToSegment(px, py, ax, ay, bx, by) {
    const vx = bx - ax, vy = by - ay, wx = px - ax, wy = py - ay;
    const len2 = vx * vx + vy * vy || 1e-5;
    const t = clamp6((wx * vx + wy * vy) / len2);
    return Math.hypot(px - (ax + vx * t), py - (ay + vy * t));
  }
  var PulseMaskMaps = class {
    constructor(root, options = {}) {
      this.__pulseMaskMaps = true;
      this.modeIndex = 0;
      this.renderQueued = false;
      this.lastRender = 0;
      this.disposed = false;
      this.applications = /* @__PURE__ */ new Map();
      this.composites = /* @__PURE__ */ new Set();
      this.renderVersion = 0;
      this.root = resolveRoot7(root);
      this.root.classList.add("pulse-mask-maps");
      this.mode = options.mode ?? "radial";
      this.modeIndex = Math.max(0, MODES.indexOf(this.mode));
      this.size = Math.max(32, Math.round(options.size ?? 128));
      this.threshold = options.threshold ?? 0.35;
      this.softness = options.softness ?? 0.16;
      this.opacity = options.opacity ?? 1;
      this.strength = options.strength ?? 1;
      this.invert = options.invert ?? false;
      this.scale = options.scale ?? 18;
      this.angle = options.angle ?? 0;
      this.offsetX = options.offsetX ?? 0;
      this.offsetY = options.offsetY ?? 0;
      this.motion = options.motion ?? 1;
      this.time = options.time ?? 0;
      this.speed = options.speed ?? 1;
      this.crackWidth = options.crackWidth ?? 1.8;
      this.rippleCount = options.rippleCount ?? 8;
      this.keyColor = options.keyColor ?? "#00ff00";
      this.keyTolerance = options.keyTolerance ?? 0.26;
      this.keyFeather = options.keyFeather ?? 0.14;
      this.blur = options.blur ?? 0;
      this.expand = options.expand ?? 0;
      this.combineMode = options.combineMode ?? "override";
      this.clampMask = options.clampMask ?? true;
      this.brushSize = Math.max(1, options.brushSize ?? 38);
      this.brushStrength = clamp6(options.brushStrength ?? 0.85);
      this.brushFeather = clamp6(options.brushFeather ?? 0.45);
      this.paintBaseOpacity = clamp6(options.paintBaseOpacity ?? 0.38);
      this.animate = options.animate ?? false;
      this.showBaseMaskInPaint = options.showBaseMaskInPaint ?? true;
      this.source = options.source ?? (this.mode === "chroma" ? "green" : this.mode === "alpha" ? "alpha" : "gradient");
      this.channel = options.channel ?? (this.mode === "alpha" ? "alpha" : "luma");
      this.outputMode = options.outputMode ?? "softReveal";
      this.sourceScale = Math.max(0.01, options.sourceScale ?? 1);
      this.sourceRotate = options.sourceRotate ?? 0;
      this.sourceOffsetX = options.sourceOffsetX ?? 0;
      this.sourceOffsetY = options.sourceOffsetY ?? 0;
      this.displacementStrength = options.displacementStrength ?? 18;
      this.renderInterval = options.renderInterval ?? 50;
      this.root.innerHTML = "";
      this.sourceCanvas = this.makeCanvas();
      this.maskCanvas = this.makeCanvas();
      this.previewCanvas = this.makeCanvas();
      this.paintCanvas = this.makeCanvas();
      this.rawMaskCanvas = this.makeCanvas();
      this.finalMaskCanvas = this.makeCanvas();
      this.paintDataCanvas = this.makeCanvas();
      this.root.append(this.panel("source", this.sourceCanvas), this.panel("mask", this.maskCanvas), this.panel("preview", this.previewCanvas), this.panel("paint", this.paintCanvas));
      if (options.label) this.root.dataset.label = options.label;
      if (options.paintDemo) this.addDemoPaint(false);
      this.render();
      if (options.imageUrl) this.setImageSource(options.imageUrl);
      if (this.animate) this.setAutoAnimate(true);
    }
    writeProp(prop, value) {
      if (this.disposed) return;
      const v = Number(value) || 0;
      if (prop === "modeIndex") {
        this.modeIndex = Math.round(v);
        this.mode = MODES[(this.modeIndex % MODES.length + MODES.length) % MODES.length];
      } else if (prop === "combineModeIndex") {
        this.combineMode = COMBINE_MODES[(Math.round(v) % COMBINE_MODES.length + COMBINE_MODES.length) % COMBINE_MODES.length];
      } else if (prop === "sourceIndex") {
        this.source = SOURCES[(Math.round(v) % SOURCES.length + SOURCES.length) % SOURCES.length] ?? "gradient";
      } else if (prop === "channelIndex") {
        this.channel = CHANNELS[(Math.round(v) % CHANNELS.length + CHANNELS.length) % CHANNELS.length];
      } else if (prop === "outputModeIndex") {
        this.outputMode = OUTPUT_MODES[(Math.round(v) % OUTPUT_MODES.length + OUTPUT_MODES.length) % OUTPUT_MODES.length];
      } else if (prop === "invert" || prop === "clampMask" || prop === "showBaseMaskInPaint") {
        this[prop] = v >= 0.5;
      } else if (prop === "animate") {
        this.setAutoAnimate(v >= 0.5);
        return;
      } else if (prop === "size") {
        this.size = Math.max(32, Math.round(v));
      } else if (prop === "brushSize") {
        this.brushSize = Math.max(1, v);
      } else if (prop === "brushStrength" || prop === "brushFeather" || prop === "paintBaseOpacity") {
        this[prop] = clamp6(v);
      } else if (PROPS.includes(prop)) {
        this[prop] = v;
      }
      this.scheduleRender();
    }
    get combineModeIndex() {
      return Math.max(0, COMBINE_MODES.indexOf(this.combineMode));
    }
    get sourceIndex() {
      return Math.max(0, SOURCES.indexOf(this.source));
    }
    get channelIndex() {
      return Math.max(0, CHANNELS.indexOf(this.channel));
    }
    get outputModeIndex() {
      return Math.max(0, OUTPUT_MODES.indexOf(this.outputMode));
    }
    setMode(mode) {
      this.mode = mode;
      this.modeIndex = Math.max(0, MODES.indexOf(mode));
      if (mode === "alpha") this.channel = "alpha";
      else if (mode === "luma") this.channel = "luma";
      this.render();
      return this;
    }
    addDemoPaint(render2 = true) {
      const s = this.size;
      const ctx = this.paintDataCanvas.getContext("2d", { willReadFrequently: true });
      ctx.clearRect(0, 0, s, s);
      this.stroke(ctx, s * 0.18, s * 0.7, s * 0.82, s * 0.32, s * 0.055, 255);
      this.stroke(ctx, s * 0.18, s * 0.26, s * 0.62, s * 0.62, s * 0.045, 0);
      this.dot(ctx, s * 0.72, s * 0.72, s * 0.08, 128);
      if (render2) this.render();
      return this;
    }
    clearPaint() {
      const ctx = this.paintDataCanvas.getContext("2d");
      ctx.clearRect(0, 0, this.size, this.size);
      this.render();
      return this;
    }
    setCombineMode(mode) {
      this.combineMode = mode;
      this.render();
      return this;
    }
    setOperation(mode) {
      return this.setCombineMode(mode);
    }
    setSource(source) {
      this.source = source;
      this.render();
      return this;
    }
    setChannel(channel) {
      this.channel = channel;
      if (this.mode !== "chroma") this.mode = "source";
      this.modeIndex = MODES.indexOf(this.mode);
      this.render();
      return this;
    }
    setOutputMode(mode) {
      this.outputMode = mode;
      this.render();
      return this;
    }
    setKeyColor(color2) {
      this.keyColor = color2;
      this.render();
      return this;
    }
    setImageSource(url) {
      const ImageCtor = this.root.ownerDocument.defaultView?.Image;
      if (!ImageCtor) return this;
      const image = new ImageCtor();
      image.crossOrigin = "anonymous";
      image.onload = () => {
        this.sourceImage = image;
        this.source = "image";
        this.render();
      };
      image.src = url;
      return this;
    }
    setCanvasSource(source) {
      this.sourceFrame = source;
      this.source = "canvas";
      this.mode = "source";
      this.modeIndex = MODES.indexOf(this.mode);
      this.render();
      return this;
    }
    setTextSource(text, options = {}) {
      this.sourceText = { text, options };
      this.source = "text";
      this.mode = "source";
      this.channel = "alpha";
      this.modeIndex = MODES.indexOf(this.mode);
      this.render();
      return this;
    }
    setSourceTransform(transform) {
      if (transform.scale !== void 0) this.sourceScale = Math.max(0.01, transform.scale);
      if (transform.rotate !== void 0) this.sourceRotate = transform.rotate;
      if (transform.x !== void 0) this.sourceOffsetX = transform.x;
      if (transform.y !== void 0) this.sourceOffsetY = transform.y;
      this.render();
      return this;
    }
    clearImage() {
      this.sourceImage = void 0;
      this.sourceFrame = void 0;
      if (this.source === "image" || this.source === "canvas") this.source = "gradient";
      this.render();
      return this;
    }
    setAutoAnimate(enabled) {
      this.stopAuto?.();
      this.stopAuto = void 0;
      this.animate = enabled;
      if (enabled) this.stopAuto = ticker.add((dt) => {
        this.time += dt;
        this.scheduleRender();
      });
      return this;
    }
    fillPaint(value) {
      const ctx = this.ctx(this.paintDataCanvas);
      const c = Math.round(value * 255);
      ctx.fillStyle = `rgba(${c},${c},${c},1)`;
      ctx.fillRect(0, 0, this.size, this.size);
      this.render();
      return this;
    }
    paintStroke(fromX, fromY, toX, toY, action = "reveal") {
      const ctx = this.paintDataCanvas.getContext("2d", { willReadFrequently: true });
      const value = action === "reveal" ? 255 : action === "hide" ? 0 : 128;
      const width = Math.max(1, this.brushSize * (this.size / 512));
      ctx.save();
      ctx.globalAlpha = this.brushStrength;
      ctx.shadowBlur = width * this.brushFeather;
      ctx.shadowColor = `rgb(${value},${value},${value})`;
      this.stroke(ctx, fromX * this.size, fromY * this.size, toX * this.size, toY * this.size, width, value);
      ctx.restore();
      this.render();
      return this;
    }
    maskDataURL() {
      return this.finalMaskCanvas.toDataURL("image/png");
    }
    alphaCanvas(options = {}) {
      const width = Math.max(2, Math.round(options.width ?? this.size));
      const height = Math.max(2, Math.round(options.height ?? this.size));
      const inset2 = Math.max(0, Number(options.inset) || 0);
      const canvas = this.root.ownerDocument.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(this.finalMaskCanvas, 0, 0, width, height);
      const source = ctx.getImageData(0, 0, width, height);
      const base = new Uint8ClampedArray(width * height);
      for (let pixel = 0; pixel < base.length; pixel++) {
        const i = pixel * 4;
        const x = pixel % width;
        const y = Math.floor(pixel / width);
        base[pixel] = Math.round(this.outputMaskValue(source.data[i] / 255, x, y) * 255);
      }
      let alpha = base;
      if (inset2 > 0) {
        const whole = Math.floor(inset2);
        const fraction = inset2 - whole;
        const erode = (input) => {
          const output2 = new Uint8ClampedArray(input.length);
          for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
            let value = 255;
            for (let oy = -1; oy <= 1; oy++) for (let ox = -1; ox <= 1; ox++) {
              const xx = Math.max(0, Math.min(width - 1, x + ox));
              const yy = Math.max(0, Math.min(height - 1, y + oy));
              value = Math.min(value, input[yy * width + xx]);
            }
            output2[y * width + x] = value;
          }
          return output2;
        };
        for (let step = 0; step < whole; step++) alpha = erode(alpha);
        if (fraction > 0) {
          const next = erode(alpha);
          const mixed = new Uint8ClampedArray(alpha.length);
          for (let i = 0; i < alpha.length; i++) mixed[i] = Math.round(lerp3(alpha[i], next[i], fraction));
          alpha = mixed;
        }
      }
      const output = ctx.createImageData(width, height);
      for (let pixel = 0; pixel < alpha.length; pixel++) {
        const i = pixel * 4;
        output.data[i] = output.data[i + 1] = output.data[i + 2] = 255;
        output.data[i + 3] = alpha[pixel];
      }
      ctx.putImageData(output, 0, 0);
      return canvas;
    }
    alphaDataURL(options = {}) {
      return this.alphaCanvas(options).toDataURL("image/png");
    }
    attachCanvasComposite(source, target, options = {}) {
      if (!(target instanceof this.root.ownerDocument.defaultView.HTMLCanvasElement)) {
        throw new Error("[pulse:mask-maps] canvas composite target must be an HTMLCanvasElement");
      }
      const originalWidth = target.width;
      const originalHeight = target.height;
      const fit = options.fit ?? "cover";
      const maxPixelRatio = Math.max(1, options.maxPixelRatio ?? 2);
      const matteInset = Math.max(0, options.matteInset ?? 0);
      const additivePasses = Math.max(1, Math.round(options.additivePasses ?? 1));
      const additiveGain = clamp6(options.additiveGain ?? 0.72);
      const glint = typeof options.glint === "object" ? options.glint : { enabled: options.glint === true };
      const media = source;
      const canPlay = typeof media.play === "function";
      const sourceWasPaused = canPlay ? media.paused !== false : false;
      let startedMedia = false;
      let stopTick;
      let disposed = false;
      let elapsed = 0;
      let lastRecovery = -Infinity;
      let maskCanvas;
      let maskSignature = "";
      let lastReduced = false;
      let diagnostics = {
        sourceWidth: 0,
        sourceHeight: 0,
        itemWidth: 0,
        itemHeight: 0,
        rasterWidth: target.width,
        rasterHeight: target.height,
        density: 1,
        fit,
        crop: "none",
        matteInset,
        playing: false,
        reducedMotion: false
      };
      const sourceSize = () => {
        const value = source;
        return {
          width: Number(value.videoWidth || value.naturalWidth || value.width || 0),
          height: Number(value.videoHeight || value.naturalHeight || value.height || 0)
        };
      };
      const isReduced = () => typeof options.reducedMotion === "boolean" ? options.reducedMotion : Boolean(options.reducedMotion?.matches);
      const requestPlay = (now2 = 0) => {
        if (!canPlay || media.paused === false || now2 - lastRecovery < 1e3) return;
        lastRecovery = now2;
        media.play().then(() => {
          startedMedia = sourceWasPaused;
        }).catch(() => {
        });
      };
      const ensureSize = () => {
        const rect = target.getBoundingClientRect();
        const itemWidth = Math.max(2, Number(options.width) || rect.width || target.width || 2);
        const itemHeight = Math.max(2, Number(options.height) || rect.height || target.height || 2);
        const size = sourceSize();
        const view = this.root.ownerDocument.defaultView;
        const requestedDensity = options.pixelRatio === "auto" || options.pixelRatio === void 0 ? view?.devicePixelRatio || 1 : Math.max(0.1, options.pixelRatio);
        const availableDensity = options.limitToSource === false || !size.width || !size.height ? Infinity : Math.min(size.width / itemWidth, size.height / itemHeight);
        const density = Math.max(0.1, Math.min(requestedDensity, maxPixelRatio, availableDensity));
        const rasterWidth = Math.max(2, Math.round(itemWidth * density));
        const rasterHeight = Math.max(2, Math.round(itemHeight * density));
        if (target.width !== rasterWidth) target.width = rasterWidth;
        if (target.height !== rasterHeight) target.height = rasterHeight;
        const itemAspect = itemWidth / itemHeight;
        const sourceAspect = size.width && size.height ? size.width / size.height : itemAspect;
        diagnostics = {
          sourceWidth: size.width,
          sourceHeight: size.height,
          itemWidth,
          itemHeight,
          rasterWidth,
          rasterHeight,
          density,
          fit,
          crop: fit !== "cover" || Math.abs(sourceAspect - itemAspect) < 1e-3 ? "none" : sourceAspect > itemAspect ? "x" : "y",
          matteInset,
          playing: canPlay ? media.paused === false : Boolean(stopTick),
          reducedMotion: isReduced()
        };
      };
      const draw = () => {
        if (disposed) return;
        if (options.autoResize !== false || !diagnostics.itemWidth) ensureSize();
        const ctx = target.getContext("2d");
        const { rasterWidth: width, rasterHeight: height } = diagnostics;
        if (isReduced()) {
          if (options.clearOnReduce !== false && !lastReduced) ctx.clearRect(0, 0, width, height);
          lastReduced = true;
          diagnostics.reducedMotion = true;
          return;
        }
        lastReduced = false;
        diagnostics.reducedMotion = false;
        const size = sourceSize();
        if (!size.width || !size.height) return;
        let drawWidth = width, drawHeight = height;
        if (fit !== "stretch") {
          const scale = fit === "cover" ? Math.max(width / size.width, height / size.height) : Math.min(width / size.width, height / size.height);
          drawWidth = size.width * scale;
          drawHeight = size.height * scale;
        }
        const drawX = (width - drawWidth) / 2;
        const drawY = (height - drawHeight) / 2;
        ctx.save();
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(source, drawX, drawY, drawWidth, drawHeight);
        for (let pass = 1; pass < additivePasses; pass++) {
          ctx.globalCompositeOperation = "lighter";
          ctx.globalAlpha = Math.pow(additiveGain, pass);
          ctx.drawImage(source, drawX, drawY, drawWidth, drawHeight);
        }
        if (glint.enabled) {
          const duration = Number.isFinite(media.duration) && Number(media.duration) > 0 ? Number(media.duration) : 1;
          const phase = canPlay ? (Number(media.currentTime) || 0) / duration % 1 : elapsed * (glint.speed ?? 1) % 1;
          const center = (0.04 + phase * 0.92) * width;
          const radius = Math.max(height * 1.25, width * Math.max(0.01, glint.width ?? 0.055));
          const gradient2 = ctx.createLinearGradient(center - radius, 0, center + radius, 0);
          gradient2.addColorStop(0, "rgba(255,255,255,0)");
          gradient2.addColorStop(0.5, glint.color ?? "#fff");
          gradient2.addColorStop(1, "rgba(255,255,255,0)");
          ctx.globalCompositeOperation = "lighter";
          ctx.globalAlpha = clamp6(glint.strength ?? 0.78);
          ctx.fillStyle = gradient2;
          ctx.fillRect(0, 0, width, height);
        }
        const nextMaskSignature = `${this.renderVersion}:${width}:${height}:${matteInset}`;
        if (!maskCanvas || maskSignature !== nextMaskSignature) {
          maskCanvas = this.alphaCanvas({ width, height, inset: matteInset });
          maskSignature = nextMaskSignature;
        }
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "destination-in";
        ctx.drawImage(maskCanvas, 0, 0, width, height);
        ctx.restore();
        diagnostics.playing = canPlay ? media.paused === false : Boolean(stopTick);
      };
      const handle = {
        target,
        render: draw,
        start: () => {
          if (disposed || stopTick) return;
          if (options.autoPlay) requestPlay(0);
          draw();
          stopTick = ticker.add((dt, now2) => {
            elapsed += dt;
            if (options.recoverPlayback && !isReduced()) requestPlay(now2);
            draw();
          });
        },
        stop: () => {
          stopTick?.();
          stopTick = void 0;
          diagnostics.playing = false;
        },
        diagnostics: () => ({ ...diagnostics }),
        dispose: () => {
          if (disposed) return;
          disposed = true;
          stopTick?.();
          stopTick = void 0;
          target.width = originalWidth;
          target.height = originalHeight;
          if (startedMedia && sourceWasPaused) media.pause?.();
          this.composites.delete(handle);
        }
      };
      this.composites.add(handle);
      if (options.autoStart !== false) handle.start();
      else draw();
      return handle;
    }
    previewDataURL() {
      return this.previewCanvas.toDataURL("image/png");
    }
    applyTo(target, options = {}) {
      const element = typeof target === "string" ? this.root.ownerDocument.querySelector(target) : target;
      if (!(element instanceof HTMLElement)) throw new Error(`[pulse:mask-maps] apply target not found: ${String(target)}`);
      if (!this.applications.has(element)) {
        this.applications.set(element, { options, original: {
          maskImage: element.style.maskImage,
          resolvedMaskImage: element.ownerDocument.defaultView?.getComputedStyle(element).maskImage ?? element.style.maskImage,
          webkitMaskImage: element.style.getPropertyValue("-webkit-mask-image"),
          maskMode: element.style.maskMode,
          webkitMaskMode: element.style.getPropertyValue("-webkit-mask-mode"),
          maskComposite: element.style.maskComposite,
          webkitMaskComposite: element.style.getPropertyValue("-webkit-mask-composite"),
          maskSize: element.style.maskSize,
          webkitMaskSize: element.style.getPropertyValue("-webkit-mask-size"),
          maskPosition: element.style.maskPosition,
          webkitMaskPosition: element.style.getPropertyValue("-webkit-mask-position"),
          maskRepeat: element.style.maskRepeat,
          webkitMaskRepeat: element.style.getPropertyValue("-webkit-mask-repeat")
        } });
      } else this.applications.get(element).options = options;
      this.applyAttachedMasks();
      return this;
    }
    detach(target) {
      const element = typeof target === "string" ? this.root.ownerDocument.querySelector(target) : target;
      if (!(element instanceof HTMLElement)) return this;
      const application = this.applications.get(element);
      if (!application) return this;
      const original = application.original;
      element.style.maskImage = original.maskImage;
      if (original.webkitMaskImage) element.style.setProperty("-webkit-mask-image", original.webkitMaskImage);
      else element.style.removeProperty("-webkit-mask-image");
      element.style.maskMode = original.maskMode;
      if (original.webkitMaskMode) element.style.setProperty("-webkit-mask-mode", original.webkitMaskMode);
      else element.style.removeProperty("-webkit-mask-mode");
      element.style.maskComposite = original.maskComposite;
      if (original.webkitMaskComposite) element.style.setProperty("-webkit-mask-composite", original.webkitMaskComposite);
      else element.style.removeProperty("-webkit-mask-composite");
      element.style.maskSize = original.maskSize;
      if (original.webkitMaskSize) element.style.setProperty("-webkit-mask-size", original.webkitMaskSize);
      else element.style.removeProperty("-webkit-mask-size");
      element.style.maskPosition = original.maskPosition;
      if (original.webkitMaskPosition) element.style.setProperty("-webkit-mask-position", original.webkitMaskPosition);
      else element.style.removeProperty("-webkit-mask-position");
      element.style.maskRepeat = original.maskRepeat;
      if (original.webkitMaskRepeat) element.style.setProperty("-webkit-mask-repeat", original.webkitMaskRepeat);
      else element.style.removeProperty("-webkit-mask-repeat");
      this.applications.delete(element);
      return this;
    }
    render() {
      this.renderQueued = false;
      if (this.disposed) return this;
      this.lastRender = typeof performance !== "undefined" ? performance.now() : Date.now();
      this.drawSource();
      this.generateRawMask();
      this.postProcessMask();
      this.combinePaintLayer();
      this.renderVersion++;
      this.drawMaskView();
      this.drawPreview();
      this.drawPaintView();
      this.applyAttachedMasks();
      return this;
    }
    dispose() {
      this.disposed = true;
      this.stopAuto?.();
      [...this.composites].forEach((composite2) => composite2.dispose());
      [...this.applications.keys()].forEach((target) => this.detach(target));
      this.renderQueued = false;
      this.root.innerHTML = "";
      this.root.classList.remove("pulse-mask-maps");
    }
    makeCanvas() {
      const canvas = document.createElement("canvas");
      canvas.width = this.size;
      canvas.height = this.size;
      return canvas;
    }
    panel(name, canvas) {
      const wrap = document.createElement("div");
      wrap.className = "mask-map-panel";
      const label = document.createElement("span");
      label.textContent = name;
      wrap.append(canvas, label);
      return wrap;
    }
    scheduleRender() {
      if (this.disposed || this.renderQueued) return;
      const now2 = typeof performance !== "undefined" ? performance.now() : Date.now();
      const delay = Math.max(0, this.renderInterval - (now2 - this.lastRender));
      this.renderQueued = true;
      const run = () => {
        if (!this.disposed) this.render();
        else this.renderQueued = false;
      };
      if (delay <= 0 && typeof requestAnimationFrame !== "undefined") requestAnimationFrame(run);
      else setTimeout(run, delay);
    }
    ctx(canvas) {
      canvas.width = this.size;
      canvas.height = this.size;
      return canvas.getContext("2d", { willReadFrequently: true });
    }
    drawSource() {
      const s = this.size, ctx = this.ctx(this.sourceCanvas);
      ctx.clearRect(0, 0, s, s);
      if (this.source === "image" && this.sourceImage) {
        this.drawTransformedSource(ctx, this.sourceImage);
        return;
      }
      if (this.source === "canvas" && this.sourceFrame) {
        this.drawTransformedSource(ctx, this.sourceFrame);
        return;
      }
      if (this.source === "text" && this.sourceText) {
        const { text, options } = this.sourceText;
        if (options.background) {
          ctx.fillStyle = options.background;
          ctx.fillRect(0, 0, s, s);
        }
        ctx.save();
        ctx.translate(s * (0.5 + this.sourceOffsetX * 0.5), s * (0.5 + this.sourceOffsetY * 0.5));
        ctx.rotate(this.sourceRotate * Math.PI / 180);
        ctx.scale(this.sourceScale, this.sourceScale);
        ctx.fillStyle = options.color ?? "#fff";
        ctx.font = options.font ?? `900 ${Math.round(s * 0.24)}px Arial Black, Arial`;
        ctx.textAlign = options.align ?? "center";
        ctx.textBaseline = options.baseline ?? "middle";
        ctx.fillText(text, (options.x ?? 0.5) * s - s * 0.5, (options.y ?? 0.5) * s - s * 0.5);
        ctx.restore();
        return;
      }
      if (this.source === "green") {
        ctx.fillStyle = "#00ff00";
        ctx.fillRect(0, 0, s, s);
        const g2 = ctx.createLinearGradient(s * 0.35, s * 0.18, s * 0.68, s * 0.84);
        g2.addColorStop(0, "#ffefe4");
        g2.addColorStop(0.42, "#9ad7ff");
        g2.addColorStop(1, "#14203a");
        ctx.fillStyle = g2;
        ctx.beginPath();
        ctx.ellipse(s * 0.52, s * 0.52, s * 0.22, s * 0.34, -0.18, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "rgba(0,0,0,.32)";
        ctx.fillRect(s * 0.38, s * 0.77, s * 0.28, s * 0.06);
        return;
      }
      if (this.source === "alpha") {
        ctx.clearRect(0, 0, s, s);
        const g2 = ctx.createRadialGradient(s * 0.48, s * 0.48, s * 0.05, s * 0.5, s * 0.5, s * 0.46);
        g2.addColorStop(0, "rgba(255,255,255,1)");
        g2.addColorStop(0.55, "rgba(77,252,255,.72)");
        g2.addColorStop(1, "rgba(255,122,26,0)");
        ctx.fillStyle = g2;
        ctx.fillRect(0, 0, s, s);
        return;
      }
      const g = ctx.createLinearGradient(0, 0, s, s);
      g.addColorStop(0, "#06080e");
      g.addColorStop(0.34, "#7cff4d");
      g.addColorStop(0.68, "#ff7a1a");
      g.addColorStop(1, "#4dfcff");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, s, s);
      ctx.fillStyle = "rgba(255,255,255,.18)";
      for (let y = 0; y < s; y += Math.max(8, s / 12)) ctx.fillRect(0, y, s, 1);
      ctx.fillStyle = "rgba(0,0,0,.32)";
      ctx.beginPath();
      ctx.arc(s * 0.35, s * 0.42, s * 0.2, 0, Math.PI * 2);
      ctx.fill();
    }
    drawTransformedSource(ctx, source) {
      const s = this.size;
      ctx.save();
      ctx.translate(s * (0.5 + this.sourceOffsetX * 0.5), s * (0.5 + this.sourceOffsetY * 0.5));
      ctx.rotate(this.sourceRotate * Math.PI / 180);
      ctx.scale(this.sourceScale, this.sourceScale);
      ctx.drawImage(source, -s * 0.5, -s * 0.5, s, s);
      ctx.restore();
    }
    generateRawMask() {
      const s = this.size, ctx = this.ctx(this.rawMaskCanvas);
      const out = ctx.createImageData(s, s);
      const data = out.data;
      const src = this.sourceCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, s, s).data;
      const t = this.time * this.speed;
      const key2 = hexToRgb(this.keyColor);
      for (let y = 0; y < s; y++) {
        for (let x = 0; x < s; x++) {
          const idx = (y * s + x) * 4;
          const r = src[idx] / 255, g = src[idx + 1] / 255, b = src[idx + 2] / 255, a = src[idx + 3] / 255;
          let v = 0;
          switch (this.mode) {
            case "source":
              v = this.sampleChannel(r, g, b, a);
              break;
            case "luma":
              v = this.thresholdSoft(r * 0.2126 + g * 0.7152 + b * 0.0722);
              break;
            case "alpha":
              v = a;
              break;
            case "chroma": {
              const dr = r - key2.r / 255, dg = g - key2.g / 255, db = b - key2.b / 255;
              v = smoothStep(this.keyTolerance, this.keyTolerance + this.keyFeather, Math.sqrt(dr * dr + dg * dg + db * db) / Math.sqrt(3));
              break;
            }
            case "radial":
              v = this.radialMask(x, y, s);
              break;
            case "linear":
              v = this.linearMask(x, y, s);
              break;
            case "noise":
              v = this.noiseMask(x, y, s, t);
              break;
            case "staticMotion":
              v = this.staticMask(x, y, s, t);
              break;
            case "scanLines":
              v = this.scanMask(x, y, s, t);
              break;
            case "cracks":
              v = this.cracksMask(x, y, s, t);
              break;
            case "ripples":
              v = this.rippleMask(x, y, s, t);
              break;
            case "waves":
              v = this.waveMask(x, y, s, t);
              break;
            case "vignette":
              v = this.vignetteMask(x, y, s);
              break;
            case "stripes":
              v = this.stripesMask(x, y, s, t);
              break;
          }
          v *= this.strength;
          if (!["luma", "chroma", "alpha"].includes(this.mode)) v = this.thresholdSoft(v);
          if (this.invert) v = 1 - v;
          const finalValue = this.clampMask ? clamp6(v * this.opacity) : v * this.opacity;
          const cc = Math.round(finalValue * 255);
          data[idx] = data[idx + 1] = data[idx + 2] = cc;
          data[idx + 3] = 255;
        }
      }
      ctx.putImageData(out, 0, 0);
    }
    sampleChannel(r, g, b, a) {
      if (this.channel === "alpha") return a;
      if (this.channel === "red") return r;
      if (this.channel === "green") return g;
      if (this.channel === "blue") return b;
      return (r * 0.2126 + g * 0.7152 + b * 0.0722) * a;
    }
    postProcessMask() {
      const ctx = this.ctx(this.finalMaskCanvas);
      ctx.drawImage(this.rawMaskCanvas, 0, 0);
      if (this.expand) this.morph(this.finalMaskCanvas, Math.round(this.expand));
      if (this.blur > 0) this.simpleBlur(this.finalMaskCanvas, Math.round(this.blur));
    }
    combinePaintLayer() {
      const s = this.size;
      const ctx = this.finalMaskCanvas.getContext("2d", { willReadFrequently: true });
      const base = ctx.getImageData(0, 0, s, s);
      const paint = this.paintDataCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, s, s);
      const b = base.data, p = paint.data;
      for (let i = 0; i < b.length; i += 4) {
        const bv = b[i] / 255, pv = p[i] / 255, pa = p[i + 3] / 255;
        let out = bv;
        if (this.combineMode === "override" || this.combineMode === "replace") out = pa > 0 ? lerp3(bv, pv, pa) : bv;
        else if (this.combineMode === "add") out = clamp6(bv + pv * pa);
        else if (this.combineMode === "subtract") out = clamp6(bv - (1 - pv) * pa);
        else if (this.combineMode === "multiply") out = bv * (pa > 0 ? lerp3(1, pv, pa) : 1);
        else if (this.combineMode === "intersect") out = pa > 0 ? Math.min(bv, pv) : bv;
        else if (this.combineMode === "max") out = Math.max(bv, pv * pa);
        else if (this.combineMode === "exclude") out = pa > 0 ? Math.abs(bv - pv) : bv;
        else if (this.combineMode === "paintOnly") out = pa > 0 ? pv : 0;
        const cc = Math.round(out * 255);
        b[i] = b[i + 1] = b[i + 2] = cc;
        b[i + 3] = 255;
      }
      ctx.putImageData(base, 0, 0);
    }
    drawMaskView() {
      const ctx = this.ctx(this.maskCanvas);
      ctx.drawImage(this.finalMaskCanvas, 0, 0);
    }
    drawPreview() {
      const s = this.size, ctx = this.ctx(this.previewCanvas);
      this.drawChecker(ctx, s, s, 16);
      const src = this.sourceCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, s, s);
      const mask2 = this.finalMaskCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, s, s);
      const out = ctx.createImageData(s, s);
      for (let y = 0; y < s; y++) for (let x = 0; x < s; x++) {
        const i = (y * s + x) * 4;
        let maskValue = mask2.data[i] / 255;
        maskValue = this.outputMaskValue(maskValue, x, y);
        let sourceIndex = i;
        if (this.outputMode === "displacement") {
          const shift = Math.round((maskValue - 0.5) * this.displacementStrength);
          const sx = Math.round(clamp6(x + shift, 0, s - 1));
          sourceIndex = (y * s + sx) * 4;
        }
        out.data[i] = src.data[sourceIndex];
        out.data[i + 1] = src.data[sourceIndex + 1];
        out.data[i + 2] = src.data[sourceIndex + 2];
        out.data[i + 3] = Math.round(maskValue * 255);
      }
      ctx.putImageData(out, 0, 0);
    }
    outputMaskValue(value, x, y) {
      if (this.outputMode === "hardCut") return value >= 0.5 ? 1 : 0;
      if (this.outputMode === "dissolve") return randHash(x + Math.floor(this.time * 47), y) <= value ? 1 : 0;
      return value;
    }
    applyAttachedMasks() {
      if (!this.applications.size) return;
      let alphaUrl = "";
      let lumaUrl = "";
      const webkitComposite = { add: "source-over", subtract: "source-out", intersect: "source-in", exclude: "xor", replace: "source-over" };
      this.applications.forEach(({ options, original }, target) => {
        const mode = options.mode ?? "alpha";
        const url = mode === "alpha" ? alphaUrl || (alphaUrl = this.alphaDataURL()) : lumaUrl || (lumaUrl = this.maskDataURL());
        const maskImage = `url("${url}")`;
        const append = options.append ?? false;
        const authoredBase = original.maskImage || original.resolvedMaskImage;
        const image = append && authoredBase && authoredBase !== "none" ? `${maskImage}, ${authoredBase}` : maskImage;
        const operation = options.operation ?? "replace";
        target.style.maskImage = image;
        target.style.setProperty("-webkit-mask-image", image);
        target.style.maskMode = mode;
        target.style.setProperty("-webkit-mask-mode", mode);
        target.style.maskComposite = operation === "replace" ? "add" : operation;
        target.style.setProperty("-webkit-mask-composite", webkitComposite[operation] ?? "source-over");
        target.style.maskSize = options.size ?? "100% 100%";
        target.style.maskPosition = options.position ?? "50% 50%";
        target.style.maskRepeat = options.repeat ?? "no-repeat";
      });
    }
    drawPaintView() {
      const s = this.size, ctx = this.ctx(this.paintCanvas);
      this.drawChecker(ctx, s, s, 16);
      ctx.save();
      ctx.globalAlpha = this.showBaseMaskInPaint ? this.paintBaseOpacity : 0;
      if (this.showBaseMaskInPaint) ctx.drawImage(this.finalMaskCanvas, 0, 0);
      ctx.restore();
      const paint = this.paintDataCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, s, s);
      const out = ctx.getImageData(0, 0, s, s);
      let painted = 0;
      for (let i = 0; i < paint.data.length; i += 4) {
        const v = paint.data[i] / 255, a = paint.data[i + 3] / 255;
        if (a <= 0) continue;
        painted++;
        const rgb = v > 0.55 ? [70, 255, 80] : v < 0.45 ? [255, 70, 90] : [255, 190, 60];
        const mix2 = Math.min(0.92, a * 0.88);
        out.data[i] = Math.round(lerp3(out.data[i], rgb[0], mix2));
        out.data[i + 1] = Math.round(lerp3(out.data[i + 1], rgb[1], mix2));
        out.data[i + 2] = Math.round(lerp3(out.data[i + 2], rgb[2], mix2));
        out.data[i + 3] = 255;
      }
      ctx.putImageData(out, 0, 0);
      if (!painted) {
        ctx.fillStyle = "rgba(0,0,0,.58)";
        ctx.fillRect(s * 0.2, s * 0.42, s * 0.6, s * 0.14);
        ctx.fillStyle = "#f2f7ff";
        ctx.font = `900 ${Math.round(s * 0.055)}px system-ui`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("PAINT", s * 0.5, s * 0.49);
      }
    }
    thresholdSoft(v) {
      if (this.softness <= 1e-3) return v >= this.threshold ? 1 : 0;
      return smoothStep(this.threshold - this.softness, this.threshold + this.softness, v);
    }
    radialMask(x, y, s) {
      const cx = s * (0.5 + this.offsetX * 0.5), cy = s * (0.5 + this.offsetY * 0.5);
      return 1 - Math.hypot(x - cx, y - cy) / (s * 0.72);
    }
    linearMask(x, y, s) {
      const a = this.angle * Math.PI / 180, nx = x / s - 0.5 - this.offsetX * 0.5, ny = y / s - 0.5 - this.offsetY * 0.5;
      return nx * Math.cos(a) + ny * Math.sin(a) + 0.5;
    }
    noiseMask(x, y, s, t) {
      return fractalNoise((x / s + t * 0.03 * this.motion) * this.scale, (y / s - t * 0.02 * this.motion) * this.scale, 4);
    }
    staticMask(x, y, s, t) {
      const n1 = fractalNoise((x / s + t * 0.12 * this.motion) * this.scale, (y / s - t * 0.06 * this.motion) * this.scale, 4);
      const n2 = randHash(Math.floor(x + t * 90 * this.motion), Math.floor(y - t * 70 * this.motion));
      return clamp6(n1 * 0.55 + n2 * 0.45 + Math.sin((x + y) * 0.2 + t * 18) * 0.08 * this.motion);
    }
    scanMask(x, y, s, t) {
      const a = this.angle * Math.PI / 180, nx = x / s - 0.5, ny = y / s - 0.5;
      return Math.pow(Math.sin((nx * Math.cos(a) + ny * Math.sin(a)) * this.scale * Math.PI * 2 + t * 5 * this.motion) * 0.5 + 0.5, 1.8);
    }
    cracksMask(x, y, s, t) {
      const density = this.scale, sx = x / s * density, sy = y / s * density, gx = Math.floor(sx), gy = Math.floor(sy);
      let nearest = 1e9;
      for (let oy = -2; oy <= 2; oy++) for (let ox = -2; ox <= 2; ox++) {
        const cx = gx + ox, cy = gy + oy, a = this.crackNode(cx, cy, t), r = this.crackNode(cx + 1, cy, t), d = this.crackNode(cx, cy + 1, t), da = this.crackNode(cx + 1, cy + 1, t);
        nearest = Math.min(nearest, distToSegment(sx, sy, a.x, a.y, r.x, r.y), distToSegment(sx, sy, a.x, a.y, d.x, d.y));
        if (randHash(cx * 19 + 4, cy * 23 + 9) < 0.48) nearest = Math.min(nearest, distToSegment(sx, sy, a.x, a.y, da.x, da.y));
      }
      const width = Math.max(2e-3, this.crackWidth * 0.018);
      const core = 1 - smoothStep(width, width * 2.2, nearest);
      const edge = smoothStep(width, width * 3.5, nearest) * (1 - smoothStep(width * 3.5, width * 6, nearest));
      return clamp6(core * 0.85 + edge * 0.35);
    }
    rippleMask(x, y, s, t) {
      const cx = 0.5 + this.offsetX * 0.5, cy = 0.5 + this.offsetY * 0.5;
      return Math.sin(Math.hypot(x / s - cx, y / s - cy) * this.rippleCount * 24 - t * 5 * this.motion) * 0.5 + 0.5;
    }
    waveMask(x, y, s, t) {
      const a = this.angle * Math.PI / 180, nx = x / s - 0.5, ny = y / s - 0.5;
      const proj = nx * Math.cos(a) + ny * Math.sin(a), cross = ny * Math.cos(a) - nx * Math.sin(a);
      return Math.sin((proj + Math.sin(cross * 18 + t * 2) * 0.12 * this.motion) * this.scale * 0.8 + t * 3 * this.motion) * 0.5 + 0.5;
    }
    vignetteMask(x, y, s) {
      return 1 - Math.hypot(x / s - 0.5, y / s - 0.5) * 1.45;
    }
    stripesMask(x, y, s, t) {
      const a = this.angle * Math.PI / 180, nx = x / s - 0.5, ny = y / s - 0.5;
      return Math.sin((nx * Math.cos(a) + ny * Math.sin(a)) * this.scale * Math.PI * 2 + t * 3 * this.motion) > 0 ? 1 : 0;
    }
    crackNode(cx, cy, t) {
      const jx = randHash(cx * 13 + 1, cy * 17 + 3) - 0.5, jy = randHash(cx * 29 + 7, cy * 31 + 5) - 0.5;
      const drift = Math.sin(t * 0.35 + randHash(cx * 41, cy * 43) * 6.28318) * 0.055 * this.motion;
      return { x: cx + 0.5 + jx * 0.72 + drift, y: cy + 0.5 + jy * 0.72 - drift };
    }
    morph(canvas, amount) {
      const radius = Math.abs(amount);
      if (!radius) return;
      const s = this.size, ctx = canvas.getContext("2d", { willReadFrequently: true });
      const src = ctx.getImageData(0, 0, s, s), dst = ctx.createImageData(s, s);
      for (let y = 0; y < s; y++) for (let x = 0; x < s; x++) {
        let val = amount > 0 ? 0 : 255;
        for (let oy = -radius; oy <= radius; oy++) for (let ox = -radius; ox <= radius; ox++) {
          const xx = Math.round(clamp6(x + ox, 0, s - 1)), yy = Math.round(clamp6(y + oy, 0, s - 1));
          const v = src.data[(yy * s + xx) * 4];
          val = amount > 0 ? Math.max(val, v) : Math.min(val, v);
        }
        const i = (y * s + x) * 4;
        dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = val;
        dst.data[i + 3] = 255;
      }
      ctx.putImageData(dst, 0, 0);
    }
    simpleBlur(canvas, radius) {
      const s = this.size, ctx = canvas.getContext("2d", { willReadFrequently: true });
      const src = ctx.getImageData(0, 0, s, s), dst = ctx.createImageData(s, s);
      for (let y = 0; y < s; y++) for (let x = 0; x < s; x++) {
        let acc = 0, count = 0;
        for (let oy = -radius; oy <= radius; oy++) for (let ox = -radius; ox <= radius; ox++) {
          const xx = Math.round(clamp6(x + ox, 0, s - 1)), yy = Math.round(clamp6(y + oy, 0, s - 1));
          acc += src.data[(yy * s + xx) * 4];
          count++;
        }
        const v = Math.round(acc / count), i = (y * s + x) * 4;
        dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = v;
        dst.data[i + 3] = 255;
      }
      ctx.putImageData(dst, 0, 0);
    }
    stroke(ctx, ax, ay, bx, by, width, value) {
      ctx.save();
      ctx.strokeStyle = `rgba(${value},${value},${value},.9)`;
      ctx.lineWidth = width;
      ctx.lineCap = "round";
      ctx.beginPath();
      ctx.moveTo(ax, ay);
      ctx.lineTo(bx, by);
      ctx.stroke();
      ctx.restore();
    }
    dot(ctx, x, y, radius, value) {
      const g = ctx.createRadialGradient(x, y, 0, x, y, radius);
      g.addColorStop(0, `rgba(${value},${value},${value},1)`);
      g.addColorStop(1, `rgba(${value},${value},${value},0)`);
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fill();
    }
    drawChecker(ctx, w, h, cell) {
      for (let y = 0; y < h; y += cell) for (let x = 0; x < w; x += cell) {
        ctx.fillStyle = (x / cell + y / cell) % 2 === 0 ? "#1a202c" : "#0c1118";
        ctx.fillRect(x, y, cell, cell);
      }
    }
  };
  var PulseMaskMapsAdapter = {
    test: (target) => Boolean(target?.__pulseMaskMaps),
    props: () => [...PROPS],
    get: (target, prop) => Number(target[prop]) || 0,
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "angle" ? "deg" : ""
  };
  registerAdapter(PulseMaskMapsAdapter);
  function maskMaps(root, params) {
    return new PulseMaskMaps(root, params);
  }

  // src/mask/mask-transition.ts
  var DEFAULT_MODES = ["wipe", "diagonal", "radial", "shutters"];
  var REVEALED = "inset(0% 0% 0% 0%)";
  function resolveTargets(targets) {
    if (typeof targets === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:mask-transition] document is not available");
      return Array.from(document.querySelectorAll(targets)).filter((target) => target instanceof HTMLElement);
    }
    if (targets instanceof HTMLElement) return [targets];
    return Array.from(targets).filter((target) => target instanceof HTMLElement);
  }
  function wrapIndex3(index, length) {
    const rounded = Math.round(Number(index) || 0);
    return (rounded % length + length) % length;
  }
  function revealedShape(mode) {
    if (mode === "diagonal") return "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)";
    if (mode === "radial") return "circle(150% at 50% 50%)";
    if (mode === "shutters") return REVEALED;
    return REVEALED;
  }
  function clamp015(value) {
    return Math.max(0, Math.min(1, Number(value) || 0));
  }
  function shapeAt(mode, targetIndex, progress) {
    const p = clamp015(progress);
    const reverse = targetIndex % 2 === 1;
    if (mode === "wipe") {
      const hidden = (100 * (1 - p)).toFixed(3);
      return reverse ? `inset(0% 0% 0% ${hidden}%)` : `inset(0% ${hidden}% 0% 0%)`;
    }
    if (mode === "diagonal") {
      const lead = clamp015(p * 1.25) * 100;
      const trail = clamp015(p * 1.25 - 0.25) * 100;
      return reverse ? `polygon(100% 0%, ${(100 - lead).toFixed(3)}% 0%, ${(100 - trail).toFixed(3)}% 100%, 100% 100%)` : `polygon(0% 0%, ${trail.toFixed(3)}% 0%, ${lead.toFixed(3)}% 100%, 0% 100%)`;
    }
    if (mode === "radial") return `circle(${(p * 150).toFixed(3)}% at ${reverse ? 72 : 28}% 50%)`;
    return `inset(${(50 * (1 - p)).toFixed(3)}% 0% ${(50 * (1 - p)).toFixed(3)}% 0%)`;
  }
  var PulseMaskTransition = class {
    constructor(targets, options = {}) {
      this.__pulseMaskTransition = true;
      this.originals = /* @__PURE__ */ new Map();
      this.stopTick = null;
      this.elapsedMs = 0;
      this.completionTimer = null;
      this.startedAt = 0;
      this.remainingMs = 0;
      this._modeIndex = 0;
      this._progress = 1;
      this._paused = true;
      this._disposed = false;
      this._speed = 1;
      this.targets = resolveTargets(targets);
      if (!this.targets.length) throw new Error("[pulse:mask-transition] no targets resolved");
      this.modes = (options.modes?.length ? options.modes : DEFAULT_MODES).filter((mode, index, all) => DEFAULT_MODES.includes(mode) && all.indexOf(mode) === index);
      if (!this.modes.length) throw new Error("[pulse:mask-transition] at least one valid mode is required");
      this.options = {
        ...options,
        duration: Math.max(0, options.duration ?? 820),
        stagger: Math.max(0, options.stagger ?? 110),
        ease: options.ease ?? "outExpo",
        reducedMotion: options.reducedMotion ?? false,
        restore: options.restore ?? true
      };
      this.easeFn = resolveEase(this.options.ease);
      this.targets.forEach((target) => {
        this.originals.set(target, {
          clipPath: target.style.clipPath,
          webkitClipPath: target.style.getPropertyValue("-webkit-clip-path"),
          transform: target.style.transform,
          filter: target.style.filter,
          opacity: target.style.opacity,
          willChange: target.style.willChange,
          mode: target.getAttribute("data-pulse-mask-transition")
        });
        target.style.clipPath = REVEALED;
        target.style.setProperty("-webkit-clip-path", REVEALED);
      });
      this._modeIndex = this.resolveIndex(options.initialMode ?? 0);
      this.writeMode();
    }
    get mode() {
      return this.modes[this._modeIndex];
    }
    get modeIndex() {
      return this._modeIndex;
    }
    get modeCount() {
      return this.modes.length;
    }
    get progress() {
      return this._progress;
    }
    get paused() {
      return this._paused;
    }
    get disposed() {
      return this._disposed;
    }
    get duration() {
      return this.totalDuration();
    }
    reveal(mode = this._modeIndex) {
      if (this._disposed) return this;
      this.stopActiveMotion();
      this._modeIndex = this.resolveIndex(mode);
      this._progress = 0;
      this._paused = false;
      this.writeMode();
      const activeMode = this.mode;
      this.options.onModeChange?.(activeMode, this._modeIndex, this);
      if (this.options.reducedMotion || this.options.duration === 0) {
        this.finish();
        return this;
      }
      this.targets.forEach((target, index) => {
        target.style.willChange = "clip-path, transform, filter, opacity";
        this.renderTarget(target, index, 0);
      });
      this.elapsedMs = 0;
      this.startTicker();
      this.remainingMs = this.options.duration + this.options.stagger * Math.max(0, this.targets.length - 1) + 34;
      this.scheduleCompletion();
      return this;
    }
    setMode(mode) {
      return this.reveal(mode);
    }
    cycle(step = 1) {
      return this.reveal(this._modeIndex + step);
    }
    seekProgress(progress) {
      const next = Math.max(0, Math.min(1, Number(progress) || 0));
      this._progress = next;
      const total = this.options.duration + this.options.stagger * Math.max(0, this.targets.length - 1);
      this.elapsedMs = total * next;
      this.renderFromElapsed();
      if (next >= 1) {
        this.finish();
        return this;
      }
      this.remainingMs = total * (1 - next);
      if (!this._paused) this.scheduleCompletion();
      return this;
    }
    seek(time) {
      return this.seekProgress((Number(time) || 0) / Math.max(1, this.totalDuration()));
    }
    restart() {
      return this.reveal(this._modeIndex);
    }
    setSpeed(rate) {
      this._speed = Math.max(0.01, Math.abs(Number(rate) || 1));
      if (!this._paused) this.scheduleCompletion();
      return this;
    }
    pause() {
      this.stopTick?.();
      this.stopTick = null;
      if (!this._paused && this.completionTimer) {
        this.remainingMs = Math.max(0, this.remainingMs - (this.now() - this.startedAt));
        clearTimeout(this.completionTimer);
        this.completionTimer = null;
      }
      this._paused = true;
      return this;
    }
    play() {
      this._paused = false;
      this.startTicker();
      this.scheduleCompletion();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this.stopActiveMotion();
      if (this.options.restore) {
        this.targets.forEach((target) => {
          const original = this.originals.get(target);
          if (!original) return;
          target.style.clipPath = original.clipPath;
          if (original.webkitClipPath) target.style.setProperty("-webkit-clip-path", original.webkitClipPath);
          else target.style.removeProperty("-webkit-clip-path");
          target.style.transform = original.transform;
          target.style.filter = original.filter;
          target.style.opacity = original.opacity;
          target.style.willChange = original.willChange;
          if (original.mode === null) target.removeAttribute("data-pulse-mask-transition");
          else target.setAttribute("data-pulse-mask-transition", original.mode);
        });
      }
      this._disposed = true;
      this._paused = true;
      this.options.onDispose?.(this);
    }
    resolveIndex(mode) {
      if (typeof mode === "number") return wrapIndex3(mode, this.modes.length);
      const index = this.modes.indexOf(mode);
      if (index < 0) throw new Error(`[pulse:mask-transition] unknown mode: ${mode}`);
      return index;
    }
    writeMode() {
      this.targets.forEach((target) => {
        target.dataset.pulseMaskTransition = this.mode;
      });
    }
    finish() {
      if (this._disposed) return;
      this.stopTick?.();
      this.stopTick = null;
      if (this.completionTimer) clearTimeout(this.completionTimer);
      this.completionTimer = null;
      this.remainingMs = 0;
      const revealed = revealedShape(this.mode);
      this.targets.forEach((target) => {
        const original = this.originals.get(target);
        target.style.clipPath = revealed;
        target.style.setProperty("-webkit-clip-path", revealed);
        target.style.transform = original?.transform ?? "";
        target.style.filter = original?.filter ?? "";
        target.style.opacity = original?.opacity ?? "";
        target.style.willChange = original?.willChange ?? "";
      });
      this._progress = 1;
      this._paused = true;
      this.options.onComplete?.(this.mode, this);
    }
    scheduleCompletion() {
      if (this.completionTimer) clearTimeout(this.completionTimer);
      this.startedAt = this.now();
      this.completionTimer = setTimeout(() => this.finish(), Math.max(0, this.remainingMs / this._speed));
    }
    stopActiveMotion() {
      if (this.completionTimer) clearTimeout(this.completionTimer);
      this.completionTimer = null;
      this.stopTick?.();
      this.stopTick = null;
    }
    now() {
      return typeof performance !== "undefined" ? performance.now() : Date.now();
    }
    startTicker() {
      this.stopTick?.();
      this.stopTick = ticker.add((dt) => {
        if (this._paused || this._disposed) return;
        this.elapsedMs += dt * 1e3 * this._speed;
        this.renderFromElapsed();
        if (this.elapsedMs >= this.totalDuration()) this.finish();
      });
    }
    renderFromElapsed() {
      let totalProgress = 0;
      this.targets.forEach((target, index) => {
        const local = clamp015((this.elapsedMs - index * this.options.stagger) / Math.max(1, this.options.duration));
        const progress = this.easeFn(local);
        totalProgress += local;
        this.renderTarget(target, index, progress);
      });
      this._progress = totalProgress / this.targets.length;
    }
    totalDuration() {
      return this.options.duration + this.options.stagger * Math.max(0, this.targets.length - 1);
    }
    renderTarget(target, index, progress) {
      const clip = shapeAt(this.mode, index, progress);
      const scale = 1.075 - 0.075 * progress;
      const rotate = (index % 2 ? 0.65 : -0.65) * (1 - progress);
      const saturation = 0.45 + 0.55 * progress;
      const contrast = 1.18 - 0.18 * progress;
      const brightness = 0.68 + 0.32 * progress;
      target.style.clipPath = clip;
      target.style.setProperty("-webkit-clip-path", clip);
      target.style.transform = `scale(${scale.toFixed(4)}) rotate(${rotate.toFixed(3)}deg)`;
      target.style.filter = `saturate(${saturation.toFixed(3)}) contrast(${contrast.toFixed(3)}) brightness(${brightness.toFixed(3)})`;
      target.style.opacity = String(0.72 + 0.28 * progress);
    }
  };
  var PulseMaskTransitionAdapter = {
    name: "mask-transition",
    test: (target) => Boolean(target?.__pulseMaskTransition),
    props: () => ["progress", "modeIndex", "modeCount", "paused"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "modeIndex") return target.modeIndex;
      if (prop === "modeCount") return target.modeCount;
      if (prop === "paused") return target.paused ? 1 : 0;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "progress") target.seekProgress(value);
      else if (prop === "modeIndex") target.setMode(value);
      else if (prop === "paused") value >= 0.5 ? target.pause() : target.play();
    },
    unit: () => ""
  };
  registerAdapter(PulseMaskTransitionAdapter);
  function maskTransition(targets, options) {
    return new PulseMaskTransition(targets, options);
  }

  // src/particles/particles.ts
  var SHAPES = ["dot", "soft", "square", "ring", "dash", "spark", "bar", "diamond", "shard", "star", "pixel", "image"];
  var EMISSION_MODES = ["radial", "cone", "top", "bottomUp", "scanBars", "orbit", "ring", "line", "imageMask"];
  var BLEND_MODES = ["source-over", "lighter", "screen", "multiply", "overlay", "soft-light", "hard-light", "color-dodge"];
  var IMAGE_MODES = ["background", "sprite", "mask", "bg+mask", "bg+sprite", "all"];
  var PARTICLE_PROPS = ["count", "maxParticles", "spawnRate", "emitterRadius", "burstAmount", "progress", "phase", "spread", "swirl", "gravity", "wind", "drag", "turbulence", "vortex", "size", "opacity", "alpha", "minOpacity", "hue", "colorShift", "trailFade", "glow", "glint", "attract", "z", "direction", "speed", "life", "emission", "edgeCollision", "edgePadding", "debugVectors", "showEmitterRadius", "autoCycle", "emitterCount", "rainbow", "imageOpacity", "maskThreshold", "shapeIndex", "emissionModeIndex", "blendModeIndex", "imageModeIndex"];
  var SUB_PARTICLE_PROPS = ["enabled", "count", "progress", "phase", "spread", "direction", "size", "speed", "life", "gravity", "turbulence", "opacity", "hue", "inherit"];
  function resolveRoot8(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:particles] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:particles] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function rng2(seed) {
    let t = seed >>> 0;
    return () => {
      t += 1831565813;
      let x = Math.imul(t ^ t >>> 15, 1 | t);
      x ^= x + Math.imul(x ^ x >>> 7, 61 | x);
      return ((x ^ x >>> 14) >>> 0) / 4294967296;
    };
  }
  function clamp7(value, min, max2) {
    return Math.max(min, Math.min(max2, Number(value) || 0));
  }
  function clamp016(value) {
    return clamp7(value, 0, 1);
  }
  function degToRad(deg) {
    return deg * Math.PI / 180;
  }
  function normalizeShape(shape) {
    return shape === "circle" ? "dot" : shape ?? "dot";
  }
  function noise2(x, y, z) {
    const v = Math.sin(x * 12.9898 + y * 78.233 + z * 37.719) * 43758.5453;
    return v - Math.floor(v);
  }
  var PulseParticles = class {
    constructor(root, options = {}) {
      this.__pulseParticles = true;
      this.particles = [];
      this._count = 0;
      this._maxParticles = 12e3;
      this._spawnRate = 220;
      this._emitterRadius = 0;
      this._burstAmount = 220;
      this._progress = 0;
      this._phase = 0;
      this._spread = 70;
      this._swirl = 0;
      this._gravity = 0;
      this._wind = 0;
      this._drag = 6e-3;
      this._turbulence = 0;
      this._vortex = 0;
      this._size = 1;
      this._opacity = 1;
      this._minOpacity = 0.08;
      this._hue = 0;
      this._colorShift = 0.15;
      this._trailFade = 0.13;
      this._glow = 28;
      this._glint = 0;
      this._edgeCollision = 0;
      this._edgePadding = 0;
      this._debugVectors = 0;
      this._showEmitterRadius = 0;
      this._autoCycle = 0;
      this._rainbow = 0;
      this._blendMode = "screen";
      this._palette = ["#ff4518", "#ff8b1a", "#ffd166", "#7cff4d"];
      this._imageUrl = "";
      this._imageMode = "background";
      this._imageOpacity = 0.3;
      this._maskThreshold = 32;
      this._emitters = [{ x: 0, y: 0 }];
      this._attract = 0;
      this._z = 0;
      this._direction = -90;
      this._speed = 1;
      this._life = 1;
      this._emission = 0;
      this._disposed = false;
      this.root = resolveRoot8(root);
      this.shape = normalizeShape(options.shape);
      this._emissionMode = options.emissionMode ?? "radial";
      this._maxParticles = Math.max(0, Math.round(options.maxParticles ?? this._maxParticles));
      this._spawnRate = Math.max(0, options.spawnRate ?? this._spawnRate);
      this._emitterRadius = Math.max(0, options.emitterRadius ?? this._emitterRadius);
      this._burstAmount = Math.max(0, Math.round(options.burstAmount ?? this._burstAmount));
      this._progress = clamp016(options.progress ?? this._progress);
      this._phase = options.phase ?? this._phase;
      this._spread = options.spread ?? this._spread;
      this._swirl = options.swirl ?? this._swirl;
      this._gravity = options.gravity ?? this._gravity;
      this._wind = options.wind ?? this._wind;
      this._drag = Math.max(0, options.drag ?? this._drag);
      this._turbulence = options.turbulence ?? this._turbulence;
      this._vortex = options.vortex ?? this._vortex;
      this._size = Math.max(0.01, options.size ?? this._size);
      this._opacity = clamp016(options.opacity ?? options.alpha ?? this._opacity);
      this._minOpacity = clamp016(options.minOpacity ?? this._minOpacity);
      this._hue = options.hue ?? this._hue;
      this._attract = options.attract ?? this._attract;
      this._z = options.z ?? this._z;
      this._direction = options.direction ?? this._direction;
      this._speed = Math.max(0, options.speed ?? this._speed);
      this._life = Math.max(0.01, options.life ?? this._life);
      this._emission = clamp016(options.emission ?? this._emission);
      this._colorShift = options.colorShift ?? this._colorShift;
      this._trailFade = clamp016(options.trailFade ?? this._trailFade);
      this._glow = Math.max(0, options.glow ?? this._glow);
      this._glint = clamp016(options.glint ?? this._glint);
      this._edgeCollision = options.edgeCollision ? 1 : 0;
      this._edgePadding = Math.max(0, options.edgePadding ?? this._edgePadding);
      this._debugVectors = options.debugVectors ? 1 : 0;
      this._showEmitterRadius = options.showEmitterRadius ? 1 : 0;
      this._autoCycle = options.autoCycle ? 1 : 0;
      this._rainbow = options.rainbow ? 1 : 0;
      this._blendMode = options.blendMode ?? this._blendMode;
      this._palette = [options.colorA ?? this._palette[0], options.colorB ?? this._palette[1], options.colorC ?? this._palette[2], options.colorD ?? this._palette[3]];
      this._imageUrl = options.imageUrl ?? "";
      this._imageMode = options.imageMode ?? this._imageMode;
      this._imageOpacity = clamp016(options.imageOpacity ?? this._imageOpacity);
      this._maskThreshold = clamp7(options.maskThreshold ?? this._maskThreshold, 0, 255);
      this.root.classList.add("pulse-particles");
      this.root.style.position = this.root.style.position || "relative";
      this.root.style.overflow = this.root.style.overflow || "hidden";
      this.root.style.isolation = this.root.style.isolation || "isolate";
      this.root.style.transformStyle = this.root.style.transformStyle || "preserve-3d";
      this._backgroundEl = document.createElement("i");
      this._backgroundEl.className = "pulse-particle-background";
      this._guideEl = document.createElement("i");
      this._guideEl.className = "pulse-particle-emitter-guide";
      this.subParticles = new PulseSubParticles(this, options.subParticles);
      this.rebuild(options.count ?? 24, options);
      if (this._autoCycle) this.setAutoCycle(true);
    }
    get count() {
      return this._count;
    }
    get maxParticles() {
      return this._maxParticles;
    }
    get spawnRate() {
      return this._spawnRate;
    }
    get emitterRadius() {
      return this._emitterRadius;
    }
    get burstAmount() {
      return this._burstAmount;
    }
    get progress() {
      return this._progress;
    }
    get phase() {
      return this._phase;
    }
    get spread() {
      return this._spread;
    }
    get swirl() {
      return this._swirl;
    }
    get gravity() {
      return this._gravity;
    }
    get wind() {
      return this._wind;
    }
    get drag() {
      return this._drag;
    }
    get turbulence() {
      return this._turbulence;
    }
    get vortex() {
      return this._vortex;
    }
    get size() {
      return this._size;
    }
    get opacity() {
      return this._opacity;
    }
    get alpha() {
      return this._opacity;
    }
    get minOpacity() {
      return this._minOpacity;
    }
    get hue() {
      return this._hue;
    }
    get colorShift() {
      return this._colorShift;
    }
    get trailFade() {
      return this._trailFade;
    }
    get glow() {
      return this._glow;
    }
    get glint() {
      return this._glint;
    }
    get attract() {
      return this._attract;
    }
    get z() {
      return this._z;
    }
    get direction() {
      return this._direction;
    }
    get speed() {
      return this._speed;
    }
    get life() {
      return this._life;
    }
    get emission() {
      return this._emission;
    }
    get emissionMode() {
      return this._emissionMode;
    }
    get edgeCollision() {
      return this._edgeCollision;
    }
    get edgePadding() {
      return this._edgePadding;
    }
    get debugVectors() {
      return this._debugVectors;
    }
    get showEmitterRadius() {
      return this._showEmitterRadius;
    }
    get autoCycle() {
      return this._autoCycle;
    }
    get emitterCount() {
      return this._emitters.length;
    }
    get rainbow() {
      return this._rainbow;
    }
    get shapeIndex() {
      return Math.max(0, SHAPES.indexOf(this.shape));
    }
    get emissionModeIndex() {
      return Math.max(0, EMISSION_MODES.indexOf(this._emissionMode));
    }
    get blendModeIndex() {
      return Math.max(0, BLEND_MODES.indexOf(this._blendMode));
    }
    get imageModeIndex() {
      return Math.max(0, IMAGE_MODES.indexOf(this._imageMode));
    }
    get imageOpacity() {
      return this._imageOpacity;
    }
    get maskThreshold() {
      return this._maskThreshold;
    }
    get imageUrl() {
      return this._imageUrl;
    }
    rebuild(count, options = {}) {
      const nextCount = Math.min(this._maxParticles, Math.max(0, Math.round(count)));
      this._count = nextCount;
      this.root.innerHTML = "";
      this.mountImageLayer();
      this.particles = [];
      const rand = rng2(options.seed ?? 1337);
      for (let i = 0; i < nextCount; i++) {
        const el = document.createElement("i");
        el.className = `pulse-particle pulse-particle-${this.shape}`;
        if (options.className) el.classList.add(options.className);
        el.textContent = options.label ? options.label(i) : "";
        el.dataset.particleIndex = String(i);
        el.style.position = "absolute";
        el.style.left = "50%";
        el.style.top = "50%";
        el.style.willChange = "transform, opacity, background, border-color";
        this.root.appendChild(el);
        this.particles.push({
          el,
          angle: rand() * Math.PI * 2,
          radius: 0.25 + rand() * 0.75,
          depth: rand() * 2 - 1,
          drift: rand() * Math.PI * 2,
          size: 0.55 + rand() * 1.25,
          hue: rand() * 360
        });
      }
      this.subParticles.rebuild();
      this.write();
      return this;
    }
    emit(count = this._burstAmount || this._count) {
      this.rebuild(count, { shape: this.shape, emissionMode: this._emissionMode, seed: Math.round(this._phase * 1e4 + this._hue + count) });
      return this;
    }
    writeProp(prop, value) {
      if (prop === "count") this.rebuild(value, { shape: this.shape, emissionMode: this._emissionMode, seed: Math.round(this._hue + value) });
      else if (prop === "maxParticles") {
        this._maxParticles = Math.max(0, Math.round(value));
        if (this._count > this._maxParticles) this.rebuild(this._maxParticles);
      } else if (prop === "spawnRate") this._spawnRate = Math.max(0, Number(value) || 0);
      else if (prop === "emitterRadius") this._emitterRadius = Math.max(0, Number(value) || 0);
      else if (prop === "burstAmount") this._burstAmount = Math.max(0, Math.round(value));
      else if (prop === "progress") this._progress = clamp016(value);
      else if (prop === "phase") this._phase = Number(value) || 0;
      else if (prop === "spread") this._spread = Number(value) || 0;
      else if (prop === "swirl") this._swirl = Number(value) || 0;
      else if (prop === "gravity") this._gravity = Number(value) || 0;
      else if (prop === "wind") this._wind = Number(value) || 0;
      else if (prop === "drag") this._drag = Math.max(0, Number(value) || 0);
      else if (prop === "turbulence") this._turbulence = Number(value) || 0;
      else if (prop === "vortex") this._vortex = Number(value) || 0;
      else if (prop === "size") this._size = Math.max(0.01, Number(value) || 0.01);
      else if (prop === "opacity" || prop === "alpha") this._opacity = clamp016(value);
      else if (prop === "minOpacity") this._minOpacity = clamp016(value);
      else if (prop === "hue") this._hue = Number(value) || 0;
      else if (prop === "colorShift") this._colorShift = Number(value) || 0;
      else if (prop === "trailFade") this._trailFade = clamp016(value);
      else if (prop === "glow") this._glow = Math.max(0, Number(value) || 0);
      else if (prop === "glint") this._glint = clamp016(value);
      else if (prop === "attract") this._attract = Number(value) || 0;
      else if (prop === "z") this._z = Number(value) || 0;
      else if (prop === "direction") this._direction = Number(value) || 0;
      else if (prop === "speed") this._speed = Math.max(0, Number(value) || 0);
      else if (prop === "life") this._life = Math.max(0.01, Number(value) || 0.01);
      else if (prop === "emission") this._emission = clamp016(value);
      else if (prop === "edgeCollision") this._edgeCollision = value >= 0.5 ? 1 : 0;
      else if (prop === "edgePadding") this._edgePadding = Math.max(0, Number(value) || 0);
      else if (prop === "debugVectors") this._debugVectors = value >= 0.5 ? 1 : 0;
      else if (prop === "showEmitterRadius") this._showEmitterRadius = value >= 0.5 ? 1 : 0;
      else if (prop === "autoCycle") {
        this.setAutoCycle(value >= 0.5);
        return;
      } else if (prop === "rainbow") this._rainbow = value >= 0.5 ? 1 : 0;
      else if (prop === "imageOpacity") this._imageOpacity = clamp016(value);
      else if (prop === "maskThreshold") this._maskThreshold = clamp7(value, 0, 255);
      else if (prop === "shapeIndex") this.setShape(SHAPES[(Math.round(value) % SHAPES.length + SHAPES.length) % SHAPES.length]);
      else if (prop === "emissionModeIndex") this._emissionMode = EMISSION_MODES[(Math.round(value) % EMISSION_MODES.length + EMISSION_MODES.length) % EMISSION_MODES.length];
      else if (prop === "blendModeIndex") this._blendMode = BLEND_MODES[(Math.round(value) % BLEND_MODES.length + BLEND_MODES.length) % BLEND_MODES.length];
      else if (prop === "imageModeIndex") this._imageMode = IMAGE_MODES[(Math.round(value) % IMAGE_MODES.length + IMAGE_MODES.length) % IMAGE_MODES.length];
      this.write();
    }
    setShape(shape) {
      this.shape = normalizeShape(shape);
      this.rebuild(this._count, { shape: this.shape, emissionMode: this._emissionMode, seed: Math.round(this._phase * 1e3 + this._hue) });
      return this;
    }
    setEmissionMode(mode) {
      this._emissionMode = mode;
      this.write();
      return this;
    }
    setBlendMode(mode) {
      this._blendMode = mode;
      this.write();
      return this;
    }
    setPalette(colors) {
      this._palette = colors;
      this.write();
      return this;
    }
    setImageSource(url, mode = this._imageMode) {
      this._imageUrl = url;
      this._imageMode = mode;
      this.mountImageLayer();
      this.write();
      return this;
    }
    clearImage() {
      this._imageUrl = "";
      this.mountImageLayer();
      this.write();
      return this;
    }
    addEmitter(x = 0, y = 0) {
      this._emitters.push({ x, y });
      this.write();
      return this;
    }
    resetEmitters() {
      this._emitters = [{ x: 0, y: 0 }];
      this.write();
      return this;
    }
    setAutoCycle(enabled) {
      this._stopAuto?.();
      this._stopAuto = void 0;
      this._autoCycle = enabled ? 1 : 0;
      if (enabled) this._stopAuto = ticker.add((dt) => {
        this._phase = (this._phase + dt * Math.max(0.05, this._speed)) % 1;
        this._progress = (this._progress + dt / Math.max(0.05, this._life)) % 1;
        this.write();
      });
      return this;
    }
    refresh() {
      this.write();
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this._stopAuto?.();
      this.root.innerHTML = "";
      this.particles = [];
      this.subParticles.dispose();
    }
    particlePose(particle, index, localOverride) {
      const t = localOverride ?? (this.particles.length <= 1 ? this._progress : clamp7(this._progress - index / this.particles.length * 0.25, 0, 1));
      const p = this._phase * Math.PI * 2;
      const emit = this.spawnOffset(particle, index, t);
      const angle = emit.angle + this._swirl * t;
      const wobble = Math.sin(p + particle.drift + index * 0.73) * this._turbulence;
      const age = clamp7(t / Math.max(0.01, this._life), 0, 1);
      const radius = this._emitterRadius + emit.radius * this._spread * this._speed * (0.25 + age * 0.95);
      const pull = this._attract * (1 - t);
      let x = emit.x + Math.cos(angle) * radius + wobble - Math.cos(angle) * pull;
      let y = emit.y + Math.sin(angle) * radius + this._gravity * t + Math.cos(p + particle.drift) * this._turbulence * 0.5 - Math.sin(angle) * pull;
      if (this._vortex !== 0) {
        const orbit = this._vortex * 0.08 * t;
        const ox = Math.cos(angle + orbit) * radius * 0.12;
        const oy = Math.sin(angle + orbit) * radius * 0.12;
        x += ox;
        y += oy;
      }
      x += this._wind * t;
      const drag = Math.max(0.08, 1 - this._drag * 4 * t);
      x *= drag;
      y *= drag;
      const z = particle.depth * this._z * t;
      const scale = particle.size * this._size * (0.55 + t * 0.7);
      const hue = (particle.hue + this._hue + index * 7) % 360;
      if (this._edgeCollision) {
        const spriteRadius = Math.max(1, 4 * scale);
        const inset2 = this._edgePadding + spriteRadius;
        const halfW = Math.max(0, this.root.clientWidth * 0.5 - inset2);
        const halfH = Math.max(0, this.root.clientHeight * 0.5 - inset2);
        x = clamp7(x, -halfW, halfW);
        y = clamp7(y, -halfH, halfH);
      }
      const shiftedHue = hue + index * this._colorShift * 90 + (this._rainbow ? index / Math.max(1, this._count) * 360 : 0);
      return { x, y, z, scale, hue: shiftedHue, angle, local: t };
    }
    spawnOffset(particle, index, local) {
      const p = this._phase * Math.PI * 2;
      const mode = this._emissionMode;
      const emissionPulse = this._emission * 2 - 1;
      let x = 0;
      let y = 0;
      let angle = particle.angle + p;
      let radius = particle.radius;
      if (mode === "cone") {
        angle = degToRad(this._direction) + (particle.radius - 0.5) * degToRad(this._spread || 1) + p * 0.15;
      } else if (mode === "top") {
        x = (particle.radius - 0.5) * this._spread * 2;
        y = -this._spread * (1 - local) - 40 * particle.radius;
        angle = degToRad(90) + p * 0.08;
      } else if (mode === "bottomUp") {
        x = (particle.radius - 0.5) * this._spread * 2;
        y = this._spread * (1 - local) + 40 * particle.radius;
        angle = degToRad(-90) + p * 0.08;
      } else if (mode === "scanBars") {
        x = (particle.radius - 0.5) * this._spread * 2.2;
        y = Math.sin(p + index * 0.41) * this._spread * 0.85;
        angle = degToRad(this._direction) + Math.sin(p + particle.drift) * 0.45;
        radius = 0.35 + particle.radius * 0.25;
      } else if (mode === "orbit") {
        angle = p + particle.angle;
        radius = 0.85 + particle.radius * 0.25;
      } else if (mode === "ring") {
        angle = particle.angle;
        radius = 0.7 + Math.abs(emissionPulse) * 0.6;
      } else if (mode === "line") {
        x = (index / Math.max(1, this.particles.length - 1) - 0.5) * this._spread * 2;
        y = Math.sin(p + particle.drift) * this._turbulence * 0.35;
        radius = 0.18 + particle.radius * 0.16;
      } else if (mode === "imageMask") {
        const cols = Math.max(1, Math.ceil(Math.sqrt(this.particles.length)));
        x = (index % cols / Math.max(1, cols - 1) - 0.5) * Math.max(1, this.root.clientWidth);
        y = (Math.floor(index / cols) / Math.max(1, Math.ceil(this.particles.length / cols) - 1) - 0.5) * Math.max(1, this.root.clientHeight);
        angle = degToRad(this._direction);
        radius = 0.04;
      }
      const emitter = this._emitters[index % this._emitters.length];
      return { x: x + emitter.x, y: y + emitter.y, angle, radius };
    }
    write() {
      this.root.style.setProperty("--particle-progress", String(this._progress));
      this.root.style.setProperty("--particle-phase", String(this._phase));
      this.mountImageLayer();
      this.mountGuide();
      const visibleCount = Math.min(this._count, Math.max(0, Math.ceil(this._spawnRate * this._life)));
      const sprite = this._imageUrl && ["sprite", "bg+sprite", "all"].includes(this._imageMode);
      this.particles.forEach((particle, index) => {
        const pose = this.particlePose(particle, index);
        const paletteColor = this._rainbow ? void 0 : this._palette[Math.abs(Math.floor(index * Math.max(0.01, this._colorShift))) % this._palette.length];
        writeParticleElement(particle.el, this.shape, pose.scale, pose.hue, pose.local, index < visibleCount ? this._opacity : 0, pose.angle, pose.x, pose.y, pose.z, particle.depth, this._glow, this._trailFade, this._blendMode, paletteColor, sprite ? this._imageUrl : "", this._glint, this._minOpacity);
      });
      this.subParticles.refresh();
    }
    mountImageLayer() {
      if (!this._imageUrl) {
        this._backgroundEl.remove();
        this.root.style.maskImage = "";
        this.root.style.maskSize = "";
        this.root.style.maskPosition = "";
        this.root.style.maskRepeat = "";
        return;
      }
      const showBackground = Boolean(this._imageUrl && ["background", "bg+mask", "bg+sprite", "all"].includes(this._imageMode));
      if (!this._backgroundEl.isConnected) this.root.prepend(this._backgroundEl);
      Object.assign(this._backgroundEl.style, { position: "absolute", inset: "0", pointerEvents: "none", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "contain", zIndex: "0" });
      this._backgroundEl.style.backgroundImage = showBackground ? `url("${this._imageUrl.replace(/"/g, '\\"')}")` : "";
      this._backgroundEl.style.opacity = showBackground ? String(this._imageOpacity) : "0";
      const useMask = Boolean(this._imageUrl && ["mask", "bg+mask", "all"].includes(this._imageMode));
      this.root.style.setProperty("--particle-mask-threshold", String(this._maskThreshold));
      this.root.style.maskImage = useMask ? `url("${this._imageUrl.replace(/"/g, '\\"')}")` : "";
      this.root.style.maskSize = useMask ? "contain" : "";
      this.root.style.maskPosition = useMask ? "center" : "";
      this.root.style.maskRepeat = useMask ? "no-repeat" : "";
    }
    mountGuide() {
      this.root.dataset.pulseDebugVectors = this._debugVectors ? "true" : "false";
      if (!this._showEmitterRadius) {
        this._guideEl.remove();
        return;
      }
      if (!this._guideEl.isConnected) this.root.append(this._guideEl);
      const diameter = Math.max(2, this._emitterRadius * 2);
      Object.assign(this._guideEl.style, { position: "absolute", left: "50%", top: "50%", width: `${diameter}px`, height: `${diameter}px`, transform: "translate(-50%,-50%)", border: "1px dashed rgba(124,255,77,.72)", borderRadius: "50%", pointerEvents: "none", zIndex: "4", display: this._showEmitterRadius ? "block" : "none" });
    }
  };
  var PulseSubParticles = class {
    constructor(parent, options = {}) {
      this.__pulseSubParticles = true;
      this.particles = [];
      this._enabled = 0;
      this._count = 3;
      this._progress = 0.7;
      this._phase = 0;
      this._spread = 42;
      this._direction = 0;
      this._size = 0.55;
      this._speed = 30;
      this._life = 1;
      this._gravity = 0;
      this._turbulence = 10;
      this._opacity = 0.82;
      this._hue = 45;
      this._inherit = 0.28;
      this._shape = "soft";
      this._spawnMode = "trail";
      this._palette = ["#ffffff", "#ffd166", "#7cff4d", "#4dfcff"];
      this._disposed = false;
      this.parent = parent;
      this._enabled = options.enabled ? 1 : 0;
      this._count = Math.max(0, Math.round(options.count ?? this._count));
      this._shape = normalizeShape(options.shape ?? this._shape);
      this._spawnMode = options.spawnMode ?? this._spawnMode;
      this._spread = options.spread ?? this._spread;
      this._direction = options.direction ?? this._direction;
      this._size = options.size ?? this._size;
      this._speed = options.speed ?? this._speed;
      this._life = options.life ?? this._life;
      this._gravity = options.gravity ?? this._gravity;
      this._turbulence = options.turbulence ?? this._turbulence;
      this._opacity = options.opacity ?? this._opacity;
      this._hue = options.hue ?? this._hue;
      this._inherit = options.inherit ?? this._inherit;
      this._palette = [options.colorA ?? this._palette[0], options.colorB ?? this._palette[1], options.colorC ?? this._palette[2], options.colorD ?? this._palette[3]];
    }
    get enabled() {
      return this._enabled;
    }
    get count() {
      return this._count;
    }
    get progress() {
      return this._progress;
    }
    get phase() {
      return this._phase;
    }
    get spread() {
      return this._spread;
    }
    get direction() {
      return this._direction;
    }
    get size() {
      return this._size;
    }
    get speed() {
      return this._speed;
    }
    get life() {
      return this._life;
    }
    get gravity() {
      return this._gravity;
    }
    get turbulence() {
      return this._turbulence;
    }
    get opacity() {
      return this._opacity;
    }
    get hue() {
      return this._hue;
    }
    get inherit() {
      return this._inherit;
    }
    get shape() {
      return this._shape;
    }
    get spawnMode() {
      return this._spawnMode;
    }
    rebuild() {
      this.particles.forEach((particle) => particle.el.remove());
      this.particles = [];
      if (!this._enabled || this._count <= 0 || this.parent.particles.length <= 0) return this;
      const rand = rng2(Math.round(this.parent.hue + this._count * 91 + this.parent.count));
      this.parent.particles.forEach((_parentParticle, parentIndex) => {
        for (let childIndex = 0; childIndex < this._count; childIndex++) {
          const el = document.createElement("i");
          el.className = `pulse-particle pulse-sub-particle pulse-particle-${this._shape}`;
          el.dataset.subParticleIndex = `${parentIndex}:${childIndex}`;
          el.style.position = "absolute";
          el.style.left = "50%";
          el.style.top = "50%";
          el.style.willChange = "transform, opacity, background, border-color";
          this.parent.root.appendChild(el);
          this.particles.push({
            el,
            parent: parentIndex,
            birth: childIndex / Math.max(1, this._count),
            angle: rand() * Math.PI * 2,
            radius: 0.2 + rand() * 0.8,
            depth: rand() * 2 - 1,
            drift: rand() * Math.PI * 2,
            size: 0.45 + rand() * 1.1,
            hue: rand() * 360,
            speed: 0.35 + rand() * 0.9,
            inherit: rand()
          });
        }
      });
      this.refresh();
      return this;
    }
    writeProp(prop, value) {
      if (prop === "enabled") {
        const next = value > 0 ? 1 : 0;
        if (next !== this._enabled) {
          this._enabled = next;
          this.rebuild();
          return;
        }
      } else if (prop === "count") {
        const next = Math.max(0, Math.round(value));
        if (next !== this._count) {
          this._count = next;
          this.rebuild();
          return;
        }
      } else if (prop === "progress") this._progress = clamp016(value);
      else if (prop === "phase") this._phase = Number(value) || 0;
      else if (prop === "spread") this._spread = Number(value) || 0;
      else if (prop === "direction") this._direction = Number(value) || 0;
      else if (prop === "size") this._size = Math.max(0.01, Number(value) || 0.01);
      else if (prop === "speed") this._speed = Math.max(0, Number(value) || 0);
      else if (prop === "life") this._life = Math.max(0.01, Number(value) || 0.01);
      else if (prop === "gravity") this._gravity = Number(value) || 0;
      else if (prop === "turbulence") this._turbulence = Number(value) || 0;
      else if (prop === "opacity") this._opacity = clamp016(value);
      else if (prop === "hue") this._hue = Number(value) || 0;
      else if (prop === "inherit") this._inherit = clamp016(value);
      this.refresh();
    }
    setShape(shape) {
      this._shape = normalizeShape(shape);
      this.rebuild();
      this.refresh();
      return this;
    }
    setSpawnMode(mode) {
      this._spawnMode = mode;
      this.refresh();
      return this;
    }
    setPalette(colors) {
      this._palette = colors;
      this.refresh();
      return this;
    }
    refresh() {
      if (!this._enabled) {
        this.particles.forEach((particle) => {
          particle.el.style.opacity = "0";
        });
        return this;
      }
      const phase = (this._phase + this.parent.phase) * Math.PI * 2;
      this.particles.forEach((particle, index) => {
        const parent = this.parent.particles[particle.parent];
        if (!parent) return;
        const parentPose = this.parent.particlePose(parent, particle.parent);
        const cycle = (this._progress + particle.birth + this.parent.progress * 0.35) % 1;
        const active = this._spawnMode === "death" ? Math.max(0, (cycle - 0.62) / 0.38) : cycle;
        const angle = degToRad(this._direction) + particle.angle + phase + (particle.radius - 0.5) * degToRad(this._spread);
        const noise = (noise2(index * 0.13, particle.drift, phase * 0.1) - 0.5) * this._turbulence * active;
        const speed = this._speed * particle.speed * active * this._life;
        const inheritX = Math.cos(parentPose.angle) * this._speed * this._inherit * particle.inherit;
        const inheritY = Math.sin(parentPose.angle) * this._speed * this._inherit * particle.inherit;
        const x = parentPose.x + Math.cos(angle) * speed + inheritX + noise;
        const y = parentPose.y + Math.sin(angle) * speed + inheritY + this._gravity * active + noise * 0.35;
        const z = parentPose.z + particle.depth * this.parent.z * 0.35;
        const fade = this._spawnMode === "trail" ? 1 - active : Math.sin(active * Math.PI);
        const scale = this._size * particle.size * (0.45 + active * 0.9);
        const hue = (parentPose.hue + particle.hue * 0.2 + this._hue) % 360;
        writeParticleElement(particle.el, this._shape, scale, hue, clamp016(fade), this._opacity, angle, x, y, z, particle.depth, 18, 0.1, "screen", this._palette[index % this._palette.length]);
      });
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.particles.forEach((particle) => particle.el.remove());
      this.particles = [];
    }
  };
  function writeParticleElement(el, shape, scale, hue, local, opacity, angle, x, y, z, depth, glow = 28, trailFade = 0.13, blendMode = "screen", paletteColor, imageUrl = "", glint = 0, minOpacity = 0.08) {
    const px = Math.max(2, 8 * scale);
    const long = shape === "dash" || shape === "spark" || shape === "bar";
    el.style.width = `${(long ? px * 2.5 : px).toFixed(2)}px`;
    el.style.height = `${(shape === "dash" ? Math.max(2, px * 0.28) : shape === "spark" || shape === "bar" ? Math.max(2, px * 1.8) : px).toFixed(2)}px`;
    const opacityFloor = clamp016(minOpacity);
    el.style.opacity = String(opacity * (opacityFloor + local * Math.max(0, 1 - opacityFloor - trailFade * 0.25)));
    const lightness = clamp7(55 + depth * 10, 35, 76);
    const color2 = paletteColor ?? `hsl(${hue} 88% ${lightness}%)`;
    if (imageUrl) {
      el.style.background = `center / contain no-repeat url("${imageUrl.replace(/"/g, '\\"')}")`;
      el.style.borderColor = "transparent";
      const shimmer = (Math.sin((local + depth * 0.41) * Math.PI * 2) + 1) * 0.5;
      const lift = 1 + glint * shimmer * 0.85;
      el.style.filter = `brightness(${lift.toFixed(3)}) contrast(${(1 + glint * 0.22).toFixed(3)}) drop-shadow(0 0 ${(glint * (2 + shimmer * 4)).toFixed(2)}px rgba(255,255,255,${(glint * (0.22 + shimmer * 0.5)).toFixed(3)}))`;
    } else if (shape === "ring") {
      el.style.filter = "";
      el.style.background = "transparent";
      el.style.borderColor = color2;
      el.style.color = color2;
    } else {
      el.style.filter = "";
      el.style.background = shape === "soft" ? `radial-gradient(circle, ${color2} 0%, hsl(${hue} 88% ${lightness}% / .42) 42%, transparent 72%)` : color2;
      el.style.borderColor = color2;
      el.style.color = color2;
    }
    el.style.boxShadow = `0 0 ${Math.max(0, glow * local).toFixed(1)}px hsl(${hue} 88% 62% / .7)`;
    el.style.mixBlendMode = blendMode;
    el.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, ${z.toFixed(2)}px) rotate(${(angle * 180 / Math.PI).toFixed(2)}deg) scale(${scale.toFixed(3)})`;
  }
  var PulseParticlesAdapter = {
    test: (target) => Boolean(target?.__pulseParticles),
    props: () => [...PARTICLE_PROPS],
    get: (target, prop) => {
      if (prop in target) return Number(target[prop]) || 0;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "direction" ? "deg" : ["spread", "gravity", "wind", "turbulence", "attract", "z", "speed"].includes(prop) ? "px" : ""
  };
  var PulseSubParticlesAdapter = {
    test: (target) => Boolean(target?.__pulseSubParticles),
    props: () => [...SUB_PARTICLE_PROPS],
    get: (target, prop) => {
      if (prop in target) return Number(target[prop]) || 0;
      return 0;
    },
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "direction" ? "deg" : ["spread", "speed", "gravity", "turbulence"].includes(prop) ? "px" : ""
  };
  registerAdapter(PulseSubParticlesAdapter);
  registerAdapter(PulseParticlesAdapter);
  function particles(root, params) {
    return new PulseParticles(root, params);
  }
  function subParticles(parent, params) {
    if (params) {
      Object.entries(params).forEach(([key2, value]) => {
        if (typeof value === "number" || typeof value === "boolean") parent.subParticles.writeProp(key2, Number(value));
      });
    }
    return parent.subParticles;
  }

  // src/texture/texture-maps.ts
  var MAP_NAMES = ["albedo", "roughness", "metallic", "normal", "height", "ao", "emissive", "opacity"];
  var SOURCE_MODES = ["image", "noise", "grunge", "fabric", "metal", "panels", "holo", "staticMotion", "scanLines", "cracks", "ripples", "waves"];
  var PROPS2 = ["time", "animSpeed", "animate", "showChecker", "size", "noiseScale", "patternDensity", "detailMix", "animAmplitude", "animFrequency", "driftX", "driftY", "lineDensity", "lineThickness", "crackDensity", "crackWidth", "rippleCount", "rippleSharpness", "waveAngle", "waveDistortion", "brightness", "contrast", "saturation", "tintMix", "heightStrength", "normalStrength", "roughnessBias", "roughnessContrast", "metallicBias", "metallicThreshold", "aoStrength", "emissiveThreshold", "emissiveBoost", "opacityThreshold", "blurRadius", "previewTiles", "invertBase", "useAlphaForOpacity", "sourceModeIndex", "previewMapIndex", "renderInterval"];
  function resolveRoot9(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:texture-maps] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:texture-maps] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function clamp8(v, min = 0, max2 = 1) {
    return Math.max(min, Math.min(max2, Number(v) || 0));
  }
  function lerp4(a, b, t) {
    return a + (b - a) * t;
  }
  function mix(a, b, t) {
    return a * (1 - t) + b * t;
  }
  function smooth2(t) {
    return t * t * (3 - 2 * t);
  }
  function smoothStep2(a, b, x) {
    const t = clamp8((x - a) / Math.max(1e-5, b - a));
    return t * t * (3 - 2 * t);
  }
  function randHash2(x, y) {
    const s = Math.sin(x * 127.1 + y * 311.7) * 43758.5453123;
    return s - Math.floor(s);
  }
  function valueNoise2(x, y) {
    const xi = Math.floor(x), yi = Math.floor(y);
    const xf = x - xi, yf = y - yi;
    const a = randHash2(xi, yi), b = randHash2(xi + 1, yi), c = randHash2(xi, yi + 1), d = randHash2(xi + 1, yi + 1);
    const ux = smooth2(xf), uy = smooth2(yf);
    return lerp4(lerp4(a, b, ux), lerp4(c, d, ux), uy);
  }
  function fractalNoise2(x, y, octaves) {
    let total = 0, amp = 1, freq = 1, max2 = 0;
    for (let i = 0; i < octaves; i++) {
      total += valueNoise2(x * freq, y * freq) * amp;
      max2 += amp;
      amp *= 0.5;
      freq *= 2;
    }
    return total / max2;
  }
  function hexToRgb2(hex) {
    const clean = hex.startsWith("#") ? hex.slice(1) : hex;
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean.padEnd(6, "0").slice(0, 6);
    const n = parseInt(full, 16);
    return { r: n >> 16 & 255, g: n >> 8 & 255, b: n & 255 };
  }
  function gradient(colors, t) {
    const p = clamp8(t) * (colors.length - 1);
    const i = Math.min(colors.length - 2, Math.floor(p));
    const f = p - i;
    const a = colors[i], b = colors[i + 1];
    return { r: lerp4(a.r, b.r, f), g: lerp4(a.g, b.g, f), b: lerp4(a.b, b.b, f) };
  }
  function adjustBCS(r, g, b, brightness, contrast, saturation) {
    r *= brightness;
    g *= brightness;
    b *= brightness;
    r = (r - 0.5) * contrast + 0.5;
    g = (g - 0.5) * contrast + 0.5;
    b = (b - 0.5) * contrast + 0.5;
    const lum = r * 0.2126 + g * 0.7152 + b * 0.0722;
    return [lerp4(lum, r, saturation), lerp4(lum, g, saturation), lerp4(lum, b, saturation)];
  }
  function distToSegment2(px, py, ax, ay, bx, by) {
    const vx = bx - ax, vy = by - ay, wx = px - ax, wy = py - ay;
    const len2 = vx * vx + vy * vy || 1e-5;
    const t = clamp8((wx * vx + wy * vy) / len2);
    const dx = px - (ax + vx * t), dy = py - (ay + vy * t);
    return Math.sqrt(dx * dx + dy * dy);
  }
  var PulseTextureMaps = class {
    constructor(root, options = {}) {
      this.__pulseTextureMaps = true;
      this.canvases = /* @__PURE__ */ new Map();
      this.renderQueued = false;
      this.lastRender = 0;
      this.disposed = false;
      this.root = resolveRoot9(root);
      this.root.classList.add("pulse-texture-maps");
      this.sourceMode = options.sourceMode ?? "cracks";
      this.size = Math.max(32, Math.round(options.size ?? 96));
      this.previewMap = options.previewMap ?? "albedo";
      this.previewTiles = Math.max(1, Math.round(options.previewTiles ?? 2));
      this.blurRadius = Math.max(0, options.blurRadius ?? 0);
      this.invertBase = options.invertBase ?? false;
      this.useAlphaForOpacity = options.useAlphaForOpacity ?? false;
      this.animSpeed = Math.max(0, options.animSpeed ?? 1);
      this.animate = options.animate ?? false;
      this.showChecker = options.showChecker ?? true;
      this.noiseScale = options.noiseScale ?? 8;
      this.patternDensity = options.patternDensity ?? 12;
      this.detailMix = options.detailMix ?? 0.45;
      this.time = options.time ?? 0;
      this.animAmplitude = options.animAmplitude ?? 1;
      this.animFrequency = options.animFrequency ?? 3;
      this.driftX = options.driftX ?? 0.7;
      this.driftY = options.driftY ?? 0.25;
      this.lineDensity = options.lineDensity ?? 28;
      this.lineThickness = options.lineThickness ?? 4;
      this.crackDensity = options.crackDensity ?? 18;
      this.crackWidth = options.crackWidth ?? 1.5;
      this.rippleCount = options.rippleCount ?? 7;
      this.rippleSharpness = options.rippleSharpness ?? 1.35;
      this.waveAngle = options.waveAngle ?? 18;
      this.waveDistortion = options.waveDistortion ?? 0.55;
      this.brightness = options.brightness ?? 1;
      this.contrast = options.contrast ?? 1.35;
      this.saturation = options.saturation ?? 1;
      this.tintMix = options.tintMix ?? 0.45;
      this.tintA = options.tintA ?? "#141416";
      this.tintB = options.tintB ?? "#535354";
      this.tintC = options.tintC ?? "#909090";
      this.tintD = options.tintD ?? "#d7d7d7";
      this.heightStrength = options.heightStrength ?? 1;
      this.normalStrength = options.normalStrength ?? 3;
      this.roughnessBias = options.roughnessBias ?? 0.55;
      this.roughnessContrast = options.roughnessContrast ?? 1.2;
      this.metallicBias = options.metallicBias ?? 0.15;
      this.metallicThreshold = options.metallicThreshold ?? 0.65;
      this.aoStrength = options.aoStrength ?? 1;
      this.emissiveThreshold = options.emissiveThreshold ?? 0.8;
      this.emissiveBoost = options.emissiveBoost ?? 1.2;
      this.opacityThreshold = options.opacityThreshold ?? 0.08;
      this.renderInterval = options.renderInterval ?? 66;
      this.root.innerHTML = "";
      this.preview = this.makeCanvas("preview");
      const label = document.createElement("span");
      label.className = "texture-map-label";
      label.textContent = options.label ?? this.sourceMode;
      this.root.append(this.preview, label);
      const strip = document.createElement("div");
      strip.className = "texture-map-strip";
      MAP_NAMES.forEach((name) => {
        const wrap = document.createElement("div");
        wrap.className = "texture-map-tile";
        const canvas = this.makeCanvas(name);
        const text = document.createElement("span");
        text.textContent = name;
        wrap.append(canvas, text);
        strip.appendChild(wrap);
        this.canvases.set(name, canvas);
      });
      this.root.appendChild(strip);
      this.render();
      if (options.imageUrl) this.setImageSource(options.imageUrl);
      if (this.animate) this.setAutoAnimate(true);
    }
    writeProp(prop, value) {
      if (this.disposed) return;
      const v = Number(value) || 0;
      if (prop === "sourceModeIndex") this.sourceMode = SOURCE_MODES[(Math.round(v) % SOURCE_MODES.length + SOURCE_MODES.length) % SOURCE_MODES.length];
      else if (prop === "previewMapIndex") this.previewMap = MAP_NAMES[(Math.round(v) % MAP_NAMES.length + MAP_NAMES.length) % MAP_NAMES.length];
      else if (prop === "invertBase" || prop === "useAlphaForOpacity" || prop === "showChecker") this[prop] = v >= 0.5;
      else if (prop === "animate") {
        this.setAutoAnimate(v >= 0.5);
        return;
      } else if (prop === "previewTiles") this.previewTiles = Math.max(1, Math.round(v));
      else if (prop === "size") this.size = Math.max(32, Math.round(v));
      else if (prop === "blurRadius" || prop === "animSpeed") this[prop] = Math.max(0, v);
      else if (PROPS2.includes(prop)) this[prop] = v;
      this.scheduleRender();
    }
    get sourceModeIndex() {
      return Math.max(0, SOURCE_MODES.indexOf(this.sourceMode));
    }
    get previewMapIndex() {
      return Math.max(0, MAP_NAMES.indexOf(this.previewMap));
    }
    setSourceMode(mode) {
      this.sourceMode = mode;
      this.render();
      return this;
    }
    setPreviewMap(name) {
      this.previewMap = name;
      this.render();
      return this;
    }
    setTints(colors) {
      [this.tintA, this.tintB, this.tintC, this.tintD] = colors;
      this.render();
      return this;
    }
    setAutoAnimate(enabled) {
      this.stopAuto?.();
      this.stopAuto = void 0;
      this.animate = enabled;
      if (enabled) this.stopAuto = ticker.add((dt) => {
        this.time += dt;
        this.scheduleRender();
      });
      return this;
    }
    setImageSource(url) {
      const ImageCtor = this.root.ownerDocument.defaultView?.Image;
      if (!ImageCtor) return this;
      const image = new ImageCtor();
      image.crossOrigin = "anonymous";
      image.onload = () => {
        const canvas = this.root.ownerDocument.createElement("canvas");
        canvas.width = image.naturalWidth || image.width;
        canvas.height = image.naturalHeight || image.height;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) return;
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
        this.imageData = { data: pixels.data, width: canvas.width, height: canvas.height };
        this.sourceMode = "image";
        this.render();
      };
      image.src = url;
      return this;
    }
    clearImage() {
      this.imageData = void 0;
      if (this.sourceMode === "image") this.sourceMode = "noise";
      this.render();
      return this;
    }
    exportDataURL(name = this.previewMap) {
      return this.canvases.get(name)?.toDataURL("image/png") ?? "";
    }
    render() {
      this.renderQueued = false;
      if (this.disposed || this.canvases.size !== MAP_NAMES.length) return this;
      this.lastRender = typeof performance !== "undefined" ? performance.now() : Date.now();
      this.buildBase();
      this.buildAlbedo();
      this.buildHeight();
      this.buildRoughness();
      this.buildMetallic();
      this.buildAO();
      this.buildNormal();
      this.buildEmissive();
      this.buildOpacity();
      this.drawPreview();
      return this;
    }
    dispose() {
      this.disposed = true;
      this.stopAuto?.();
      this.renderQueued = false;
      this.root.innerHTML = "";
      this.canvases.clear();
    }
    scheduleRender() {
      if (this.disposed || this.renderQueued) return;
      const now2 = typeof performance !== "undefined" ? performance.now() : Date.now();
      const elapsed = now2 - this.lastRender;
      const delay = Math.max(0, this.renderInterval - elapsed);
      this.renderQueued = true;
      const run = () => {
        if (!this.disposed) this.render();
        else this.renderQueued = false;
      };
      if (delay <= 0 && typeof requestAnimationFrame !== "undefined") requestAnimationFrame(run);
      else setTimeout(run, delay);
    }
    makeCanvas(_name) {
      const canvas = document.createElement("canvas");
      canvas.width = this.size;
      canvas.height = this.size;
      return canvas;
    }
    setCanvas(canvas) {
      canvas.width = this.size;
      canvas.height = this.size;
      return canvas.getContext("2d", { willReadFrequently: true });
    }
    buildBase() {
      const out = new Uint8ClampedArray(this.size * this.size * 4);
      const s = this.size;
      for (let y = 0; y < s; y++) {
        for (let x = 0; x < s; x++) {
          const sampled = clamp8(this.sampleSource(x, y));
          const v = this.invertBase ? 1 - sampled : sampled;
          const i = (y * s + x) * 4;
          const c = Math.round(v * 255);
          out[i] = out[i + 1] = out[i + 2] = c;
          out[i + 3] = 255;
        }
      }
      this.base = out;
    }
    sampleSource(x, y) {
      const s = this.size, nx = x / s, ny = y / s, t = this.time * this.animSpeed;
      const dx = this.driftX * t, dy = this.driftY * t;
      switch (this.sourceMode) {
        case "image": {
          if (!this.imageData) return fractalNoise2(nx * this.noiseScale, ny * this.noiseScale, 4);
          const ix = Math.min(this.imageData.width - 1, Math.floor(nx * this.imageData.width));
          const iy = Math.min(this.imageData.height - 1, Math.floor(ny * this.imageData.height));
          const i = (iy * this.imageData.width + ix) * 4;
          return (this.imageData.data[i] * 0.2126 + this.imageData.data[i + 1] * 0.7152 + this.imageData.data[i + 2] * 0.0722) / 255;
        }
        case "noise":
          return mix(fractalNoise2((nx + dx * 0.02) * this.noiseScale, (ny + dy * 0.02) * this.noiseScale, 4), fractalNoise2((nx - dx * 0.03) * this.noiseScale * 2, (ny + dy * 0.01) * this.noiseScale * 2, 2), this.detailMix);
        case "grunge":
          return fractalNoise2((nx + dx * 0.02) * this.noiseScale, (ny + dy * 0.02) * this.noiseScale, 5) * 0.72 + this.blotch(x, y) * 0.28;
        case "fabric":
          return clamp8(this.fabric(x, y) * 0.75 + fractalNoise2(nx * this.noiseScale * 2, ny * this.noiseScale * 2, 3) * this.detailMix * 0.35);
        case "metal":
          return this.brushedMetal(x, y);
        case "panels":
          return this.panels(x, y);
        case "holo":
          return this.holo(x, y);
        case "staticMotion":
          return this.staticMotion(x, y);
        case "scanLines":
          return this.scanLines(x, y);
        case "cracks":
          return this.cracks(x, y);
        case "ripples":
          return this.ripples(x, y);
        case "waves":
          return this.waves(x, y);
        default:
          return fractalNoise2(nx * this.noiseScale, ny * this.noiseScale, 4);
      }
    }
    buildAlbedo() {
      const ctx = this.setCanvas(this.canvases.get("albedo"));
      const out = ctx.createImageData(this.size, this.size);
      const colors = [hexToRgb2(this.tintA), hexToRgb2(this.tintB), hexToRgb2(this.tintC), hexToRgb2(this.tintD)];
      const src = this.base;
      for (let i = 0; i < src.length; i += 4) {
        let r = src[i] / 255, g = src[i + 1] / 255, b = src[i + 2] / 255;
        [r, g, b] = adjustBCS(r, g, b, this.brightness, this.contrast, this.saturation);
        const lum = (r + g + b) / 3;
        const tint = gradient(colors, lum);
        out.data[i] = Math.round(clamp8(lerp4(r, tint.r / 255, this.tintMix)) * 255);
        out.data[i + 1] = Math.round(clamp8(lerp4(g, tint.g / 255, this.tintMix)) * 255);
        out.data[i + 2] = Math.round(clamp8(lerp4(b, tint.b / 255, this.tintMix)) * 255);
        out.data[i + 3] = 255;
      }
      ctx.putImageData(out, 0, 0);
    }
    buildHeight() {
      const albedo = this.ctx("albedo").getImageData(0, 0, this.size, this.size).data;
      const ctx = this.setCanvas(this.canvases.get("height"));
      const out = ctx.createImageData(this.size, this.size);
      for (let i = 0; i < albedo.length; i += 4) {
        let v = (albedo[i] + albedo[i + 1] + albedo[i + 2]) / 3 / 255 * this.heightStrength;
        if (this.sourceMode === "cracks") v = Math.pow(v, 1.8);
        if (this.sourceMode === "ripples" || this.sourceMode === "waves") v = Math.pow(v, 1.15);
        const c = Math.round(clamp8(v) * 255);
        out.data[i] = out.data[i + 1] = out.data[i + 2] = c;
        out.data[i + 3] = 255;
      }
      ctx.putImageData(out, 0, 0);
    }
    buildRoughness() {
      this.grayFrom("height", "roughness", (v) => clamp8(Math.pow(v, 1 / Math.max(0.01, this.roughnessContrast)) * 0.65 + this.roughnessBias * 0.65));
    }
    buildMetallic() {
      this.grayFrom("albedo", "metallic", (v) => clamp8(v * 0.6 + this.metallicBias > this.metallicThreshold ? 1 : (v * 0.6 + this.metallicBias) * 0.5));
    }
    buildEmissive() {
      this.colorMaskFrom("albedo", "emissive", (v) => v > this.emissiveThreshold ? clamp8((v - this.emissiveThreshold) / Math.max(1e-4, 1 - this.emissiveThreshold) * this.emissiveBoost) : 0);
    }
    buildOpacity() {
      this.grayFrom(this.useAlphaForOpacity ? "albedo" : "height", "opacity", (v) => v > this.opacityThreshold ? 1 : 0);
    }
    buildAO() {
      const src = this.ctx("height").getImageData(0, 0, this.size, this.size).data;
      const ctx = this.setCanvas(this.canvases.get("ao"));
      const out = ctx.createImageData(this.size, this.size);
      for (let y = 0; y < this.size; y++) {
        for (let x = 0; x < this.size; x++) {
          const idx = (y * this.size + x) * 4;
          const center = src[idx] / 255;
          let acc = 0, count = 0;
          for (let oy = -2; oy <= 2; oy++) for (let ox = -2; ox <= 2; ox++) {
            const xx = clamp8(x + ox, 0, this.size - 1), yy = clamp8(y + oy, 0, this.size - 1);
            acc += src[(yy * this.size + xx) * 4] / 255;
            count++;
          }
          const c = Math.round(clamp8(1 - Math.max(0, acc / count - center) * this.aoStrength) * 255);
          out.data[idx] = out.data[idx + 1] = out.data[idx + 2] = c;
          out.data[idx + 3] = 255;
        }
      }
      ctx.putImageData(out, 0, 0);
    }
    buildNormal() {
      const src = this.ctx("height").getImageData(0, 0, this.size, this.size).data;
      const ctx = this.setCanvas(this.canvases.get("normal"));
      const out = ctx.createImageData(this.size, this.size);
      for (let y = 0; y < this.size; y++) {
        for (let x = 0; x < this.size; x++) {
          let dx = (this.heightAt(src, x - 1, y) - this.heightAt(src, x + 1, y)) * this.normalStrength;
          let dy = (this.heightAt(src, x, y - 1) - this.heightAt(src, x, y + 1)) * this.normalStrength;
          let dz = 1;
          const len = Math.sqrt(dx * dx + dy * dy + dz * dz) || 1;
          dx /= len;
          dy /= len;
          dz /= len;
          const i = (y * this.size + x) * 4;
          out.data[i] = Math.round((dx * 0.5 + 0.5) * 255);
          out.data[i + 1] = Math.round((dy * 0.5 + 0.5) * 255);
          out.data[i + 2] = Math.round((dz * 0.5 + 0.5) * 255);
          out.data[i + 3] = 255;
        }
      }
      ctx.putImageData(out, 0, 0);
    }
    drawPreview() {
      const ctx = this.setCanvas(this.preview);
      const src = this.canvases.get(this.previewMap);
      if (this.showChecker) {
        const cellSize = Math.max(4, this.size / 12);
        for (let y = 0; y < this.size; y += cellSize) for (let x = 0; x < this.size; x += cellSize) {
          ctx.fillStyle = (x / cellSize + y / cellSize) % 2 < 1 ? "#1a202c" : "#0c1118";
          ctx.fillRect(x, y, cellSize, cellSize);
        }
      }
      ctx.filter = this.blurRadius > 0 ? `blur(${this.blurRadius}px)` : "none";
      const cell = this.size / this.previewTiles;
      for (let y = 0; y < this.previewTiles; y++) for (let x = 0; x < this.previewTiles; x++) ctx.drawImage(src, x * cell, y * cell, cell, cell);
      ctx.filter = "none";
    }
    ctx(name) {
      return this.canvases.get(name).getContext("2d", { willReadFrequently: true });
    }
    heightAt(src, x, y) {
      return src[(Math.round(clamp8(y, 0, this.size - 1)) * this.size + Math.round(clamp8(x, 0, this.size - 1))) * 4] / 255;
    }
    grayFrom(from, to, fn) {
      const src = this.ctx(from).getImageData(0, 0, this.size, this.size).data;
      const ctx = this.setCanvas(this.canvases.get(to));
      const out = ctx.createImageData(this.size, this.size);
      for (let i = 0; i < src.length; i += 4) {
        const c = Math.round(fn((src[i] + src[i + 1] + src[i + 2]) / 3 / 255) * 255);
        out.data[i] = out.data[i + 1] = out.data[i + 2] = c;
        out.data[i + 3] = 255;
      }
      ctx.putImageData(out, 0, 0);
    }
    colorMaskFrom(from, to, fn) {
      const src = this.ctx(from).getImageData(0, 0, this.size, this.size).data;
      const ctx = this.setCanvas(this.canvases.get(to));
      const out = ctx.createImageData(this.size, this.size);
      for (let i = 0; i < src.length; i += 4) {
        const m = fn((src[i] + src[i + 1] + src[i + 2]) / 3 / 255);
        out.data[i] = Math.round(src[i] * m);
        out.data[i + 1] = Math.round(src[i + 1] * m);
        out.data[i + 2] = Math.round(src[i + 2] * m);
        out.data[i + 3] = 255;
      }
      ctx.putImageData(out, 0, 0);
    }
    blotch(x, y) {
      return Math.pow(fractalNoise2(x / this.size * this.patternDensity + this.time * 0.06, y / this.size * this.patternDensity - this.time * 0.04, 3), 2);
    }
    fabric(x, y) {
      return clamp8((Math.abs(Math.sin(x / this.size * Math.PI * this.patternDensity + this.time * 0.4)) + Math.abs(Math.sin(y / this.size * Math.PI * this.patternDensity - this.time * 0.35))) * 0.375 + fractalNoise2(x / this.size * 8, y / this.size * 8, 3) * 0.18);
    }
    brushedMetal(x, y) {
      return clamp8((Math.sin(y / this.size * Math.PI * (120 + this.lineDensity) + this.time * this.animFrequency) * 0.09 * this.animAmplitude + 0.5) * 0.42 + fractalNoise2((x / this.size + this.time * this.driftX * 0.02) * this.noiseScale * 0.6, (y / this.size + this.time * this.driftY * 0.02) * 24, 3) * (0.55 + this.detailMix * 0.4));
    }
    panels(x, y) {
      const gx = Math.floor(x / this.size * this.patternDensity), gy = Math.floor(y / this.size * this.patternDensity);
      const lx = x / this.size * this.patternDensity - gx, ly = y / this.size * this.patternDensity - gy;
      let v = 0.15 + randHash2(gx, gy) * 0.35;
      if (lx < 0.06 || lx > 0.94 || ly < 0.06 || ly > 0.94) v *= 0.2;
      if (randHash2(gx * 2, gy * 3) > 0.82 && lx > 0.18 && lx < 0.82 && ly > 0.18 && ly < 0.28) v = 1;
      if (randHash2(gx * 5, gy * 7) > 0.9 && lx > 0.7 && ly > 0.7) v = 0.85;
      return clamp8(v + Math.sin((gx + gy) * 0.65 + this.time * 2.2) * 0.04 * this.animAmplitude);
    }
    holo(x, y) {
      const scan = Math.sin(y / this.size * Math.PI * this.lineDensity + this.time * this.animFrequency * 2.4) * 0.5 + 0.5;
      const band = Math.sin(x / this.size * Math.PI * this.patternDensity * 0.9 + y / this.size * 8 + this.time * this.animFrequency) * 0.5 + 0.5;
      return clamp8(scan * 0.42 + band * 0.42 + fractalNoise2((x / this.size + this.time * this.driftX * 0.02) * 6, (y / this.size + this.time * this.driftY * 0.02) * 6, 3) * 0.25);
    }
    staticMotion(x, y) {
      const n1 = fractalNoise2((x / this.size + this.time * this.driftX * 0.12) * this.noiseScale * this.animFrequency, (y / this.size + this.time * this.driftY * 0.12) * this.noiseScale, 4);
      const n2 = fractalNoise2((x / this.size - this.time * this.driftX * 0.07) * this.noiseScale * 3.2, (y / this.size + this.time * this.driftY * 0.05) * this.noiseScale * 2.7, 2);
      return clamp8(mix(n1, n2, this.detailMix) + Math.sin((x + y) * 0.12 + this.time * 18) * 0.08 * this.animAmplitude);
    }
    scanLines(x, y) {
      const ny = y / this.size, nx = x / this.size;
      const phase = ny * this.lineDensity * Math.PI * 2 + this.time * this.animFrequency * 4;
      const lines = smoothStep2(0.5 - this.lineThickness / 60, 0.5 + this.lineThickness / 60, Math.sin(phase) * 0.5 + 0.5);
      const glow = Math.sin(nx * Math.PI * this.patternDensity * 0.5 + this.time * 1.5) * 0.5 + 0.5;
      return clamp8(lines * 0.78 + glow * 0.14 + fractalNoise2((nx + this.time * this.driftX * 0.03) * this.noiseScale * 0.8, (ny + this.time * this.driftY * 0.02) * this.noiseScale * 0.8, 3) * this.detailMix * 0.45);
    }
    ripples(x, y) {
      const nx = x / this.size - 0.5, ny = y / this.size - 0.5;
      const dist = Math.sqrt(nx * nx + ny * ny);
      const wave = Math.sin(dist * this.rippleCount * 20 - this.time * this.animFrequency * 4) * 0.5 + 0.5;
      return clamp8(Math.pow(wave, this.rippleSharpness) * 0.82 + fractalNoise2((nx + this.time * this.driftX * 0.03) * this.noiseScale + 10, (ny + this.time * this.driftY * 0.03) * this.noiseScale + 20, 2) * this.detailMix * 0.35);
    }
    waves(x, y) {
      const angle = this.waveAngle * Math.PI / 180, nx = x / this.size - 0.5, ny = y / this.size - 0.5;
      const proj = nx * Math.cos(angle) + ny * Math.sin(angle), secondary = ny * Math.cos(angle) - nx * Math.sin(angle);
      const base = Math.sin(proj * this.lineDensity * 2 + this.time * this.animFrequency * 2.5) * 0.5 + 0.5;
      const distortion = Math.sin(secondary * 18 + this.time * 1.8) * this.waveDistortion * 0.28 * this.animAmplitude;
      return clamp8(base * 0.74 + distortion * 0.3 + fractalNoise2((nx + distortion + this.time * this.driftX * 0.02) * this.noiseScale * 1.2, (ny + distortion + this.time * this.driftY * 0.02) * this.noiseScale * 1.2, 2) * this.detailMix * 0.35);
    }
    crackNode(cx, cy) {
      const jx = randHash2(cx * 13 + 1, cy * 17 + 3) - 0.5, jy = randHash2(cx * 29 + 7, cy * 31 + 5) - 0.5;
      const drift = Math.sin(this.time * 0.35 + randHash2(cx * 41, cy * 43) * 6.28318) * 0.055 * this.animAmplitude;
      return { x: cx + 0.5 + jx * 0.72 + drift, y: cy + 0.5 + jy * 0.72 - drift };
    }
    cracks(x, y) {
      const sx = x / this.size * this.crackDensity, sy = y / this.size * this.crackDensity, gx = Math.floor(sx), gy = Math.floor(sy);
      let nearestLine = 1e9, nearestEdge = 1e9;
      for (let oy = -2; oy <= 2; oy++) for (let ox = -2; ox <= 2; ox++) {
        const cx = gx + ox, cy = gy + oy, a = this.crackNode(cx, cy), right = this.crackNode(cx + 1, cy), down = this.crackNode(cx, cy + 1), diagA = this.crackNode(cx + 1, cy + 1), diagB = this.crackNode(cx - 1, cy + 1);
        nearestLine = Math.min(nearestLine, distToSegment2(sx, sy, a.x, a.y, right.x, right.y), distToSegment2(sx, sy, a.x, a.y, down.x, down.y));
        if (randHash2(cx * 19 + 4, cy * 23 + 9) < 0.22 + this.detailMix * 0.55) nearestLine = Math.min(nearestLine, distToSegment2(sx, sy, a.x, a.y, diagA.x, diagA.y));
        if (randHash2(cx * 31 + 7, cy * 17 + 11) < 0.14 + this.detailMix * 0.42) nearestLine = Math.min(nearestLine, distToSegment2(sx, sy, a.x, a.y, diagB.x, diagB.y));
        if (randHash2(cx * 43 + 5, cy * 47 + 2) < 0.16 + this.detailMix * 0.36) {
          const h = this.crackNode(cx + randHash2(cx, cy) * 1.5 - 0.25, cy + randHash2(cx + 5, cy + 8) * 1.5 - 0.25);
          nearestEdge = Math.min(nearestEdge, distToSegment2(sx, sy, a.x, a.y, h.x, h.y));
        }
      }
      const width = Math.max(2e-3, this.crackWidth * 0.018);
      const core = 1 - smoothStep2(width, width * 2.2, nearestLine);
      const hair = 1 - smoothStep2(width * 0.35, width * 0.95, nearestEdge);
      const chippedEdge = smoothStep2(width * 1.05, width * 3.7, nearestLine) * (1 - smoothStep2(width * 3.7, width * 6.2, nearestLine));
      const stoneNoise = fractalNoise2(x / this.size * this.noiseScale * 1.2 + this.time * 0.02, y / this.size * this.noiseScale * 1.2 - this.time * 0.015, 4);
      const grain = fractalNoise2(x / this.size * this.noiseScale * 4, y / this.size * this.noiseScale * 4, 2);
      return clamp8(0.46 + stoneNoise * 0.28 + grain * 0.12 + chippedEdge * (0.32 + this.animAmplitude * 0.06) - core * 0.92 - hair * 0.5);
    }
  };
  var PulseTextureMapsAdapter = {
    test: (target) => Boolean(target?.__pulseTextureMaps),
    props: () => [...PROPS2],
    get: (target, prop) => Number(target[prop]) || 0,
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "waveAngle" ? "deg" : ""
  };
  registerAdapter(PulseTextureMapsAdapter);
  function textureMaps(root, params) {
    return new PulseTextureMaps(root, params);
  }

  // src/texture/texture-asset.ts
  var PULSE_TEXTURE_ASSET_PRESETS = {
    diamond: {
      drift: 1,
      zoom: 0.08,
      contrast: 1.16,
      brightness: 1.04,
      saturation: 0.78,
      hue: 0,
      shimmer: 1,
      displacement: 2.3,
      frequencyX: 0.012,
      frequencyY: 0.035,
      grain: 0.045,
      vignette: 0.17,
      glints: 42,
      glintSize: 1,
      blendMode: "screen",
      opacity: 1
    },
    holographicFoil: {
      drift: 0.9,
      zoom: 0.11,
      contrast: 1.08,
      brightness: 1.04,
      saturation: 1.35,
      hue: 28,
      shimmer: 0.85,
      displacement: 5.5,
      frequencyX: 8e-3,
      frequencyY: 0.024,
      grain: 0.035,
      vignette: 0.12,
      glints: 24,
      glintSize: 0.85,
      blendMode: "screen",
      opacity: 0.92
    },
    liquidChrome: {
      drift: 0.72,
      zoom: 0.105,
      contrast: 1.2,
      brightness: 1.02,
      saturation: 0.38,
      hue: 4,
      shimmer: 0.78,
      displacement: 11,
      frequencyX: 6e-3,
      frequencyY: 0.018,
      grain: 0.03,
      vignette: 0.16,
      glints: 10,
      glintSize: 1.2,
      blendMode: "screen",
      opacity: 0.9
    },
    brokenGlass: {
      drift: 0.68,
      zoom: 0.095,
      contrast: 1.18,
      brightness: 1.03,
      saturation: 0.72,
      hue: 8,
      shimmer: 0.9,
      displacement: 3.6,
      frequencyX: 0.014,
      frequencyY: 0.042,
      grain: 0.04,
      vignette: 0.13,
      glints: 32,
      glintSize: 1.1,
      blendMode: "screen",
      opacity: 0.95
    },
    waterCaustics: {
      drift: 0.42,
      zoom: 0.12,
      contrast: 1.08,
      brightness: 1.04,
      saturation: 1.08,
      hue: 6,
      shimmer: 0.75,
      displacement: 14,
      frequencyX: 0.01,
      frequencyY: 0.028,
      grain: 0.018,
      vignette: 0.08,
      glints: 8,
      glintSize: 0.7,
      blendMode: "soft-light",
      opacity: 0.82
    },
    marble: {
      drift: 0.28,
      zoom: 0.075,
      contrast: 1.04,
      brightness: 1.05,
      saturation: 0.7,
      hue: 0,
      shimmer: 0.34,
      displacement: 1.5,
      frequencyX: 5e-3,
      frequencyY: 0.012,
      grain: 0.025,
      vignette: 0.1,
      glints: 0,
      glintSize: 0.7,
      blendMode: "normal",
      opacity: 0.9
    },
    concrete: {
      drift: 0.24,
      zoom: 0.065,
      contrast: 1.2,
      brightness: 0.92,
      saturation: 0.45,
      hue: 0,
      shimmer: 0.18,
      displacement: 2.8,
      frequencyX: 0.018,
      frequencyY: 0.05,
      grain: 0.055,
      vignette: 0.25,
      glints: 0,
      glintSize: 0.7,
      blendMode: "multiply",
      opacity: 0.82
    }
  };
  var nextId4 = 1;
  var clamp9 = (value, min, max2) => Math.max(min, Math.min(max2, Number.isFinite(value) ? value : min));
  function resolveRoot10(root) {
    const element = typeof root === "string" ? document.querySelector(root) : root;
    if (!element) throw new Error(`[pulse:texture-asset] root not found: ${String(root)}`);
    return element;
  }
  function randomFrom(seed) {
    let state = seed >>> 0;
    return () => {
      state += 1831565813;
      let value = state;
      value = Math.imul(value ^ value >>> 15, value | 1);
      value ^= value + Math.imul(value ^ value >>> 7, value | 61);
      return ((value ^ value >>> 14) >>> 0) / 4294967296;
    };
  }
  function mergedPreset(options) {
    const base = typeof options.preset === "object" ? options.preset : PULSE_TEXTURE_ASSET_PRESETS[options.preset ?? "liquidChrome"];
    const result = { ...base };
    for (const key2 of Object.keys(base)) {
      if (options[key2] != null) result[key2] = options[key2];
    }
    return result;
  }
  var PulseTextureAsset = class {
    constructor(root, options) {
      this.glints = [];
      this.glintData = [];
      this.playing = false;
      this.loaded = false;
      this.time = 0;
      this.speed = 1;
      this.disposed = false;
      this.changed = { position: false, overflow: false, isolation: false };
      this.root = resolveRoot10(root);
      this.options = { ...options };
      this.preset = mergedPreset(options);
      this.speed = Math.max(0, options.speed ?? 1);
      this.original = {
        position: this.root.style.position,
        overflow: this.root.style.overflow,
        isolation: this.root.style.isolation
      };
      const computed = getComputedStyle(this.root);
      if (computed.position === "static") {
        this.root.style.position = "relative";
        this.changed.position = true;
      }
      if (options.clip !== false && computed.overflow === "visible") {
        this.root.style.overflow = "hidden";
        this.changed.overflow = true;
      }
      if (computed.isolation !== "isolate") {
        this.root.style.isolation = "isolate";
        this.changed.isolation = true;
      }
      const id2 = `pulse-texture-asset-${nextId4++}`;
      this.layer = document.createElement("div");
      this.layer.className = `pulse-texture-asset${options.className ? ` ${options.className}` : ""}`;
      this.layer.dataset.pulseTextureAsset = id2;
      this.layer.setAttribute("aria-hidden", "true");
      Object.assign(this.layer.style, {
        position: "absolute",
        inset: "0",
        pointerEvents: "none",
        overflow: "hidden",
        zIndex: options.placement === "front" ? "10" : "0",
        mixBlendMode: this.preset.blendMode,
        opacity: String(clamp9(this.preset.opacity * (options.intensity ?? 1), 0, 1)),
        maskImage: options.maskImage ?? "",
        WebkitMaskImage: options.maskImage ?? "",
        maskMode: options.maskMode ?? "alpha",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskSize: "100% 100%",
        WebkitMaskSize: "100% 100%"
      });
      const svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg2.setAttribute("width", "0");
      svg2.setAttribute("height", "0");
      svg2.style.position = "absolute";
      const defs = document.createElementNS(svg2.namespaceURI, "defs");
      const filter = document.createElementNS(svg2.namespaceURI, "filter");
      filter.setAttribute("id", id2);
      filter.setAttribute("x", "-15%");
      filter.setAttribute("y", "-15%");
      filter.setAttribute("width", "130%");
      filter.setAttribute("height", "130%");
      this.turbulence = document.createElementNS(svg2.namespaceURI, "feTurbulence");
      this.turbulence.setAttribute("type", "turbulence");
      this.turbulence.setAttribute("numOctaves", "2");
      this.turbulence.setAttribute("seed", String(options.seed ?? 42));
      this.turbulence.setAttribute("result", "noise");
      this.displacement = document.createElementNS(svg2.namespaceURI, "feDisplacementMap");
      this.displacement.setAttribute("in", "SourceGraphic");
      this.displacement.setAttribute("in2", "noise");
      this.displacement.setAttribute("xChannelSelector", "R");
      this.displacement.setAttribute("yChannelSelector", "G");
      filter.append(this.turbulence, this.displacement);
      defs.appendChild(filter);
      svg2.appendChild(defs);
      this.image = document.createElement("img");
      this.image.src = options.source;
      this.image.alt = "";
      this.image.decoding = "async";
      this.image.draggable = false;
      this.image.addEventListener("load", () => {
        this.loaded = true;
      }, { once: true });
      Object.assign(this.image.style, {
        position: "absolute",
        left: "50%",
        top: "50%",
        width: "112%",
        height: "112%",
        objectFit: options.fit ?? "cover",
        transformOrigin: "50% 50%",
        filter: `url(#${id2})`,
        willChange: "transform, filter",
        userSelect: "none"
      });
      this.tint = this.overlay();
      this.tint.style.background = options.tint ?? "transparent";
      this.tint.style.opacity = String(clamp9(options.tintStrength ?? 0, 0, 1));
      this.tint.style.mixBlendMode = "color";
      this.shimmer = this.overlay();
      Object.assign(this.shimmer.style, {
        width: "42%",
        left: "-55%",
        background: "linear-gradient(105deg, transparent 0 25%, rgba(255,255,255,.85) 50%, transparent 75% 100%)",
        filter: "blur(14px)",
        mixBlendMode: "screen",
        willChange: "transform, opacity"
      });
      this.grain = this.overlay();
      this.grain.style.backgroundImage = "repeating-conic-gradient(rgba(255,255,255,.45) 0 2%, rgba(0,0,0,.35) 0 4%)";
      this.grain.style.backgroundSize = "7px 7px";
      this.grain.style.mixBlendMode = "soft-light";
      this.grain.style.opacity = String(clamp9(this.preset.grain, 0, 0.3));
      this.vignette = this.overlay();
      this.setVignette();
      this.layer.append(svg2, this.image, this.tint, this.shimmer, this.grain);
      this.mountGlints(options.seed ?? 42);
      this.layer.appendChild(this.vignette);
      if (options.placement === "front") this.root.appendChild(this.layer);
      else this.root.insertBefore(this.layer, this.root.firstChild);
      this.render(0);
      if (options.autoplay !== false && !options.reducedMotion) this.play();
    }
    play() {
      if (this.disposed || this.playing || this.options.reducedMotion) return this;
      this.playing = true;
      this.stopTick = ticker.add((dt) => {
        this.time += dt * this.speed;
        this.render(this.time);
      });
      return this;
    }
    pause() {
      this.stopTick?.();
      this.stopTick = void 0;
      this.playing = false;
      return this;
    }
    seek(time) {
      this.time = Math.max(0, Number(time) || 0);
      this.render(this.time);
      return this;
    }
    restart() {
      this.seek(0);
      return this.play();
    }
    setSpeed(speed) {
      this.speed = Math.max(0, Number(speed) || 0);
      return this;
    }
    update(options) {
      this.options = { ...this.options, ...options };
      this.preset = mergedPreset(this.options);
      if (options.source) {
        this.loaded = false;
        this.image.src = options.source;
      }
      if (options.speed != null) this.setSpeed(options.speed);
      if (options.fit) this.image.style.objectFit = options.fit;
      this.layer.style.mixBlendMode = this.preset.blendMode;
      this.layer.style.opacity = String(clamp9(this.preset.opacity * (this.options.intensity ?? 1), 0, 1));
      this.tint.style.background = this.options.tint ?? "transparent";
      this.tint.style.opacity = String(clamp9(this.options.tintStrength ?? 0, 0, 1));
      this.grain.style.opacity = String(clamp9(this.preset.grain, 0, 0.3));
      this.setVignette();
      this.render(this.time);
      return this;
    }
    diagnostics() {
      return {
        source: this.options.source,
        preset: typeof this.options.preset === "string" ? this.options.preset : "custom",
        playing: this.playing,
        time: this.time,
        duration: Math.max(0.1, this.options.duration ?? 10),
        reducedMotion: Boolean(this.options.reducedMotion),
        glintCount: this.glints.length,
        loaded: this.loaded || this.image.complete
      };
    }
    dispose() {
      if (this.disposed) return;
      this.pause();
      this.disposed = true;
      this.layer.remove();
      if (this.changed.position) this.root.style.position = this.original.position;
      if (this.changed.overflow) this.root.style.overflow = this.original.overflow;
      if (this.changed.isolation) this.root.style.isolation = this.original.isolation;
    }
    overlay() {
      const element = document.createElement("div");
      Object.assign(element.style, { position: "absolute", inset: "0", pointerEvents: "none" });
      return element;
    }
    setVignette() {
      this.vignette.style.background = `radial-gradient(circle at 50% 48%, transparent 40%, rgba(0,0,0,${clamp9(this.preset.vignette, 0, 0.85)}) 100%)`;
    }
    mountGlints(seed) {
      const random2 = randomFrom(seed);
      const count = Math.max(0, Math.min(80, Math.round(this.preset.glints)));
      for (let index = 0; index < count; index++) {
        const glint = document.createElement("span");
        const size = (1.2 + random2() * 4.2) * this.preset.glintSize;
        const cross = random2() > 0.82;
        Object.assign(glint.style, {
          position: "absolute",
          left: `${random2() * 100}%`,
          top: `${random2() * 100}%`,
          width: `${cross ? size * 4 : size}px`,
          height: `${cross ? Math.max(1, size * 0.34) : size}px`,
          borderRadius: "999px",
          background: "white",
          boxShadow: `0 0 ${size * 3}px rgba(255,255,255,.92)`,
          mixBlendMode: "screen",
          transformOrigin: "50% 50%",
          pointerEvents: "none",
          opacity: "0"
        });
        this.glintData.push({ phase: random2() * Math.PI * 2, pace: 0.35 + random2() * 0.9, cross });
        this.glints.push(glint);
        this.layer.appendChild(glint);
      }
    }
    render(inputTime) {
      const duration = Math.max(0.1, this.options.duration ?? 10);
      const time = this.options.reducedMotion ? 0 : inputTime % duration;
      const intensity = Math.max(0, this.options.intensity ?? 1);
      const width = this.root.clientWidth || 1e3, height = this.root.clientHeight || 600;
      const driftX = Math.sin(time * 0.34) * width * 0.012 * this.preset.drift;
      const driftY = Math.cos(time * 0.27) * height * 0.015 * this.preset.drift;
      const zoom = (1.055 + this.preset.zoom * (0.36 + 0.64 * Math.sin(time * 0.31) ** 2)) * Math.max(0.1, this.options.scale ?? 1);
      const hue = Math.sin(time * 0.23) * this.preset.hue * intensity;
      const frequencyX = Math.max(1e-3, this.preset.frequencyX * (0.78 + Math.sin(time * 0.37) * 0.22));
      const frequencyY = Math.max(1e-3, this.preset.frequencyY * (0.76 + Math.cos(time * 0.29) * 0.24));
      const displacement = Math.max(0, this.preset.displacement * intensity * (0.72 + Math.sin(time * 0.55) * 0.28));
      const sweep = time / duration * 195 - 48;
      this.image.style.transform = `translate(calc(-50% + ${driftX.toFixed(2)}px), calc(-50% + ${driftY.toFixed(2)}px)) scale(${zoom.toFixed(4)})`;
      this.image.style.filter = `url(#${this.layer.dataset.pulseTextureAsset}) contrast(${this.preset.contrast}) brightness(${this.preset.brightness}) saturate(${this.preset.saturation}) hue-rotate(${hue.toFixed(2)}deg)`;
      this.turbulence.setAttribute("baseFrequency", `${frequencyX.toFixed(5)} ${frequencyY.toFixed(5)}`);
      this.displacement.setAttribute("scale", displacement.toFixed(2));
      this.shimmer.style.transform = `translateX(${sweep.toFixed(2)}%) skewX(-12deg)`;
      this.shimmer.style.opacity = String(clamp9(this.preset.shimmer * intensity * 0.78, 0, 1));
      this.grain.style.backgroundPosition = `${Math.round(time * 23) % 21}px ${Math.round(time * 17) % 19}px`;
      this.glints.forEach((glint, index) => {
        const datum = this.glintData[index], wave = Math.sin(time * datum.pace + datum.phase);
        const flash = Math.pow(Math.max(0, (wave - 0.64) / 0.36), 3);
        glint.style.opacity = String(clamp9(flash * intensity, 0, 1));
        glint.style.transform = `translate(-50%,-50%) rotate(${datum.cross ? time * 7 + index * 13 : 0}deg) scale(${0.72 + flash * 0.48})`;
      });
    }
  };
  var textureAsset = (root, options) => new PulseTextureAsset(root, options);
  function validatePulseTextureAssetManifest(input) {
    const errors = [];
    const value = input;
    if (!value || typeof value !== "object") errors.push("manifest must be an object");
    if (value?.schema !== "pulse-texture-library/v1") errors.push("schema must be pulse-texture-library/v1");
    if (!Array.isArray(value?.textures)) errors.push("textures must be an array");
    const ids = /* @__PURE__ */ new Set();
    for (const [index, item] of (value?.textures ?? []).entries()) {
      if (!item || typeof item !== "object") {
        errors.push(`textures[${index}] must be an object`);
        continue;
      }
      if (!item.id || typeof item.id !== "string") errors.push(`textures[${index}].id is required`);
      else if (ids.has(item.id)) errors.push(`duplicate texture id: ${item.id}`);
      else ids.add(item.id);
      if (!item.source || typeof item.source !== "string") errors.push(`textures[${index}].source is required`);
      if (typeof item.preset === "string" && !(item.preset in PULSE_TEXTURE_ASSET_PRESETS)) {
        errors.push(`textures[${index}].preset is unknown: ${item.preset}`);
      }
    }
    return { valid: errors.length === 0, errors, textureCount: value?.textures?.length ?? 0 };
  }
  function textureAssetFromManifest(root, manifest, id2, options = {}) {
    const report = validatePulseTextureAssetManifest(manifest);
    if (!report.valid) throw new Error(`[pulse:texture-asset] invalid manifest: ${report.errors.join("; ")}`);
    const item = manifest.textures.find((texture2) => texture2.id === id2);
    if (!item) throw new Error(`[pulse:texture-asset] manifest texture not found: ${id2}`);
    const profile = options.aspectProfile ? item.aspectProfiles?.[options.aspectProfile] : void 0;
    const { aspectProfile: _aspectProfile, ...overrides } = options;
    return new PulseTextureAsset(root, {
      duration: manifest.durationSeconds,
      ...item.defaults,
      source: item.source,
      preset: item.preset,
      ...profile,
      ...overrides
    });
  }

  // src/waapi/waapi.ts
  function fallbackAnimate(targets, params) {
    const list = typeof targets === "string" ? Array.from(document.querySelectorAll(targets)) : targets instanceof Element ? [targets] : Array.from(targets);
    const {
      duration = 1e3,
      delay = 0,
      loop = false,
      alternate = false,
      reversed = false,
      autoplay = true,
      ease = "linear",
      persist = false,
      reducedMotion = false,
      debug: _debug,
      onBegin,
      onUpdate: _onUpdate,
      onComplete,
      ...props
    } = params;
    const keyframes2 = Object.keys(props).map((key2) => [key2, props[key2]]).reduce((acc, [key2, value]) => {
      acc[key2] = value;
      return acc;
    }, {});
    onBegin?.();
    if (!list.every((el) => typeof el.animate === "function")) {
      list.forEach((el) => {
        for (const [property, raw] of Object.entries(props)) {
          const value = Array.isArray(raw) ? raw[raw.length - 1] : raw;
          if (property in el.style) el.style.setProperty(property.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`), String(value));
        }
      });
      onComplete?.();
      return { play() {
        return this;
      }, pause() {
        return this;
      }, seek() {
        return this;
      }, restart() {
        return this;
      }, setSpeed() {
        return this;
      }, reverse() {
        return this;
      }, dispose() {
      } };
    }
    const animations = list.map((el, index) => el.animate(keyframes2, {
      duration: reducedMotion ? 0 : duration,
      delay: typeof delay === "function" ? delay(el, index, list.length) : delay,
      iterations: loop === true ? Infinity : loop || 1,
      direction: reversed ? "reverse" : alternate ? "alternate" : "normal",
      easing: typeof ease === "string" ? ease : "linear",
      fill: persist ? "both" : "none"
    }));
    if (onComplete) Promise.all(animations.map((animation) => animation.finished.catch(() => void 0))).then(() => onComplete());
    if (!autoplay) animations.forEach((animation) => animation.pause());
    return {
      play() {
        animations.forEach((a) => a.play());
        return this;
      },
      pause() {
        animations.forEach((a) => a.pause());
        return this;
      },
      seek(time) {
        animations.forEach((a) => {
          a.currentTime = time;
        });
        return this;
      },
      restart() {
        animations.forEach((a) => {
          a.currentTime = 0;
          a.play();
        });
        return this;
      },
      setSpeed(rate) {
        animations.forEach((a) => {
          a.playbackRate = rate;
        });
        return this;
      },
      reverse() {
        animations.forEach((a) => a.reverse());
        return this;
      },
      dispose() {
        animations.forEach((a) => a.cancel());
      }
    };
  }
  var PulseWaapi = class {
    animate(targets, params = {}) {
      if (typeof document === "undefined") {
        return { play() {
          return this;
        }, pause() {
          return this;
        }, seek() {
          return this;
        }, restart() {
          return this;
        }, setSpeed() {
          return this;
        }, dispose() {
        } };
      }
      try {
        const { reducedMotion = false, debug: _debug, ...animeParams2 } = params;
        const live = waapi.animate(targets, { ...animeParams2, duration: reducedMotion ? 0 : animeParams2.duration });
        return {
          play() {
            live.play();
            return this;
          },
          pause() {
            live.pause();
            return this;
          },
          seek(time) {
            live.seek(time);
            return this;
          },
          restart() {
            live.restart();
            return this;
          },
          setSpeed(rate) {
            live.speed = rate;
            return this;
          },
          reverse() {
            live.reverse();
            return this;
          },
          dispose() {
            live.revert();
          }
        };
      } catch (error) {
        if (params.debug && typeof console !== "undefined") console.warn("[pulse:waapi] native wrapper unavailable; using browser fallback", error);
        return fallbackAnimate(targets, params);
      }
    }
  };
  var pulseWaapi = new PulseWaapi();

  // src/blend/blend-modes.ts
  var BLEND_MODES2 = ["source-over", "multiply", "screen", "overlay", "soft-light", "hard-light", "color-dodge", "color-burn", "lighten", "darken", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  var LAYER_TYPES = ["gradientGlow", "colorBars", "duotoneBlob", "spotlight", "stripes", "noise", "checker", "circles", "text"];
  var SOURCE_MODES2 = ["portrait", "gradient", "shapes", "product"];
  var PROPS3 = ["time", "size", "baseExposure", "activeLayer", "layerEnabled", "layerOpacity", "layerExposure", "rotation", "scale", "offsetX", "offsetY", "density", "softness", "showLabels", "sourceModeIndex", "blendModeIndex", "layerTypeIndex"];
  function resolveRoot11(root) {
    if (typeof root === "string") {
      if (typeof document === "undefined") throw new Error("[pulse:blend-modes] document is not available");
      const el = document.querySelector(root);
      if (!(el instanceof HTMLElement)) throw new Error(`[pulse:blend-modes] root not found: ${root}`);
      return el;
    }
    return root;
  }
  function clamp10(v, min = 0, max2 = 1) {
    return Math.max(min, Math.min(max2, Number(v) || 0));
  }
  function clamp255(v) {
    return Math.max(0, Math.min(255, Math.round(v)));
  }
  function lerp5(a, b, t) {
    return a + (b - a) * t;
  }
  function hexToRgb3(hex) {
    const clean = hex.startsWith("#") ? hex.slice(1) : hex;
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean.padEnd(6, "0").slice(0, 6);
    const n = parseInt(full, 16);
    return { r: n >> 16 & 255, g: n >> 8 & 255, b: n & 255 };
  }
  function mixHex(a, b, t) {
    const ca = hexToRgb3(a), cb = hexToRgb3(b);
    const r = clamp255(lerp5(ca.r, cb.r, t)), g = clamp255(lerp5(ca.g, cb.g, t)), blue = clamp255(lerp5(ca.b, cb.b, t));
    return `rgb(${r},${g},${blue})`;
  }
  function hexMixRgb(a, b, t) {
    const ca = hexToRgb3(a), cb = hexToRgb3(b);
    return { r: clamp255(lerp5(ca.r, cb.r, t)), g: clamp255(lerp5(ca.g, cb.g, t)), b: clamp255(lerp5(ca.b, cb.b, t)) };
  }
  function layer(name, enabled, blendMode, opacity, exposure, layerType2, colorA, colorB, scale, rotation, offsetX, offsetY, density, softness, text) {
    return { name, enabled, blendMode, opacity, exposure, layerType: layerType2, colorA, colorB, scale, rotation, offsetX, offsetY, density, softness, text };
  }
  var PRESETS = {
    neonPoster: {
      sourceMode: "gradient",
      layers: [
        layer("Layer 1", true, "screen", 0.86, 1.05, "spotlight", "#4dfcff", "#ffffff", 1.05, 0, 0.18, -0.12, 12, 0.82, "LIGHT"),
        layer("Layer 2", true, "overlay", 0.72, 1, "stripes", "#ff7a1a", "#7b4dff", 1.2, 24, 0, 0, 18, 0.48, "POSTER"),
        layer("Layer 3", true, "color-dodge", 0.74, 1.12, "text", "#ff4dd8", "#4dfcff", 1, 0, 0, 0, 12, 0.45, "NEON")
      ]
    },
    productGlow: {
      sourceMode: "product",
      layers: [
        layer("Layer 1", true, "screen", 0.82, 1.06, "gradientGlow", "#4dfcff", "#ffffff", 1.15, -16, 0.16, -0.18, 12, 0.76, "GLOW"),
        layer("Layer 2", true, "soft-light", 0.68, 1, "checker", "#ffffff", "#20263a", 1.15, 0, 0, 0, 14, 0.36, "SOFT"),
        layer("Layer 3", true, "color", 0.52, 1, "duotoneBlob", "#9be8ff", "#1f65ff", 1.05, 10, -0.05, 0.04, 12, 0.54, "TINT")
      ]
    },
    gritPoster: {
      sourceMode: "portrait",
      layers: [
        layer("Layer 1", true, "multiply", 0.82, 0.92, "noise", "#2a1c16", "#090909", 1, 0, 0, 0, 32, 0.35, "GRIT"),
        layer("Layer 2", true, "overlay", 0.7, 1, "gradientGlow", "#ff7a1a", "#2a0f30", 1.18, 28, -0.1, 0.1, 12, 0.62, "TONE"),
        layer("Layer 3", true, "soft-light", 0.66, 1, "text", "#fff0c4", "#ffffff", 1, 0, 0, 0, 12, 0.45, "EDITORIAL")
      ]
    },
    experimentalFx: {
      sourceMode: "shapes",
      layers: [
        layer("Layer 1", true, "difference", 1, 1, "colorBars", "#ff7a1a", "#4dfcff", 1, 0, 0, 0, 8, 0.4, "DIFF"),
        layer("Layer 2", true, "exclusion", 0.86, 1, "circles", "#ff4d68", "#fff056", 1, 0, 0, 0, 12, 0.5, "EXCL"),
        layer("Layer 3", true, "hard-light", 0.68, 1, "text", "#ffffff", "#ffffff", 1, 0, 0, 0, 12, 0.5, "FX")
      ]
    },
    cinematicGrade: {
      sourceMode: "portrait",
      layers: [
        layer("Layer 1", true, "color", 0.62, 1, "gradientGlow", "#0d8ea6", "#ff8f4d", 1.25, 18, -0.16, 0.12, 12, 0.82, "GRADE"),
        layer("Layer 2", true, "soft-light", 0.56, 1, "spotlight", "#203040", "#ffe8cf", 1.12, 0, 0.1, -0.08, 12, 0.74, "LIGHT"),
        layer("Layer 3", true, "multiply", 0.38, 0.9, "stripes", "#1b1822", "#0e1018", 1.18, 30, 0, 0, 22, 0.28, "MOOD")
      ]
    },
    luminosityStack: {
      sourceMode: "product",
      layers: [
        layer("Layer 1", true, "luminosity", 0.9, 1.05, "checker", "#ffffff", "#1a1a1a", 1.25, 0, 0, 0, 16, 0.4, "LUMA"),
        layer("Layer 2", true, "screen", 0.48, 1.1, "spotlight", "#ffffff", "#4dfcff", 1.05, 0, 0.16, -0.12, 12, 0.78, "LIGHT"),
        layer("Layer 3", true, "color", 0.4, 1, "duotoneBlob", "#ffb36b", "#8bd8ff", 1.1, -16, -0.08, 0.04, 12, 0.56, "TINT")
      ]
    }
  };
  var PulseBlendModes = class {
    constructor(root, options = {}) {
      this.__pulseBlendModes = true;
      this.renderQueued = false;
      this.lastRender = 0;
      this.disposed = false;
      this.root = resolveRoot11(root);
      this.root.classList.add("pulse-blend-modes");
      const preset = PRESETS[options.preset ?? "neonPoster"];
      this.sourceMode = options.sourceMode ?? preset.sourceMode;
      this.size = Math.max(32, Math.round(options.size ?? 128));
      this.activeLayer = Math.max(0, Math.round(options.activeLayer ?? 0));
      this.baseExposure = options.baseExposure ?? 1;
      this.showLabels = options.showLabels ?? false;
      this.time = options.time ?? 0;
      this.renderInterval = options.renderInterval ?? 50;
      this.layers = options.layers?.length ? options.layers.map((l, i) => this.makeLayer(l, i)) : preset.layers.map((l) => ({ ...l }));
      this.baseCanvas = this.makeCanvas();
      this.layerCanvas = this.makeCanvas();
      this.resultCanvas = this.makeCanvas();
      this.compareCanvas = this.makeCanvas();
      this.tempLayerCanvas = this.makeCanvas();
      this.root.innerHTML = "";
      this.root.append(this.panel("base", this.baseCanvas), this.panel("layer", this.layerCanvas), this.panel("result", this.resultCanvas), this.panel("split", this.compareCanvas));
      this.render();
    }
    get active() {
      return this.layers[(this.activeLayer % this.layers.length + this.layers.length) % this.layers.length];
    }
    get layerOpacity() {
      return this.active.opacity;
    }
    get layerExposure() {
      return this.active.exposure;
    }
    get layerEnabled() {
      return this.active.enabled ? 1 : 0;
    }
    get rotation() {
      return this.active.rotation;
    }
    get scale() {
      return this.active.scale;
    }
    get offsetX() {
      return this.active.offsetX;
    }
    get offsetY() {
      return this.active.offsetY;
    }
    get density() {
      return this.active.density;
    }
    get softness() {
      return this.active.softness;
    }
    get blendModeIndex() {
      return Math.max(0, BLEND_MODES2.indexOf(this.active.blendMode));
    }
    get layerTypeIndex() {
      return Math.max(0, LAYER_TYPES.indexOf(this.active.layerType));
    }
    get sourceModeIndex() {
      return Math.max(0, SOURCE_MODES2.indexOf(this.sourceMode));
    }
    writeProp(prop, value) {
      if (this.disposed) return;
      const v = Number(value) || 0;
      if (prop === "time") this.time = v;
      else if (prop === "size") this.size = Math.max(32, Math.round(v));
      else if (prop === "baseExposure") this.baseExposure = Math.max(0, v);
      else if (prop === "activeLayer") this.activeLayer = Math.round(v);
      else if (prop === "layerEnabled") this.active.enabled = v >= 0.5;
      else if (prop === "layerOpacity") this.active.opacity = clamp10(v);
      else if (prop === "layerExposure") this.active.exposure = Math.max(0, v);
      else if (prop === "rotation") this.active.rotation = v;
      else if (prop === "scale") this.active.scale = Math.max(0.05, v);
      else if (prop === "offsetX") this.active.offsetX = v;
      else if (prop === "offsetY") this.active.offsetY = v;
      else if (prop === "density") this.active.density = Math.max(1, v);
      else if (prop === "softness") this.active.softness = clamp10(v);
      else if (prop === "showLabels") this.showLabels = v >= 0.5;
      else if (prop === "sourceModeIndex") this.sourceMode = SOURCE_MODES2[(Math.round(v) % SOURCE_MODES2.length + SOURCE_MODES2.length) % SOURCE_MODES2.length];
      else if (prop === "blendModeIndex") this.active.blendMode = BLEND_MODES2[(Math.round(v) % BLEND_MODES2.length + BLEND_MODES2.length) % BLEND_MODES2.length];
      else if (prop === "layerTypeIndex") this.active.layerType = LAYER_TYPES[(Math.round(v) % LAYER_TYPES.length + LAYER_TYPES.length) % LAYER_TYPES.length];
      this.scheduleRender();
    }
    setPreset(preset) {
      const p = PRESETS[preset];
      this.sourceMode = p.sourceMode;
      this.layers.splice(0, this.layers.length, ...p.layers.map((l) => ({ ...l })));
      this.activeLayer = 0;
      this.render();
      return this;
    }
    setSourceMode(mode) {
      this.sourceMode = mode;
      this.render();
      return this;
    }
    setActiveLayer(index) {
      this.activeLayer = Math.max(0, Math.min(this.layers.length - 1, Math.round(index)));
      this.render();
      return this;
    }
    setLayerColors(colorA, colorB, index = this.activeLayer) {
      const item = this.layers[index];
      if (item) {
        item.colorA = colorA;
        item.colorB = colorB;
      }
      this.render();
      return this;
    }
    setLayerText(text, index = this.activeLayer) {
      const item = this.layers[index];
      if (item) item.text = text;
      this.render();
      return this;
    }
    addLayer(options = {}) {
      this.layers.push(this.makeLayer(options, this.layers.length));
      this.activeLayer = this.layers.length - 1;
      this.render();
      return this;
    }
    removeLayer(index = this.activeLayer) {
      if (this.layers.length > 1) this.layers.splice(Math.max(0, Math.min(this.layers.length - 1, index)), 1);
      this.activeLayer = Math.max(0, Math.min(this.activeLayer, this.layers.length - 1));
      this.render();
      return this;
    }
    resultDataURL() {
      return this.resultCanvas.toDataURL("image/png");
    }
    compareDataURL() {
      return this.compareCanvas.toDataURL("image/png");
    }
    render() {
      this.renderQueued = false;
      if (this.disposed || !this.layers.length) return this;
      this.lastRender = typeof performance !== "undefined" ? performance.now() : Date.now();
      this.drawBase();
      this.drawActiveLayer();
      this.drawResult();
      this.drawCompare();
      return this;
    }
    dispose() {
      this.disposed = true;
      this.renderQueued = false;
      this.root.innerHTML = "";
      this.root.classList.remove("pulse-blend-modes");
    }
    makeLayer(input, index) {
      return layer(
        input.name ?? `Layer ${index + 1}`,
        input.enabled ?? true,
        input.blendMode ?? "screen",
        input.opacity ?? 0.75,
        input.exposure ?? 1,
        input.layerType ?? "spotlight",
        input.colorA ?? "#4dfcff",
        input.colorB ?? "#ffffff",
        input.scale ?? 1,
        input.rotation ?? 0,
        input.offsetX ?? 0,
        input.offsetY ?? 0,
        input.density ?? 12,
        input.softness ?? 0.5,
        input.text ?? "BLEND"
      );
    }
    makeCanvas() {
      const canvas = document.createElement("canvas");
      canvas.width = this.size;
      canvas.height = this.size;
      return canvas;
    }
    panel(name, canvas) {
      const wrap = document.createElement("div");
      wrap.className = "blend-mode-panel";
      const label = document.createElement("span");
      label.textContent = name;
      wrap.append(canvas, label);
      return wrap;
    }
    ctx(canvas) {
      canvas.width = this.size;
      canvas.height = this.size;
      return canvas.getContext("2d", { willReadFrequently: true });
    }
    scheduleRender() {
      if (this.disposed || this.renderQueued) return;
      const now2 = typeof performance !== "undefined" ? performance.now() : Date.now();
      const delay = Math.max(0, this.renderInterval - (now2 - this.lastRender));
      this.renderQueued = true;
      const run = () => {
        if (!this.disposed) this.render();
        else this.renderQueued = false;
      };
      if (delay <= 0 && typeof requestAnimationFrame !== "undefined") requestAnimationFrame(run);
      else setTimeout(run, delay);
    }
    drawBase() {
      const s = this.size, ctx = this.ctx(this.baseCanvas);
      if (this.sourceMode === "portrait") this.drawPortrait(ctx, s);
      else if (this.sourceMode === "shapes") this.drawShapes(ctx, s);
      else if (this.sourceMode === "product") this.drawProduct(ctx, s);
      else this.drawGradient(ctx, s);
      this.applyExposure(ctx, s, this.baseExposure);
      if (this.showLabels) this.labelCanvas(ctx, s, "BASE");
    }
    drawActiveLayer() {
      const ctx = this.ctx(this.layerCanvas);
      this.renderLayer(ctx, this.active, this.size);
      if (this.showLabels) this.labelCanvas(ctx, this.size, this.active.blendMode.toUpperCase());
    }
    drawResult() {
      const s = this.size, ctx = this.ctx(this.resultCanvas), temp = this.ctx(this.tempLayerCanvas);
      ctx.drawImage(this.baseCanvas, 0, 0);
      this.layers.forEach((item, index) => {
        if (!item.enabled) return;
        temp.clearRect(0, 0, s, s);
        const live = { ...item };
        live.rotation += Math.sin(this.time * Math.PI * 2 + index) * 6;
        live.offsetX += Math.sin(this.time * Math.PI * 2 + index * 1.7) * 0.05;
        live.offsetY += Math.cos(this.time * Math.PI * 2 + index * 1.3) * 0.05;
        this.renderLayer(temp, live, s);
        ctx.save();
        ctx.globalAlpha = clamp10(item.opacity);
        ctx.globalCompositeOperation = item.blendMode;
        ctx.drawImage(this.tempLayerCanvas, 0, 0);
        ctx.restore();
      });
      if (this.showLabels) this.labelCanvas(ctx, s, "FINAL");
    }
    drawCompare() {
      const s = this.size, ctx = this.ctx(this.compareCanvas);
      ctx.drawImage(this.baseCanvas, 0, 0);
      ctx.save();
      ctx.beginPath();
      ctx.rect(s * 0.5, 0, s * 0.5, s);
      ctx.clip();
      ctx.drawImage(this.resultCanvas, 0, 0);
      ctx.restore();
      ctx.strokeStyle = "rgba(255,255,255,.9)";
      ctx.lineWidth = Math.max(1, s * 0.01);
      ctx.beginPath();
      ctx.moveTo(s * 0.5, 0);
      ctx.lineTo(s * 0.5, s);
      ctx.stroke();
      if (this.showLabels) this.labelCanvas(ctx, s, "SPLIT");
    }
    renderLayer(ctx, item, s) {
      ctx.clearRect(0, 0, s, s);
      ctx.save();
      ctx.translate(s * 0.5 + item.offsetX * s * 0.25, s * 0.5 + item.offsetY * s * 0.25);
      ctx.rotate(item.rotation * Math.PI / 180);
      ctx.scale(item.scale, item.scale);
      ctx.translate(-s * 0.5, -s * 0.5);
      if (item.layerType === "gradientGlow") this.drawGradientGlow(ctx, s, item);
      else if (item.layerType === "colorBars") this.drawColorBars(ctx, s, item);
      else if (item.layerType === "duotoneBlob") this.drawDuotoneBlob(ctx, s, item);
      else if (item.layerType === "spotlight") this.drawSpotlight(ctx, s, item);
      else if (item.layerType === "stripes") this.drawStripes(ctx, s, item);
      else if (item.layerType === "noise") this.drawNoise(ctx, s, item);
      else if (item.layerType === "checker") this.drawChecker(ctx, s, item);
      else if (item.layerType === "circles") this.drawCircles(ctx, s, item);
      else if (item.layerType === "text") this.drawText(ctx, s, item);
      ctx.restore();
      this.applyExposure(ctx, s, item.exposure);
    }
    drawPortrait(ctx, s) {
      const bg = ctx.createLinearGradient(0, 0, s, s);
      bg.addColorStop(0, "#08141b");
      bg.addColorStop(0.45, "#16384a");
      bg.addColorStop(1, "#10070d");
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, s, s);
      ctx.fillStyle = "rgba(0,0,0,.28)";
      ctx.beginPath();
      ctx.ellipse(s * 0.5, s * 0.82, s * 0.18, s * 0.05, 0, 0, Math.PI * 2);
      ctx.fill();
      const body = ctx.createLinearGradient(s * 0.38, s * 0.25, s * 0.63, s * 0.83);
      body.addColorStop(0, "#f6c38a");
      body.addColorStop(0.35, "#ba6a3f");
      body.addColorStop(1, "#24324c");
      ctx.fillStyle = body;
      this.roundRect(ctx, s * 0.36, s * 0.34, s * 0.28, s * 0.42, s * 0.09);
      ctx.fill();
      ctx.fillStyle = "#5a3426";
      ctx.beginPath();
      ctx.arc(s * 0.5, s * 0.25, s * 0.11, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = "#1a120d";
      ctx.beginPath();
      ctx.arc(s * 0.5, s * 0.2, s * 0.115, Math.PI, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = "#d38852";
      ctx.lineWidth = s * 0.048;
      ctx.lineCap = "round";
      ctx.beginPath();
      ctx.moveTo(s * 0.4, s * 0.45);
      ctx.lineTo(s * 0.25, s * 0.58);
      ctx.moveTo(s * 0.6, s * 0.45);
      ctx.lineTo(s * 0.75, s * 0.58);
      ctx.stroke();
      ctx.fillStyle = "#f3f7ff";
      ctx.fillRect(s * 0.458, s * 0.42, s * 0.084, s * 0.21);
    }
    drawGradient(ctx, s) {
      const bg = ctx.createLinearGradient(0, 0, s, s);
      bg.addColorStop(0, "#0a0d18");
      bg.addColorStop(0.35, "#3d226e");
      bg.addColorStop(0.7, "#0d6b7a");
      bg.addColorStop(1, "#f96c2f");
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, s, s);
      ctx.fillStyle = "rgba(255,255,255,.16)";
      for (let i = 0; i < 8; i++) {
        this.roundRect(ctx, s * (0.08 + i * 0.07), s * (0.14 + i * 0.015), s * 0.13, s * 0.07, s * 0.02);
        ctx.fill();
      }
      ctx.fillStyle = "rgba(255,255,255,.92)";
      ctx.font = `900 ${Math.round(s * 0.13)}px system-ui`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("POSTER", s * 0.5, s * 0.47);
      ctx.font = `700 ${Math.round(s * 0.045)}px system-ui`;
      ctx.fillText("Blend stack", s * 0.5, s * 0.56);
    }
    drawShapes(ctx, s) {
      const bg = ctx.createLinearGradient(0, 0, s, s);
      bg.addColorStop(0, "#040404");
      bg.addColorStop(0.52, "#777");
      bg.addColorStop(1, "#f2f2f2");
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, s, s);
      ctx.fillStyle = "#fff";
      ctx.beginPath();
      ctx.arc(s * 0.28, s * 0.32, s * 0.14, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = "#bdbdbd";
      ctx.fillRect(s * 0.52, s * 0.18, s * 0.24, s * 0.24);
      ctx.fillStyle = "#0c0c0c";
      ctx.beginPath();
      ctx.moveTo(s * 0.24, s * 0.72);
      ctx.lineTo(s * 0.48, s * 0.47);
      ctx.lineTo(s * 0.73, s * 0.72);
      ctx.closePath();
      ctx.fill();
    }
    drawProduct(ctx, s) {
      const bg = ctx.createLinearGradient(0, 0, 0, s);
      bg.addColorStop(0, "#12161c");
      bg.addColorStop(1, "#07090d");
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, s, s);
      const floor2 = ctx.createLinearGradient(0, s * 0.58, 0, s);
      floor2.addColorStop(0, "rgba(255,255,255,.08)");
      floor2.addColorStop(1, "rgba(255,255,255,0)");
      ctx.fillStyle = floor2;
      ctx.fillRect(0, s * 0.58, s, s * 0.42);
      ctx.fillStyle = "rgba(0,0,0,.32)";
      ctx.beginPath();
      ctx.ellipse(s * 0.5, s * 0.79, s * 0.17, s * 0.05, 0, 0, Math.PI * 2);
      ctx.fill();
      const bottle = ctx.createLinearGradient(s * 0.42, 0, s * 0.58, 0);
      bottle.addColorStop(0, "#d7dde8");
      bottle.addColorStop(0.5, "#ffffff");
      bottle.addColorStop(1, "#c4ceda");
      ctx.fillStyle = bottle;
      this.roundRect(ctx, s * 0.39, s * 0.22, s * 0.22, s * 0.48, s * 0.05);
      ctx.fill();
      ctx.fillStyle = "#111920";
      this.roundRect(ctx, s * 0.435, s * 0.15, s * 0.13, s * 0.11, s * 0.02);
      ctx.fill();
      ctx.fillStyle = "#e9eef5";
      ctx.fillRect(s * 0.435, s * 0.38, s * 0.13, s * 0.11);
    }
    drawGradientGlow(ctx, s, item) {
      const g = ctx.createRadialGradient(s * 0.35, s * 0.32, s * 0.08, s * 0.45, s * 0.42, s * 0.55);
      g.addColorStop(0, item.colorA);
      g.addColorStop(Math.max(0.35, 1 - item.softness), item.colorB);
      g.addColorStop(1, "rgba(0,0,0,0)");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, s, s);
    }
    drawSpotlight(ctx, s, item) {
      const g = ctx.createRadialGradient(s * 0.5, s * 0.5, s * 0.05, s * 0.5, s * 0.5, s * 0.46);
      g.addColorStop(0, item.colorB);
      g.addColorStop(Math.max(0.2, 1 - item.softness), item.colorA);
      g.addColorStop(1, "rgba(0,0,0,0)");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, s, s);
    }
    drawColorBars(ctx, s, item) {
      const bars = 6;
      for (let i = 0; i < bars; i++) {
        ctx.fillStyle = mixHex(item.colorA, item.colorB, i / (bars - 1));
        ctx.fillRect(i * s / bars, 0, s / bars + 1, s);
      }
    }
    drawDuotoneBlob(ctx, s, item) {
      const g = ctx.createLinearGradient(0, 0, s, s);
      g.addColorStop(0, item.colorA);
      g.addColorStop(1, item.colorB);
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.moveTo(s * 0.18, s * 0.32);
      ctx.bezierCurveTo(s * 0.28, s * 0.08, s * 0.68, s * 0.12, s * 0.78, s * 0.36);
      ctx.bezierCurveTo(s * 0.9, s * 0.6, s * 0.68, s * 0.88, s * 0.38, s * 0.82);
      ctx.bezierCurveTo(s * 0.08, s * 0.74, s * 0.06, s * 0.52, s * 0.18, s * 0.32);
      ctx.fill();
    }
    drawStripes(ctx, s, item) {
      const density = Math.max(2, item.density);
      ctx.fillStyle = item.colorA;
      ctx.fillRect(0, 0, s, s);
      ctx.strokeStyle = item.colorB;
      ctx.lineWidth = s / (density * 2.6);
      for (let i = -s; i < s * 2; i += s / density) {
        ctx.beginPath();
        ctx.moveTo(i, 0);
        ctx.lineTo(i - s, s);
        ctx.stroke();
      }
    }
    drawNoise(ctx, s, item) {
      const img = ctx.createImageData(s, s), d = img.data;
      for (let i = 0; i < d.length; i += 4) {
        const x = i / 4 % s, y = Math.floor(i / 4 / s);
        const n = Math.sin(x * 12.9898 + y * 78.233 + this.time * 22) * 43758.5453;
        const c = hexMixRgb(item.colorA, item.colorB, n - Math.floor(n));
        d[i] = c.r;
        d[i + 1] = c.g;
        d[i + 2] = c.b;
        d[i + 3] = 255;
      }
      ctx.putImageData(img, 0, 0);
    }
    drawChecker(ctx, s, item) {
      const density = Math.max(2, item.density), cell = s / density;
      for (let y = 0; y < density; y++) for (let x = 0; x < density; x++) {
        ctx.fillStyle = (x + y) % 2 === 0 ? item.colorA : item.colorB;
        ctx.fillRect(x * cell, y * cell, cell + 1, cell + 1);
      }
    }
    drawCircles(ctx, s, item) {
      const density = Math.max(3, Math.floor(item.density * 0.5));
      for (let y = 0; y < density; y++) for (let x = 0; x < density; x++) {
        ctx.fillStyle = mixHex(item.colorA, item.colorB, (x + y) % Math.max(2, density - 1) / Math.max(1, density - 1));
        ctx.beginPath();
        ctx.arc((x + 0.5) * s / density, (y + 0.5) * s / density, s / (density * 3.1), 0, Math.PI * 2);
        ctx.fill();
      }
    }
    drawText(ctx, s, item) {
      const g = ctx.createLinearGradient(0, 0, s, s);
      g.addColorStop(0, item.colorA);
      g.addColorStop(1, item.colorB);
      ctx.fillStyle = g;
      ctx.font = `900 ${Math.round(s * 0.19)}px system-ui`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(item.text || "BLEND", s * 0.5, s * 0.5);
    }
    applyExposure(ctx, s, exposure) {
      if (Math.abs(exposure - 1) < 1e-3) return;
      const img = ctx.getImageData(0, 0, s, s), d = img.data;
      for (let i = 0; i < d.length; i += 4) {
        d[i] = clamp255(d[i] * exposure);
        d[i + 1] = clamp255(d[i + 1] * exposure);
        d[i + 2] = clamp255(d[i + 2] * exposure);
      }
      ctx.putImageData(img, 0, 0);
    }
    labelCanvas(ctx, s, text) {
      ctx.save();
      ctx.fillStyle = "rgba(0,0,0,.72)";
      this.roundRect(ctx, s * 0.25, s * 0.04, s * 0.5, s * 0.08, 10);
      ctx.fill();
      ctx.fillStyle = "#fff";
      ctx.font = `800 ${Math.round(s * 0.03)}px system-ui`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(text, s * 0.5, s * 0.08);
      ctx.restore();
    }
    roundRect(ctx, x, y, w, h, r) {
      const rr = Math.min(r, w / 2, h / 2);
      ctx.beginPath();
      ctx.moveTo(x + rr, y);
      ctx.arcTo(x + w, y, x + w, y + h, rr);
      ctx.arcTo(x + w, y + h, x, y + h, rr);
      ctx.arcTo(x, y + h, x, y, rr);
      ctx.arcTo(x, y, x + w, y, rr);
      ctx.closePath();
    }
  };
  var PulseBlendModesAdapter = {
    test: (target) => Boolean(target?.__pulseBlendModes),
    props: () => [...PROPS3],
    get: (target, prop) => Number(target[prop]) || 0,
    set: (target, prop, value) => target.writeProp(prop, value),
    unit: (_target, prop) => prop === "rotation" ? "deg" : ""
  };
  registerAdapter(PulseBlendModesAdapter);
  function blendModes(root, params) {
    return new PulseBlendModes(root, params);
  }

  // src/spacing/spacing.ts
  var INTERACTIVE_SELECTOR = 'a,button,input,select,textarea,[role="button"],[tabindex]';
  function resolveElement(target) {
    if (!target) return null;
    if (typeof target === "string") {
      if (typeof document === "undefined") return null;
      const found = document.querySelector(target);
      return found instanceof HTMLElement ? found : null;
    }
    return target;
  }
  function labelFor(target, el) {
    if (typeof target === "string") return target;
    if (el.id) return `#${el.id}`;
    const role = el.dataset?.pulseStructureRole;
    return role ? `[data-pulse-structure-role="${role}"]` : el.tagName.toLowerCase();
  }
  function rectFrom(el) {
    const r = el.getBoundingClientRect();
    return {
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      top: r.top,
      right: r.right,
      bottom: r.bottom,
      left: r.left
    };
  }
  function inset(rect, padding) {
    const width = Math.max(0, rect.width - padding * 2);
    const height = Math.max(0, rect.height - padding * 2);
    return {
      x: rect.x + padding,
      y: rect.y + padding,
      left: rect.left + padding,
      top: rect.top + padding,
      width,
      height,
      right: rect.left + padding + width,
      bottom: rect.top + padding + height
    };
  }
  function roundRect(x, y, width, height) {
    return {
      x,
      y,
      width,
      height,
      left: x,
      top: y,
      right: x + width,
      bottom: y + height
    };
  }
  function overlapAmount(a, b) {
    const x = Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left));
    const y = Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
    return x * y;
  }
  function escapes(child, parent) {
    const left = Math.max(0, parent.left - child.left);
    const top = Math.max(0, parent.top - child.top);
    const right = Math.max(0, child.right - parent.right);
    const bottom = Math.max(0, child.bottom - parent.bottom);
    return Math.max(left, top, right, bottom);
  }
  function offGridAmount(rect, grid2) {
    const values = [rect.x, rect.y, rect.width, rect.height];
    return values.reduce((max2, value) => Math.max(max2, Math.abs(value - Math.round(value / grid2) * grid2)), 0);
  }
  function selectorList(selector, root) {
    if (!selector) return [];
    return Array.from(root.querySelectorAll(selector)).filter((el) => el instanceof HTMLElement).map((el) => ({ el, label: labelFor(el, el), rect: rectFrom(el) }));
  }
  var PulseSpacing = class {
    constructor(root, options = {}) {
      this.__pulseSpacing = true;
      this.progress = 0;
      this.lastReport = null;
      const el = resolveElement(root);
      if (!el) throw new Error("[pulse:spacing] root not found");
      this.root = el;
      this.options = options;
      this.rootLabel = labelFor(root, el);
    }
    audit(options = {}) {
      const config = { ...this.options, ...options };
      const rootRect = rectFrom(this.root);
      const usable = inset(rootRect, config.padding ?? 0);
      const measured = this.measureChildren(config);
      const violations = [];
      const suggestions = [];
      const rects = { [this.rootLabel]: rootRect };
      measured.forEach((item) => {
        rects[item.label] = item.rect;
        const escape = escapes(item.rect, usable);
        if (escape > 0) {
          violations.push({
            type: "boundary",
            target: item.label,
            severity: "fail",
            amount: escape,
            message: `${item.label} escapes ${this.rootLabel} by ${Math.round(escape)}px`,
            rect: item.rect,
            parentRect: usable
          });
          suggestions.push({
            type: "contain",
            target: item.label,
            within: this.rootLabel,
            message: `Contain ${item.label} inside its parent usable area before animating it.`
          });
        }
      });
      for (let i = 0; i < measured.length; i++) {
        for (let j = i + 1; j < measured.length; j++) {
          const a = measured[i];
          const b = measured[j];
          if (a.el.contains(b.el) || b.el.contains(a.el)) continue;
          const amount = overlapAmount(a.rect, b.rect);
          if (amount > 0) {
            const target = a.rect.width * a.rect.height <= b.rect.width * b.rect.height ? a : b;
            const against = target === a ? b : a;
            violations.push({
              type: "overlap",
              target: target.label,
              against: against.label,
              severity: "fail",
              amount,
              message: `${target.label} overlaps ${against.label}`,
              rect: target.rect,
              parentRect: against.rect
            });
            suggestions.push({
              type: "move-to-lane",
              target: target.label,
              message: "Move the smaller floating module into a declared lane or reserve a slot for it."
            });
          }
        }
      }
      selectorList(config.textSelector, this.root).forEach((item) => {
        const overflow = Math.max(0, item.el.scrollWidth - item.el.clientWidth);
        if (overflow > 1) {
          violations.push({
            type: "text-overflow",
            target: item.label,
            severity: "fail",
            amount: overflow,
            message: `${item.label} text exceeds its box by ${Math.round(overflow)}px`,
            rect: item.rect
          });
          suggestions.push({
            type: "wrap-text",
            target: item.label,
            message: `Allow ${item.label} to wrap, reduce type scale, or widen its text lane.`
          });
        }
      });
      selectorList(config.touchSelector ?? INTERACTIVE_SELECTOR, this.root).forEach((item) => {
        if (item.rect.width === 0 || item.rect.height === 0) return;
        if (item.rect.width < 44 || item.rect.height < 44) {
          violations.push({
            type: "touch-target",
            target: item.label,
            severity: "warn",
            amount: Math.min(item.rect.width, item.rect.height),
            message: `${item.label} is smaller than the 44px touch target floor`,
            rect: item.rect
          });
        }
      });
      if (config.checkGrid && config.grid && config.grid > 0) {
        measured.forEach((item) => {
          const amount = offGridAmount(item.rect, config.grid ?? 4);
          if (amount > 0.5) {
            violations.push({
              type: "off-grid",
              target: item.label,
              severity: "warn",
              amount,
              message: `${item.label} is not aligned to the ${config.grid}px spacing grid`,
              rect: item.rect
            });
          }
        });
      }
      const failCount = violations.filter((v) => v.severity === "fail").length;
      const warnCount = violations.length - failCount;
      const report = {
        ok: failCount === 0,
        score: Math.max(0, 100 - failCount * 18 - warnCount * 6),
        root: this.rootLabel,
        violations,
        suggestions,
        rects
      };
      this.lastReport = report;
      this.root.dataset.pulseSpacingOk = String(report.ok);
      this.root.dataset.pulseSpacingScore = String(report.score);
      this.root.dataset.pulseSpacingViolations = String(report.violations.length);
      return report;
    }
    match(options) {
      const target = resolveElement(options.target);
      const within = resolveElement(options.within);
      if (!target) throw new Error("[pulse:spacing] match target not found");
      if (!within) throw new Error("[pulse:spacing] match lane not found");
      const mode = options.mode ?? "contain";
      const lane = inset(rectFrom(within), options.padding ?? 0);
      const current = rectFrom(target);
      const rect = this.fitRect(current, lane, mode);
      const style = {
        position: "absolute",
        left: `${Math.round(rect.left)}px`,
        top: `${Math.round(rect.top)}px`,
        width: `${Math.round(rect.width)}px`,
        height: `${Math.round(rect.height)}px`
      };
      if (options.apply) this.applyRect(target, style);
      return {
        target: labelFor(options.target, target),
        within: labelFor(options.within, within),
        mode,
        rect,
        style
      };
    }
    get violationCount() {
      return this.lastReport?.violations.length ?? this.audit().violations.length;
    }
    get score() {
      return this.lastReport?.score ?? this.audit().score;
    }
    measureChildren(config) {
      const targets = config.children?.length ? config.children : Array.from(this.root.children).filter((el) => el instanceof HTMLElement);
      return targets.flatMap((target) => {
        const el = resolveElement(target);
        return el ? [{ el, label: labelFor(target, el), rect: rectFrom(el) }] : [];
      });
    }
    fitRect(current, lane, mode) {
      if (mode === "fill" || mode === "horizontal-fill") return roundRect(lane.left, lane.top, lane.width, lane.height);
      if (mode === "vertical-fill") return roundRect(lane.left, lane.top, Math.min(current.width, lane.width), lane.height);
      const width = Math.min(current.width, lane.width);
      const height = Math.min(current.height, lane.height);
      const x = mode === "center" ? lane.left + (lane.width - width) / 2 : Math.min(Math.max(current.left, lane.left), lane.right - width);
      const y = mode === "center" ? lane.top + (lane.height - height) / 2 : Math.min(Math.max(current.top, lane.top), lane.bottom - height);
      return roundRect(x, y, width, height);
    }
    applyRect(target, style) {
      if (style.position) target.style.position = style.position;
      if (style.left) target.style.left = style.left;
      if (style.top) target.style.top = style.top;
      if (style.width) target.style.width = style.width;
      if (style.height) target.style.height = style.height;
    }
  };
  var PulseSpacingAdapter = {
    test: (target) => Boolean(target?.__pulseSpacing),
    props: () => ["score", "violationCount", "progress"],
    get: (target, prop) => {
      if (prop === "score") return target.score;
      if (prop === "violationCount") return target.violationCount;
      if (prop === "progress") return target.progress;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "progress") {
        target.progress = Math.max(0, Math.min(1, value));
        target.root.style.setProperty("--pulse-spacing-progress", String(target.progress));
      }
    },
    unit: () => ""
  };
  registerAdapter(PulseSpacingAdapter);
  function spacing(root, options) {
    return new PulseSpacing(root, options);
  }

  // src/structure/structure.ts
  function resolveElement2(target) {
    if (!target) return null;
    if (typeof target === "string") {
      if (typeof document === "undefined") return null;
      const found = document.querySelector(target);
      return found instanceof HTMLElement ? found : null;
    }
    return target;
  }
  function selectorLabel(target) {
    if (typeof target === "string") return target;
    return target.id ? `#${target.id}` : target.tagName.toLowerCase();
  }
  var PulseStructure = class {
    constructor(root, options = {}) {
      this.__pulseStructure = true;
      this.progress = 0;
      this.lastProof = null;
      const el = resolveElement2(root);
      if (!el) throw new Error("[pulse:structure] root not found");
      this.root = el;
      this.options = options;
    }
    apply() {
      this.nodes().forEach((node) => {
        const el = resolveElement2(node.selector);
        if (!el) return;
        el.dataset.pulseStructureId = node.id;
        el.dataset.pulseStructureRole = node.role;
        if (node.parent) el.dataset.pulseStructureParent = node.parent;
        if (node.fit) el.dataset.pulseStructureFit = node.fit;
        if (node.textFit) el.dataset.pulseStructureTextFit = node.textFit;
        if (typeof node.padding === "number") el.style.setProperty("--pulse-structure-pad", `${node.padding}px`);
        if (node.textFit === "wrap") {
          el.style.overflowWrap = "anywhere";
          el.style.wordBreak = "normal";
        } else if (node.textFit === "truncate") {
          el.style.overflow = "hidden";
          el.style.textOverflow = "ellipsis";
          el.style.whiteSpace = "nowrap";
        }
      });
      this.root.dataset.pulseStructureReady = "true";
      return this;
    }
    audit() {
      const nodes = this.nodes();
      const proofNodes = nodes.map((node) => ({
        id: node.id,
        selector: selectorLabel(node.selector),
        role: node.role,
        parent: node.parent,
        found: Boolean(resolveElement2(node.selector))
      }));
      const suggestions = [];
      nodes.forEach((node) => {
        if (node.parent && !nodes.some((candidate) => candidate.id === node.parent)) {
          suggestions.push({
            type: "missing-parent",
            target: selectorLabel(node.selector),
            message: `${node.id} references missing parent ${node.parent}`
          });
        }
        if (node.fit && node.target) {
          suggestions.push({
            type: node.fit,
            target: selectorLabel(node.selector),
            within: selectorLabel(node.target),
            message: `${node.id} should fit ${node.fit} inside ${selectorLabel(node.target)}`
          });
        }
        if (node.textFit && node.textFit !== "none") {
          suggestions.push({
            type: "text-fit",
            target: selectorLabel(node.selector),
            message: `${node.id} text fit mode is ${node.textFit}`
          });
        }
      });
      const spacing2 = new PulseSpacing(this.root, {
        ...this.options.spacing,
        children: nodes.map((node) => node.selector).filter((selector) => resolveElement2(selector))
      }).audit();
      const missing = proofNodes.filter((node) => !node.found).length;
      const ok = missing === 0 && spacing2.ok;
      const proof = {
        ok,
        score: Math.max(0, spacing2.score - missing * 20),
        nodes: proofNodes,
        suggestions: [...suggestions, ...spacing2.suggestions],
        spacing: spacing2
      };
      this.lastProof = proof;
      this.root.dataset.pulseStructureOk = String(proof.ok);
      this.root.dataset.pulseStructureScore = String(proof.score);
      this.root.dataset.pulseStructureNodes = String(proof.nodes.length);
      return proof;
    }
    match(id2, apply = true) {
      const node = this.nodes().find((candidate) => candidate.id === id2);
      if (!node?.fit || !node.target) throw new Error(`[pulse:structure] node ${id2} has no fit target`);
      return new PulseSpacing(this.root).match({
        target: node.selector,
        within: node.target,
        mode: node.fit,
        padding: node.padding ?? 0,
        apply
      });
    }
    autoFit() {
      this.nodes().forEach((node) => {
        if (node.fit && node.target) this.match(node.id, true);
      });
      return this;
    }
    get score() {
      return this.lastProof?.score ?? this.audit().score;
    }
    get nodeCount() {
      return this.nodes().length;
    }
    nodes() {
      return this.options.nodes ?? [];
    }
  };
  var PulseStructureAdapter = {
    test: (target) => Boolean(target?.__pulseStructure),
    props: () => ["score", "nodeCount", "progress"],
    get: (target, prop) => {
      if (prop === "score") return target.score;
      if (prop === "nodeCount") return target.nodeCount;
      if (prop === "progress") return target.progress;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "progress") {
        target.progress = Math.max(0, Math.min(1, value));
        target.root.style.setProperty("--pulse-structure-progress", String(target.progress));
      }
    },
    unit: () => ""
  };
  registerAdapter(PulseStructureAdapter);
  function structure(root, options) {
    return new PulseStructure(root, options);
  }

  // src/profiler/profiler.ts
  var PulseProfiler = class {
    constructor() {
      this.enabled = false;
      this.lastFrame = 0;
      this.frames = 0;
      this.fps = 0;
      this.frameTime = 0;
      this._counts = { bags: 0, tweens: 0, timelines: 0, scopes: 0, signals: 0, patches: 0 };
      this.resources = /* @__PURE__ */ new Map();
      this.runtimeWarnings = /* @__PURE__ */ new Set();
      this.track = (_dt) => {
        if (!this.enabled) return;
        const now2 = typeof performance !== "undefined" ? performance.now() : Date.now();
        const delta = now2 - this.lastFrame;
        this.lastFrame = now2;
        this.frameTime = this.frameTime * 0.9 + delta * 0.1;
        this.frames++;
        if (delta > 34) this.runtimeWarnings.add(`long-frame:${Math.round(delta)}ms`);
        if (this.frames >= 30) {
          this.fps = Math.round(1e3 / this.frameTime);
          this.frames = 0;
        }
      };
    }
    enable() {
      if (this.enabled) return;
      this.enabled = true;
      this.lastFrame = typeof performance !== "undefined" ? performance.now() : Date.now();
      this._unsub = ticker.add(this.track);
    }
    disable() {
      this.enabled = false;
      this._unsub?.();
    }
    snapshot() {
      const count = (kind) => this.resources.get(kind)?.size ?? 0;
      const adapterCounts = {};
      adapters.forEach((adapter) => {
        const name = adapter.name ?? "anonymous";
        adapterCounts[name] = (adapterCounts[name] ?? 0) + 1;
      });
      return {
        fps: this.fps,
        frameTime: +this.frameTime.toFixed(2),
        activeTimers: ticker.size,
        activeBags: count("bag") || this._counts.bags,
        activeTweens: count("tween") || this._counts.tweens,
        activeTimelines: count("timeline") || this._counts.timelines,
        activeScopes: count("scope") || this._counts.scopes,
        activeSignals: count("signal") || this._counts.signals,
        activePatches: count("patch") || this._counts.patches,
        adapters: adapterCounts,
        warnings: [...this.runtimeWarnings, ...this.warnLeaks()]
      };
    }
    /** Inspect a target's adapter (reads adapter registry without mutating). */
    inspect(target, resolveAdapter2) {
      const a = resolveAdapter2(target);
      return { adapter: a ? a.name ?? "anon" : null, props: a ? a.props(target) : [] };
    }
    warnLeaks() {
      const warnings = [];
      for (const [kind, items] of this.resources) {
        const disposed = [...items].filter((item) => item?.disposed === true || item?.isDisposed === true).length;
        if (disposed) warnings.push(`${kind}:${disposed} disposed resource${disposed === 1 ? "" : "s"} still tracked`);
      }
      const tracked = [...this.resources.values()].reduce((total, items) => total + items.size, 0);
      if (ticker.size > 0 && tracked === 0) warnings.push(`ticker:${ticker.size} callbacks without tracked owners`);
      return warnings;
    }
    trackResource(kind, resource) {
      const key2 = kind || "resource";
      const items = this.resources.get(key2) ?? /* @__PURE__ */ new Set();
      items.add(resource);
      this.resources.set(key2, items);
      return () => {
        items.delete(resource);
        if (!items.size) this.resources.delete(key2);
      };
    }
    resourceCounts() {
      return Object.fromEntries([...this.resources].map(([kind, items]) => [kind, items.size]));
    }
    clearWarnings() {
      this.runtimeWarnings.clear();
    }
    setCounts(c) {
      Object.assign(this._counts, c);
    }
  };
  var profiler = new PulseProfiler();

  // src/editor/project-schema.ts
  var CURRENT_PULSE_EDITOR_SCHEMA_VERSION = 1;
  function finitePositive(value) {
    return typeof value === "number" && Number.isFinite(value) && value > 0;
  }
  function migratePulseEditorProject(input) {
    if (!input || typeof input !== "object" || Array.isArray(input)) throw new Error("[pulse:editor] project must be an object");
    const source = structuredClone(input);
    const version = Number(source.schemaVersion ?? 0);
    if (version > CURRENT_PULSE_EDITOR_SCHEMA_VERSION) {
      throw new Error(`[pulse:editor] project schema ${version} is newer than runtime schema ${CURRENT_PULSE_EDITOR_SCHEMA_VERSION}`);
    }
    if (version <= 0) {
      source.schemaVersion = 1;
      source.background ?? (source.background = "#000000");
      source.tracks ?? (source.tracks = []);
      source.clips ?? (source.clips = []);
      source.assets ?? (source.assets = []);
    }
    return source;
  }
  function validatePulseEditorProject(input) {
    let project;
    try {
      project = migratePulseEditorProject(input);
    } catch (error) {
      return { ok: false, errors: [error instanceof Error ? error.message : String(error)] };
    }
    const errors = [];
    if (project.schemaVersion !== CURRENT_PULSE_EDITOR_SCHEMA_VERSION) errors.push("schemaVersion must be 1");
    if (!project.id || typeof project.id !== "string") errors.push("id must be a non-empty string");
    if (!project.name || typeof project.name !== "string") errors.push("name must be a non-empty string");
    for (const key2 of ["width", "height", "fps", "duration"]) {
      if (!finitePositive(project[key2])) errors.push(`${key2} must be a positive finite number`);
    }
    for (const key2 of ["tracks", "clips", "assets"]) {
      if (!Array.isArray(project[key2])) errors.push(`${key2} must be an array`);
    }
    if (!errors.length) {
      const ids = [...project.tracks, ...project.clips, ...project.assets].map((item) => item?.id).filter(Boolean);
      if (new Set(ids).size !== ids.length) errors.push("track, clip, and asset ids must be unique");
      project.clips.forEach((clip, index) => {
        if (!finitePositive(clip.end) || clip.start < 0 || clip.end <= clip.start) errors.push(`clips[${index}] has an invalid time range`);
        if (!project.tracks.some((track) => track.id === clip.trackId)) errors.push(`clips[${index}] references missing track ${clip.trackId}`);
      });
    }
    return errors.length ? { ok: false, errors } : { ok: true, errors, project };
  }
  function assertPulseEditorProject(input) {
    const result = validatePulseEditorProject(input);
    if (!result.ok || !result.project) throw new Error(`[pulse:editor] invalid project: ${result.errors.join("; ")}`);
    return result.project;
  }

  // src/editor/editor-runtime.ts
  var DEFAULT_TRANSFORM = { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 };
  function clamp11(value, min, max2) {
    return Math.max(min, Math.min(max2, Number(value) || 0));
  }
  function cloneTransform(transform) {
    return { ...DEFAULT_TRANSFORM, ...transform ?? {} };
  }
  function setPath(state, property, value) {
    state.values[property] = value;
    if (property in state.transform) {
      state.transform[property] = value;
      return;
    }
    if (state.textStyle && property in state.textStyle) {
      state.textStyle[property] = value;
    }
  }
  function interpolateKeyframes(keyframes2, property, time, fallback) {
    const frames = keyframes2.filter((keyframe) => keyframe.property === property).sort((a, b) => a.time - b.time);
    if (!frames.length) return fallback;
    if (time <= frames[0].time) return frames[0].value;
    if (time >= frames[frames.length - 1].time) return frames[frames.length - 1].value;
    const rightIndex = frames.findIndex((frame) => frame.time >= time);
    const left = frames[Math.max(0, rightIndex - 1)];
    const right = frames[rightIndex];
    const span = Math.max(1e-6, right.time - left.time);
    const raw = clamp11((time - left.time) / span, 0, 1);
    const eased = resolveEase(right.easing ?? "linear")(raw);
    return left.value + (right.value - left.value) * eased;
  }
  function effectProgress(effect, clip, localTime) {
    const duration = Math.max(1e-3, effect.duration);
    const clipDuration = Math.max(1e-3, clip.end - clip.start);
    if (effect.phase === "outro") return clamp11((localTime - (clipDuration - duration - effect.delay)) / duration, 0, 1);
    if (effect.phase === "loop") {
      const repeats = Math.max(1, effect.repeat + 1);
      const cycle = Math.max(0, localTime - effect.delay) / duration * repeats % 1;
      return effect.direction === "alternate" ? 1 - Math.abs(cycle * 2 - 1) : cycle;
    }
    return clamp11((localTime - effect.delay) / duration, 0, 1);
  }
  function applyEffect(state, clip, effect) {
    if (!effect.enabled) return;
    const raw = effectProgress(effect, clip, state.localTime);
    const eased = resolveEase(effect.easing || "linear")(raw);
    const amount = Number(effect.params.amount ?? 1) || 1;
    const leaving = effect.phase === "outro";
    const phaseValue = leaving ? 1 - eased : eased;
    if (effect.type === "fade") state.transform.opacity *= phaseValue;
    if (effect.type === "rise") state.transform.y += (1 - phaseValue) * (Number(effect.params.distance ?? 64) || 64) * amount;
    if (effect.type === "pop") state.transform.scale *= 0.72 + phaseValue * 0.28;
    if (effect.type === "pulse") state.transform.scale *= 1 + Math.sin(raw * Math.PI * 2) * 0.06 * amount;
    if (effect.type === "blur") state.values.blur = Math.max(0, (1 - phaseValue) * (Number(effect.params.radius ?? 18) || 18) * amount);
  }
  function evaluatePulseEditorProject(project, time) {
    const safeTime = clamp11(time, 0, Math.max(0, project.duration));
    const tracks = new Map(project.tracks.map((track) => [track.id, track]));
    const ordered = project.clips.filter((clip) => clip.enabled).sort((a, b) => (tracks.get(a.trackId)?.order ?? 0) - (tracks.get(b.trackId)?.order ?? 0));
    const states2 = /* @__PURE__ */ new Map();
    for (const clip of ordered) {
      const track = tracks.get(clip.trackId);
      if (!track || !track.visible || safeTime < clip.start || safeTime >= clip.end) continue;
      const localTime = safeTime - clip.start;
      const duration = Math.max(1e-3, clip.end - clip.start);
      const state = {
        targetId: clip.targetId,
        clipId: clip.id,
        kind: clip.kind,
        active: true,
        muted: track.muted,
        localTime,
        progress: clamp11(localTime / duration, 0, 1),
        text: clip.text,
        wordTimings: clip.wordTimings?.map((word) => ({ ...word })),
        assetId: clip.assetId,
        targetMode: clip.targetMode,
        transform: cloneTransform(clip.transform),
        textStyle: clip.textStyle ? { ...clip.textStyle } : void 0,
        values: {}
      };
      const properties = new Set(clip.keyframes.map((keyframe) => keyframe.property));
      for (const property of properties) {
        const transformValue = state.transform[property];
        const textValue = state.textStyle ? Number(state.textStyle[property]) : Number.NaN;
        const fallback = Number.isFinite(transformValue) ? transformValue : Number.isFinite(textValue) ? textValue : 0;
        setPath(state, property, interpolateKeyframes(clip.keyframes, property, localTime, fallback));
      }
      for (const effect of clip.effects) applyEffect(state, clip, effect);
      const unitCount = clip.targetMode === "words" ? clip.wordTimings?.length ?? clip.text?.trim().split(/\s+/).filter(Boolean).length ?? 0 : clip.targetMode === "chars" ? [...clip.text ?? ""].length : 0;
      if (unitCount > 0) {
        const stagger3 = clip.effects.find((effect) => effect.enabled && effect.phase === "intro")?.stagger ?? 0;
        state.unitProgress = Array.from({ length: unitCount }, (_, index) => {
          const timedWord = clip.targetMode === "words" ? clip.wordTimings?.[index] : void 0;
          const unitStart = timedWord?.start ?? index * stagger3;
          const unitDuration = Math.max(0.08, timedWord ? timedWord.end - timedWord.start : 0.35);
          return clamp11((localTime - unitStart) / unitDuration, 0, 1);
        });
      }
      states2.set(clip.targetId, state);
    }
    return states2;
  }
  var PulseEditorRuntime = class {
    constructor(project, options = {}) {
      this.__pulseEditorRuntime = true;
      this.targets = /* @__PURE__ */ new Map();
      this.frameHandle = 0;
      this.lastNow = 0;
      this.time = 0;
      this.rate = 1;
      this.state = "stopped";
      this.loop = null;
      this.disposed = false;
      this.tick = (now2) => {
        this.frameHandle = 0;
        if (this.state !== "playing" || this.disposed) return;
        const delta = Math.max(0, Math.min(0.1, (now2 - this.lastNow) / 1e3)) * this.rate;
        this.lastNow = now2;
        let next = this.time + delta;
        if (this.loop && next >= this.loop.end) next = this.loop.start + (next - this.loop.end);
        if (next >= this.project.duration) {
          this.seek(this.project.duration);
          this.pause();
          return;
        }
        this.seek(next);
        this.schedule();
      };
      this.project = assertPulseEditorProject(project);
      this.requestFrame = options.requestFrame ?? ((callback) => requestAnimationFrame(callback));
      this.cancelFrame = options.cancelFrame ?? ((handle) => cancelAnimationFrame(handle));
      this.now = options.now ?? (() => performance.now());
      this.onTime = options.onTime;
      this.onState = options.onState;
    }
    get currentTime() {
      return this.time;
    }
    get playbackState() {
      return this.state;
    }
    get playbackRate() {
      return this.rate;
    }
    get activeTargetCount() {
      return this.targets.size;
    }
    get isDisposed() {
      return this.disposed;
    }
    load(project) {
      this.pause();
      this.project = assertPulseEditorProject(project);
      this.time = clamp11(this.time, 0, this.project.duration);
      this.refreshContexts();
      this.seek(this.time);
    }
    snapshotAt(time) {
      return evaluatePulseEditorProject(this.project, time);
    }
    registerTarget(targetId, target, adapter) {
      this.unregisterTarget(targetId);
      const context = this.context(targetId);
      adapter.register?.(target, context);
      adapter.mount(target, context);
      this.targets.set(targetId, { target, adapter });
      this.seek(this.time);
    }
    unregisterTarget(targetId) {
      const entry = this.targets.get(targetId);
      if (!entry) return;
      const context = this.context(targetId);
      entry.adapter.reset(entry.target, context);
      entry.adapter.unregister?.(entry.target, context);
      entry.adapter.dispose(entry.target, context);
      this.targets.delete(targetId);
    }
    play() {
      if (this.disposed || this.state === "playing") return;
      if (this.time >= this.project.duration) this.time = 0;
      this.setState("playing");
      this.seek(this.time);
      this.lastNow = this.now();
      this.schedule();
    }
    pause() {
      if (this.frameHandle) this.cancelFrame(this.frameHandle);
      this.frameHandle = 0;
      if (this.state === "playing") {
        this.setState("paused");
        this.seek(this.time);
      }
    }
    stop() {
      if (this.frameHandle) this.cancelFrame(this.frameHandle);
      this.frameHandle = 0;
      this.setState("stopped");
      this.seek(0);
    }
    seek(time) {
      this.time = clamp11(time, 0, this.project.duration);
      const states2 = this.snapshotAt(this.time);
      for (const [targetId, entry] of this.targets) {
        const context = this.context(targetId);
        const targetState = states2.get(targetId);
        if (!targetState) {
          entry.adapter.reset(entry.target, context);
          continue;
        }
        entry.adapter.update(entry.target, targetState, context);
        entry.adapter.seek(entry.target, this.time, targetState, context);
      }
      this.onTime?.(this.time, this.state);
    }
    step(frames) {
      this.pause();
      this.seek(this.time + frames / Math.max(1, this.project.fps));
    }
    setPlaybackRate(rate) {
      this.rate = clamp11(rate, 0.1, 4);
    }
    setLoop(loop) {
      if (!loop || loop.end <= loop.start) {
        this.loop = null;
        return;
      }
      this.loop = {
        start: clamp11(loop.start, 0, this.project.duration),
        end: clamp11(loop.end, 0, this.project.duration)
      };
    }
    dispose() {
      if (this.disposed) return;
      if (this.frameHandle) this.cancelFrame(this.frameHandle);
      this.frameHandle = 0;
      for (const targetId of [...this.targets.keys()]) this.unregisterTarget(targetId);
      this.disposed = true;
      this.setState("stopped");
    }
    context(targetId) {
      return { project: this.project, targetId, playbackState: this.state };
    }
    refreshContexts() {
      for (const [targetId, entry] of this.targets) {
        entry.adapter.update(entry.target, {
          targetId,
          clipId: null,
          kind: entry.adapter.kind,
          active: false,
          muted: false,
          localTime: 0,
          progress: 0,
          transform: cloneTransform(),
          values: {}
        }, this.context(targetId));
      }
    }
    setState(state) {
      if (this.state === state) return;
      this.state = state;
      this.onState?.(state);
    }
    schedule() {
      if (this.frameHandle || this.state !== "playing" || this.disposed) return;
      this.frameHandle = this.requestFrame(this.tick);
    }
  };
  function editorRuntime(project, options) {
    return new PulseEditorRuntime(project, options);
  }

  // src/editor/project-converter.ts
  var generatedId = 0;
  var id = (prefix) => `${prefix}-${++generatedId}`;
  var num2 = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  var positive2 = (value, fallback) => Math.max(1e-3, num2(value, fallback));
  function targetKind(value, fallback = "dom") {
    const normalized = String(value || "").toLowerCase();
    if (normalized.includes("text") || normalized.includes("lyric") || normalized.includes("word")) return "text";
    if (normalized.includes("image") || normalized.includes("photo")) return "image";
    if (normalized.includes("video")) return "video";
    if (normalized.includes("audio") || normalized.includes("stem")) return "audio";
    if (normalized.includes("svg") || normalized.includes("path")) return "svg";
    return fallback;
  }
  function pulseEffectType(name) {
    const value = String(name || "").toLowerCase();
    if (value.includes("fade")) return "fade";
    if (value.includes("rise") || value.includes("slide") || value.includes("drop") || value.includes("cascade")) return "rise";
    if (value.includes("blur") || value.includes("focus")) return "blur";
    if (value.includes("pulse") || value.includes("shake") || value.includes("wobble") || value.includes("float")) return "pulse";
    return "pop";
  }
  function normalizeTargetMode(mode) {
    const value = String(mode || "").toLowerCase();
    if (value === "word" || value === "words") return "words";
    if (value === "char" || value === "chars" || value === "selection") return "chars";
    return "line";
  }
  function lineFor(source, lineId) {
    return (source.lyrics || []).find((line) => line.id === lineId) || null;
  }
  function relativeTime(value, clipStart) {
    const time = num2(value);
    return Math.max(0, time >= clipStart ? time - clipStart : time);
  }
  function motionClip(source, clip, index, path = false) {
    const line = lineFor(source, clip.lineId);
    const start = Math.max(0, num2(clip.start, num2(line?.start)));
    const end = Math.max(start + 1e-3, num2(clip.end, start + positive2(clip.duration, 0.6)));
    const duration = end - start;
    const sourceEffect = String(clip.effect || (path ? "pathRide" : "popIn"));
    return {
      id: clip.id || id(path ? "pulse-path" : "pulse-motion"),
      trackId: clip.trackId || (path ? "path_motion" : "motion_fx"),
      targetId: clip.targetId || `${clip.lineId || "stage"}:${normalizeTargetMode(clip.targetMode)}:${index}`,
      kind: path ? "svg" : "dom",
      name: clip.name || sourceEffect,
      start,
      end,
      enabled: clip.applied !== false && clip.enabled !== false,
      text: line?.text || "",
      wordTimings: (line?.words || []).map((word, wordIndex) => ({
        id: word.id || `${clip.id || index}-word-${wordIndex}`,
        text: word.text || "",
        start: relativeTime(word.start, start),
        end: Math.max(relativeTime(word.end, start), relativeTime(word.start, start) + 1e-3)
      })),
      targetMode: normalizeTargetMode(clip.targetMode),
      transform: { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 },
      keyframes: (clip.keyframes || []).map((keyframe) => {
        const propertyMap = {
          "transform.x": "x",
          "transform.y": "y",
          "transform.scale": "scale",
          "transform.rotate": "rotate",
          "style.opacity": "opacity"
        };
        return {
          id: keyframe.id || id("pulse-key"),
          property: propertyMap[keyframe.property] || keyframe.property || "opacity",
          time: relativeTime(keyframe.time, start),
          value: num2(keyframe.value),
          easing: keyframe.ease || keyframe.easing || "linear"
        };
      }),
      effects: [{
        id: `${clip.id || index}-effect`,
        type: pulseEffectType(sourceEffect),
        enabled: clip.applied !== false && clip.enabled !== false,
        phase: "intro",
        duration: Math.min(duration, positive2(clip.duration, duration)),
        delay: num2(clip.delay) / 1e3,
        stagger: num2(clip.stagger) / 1e3,
        easing: clip.ease || clip.easing || "outExpo",
        direction: "normal",
        repeat: Math.max(0, Math.round(num2(clip.repeat))),
        params: { amount: num2(clip.intensity, 1), sourceEffect, pathId: clip.pathId || "" }
      }],
      metadata: {
        source: "atlas-motion",
        sourceEffect,
        selector: clip.selector || "",
        selectionRange: clip.selectionRange || null,
        pathId: clip.pathId || null
      }
    };
  }
  function lyricClip(line, index) {
    const start = Math.max(0, num2(line.start));
    const end = Math.max(start + 1e-3, num2(line.end, start + 1));
    return {
      id: `pulse-lyric-${line.id || index}`,
      trackId: line.layerId || "layer_main_text",
      targetId: `${line.id || index}:line`,
      kind: "text",
      name: line.name || String(line.text || "").slice(0, 48) || `Lyric ${index + 1}`,
      start,
      end,
      enabled: line.visible !== false,
      text: line.text || "",
      wordTimings: (line.words || []).map((word, wordIndex) => ({
        id: word.id || `${line.id || index}-word-${wordIndex}`,
        text: word.text || "",
        start: relativeTime(word.start, start),
        end: Math.max(relativeTime(word.end, start), relativeTime(word.start, start) + 1e-3)
      })),
      targetMode: "line",
      transform: {
        x: num2(line.motion?.camera?.x),
        y: num2(line.motion?.camera?.y),
        scale: num2(line.motion?.camera?.zoom, 1),
        rotate: num2(line.motion?.camera?.rotate),
        opacity: num2(line.style?.opacity, 1)
      },
      textStyle: {
        color: line.style?.color || "#ffffff",
        fontFamily: line.style?.fontFamily || "Inter",
        fontSize: positive2(line.style?.fontSize, 112),
        fontWeight: Math.max(100, num2(line.style?.fontWeight, 800)),
        align: ["left", "right"].includes(line.style?.align) ? line.style.align : "center",
        letterSpacing: num2(line.style?.letterSpacing),
        lineHeight: positive2(line.style?.lineHeight, 0.92),
        boxWidth: positive2(line.style?.boxWidth, 88),
        boxHeight: positive2(line.style?.boxHeight, 42)
      },
      keyframes: [],
      effects: [],
      metadata: { source: "atlas-lyric", layerId: line.layerId || "layer_main_text" }
    };
  }
  function convertAtlasEditorProject(source = {}) {
    const tracks = [];
    const seenTracks = /* @__PURE__ */ new Set();
    const ensureTrack = (trackId, name, kind) => {
      if (!trackId || seenTracks.has(trackId)) return;
      seenTracks.add(trackId);
      tracks.push({ id: trackId, name, kind, order: tracks.length, visible: true, locked: false, muted: false });
    };
    (source.layers || []).forEach((layer2, index) => {
      ensureTrack(layer2.id || `layer-${index}`, layer2.name || `Layer ${index + 1}`, targetKind(layer2.kind || layer2.id, "dom"));
    });
    (source.lyrics || []).forEach((line) => ensureTrack(line.layerId || "layer_main_text", "Lyrics", "text"));
    (source.motionClips || []).forEach((clip) => ensureTrack(clip.trackId || "motion_fx", "Motion FX", "dom"));
    (source.pathClips || []).forEach((clip) => ensureTrack(clip.trackId || "path_motion", "Path Motion", "svg"));
    if ((source.images || []).length) ensureTrack("pulse_images", "Images", "image");
    if ((source.audioTracks || []).length) ensureTrack("pulse_audio", "Audio", "audio");
    const assets = [
      ...(source.images || []).map((asset, index) => ({
        id: asset.id || `pulse-image-${index}`,
        kind: "image",
        name: asset.name || asset.fileName || `Image ${index + 1}`,
        source: asset.src || asset.source || ""
      })),
      ...(source.audioTracks || []).map((asset, index) => ({
        id: asset.id || `pulse-audio-${index}`,
        kind: "audio",
        name: asset.name || asset.fileName || `Audio ${index + 1}`,
        source: asset.src || asset.sourceUrl || asset.source || "",
        duration: positive2(asset.duration, 1e-3)
      }))
    ];
    const clips = [
      ...(source.lyrics || []).map(lyricClip),
      ...(source.motionClips || []).map((clip, index) => motionClip(source, clip, index, false)),
      ...(source.pathClips || []).map((clip, index) => motionClip(source, clip, index, true)),
      ...(source.images || []).map((image, index) => ({
        id: `pulse-image-clip-${image.id || index}`,
        trackId: "pulse_images",
        targetId: image.id || `image-${index}`,
        kind: "image",
        name: image.name || image.fileName || `Image ${index + 1}`,
        start: Math.max(0, num2(image.start)),
        end: Math.max(num2(image.start) + 1e-3, num2(image.end, num2(source.duration, 1))),
        enabled: image.visible !== false,
        assetId: image.id || `pulse-image-${index}`,
        transform: { x: num2(image.x), y: num2(image.y), scale: 1, rotate: num2(image.rotation), opacity: num2(image.opacity, 1) },
        keyframes: [],
        effects: [],
        metadata: { source: "atlas-image", width: image.width, height: image.height, units: "percent" }
      })),
      ...(source.audioTracks || []).map((audio, index) => {
        const start = Math.max(0, num2(audio.start));
        return {
          id: `pulse-audio-clip-${audio.id || index}`,
          trackId: "pulse_audio",
          targetId: audio.id || `audio-${index}`,
          kind: "audio",
          name: audio.name || audio.fileName || `Audio ${index + 1}`,
          start,
          end: Math.max(start + 1e-3, start + positive2(audio.duration, num2(source.duration, 1))),
          enabled: audio.visible !== false && !audio.muted,
          assetId: audio.id || `pulse-audio-${index}`,
          transform: { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1 },
          keyframes: [],
          effects: [],
          metadata: { source: "atlas-audio", gain: num2(audio.gain, 1), pan: num2(audio.pan), role: audio.role || "audio" }
        };
      })
    ];
    if (!tracks.length) ensureTrack("motion_fx", "Motion FX", "dom");
    return {
      schemaVersion: 1,
      id: source.id || "pulse-atlas-project",
      name: source.title || source.name || "Pulse Atlas Project",
      width: Math.max(1, Math.round(num2(source.resolution?.width, 1920))),
      height: Math.max(1, Math.round(num2(source.resolution?.height, 1080))),
      fps: Math.max(1, Math.round(num2(source.resolution?.fps, 60))),
      duration: positive2(source.duration, 1),
      background: source.stageBackground?.color || source.background || "#000000",
      tracks,
      clips,
      assets
    };
  }
  function fingerprintPulseEditorProject(project) {
    return JSON.stringify({
      schemaVersion: project.schemaVersion,
      id: project.id,
      size: [project.width, project.height, project.fps, project.duration],
      background: project.background,
      tracks: project.tracks.map((track) => [track.id, track.order, track.visible, track.locked, track.muted]),
      clips: project.clips.map((clip) => [
        clip.id,
        clip.trackId,
        clip.targetId,
        clip.start,
        clip.end,
        clip.enabled,
        clip.assetId,
        clip.transform,
        clip.textStyle,
        clip.keyframes,
        clip.effects,
        clip.metadata
      ]),
      assets: project.assets.map((asset) => [asset.id, asset.kind, asset.name, asset.duration])
    });
  }

  // src/editor/dom-target-adapter.ts
  var states = /* @__PURE__ */ new WeakMap();
  var num3 = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  function stateFor(target) {
    let state = states.get(target);
    if (!state) {
      state = {
        x: 0,
        y: 0,
        scale: 1,
        rotate: 0,
        opacity: 1,
        blur: 0,
        base: {
          translate: target.style.translate,
          scale: target.style.scale,
          rotate: target.style.rotate,
          opacity: target.style.opacity,
          filter: target.style.filter,
          visibility: target.style.visibility
        }
      };
      states.set(target, state);
    }
    return state;
  }
  function write(target, state) {
    target.style.translate = `${state.x}px ${state.y}px`;
    target.style.scale = String(state.scale);
    target.style.rotate = `${state.rotate}deg`;
    target.style.opacity = String(Math.max(0, Math.min(1, state.opacity)));
    const blur = state.blur > 0 ? `blur(${state.blur}px)` : "";
    target.style.filter = [state.base.filter, blur].filter(Boolean).join(" ");
  }
  function restore(target) {
    const state = states.get(target);
    if (!state) return;
    Object.assign(target.style, state.base);
    states.delete(target);
  }
  function createPulseEditorDomAdapter(options = {}) {
    const owns = (target) => typeof HTMLElement !== "undefined" && target instanceof HTMLElement && (options.test?.(target) ?? true);
    const adapter = {
      test: owns,
      props: () => ["x", "y", "scale", "rotate", "opacity", "blur"],
      get: (target, property) => num3(stateFor(target)[property], property === "scale" || property === "opacity" ? 1 : 0),
      set: (target, property, value) => {
        const state = stateFor(target);
        state[property] = num3(value, state[property]);
        write(target, state);
      },
      unit: (_target, property) => property === "rotate" ? "deg" : property === "scale" || property === "opacity" ? "" : "px"
    };
    const targetAdapter = {
      kind: "dom",
      mount(target) {
        stateFor(target);
        target.dataset.pulseTarget = options.name || "editor-dom";
      },
      update(target, next) {
        target.style.visibility = next.active ? stateFor(target).base.visibility : "hidden";
        if (!next.active) return;
        const state = stateFor(target);
        Object.assign(state, next.transform || {});
        state.blur = num3(next.values?.blur);
        write(target, state);
      },
      seek() {
      },
      reset(target) {
        const state = stateFor(target);
        Object.assign(state, { x: 0, y: 0, scale: 1, rotate: 0, opacity: 1, blur: 0 });
        target.style.visibility = state.base.visibility;
        write(target, state);
      },
      dispose(target) {
        delete target.dataset.pulseTarget;
        restore(target);
      }
    };
    return { adapter, targetAdapter };
  }
  function registerPulseEditorDomAdapter(options = {}) {
    const result = createPulseEditorDomAdapter(options);
    registerAdapter(result.adapter);
    return result;
  }

  // src/controls/controls.ts
  function elementValue(element) {
    const input = element;
    if (input.type === "checkbox") return input.checked;
    if (input.type === "range" || input.type === "number") return Number(input.value);
    return input.value ?? "";
  }
  function setElementValue(element, value) {
    const input = element;
    if (input.type === "checkbox") input.checked = Boolean(value);
    else if ("value" in input) input.value = String(value);
  }
  function connectPulseControls(owner, root, schema) {
    const cleanups = [];
    const connected = [];
    const missing = [];
    const bindings = schema.flatMap((descriptor) => {
      const element = root.querySelector(`#${descriptor.id}`);
      if (!element) {
        missing.push(descriptor.id);
        return [];
      }
      connected.push(descriptor.id);
      const event = descriptor.event ?? (element.type === "range" ? "input" : "change");
      const update = () => {
        const value = event === "click" ? true : elementValue(element);
        if (descriptor.apply) descriptor.apply(owner, value, element);
        else if (descriptor.prop) writeProp(descriptor.target?.(owner) ?? owner, descriptor.prop, Number(value));
        const output = root.querySelector(`#${descriptor.id}Value`);
        if (output) output.textContent = descriptor.format ? descriptor.format(value) : String(value);
      };
      element.addEventListener(event, update);
      cleanups.push(() => element.removeEventListener(event, update));
      return [{ descriptor, element }];
    });
    const sync2 = () => {
      bindings.forEach(({ descriptor, element }) => {
        const target = descriptor.target?.(owner) ?? owner;
        const value = descriptor.read ? descriptor.read(owner, element) : descriptor.prop ? readProp(target, descriptor.prop).v : elementValue(element);
        setElementValue(element, value);
        const output = root.querySelector(`#${descriptor.id}Value`);
        if (output) output.textContent = descriptor.format ? descriptor.format(value) : String(value);
      });
    };
    sync2();
    return { connected, missing, sync: sync2, dispose: () => cleanups.splice(0).forEach((fn) => fn()) };
  }
  var numeric2 = (id2, prop = id2) => ({ id: id2, prop });
  var checked = (id2, prop = id2) => ({ id: id2, prop, read: (owner) => Boolean(readProp(owner, prop).v) });
  var selected = (id2, apply, read) => ({
    id: id2,
    apply: (owner, value) => apply(owner, String(value)),
    read: (owner) => read(owner)
  });
  var particleControlSchema = [
    numeric2("spawnRate"),
    numeric2("maxParticles"),
    numeric2("emitterRadius"),
    numeric2("burstAmount"),
    numeric2("spread"),
    numeric2("direction"),
    numeric2("life"),
    numeric2("size"),
    numeric2("speed"),
    numeric2("colorShift"),
    numeric2("gravity"),
    numeric2("wind"),
    numeric2("drag"),
    numeric2("turbulence"),
    numeric2("vortex"),
    numeric2("trailFade"),
    numeric2("glow"),
    numeric2("glint"),
    numeric2("alpha"),
    numeric2("minOpacity"),
    numeric2("edgePadding"),
    numeric2("imageOpacity"),
    numeric2("maskThreshold"),
    checked("edgeCollision"),
    checked("debugVectors"),
    checked("showEmitterRadius"),
    checked("autoCycle"),
    checked("rainbowMode", "rainbow"),
    selected("shape", (owner, value) => owner.setShape(value), (owner) => owner.shape === "dot" ? "circle" : owner.shape),
    selected("emissionMode", (owner, value) => owner.setEmissionMode(value), (owner) => owner.emissionMode),
    selected("blendMode", (owner, value) => owner.setBlendMode(value), (owner) => ["source-over", "lighter", "screen", "multiply", "overlay", "soft-light", "hard-light", "color-dodge"][owner.blendModeIndex]),
    selected("imageMode", (owner, value) => owner.setImageSource(owner.imageUrl, value), (owner) => ["background", "sprite", "mask", "bg+mask", "bg+sprite", "all"][owner.imageModeIndex]),
    { id: "colorA", apply: (owner, value, element) => owner.setPalette([String(value), element.ownerDocument.querySelector("#colorB")?.value, element.ownerDocument.querySelector("#colorC")?.value, element.ownerDocument.querySelector("#colorD")?.value]), read: (owner) => owner._palette?.[0] ?? "#ff4518" },
    { id: "colorB", apply: (owner, value, element) => owner.setPalette([element.ownerDocument.querySelector("#colorA")?.value, String(value), element.ownerDocument.querySelector("#colorC")?.value, element.ownerDocument.querySelector("#colorD")?.value]), read: (owner) => owner._palette?.[1] ?? "#ff8b1a" },
    { id: "colorC", apply: (owner, value, element) => owner.setPalette([element.ownerDocument.querySelector("#colorA")?.value, element.ownerDocument.querySelector("#colorB")?.value, String(value), element.ownerDocument.querySelector("#colorD")?.value]), read: (owner) => owner._palette?.[2] ?? "#ffd166" },
    { id: "colorD", apply: (owner, value, element) => owner.setPalette([element.ownerDocument.querySelector("#colorA")?.value, element.ownerDocument.querySelector("#colorB")?.value, element.ownerDocument.querySelector("#colorC")?.value, String(value)]), read: (owner) => owner._palette?.[3] ?? "#7cff4d" },
    { id: "imageUpload", apply: (owner, _value, element) => {
      const file = element.files?.[0];
      if (file && typeof URL !== "undefined") owner.setImageSource(URL.createObjectURL(file));
    } },
    { id: "clearImageBtn", event: "click", apply: (owner) => owner.clearImage() },
    { id: "burstBtn", event: "click", apply: (owner) => owner.emit() },
    { id: "clearBtn", event: "click", apply: (owner) => owner.rebuild(0) },
    { id: "addEmitterBtn", event: "click", apply: (owner) => owner.addEmitter() },
    { id: "resetEmittersBtn", event: "click", apply: (owner) => owner.resetEmitters() },
    ...["childCount", "childLife", "childSize", "childSpeed"].map((id2) => ({ id: id2, prop: id2.replace("child", "").replace(/^./, (c) => c.toLowerCase()), target: (owner) => owner.subParticles })),
    { id: "childEnabled", prop: "enabled", target: (owner) => owner.subParticles },
    { id: "childInheritVelocity", prop: "inherit", target: (owner) => owner.subParticles },
    selected("childShape", (owner, value) => owner.subParticles.setShape(value), (owner) => owner.subParticles.shape === "dot" ? "circle" : owner.subParticles.shape),
    selected("childSpawnMode", (owner, value) => owner.subParticles.setSpawnMode(value), (owner) => owner.subParticles.spawnMode),
    { id: "childColorA", apply: (owner, value, element) => owner.subParticles.setPalette([String(value), element.ownerDocument.querySelector("#childColorB")?.value, element.ownerDocument.querySelector("#childColorC")?.value, element.ownerDocument.querySelector("#childColorD")?.value]) },
    { id: "childColorB", apply: (owner, value, element) => owner.subParticles.setPalette([element.ownerDocument.querySelector("#childColorA")?.value, String(value), element.ownerDocument.querySelector("#childColorC")?.value, element.ownerDocument.querySelector("#childColorD")?.value]) },
    { id: "childColorC", apply: (owner, value, element) => owner.subParticles.setPalette([element.ownerDocument.querySelector("#childColorA")?.value, element.ownerDocument.querySelector("#childColorB")?.value, String(value), element.ownerDocument.querySelector("#childColorD")?.value]) },
    { id: "childColorD", apply: (owner, value, element) => owner.subParticles.setPalette([element.ownerDocument.querySelector("#childColorA")?.value, element.ownerDocument.querySelector("#childColorB")?.value, element.ownerDocument.querySelector("#childColorC")?.value, String(value)]) }
  ];
  var maskControlSchema = [
    numeric2("canvasSize", "size"),
    numeric2("threshold"),
    numeric2("softness"),
    numeric2("maskOpacity", "opacity"),
    numeric2("blur"),
    numeric2("expand"),
    numeric2("keyTolerance"),
    numeric2("keyFeather"),
    numeric2("scale"),
    numeric2("strength"),
    numeric2("angle"),
    numeric2("offsetX"),
    numeric2("offsetY"),
    numeric2("crackWidth"),
    numeric2("rippleCount"),
    numeric2("speed"),
    numeric2("manualTime", "time"),
    numeric2("motion"),
    numeric2("brushSize"),
    numeric2("brushStrength"),
    numeric2("brushFeather"),
    numeric2("paintBaseOpacity"),
    numeric2("sourceScale"),
    numeric2("sourceRotate"),
    numeric2("sourceOffsetX"),
    numeric2("sourceOffsetY"),
    numeric2("displacementStrength"),
    checked("invert"),
    checked("clampMask"),
    checked("animate"),
    checked("showBaseMaskInPaint"),
    { id: "keyColor", apply: (owner, value) => owner.setKeyColor(String(value)), read: (owner) => owner.keyColor },
    { id: "imageUpload", apply: (owner, _value, element) => {
      const file = element.files?.[0];
      if (file && typeof URL !== "undefined") owner.setImageSource(URL.createObjectURL(file));
    } },
    { id: "clearImageBtn", event: "click", apply: (owner) => owner.clearImage() },
    selected("maskType", (owner, value) => owner.setMode(value), (owner) => owner.mode),
    selected("maskChannel", (owner, value) => owner.setChannel(value), (owner) => owner.channel),
    selected("outputMode", (owner, value) => owner.setOutputMode(value), (owner) => owner.outputMode),
    selected("combineMode", (owner, value) => owner.setCombineMode(value), (owner) => owner.combineMode),
    { id: "clearPaint", event: "click", apply: (owner) => owner.clearPaint() },
    { id: "clearPaint2", event: "click", apply: (owner) => owner.clearPaint() },
    { id: "addDemoPaint", event: "click", apply: (owner) => owner.addDemoPaint() },
    { id: "paintHideAll", event: "click", apply: (owner) => owner.fillPaint(0) },
    { id: "paintNeutralAll", event: "click", apply: (owner) => owner.fillPaint(0.5) },
    { id: "paintRevealAll", event: "click", apply: (owner) => owner.fillPaint(1) },
    { id: "loadAlphaSample", event: "click", apply: (owner) => {
      owner.setSource("alpha");
      owner.setMode("alpha");
    } },
    { id: "loadGreenSample", event: "click", apply: (owner) => {
      owner.setSource("green");
      owner.setMode("chroma");
    } },
    { id: "loadLumaSample", event: "click", apply: (owner) => {
      owner.setSource("luma");
      owner.setMode("luma");
    } },
    { id: "loadPaintSample", event: "click", apply: (owner) => owner.addDemoPaint() },
    { id: "rebuildBtn", event: "click", apply: (owner) => owner.render() }
  ];
  var textureControlSchema = [
    numeric2("tileSize", "size"),
    numeric2("noiseScale"),
    numeric2("patternDensity"),
    numeric2("detailMix"),
    numeric2("animSpeed"),
    numeric2("animAmplitude"),
    numeric2("animFrequency"),
    numeric2("driftX"),
    numeric2("driftY"),
    numeric2("lineDensity"),
    numeric2("lineThickness"),
    numeric2("crackDensity"),
    numeric2("crackWidth"),
    numeric2("rippleCount"),
    numeric2("rippleSharpness"),
    numeric2("waveAngle"),
    numeric2("waveDistortion"),
    numeric2("brightness"),
    numeric2("contrast"),
    numeric2("saturation"),
    numeric2("tintMix"),
    numeric2("heightStrength"),
    numeric2("normalStrength"),
    numeric2("roughnessBias"),
    numeric2("roughnessContrast"),
    numeric2("metallicBias"),
    numeric2("metallicThreshold"),
    numeric2("aoStrength"),
    numeric2("emissiveThreshold"),
    numeric2("emissiveBoost"),
    numeric2("opacityThreshold"),
    numeric2("blurRadius"),
    numeric2("previewTiles"),
    numeric2("manualTime", "time"),
    checked("invertBase"),
    checked("useAlphaForOpacity"),
    checked("animate"),
    checked("showChecker"),
    selected("sourceMode", (owner, value) => owner.setSourceMode(value), (owner) => owner.sourceMode),
    selected("previewMap", (owner, value) => owner.setPreviewMap(value), (owner) => owner.previewMap),
    { id: "imageUpload", apply: (owner, _value, element) => {
      const file = element.files?.[0];
      if (file && typeof URL !== "undefined") owner.setImageSource(URL.createObjectURL(file));
    } },
    { id: "clearImageBtn", event: "click", apply: (owner) => owner.clearImage() },
    { id: "tintA", apply: (owner, value, element) => owner.setTints([String(value), element.ownerDocument.querySelector("#tintB")?.value, element.ownerDocument.querySelector("#tintC")?.value, element.ownerDocument.querySelector("#tintD")?.value]), read: (owner) => owner.tintA },
    { id: "tintB", apply: (owner, value, element) => owner.setTints([element.ownerDocument.querySelector("#tintA")?.value, String(value), element.ownerDocument.querySelector("#tintC")?.value, element.ownerDocument.querySelector("#tintD")?.value]), read: (owner) => owner.tintB },
    { id: "tintC", apply: (owner, value, element) => owner.setTints([element.ownerDocument.querySelector("#tintA")?.value, element.ownerDocument.querySelector("#tintB")?.value, String(value), element.ownerDocument.querySelector("#tintD")?.value]), read: (owner) => owner.tintC },
    { id: "tintD", apply: (owner, value, element) => owner.setTints([element.ownerDocument.querySelector("#tintA")?.value, element.ownerDocument.querySelector("#tintB")?.value, element.ownerDocument.querySelector("#tintC")?.value, String(value)]), read: (owner) => owner.tintD },
    { id: "rebuildBtn", event: "click", apply: (owner) => owner.render() }
  ];
  var blendControlSchema = [
    numeric2("size"),
    numeric2("baseExposure"),
    numeric2("opacity", "layerOpacity"),
    numeric2("layerExposure"),
    numeric2("rotation"),
    numeric2("scale"),
    numeric2("offsetX"),
    numeric2("offsetY"),
    numeric2("density"),
    numeric2("softness"),
    checked("layerEnabled"),
    checked("showLabels"),
    selected("activeLayerSelect", (owner, value) => owner.setActiveLayer(Number(value)), (owner) => String(owner.activeLayer)),
    selected("blendMode", (owner, value) => {
      owner.active.blendMode = value;
      owner.render();
    }, (owner) => owner.active.blendMode),
    selected("layerType", (owner, value) => {
      owner.active.layerType = value;
      owner.render();
    }, (owner) => owner.active.layerType),
    { id: "colorA", apply: (owner, value) => owner.setLayerColors(String(value), owner.active.colorB), read: (owner) => owner.active.colorA },
    { id: "colorB", apply: (owner, value) => owner.setLayerColors(owner.active.colorA, String(value)), read: (owner) => owner.active.colorB },
    { id: "textInput", apply: (owner, value) => owner.setLayerText(String(value)), read: (owner) => owner.active.text },
    { id: "loadGradientSample", event: "click", apply: (owner) => owner.setSourceMode("gradient") },
    { id: "loadPortraitSample", event: "click", apply: (owner) => owner.setSourceMode("portrait") },
    { id: "loadProductSample", event: "click", apply: (owner) => owner.setSourceMode("product") },
    { id: "loadShapesSample", event: "click", apply: (owner) => owner.setSourceMode("shapes") },
    { id: "rebuildBtn", event: "click", apply: (owner) => owner.render() }
  ];
  var layoutControlSchema = [numeric2("stateIndex"), numeric2("progress")];
  var timelineControlSchema = [numeric2("time"), numeric2("progress"), numeric2("speed"), checked("paused")];
  var gridControlSchema = [
    numeric2("progress"),
    numeric2("phase"),
    numeric2("rows"),
    numeric2("cols"),
    numeric2("gap"),
    numeric2("spread"),
    numeric2("wave"),
    numeric2("scale"),
    numeric2("rotate"),
    numeric2("opacity"),
    numeric2("stateIndex")
  ];
  var cameraControlSchema = [
    numeric2("x"),
    numeric2("y"),
    numeric2("z"),
    numeric2("zoom"),
    numeric2("rotate"),
    numeric2("tilt"),
    numeric2("focus"),
    numeric2("shake"),
    numeric2("progress"),
    numeric2("perspective")
  ];
  var eventsControlSchema = [numeric2("progress"), numeric2("velocity"), numeric2("scroll"), checked("active")];
  var splitControlSchema = [numeric2("progress"), numeric2("phase"), numeric2("x"), numeric2("y"), numeric2("rotate"), numeric2("scale"), numeric2("opacity")];
  var spacingControlSchema = [numeric2("progress")];
  var structureControlSchema = [numeric2("progress")];
  var siteControlSchema = [
    selected("siteMode", (owner, value) => owner.setMode(value), (owner) => owner.mode),
    { id: "siteReady", event: "click", apply: (owner) => owner.setReady(true), read: (owner) => owner.ready }
  ];
  var pulseControlSchemas = {
    particles: particleControlSchema,
    maskMaps: maskControlSchema,
    textureMaps: textureControlSchema,
    blendModes: blendControlSchema,
    layout: layoutControlSchema,
    timeline: timelineControlSchema,
    grid: gridControlSchema,
    camera: cameraControlSchema,
    events: eventsControlSchema,
    split: splitControlSchema,
    site: siteControlSchema,
    spacing: spacingControlSchema,
    structure: structureControlSchema
  };

  // src/site/experience.ts
  function defaultRoot() {
    return typeof document === "undefined" ? null : document;
  }
  function one(root, input) {
    if (!input) return null;
    if (typeof input !== "string") return input;
    return root?.querySelector(input) ?? null;
  }
  function many(root, input) {
    if (typeof input === "string") return root ? Array.from(root.querySelectorAll(input)) : [];
    return Array.from(input).map((item) => one(root, item)).filter((item) => Boolean(item));
  }
  var PulseChapterStage = class {
    constructor(options) {
      this.activeIndex = 0;
      this.observer = null;
      const root = options.root ?? defaultRoot();
      this.sections = many(root, options.sections);
      this.stageArt = many(root, options.stageArt);
      this.labels = options.labels ?? this.sections.map((section, index) => section.dataset.pulseChapter ?? `Chapter ${index + 1}`);
      this.label = one(root, options.label);
      this.counter = one(root, options.counter);
      this.activeClass = options.activeClass ?? "is-active";
      this.onChange = options.onChange;
      this.select(options.initialIndex ?? 0);
      if (typeof IntersectionObserver !== "undefined" && this.sections.length) {
        this.observer = new IntersectionObserver((entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible) return;
          const index = this.sections.indexOf(visible.target);
          if (index >= 0) this.select(index);
        }, {
          threshold: options.threshold ?? [0.3, 0.5, 0.7],
          rootMargin: options.rootMargin ?? "-10% 0px -10% 0px"
        });
        this.sections.forEach((section) => this.observer?.observe(section));
      }
    }
    select(index) {
      if (!this.sections.length && !this.stageArt.length) return this;
      const upper = Math.max(this.sections.length, this.stageArt.length, this.labels.length) - 1;
      this.activeIndex = Math.max(0, Math.min(index, upper));
      const label = this.labels[this.activeIndex] ?? `Chapter ${this.activeIndex + 1}`;
      this.sections.forEach((section, itemIndex) => {
        const active = itemIndex === this.activeIndex;
        section.dataset.pulseActive = String(active);
        if (active) section.setAttribute("aria-current", "true");
        else section.removeAttribute("aria-current");
      });
      this.stageArt.forEach((art, itemIndex) => {
        const active = itemIndex === this.activeIndex;
        art.classList.toggle(this.activeClass, active);
        art.dataset.pulseActive = String(active);
        art.setAttribute("aria-hidden", String(!active));
      });
      if (this.label) this.label.textContent = label;
      if (this.counter) this.counter.textContent = `${String(this.activeIndex + 1).padStart(2, "0")} / ${String(upper + 1).padStart(2, "0")}`;
      this.onChange?.(this.activeIndex, label);
      return this;
    }
    dispose() {
      this.observer?.disconnect();
      this.observer = null;
    }
  };
  var PulseVideoWall = class {
    constructor(options) {
      this.activeIndex = 0;
      this.listeners = [];
      const root = options.root ?? defaultRoot();
      this.items = options.items;
      this.buttons = many(root, options.buttons);
      this.frame = one(root, options.frame);
      this.title = one(root, options.title);
      this.meta = one(root, options.meta);
      this.counter = one(root, options.counter);
      this.previewImages = options.previewImages ? many(root, options.previewImages) : [];
      this.previewCaptions = options.previewCaptions ? many(root, options.previewCaptions) : [];
      this.activeClass = options.activeClass ?? "is-active";
      this.onSelect = options.onSelect;
      this.buttons.forEach((button, index) => {
        const activate = () => this.select(index);
        button.addEventListener("click", activate);
        this.listeners.push(() => button.removeEventListener("click", activate));
      });
      this.select(options.initialIndex ?? 0);
    }
    select(index) {
      if (!this.items.length) return this;
      this.activeIndex = Math.max(0, Math.min(index, this.items.length - 1));
      const item = this.items[this.activeIndex];
      if (this.frame && this.frame.src !== item.embedUrl) this.frame.src = item.embedUrl;
      if (this.title) this.title.textContent = item.title;
      if (this.meta) this.meta.textContent = item.meta ?? "";
      if (this.counter) this.counter.textContent = `${String(this.activeIndex + 1).padStart(2, "0")} / ${String(this.items.length).padStart(2, "0")}`;
      if (item.thumbnailUrl) {
        this.previewImages.forEach((image) => {
          if (image.getAttribute("src") !== item.thumbnailUrl) image.src = item.thumbnailUrl ?? "";
          image.alt = item.thumbnailAlt ?? `Still from ${item.title}`;
          image.dataset.pulseVideoId = item.id;
        });
      }
      this.previewCaptions.forEach((caption) => {
        caption.textContent = item.title;
        caption.dataset.pulseVideoId = item.id;
      });
      this.buttons.forEach((button, itemIndex) => {
        const active = itemIndex === this.activeIndex;
        button.classList.toggle(this.activeClass, active);
        button.setAttribute("aria-pressed", String(active));
        button.dataset.pulseActive = String(active);
      });
      this.onSelect?.(item, this.activeIndex);
      return this;
    }
    dispose() {
      this.listeners.splice(0).forEach((dispose) => dispose());
    }
  };
  var PulsePreviewPlaylist = class {
    constructor(options) {
      this.activeIndex = 0;
      this.listeners = [];
      const root = options.root ?? defaultRoot();
      this.tracks = options.tracks;
      this.buttons = many(root, options.buttons);
      this.media = one(root, options.media);
      this.title = one(root, options.title);
      this.artist = one(root, options.artist);
      this.collection = one(root, options.collection);
      this.counter = one(root, options.counter);
      this.storeLink = one(root, options.storeLink);
      this.activeClass = options.activeClass ?? "is-active";
      this.trackIdAttribute = options.trackIdAttribute ?? "data-preview-id";
      this.autoplayOnSelect = options.autoplayOnSelect ?? false;
      this.onSelect = options.onSelect;
      this.onStateChange = options.onStateChange;
      this.buttons.forEach((button, index) => {
        const trackIndex = this.trackIndexForButton(button, index);
        if (trackIndex < 0) return;
        button.dataset.pulseTrackIndex = String(trackIndex);
        const activate = () => this.select(trackIndex, this.autoplayOnSelect);
        button.addEventListener("click", activate);
        this.listeners.push(() => button.removeEventListener("click", activate));
      });
      if (this.media) {
        const state = () => this.emitState();
        this.media.addEventListener("play", state);
        this.media.addEventListener("pause", state);
        this.media.addEventListener("ended", state);
        this.listeners.push(() => {
          this.media?.removeEventListener("play", state);
          this.media?.removeEventListener("pause", state);
          this.media?.removeEventListener("ended", state);
        });
      }
      this.select(options.initialIndex ?? 0, false);
    }
    select(index, autoplay = false) {
      if (!this.tracks.length) return this;
      this.activeIndex = Math.max(0, Math.min(index, this.tracks.length - 1));
      const track = this.tracks[this.activeIndex];
      const changed = Boolean(this.media && this.media.src !== track.previewUrl);
      if (this.media && changed) {
        this.media.crossOrigin = "anonymous";
        this.media.src = track.previewUrl;
        this.media.load?.();
      }
      if (this.title) this.title.textContent = track.title;
      if (this.artist) this.artist.textContent = track.artist ?? "";
      if (this.collection) this.collection.textContent = track.collection ?? "";
      if (this.counter) this.counter.textContent = `${String(this.activeIndex + 1).padStart(2, "0")} / ${String(this.tracks.length).padStart(2, "0")}`;
      if (this.storeLink) {
        if (track.storeUrl) {
          this.storeLink.href = track.storeUrl;
          this.storeLink.hidden = false;
        } else {
          this.storeLink.removeAttribute("href");
          this.storeLink.hidden = true;
        }
      }
      this.buttons.forEach((button, itemIndex) => {
        const active = this.trackIndexForButton(button, itemIndex) === this.activeIndex;
        button.classList.toggle(this.activeClass, active);
        button.setAttribute("aria-pressed", String(active));
        button.dataset.pulseActive = String(active);
      });
      this.onSelect?.(track, this.activeIndex);
      if (autoplay) void this.play();
      else this.emitState();
      return this;
    }
    async play() {
      if (!this.media) return false;
      try {
        await this.media.play();
        return true;
      } catch {
        this.emitState();
        return false;
      }
    }
    pause() {
      this.media?.pause();
      return this;
    }
    seek(time) {
      if (this.media) this.media.currentTime = Math.max(0, Number(time) || 0);
      return this;
    }
    seekProgress(progress) {
      if (!this.media) return this;
      const duration = Number.isFinite(this.media.duration) ? this.media.duration : this.tracks[this.activeIndex]?.duration ?? 0;
      return this.seek(duration * Math.max(0, Math.min(1, Number(progress) || 0)));
    }
    restart() {
      this.seek(0);
      void this.play();
      return this;
    }
    setSpeed(rate) {
      if (this.media) this.media.playbackRate = Math.max(0.01, Math.abs(Number(rate) || 1));
      return this;
    }
    async toggle() {
      if (!this.media) return false;
      if (this.media.paused) return this.play();
      this.pause();
      return true;
    }
    dispose() {
      this.listeners.splice(0).forEach((dispose) => dispose());
    }
    emitState() {
      this.onStateChange?.(Boolean(this.media && !this.media.paused), this.tracks[this.activeIndex] ?? null, this.activeIndex);
    }
    trackIndexForButton(button, fallbackIndex) {
      const requestedId = button.getAttribute(this.trackIdAttribute)?.trim();
      if (requestedId) return this.tracks.findIndex((track) => track.id === requestedId);
      return fallbackIndex < this.tracks.length ? fallbackIndex : -1;
    }
  };
  var PulseAudioReactive = class {
    constructor(engine2, options) {
      this.active = false;
      this.unsubscribe = null;
      this.connected = false;
      this.start = () => {
        this.active = true;
        this.arm();
        this.target?.setAttribute("data-pulse-audio-state", "active");
        if (!this.unsubscribe) this.unsubscribe = ticker.add(this.refresh);
      };
      this.pause = () => {
        this.active = false;
        this.target?.setAttribute("data-pulse-audio-state", "idle");
        this.unsubscribe?.();
        this.unsubscribe = null;
        this.write(0, 0, 0, false);
      };
      this.refresh = () => {
        if (!this.active || !this.target) return;
        const bands = this.audio.bands;
        const measured = bands.level > 5e-3 || bands.bass > 5e-3;
        const time = this.media?.currentTime ?? 0;
        const phase = time * (this.fallbackBpm / 60) * Math.PI * 2;
        const fallback = 0.14 + Math.abs(Math.sin(phase) * 0.22 + Math.sin(phase * 1.75) * 0.07);
        const bass = this.reducedMotion ? 0 : measured ? bands.bass : fallback;
        const level = this.reducedMotion ? 0 : measured ? bands.level : fallback * 0.72;
        const beat = !this.reducedMotion && (measured ? bands.beat : Math.sin(phase) > 0.9);
        this.write(bass, level, measured ? bands.beatStrength : beat ? fallback : 0, beat);
      };
      const root = options.root ?? defaultRoot();
      this.media = one(root, options.media);
      this.target = one(root, options.target);
      this.audio = options.audio ?? engine2.audio(options.audioOptions);
      this.cssPrefix = options.cssPrefix ?? "pulse-audio";
      this.fallbackBpm = Math.max(1, options.fallbackBpm ?? 92);
      this.reducedMotion = options.reducedMotion ?? Boolean(engine2.reducedMotion);
      this.media?.addEventListener("play", this.start);
      this.media?.addEventListener("pause", this.pause);
      this.media?.addEventListener("ended", this.pause);
      this.write(0, 0, 0, false);
    }
    arm() {
      if (!this.media) return false;
      if (!this.connected) this.connected = this.audio.connect(this.media);
      return this.connected;
    }
    dispose() {
      this.pause();
      this.media?.removeEventListener("play", this.start);
      this.media?.removeEventListener("pause", this.pause);
      this.media?.removeEventListener("ended", this.pause);
    }
    write(bass, level, beatStrength, beat) {
      if (!this.target) return;
      this.target.style.setProperty(`--${this.cssPrefix}-bass`, bass.toFixed(3));
      this.target.style.setProperty(`--${this.cssPrefix}-level`, level.toFixed(3));
      this.target.style.setProperty(`--${this.cssPrefix}-beat`, beatStrength.toFixed(3));
      this.target.dataset.pulseBeat = String(beat);
    }
  };
  function chapterStage(options) {
    return new PulseChapterStage(options);
  }
  function videoWall(options) {
    return new PulseVideoWall(options);
  }
  function previewPlaylist(options) {
    return new PulsePreviewPlaylist(options);
  }
  function audioReactive(engine2, options) {
    return new PulseAudioReactive(engine2, options);
  }

  // src/site/experience-kit.ts
  var PulseFrameSequence = class {
    constructor(options) {
      this.options = options;
      this.frame = 0;
      this.direction = 1;
      this.playing = false;
      this.elapsed = 0;
      this.speed = 1;
      this.preloaded = [];
      this.onReducedChange = () => {
        if (this.isReduced()) {
          this.pause();
          this.seek(this.options.initialFrame ?? 0);
        }
      };
      const root = options.root ?? (typeof document !== "undefined" ? document : null);
      const target = typeof options.target === "string" ? root?.querySelector(options.target) : options.target;
      if (!target) throw new Error("[pulse:frame-sequence] target image not found");
      this.target = target;
      this.originalSrc = target.getAttribute("src");
      this.frames = Array.isArray(options.frames) ? [...options.frames] : Array.from({ length: Math.max(1, Math.round(options.frames)) }, (_, frame) => {
        if (!options.src) throw new Error("[pulse:frame-sequence] numeric frames require a src(frame) resolver");
        return options.src(frame);
      });
      if (!this.frames.length) throw new Error("[pulse:frame-sequence] at least one frame is required");
      if (typeof options.reducedMotion === "object") {
        this.reducedQuery = options.reducedMotion;
        this.reducedQuery.addEventListener?.("change", this.onReducedChange);
      }
      this.preload(options.preload ?? 0);
      this.seek(options.initialFrame ?? 0);
    }
    play() {
      if (this.playing || this.isReduced() || this.frames.length < 2) return this;
      this.playing = true;
      this.stopTick = ticker.add((dt) => {
        this.elapsed += dt;
        const step = 1 / (Math.max(1, this.options.fps ?? 12) * this.speed);
        while (this.elapsed >= step && this.playing) {
          this.elapsed -= step;
          this.next();
        }
      });
      return this;
    }
    pause() {
      this.stopTick?.();
      this.stopTick = void 0;
      this.playing = false;
      this.elapsed = 0;
      return this;
    }
    seek(frame) {
      this.frame = Math.max(0, Math.min(this.frames.length - 1, Math.round(frame)));
      const src = this.frames[this.frame];
      if (this.target.getAttribute("src") !== src) this.target.setAttribute("src", src);
      this.options.onFrame?.(this.frame, src);
      return this;
    }
    seekProgress(progress) {
      return this.seek((this.frames.length - 1) * Math.max(0, Math.min(1, Number(progress) || 0)));
    }
    restart() {
      this.direction = 1;
      this.seek(this.options.initialFrame ?? 0);
      return this.play();
    }
    setSpeed(rate) {
      this.speed = Math.max(0.01, Math.abs(Number(rate) || 1));
      return this;
    }
    reverse() {
      this.direction = this.direction === 1 ? -1 : 1;
      return this;
    }
    next() {
      const last = this.frames.length - 1;
      let next = this.frame + this.direction;
      if (next > last || next < 0) {
        if (this.options.pingPong) {
          this.direction = this.direction === 1 ? -1 : 1;
          next = this.frame + this.direction;
        } else if (this.options.loop !== false) {
          next = next > last ? 0 : last;
        } else {
          this.seek(next > last ? last : 0);
          return this.pause();
        }
      }
      return this.seek(next);
    }
    diagnostics() {
      return { frame: this.frame, frames: this.frames.length, fps: Math.max(1, this.options.fps ?? 12), playing: this.playing, direction: this.direction, reducedMotion: this.isReduced() };
    }
    dispose() {
      this.pause();
      this.reducedQuery?.removeEventListener?.("change", this.onReducedChange);
      if (this.originalSrc == null) this.target.removeAttribute("src");
      else this.target.setAttribute("src", this.originalSrc);
      this.preloaded.length = 0;
    }
    isReduced() {
      return typeof this.options.reducedMotion === "boolean" ? this.options.reducedMotion : Boolean(this.options.reducedMotion?.matches);
    }
    preload(value) {
      if (typeof Image === "undefined" || value === 0) return;
      const count = value === "all" ? this.frames.length : Math.max(0, Math.min(this.frames.length, Math.round(value)));
      for (let frame = 0; frame < count; frame++) {
        const image = new Image();
        image.src = this.frames[frame];
        this.preloaded.push(image);
      }
    }
  };
  var PulseResponsiveDirector = class {
    constructor(options = {}) {
      this.options = options;
      this.cleanup = null;
      this.listeners = [];
      this.mode = options.initialMode ?? this.resolveMode();
      this.context = this.makeContext(null);
      this.apply(null);
      if (typeof window !== "undefined") {
        const refresh = () => this.refresh();
        window.addEventListener("resize", refresh, { passive: true });
        window.addEventListener("orientationchange", refresh, { passive: true });
        this.listeners.push(() => window.removeEventListener("resize", refresh), () => window.removeEventListener("orientationchange", refresh));
        const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)");
        reduced?.addEventListener?.("change", refresh);
        if (reduced) this.listeners.push(() => reduced.removeEventListener?.("change", refresh));
      }
    }
    refresh(force = false) {
      const next = this.resolveMode();
      const changed = next !== this.mode || this.resolveReducedMotion() !== this.context.reducedMotion || this.resolveOrientation() !== this.context.orientation;
      if (!force && !changed) return this;
      const previous = this.mode;
      this.mode = next;
      this.apply(previous);
      return this;
    }
    dispose() {
      this.cleanup?.();
      this.cleanup = null;
      this.listeners.splice(0).forEach((dispose) => dispose());
    }
    apply(previousMode) {
      this.cleanup?.();
      this.cleanup = null;
      this.context = this.makeContext(previousMode);
      if (typeof document !== "undefined") {
        document.documentElement.dataset.pulseResponsiveMode = this.mode;
        document.documentElement.dataset.pulseOrientation = this.context.orientation;
        document.documentElement.dataset.pulseReducedMotion = String(this.context.reducedMotion);
      }
      const cleanup = this.options.onChange?.(this.context);
      if (typeof cleanup === "function") this.cleanup = cleanup;
    }
    resolveMode() {
      if (typeof window === "undefined") return this.options.initialMode ?? "desktop";
      return window.innerWidth <= (this.options.mobileMax ?? 720) ? "mobile" : window.innerWidth <= (this.options.tabletMax ?? 1080) ? "tablet" : "desktop";
    }
    resolveReducedMotion() {
      return this.options.reducedMotion ?? (typeof window !== "undefined" && Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches));
    }
    resolveOrientation() {
      return typeof window !== "undefined" && window.innerHeight > window.innerWidth ? "portrait" : "landscape";
    }
    makeContext(previousMode) {
      return { mode: this.mode, previousMode, reducedMotion: this.resolveReducedMotion(), orientation: this.resolveOrientation() };
    }
  };
  var PulseMediaCoordinator = class {
    constructor(options = {}) {
      this.options = options;
      this.activeId = null;
      this.states = /* @__PURE__ */ new Map();
      this.media = /* @__PURE__ */ new Map();
      this.listeners = /* @__PURE__ */ new Map();
    }
    register(id2, media) {
      this.unregister(id2);
      this.media.set(id2, media);
      this.states.set(id2, "idle");
      const bind = (event, state) => {
        const handler = () => {
          if (state === "playing") {
            this.pauseAll(id2);
            this.activeId = id2;
          }
          if (this.activeId === id2 && (state === "ended" || state === "error")) this.activeId = null;
          this.setState(id2, state, media);
        };
        media.addEventListener(event, handler);
        return () => media.removeEventListener(event, handler);
      };
      this.listeners.set(id2, [bind("loadstart", "loading"), bind("playing", "playing"), bind("pause", "paused"), bind("ended", "ended"), bind("error", "error"), bind("stalled", "error")]);
      return this;
    }
    unregister(id2) {
      this.listeners.get(id2)?.forEach((dispose) => dispose());
      this.listeners.delete(id2);
      this.media.delete(id2);
      this.states.delete(id2);
      if (this.activeId === id2) this.activeId = null;
      return this;
    }
    async play(id2) {
      const media = this.media.get(id2);
      if (!media) return false;
      this.pauseAll(id2);
      try {
        await media.play();
        this.activeId = id2;
        this.setState(id2, "playing", media);
        return true;
      } catch {
        this.setState(id2, "blocked", media);
        return false;
      }
    }
    pauseAll(exceptId) {
      this.media.forEach((media, id2) => {
        if (id2 !== exceptId && !media.paused) media.pause();
      });
      return this;
    }
    dispose() {
      [...this.media.keys()].forEach((id2) => this.unregister(id2));
    }
    setState(id2, state, media) {
      this.states.set(id2, state);
      media.dataset.pulseMediaState = state;
      this.options.onStateChange?.(id2, state, media);
    }
  };
  var PulseRail = class {
    constructor(options) {
      this.options = options;
      this.activeIndex = 0;
      this.listeners = [];
      const root = options.root ?? (typeof document !== "undefined" ? document : null);
      const one2 = (input) => typeof input === "string" ? root?.querySelector(input) ?? null : input ?? null;
      this.container = one2(options.container);
      this.items = this.container ? Array.from(this.container.querySelectorAll(options.items ?? ":scope > *")) : [];
      this.previous = one2(options.previous);
      this.next = one2(options.next);
      const previous = () => this.go(this.activeIndex - 1);
      const next = () => this.go(this.activeIndex + 1);
      const keydown = (event) => {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          previous();
        }
        if (event.key === "ArrowRight") {
          event.preventDefault();
          next();
        }
      };
      this.previous?.addEventListener("click", previous);
      this.next?.addEventListener("click", next);
      this.container?.addEventListener("keydown", keydown);
      this.listeners.push(() => this.previous?.removeEventListener("click", previous), () => this.next?.removeEventListener("click", next), () => this.container?.removeEventListener("keydown", keydown));
      this.go(options.initialIndex ?? 0, false);
    }
    go(index, scroll = true) {
      if (!this.items.length) return this;
      const last = this.items.length - 1;
      this.activeIndex = this.options.loop ? (index + this.items.length) % this.items.length : Math.max(0, Math.min(index, last));
      this.items.forEach((item2, itemIndex) => {
        const active = itemIndex === this.activeIndex;
        item2.classList.toggle(this.options.activeClass ?? "is-active", active);
        item2.dataset.pulseActive = String(active);
        if (active) item2.setAttribute("aria-current", "true");
        else item2.removeAttribute("aria-current");
      });
      this.previous?.toggleAttribute("disabled", !this.options.loop && this.activeIndex === 0);
      this.next?.toggleAttribute("disabled", !this.options.loop && this.activeIndex === last);
      const item = this.items[this.activeIndex];
      if (scroll) item.scrollIntoView?.({ behavior: "smooth", block: "nearest", inline: "center" });
      this.options.onChange?.(this.activeIndex, item);
      return this;
    }
    dispose() {
      this.listeners.splice(0).forEach((dispose) => dispose());
    }
  };
  var PulseSelectionLink = class {
    constructor(options) {
      this.options = options;
      this.activeIndex = 0;
      this.items = options.items;
      this.select(options.initialIndex ?? 0);
    }
    select(index) {
      if (!this.items.length) return this;
      this.activeIndex = Math.max(0, Math.min(index, this.items.length - 1));
      this.options.apply(this.items[this.activeIndex], this.activeIndex);
      return this;
    }
    selectBy(predicate) {
      const index = this.items.findIndex(predicate);
      return index >= 0 ? this.select(index) : this;
    }
    dispose() {
    }
  };
  function validatePulseAssetManifest(manifest) {
    const errors = [];
    const ids = /* @__PURE__ */ new Set();
    manifest.assets.forEach((asset, index) => {
      if (!asset.id.trim()) errors.push(`assets[${index}] is missing id`);
      if (ids.has(asset.id)) errors.push(`duplicate asset id: ${asset.id}`);
      ids.add(asset.id);
      if (!asset.src.trim()) errors.push(`asset ${asset.id || index} is missing src`);
      if (asset.kind === "image" && !asset.alt?.trim()) errors.push(`image ${asset.id} is missing alt text`);
      if (asset.kind === "video" && !asset.poster?.trim()) errors.push(`video ${asset.id} is missing poster`);
    });
    return { valid: !errors.length, errors, publicAssets: manifest.assets.filter((asset) => asset.public !== false).map((asset) => asset.src), privateAssets: manifest.assets.filter((asset) => asset.public === false).map((asset) => asset.src) };
  }
  function auditPulseRelease(root = document) {
    const doc2 = root instanceof Document ? root : root.ownerDocument;
    const element = root instanceof Document ? root.documentElement : root;
    const missingImages = Array.from(root.querySelectorAll("img")).filter((img) => !img.complete || img.naturalWidth === 0).map((img) => img.currentSrc || img.src);
    const missingLabels = Array.from(root.querySelectorAll("button, a, input, select, textarea")).filter((control) => !control.getAttribute("aria-label") && !control.getAttribute("aria-labelledby") && !control.textContent?.trim() && !(control instanceof HTMLInputElement && control.type !== "button")).map((control) => control.id || control.tagName.toLowerCase());
    const smallTouchTargets = Array.from(root.querySelectorAll("button, a, input, select")).filter((control) => {
      const rect = control.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && (rect.width < 44 || rect.height < 44);
    }).map((control) => control.id || control.textContent?.trim().slice(0, 40) || control.tagName.toLowerCase());
    const overflowX = element.scrollWidth > element.clientWidth;
    const media = Array.from(root.querySelectorAll("audio, video")).map((item, index) => ({ id: item.id || `media-${index + 1}`, state: item.dataset.pulseMediaState ?? (item.paused ? "paused" : "playing") }));
    return { passed: !overflowX && !missingImages.length && !missingLabels.length, viewport: { width: doc2?.defaultView?.innerWidth ?? element.clientWidth, height: doc2?.defaultView?.innerHeight ?? element.clientHeight }, overflowX, missingImages, missingLabels, smallTouchTargets, media };
  }
  var PulseMotionBudget = class {
    constructor(options = {}) {
      this.mode = options.mode ?? "balanced";
      this.reducedMotion = options.reducedMotion ?? false;
      this.disabled = new Set(options.disabled ?? []);
    }
    allows(tier) {
      if (this.disabled.has(tier)) return false;
      if (tier === "essential") return true;
      if (this.reducedMotion) return false;
      return tier === "experimental" ? this.mode === "showcase" : this.mode !== "lite";
    }
  };
  var PulseArchive = class {
    constructor(entries = []) {
      this.entries = entries;
    }
    find(id2) {
      return this.entries.find((entry) => entry.id === id2);
    }
    byEra(era) {
      return this.entries.filter((entry) => entry.era === era);
    }
    related(id2) {
      const ids = new Set(this.find(id2)?.relatedIds ?? []);
      return this.entries.filter((entry) => ids.has(entry.id) || entry.relatedIds?.includes(id2));
    }
    publicEntries() {
      return this.entries.filter((entry) => !entry.private);
    }
  };

  // src/site/site.ts
  var MODE_ORDER = {
    lite: 0,
    balanced: 1,
    showcase: 2
  };
  var LEVEL_ORDER = {
    essential: 0,
    enhanced: 1,
    heavy: 2
  };
  function modeFromDocument(fallback) {
    if (typeof document === "undefined") return fallback;
    const fromDataset = document.documentElement.dataset.pulseSiteMode;
    if (fromDataset === "showcase" || fromDataset === "balanced" || fromDataset === "lite") return fromDataset;
    const fromQuery = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "").get("pulse-mode");
    if (fromQuery === "showcase" || fromQuery === "balanced" || fromQuery === "lite") return fromQuery;
    return fallback;
  }
  function effectAllowed(mode, level) {
    return MODE_ORDER[mode] >= LEVEL_ORDER[level];
  }
  var PulseSite = class {
    constructor(engine2, options = {}) {
      this.systems = /* @__PURE__ */ new Map();
      this.playables = [];
      this.disposers = [];
      this.ready = false;
      this.lazyStarted = 0;
      this.overflowX = false;
      this.scrollWidth = 0;
      this.clientWidth = 0;
      this.P = engine2;
      this.id = options.id ?? "pulse-site";
      this.root = options.root ?? (typeof document !== "undefined" ? document.documentElement : {});
      this.proofPrefix = options.proofPrefix ?? "pulseSite";
      const requested = modeFromDocument(options.mode ?? "balanced");
      this.mode = engine2?.reducedMotion && options.reducedMotionMode ? options.reducedMotionMode : requested;
      this.write("id", this.id);
      this.write("mode", this.mode);
      this.write("ready", "false");
      if (options.mobileOverflowGuard !== false) this.installOverflowGuard();
      globalThis.__pulseSiteProof = () => this.proof();
    }
    shouldRun(level = "enhanced") {
      return effectAllowed(this.mode, level);
    }
    setMode(mode) {
      this.mode = mode;
      this.write("mode", mode);
      this.syncProof();
      return this;
    }
    run(name, factory, options = {}) {
      const level = options.level ?? "enhanced";
      if (!this.shouldRun(level)) {
        this.mark(name, "skipped");
        return null;
      }
      try {
        const result = factory();
        this.trackMany(result);
        this.mark(name, "ok");
        return result;
      } catch (error) {
        this.mark(name, "fail");
        if (typeof console !== "undefined") console.error(`[pulse:site] ${name}`, error);
        return null;
      }
    }
    lazy(target, name, factory, options = {}) {
      const level = options.level ?? "heavy";
      const root = typeof target === "string" ? typeof document !== "undefined" ? document.querySelector(target) : null : target;
      if (!root || typeof IntersectionObserver === "undefined") {
        this.run(name, factory, { level });
        return;
      }
      if (!this.shouldRun(level)) {
        this.mark(name, "skipped");
        return;
      }
      let started = false;
      let tracked = [];
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target !== root) continue;
          if (entry.isIntersecting && (!started || !options.once)) {
            started = true;
            this.lazyStarted++;
            const result = this.run(name, factory, { level });
            tracked = this.collectPlayables(result);
            if (options.once !== false) observer.unobserve(root);
            this.syncProof();
          } else if (!entry.isIntersecting && options.disposeOnExit && tracked.length) {
            tracked.forEach((item) => {
              this.disposePlayable(item);
              const index = this.playables.indexOf(item);
              if (index >= 0) this.playables.splice(index, 1);
              this.P?.untrack?.(item);
            });
            tracked = [];
            this.syncProof();
          }
        }
      }, { rootMargin: options.rootMargin ?? "160px 0px", threshold: options.threshold ?? 0.08 });
      observer.observe(root);
      this.disposers.push(() => observer.disconnect());
    }
    reveal(targets, options = {}) {
      if (typeof document === "undefined") return;
      const list = typeof targets === "string" ? Array.from(document.querySelectorAll(targets)) : Array.from(targets);
      if (!list.length) return;
      if (!this.shouldRun("essential") || typeof IntersectionObserver === "undefined") {
        list.forEach((el) => {
          el.style.opacity = "1";
          el.style.transform = "none";
        });
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          this.track(this.P.bag(el, { opacity: [0, 1], y: [options.y ?? 26, 0] }, { duration: options.duration ?? 0.72, ease: "outExpo" }));
          observer.unobserve(el);
        });
      }, { threshold: options.threshold ?? 0.14, rootMargin: options.rootMargin ?? "0px 0px -6% 0px" });
      list.forEach((el) => observer.observe(el));
      this.disposers.push(() => observer.disconnect());
    }
    chapterStage(options) {
      return this.track(new PulseChapterStage(options));
    }
    videoWall(options) {
      return this.track(new PulseVideoWall(options));
    }
    previewPlaylist(options) {
      return this.track(new PulsePreviewPlaylist(options));
    }
    audioReactive(options) {
      return this.track(new PulseAudioReactive(this.P, options));
    }
    responsiveDirector(options = {}) {
      return this.track(new PulseResponsiveDirector(options));
    }
    mediaCoordinator(options = {}) {
      return this.track(new PulseMediaCoordinator(options));
    }
    frameSequence(options) {
      return this.track(new PulseFrameSequence(options));
    }
    rail(options) {
      return this.track(new PulseRail(options));
    }
    selectionLink(options) {
      return this.track(new PulseSelectionLink(options));
    }
    motionBudget(options = {}) {
      return new PulseMotionBudget({ mode: this.mode, reducedMotion: Boolean(this.P?.reducedMotion), ...options });
    }
    track(item) {
      this.trackMany(item);
      this.syncProof();
      return item;
    }
    mark(name, state = "ok") {
      this.systems.set(name, state);
      this.syncProof();
      return this;
    }
    setReady(value = true) {
      this.ready = value;
      this.write("ready", String(value));
      this.syncProof();
      return this;
    }
    checkOverflow() {
      if (typeof document === "undefined") return false;
      this.clientWidth = document.documentElement.clientWidth;
      this.scrollWidth = document.documentElement.scrollWidth;
      this.overflowX = this.scrollWidth > this.clientWidth;
      this.write("overflowX", String(this.overflowX));
      this.write("scrollWidth", String(this.scrollWidth));
      this.write("clientWidth", String(this.clientWidth));
      return this.overflowX;
    }
    proof() {
      this.checkOverflow();
      const failed = [...this.systems.entries()].filter(([, state]) => state === "fail").map(([name]) => name);
      const skipped = [...this.systems.entries()].filter(([, state]) => state === "skipped").map(([name]) => name);
      return {
        id: this.id,
        mode: this.mode,
        ready: this.ready,
        systems: this.systems.size,
        ok: [...this.systems.values()].filter((state) => state === "ok").length,
        failed,
        skipped,
        playables: this.playables.length,
        lazyStarted: this.lazyStarted,
        overflowX: this.overflowX,
        scrollWidth: this.scrollWidth,
        clientWidth: this.clientWidth
      };
    }
    syncProof() {
      const proof = this.proof();
      this.write("systems", String(proof.systems));
      this.write("ok", String(proof.ok));
      this.write("failed", proof.failed.join(","));
      this.write("skipped", proof.skipped.join(","));
      this.write("playables", String(proof.playables));
      this.write("lazyStarted", String(proof.lazyStarted));
    }
    dispose() {
      this.playables.forEach((item) => {
        this.disposePlayable(item);
        this.P?.untrack?.(item);
      });
      this.disposers.forEach((fn) => {
        try {
          fn();
        } catch {
        }
      });
      this.playables.length = 0;
      this.disposers.length = 0;
      this.syncProof();
    }
    installOverflowGuard() {
      if (typeof document === "undefined" || typeof window === "undefined") return;
      const guardMode = globalThis.CSS?.supports?.("overflow-x", "clip") ? "clip" : "hidden";
      document.documentElement.style.overflowX = guardMode;
      document.body.style.overflowX = guardMode;
      const update = () => this.checkOverflow();
      update();
      window.addEventListener("resize", update, { passive: true });
      this.disposers.push(() => window.removeEventListener("resize", update));
    }
    write(key2, value) {
      const name = `${this.proofPrefix}${key2.charAt(0).toUpperCase()}${key2.slice(1)}`;
      if (this.root?.dataset) this.root.dataset[name] = value;
    }
    collectPlayables(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.flatMap((item) => this.collectPlayables(item));
      if (typeof value === "function") return [{ dispose: value }];
      const candidate = value;
      return candidate.dispose || candidate.destroy || candidate.pause || candidate.play ? [candidate] : [];
    }
    trackMany(value) {
      const items = this.collectPlayables(value);
      items.forEach((item) => {
        if (!this.playables.includes(item)) this.playables.push(item);
      });
    }
    disposePlayable(item) {
      try {
        if (item.dispose) item.dispose();
        else if (item.destroy) item.destroy();
        else if (item.pause) item.pause();
      } catch {
      }
    }
  };
  function pulseSite(engine2, options) {
    return new PulseSite(engine2, options);
  }

  // src/color/color-cycle.ts
  function isElement(value) {
    return typeof Element !== "undefined" && value instanceof Element;
  }
  function resolveTargets2(target, scope2) {
    if (typeof target === "string") {
      const root = scope2 ?? (typeof document !== "undefined" ? document : null);
      return root && typeof HTMLElement !== "undefined" ? Array.from(root.querySelectorAll(target)).filter((item) => item instanceof HTMLElement) : [];
    }
    const values = isElement(target) ? [target] : Array.from(target);
    return values.filter((item) => item instanceof HTMLElement);
  }
  function styleValue(element, property) {
    return property.startsWith("--") || property.includes("-") ? element.style.getPropertyValue(property) : element.style[property] ?? "";
  }
  function restoreStyle(element, property, value, priority) {
    if (property.startsWith("--") || property.includes("-")) {
      if (value) element.style.setProperty(property, value, priority);
      else element.style.removeProperty(property);
    } else {
      element.style[property] = value;
    }
  }
  var PulseColorCycle = class {
    constructor(bindings, options = {}) {
      this.__pulseColorCycle = true;
      this.states = [];
      this.requestedPlaying = false;
      this.began = false;
      this._disposed = false;
      this.observer = null;
      this.visible = /* @__PURE__ */ new Set();
      this.onIntersection = (entries) => {
        for (const entry of entries) {
          const wasVisible = this.visible.has(entry.target);
          if (entry.isIntersecting) this.visible.add(entry.target);
          else this.visible.delete(entry.target);
          if (wasVisible !== entry.isIntersecting) this.options.onVisibilityChange?.(entry.target, entry.isIntersecting, this);
        }
        this.syncPlayback();
      };
      this.duration = Math.max(1e-6, options.duration ?? 8);
      this.options = {
        ...options,
        visibility: options.visibility ?? "viewport",
        restore: options.restore ?? true,
        reducedMotion: options.reducedMotion ?? false
      };
      const seen = /* @__PURE__ */ new Map();
      let targetIndex = 0;
      for (const binding of bindings) {
        const colors = binding.colors.filter(Boolean);
        if (colors.length < 2) {
          this.warn(`Skipped color binding with fewer than two colors: ${String(binding.target)}`);
          continue;
        }
        for (const element of resolveTargets2(binding.target, options.scope)) {
          const property = binding.property ?? "color";
          const elementProperties = seen.get(element) ?? /* @__PURE__ */ new Set();
          if (elementProperties.has(property)) {
            this.warn(`Skipped duplicate color binding for ${property}`);
            continue;
          }
          elementProperties.add(property);
          seen.set(element, elementProperties);
          const phase = Math.max(0, binding.phase ?? targetIndex * (options.stagger ?? 0));
          const bag = new Bag(element, { [property]: { css: property, colors } }, {
            duration: this.duration,
            ease: options.ease ?? "inOutSine",
            loop: options.loop ?? true,
            alternate: options.alternate ?? false,
            autoplay: false,
            playbackRate: options.speed ?? 1
          });
          this.states.push({
            element,
            property,
            phase,
            bag,
            original: styleValue(element, property),
            originalPriority: property.startsWith("--") ? element.style.getPropertyPriority(property) : ""
          });
          targetIndex++;
        }
      }
      if (this.options.reducedMotion) {
        this.states.forEach((state) => state.bag.seek(0));
      } else if (this.options.visibility === "viewport" && typeof IntersectionObserver !== "undefined") {
        this.observer = new IntersectionObserver(this.onIntersection, {
          rootMargin: options.rootMargin ?? "120px 0px",
          threshold: options.threshold ?? 0.01
        });
        this.states.forEach((state) => this.observer?.observe(state.element));
      } else {
        this.states.forEach((state) => this.visible.add(state.element));
      }
      if (options.autoplay !== false && !this.options.reducedMotion) this.play();
    }
    get disposed() {
      return this._disposed;
    }
    get targetCount() {
      return this.states.length;
    }
    get activeCount() {
      return this.states.filter((state) => !state.bag.paused).length;
    }
    get progress() {
      return this.states[0]?.bag.iterationProgress ?? 0;
    }
    play() {
      if (this._disposed || this.options.reducedMotion) return this;
      this.requestedPlaying = true;
      if (!this.began) {
        this.began = true;
        this.options.onBegin?.(this);
      }
      this.syncPlayback();
      return this;
    }
    pause() {
      this.requestedPlaying = false;
      this.states.forEach((state) => state.bag.pause());
      return this;
    }
    seek(time) {
      const base = Math.max(0, Number(time) || 0);
      this.states.forEach((state) => state.bag.seek(base + state.phase));
      return this;
    }
    seekProgress(progress) {
      const normalized = Math.max(0, Math.min(1, Number(progress) || 0));
      return this.seek(normalized >= 1 ? Math.max(0, this.duration - 1e-6) : normalized * this.duration);
    }
    restart() {
      this.seek(0);
      return this.play();
    }
    setSpeed(rate) {
      this.states.forEach((state) => state.bag.setSpeed(rate));
      return this;
    }
    reverse() {
      this.states.forEach((state) => {
        state.bag.reverse();
        if (!this.shouldPlay(state.element)) state.bag.pause();
      });
      return this;
    }
    dispose() {
      if (this._disposed) return;
      this._disposed = true;
      this.requestedPlaying = false;
      this.observer?.disconnect();
      this.observer = null;
      this.states.forEach((state) => {
        state.bag.dispose();
        if (this.options.restore) restoreStyle(state.element, state.property, state.original, state.originalPriority);
      });
      this.visible.clear();
      this.options.onDispose?.(this);
    }
    shouldPlay(element) {
      return this.requestedPlaying && (this.options.visibility === "always" || this.visible.has(element));
    }
    syncPlayback() {
      this.states.forEach((state) => {
        if (this.shouldPlay(state.element)) state.bag.play();
        else state.bag.pause();
      });
    }
    warn(message) {
      if (this.options.debug && typeof console !== "undefined") console.warn("[pulse:color-cycle]", message);
    }
  };
  var PulseColorCycleAdapter = {
    name: "color-cycle",
    test: (target) => Boolean(target?.__pulseColorCycle),
    props: () => ["progress", "targetCount", "activeCount"],
    get: (target, prop) => {
      if (prop === "progress") return target.progress;
      if (prop === "targetCount") return target.targetCount;
      if (prop === "activeCount") return target.activeCount;
      return 0;
    },
    set: (target, prop, value) => {
      if (prop === "progress") target.seekProgress(value);
    },
    unit: () => ""
  };
  registerAdapter(PulseColorCycleAdapter);
  function colorCycle(bindings, options) {
    return new PulseColorCycle(bindings, options);
  }

  // src/juce/index.ts
  var ORDER = ["canvas", "full-container", "container", "sub-container", "module", "component", "micro"];
  var COLOR = /^#(?:[0-9a-f]{6}|[0-9a-f]{8})$/i;
  function finite2(value, label) {
    if (!Number.isFinite(value)) throw new Error(`[pulse:juce] ${label} must be finite`);
    return value;
  }
  function normalizeNode(node) {
    return {
      id: String(node.id),
      level: node.level,
      bounds: {
        x: finite2(node.bounds.x, `${node.id}.x`),
        y: finite2(node.bounds.y, `${node.id}.y`),
        width: finite2(node.bounds.width, `${node.id}.width`),
        height: finite2(node.bounds.height, `${node.id}.height`)
      },
      ...node.padding === void 0 ? {} : { padding: finite2(node.padding, `${node.id}.padding`) },
      ...node.children ? { children: node.children.map(normalizeNode) } : {}
    };
  }
  function validateNode(node, path, parent, out) {
    const values = Object.entries(node.bounds);
    if (!node.id) out.push({ path, code: "id", message: "Every layout node needs an id." });
    if (node.bounds.width < 0 || node.bounds.height < 0) out.push({ path, code: "size", message: "Width and height cannot be negative." });
    for (const [key2, value] of values) {
      const grid2 = ORDER.indexOf(node.level) <= ORDER.indexOf("module") ? 4 : 2;
      if (value % grid2 !== 0) out.push({ path: `${path}.bounds.${key2}`, code: "grid", message: `${node.level} values must align to the ${grid2}px grid.` });
    }
    if (node.padding !== void 0 && node.padding % 2 !== 0) out.push({ path: `${path}.padding`, code: "grid", message: "Padding must align to the 2px grid." });
    if (parent) {
      if (ORDER.indexOf(node.level) !== ORDER.indexOf(parent.level) + 1) out.push({ path, code: "hierarchy", message: `${node.level} cannot be a direct child of ${parent.level}.` });
      const p = parent.padding ?? 0;
      const maxX = parent.bounds.width - p;
      const maxY = parent.bounds.height - p;
      if (node.bounds.x < p || node.bounds.y < p || node.bounds.x + node.bounds.width > maxX || node.bounds.y + node.bounds.height > maxY) {
        out.push({ path, code: "containment", message: "Child bounds must fit inside the parent padding box." });
      }
    }
    (node.children ?? []).forEach((child, index) => validateNode(child, `${path}.children[${index}]`, node, out));
  }
  var PulseJuceConverter = class {
    static convert(input) {
      const document2 = {
        family: "PulseJuce",
        version: 1,
        layout: normalizeNode(input.layout),
        theme: { name: input.theme.name, colors: { ...input.theme.colors }, ...input.theme.values ? { values: { ...input.theme.values } } : {} },
        motion: input.motion.map((track) => ({ ...track, durationMs: finite2(track.durationMs, `${track.target}.durationMs`) })),
        ...input.metadata ? { metadata: { ...input.metadata } } : {}
      };
      const violations = [];
      if (document2.layout.level !== "canvas") violations.push({ path: "layout", code: "root", message: "The layout root must be a canvas." });
      validateNode(document2.layout, "layout", null, violations);
      for (const [name, color2] of Object.entries(document2.theme.colors)) if (!COLOR.test(color2)) violations.push({ path: `theme.colors.${name}`, code: "color", message: "Use #RRGGBB or #RRGGBBAA." });
      document2.motion.forEach((track, index) => {
        if (track.durationMs < 0 || (track.delayMs ?? 0) < 0) violations.push({ path: `motion[${index}]`, code: "time", message: "Motion timing cannot be negative." });
      });
      return { document: document2, json: JSON.stringify(document2, null, 2), violations, valid: violations.length === 0 };
    }
  };
  var PulseJuceMotionAdapter = class {
    constructor(sink) {
      this.sink = sink;
    }
    apply(track, progress) {
      const t = Math.max(0, Math.min(1, progress));
      const value = track.from + (track.to - track.from) * t;
      this.sink.setValue(track.target, track.property, value);
      return value;
    }
  };
  var PulseJuce = {
    Converter: PulseJuceConverter,
    MotionAdapter: PulseJuceMotionAdapter,
    convert: PulseJuceConverter.convert
  };

  // src/playable.ts
  var playableFallbacks = /* @__PURE__ */ new Map();
  function recordPlayableFallback(target, requested, resolved) {
    const name = target?.constructor?.name || typeof target;
    const key2 = `${name}:${requested}:${resolved}`;
    const existing = playableFallbacks.get(key2);
    if (existing) existing.count += 1;
    else playableFallbacks.set(key2, { target: name, requested, resolved, count: 1 });
  }
  function getPlayableDiagnostics() {
    const fallbacks = [...playableFallbacks.values()].map((entry) => ({ ...entry }));
    return { fallbackCount: fallbacks.reduce((sum, entry) => sum + entry.count, 0), fallbacks };
  }
  function resetPlayableDiagnostics() {
    playableFallbacks.clear();
  }
  var PlayableBase = class {
    constructor() {
      this.playing = false;
      this._speed = 1;
      this._elapsed = 0;
      /** Optional total duration for progress-based seeking. */
      this._duration = 0;
    }
    play() {
      if (this.playing) return this;
      this.playing = true;
      this.bind();
      return this;
    }
    pause() {
      this.playing = false;
      this.unbind();
      return this;
    }
    seek(time) {
      this._elapsed = time;
      this.onTick(0);
      return this;
    }
    seekProgress(progress) {
      const p = progress < 0 ? 0 : progress > 1 ? 1 : progress;
      return this.seek((this._duration || 0) * p);
    }
    restart() {
      this._elapsed = 0;
      this.play();
      return this;
    }
    setSpeed(rate) {
      this._speed = rate;
      return this;
    }
    reverse() {
      this._speed = -this._speed;
      return this;
    }
  };
  function isPulsePlayable(value) {
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    const v = value;
    return typeof v.play === "function" && typeof v.pause === "function" && typeof v.seek === "function" && typeof v.dispose === "function";
  }
  function normalizePlayable(target) {
    if (isPulsePlayable(target) && typeof target.setSpeed === "function") return target;
    const call = (name, ...args) => {
      const fn = target?.[name];
      if (typeof fn === "function") fn.apply(target, args);
    };
    const disposeName = typeof target?.dispose === "function" ? "dispose" : typeof target?.destroy === "function" ? "destroy" : typeof target?.revert === "function" ? "revert" : typeof target?.teardown === "function" ? "teardown" : typeof target?.stop === "function" ? "stop" : null;
    const wrapper = {
      play() {
        call("play");
        return this;
      },
      pause() {
        if (typeof target?.pause === "function") call("pause");
        else {
          recordPlayableFallback(target, "pause", "stop");
          call("stop");
        }
        return this;
      },
      seek(time) {
        if (typeof target?.seek !== "function") recordPlayableFallback(target, "seek", "noop");
        call("seek", time);
        return this;
      },
      seekProgress(progress) {
        if (typeof target?.seekProgress === "function") {
          call("seekProgress", progress);
          return this;
        }
        const dur = typeof target?.duration === "number" ? target.duration : 0;
        recordPlayableFallback(target, "seekProgress", "seek");
        call("seek", dur * (progress < 0 ? 0 : progress > 1 ? 1 : progress));
        return this;
      },
      restart() {
        if (typeof target?.restart === "function") call("restart");
        else {
          recordPlayableFallback(target, "restart", "seek+play");
          call("seek", 0);
          call("play");
        }
        return this;
      },
      setSpeed(rate) {
        if (typeof target?.setSpeed !== "function") recordPlayableFallback(target, "setSpeed", "noop");
        call("setSpeed", rate);
        return this;
      },
      reverse() {
        call("reverse");
        return this;
      },
      dispose() {
        if (disposeName) {
          if (disposeName !== "dispose") recordPlayableFallback(target, "dispose", disposeName);
          call(disposeName);
        } else recordPlayableFallback(target, "dispose", "noop");
      }
    };
    return wrapper;
  }

  // src/pulsecore.ts
  var PulseCore = {
    // 01
    PulseTicker: {
      ticker,
      tick: (fn) => ticker.add(fn),
      size: () => ticker.size
    },
    // 02 + 03
    PulseTimer: { Timer: Timer2, Bag, Tween, Timeline: Timeline2, Spring, Easing, resolveEase },
    PulseMotion: { Bag, Tween, Timeline: Timeline2, Spring },
    PulseEditor: {
      PulseEditorRuntime,
      create: editorRuntime,
      convertAtlasProject: convertAtlasEditorProject,
      fingerprintProject: fingerprintPulseEditorProject,
      createDomAdapter: createPulseEditorDomAdapter,
      registerDomAdapter: registerPulseEditorDomAdapter,
      schemaVersion: CURRENT_PULSE_EDITOR_SCHEMA_VERSION,
      migrateProject: migratePulseEditorProject,
      validateProject: validatePulseEditorProject,
      assertProject: assertPulseEditorProject
    },
    PulseControls: { connect: connectPulseControls, schemas: pulseControlSchemas },
    PulseRmtLayers: {
      validate: validateRmtLayerManifest,
      normalize: normalizeRmtLayerManifest,
      fingerprint: fingerprintRmtLayerSplitterManifest,
      toEditorProject: rmtLayerSplitterToPulseEditorProject,
      mountDomScene: mountRmtLayerDomScene,
      createPlan: createRmtLayerSplitterPulsePlan
    },
    PulseSite: {
      PulseSite,
      create: pulseSite,
      PulseChapterStage,
      chapterStage,
      PulseVideoWall,
      videoWall,
      PulsePreviewPlaylist,
      previewPlaylist,
      PulseAudioReactive,
      audioReactive,
      PulseResponsiveDirector,
      PulseMediaCoordinator,
      PulseFrameSequence,
      PulseRail,
      PulseSelectionLink,
      PulseMotionBudget,
      PulseArchive,
      validateAssetManifest: validatePulseAssetManifest,
      auditRelease: auditPulseRelease
    },
    // 04
    PulseAdapter: {
      register: (a) => registerAdapter(a),
      resolve: (t) => resolveAdapter(t),
      read: (t, p) => readProp(t, p),
      write: (t, p, v) => writeProp(t, p, v),
      list: () => adapters.map((a) => a.name ?? "anon")
    },
    // 05
    PulseProperties,
    // 06
    PulseEngines: {
      text: { splitText: splitText2, textAnim, PulseSplit, split: pulseSplit, splitAdapter: PulseSplitAdapter, PulseTypeMorph, typeMorph, typeMorphAdapter: PulseTypeMorphAdapter },
      svg: { drawOn, morphPath, isSVG, svg, PulseMorph, morph, adapter: PulseMorphAdapter },
      box: { ...pulseBox, makeDraggable },
      layout: { PulseLayout, create: layout, adapter: PulseLayoutAdapter },
      timeline: { PulseTimelineEngine, create: timelineEngine, adapter: PulseTimelineEngineAdapter },
      grid: { PulseGrid, create: grid, adapter: PulseGridAdapter },
      magnet: { PulseMagnet, create: magnet, adapter: PulseMagnetAdapter },
      camera: { PulseCamera, create: camera, adapter: PulseCameraAdapter },
      events: { PulseEvents, create: events, adapter: PulseEventsAdapter },
      maskLayer: { PulseMaskLayer, create: maskLayer, adapter: PulseMaskLayerAdapter },
      maskMaps: { PulseMaskMaps, create: maskMaps, adapter: PulseMaskMapsAdapter },
      maskTransition: { PulseMaskTransition, create: maskTransition, adapter: PulseMaskTransitionAdapter },
      textureMaps: { PulseTextureMaps, create: textureMaps, adapter: PulseTextureMapsAdapter },
      textureAsset: { PulseTextureAsset, create: textureAsset, presets: PULSE_TEXTURE_ASSET_PRESETS },
      particles: { PulseParticles, PulseSubParticles, create: particles, subParticles, adapter: PulseParticlesAdapter, subAdapter: PulseSubParticlesAdapter },
      blendModes: { PulseBlendModes, create: blendModes, adapter: PulseBlendModesAdapter },
      spacing: { PulseSpacing, create: spacing, adapter: PulseSpacingAdapter },
      structure: { PulseStructure, create: structure, adapter: PulseStructureAdapter },
      color: { PulseColorCycle, create: colorCycle, adapter: PulseColorCycleAdapter }
    },
    // 07
    PulseModules: { Audio, Cursor, Magnet, fx, Recorder, PulseWaapi, waapi: pulseWaapi },
    // 08
    PulseScene,
    Group: TimerGroup,
    debug,
    // 09+ ecosystem
    PulseConverter,
    PulseJuce,
    PulseLifecycle: { diagnostics: getPlayableDiagnostics, normalize: normalizePlayable, resetDiagnostics: resetPlayableDiagnostics },
    PulsePlan,
    PulseScope,
    PulseSignal,
    SignalRegistry,
    PulseSplit: { PulseSplit, create: pulseSplit, adapter: PulseSplitAdapter },
    PulseTypeMorph: { PulseTypeMorph, create: typeMorph, adapter: PulseTypeMorphAdapter },
    PulseGrid: { PulseGrid, create: grid, adapter: PulseGridAdapter },
    PulseMagnet: { PulseMagnet, create: magnet, adapter: PulseMagnetAdapter },
    PulseCamera: { PulseCamera, create: camera, adapter: PulseCameraAdapter },
    PulseEvents: { PulseEvents, create: events, adapter: PulseEventsAdapter },
    PulseMaskLayer: { PulseMaskLayer, create: maskLayer, adapter: PulseMaskLayerAdapter },
    PulseMaskMaps: { PulseMaskMaps, create: maskMaps, adapter: PulseMaskMapsAdapter },
    PulseMaskTransition: { PulseMaskTransition, create: maskTransition, adapter: PulseMaskTransitionAdapter },
    PulseTextureMaps: { PulseTextureMaps, create: textureMaps, adapter: PulseTextureMapsAdapter },
    PulseTextureAsset: { PulseTextureAsset, create: textureAsset, presets: PULSE_TEXTURE_ASSET_PRESETS },
    PulseWaapi: { PulseWaapi, create: () => pulseWaapi },
    PulseParticles: { PulseParticles, PulseSubParticles, create: particles, subParticles, adapter: PulseParticlesAdapter, subAdapter: PulseSubParticlesAdapter },
    PulseBlendModes: { PulseBlendModes, create: blendModes, adapter: PulseBlendModesAdapter },
    PulseSpacing: { PulseSpacing, create: spacing, adapter: PulseSpacingAdapter },
    PulseStructure: { PulseStructure, create: structure, adapter: PulseStructureAdapter },
    PulseColorCycle: { PulseColorCycle, create: colorCycle, adapter: PulseColorCycleAdapter },
    PulseMorph: { PulseMorph, create: morph, adapter: PulseMorphAdapter },
    PulsePatch: PulsePatchChain,
    PulseLayout: { PulseLayout, create: layout, adapter: PulseLayoutAdapter },
    PulseTimeline: { PulseTimelineEngine, create: timelineEngine, adapter: PulseTimelineEngineAdapter },
    profiler,
    // factories
    scene(id2) {
      return new PulseScene(id2);
    },
    site(engine2, params) {
      return pulseSite(engine2, params);
    },
    scope(id2, opts) {
      return new PulseScope(id2, opts);
    },
    signal(name) {
      return new PulseSignal(name);
    },
    split(root, params) {
      return pulseSplit(root, params);
    },
    typeMorph(root, params) {
      return typeMorph(root, params);
    },
    grid(root, params) {
      return grid(root, params);
    },
    pulseMagnet(root, params) {
      return magnet(root, params);
    },
    magenet(root, params) {
      return magnet(root, params);
    },
    camera(root, params) {
      return camera(root, params);
    },
    events(params) {
      return events(params);
    },
    maskLayer(root, name, params) {
      return maskLayer(root, name, params);
    },
    maskMaps(root, params) {
      return maskMaps(root, params);
    },
    maskTransition(targets, params) {
      return maskTransition(targets, params);
    },
    textureMaps(root, params) {
      return textureMaps(root, params);
    },
    textureAsset(root, params) {
      return textureAsset(root, params);
    },
    waapi(targets, params) {
      return pulseWaapi.animate(targets, params);
    },
    particles(root, params) {
      return particles(root, params);
    },
    subParticles(parent, params) {
      return subParticles(parent, params);
    },
    blendModes(root, params) {
      return blendModes(root, params);
    },
    spacing(root, params) {
      return spacing(root, params);
    },
    structure(root, params) {
      return structure(root, params);
    },
    colorCycle(bindings, params) {
      return colorCycle(bindings, params);
    },
    morph(target, states2, params) {
      return morph(target, states2, params);
    },
    design(root, params) {
      return structure(root, params);
    },
    layout(root, params) {
      return layout(root, params);
    },
    timelineEngine(params) {
      return timelineEngine(params);
    },
    editor(project, params) {
      return editorRuntime(project, params);
    },
    controls(target, root, schema) {
      return connectPulseControls(target, root, schema);
    },
    patch(target, spec, opts) {
      return new PulsePatchChain(target, spec ?? {}, opts ?? {});
    },
    plan(input) {
      return input;
    }
  };

  // src/surface/surface.ts
  var COLOR_RE = /^(#([0-9a-f]{3,8})|rgb|rgba|hsl|hsla|oklch|oklab)/i;
  var isColorLike = (s) => COLOR_RE.test(s.trim());
  var CONTRACT = {
    "--surface-intensity": 1,
    "--surface-speed": 1,
    "--surface-opacity": 1,
    "--color-a": "#ffffff",
    "--color-b": "#000000",
    "--color-c": "transparent",
    "--shine-x": "0%",
    "--shine-y": "50%",
    "--shine-opacity": 0.5,
    "--shine-width": 18,
    "--mask-x": "50%",
    "--mask-y": "50%",
    "--mask-scale": 1,
    "--mask-opacity": 1,
    "--distort": 0,
    "--blur": "0px",
    "--glow": 0,
    "--grain": 0,
    "--scan-y": "0%",
    "--scan-offset": "0px",
    "--flicker": 1
  };
  var unitForSurfaceVar = (name, raw) => {
    if (Array.isArray(raw) && typeof raw[raw.length - 1] === "string" && !isColorLike(raw[raw.length - 1]) && !/^-?[\d.]+/.test(raw[raw.length - 1])) {
      return raw[raw.length - 1];
    }
    const contract = CONTRACT[name];
    if (typeof contract === "string") {
      const m = /^-?[\d.]+([a-z%]+)$/i.exec(contract.trim());
      if (m) return m[1];
    }
    if (/(^--(mask|shine|scan)-[xy]$|^--scan-y$|^--holo-shift$|^--chrome-pos$|^--heat-x$|^--water-x$|^--gold-pos$)/.test(name)) return "%";
    if (/(offset|blur|width|radius|gap|x$|y$)/.test(name) && !/(opacity|flicker|glow|grain|distort|spec|sparkle)/.test(name)) return "px";
    return "";
  };
  var numericKeys = (values) => values.filter((x) => typeof x === "number");
  var SURFACES = {
    water: {
      cls: "pulse-water",
      mask: "water",
      texture: "liquid",
      vars: { "--mask-x": [0, 100], "--mask-y": [40, 65], "--distort": [4, 18], "--shine-opacity": [0.15, 0.65], "--blur": [0, 1.8, "px"] },
      helpers: (el, P) => [P.distort.attach(el, { type: "turbulence", strength: 16, frequency: 0.02, blur: 1.4, speed: 3 })],
      meta: { mask: "turbulence + ripple", texture: "liquid-gradient", mode: "css/svg", adapter: "css-var + filter" }
    },
    diamond: {
      cls: "pulse-diamond",
      texture: "prism",
      mask: "facets",
      vars: { "--shine-x": [-40, 140], "--shine-opacity": [0.25, 0.8], "--sparkle": [0, 1], "--prism-a": ["#ffffff", "#00eaff"], "--prism-b": ["#ffffff", "#ff4dff"], "--glow": [0.2, 1] },
      helpers: (el, P) => [P.shine.attach(el, { angle: 115, width: 24, opacity: 0.85, speed: 1.6, loopDelay: 1 })],
      meta: { mask: "shine + facets", texture: "prism-gradient", mode: "css", adapter: "css-var" }
    },
    chrome: {
      cls: "pulse-chrome",
      texture: "metal",
      vars: { "--chrome-light": [0, 100], "--chrome-pos": [0, 100], "--spec": [0.1, 0.9] },
      helpers: (el, P) => [P.shine.attach(el, { angle: 105, width: 20, opacity: 0.9, speed: 2.2, loopDelay: 0.6 })],
      meta: { mask: "wide vertical shine", texture: "metallic-gradient", mode: "css", adapter: "css-var" }
    },
    glass: {
      cls: "pulse-glass",
      texture: "glass",
      mask: "glass",
      vars: { "--glass-blur": [0, 12], "--glass-tint": ["rgba(255,255,255,0.05)", "rgba(255,255,255,0.25)"], "--glass-edge": [0, 1], "--shine-x": [-40, 120] },
      helpers: (el, P) => [P.shine.attach(el, { angle: 120, width: 18, opacity: 0.4, speed: 2.6 })],
      meta: { mask: "soft gradient + edge", texture: "glass-reflection", mode: "css+backdrop", adapter: "css-var" }
    },
    hologram: {
      cls: "pulse-hologram",
      texture: "holo",
      vars: { "--holo-a": ["#00eaff", "#ff00ea"], "--holo-b": ["#ff00ea", "#00ff88"], "--holo-shift": [0, 100], "--holo-scan": [0, 100], "--flicker": [0.6, 1] },
      helpers: (el, P) => [P.scan.attach(el, { preset: "holo", direction: "down", gap: 6, thickness: 2, beam: true })],
      meta: { mask: "scanlines + noise", texture: "holo-gradient", mode: "css", adapter: "css-var" }
    },
    static: {
      cls: "pulse-static",
      mask: "static",
      texture: "noise",
      vars: { "--grain": [0, 1], "--static-amount": [0, 1], "--static-speed": [0.2, 2], "--flicker": [0.7, 1], "--noise-x": [0, 40, 12, 60, 8], "--noise-y": [0, 30, 50, 5, 35] },
      helpers: (el, P) => [P.noise.attach(el, { seed: 7, intensity: 0.45, speed: 0.08, mode: "css" })],
      meta: { mask: "noise", texture: "noise", mode: "canvas/css", adapter: "css-var + dataurl" }
    },
    ripple: {
      cls: "pulse-ripple",
      mask: "water",
      texture: "liquid",
      vars: { "--ripple-radius": [0, 140], "--ripple-opacity": [1, 0], "--ripple-width": [4, 10], "--mask-x": [50, 50], "--mask-y": [50, 50] },
      helpers: (el, P) => [P.distort.attach(el, { type: "ripple", strength: 10, frequency: 0.02 })],
      meta: { mask: "radial ring", texture: "glow-ring", mode: "css", adapter: "css-var" }
    },
    glitch: {
      cls: "pulse-glitch",
      mask: "glitch",
      texture: "noise",
      vars: { "--glitch-x": [0, -2, 4, -1, 0], "--glitch-y": [0, 1, -1, 0], "--rgb-r": [0, 5, -3, 2, 0], "--rgb-b": [0, -4, 3, -2, 0], "--flicker": [1, 0.4, 1, 0.7, 1] },
      helpers: (el, P) => {
        const applied = P.mask.apply(el, "glitch-slices");
        el.style.setProperty("--surface-mask-image", applied);
        el.style.maskImage = "";
        return [{ timers: [], dispose() {
        } }];
      },
      meta: { mask: "slices + noise", texture: "rgb-offset", mode: "css", adapter: "css-var + transform" }
    },
    heat: {
      cls: "pulse-heat",
      mask: "heat",
      texture: "metal",
      vars: { "--heat-x": [0, 100], "--distort": [4, 12], "--blur": [0, 1.5, "px"], "--hue-shift": [0, 24] },
      helpers: (el, P) => [P.distort.attach(el, { type: "heat", maskName: "heat", strength: 12, frequency: 0.01, blur: 1.5, speed: 2.2 })],
      meta: { mask: "turbulence/wave", texture: "warm-shimmer", mode: "svg-filter", adapter: "svg-attr + css-var" }
    },
    crt: {
      cls: "pulse-crt",
      texture: "scan",
      vars: { "--scan-offset": [0, 28], "--scan-gap": [4, 4], "--glow": [0.2, 0.8], "--flicker": [0.7, 1] },
      helpers: (el, P) => [P.scan.attach(el, { preset: "crt", direction: "down", gap: 4, thickness: 1, color: "rgba(0,255,90,.45)", flicker: true })],
      meta: { mask: "scanlines", texture: "phosphor-glow", mode: "css", adapter: "css-var" }
    },
    neon: {
      cls: "pulse-neon",
      texture: "neon",
      vars: { "--glow": [0.35, 1], "--neon-opacity": [0.75, 1], "--color-a": ["#b000ff", "#00eaff"], "--color-b": ["#ff00ea", "#00eaff"] },
      helpers: (el, P) => [P.scan.attach(el, { preset: "crt", direction: "down", gap: 8, thickness: 2, color: "rgba(0,255,255,.2)" })],
      meta: { mask: "radial-glow", texture: "color-bloom", mode: "css", adapter: "css-var + shadow" }
    },
    gold: {
      cls: "pulse-gold",
      texture: "gold",
      vars: { "--shine-x": [-40, 140], "--shine-opacity": [0.3, 0.9], "--gold-warmth": [0.6, 1], "--color-a": ["#6b4700", "#d7a928"], "--color-c": ["#fff1a8", "#fff1a8"] },
      helpers: (el, P) => [P.shine.attach(el, { angle: 110, width: 18, opacity: 0.72, speed: 2 })],
      meta: { mask: "diagonal-shine", texture: "gold-metallic", mode: "css", adapter: "css-var" }
    },
    ctScan: {
      cls: "pulse-ct-scan",
      texture: "liquid",
      vars: { "--scan-y": [-15, 115], "--scan-offset": [0, 36], "--scan-glow": [0.35, 1], "--scan-opacity": [0.18, 0.55], "--mask-x": [50, 50] },
      helpers: (el, P) => [P.scan.attach(el, { preset: "ct", direction: "pingpong", gap: 12, thickness: 2, color: "rgba(0,235,255,.85)", beam: true })],
      meta: { mask: "scanlines + beam", texture: "medical-cyan", mode: "css", adapter: "css-var" }
    },
    fracture: {
      cls: "pulse-fracture",
      texture: "fracture",
      vars: { "--crack-width": [0.5, 3], "--crack-opacity": [0, 1], "--spread": [0, 1], "--edge-glow": [0, 1] },
      helpers: (el, P, o) => [P.fracture.attach(el, { seed: o.seed ?? 12, points: o.points ?? 18, crackWidth: o.crackWidth ?? 3, jitter: o.jitter ?? 0.45, spread: o.spread ?? 1, edgeGlow: o.edgeGlow ?? true, loop: true })],
      meta: { mask: "fracture/cracks", texture: "white-crack", mode: "svg-mask", adapter: "svg-mask + css-var" }
    }
  };
  var PulseSurface = class {
    constructor(engine2) {
      this.P = engine2;
    }
    names() {
      return Object.keys(SURFACES);
    }
    has(name) {
      return !!SURFACES[name];
    }
    meta(name) {
      return SURFACES[name]?.meta;
    }
    /** Apply a surface recipe to el → controllable SurfaceHandle. */
    apply(name, el, opts = {}) {
      const recipe = SURFACES[name];
      if (!recipe) {
        console.warn(`[pulse:surface] unknown "${name}"`);
        return this.nullHandle(el, name);
      }
      el.classList.add("pulse-surface", recipe.cls);
      for (const k of Object.keys(CONTRACT)) if (!el.style.getPropertyValue(k)) el.style.setProperty(k, String(CONTRACT[k]));
      if (recipe.texture) this.P.texture.apply(el, recipe.texture);
      if (recipe.mask) {
        const applied = this.P.mask.apply(el, recipe.mask);
        if (applied.includes("#pm-pat-")) {
          el.style.setProperty("--surface-pattern", applied);
        } else if (applied.includes("#pm-mask-")) {
          el.style.setProperty("--surface-mask-image", applied);
          el.style.maskImage = "";
        } else if (applied.includes("#pm-")) {
          el.style.setProperty("--surface-filter", applied);
          el.style.filter = "";
        }
      }
      const spec = {};
      for (const k of Object.keys(recipe.vars)) {
        const v = recipe.vars[k];
        if (Array.isArray(v) && v.length && typeof v[0] === "string" && v.every((s) => isColorLike(s))) {
          spec[k] = { colors: v, css: k };
        } else if (Array.isArray(v) && typeof v[0] === "string") {
          const m0 = /^(-?[\d.]+)(%|\w*)$/.exec(v[0]);
          const m1 = /^(-?[\d.]+)(%|\w*)$/.exec(v[1]);
          const u = m0 && m0[2] || m1 && m1[2] || "";
          spec[k] = { from: m0 ? parseFloat(v[0]) : 0, to: m1 ? parseFloat(v[1]) : 0, unit: u, css: k };
        } else if (Array.isArray(v)) {
          spec[k] = { keys: numericKeys(v), unit: unitForSurfaceVar(k, v), css: k };
        } else spec[k] = { ...v, css: k };
      }
      const plan = this.P.convert("bag", {
        name: `surface:${name}`,
        target: el,
        props: spec,
        duration: opts.duration ?? 2.4,
        ease: opts.ease ?? "inOutSine",
        loop: opts.loop ?? true,
        alternate: opts.alternate ?? true,
        delay: opts.delay ?? 0
      });
      const bag = plan.mount(this.P);
      const helperHandles = recipe.helpers ? recipe.helpers(el, this.P, opts) : [];
      const timers = [bag, ...helperHandles.flatMap((h) => h?.timers || [])];
      return this.handle(el, name, timers, helperHandles, opts);
    }
    handle(el, name, timers, helperHandles, opts) {
      const self2 = this;
      let delegate = null;
      const cleanupLocal = () => {
        timers.forEach((t) => {
          t.cancel && t.cancel();
          t.dispose && t.dispose();
        });
        helperHandles.forEach((h) => h && h.dispose && h.dispose());
        el.classList.remove("pulse-surface", SURFACES[name]?.cls || "");
        el.style.removeProperty("--surface-filter");
        el.style.removeProperty("--surface-mask-image");
        el.style.removeProperty("--surface-pattern");
        el.style.removeProperty("--texture-bg");
        el.style.filter = "";
        el.style.maskImage = "";
      };
      return {
        el,
        name,
        get timers() {
          return delegate?.timers ?? timers;
        },
        play() {
          (delegate?.timers ?? timers).forEach((t) => t.play && t.play());
        },
        pause() {
          (delegate?.timers ?? timers).forEach((t) => t.pause && t.pause());
        },
        seek(_t) {
          (delegate?.timers ?? timers).forEach((t) => t.seek && t.seek(_t));
        },
        dispose() {
          if (delegate) {
            delegate.dispose();
            delegate = null;
            return;
          }
          cleanupLocal();
        },
        update(o) {
          if (delegate) delegate.dispose();
          else cleanupLocal();
          delegate = self2.apply(name, el, { ...opts, ...o });
        }
      };
    }
    nullHandle(el, name) {
      return { el, name, timers: [], play() {
      }, pause() {
      }, seek() {
      }, dispose() {
      }, update() {
      } };
    }
    // convenience named methods (mirror P.surface.water(...))
    water(el, o = {}) {
      return this.apply("water", el, o);
    }
    diamond(el, o = {}) {
      return this.apply("diamond", el, o);
    }
    chrome(el, o = {}) {
      return this.apply("chrome", el, o);
    }
    glass(el, o = {}) {
      return this.apply("glass", el, o);
    }
    hologram(el, o = {}) {
      return this.apply("hologram", el, o);
    }
    static(el, o = {}) {
      return this.apply("static", el, o);
    }
    ripple(el, o = {}) {
      return this.apply("ripple", el, o);
    }
    glitch(el, o = {}) {
      return this.apply("glitch", el, o);
    }
    heat(el, o = {}) {
      return this.apply("heat", el, o);
    }
    crt(el, o = {}) {
      return this.apply("crt", el, o);
    }
    neon(el, o = {}) {
      return this.apply("neon", el, o);
    }
    gold(el, o = {}) {
      return this.apply("gold", el, o);
    }
    ctScan(el, o = {}) {
      return this.apply("ctScan", el, o);
    }
    fracture(el, o = {}) {
      return this.apply("fracture", el, o);
    }
  };

  // src/surface/helpers.ts
  var mk = (timers) => ({
    timers,
    dispose() {
      timers.forEach((t) => {
        t.cancel && t.cancel();
        t.dispose && t.dispose();
      });
    }
  });
  var PulseScan = class {
    constructor(P) {
      this.P = P;
    }
    /** preset: ct | holo | crt. direction: up | down | pingpong. */
    attach(el, o = {}) {
      const preset = o.preset || "ct";
      const dir = o.direction || "pingpong";
      const gap = o.gap ?? (preset === "crt" ? 4 : preset === "holo" ? 6 : 12);
      const thick = o.thickness ?? (preset === "crt" ? 1 : 2);
      const col = o.color || (preset === "crt" ? "rgba(0,255,90,.45)" : "rgba(0,235,255,.5)");
      el.style.setProperty("--scan-gap", gap + "px");
      el.style.setProperty("--scan-thickness", thick + "px");
      el.style.setProperty("--scan-color", col);
      if (o.beam) {
        el.style.setProperty("--scan-beam", "1");
        el.classList.add("pulse-scan-beam");
      }
      const spec = {
        "--scan-offset": dir === "up" ? { from: 0, to: -gap } : dir === "down" ? { from: 0, to: gap } : { from: 0, to: gap * 3 }
      };
      if (preset === "ct" && (dir === "up" || dir === "pingpong")) {
        spec["--scan-y"] = { from: -15, to: 115, unit: "%" };
        spec["--scan-opacity"] = { from: 0.18, to: 0.55 };
        spec["--scan-glow"] = { from: 0.35, to: 1 };
      }
      if (o.flicker) spec["--flicker"] = { keys: [1, 0.6, 1, 0.85, 1] };
      const bag = this.P.bag(el, spec, {
        duration: o.duration ?? (preset === "ct" ? 2.6 : preset === "crt" ? 1.4 : 2),
        ease: "inOutSine",
        loop: true,
        alternate: dir === "pingpong",
        loopDelay: o.loopDelay ?? 0
      });
      return mk([bag]);
    }
  };
  var PulseShine = class {
    constructor(P) {
      this.P = P;
    }
    attach(el, o = {}) {
      const angle = o.angle ?? 115;
      const width = o.width ?? 22;
      const op = o.opacity ?? 0.8;
      el.style.setProperty("--shine-angle", angle + "deg");
      el.style.setProperty("--shine-width", width + "%");
      el.style.setProperty("--shine-base", op + "");
      const bag = this.P.bag(el, {
        "--shine-x": { from: -60, to: 140, unit: "%" },
        "--shine-opacity": { from: op * 0.25, to: op }
      }, {
        duration: o.speed ?? 1.6,
        ease: "outExpo",
        loop: true,
        loopDelay: o.loopDelay ?? 1
      });
      return mk([bag]);
    }
  };
  var PulseNoise = class {
    constructor(P) {
      this.P = P;
    }
    attach(el, o = {}) {
      const seed = o.seed ?? 5;
      const intensity = o.intensity ?? 0.4;
      el.style.setProperty("--grain-seed", seed + "");
      el.style.setProperty("--grain-amount", intensity + "");
      if (o.mode === "canvas") el.classList.add("pulse-noise-canvas");
      const timers = [];
      timers.push(this.P.bag(el, {
        "--grain": { from: 0.2, to: intensity },
        "--flicker": o.flicker ? { keys: [1, 0.4, 1, 0.7, 1] } : { from: 0.85, to: 1 }
      }, { duration: o.flicker ? 0.4 : 1 / (o.speed || 0.1), loop: true, alternate: !o.flicker, ease: "steps(4)" }));
      return mk(timers);
    }
  };
  var PulseDistort = class {
    constructor(P) {
      this.P = P;
    }
    attach(el, o = {}) {
      const type = o.type || "turbulence";
      const strength = o.strength ?? 12;
      const maskName = o.maskName || (type === "glass" ? "glass" : type === "heat" ? "heat" : "water");
      el.style.setProperty("--surface-filter", `url(#pm-${maskName})`);
      el.style.filter = "";
      const timers = [];
      if (type !== "ripple") {
        timers.push(this.P.bag(el, {
          "--distort": { from: strength * 0.3, to: strength },
          "--blur": { from: 0, to: o.blur ?? 1.2, unit: "px" }
        }, { duration: o.speed ?? 2.2, loop: true, alternate: true, ease: "inOutSine" }));
      }
      return mk(timers);
    }
  };
  var PulseFracture = class {
    constructor(P) {
      this.P = P;
    }
    attach(el, o = {}) {
      const NS = "http://www.w3.org/2000/svg";
      const svg2 = document.createElementNS(NS, "svg");
      svg2.setAttribute("class", "pulse-fracture-svg");
      svg2.setAttribute("viewBox", "0 0 100 100");
      svg2.setAttribute("preserveAspectRatio", "none");
      svg2.style.cssText = "position:absolute;inset:0;width:100%;height:100%;pointer-events:none;";
      for (const d of this.crackPaths(o)) {
        const p = document.createElementNS(NS, "path");
        p.setAttribute("d", d);
        p.setAttribute("class", "pulse-crack");
        svg2.appendChild(p);
      }
      el.appendChild(svg2);
      if (o.edgeGlow) el.classList.add("pulse-fracture-edge");
      const timers = [];
      if (o.spread !== 0 && o.spread != null) {
        timers.push(this.P.bag(el, {
          "--crack-width": { from: 0.5, to: o.crackWidth ?? 3 },
          "--crack-opacity": { from: 0, to: 1 },
          "--spread": { from: 0, to: o.spread }
        }, { duration: o.duration ?? 1.6, loop: !!o.loop, alternate: !!o.loop, ease: "outExpo" }));
      }
      const dispose = () => {
        svg2.remove();
        el.classList.remove("pulse-fracture-edge");
      };
      return { timers, dispose };
    }
    crackPaths(o) {
      const pts = o.points ?? 18, jit = o.jitter ?? 0.45, seed = o.seed ?? 12;
      const rnd = (n) => {
        const x = Math.sin(n * 12.9898 + seed * 78.233) * 43758.5453;
        return x - Math.floor(x);
      };
      const verts = Array.from({ length: pts }, (_, i) => [rnd(i) * 100, rnd(i + pts) * 100]);
      const paths = [];
      for (let i = 1; i < pts; i++) {
        const a = verts[i - 1], b = verts[i];
        const mx = (a[0] + b[0]) / 2 + (rnd(i * 3) - 0.5) * jit * 100;
        const my = (a[1] + b[1]) / 2 + (rnd(i * 3 + 1) - 0.5) * jit * 100;
        paths.push(`M${a[0].toFixed(1)} ${a[1].toFixed(1)} L${mx.toFixed(1)} ${my.toFixed(1)} L${b[0].toFixed(1)} ${b[1].toFixed(1)}`);
      }
      return paths;
    }
  };

  // src/texture/texture.ts
  var PulseTexture = class {
    constructor(_engine) {
      this.defs = /* @__PURE__ */ new Map();
      this.registerDefaults();
    }
    liquid(name = "liquid", o = {}) {
      this.defs.set(name, { kind: "liquid", opts: { a: "#003cff", b: "#00eaff", c: "#00112b", ...o } });
      return this;
    }
    prism(name = "prism", o = {}) {
      this.defs.set(name, { kind: "prism", opts: { a: "#ffffff", b: "#00eaff", c: "#ff4dff", ...o } });
      return this;
    }
    metal(name = "metal", o = {}) {
      this.defs.set(name, { kind: "metal", opts: { dark: "#202124", mid: "#bfc1c5", bright: "#ffffff", ...o } });
      return this;
    }
    glass(name = "glass", o = {}) {
      this.defs.set(name, { kind: "glass", opts: { tint: "rgba(255,255,255,.16)", edge: "rgba(255,255,255,.28)", ...o } });
      return this;
    }
    holo(name = "holo", o = {}) {
      this.defs.set(name, { kind: "holo", opts: { a: "#00eaff", b: "#7b00ff", c: "#00ff7a", ...o } });
      return this;
    }
    noise(name = "noise", o = {}) {
      this.defs.set(name, { kind: "noise", opts: { ...o } });
      return this;
    }
    scan(name = "scan", o = {}) {
      this.defs.set(name, { kind: "scan", opts: { gap: 6, color: "rgba(0,255,90,.45)", ...o } });
      return this;
    }
    neon(name = "neon", o = {}) {
      this.defs.set(name, { kind: "neon", opts: { color: "#b000ff", ...o } });
      return this;
    }
    gold(name = "gold", o = {}) {
      this.defs.set(name, { kind: "gold", opts: { a: "#6b4700", b: "#d7a928", c: "#fff1a8", ...o } });
      return this;
    }
    fracture(name = "fracture", o = {}) {
      this.defs.set(name, { kind: "fracture", opts: { ...o } });
      return this;
    }
    has(name) {
      return this.defs.has(name);
    }
    names() {
      return [...this.defs.keys()];
    }
    /** CSS background string for a texture, driven by --vars the recipe sets. */
    background(name) {
      const d = this.defs.get(name);
      if (!d) return "";
      const o = d.opts;
      switch (d.kind) {
        case "liquid":
          return `radial-gradient(circle at var(--mask-x,50%) var(--mask-y,50%), rgba(255,255,255,var(--shine-opacity,.4)), transparent 34%), linear-gradient(135deg, var(--color-a,${o.a}), var(--color-b,${o.b}), ${o.c})`;
        case "prism":
          return `linear-gradient(135deg, #11131c, #2b2f42 45%, #05060c), linear-gradient(45deg, var(--color-a,${o.a}), var(--color-b,${o.b}), var(--color-c,${o.c}))`;
        case "metal":
          return `linear-gradient(105deg, ${o.dark} 0%, ${o.mid} 28%, ${o.bright} 48%, #777a80 58%, #d8d9dc 76%, #34363a 100%)`;
        case "glass":
          return `linear-gradient(160deg, ${o.tint}, rgba(180,210,255,.12))`;
        case "holo":
          return `linear-gradient(125deg, rgba(0,255,255,.35), rgba(120,0,255,.55) var(--holo-shift,50%), rgba(0,255,120,.25)), #020716`;
        case "scan":
          return `radial-gradient(circle at 50% 50%, rgba(0,255,90,.16), transparent 55%), #001006`;
        case "neon":
          return `radial-gradient(circle at 50% 50%, color-mix(in srgb, var(--color-a,#b000ff) 22%, transparent), transparent 70%)`;
        case "gold":
          return `linear-gradient(110deg, ${o.a}, #b8860b 25%, ${o.c} 48%, #c9971a 62%, ${o.b} 100%)`;
        case "noise":
          return o.dataURL ? `url(${o.dataURL})` : `repeating-conic-gradient(#111 0% 25%, #2b2b34 0% 50%), repeating-linear-gradient(90deg, rgba(255,255,255,.12) 0 1px, transparent 1px 5px)`;
        case "fracture":
          return `linear-gradient(135deg, #0c0c12, #1a1a24 50%, #06060c)`;
        default:
          return "";
      }
    }
    /** Apply a texture as the element's background (to its ::before via var). */
    apply(el, name) {
      const bg = this.background(name);
      if (bg) el.style.setProperty("--texture-bg", bg);
      return bg;
    }
    registerDefaults() {
      this.liquid();
      this.prism();
      this.metal();
      this.glass();
      this.holo();
      this.noise();
      this.scan();
      this.neon();
      this.gold();
      this.fracture();
    }
  };
  var texture = (engine2) => new PulseTexture(engine2);

  // src/core/engine.ts
  var Pulse = class {
    constructor(options = {}) {
      this.version = "1.9.0";
      this.owned = /* @__PURE__ */ new Map();
      const systemReduced = typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.motion = {
        reducedMotion: options.motion?.reducedMotion ?? systemReduced,
        speed: Math.max(1e-6, options.motion?.speed ?? 1),
        frameRate: Math.max(0, options.motion?.frameRate ?? 0)
      };
    }
    /** When true, cosmetic motion resolves immediately across modern wrappers. */
    get reducedMotion() {
      return this.motion.reducedMotion;
    }
    set reducedMotion(value) {
      this.motion.reducedMotion = Boolean(value);
    }
    // core
    tween(target, spec) {
      if (this.reducedMotion) {
        const t = new Tween(target, { ...spec, duration: 0 });
        t.set(1);
        return this.track(t, "tween");
      }
      return this.track(new Tween(target, spec).setSpeed(this.motion.speed), "tween");
    }
    timeline() {
      return this.track(new Timeline2().setSpeed(this.motion.speed), "timeline");
    }
    timelineEngine(params) {
      const timeline = new PulseTimelineEngine({ ...params, reducedMotion: params?.reducedMotion ?? this.reducedMotion });
      timeline.setSpeed(this.motion.speed);
      return this.track(timeline, "timeline");
    }
    editor(project, params) {
      return this.track(new PulseEditorRuntime(project, params), "editor");
    }
    bag(el, spec, opts) {
      if (this.reducedMotion) {
        const b = new Bag(el, spec, { ...opts, duration: 0 });
        b.snap();
        return this.track(b, "bag");
      }
      return this.track(new Bag(el, spec, { ...opts, playbackRate: opts?.playbackRate ?? this.motion.speed }), "bag");
    }
    spring(opts) {
      return new Spring(opts);
    }
    // easing
    ease(name) {
      return resolveEase(name);
    }
    get Easing() {
      return Easing;
    }
    // modules
    audio(opts) {
      return this.track(new Audio(opts), "audio");
    }
    cursor(opts) {
      return this.track(new Cursor(opts), "cursor");
    }
    magnet(opts) {
      return this.track(new Magnet(opts), "pointer-magnet");
    }
    recorder(stage, opts) {
      return this.track(new Recorder(stage, opts), "recorder");
    }
    // box engine — hierarchy / container system
    box(spec, mount) {
      return this.track(new Box(spec, mount), "box");
    }
    boxTree(spec, mount) {
      return this.track(new BoxTree(spec, mount), "box-tree");
    }
    get PulseBox() {
      return pulseBox;
    }
    /** Drag a Box (or any HTMLElement) — modeled on anime.js v4 Draggable.
     *  types: 'x' | 'y' | 'xy' | 'translate' | 'rotate' | 'scale'. */
    drag(target, params = {}) {
      return this.track(makeDraggable2(target, params), "drag");
    }
    // adapters — pluggable get/set seam for any target type
    adapter(target) {
      return resolveAdapter(target);
    }
    registerAdapter(a) {
      registerAdapter(a);
    }
    readProp(target, prop) {
      return readProp(target, prop);
    }
    writeProp(target, prop, value) {
      writeProp(target, prop, value);
    }
    // utils — pure helpers
    get utils() {
      return utils;
    }
    clamp(v, a, b) {
      return clamp2(v, a, b);
    }
    lerp(a, b, t) {
      return lerp2(a, b, t);
    }
    random(a = 0, b = 1) {
      return random(a, b);
    }
    // text — split + stagger-animate
    splitText(el, mode) {
      return splitText2(el, mode);
    }
    split(root, params) {
      return this.track(pulseSplit(root, { ...params, reducedMotion: params?.reducedMotion ?? this.reducedMotion }), "split");
    }
    typeMorph(target, params) {
      return this.track(new PulseTypeMorph(target, {
        ...params,
        reducedMotion: params.reducedMotion ?? this.reducedMotion
      }), "type-morph");
    }
    textAnim(el, spec, opts) {
      return textAnim(el, spec, opts);
    }
    // svg — draw-on / morph
    get svg() {
      return svg;
    }
    drawOn(el, opts) {
      return this.track(drawOn(el, opts), "draw-on");
    }
    morph(target, states2, options) {
      return this.track(new PulseMorph(target, states2, {
        ...options,
        speed: options?.speed ?? this.motion.speed,
        reducedMotion: options?.reducedMotion ?? this.reducedMotion
      }), "morph");
    }
    morphPath(el, fromD, toD, opts) {
      return this.track(morphPath(el, fromD, toD, {
        ...opts,
        speed: opts?.speed ?? this.motion.speed,
        reducedMotion: opts?.reducedMotion ?? this.reducedMotion
      }), "morph");
    }
    // fx registry (shared singleton — register once, play anywhere)
    get fx() {
      return fx;
    }
    waapi(targets, params) {
      return this.track(pulseWaapi.animate(targets, { ...params, reducedMotion: params?.reducedMotion ?? this.reducedMotion }), "waapi");
    }
    // color codec (PulseColor)
    get color() {
      return color;
    }
    colorCycle(bindings, options) {
      return this.track(new PulseColorCycle(bindings, {
        ...options,
        speed: options?.speed ?? this.motion.speed,
        reducedMotion: options?.reducedMotion ?? this.reducedMotion
      }), "color-cycle");
    }
    // surface recipes (PulseSurface) — built per-engine so fx registry is shared
    get surface() {
      if (!this._surface) this._surface = new PulseSurface(this);
      return this._surface;
    }
    // procedural black/white/control maps (PulseMask) — no image files
    get mask() {
      if (!this._mask) this._mask = new PulseMask(this);
      return this._mask;
    }
    maskTransition(targets, params) {
      return this.track(new PulseMaskTransition(targets, {
        ...params,
        reducedMotion: params?.reducedMotion ?? this.reducedMotion
      }), "mask-transition");
    }
    // visible texture layers (PulseTexture) — style, paired with a mask
    get texture() {
      if (!this._texture) this._texture = new PulseTexture(this);
      return this._texture;
    }
    textureMaps(root, params) {
      return this.track(new PulseTextureMaps(root, params), "texture-maps");
    }
    textureAsset(root, params) {
      return this.track(new PulseTextureAsset(root, {
        ...params,
        reducedMotion: params.reducedMotion ?? this.reducedMotion,
        speed: params.speed ?? this.motion.speed
      }), "texture-asset");
    }
    textureAssetFromManifest(root, manifest, id2, params = {}) {
      return this.track(textureAssetFromManifest(root, manifest, id2, {
        ...params,
        reducedMotion: params.reducedMotion ?? this.reducedMotion,
        speed: params.speed ?? this.motion.speed
      }), "texture-asset");
    }
    // shared surface helpers (reused across recipes)
    get scan() {
      return new PulseScan(this);
    }
    get shine() {
      return new PulseShine(this);
    }
    get noise() {
      return new PulseNoise(this);
    }
    get distort() {
      return new PulseDistort(this);
    }
    get fracture() {
      return new PulseFracture(this);
    }
    // raw ticker access (for custom loops)
    tick(fn) {
      const minFrame = this.motion.frameRate > 0 ? 1 / this.motion.frameRate : 0;
      let accumulated = 0;
      const raw = ticker.add((dt, now2) => {
        accumulated += dt;
        if (minFrame && accumulated < minFrame) return;
        const elapsed = minFrame ? accumulated : dt;
        accumulated = 0;
        fn(elapsed * this.motion.speed, now2);
      });
      let active = true;
      const release = profiler.trackResource("tick", raw);
      const dispose = () => {
        if (!active) return;
        active = false;
        raw();
        release();
        this.owned.delete(dispose);
      };
      this.owned.set(dispose, { dispose, release: () => {
      } });
      return dispose;
    }
    /** Stagger a spec across elements. Returns the Tween array. */
    stagger(els, spec, step = 0.08, base = 0) {
      return stagger(els, this.reducedMotion ? { ...spec, duration: 0 } : spec, step, base).map((item) => this.track(item.setSpeed(this.motion.speed), "tween"));
    }
    // composition runtime (System 08)
    scene(id2) {
      return new PulseScene(id2);
    }
    group() {
      return new TimerGroup();
    }
    get properties() {
      return PulseProperties;
    }
    // diagnostics (System 09-lite)
    get core() {
      return PulseCore;
    }
    get controlSchemas() {
      return pulseControlSchemas;
    }
    controls(target, root, schema) {
      return connectPulseControls(target, root, schema);
    }
    get debug() {
      return debug;
    }
    // ecosystem (Systems 09+)
    convert(type, input) {
      return PulseConverter.convert(this, type, input);
    }
    /** Compile an RMT Layer Splitter export through the public converter seam. */
    rmtLayers(manifest, options) {
      return this.convert("rmt-layer-splitter", { manifest, ...options });
    }
    scope(id2, opts) {
      return this.track(new PulseScope(id2, opts), "scope");
    }
    signal(name) {
      return this.track(new PulseSignal(name), "signal");
    }
    grid(root, params) {
      return this.track(new PulseGrid(root, params), "grid");
    }
    pulseMagnet(root, params) {
      return this.track(new PulseMagnet(root, params), "magnet");
    }
    magenet(root, params) {
      return this.pulseMagnet(root, params);
    }
    camera(root, params) {
      return this.track(new PulseCamera(root, params), "camera");
    }
    events(params) {
      return this.track(new PulseEvents(params), "events");
    }
    maskLayer(root, name, params) {
      return this.track(new PulseMaskLayer(root, name, { ...params, mask: params?.mask ?? this.mask }), "mask-layer");
    }
    maskMaps(root, params) {
      return this.track(new PulseMaskMaps(root, params), "mask-maps");
    }
    particles(root, params) {
      return this.track(new PulseParticles(root, params), "particles");
    }
    blendModes(root, params) {
      return this.track(new PulseBlendModes(root, params), "blend-modes");
    }
    site(params) {
      return this.track(new PulseSite(this, params), "site");
    }
    spacing(root, params) {
      return this.track(new PulseSpacing(root, params), "spacing");
    }
    structure(root, params) {
      return this.track(new PulseStructure(root, params), "structure");
    }
    design(root, params) {
      return this.structure(root, params);
    }
    subParticles(parent, params) {
      return this.track(subParticles(parent, params), "sub-particles");
    }
    layout(root, params) {
      return this.track(new PulseLayout(root, params), "layout");
    }
    patch(target, spec, opts) {
      return this.track(new PulsePatchChain(target, spec ?? {}, opts ?? {}, this), "patch");
    }
    get profiler() {
      return profiler;
    }
    /** Register a resource with this Pulse instance so destroy() cannot affect siblings. */
    track(resource, kind) {
      if (!resource || this.owned.has(resource)) return resource;
      const candidate = resource;
      const dispose = typeof candidate.dispose === "function" ? () => candidate.dispose() : typeof candidate.destroy === "function" ? () => {
        recordPlayableFallback(candidate, "dispose", "destroy");
        candidate.destroy();
      } : typeof candidate.pause === "function" ? () => {
        recordPlayableFallback(candidate, "dispose", "pause");
        candidate.pause();
      } : null;
      if (!dispose) return resource;
      const inferred = kind ?? candidate.constructor?.name?.replace(/^Pulse/, "").toLowerCase() ?? "resource";
      const release = profiler.trackResource(inferred, resource);
      this.owned.set(resource, { dispose, release });
      return resource;
    }
    untrack(resource) {
      const owned = this.owned.get(resource);
      if (!owned) return;
      owned.release();
      this.owned.delete(resource);
    }
    /** Tear down only resources created by this Pulse instance. */
    destroy() {
      for (const [resource, owned] of [...this.owned]) {
        try {
          owned.dispose();
        } finally {
          owned.release();
          this.owned.delete(resource);
        }
      }
    }
    /** Canonical lifecycle alias. `destroy()` remains for compatibility. */
    dispose() {
      this.destroy();
    }
    get activeCount() {
      return ticker.size;
    }
    get ownedCount() {
      return this.owned.size;
    }
  };

  // src/compat/legacy-shim.ts
  function parseVal(raw) {
    if (typeof raw === "number") return { v: raw, unit: "" };
    const m = String(raw).match(/^([+-]?[\d.]+)(px|vh|vw|%|rem|em)?$/);
    if (!m) return { v: 0, unit: "" };
    return { v: parseFloat(m[1]), unit: m[2] ?? "" };
  }
  var MS_KEYS = /* @__PURE__ */ new Set(["translateX", "translateY", "translateZ", "x", "y", "z"]);
  var DEG_KEYS = /* @__PURE__ */ new Set(["rotateX", "rotateY", "rotateZ", "rotate", "rx", "ry", "rz"]);
  function unitFor2(key2) {
    if (MS_KEYS.has(key2)) return "px";
    if (DEG_KEYS.has(key2)) return "deg";
    return "";
  }
  function toSec(ms) {
    return ms === void 0 ? void 0 : ms / 1e3;
  }
  function resolveTargets3(targets) {
    if (!targets) return [];
    if (typeof targets === "string") return Array.from(document.querySelectorAll(targets));
    if (typeof HTMLElement !== "undefined" && targets instanceof HTMLElement) return [targets];
    const isList = typeof NodeList !== "undefined" && targets instanceof NodeList || targets && typeof targets.length === "number" && typeof targets !== "string";
    if (isList) return Array.from(targets);
    return [];
  }
  function specFromParams(parameters) {
    const spec = {};
    for (const key2 in parameters) {
      const raw = parameters[key2];
      if (key2 === "duration" || key2 === "ease" || key2 === "loop" || key2 === "alternate" || key2 === "delay" || key2 === "transformPerspective") continue;
      let from = 0, to = 1, unit = unitFor2(key2);
      if (Array.isArray(raw)) {
        const parsed = raw.map((v) => parseVal(v));
        if (parsed.length >= 3) {
          const keys = parsed.map((p) => p.v);
          unit = parsed[0].unit || parsed[parsed.length - 1].unit || unit;
          spec[key2] = { keys, unit };
          continue;
        }
        from = parsed[0].v;
        to = parsed[parsed.length - 1].v;
        unit = parsed[0].unit || parsed[parsed.length - 1].unit || unit;
      } else {
        const p = parseVal(raw);
        from = 0;
        to = p.v;
        unit = p.unit || unit;
      }
      spec[key2] = { from, to, unit };
    }
    if (parameters.transformPerspective) {
      spec.perspective = { from: Number(parameters.transformPerspective) || 0, to: Number(parameters.transformPerspective) || 0, unit: "px" };
    }
    return spec;
  }
  function createLegacyEngine(pulse) {
    const shim = {
      createAnimation({ targets, parameters }) {
        const els = resolveTargets3(targets);
        const spec = specFromParams(parameters);
        const duration = toSec(parameters.duration) ?? 0.6;
        const ease = parameters.ease ?? "outCubic";
        const loop = !!parameters.loop;
        const alternate = !!parameters.alternate;
        const delay = parameters.delay;
        els.forEach((el, i) => {
          const d = typeof delay === "function" ? delay(i) : delay ?? 0;
          pulse.bag(el, spec, { duration, ease, delay: toSec(d) ?? 0, loop, alternate });
        });
      },
      stagger(stepMs) {
        return (i) => i * stepMs;
      },
      createTimeline() {
        const tl = pulse.timeline();
        return { play: () => tl.play(), add: () => tl };
      },
      createScrollObserver() {
        return { kill() {
        } };
      }
    };
    const ctor = function() {
      return shim;
    };
    return ctor;
  }
  function installLegacyShim(pulse) {
    const legacy = createLegacyEngine(pulse);
    globalThis.AnimationEngine = legacy;
    if (typeof window !== "undefined") window.AnimationEngine = legacy;
  }

  // src/index.ts
  var PulseEngine = Pulse;
  var PULSE_CORE_VERSION = "1.9.0";
  globalThis.Pulse = PulseEngine;
  if (typeof window !== "undefined") window.Pulse = PulseEngine;
  globalThis.PulseCore = PulseCore;
  if (typeof window !== "undefined") window.PulseCore = PulseCore;
  installLegacyShim(new PulseEngine());
  var src_default = PulseEngine;
})();
/*! Bundled license information:

html2canvas/dist/html2canvas.js:
  (*!
   * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   *)
  (*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
  
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
  
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** *)

animejs/dist/modules/core/consts.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/globals.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/helpers.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/transforms.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/adapters/registry.js:
  (**
   * Anime.js - adapters - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/colors.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/values.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/render.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/styles.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/clock.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/animation/additive.js:
  (**
   * Anime.js - animation - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/engine/engine.js:
  (**
   * Anime.js - engine - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/animation/composition.js:
  (**
   * Anime.js - animation - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/timer/timer.js:
  (**
   * Anime.js - timer - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/targets.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/core/units.js:
  (**
   * Anime.js - core - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/easings/none.js:
  (**
   * Anime.js - easings - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/easings/eases/parser.js:
  (**
   * Anime.js - easings - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/animation/animation.js:
  (**
   * Anime.js - animation - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/timeline/position.js:
  (**
   * Anime.js - timeline - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/timeline/timeline.js:
  (**
   * Anime.js - timeline - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/animatable/animatable.js:
  (**
   * Anime.js - animatable - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/utils/number.js:
  (**
   * Anime.js - utils - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/easings/spring/index.js:
  (**
   * Anime.js - easings - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/waapi/composition.js:
  (**
   * Anime.js - waapi - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/utils/target.js:
  (**
   * Anime.js - utils - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/draggable/draggable.js:
  (**
   * Anime.js - draggable - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/utils/time.js:
  (**
   * Anime.js - utils - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/events/scroll.js:
  (**
   * Anime.js - events - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/waapi/waapi.js:
  (**
   * Anime.js - waapi - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/layout/layout.js:
  (**
   * Anime.js - layout - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/text/split.js:
  (**
   * Anime.js - text - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/text/index.js:
  (**
   * Anime.js - text - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/index.js:
  (**
   * Anime.js - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/timeline/index.js:
  (**
   * Anime.js - timeline - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/layout/index.js:
  (**
   * Anime.js - layout - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/events/index.js:
  (**
   * Anime.js - events - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)

animejs/dist/modules/waapi/index.js:
  (**
   * Anime.js - waapi - ESM
   * @version v4.5.0
   * @license MIT
   * @copyright 2026 - Julian Garnier
   *)
*/
